/**
 * filerobot-image-editor v4.4.0
 * https://github.com/scaleflex/filerobot-image-editor
 * Copyright (c) 2019 Scaleflex
 * Released under the MIT license
 * Date: 2023-03-29T23:28:39.806Z
 */
!(function (e, t) {
  'object' == typeof exports && 'undefined' != typeof module
    ? (module.exports = t())
    : 'function' == typeof define && define.amd
    ? define(t)
    : ((e = 'undefined' != typeof globalThis ? globalThis : e || self).FilerobotImageEditor = t())
})(this, function () {
  'use strict'
  function e(t) {
    return (e =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (e) {
            return typeof e
          }
        : function (e) {
            return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
              ? 'symbol'
              : typeof e
          })(t)
  }
  function t(t) {
    return (
      (t = (function (t, n) {
        if ('object' !== e(t) || null === t) return t
        var r = t[Symbol.toPrimitive]
        if (void 0 === r) return String(t)
        if ('object' !== e((r = r.call(t, n)))) return r
        throw new TypeError('@@toPrimitive must return a primitive value.')
      })(t, 'string')),
      'symbol' === e(t) ? t : String(t)
    )
  }
  function n(e, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r]
      ;(i.enumerable = i.enumerable || !1),
        (i.configurable = !0),
        'value' in i && (i.writable = !0),
        Object.defineProperty(e, t(i.key), i)
    }
  }
  function r(e, n, r) {
    return (
      (n = t(n)) in e
        ? Object.defineProperty(e, n, { value: r, enumerable: !0, configurable: !0, writable: !0 })
        : (e[n] = r),
      e
    )
  }
  function i(e, t, n) {
    if (t.has(e)) return t.get(e)
    throw new TypeError('attempted to ' + n + ' private field on non-instance')
  }
  function o(e, t) {
    return (t = i(e, t, 'get')).get ? t.get.call(e) : t.value
  }
  function a(e, t, n) {
    if ((t = i(e, t, 'set')).set) t.set.call(e, n)
    else {
      if (!t.writable) throw new TypeError('attempted to set read only private field')
      t.value = n
    }
  }
  var l =
      'undefined' == typeof globalThis
        ? 'undefined' == typeof window
          ? 'undefined' == typeof global
            ? 'undefined' == typeof self
              ? {}
              : self
            : global
          : window
        : globalThis,
    s = { exports: {} },
    c = {},
    u = Symbol.for('react.element'),
    d = Symbol.for('react.portal'),
    f = Symbol.for('react.fragment'),
    h = Symbol.for('react.strict_mode'),
    p = Symbol.for('react.profiler'),
    g = Symbol.for('react.provider'),
    m = Symbol.for('react.context'),
    v = Symbol.for('react.forward_ref'),
    y = Symbol.for('react.suspense'),
    b = Symbol.for('react.memo'),
    w = Symbol.for('react.lazy'),
    C = Symbol.iterator,
    x = {
      isMounted: function () {
        return !1
      },
      enqueueForceUpdate: function () {},
      enqueueReplaceState: function () {},
      enqueueSetState: function () {}
    },
    E = Object.assign,
    S = {}
  function O(e, t, n) {
    ;(this.props = e), (this.context = t), (this.refs = S), (this.updater = n || x)
  }
  function k() {}
  function P(e, t, n) {
    ;(this.props = e), (this.context = t), (this.refs = S), (this.updater = n || x)
  }
  ;(O.prototype.isReactComponent = {}),
    (O.prototype.setState = function (e, t) {
      if ('object' != typeof e && 'function' != typeof e && null != e)
        throw Error(
          'setState(...): takes an object of state variables to update or a function which returns an object of state variables.'
        )
      this.updater.enqueueSetState(this, e, t, 'setState')
    }),
    (O.prototype.forceUpdate = function (e) {
      this.updater.enqueueForceUpdate(this, e, 'forceUpdate')
    }),
    (k.prototype = O.prototype)
  var _ =
      (((ce = P.prototype = new k()).constructor = P),
      E(ce, O.prototype),
      (ce.isPureReactComponent = !0),
      Array.isArray),
    L = Object.prototype.hasOwnProperty,
    T = { current: null },
    I = { key: !0, ref: !0, __self: !0, __source: !0 }
  function M(e, t, n) {
    var r,
      i = {},
      o = null,
      a = null
    if (null != t)
      for (r in (void 0 !== t.ref && (a = t.ref), void 0 !== t.key && (o = '' + t.key), t))
        L.call(t, r) && !I.hasOwnProperty(r) && (i[r] = t[r])
    var l = arguments.length - 2
    if (1 === l) i.children = n
    else if (1 < l) {
      for (var s = Array(l), c = 0; c < l; c++) s[c] = arguments[c + 2]
      i.children = s
    }
    if (e && e.defaultProps) for (r in (l = e.defaultProps)) void 0 === i[r] && (i[r] = l[r])
    return { $$typeof: u, type: e, key: o, ref: a, props: i, _owner: T.current }
  }
  function j(e) {
    return 'object' == typeof e && null !== e && e.$$typeof === u
  }
  var R = /\/+/g
  function D(e, t) {
    return 'object' == typeof e && null !== e && null != e.key
      ? ((e = '' + e.key),
        (n = { '=': '=0', ':': '=2' }),
        '$' +
          e.replace(/[=:]/g, function (e) {
            return n[e]
          }))
      : t.toString(36)
    var n
  }
  function A(e, t, n, r, i) {
    var o,
      a,
      l = !1
    if (null === (e = 'undefined' != (c = typeof e) && 'boolean' !== c ? e : null)) l = !0
    else
      switch (c) {
        case 'string':
        case 'number':
          l = !0
          break
        case 'object':
          switch (e.$$typeof) {
            case u:
            case d:
              l = !0
          }
      }
    if (l)
      return (
        (i = i((l = e))),
        (e = '' === r ? '.' + D(l, 0) : r),
        _(i)
          ? ((n = ''),
            A(i, t, (n = null != e ? e.replace(R, '$&/') + '/' : n), '', function (e) {
              return e
            }))
          : null != i &&
            (j(i) &&
              ((a = n + (!(o = i).key || (l && l.key === i.key) ? '' : ('' + i.key).replace(R, '$&/') + '/') + e),
              (i = { $$typeof: u, type: o.type, key: a, ref: o.ref, props: o.props, _owner: o._owner })),
            t.push(i)),
        1
      )
    if (((l = 0), (r = '' === r ? '.' : r + ':'), _(e)))
      for (var s = 0; s < e.length; s++) {
        var c,
          f = r + D((c = e[s]), s)
        l += A(c, t, n, f, i)
      }
    else if (
      'function' ==
      typeof (f =
        null !== (a = e) && 'object' == typeof a && 'function' == typeof (a = (C && a[C]) || a['@@iterator'])
          ? a
          : null)
    )
      for (e = f.call(e), s = 0; !(c = e.next()).done; ) l += A((c = c.value), t, n, (f = r + D(c, s++)), i)
    else if ('object' === c)
      throw (
        ((t = String(e)),
        Error(
          'Objects are not valid as a React child (found: ' +
            ('[object Object]' === t ? 'object with keys {' + Object.keys(e).join(', ') + '}' : t) +
            '). If you meant to render a collection of children, use an array instead.'
        ))
      )
    return l
  }
  function z(e, t, n) {
    var r
    return (
      null == e ||
        ((r = 0),
        A(e, (e = []), '', '', function (e) {
          return t.call(n, e, r++)
        })),
      e
    )
  }
  function N(e) {
    var t
    if (
      (-1 === e._status &&
        ((t = (t = e._result)()).then(
          function (t) {
            ;(0 !== e._status && -1 !== e._status) || ((e._status = 1), (e._result = t))
          },
          function (t) {
            ;(0 !== e._status && -1 !== e._status) || ((e._status = 2), (e._result = t))
          }
        ),
        -1 === e._status) &&
        ((e._status = 0), (e._result = t)),
      1 === e._status)
    )
      return e._result.default
    throw e._result
  }
  var F,
    H,
    B,
    V,
    W,
    G,
    Z,
    U,
    X,
    Y,
    q,
    $,
    K,
    Q,
    J,
    ee,
    te,
    ne,
    re,
    ie,
    oe,
    ae,
    le = { current: null },
    se = { transition: null },
    ce = { ReactCurrentDispatcher: le, ReactCurrentBatchConfig: se, ReactCurrentOwner: T },
    ue =
      ((c.Children = {
        map: z,
        forEach: function (e, t, n) {
          z(
            e,
            function () {
              t.apply(this, arguments)
            },
            n
          )
        },
        count: function (e) {
          var t = 0
          return (
            z(e, function () {
              t++
            }),
            t
          )
        },
        toArray: function (e) {
          return (
            z(e, function (e) {
              return e
            }) || []
          )
        },
        only: function (e) {
          if (j(e)) return e
          throw Error('React.Children.only expected to receive a single React element child.')
        }
      }),
      (c.Component = O),
      (c.Fragment = f),
      (c.Profiler = p),
      (c.PureComponent = P),
      (c.StrictMode = h),
      (c.Suspense = y),
      (c.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ce),
      (c.cloneElement = function (e, t, n) {
        if (null == e)
          throw Error('React.cloneElement(...): The argument must be a React element, but you passed ' + e + '.')
        var r = E({}, e.props),
          i = e.key,
          o = e.ref,
          a = e._owner
        if (null != t)
          for (l in (void 0 !== t.ref && ((o = t.ref), (a = T.current)),
          void 0 !== t.key && (i = '' + t.key),
          e.type && e.type.defaultProps && (s = e.type.defaultProps),
          t))
            L.call(t, l) && !I.hasOwnProperty(l) && (r[l] = (void 0 === t[l] && void 0 !== s ? s : t)[l])
        var l = arguments.length - 2
        if (1 === l) r.children = n
        else if (1 < l) {
          for (var s = Array(l), c = 0; c < l; c++) s[c] = arguments[c + 2]
          r.children = s
        }
        return { $$typeof: u, type: e.type, key: i, ref: o, props: r, _owner: a }
      }),
      (c.createContext = function (e) {
        return (
          ((e = {
            $$typeof: m,
            _currentValue: e,
            _currentValue2: e,
            _threadCount: 0,
            Provider: null,
            Consumer: null,
            _defaultValue: null,
            _globalName: null
          }).Provider = { $$typeof: g, _context: e }),
          (e.Consumer = e)
        )
      }),
      (c.createElement = M),
      (c.createFactory = function (e) {
        var t = M.bind(null, e)
        return (t.type = e), t
      }),
      (c.createRef = function () {
        return { current: null }
      }),
      (c.forwardRef = function (e) {
        return { $$typeof: v, render: e }
      }),
      (c.isValidElement = j),
      (c.lazy = function (e) {
        return { $$typeof: w, _payload: { _status: -1, _result: e }, _init: N }
      }),
      (c.memo = function (e, t) {
        return { $$typeof: b, type: e, compare: void 0 === t ? null : t }
      }),
      (c.startTransition = function (e) {
        var t = se.transition
        se.transition = {}
        try {
          e()
        } finally {
          se.transition = t
        }
      }),
      (c.unstable_act = function () {
        throw Error('act(...) is not supported in production builds of React.')
      }),
      (c.useCallback = function (e, t) {
        return le.current.useCallback(e, t)
      }),
      (c.useContext = function (e) {
        return le.current.useContext(e)
      }),
      (c.useDebugValue = function () {}),
      (c.useDeferredValue = function (e) {
        return le.current.useDeferredValue(e)
      }),
      (c.useEffect = function (e, t) {
        return le.current.useEffect(e, t)
      }),
      (c.useId = function () {
        return le.current.useId()
      }),
      (c.useImperativeHandle = function (e, t, n) {
        return le.current.useImperativeHandle(e, t, n)
      }),
      (c.useInsertionEffect = function (e, t) {
        return le.current.useInsertionEffect(e, t)
      }),
      (c.useLayoutEffect = function (e, t) {
        return le.current.useLayoutEffect(e, t)
      }),
      (c.useMemo = function (e, t) {
        return le.current.useMemo(e, t)
      }),
      (c.useReducer = function (e, t, n) {
        return le.current.useReducer(e, t, n)
      }),
      (c.useRef = function (e) {
        return le.current.useRef(e)
      }),
      (c.useState = function (e) {
        return le.current.useState(e)
      }),
      (c.useSyncExternalStore = function (e, t, n) {
        return le.current.useSyncExternalStore(e, t, n)
      }),
      (c.useTransition = function () {
        return le.current.useTransition()
      }),
      (c.version = '18.2.0'),
      (s.exports = c),
      s.exports),
    de = { exports: {} },
    fe = ((f = {}), { exports: {} })
  function he(e, t) {
    var n = e.length
    for (e.push(t); 0 < n; ) {
      var r = (n - 1) >>> 1,
        i = e[r]
      if (!(0 < me(i, t))) break
      ;(e[r] = t), (e[n] = i), (n = r)
    }
  }
  function pe(e) {
    return 0 === e.length ? null : e[0]
  }
  function ge(e) {
    if (0 !== e.length) {
      var t = e[0],
        n = e.pop()
      if (n !== t) {
        e[0] = n
        for (var r = 0, i = e.length, o = i >>> 1; r < o; ) {
          var a = 2 * (r + 1) - 1,
            l = e[a],
            s = 1 + a,
            c = e[s]
          if (me(l, n) < 0) r = s < i && me(c, l) < 0 ? ((e[r] = c), (e[s] = n), s) : ((e[r] = l), (e[a] = n), a)
          else {
            if (!(s < i && me(c, n) < 0)) break
            ;(e[r] = c), (e[s] = n), (r = s)
          }
        }
      }
    }
  }
  function me(e, t) {
    var n = e.sortIndex - t.sortIndex
    return 0 != n ? n : e.id - t.id
  }
  function ve(e) {
    for (var t = pe(G); null !== t; ) {
      if (null === t.callback) ge(G)
      else {
        if (!(t.startTime <= e)) break
        ge(G), (t.sortIndex = t.expirationTime), he(W, t)
      }
      t = pe(G)
    }
  }
  function ye(e) {
    var t
    ;($ = !1), ve(e), q || (null !== pe(W) ? ((q = !0), xe(be)) : null !== (t = pe(G)) && Ee(ye, t.startTime - e))
  }
  function be(e, t) {
    ;(q = !1), $ && (($ = !1), Q(ie), (ie = -1)), (Y = !0)
    var n = X
    try {
      for (ve(t), U = pe(W); null !== U && (!(U.expirationTime > t) || (e && !we())); ) {
        var r,
          i = U.callback
        'function' == typeof i
          ? ((U.callback = null),
            (X = U.priorityLevel),
            (r = i(U.expirationTime <= t)),
            (t = F.unstable_now()),
            'function' == typeof r ? (U.callback = r) : U === pe(W) && ge(W),
            ve(t))
          : ge(W),
          (U = pe(W))
      }
      var o
      return null !== U || (null !== (o = pe(G)) && Ee(ye, o.startTime - t), !1)
    } finally {
      ;(U = null), (X = n), (Y = !1)
    }
  }
  function we() {
    return !(F.unstable_now() - ae < oe)
  }
  function Ce() {
    if (null !== re) {
      var e = F.unstable_now(),
        t = ((ae = e), !0)
      try {
        t = re(!0, e)
      } finally {
        t ? ee() : ((ne = !1), (re = null))
      }
    } else ne = !1
  }
  function xe(e) {
    ;(re = e), ne || ((ne = !0), ee())
  }
  function Ee(e, t) {
    ie = K(function () {
      e(F.unstable_now())
    }, t)
  }
  ;(F = p = {}),
    'object' == typeof performance && 'function' == typeof performance.now
      ? ((H = performance),
        (F.unstable_now = function () {
          return H.now()
        }))
      : ((B = Date),
        (V = B.now()),
        (F.unstable_now = function () {
          return B.now() - V
        })),
    (W = []),
    (G = []),
    (Z = 1),
    (U = null),
    ($ = q = Y = !(X = 3)),
    (K = 'function' == typeof setTimeout ? setTimeout : null),
    (Q = 'function' == typeof clearTimeout ? clearTimeout : null),
    (J = 'undefined' != typeof setImmediate ? setImmediate : null),
    'undefined' != typeof navigator &&
      void 0 !== navigator.scheduling &&
      void 0 !== navigator.scheduling.isInputPending &&
      navigator.scheduling.isInputPending.bind(navigator.scheduling),
    (ne = !1),
    (re = null),
    (oe = 5),
    (ae = ie = -1),
    (ee =
      'function' == typeof J
        ? function () {
            J(Ce)
          }
        : 'undefined' != typeof MessageChannel
        ? ((h = new MessageChannel()),
          (te = h.port2),
          (h.port1.onmessage = Ce),
          function () {
            te.postMessage(null)
          })
        : function () {
            K(Ce, 0)
          }),
    (F.unstable_IdlePriority = 5),
    (F.unstable_ImmediatePriority = 1),
    (F.unstable_LowPriority = 4),
    (F.unstable_NormalPriority = 3),
    (F.unstable_Profiling = null),
    (F.unstable_UserBlockingPriority = 2),
    (F.unstable_cancelCallback = function (e) {
      e.callback = null
    }),
    (F.unstable_continueExecution = function () {
      q || Y || ((q = !0), xe(be))
    }),
    (F.unstable_forceFrameRate = function (e) {
      e < 0 || 125 < e
        ? console.error(
            'forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported'
          )
        : (oe = 0 < e ? Math.floor(1e3 / e) : 5)
    }),
    (F.unstable_getCurrentPriorityLevel = function () {
      return X
    }),
    (F.unstable_getFirstCallbackNode = function () {
      return pe(W)
    }),
    (F.unstable_next = function (e) {
      switch (X) {
        case 1:
        case 2:
        case 3:
          var t = 3
          break
        default:
          t = X
      }
      var n = X
      X = t
      try {
        return e()
      } finally {
        X = n
      }
    }),
    (F.unstable_pauseExecution = function () {}),
    (F.unstable_requestPaint = function () {}),
    (F.unstable_runWithPriority = function (e, t) {
      switch (e) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break
        default:
          e = 3
      }
      var n = X
      X = e
      try {
        return t()
      } finally {
        X = n
      }
    }),
    (F.unstable_scheduleCallback = function (e, t, n) {
      var r = F.unstable_now()
      switch (((n = 'object' == typeof n && null !== n && 'number' == typeof (n = n.delay) && 0 < n ? r + n : r), e)) {
        case 1:
          var i = -1
          break
        case 2:
          i = 250
          break
        case 5:
          i = 1073741823
          break
        case 4:
          i = 1e4
          break
        default:
          i = 5e3
      }
      return (
        (e = { id: Z++, callback: t, priorityLevel: e, startTime: n, expirationTime: (i = n + i), sortIndex: -1 }),
        r < n
          ? ((e.sortIndex = n),
            he(G, e),
            null === pe(W) && e === pe(G) && ($ ? (Q(ie), (ie = -1)) : ($ = !0), Ee(ye, n - r)))
          : ((e.sortIndex = i), he(W, e), q || Y || ((q = !0), xe(be))),
        e
      )
    }),
    (F.unstable_shouldYield = we),
    (F.unstable_wrapCallback = function (e) {
      var t = X
      return function () {
        var n = X
        X = t
        try {
          return e.apply(this, arguments)
        } finally {
          X = n
        }
      }
    }),
    (fe.exports = p)
  y = s.exports
  var Se = fe.exports
  function Oe(e) {
    for (var t = 'https://reactjs.org/docs/error-decoder.html?invariant=' + e, n = 1; n < arguments.length; n++)
      t += '&args[]=' + encodeURIComponent(arguments[n])
    return (
      'Minified React error #' +
      e +
      '; visit ' +
      t +
      ' for the full message or use the non-minified dev environment for full errors and additional helpful warnings.'
    )
  }
  var ke = new Set(),
    Pe = {}
  function _e(e, t) {
    Le(e, t), Le(e + 'Capture', t)
  }
  function Le(e, t) {
    for (Pe[e] = t, e = 0; e < t.length; e++) ke.add(t[e])
  }
  ce = !('undefined' == typeof window || void 0 === window.document || void 0 === window.document.createElement)
  var Te = Object.prototype.hasOwnProperty,
    Ie =
      /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
    Me = {},
    je = {}
  function Re(e, t, n, r, i, o, a) {
    ;(this.acceptsBooleans = 2 === t || 3 === t || 4 === t),
      (this.attributeName = r),
      (this.attributeNamespace = i),
      (this.mustUseProperty = n),
      (this.propertyName = e),
      (this.type = t),
      (this.sanitizeURL = o),
      (this.removeEmptyString = a)
  }
  var De = {},
    Ae =
      ('children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style'
        .split(' ')
        .forEach(function (e) {
          De[e] = new Re(e, 0, !1, e, null, !1, !1)
        }),
      [
        ['acceptCharset', 'accept-charset'],
        ['className', 'class'],
        ['htmlFor', 'for'],
        ['httpEquiv', 'http-equiv']
      ].forEach(function (e) {
        var t = e[0]
        De[t] = new Re(t, 1, !1, e[1], null, !1, !1)
      }),
      ['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (e) {
        De[e] = new Re(e, 2, !1, e.toLowerCase(), null, !1, !1)
      }),
      ['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (e) {
        De[e] = new Re(e, 2, !1, e, null, !1, !1)
      }),
      'allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope'
        .split(' ')
        .forEach(function (e) {
          De[e] = new Re(e, 3, !1, e.toLowerCase(), null, !1, !1)
        }),
      ['checked', 'multiple', 'muted', 'selected'].forEach(function (e) {
        De[e] = new Re(e, 3, !0, e, null, !1, !1)
      }),
      ['capture', 'download'].forEach(function (e) {
        De[e] = new Re(e, 4, !1, e, null, !1, !1)
      }),
      ['cols', 'rows', 'size', 'span'].forEach(function (e) {
        De[e] = new Re(e, 6, !1, e, null, !1, !1)
      }),
      ['rowSpan', 'start'].forEach(function (e) {
        De[e] = new Re(e, 5, !1, e.toLowerCase(), null, !1, !1)
      }),
      /[\-:]([a-z])/g)
  function ze(e) {
    return e[1].toUpperCase()
  }
  function Ne(e, t, n, r) {
    var i,
      o = De.hasOwnProperty(t) ? De[t] : null
    ;(null !== o
      ? 0 !== o.type
      : r || !(2 < t.length) || ('o' !== t[0] && 'O' !== t[0]) || ('n' !== t[1] && 'N' !== t[1])) &&
      ((function (e, t, n, r) {
        if (
          null == t ||
          (function (e, t, n, r) {
            if (null === n || 0 !== n.type)
              switch (typeof t) {
                case 'function':
                case 'symbol':
                  return 1
                case 'boolean':
                  return r
                    ? void 0
                    : null !== n
                    ? !n.acceptsBooleans
                    : 'data-' !== (e = e.toLowerCase().slice(0, 5)) && 'aria-' !== e
                default:
                  return
              }
          })(e, t, n, r)
        )
          return 1
        if (!r && null !== n)
          switch (n.type) {
            case 3:
              return !t
            case 4:
              return !1 === t
            case 5:
              return isNaN(t)
            case 6:
              return isNaN(t) || t < 1
          }
      })(t, n, o, r) && (n = null),
      r || null === o
        ? ((i = t),
          (Te.call(je, i) || (!Te.call(Me, i) && (Ie.test(i) ? (je[i] = !0) : void (Me[i] = !0)))) &&
            (null === n ? e.removeAttribute(t) : e.setAttribute(t, '' + n)))
        : o.mustUseProperty
        ? (e[o.propertyName] = null === n ? 3 !== o.type && '' : n)
        : ((t = o.attributeName),
          (r = o.attributeNamespace),
          null === n
            ? e.removeAttribute(t)
            : ((n = 3 === (o = o.type) || (4 === o && !0 === n) ? '' : '' + n),
              r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))))
  }
  'accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height'
    .split(' ')
    .forEach(function (e) {
      var t = e.replace(Ae, ze)
      De[t] = new Re(t, 1, !1, e, null, !1, !1)
    }),
    'xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type'.split(' ').forEach(function (e) {
      var t = e.replace(Ae, ze)
      De[t] = new Re(t, 1, !1, e, 'http://www.w3.org/1999/xlink', !1, !1)
    }),
    ['xml:base', 'xml:lang', 'xml:space'].forEach(function (e) {
      var t = e.replace(Ae, ze)
      De[t] = new Re(t, 1, !1, e, 'http://www.w3.org/XML/1998/namespace', !1, !1)
    }),
    ['tabIndex', 'crossOrigin'].forEach(function (e) {
      De[e] = new Re(e, 1, !1, e.toLowerCase(), null, !1, !1)
    }),
    (De.xlinkHref = new Re('xlinkHref', 1, !1, 'xlink:href', 'http://www.w3.org/1999/xlink', !0, !1)),
    ['src', 'href', 'action', 'formAction'].forEach(function (e) {
      De[e] = new Re(e, 1, !1, e.toLowerCase(), null, !0, !0)
    })
  c = y.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED
  var Fe = Symbol.for('react.element'),
    He = Symbol.for('react.portal'),
    Be = Symbol.for('react.fragment'),
    Ve = Symbol.for('react.strict_mode'),
    We = Symbol.for('react.profiler'),
    Ge = Symbol.for('react.provider'),
    Ze = Symbol.for('react.context'),
    Ue = Symbol.for('react.forward_ref'),
    Xe = Symbol.for('react.suspense'),
    Ye = Symbol.for('react.suspense_list'),
    qe = Symbol.for('react.memo'),
    $e = Symbol.for('react.lazy'),
    Ke = Symbol.for('react.offscreen'),
    Qe = Symbol.iterator
  function Je(e) {
    return null !== e && 'object' == typeof e && 'function' == typeof (e = (Qe && e[Qe]) || e['@@iterator']) ? e : null
  }
  var et,
    tt = Object.assign
  function nt(e) {
    if (void 0 === et)
      try {
        throw Error()
      } catch (n) {
        var t = n.stack.trim().match(/\n( *(at )?)/)
        et = (t && t[1]) || ''
      }
    return '\n' + et + e
  }
  var rt = !1
  function it(e, t) {
    if (!e || rt) return ''
    rt = !0
    var n = Error.prepareStackTrace
    Error.prepareStackTrace = void 0
    try {
      if (t)
        if (
          ((t = function () {
            throw Error()
          }),
          Object.defineProperty(t.prototype, 'props', {
            set: function () {
              throw Error()
            }
          }),
          'object' == typeof Reflect && Reflect.construct)
        ) {
          try {
            Reflect.construct(t, [])
          } catch (c) {
            var r = c
          }
          Reflect.construct(e, [], t)
        } else {
          try {
            t.call()
          } catch (c) {
            r = c
          }
          e.call(t.prototype)
        }
      else {
        try {
          throw Error()
        } catch (c) {
          r = c
        }
        e()
      }
    } catch (c) {
      if (c && r && 'string' == typeof c.stack) {
        for (
          var i, o = c.stack.split('\n'), a = r.stack.split('\n'), l = o.length - 1, s = a.length - 1;
          1 <= l && 0 <= s && o[l] !== a[s];

        )
          s--
        for (; 1 <= l && 0 <= s; l--, s--)
          if (o[l] !== a[s]) {
            if (1 !== l || 1 !== s)
              do {
                if ((l--, --s < 0 || o[l] !== a[s]))
                  return (
                    (i = '\n' + o[l].replace(' at new ', ' at ')),
                    (i = e.displayName && i.includes('<anonymous>') ? i.replace('<anonymous>', e.displayName) : i)
                  )
              } while (1 <= l && 0 <= s)
            break
          }
      }
    } finally {
      ;(rt = !1), (Error.prepareStackTrace = n)
    }
    return (e = e ? e.displayName || e.name : '') ? nt(e) : ''
  }
  function ot(e) {
    var t = e.type
    switch (e.tag) {
      case 24:
        return 'Cache'
      case 9:
        return (t.displayName || 'Context') + '.Consumer'
      case 10:
        return (t._context.displayName || 'Context') + '.Provider'
      case 18:
        return 'DehydratedFragment'
      case 11:
        return (
          (e = (e = t.render).displayName || e.name || ''),
          t.displayName || ('' !== e ? 'ForwardRef(' + e + ')' : 'ForwardRef')
        )
      case 7:
        return 'Fragment'
      case 5:
        return t
      case 4:
        return 'Portal'
      case 3:
        return 'Root'
      case 6:
        return 'Text'
      case 16:
        return (function e(t) {
          if (null != t) {
            if ('function' == typeof t) return t.displayName || t.name || null
            if ('string' == typeof t) return t
            switch (t) {
              case Be:
                return 'Fragment'
              case He:
                return 'Portal'
              case We:
                return 'Profiler'
              case Ve:
                return 'StrictMode'
              case Xe:
                return 'Suspense'
              case Ye:
                return 'SuspenseList'
            }
            if ('object' == typeof t)
              switch (t.$$typeof) {
                case Ze:
                  return (t.displayName || 'Context') + '.Consumer'
                case Ge:
                  return (t._context.displayName || 'Context') + '.Provider'
                case Ue:
                  var n = t.render
                  return (
                    (t = t.displayName) ||
                    ('' !== (t = n.displayName || n.name || '') ? 'ForwardRef(' + t + ')' : 'ForwardRef')
                  )
                case qe:
                  return null !== (n = t.displayName || null) ? n : e(t.type) || 'Memo'
                case $e:
                  ;(n = t._payload), (t = t._init)
                  try {
                    return e(t(n))
                  } catch (r) {}
              }
          }
          return null
        })(t)
      case 8:
        return t === Ve ? 'StrictMode' : 'Mode'
      case 22:
        return 'Offscreen'
      case 12:
        return 'Profiler'
      case 21:
        return 'Scope'
      case 13:
        return 'Suspense'
      case 19:
        return 'SuspenseList'
      case 25:
        return 'TracingMarker'
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if ('function' == typeof t) return t.displayName || t.name || null
        if ('string' == typeof t) return t
    }
    return null
  }
  function at(e) {
    switch (typeof e) {
      case 'boolean':
      case 'number':
      case 'string':
      case 'undefined':
      case 'object':
        return e
      default:
        return ''
    }
  }
  function lt(e) {
    var t = e.type
    return (e = e.nodeName) && 'input' === e.toLowerCase() && ('checkbox' === t || 'radio' === t)
  }
  function st(e) {
    e._valueTracker ||
      (e._valueTracker = (function (e) {
        var t,
          n,
          r = lt(e) ? 'checked' : 'value',
          i = Object.getOwnPropertyDescriptor(e.constructor.prototype, r),
          o = '' + e[r]
        if (!e.hasOwnProperty(r) && void 0 !== i && 'function' == typeof i.get && 'function' == typeof i.set)
          return (
            (t = i.get),
            (n = i.set),
            Object.defineProperty(e, r, {
              configurable: !0,
              get: function () {
                return t.call(this)
              },
              set: function (e) {
                ;(o = '' + e), n.call(this, e)
              }
            }),
            Object.defineProperty(e, r, { enumerable: i.enumerable }),
            {
              getValue: function () {
                return o
              },
              setValue: function (e) {
                o = '' + e
              },
              stopTracking: function () {
                ;(e._valueTracker = null), delete e[r]
              }
            }
          )
      })(e))
  }
  function ct(e) {
    var t, n, r
    if (e)
      return (t = e._valueTracker)
        ? ((n = t.getValue()),
          (r = ''),
          (e = r = e ? (lt(e) ? (e.checked ? 'true' : 'false') : e.value) : r) !== n && (t.setValue(e), 1))
        : 1
  }
  function ut(e) {
    if (void 0 === (e = e || ('undefined' != typeof document ? document : void 0))) return null
    try {
      return e.activeElement || e.body
    } catch (t) {
      return e.body
    }
  }
  function dt(e, t) {
    var n = t.checked
    return tt({}, t, {
      defaultChecked: void 0,
      defaultValue: void 0,
      value: void 0,
      checked: null != n ? n : e._wrapperState.initialChecked
    })
  }
  function ft(e, t) {
    var n = null == t.defaultValue ? '' : t.defaultValue,
      r = null != t.checked ? t.checked : t.defaultChecked
    n = at(null != t.value ? t.value : n)
    e._wrapperState = {
      initialChecked: r,
      initialValue: n,
      controlled: 'checkbox' === t.type || 'radio' === t.type ? null != t.checked : null != t.value
    }
  }
  function ht(e, t) {
    null != (t = t.checked) && Ne(e, 'checked', t, !1)
  }
  function pt(e, t) {
    ht(e, t)
    var n = at(t.value),
      r = t.type
    if (null != n)
      'number' === r
        ? ((0 === n && '' === e.value) || e.value != n) && (e.value = '' + n)
        : e.value !== '' + n && (e.value = '' + n)
    else if ('submit' === r || 'reset' === r) return void e.removeAttribute('value')
    t.hasOwnProperty('value')
      ? mt(e, t.type, n)
      : t.hasOwnProperty('defaultValue') && mt(e, t.type, at(t.defaultValue)),
      null == t.checked && null != t.defaultChecked && (e.defaultChecked = !!t.defaultChecked)
  }
  function gt(e, t, n) {
    if (t.hasOwnProperty('value') || t.hasOwnProperty('defaultValue')) {
      var r = t.type
      if (!(('submit' !== r && 'reset' !== r) || (void 0 !== t.value && null !== t.value))) return
      ;(t = '' + e._wrapperState.initialValue), n || t === e.value || (e.value = t), (e.defaultValue = t)
    }
    '' !== (n = e.name) && (e.name = ''),
      (e.defaultChecked = !!e._wrapperState.initialChecked),
      '' !== n && (e.name = n)
  }
  function mt(e, t, n) {
    ;('number' === t && ut(e.ownerDocument) === e) ||
      (null == n
        ? (e.defaultValue = '' + e._wrapperState.initialValue)
        : e.defaultValue !== '' + n && (e.defaultValue = '' + n))
  }
  var vt = Array.isArray
  function yt(e, t, n, r) {
    if (((e = e.options), t)) {
      t = {}
      for (var i = 0; i < n.length; i++) t['$' + n[i]] = !0
      for (n = 0; n < e.length; n++)
        (i = t.hasOwnProperty('$' + e[n].value)),
          e[n].selected !== i && (e[n].selected = i),
          i && r && (e[n].defaultSelected = !0)
    } else {
      for (n = '' + at(n), t = null, i = 0; i < e.length; i++) {
        if (e[i].value === n) return (e[i].selected = !0), void (r && (e[i].defaultSelected = !0))
        null !== t || e[i].disabled || (t = e[i])
      }
      null !== t && (t.selected = !0)
    }
  }
  function bt(e, t) {
    if (null != t.dangerouslySetInnerHTML) throw Error(Oe(91))
    return tt({}, t, { value: void 0, defaultValue: void 0, children: '' + e._wrapperState.initialValue })
  }
  function wt(e, t) {
    var n = t.value
    if (null == n) {
      if (((n = t.children), (t = t.defaultValue), null != n)) {
        if (null != t) throw Error(Oe(92))
        if (vt(n)) {
          if (1 < n.length) throw Error(Oe(93))
          n = n[0]
        }
        t = n
      }
      n = t = null == t ? '' : t
    }
    e._wrapperState = { initialValue: at(n) }
  }
  function Ct(e, t) {
    var n = at(t.value),
      r = at(t.defaultValue)
    null != n &&
      ((n = '' + n) !== e.value && (e.value = n), null == t.defaultValue) &&
      e.defaultValue !== n &&
      (e.defaultValue = n),
      null != r && (e.defaultValue = '' + r)
  }
  function xt(e) {
    var t = e.textContent
    t === e._wrapperState.initialValue && '' !== t && null !== t && (e.value = t)
  }
  function Et(e) {
    switch (e) {
      case 'svg':
        return 'http://www.w3.org/2000/svg'
      case 'math':
        return 'http://www.w3.org/1998/Math/MathML'
      default:
        return 'http://www.w3.org/1999/xhtml'
    }
  }
  function St(e, t) {
    return null == e || 'http://www.w3.org/1999/xhtml' === e
      ? Et(t)
      : 'http://www.w3.org/2000/svg' === e && 'foreignObject' === t
      ? 'http://www.w3.org/1999/xhtml'
      : e
  }
  kt = function (e, t) {
    if ('http://www.w3.org/2000/svg' !== e.namespaceURI || 'innerHTML' in e) e.innerHTML = t
    else {
      for (
        (Ot = Ot || document.createElement('div')).innerHTML = '<svg>' + t.valueOf().toString() + '</svg>',
          t = Ot.firstChild;
        e.firstChild;

      )
        e.removeChild(e.firstChild)
      for (; t.firstChild; ) e.appendChild(t.firstChild)
    }
  }
  var Ot,
    kt,
    Pt =
      'undefined' != typeof MSApp && MSApp.execUnsafeLocalFunction
        ? function (e, t, n, r) {
            MSApp.execUnsafeLocalFunction(function () {
              return kt(e, t)
            })
          }
        : kt
  function _t(e, t) {
    if (t) {
      var n = e.firstChild
      if (n && n === e.lastChild && 3 === n.nodeType) return void (n.nodeValue = t)
    }
    e.textContent = t
  }
  var Lt = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    },
    Tt = ['Webkit', 'ms', 'Moz', 'O']
  function It(e, t, n) {
    return null == t || 'boolean' == typeof t || '' === t
      ? ''
      : n || 'number' != typeof t || 0 === t || (Lt.hasOwnProperty(e) && Lt[e])
      ? ('' + t).trim()
      : t + 'px'
  }
  function Mt(e, t) {
    for (var n in ((e = e.style), t)) {
      var r, i
      t.hasOwnProperty(n) &&
        ((r = 0 === n.indexOf('--')),
        (i = It(n, t[n], r)),
        'float' === n && (n = 'cssFloat'),
        r ? e.setProperty(n, i) : (e[n] = i))
    }
  }
  Object.keys(Lt).forEach(function (e) {
    Tt.forEach(function (t) {
      ;(t = t + e.charAt(0).toUpperCase() + e.substring(1)), (Lt[t] = Lt[e])
    })
  })
  var jt = tt(
    { menuitem: !0 },
    {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
    }
  )
  function Rt(e, t) {
    if (t) {
      if (jt[e] && (null != t.children || null != t.dangerouslySetInnerHTML)) throw Error(Oe(137, e))
      if (null != t.dangerouslySetInnerHTML) {
        if (null != t.children) throw Error(Oe(60))
        if ('object' != typeof t.dangerouslySetInnerHTML || !('__html' in t.dangerouslySetInnerHTML))
          throw Error(Oe(61))
      }
      if (null != t.style && 'object' != typeof t.style) throw Error(Oe(62))
    }
  }
  function Dt(e, t) {
    if (-1 === e.indexOf('-')) return 'string' == typeof t.is
    switch (e) {
      case 'annotation-xml':
      case 'color-profile':
      case 'font-face':
      case 'font-face-src':
      case 'font-face-uri':
      case 'font-face-format':
      case 'font-face-name':
      case 'missing-glyph':
        return !1
      default:
        return !0
    }
  }
  var At = null
  function zt(e) {
    return 3 ===
      (e = (e = e.target || e.srcElement || window).correspondingUseElement ? e.correspondingUseElement : e).nodeType
      ? e.parentNode
      : e
  }
  var Nt = null,
    Ft = null,
    Ht = null
  function Bt(e) {
    if ((e = wo(e))) {
      if ('function' != typeof Nt) throw Error(Oe(280))
      var t = e.stateNode
      t && ((t = xo(t)), Nt(e.stateNode, e.type, t))
    }
  }
  function Vt(e) {
    Ft ? (Ht ? Ht.push(e) : (Ht = [e])) : (Ft = e)
  }
  function Wt() {
    if (Ft) {
      var e = Ft,
        t = Ht
      if (((Ht = Ft = null), Bt(e), t)) for (e = 0; e < t.length; e++) Bt(t[e])
    }
  }
  function Gt(e, t) {
    return e(t)
  }
  function Zt() {}
  var Ut = !1
  function Xt(e, t, n) {
    if (Ut) return e(t, n)
    Ut = !0
    try {
      Gt(e, t, n)
    } finally {
      ;(Ut = !1), (null === Ft && null === Ht) || (Zt(), Wt())
    }
  }
  function Yt(e, t) {
    var n = e.stateNode
    if (null === n) return null
    var r = xo(n)
    if (null === r) return null
    switch (((n = r[t]), t)) {
      case 'onClick':
      case 'onClickCapture':
      case 'onDoubleClick':
      case 'onDoubleClickCapture':
      case 'onMouseDown':
      case 'onMouseDownCapture':
      case 'onMouseMove':
      case 'onMouseMoveCapture':
      case 'onMouseUp':
      case 'onMouseUpCapture':
      case 'onMouseEnter':
        e = !(r = (r = !r.disabled)
          ? r
          : !('button' === (e = e.type) || 'input' === e || 'select' === e || 'textarea' === e))
        break
      default:
        e = !1
    }
    if (e) return null
    if (n && 'function' != typeof n) throw Error(Oe(231, t, typeof n))
    return n
  }
  var qt = !1
  if (ce)
    try {
      var $t = {}
      Object.defineProperty($t, 'passive', {
        get: function () {
          qt = !0
        }
      }),
        window.addEventListener('test', $t, $t),
        window.removeEventListener('test', $t, $t)
    } catch (sD) {
      qt = !1
    }
  var Kt = !1,
    Qt = null,
    Jt = !1,
    en = null,
    tn = {
      onError: function (e) {
        ;(Kt = !0), (Qt = e)
      }
    }
  function nn(e, t, n, r, i, o, a, l, s) {
    ;(Kt = !1),
      (Qt = null),
      function (e, t, n, r, i, o, a, l, s) {
        var c = Array.prototype.slice.call(arguments, 3)
        try {
          t.apply(n, c)
        } catch (u) {
          this.onError(u)
        }
      }.apply(tn, arguments)
  }
  function rn(e) {
    var t = e,
      n = e
    if (e.alternate) for (; t.return; ) t = t.return
    else for (e = t; 0 != (4098 & (t = e).flags) && (n = t.return), (e = t.return); );
    return 3 === t.tag ? n : null
  }
  function on(e) {
    if (13 === e.tag) {
      var t = e.memoizedState
      if (null !== (t = null === t && null !== (e = e.alternate) ? e.memoizedState : t)) return t.dehydrated
    }
    return null
  }
  function an(e) {
    if (rn(e) !== e) throw Error(Oe(188))
  }
  function ln(e) {
    return null !==
      (e = (function (e) {
        var t = e.alternate
        if (!t) {
          if (null === (t = rn(e))) throw Error(Oe(188))
          return t !== e ? null : e
        }
        for (var n = e, r = t; ; ) {
          var i = n.return
          if (null === i) break
          var o = i.alternate
          if (null === o) {
            if (null === (r = i.return)) break
            n = r
          } else {
            if (i.child === o.child) {
              for (o = i.child; o; ) {
                if (o === n) return an(i), e
                if (o === r) return an(i), t
                o = o.sibling
              }
              throw Error(Oe(188))
            }
            if (n.return !== r.return) (n = i), (r = o)
            else {
              for (var a = !1, l = i.child; l; ) {
                if (l === n) {
                  ;(a = !0), (n = i), (r = o)
                  break
                }
                if (l === r) {
                  ;(a = !0), (r = i), (n = o)
                  break
                }
                l = l.sibling
              }
              if (!a) {
                for (l = o.child; l; ) {
                  if (l === n) {
                    ;(a = !0), (n = o), (r = i)
                    break
                  }
                  if (l === r) {
                    ;(a = !0), (r = o), (n = i)
                    break
                  }
                  l = l.sibling
                }
                if (!a) throw Error(Oe(189))
              }
            }
            if (n.alternate !== r) throw Error(Oe(190))
          }
        }
        if (3 !== n.tag) throw Error(Oe(188))
        return n.stateNode.current === n ? e : t
      })(e))
      ? (function e(t) {
          if (5 === t.tag || 6 === t.tag) return t
          for (t = t.child; null !== t; ) {
            var n = e(t)
            if (null !== n) return n
            t = t.sibling
          }
          return null
        })(e)
      : null
  }
  var sn = Se.unstable_scheduleCallback,
    cn = Se.unstable_cancelCallback,
    un = Se.unstable_shouldYield,
    dn = Se.unstable_requestPaint,
    fn = Se.unstable_now,
    hn = Se.unstable_getCurrentPriorityLevel,
    pn = Se.unstable_ImmediatePriority,
    gn = Se.unstable_UserBlockingPriority,
    mn = Se.unstable_NormalPriority,
    vn = Se.unstable_LowPriority,
    yn = Se.unstable_IdlePriority,
    bn = null,
    wn = null,
    Cn =
      Math.clz32 ||
      function (e) {
        return 0 == (e >>>= 0) ? 32 : (31 - ((xn(e) / En) | 0)) | 0
      },
    xn = Math.log,
    En = Math.LN2,
    Sn = 64,
    On = 4194304
  function kn(e) {
    switch (e & -e) {
      case 1:
        return 1
      case 2:
        return 2
      case 4:
        return 4
      case 8:
        return 8
      case 16:
        return 16
      case 32:
        return 32
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return 4194240 & e
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return 130023424 & e
      case 134217728:
        return 134217728
      case 268435456:
        return 268435456
      case 536870912:
        return 536870912
      case 1073741824:
        return 1073741824
      default:
        return e
    }
  }
  function Pn(e, t) {
    var n = e.pendingLanes
    if (0 === n) return 0
    var r,
      i = 0,
      o = e.suspendedLanes,
      a = e.pingedLanes,
      l = 268435455 & n
    if (
      (0 != l
        ? 0 != (r = l & ~o)
          ? (i = kn(r))
          : 0 != (a &= l) && (i = kn(a))
        : 0 != (l = n & ~o)
        ? (i = kn(l))
        : 0 !== a && (i = kn(a)),
      0 === i)
    )
      return 0
    if (0 !== t && t !== i && 0 == (t & o) && ((a = t & -t) <= (o = i & -i) || (16 === o && 0 != (4194240 & a))))
      return t
    if ((0 != (4 & i) && (i |= 16 & n), 0 !== (t = e.entangledLanes)))
      for (e = e.entanglements, t &= i; 0 < t; ) (i |= e[(n = 31 - Cn(t))]), (t &= ~(o = 1 << n))
    return i
  }
  function _n(e) {
    return 0 != (e = -1073741825 & e.pendingLanes) ? e : 1073741824 & e ? 1073741824 : 0
  }
  function Ln() {
    var e = Sn
    return 0 == (4194240 & (Sn <<= 1)) && (Sn = 64), e
  }
  function Tn(e) {
    for (var t = [], n = 0; n < 31; n++) t.push(e)
    return t
  }
  function In(e, t, n) {
    ;(e.pendingLanes |= t),
      536870912 !== t && ((e.suspendedLanes = 0), (e.pingedLanes = 0)),
      ((e = e.eventTimes)[(t = 31 - Cn(t))] = n)
  }
  function Mn(e, t) {
    var n = (e.entangledLanes |= t)
    for (e = e.entanglements; n; ) {
      var r = 31 - Cn(n),
        i = 1 << r
      ;(i & t) | (e[r] & t) && (e[r] |= t), (n &= ~i)
    }
  }
  var jn = 0
  function Rn(e) {
    return 1 < (e &= -e) ? (4 < e ? (0 != (268435455 & e) ? 16 : 536870912) : 4) : 1
  }
  var Dn,
    An,
    zn,
    Nn,
    Fn,
    Hn = !1,
    Bn = [],
    Vn = null,
    Wn = null,
    Gn = null,
    Zn = new Map(),
    Un = new Map(),
    Xn = [],
    Yn =
      'mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit'.split(
        ' '
      )
  function qn(e, t) {
    switch (e) {
      case 'focusin':
      case 'focusout':
        Vn = null
        break
      case 'dragenter':
      case 'dragleave':
        Wn = null
        break
      case 'mouseover':
      case 'mouseout':
        Gn = null
        break
      case 'pointerover':
      case 'pointerout':
        Zn.delete(t.pointerId)
        break
      case 'gotpointercapture':
      case 'lostpointercapture':
        Un.delete(t.pointerId)
    }
  }
  function $n(e, t, n, r, i, o) {
    return (
      null === e || e.nativeEvent !== o
        ? ((e = { blockedOn: t, domEventName: n, eventSystemFlags: r, nativeEvent: o, targetContainers: [i] }),
          null !== t && null !== (t = wo(t)) && An(t))
        : ((e.eventSystemFlags |= r), (t = e.targetContainers), null !== i && -1 === t.indexOf(i) && t.push(i)),
      e
    )
  }
  function Kn(e) {
    var t = bo(e.target)
    if (null !== t) {
      var n = rn(t)
      if (null !== n)
        if (13 === (t = n.tag)) {
          if (null !== (t = on(n)))
            return (
              (e.blockedOn = t),
              void Fn(e.priority, function () {
                zn(n)
              })
            )
        } else if (3 === t && n.stateNode.current.memoizedState.isDehydrated)
          return void (e.blockedOn = 3 === n.tag ? n.stateNode.containerInfo : null)
    }
    e.blockedOn = null
  }
  function Qn(e) {
    if (null === e.blockedOn) {
      for (var t = e.targetContainers; 0 < t.length; ) {
        var n = cr(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent)
        if (null !== n) return null !== (t = wo(n)) && An(t), (e.blockedOn = n), 0
        var r = new (n = e.nativeEvent).constructor(n.type, n)
        ;(At = r), n.target.dispatchEvent(r), (At = null), t.shift()
      }
      return 1
    }
  }
  function Jn(e, t, n) {
    Qn(e) && n.delete(t)
  }
  function er() {
    ;(Hn = !1),
      null !== Vn && Qn(Vn) && (Vn = null),
      null !== Wn && Qn(Wn) && (Wn = null),
      null !== Gn && Qn(Gn) && (Gn = null),
      Zn.forEach(Jn),
      Un.forEach(Jn)
  }
  function tr(e, t) {
    e.blockedOn === t &&
      ((e.blockedOn = null), Hn || ((Hn = !0), Se.unstable_scheduleCallback(Se.unstable_NormalPriority, er)))
  }
  function nr(e) {
    function t(t) {
      return tr(t, e)
    }
    if (0 < Bn.length) {
      tr(Bn[0], e)
      for (var n = 1; n < Bn.length; n++) {
        var r = Bn[n]
        r.blockedOn === e && (r.blockedOn = null)
      }
    }
    for (
      null !== Vn && tr(Vn, e), null !== Wn && tr(Wn, e), null !== Gn && tr(Gn, e), Zn.forEach(t), Un.forEach(t), n = 0;
      n < Xn.length;
      n++
    )
      (r = Xn[n]).blockedOn === e && (r.blockedOn = null)
    for (; 0 < Xn.length && null === (n = Xn[0]).blockedOn; ) Kn(n), null === n.blockedOn && Xn.shift()
  }
  var rr = c.ReactCurrentBatchConfig,
    ir = !0
  function or(e, t, n, r) {
    var i = jn,
      o = rr.transition
    rr.transition = null
    try {
      ;(jn = 1), lr(e, t, n, r)
    } finally {
      ;(jn = i), (rr.transition = o)
    }
  }
  function ar(e, t, n, r) {
    var i = jn,
      o = rr.transition
    rr.transition = null
    try {
      ;(jn = 4), lr(e, t, n, r)
    } finally {
      ;(jn = i), (rr.transition = o)
    }
  }
  function lr(e, t, n, r) {
    if (ir) {
      var i = cr(e, 0, 0, r)
      if (null === i) Zi(e, t, r, sr, n), qn(e, r)
      else if (
        (function (e, t, n, r, i) {
          switch (t) {
            case 'focusin':
              return (Vn = $n(Vn, e, t, n, r, i)), 1
            case 'dragenter':
              return (Wn = $n(Wn, e, t, n, r, i)), 1
            case 'mouseover':
              return (Gn = $n(Gn, e, t, n, r, i)), 1
            case 'pointerover':
              var o = i.pointerId
              return Zn.set(o, $n(Zn.get(o) || null, e, t, n, r, i)), 1
            case 'gotpointercapture':
              return (o = i.pointerId), Un.set(o, $n(Un.get(o) || null, e, t, n, r, i)), 1
          }
        })(i, e, t, n, r)
      )
        r.stopPropagation()
      else if ((qn(e, r), 4 & t && -1 < Yn.indexOf(e))) {
        for (; null !== i; ) {
          var o = wo(i)
          if ((null !== o && Dn(o), null === (o = cr(e, 0, 0, r)) && Zi(e, t, r, sr, n), o === i)) break
          i = o
        }
        null !== i && r.stopPropagation()
      } else Zi(e, t, r, null, n)
    }
  }
  var sr = null
  function cr(e, t, n, r) {
    if ((sr = null) !== (e = bo((e = zt(r)))))
      if (null === (t = rn(e))) e = null
      else if (13 === (n = t.tag)) {
        if (null !== (e = on(t))) return e
        e = null
      } else if (3 === n) {
        if (t.stateNode.current.memoizedState.isDehydrated) return 3 === t.tag ? t.stateNode.containerInfo : null
        e = null
      } else t !== e && (e = null)
    return (sr = e), null
  }
  function ur(e) {
    switch (e) {
      case 'cancel':
      case 'click':
      case 'close':
      case 'contextmenu':
      case 'copy':
      case 'cut':
      case 'auxclick':
      case 'dblclick':
      case 'dragend':
      case 'dragstart':
      case 'drop':
      case 'focusin':
      case 'focusout':
      case 'input':
      case 'invalid':
      case 'keydown':
      case 'keypress':
      case 'keyup':
      case 'mousedown':
      case 'mouseup':
      case 'paste':
      case 'pause':
      case 'play':
      case 'pointercancel':
      case 'pointerdown':
      case 'pointerup':
      case 'ratechange':
      case 'reset':
      case 'resize':
      case 'seeked':
      case 'submit':
      case 'touchcancel':
      case 'touchend':
      case 'touchstart':
      case 'volumechange':
      case 'change':
      case 'selectionchange':
      case 'textInput':
      case 'compositionstart':
      case 'compositionend':
      case 'compositionupdate':
      case 'beforeblur':
      case 'afterblur':
      case 'beforeinput':
      case 'blur':
      case 'fullscreenchange':
      case 'focus':
      case 'hashchange':
      case 'popstate':
      case 'select':
      case 'selectstart':
        return 1
      case 'drag':
      case 'dragenter':
      case 'dragexit':
      case 'dragleave':
      case 'dragover':
      case 'mousemove':
      case 'mouseout':
      case 'mouseover':
      case 'pointermove':
      case 'pointerout':
      case 'pointerover':
      case 'scroll':
      case 'toggle':
      case 'touchmove':
      case 'wheel':
      case 'mouseenter':
      case 'mouseleave':
      case 'pointerenter':
      case 'pointerleave':
        return 4
      case 'message':
        switch (hn()) {
          case pn:
            return 1
          case gn:
            return 4
          case mn:
          case vn:
            return 16
          case yn:
            return 536870912
          default:
            return 16
        }
      default:
        return 16
    }
  }
  var dr = null,
    fr = null,
    hr = null
  function pr() {
    if (hr) return hr
    for (
      var e = fr, t = e.length, n = ('value' in dr) ? dr.value : dr.textContent, r = n.length, i = 0;
      i < t && e[i] === n[i];
      i++
    );
    for (var o = t - i, a = 1; a <= o && e[t - a] === n[r - a]; a++);
    return (hr = n.slice(i, 1 < a ? 1 - a : void 0))
  }
  function gr(e) {
    var t = e.keyCode
    return (
      'charCode' in e ? 0 === (e = e.charCode) && 13 === t && (e = 13) : (e = t),
      32 <= (e = 10 === e ? 13 : e) || 13 === e ? e : 0
    )
  }
  function mr() {
    return !0
  }
  function vr() {
    return !1
  }
  function yr(e) {
    function t(t, n, r, i, o) {
      for (var a in ((this._reactName = t),
      (this._targetInst = r),
      (this.type = n),
      (this.nativeEvent = i),
      (this.target = o),
      (this.currentTarget = null),
      e))
        e.hasOwnProperty(a) && ((t = e[a]), (this[a] = t ? t(i) : i[a]))
      return (
        (this.isDefaultPrevented = (null != i.defaultPrevented ? i.defaultPrevented : !1 === i.returnValue) ? mr : vr),
        (this.isPropagationStopped = vr),
        this
      )
    }
    return (
      tt(t.prototype, {
        preventDefault: function () {
          this.defaultPrevented = !0
          var e = this.nativeEvent
          e &&
            (e.preventDefault ? e.preventDefault() : 'unknown' != typeof e.returnValue && (e.returnValue = !1),
            (this.isDefaultPrevented = mr))
        },
        stopPropagation: function () {
          var e = this.nativeEvent
          e &&
            (e.stopPropagation ? e.stopPropagation() : 'unknown' != typeof e.cancelBubble && (e.cancelBubble = !0),
            (this.isPropagationStopped = mr))
        },
        persist: function () {},
        isPersistent: mr
      }),
      t
    )
  }
  var br,
    wr,
    Cr,
    xr = yr(
      (h = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function (e) {
          return e.timeStamp || Date.now()
        },
        defaultPrevented: 0,
        isTrusted: 0
      })
    ),
    Er = yr((p = tt({}, h, { view: 0, detail: 0 }))),
    Sr = yr(
      ($t = tt({}, p, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: Rr,
        button: 0,
        buttons: 0,
        relatedTarget: function (e) {
          return void 0 === e.relatedTarget
            ? e.fromElement === e.srcElement
              ? e.toElement
              : e.fromElement
            : e.relatedTarget
        },
        movementX: function (e) {
          return 'movementX' in e
            ? e.movementX
            : (e !== Cr &&
                ((wr =
                  Cr && 'mousemove' === e.type ? ((br = e.screenX - Cr.screenX), e.screenY - Cr.screenY) : (br = 0)),
                (Cr = e)),
              br)
        },
        movementY: function (e) {
          return 'movementY' in e ? e.movementY : wr
        }
      }))
    ),
    Or = yr(tt({}, $t, { dataTransfer: 0 })),
    kr = yr(tt({}, p, { relatedTarget: 0 })),
    Pr = yr(tt({}, h, { animationName: 0, elapsedTime: 0, pseudoElement: 0 })),
    _r = yr(
      tt({}, h, {
        clipboardData: function (e) {
          return ('clipboardData' in e ? e : window).clipboardData
        }
      })
    ),
    Lr = yr(tt({}, h, { data: 0 })),
    Tr = {
      Esc: 'Escape',
      Spacebar: ' ',
      Left: 'ArrowLeft',
      Up: 'ArrowUp',
      Right: 'ArrowRight',
      Down: 'ArrowDown',
      Del: 'Delete',
      Win: 'OS',
      Menu: 'ContextMenu',
      Apps: 'ContextMenu',
      Scroll: 'ScrollLock',
      MozPrintableKey: 'Unidentified'
    },
    Ir = {
      8: 'Backspace',
      9: 'Tab',
      12: 'Clear',
      13: 'Enter',
      16: 'Shift',
      17: 'Control',
      18: 'Alt',
      19: 'Pause',
      20: 'CapsLock',
      27: 'Escape',
      32: ' ',
      33: 'PageUp',
      34: 'PageDown',
      35: 'End',
      36: 'Home',
      37: 'ArrowLeft',
      38: 'ArrowUp',
      39: 'ArrowRight',
      40: 'ArrowDown',
      45: 'Insert',
      46: 'Delete',
      112: 'F1',
      113: 'F2',
      114: 'F3',
      115: 'F4',
      116: 'F5',
      117: 'F6',
      118: 'F7',
      119: 'F8',
      120: 'F9',
      121: 'F10',
      122: 'F11',
      123: 'F12',
      144: 'NumLock',
      145: 'ScrollLock',
      224: 'Meta'
    },
    Mr = { Alt: 'altKey', Control: 'ctrlKey', Meta: 'metaKey', Shift: 'shiftKey' }
  function jr(e) {
    var t = this.nativeEvent
    return t.getModifierState ? t.getModifierState(e) : !!(e = Mr[e]) && !!t[e]
  }
  function Rr() {
    return jr
  }
  var Dr = yr(
      tt({}, p, {
        key: function (e) {
          if (e.key) {
            var t = Tr[e.key] || e.key
            if ('Unidentified' !== t) return t
          }
          return 'keypress' === e.type
            ? 13 === (e = gr(e))
              ? 'Enter'
              : String.fromCharCode(e)
            : 'keydown' === e.type || 'keyup' === e.type
            ? Ir[e.keyCode] || 'Unidentified'
            : ''
        },
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: Rr,
        charCode: function (e) {
          return 'keypress' === e.type ? gr(e) : 0
        },
        keyCode: function (e) {
          return 'keydown' === e.type || 'keyup' === e.type ? e.keyCode : 0
        },
        which: function (e) {
          return 'keypress' === e.type ? gr(e) : 'keydown' === e.type || 'keyup' === e.type ? e.keyCode : 0
        }
      })
    ),
    Ar = yr(
      tt({}, $t, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
      })
    ),
    zr = yr(
      tt({}, p, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: Rr
      })
    ),
    Nr = yr(tt({}, h, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 })),
    Fr = yr(
      tt({}, $t, {
        deltaX: function (e) {
          return 'deltaX' in e ? e.deltaX : 'wheelDeltaX' in e ? -e.wheelDeltaX : 0
        },
        deltaY: function (e) {
          return 'deltaY' in e ? e.deltaY : 'wheelDeltaY' in e ? -e.wheelDeltaY : 'wheelDelta' in e ? -e.wheelDelta : 0
        },
        deltaZ: 0,
        deltaMode: 0
      })
    ),
    Hr = [9, 13, 27, 32],
    Br = ce && 'CompositionEvent' in window,
    Vr =
      ((p = null), ce && 'documentMode' in document && (p = document.documentMode), ce && 'TextEvent' in window && !p),
    Wr = ce && (!Br || (p && 8 < p && p <= 11)),
    Gr = String.fromCharCode(32),
    Zr = !1
  function Ur(e, t) {
    switch (e) {
      case 'keyup':
        return -1 !== Hr.indexOf(t.keyCode)
      case 'keydown':
        return 229 !== t.keyCode
      case 'keypress':
      case 'mousedown':
      case 'focusout':
        return 1
      default:
        return
    }
  }
  function Xr(e) {
    return 'object' == typeof (e = e.detail) && 'data' in e ? e.data : null
  }
  var Yr = !1,
    qr = {
      color: !0,
      date: !0,
      datetime: !0,
      'datetime-local': !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    }
  function $r(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase()
    return 'input' === t ? qr[e.type] : 'textarea' === t
  }
  function Kr(e, t, n, r) {
    Vt(r),
      0 < (t = Xi(t, 'onChange')).length &&
        ((n = new xr('onChange', 'change', null, n, r)), e.push({ event: n, listeners: t }))
  }
  var Qr = null,
    Jr = null
  function ei(e) {
    Fi(e, 0)
  }
  function ti(e) {
    if (ct(Co(e))) return e
  }
  function ni(e, t) {
    if ('change' === e) return t
  }
  var ri = !1
  function ii() {
    Qr && (Qr.detachEvent('onpropertychange', oi), (Jr = Qr = null))
  }
  function oi(e) {
    var t
    'value' === e.propertyName && ti(Jr) && (Kr((t = []), Jr, e, zt(e)), Xt(ei, t))
  }
  function ai(e, t, n) {
    'focusin' === e ? (ii(), (Jr = n), (Qr = t).attachEvent('onpropertychange', oi)) : 'focusout' === e && ii()
  }
  function li(e) {
    if ('selectionchange' === e || 'keyup' === e || 'keydown' === e) return ti(Jr)
  }
  function si(e, t) {
    if ('click' === e) return ti(t)
  }
  function ci(e, t) {
    if ('input' === e || 'change' === e) return ti(t)
  }
  ce &&
    ((p =
      ce &&
      ((h = 'oninput' in document) ||
        (($t = document.createElement('div')).setAttribute('oninput', 'return;'),
        (h = 'function' == typeof $t.oninput)),
      h)),
    (ri = p && (!document.documentMode || 9 < document.documentMode)))
  var ui =
    'function' == typeof Object.is
      ? Object.is
      : function (e, t) {
          return (e === t && (0 !== e || 1 / e == 1 / t)) || (e != e && t != t)
        }
  function di(e, t) {
    if (!ui(e, t)) {
      if ('object' != typeof e || null === e || 'object' != typeof t || null === t) return !1
      var n = Object.keys(e),
        r = Object.keys(t)
      if (n.length !== r.length) return !1
      for (r = 0; r < n.length; r++) {
        var i = n[r]
        if (!Te.call(t, i) || !ui(e[i], t[i])) return !1
      }
    }
    return !0
  }
  function fi(e) {
    for (; e && e.firstChild; ) e = e.firstChild
    return e
  }
  function hi(e, t) {
    var n,
      r = fi(e)
    for (e = 0; r; ) {
      if (3 === r.nodeType) {
        if (((n = e + r.textContent.length), e <= t && t <= n)) return { node: r, offset: t - e }
        e = n
      }
      e: {
        for (; r; ) {
          if (r.nextSibling) {
            r = r.nextSibling
            break e
          }
          r = r.parentNode
        }
        r = void 0
      }
      r = fi(r)
    }
  }
  function pi() {
    for (var e = window, t = ut(); t instanceof e.HTMLIFrameElement; ) {
      try {
        var n = 'string' == typeof t.contentWindow.location.href
      } catch (r) {
        n = !1
      }
      if (!n) break
      t = ut((e = t.contentWindow).document)
    }
    return t
  }
  function gi(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase()
    return (
      t &&
      (('input' === t &&
        ('text' === e.type || 'search' === e.type || 'tel' === e.type || 'url' === e.type || 'password' === e.type)) ||
        'textarea' === t ||
        'true' === e.contentEditable)
    )
  }
  var mi = ce && 'documentMode' in document && document.documentMode <= 11,
    vi = null,
    yi = null,
    bi = null,
    wi = !1
  function Ci(e, t, n) {
    var r = n.window === n ? n.document : 9 === n.nodeType ? n : n.ownerDocument
    wi ||
      null == vi ||
      vi !== ut(r) ||
      ((r =
        'selectionStart' in (r = vi) && gi(r)
          ? { start: r.selectionStart, end: r.selectionEnd }
          : {
              anchorNode: (r = ((r.ownerDocument && r.ownerDocument.defaultView) || window).getSelection()).anchorNode,
              anchorOffset: r.anchorOffset,
              focusNode: r.focusNode,
              focusOffset: r.focusOffset
            }),
      bi && di(bi, r)) ||
      ((bi = r),
      0 < (r = Xi(yi, 'onSelect')).length &&
        ((t = new xr('onSelect', 'select', null, t, n)), e.push({ event: t, listeners: r }), (t.target = vi)))
  }
  function xi(e, t) {
    var n = {}
    return (n[e.toLowerCase()] = t.toLowerCase()), (n['Webkit' + e] = 'webkit' + t), (n['Moz' + e] = 'moz' + t), n
  }
  var Ei = {
      animationend: xi('Animation', 'AnimationEnd'),
      animationiteration: xi('Animation', 'AnimationIteration'),
      animationstart: xi('Animation', 'AnimationStart'),
      transitionend: xi('Transition', 'TransitionEnd')
    },
    Si = {},
    Oi = {}
  function ki(e) {
    if (Si[e]) return Si[e]
    if (Ei[e]) {
      var t,
        n = Ei[e]
      for (t in n) if (n.hasOwnProperty(t) && t in Oi) return (Si[e] = n[t])
    }
    return e
  }
  ce &&
    ((Oi = document.createElement('div').style),
    'AnimationEvent' in window ||
      (delete Ei.animationend.animation, delete Ei.animationiteration.animation, delete Ei.animationstart.animation),
    'TransitionEvent' in window || delete Ei.transitionend.transition)
  var Pi = ki('animationend'),
    _i = ki('animationiteration'),
    Li = ki('animationstart'),
    Ti = ki('transitionend'),
    Ii = new Map(),
    Mi =
      'abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel'.split(
        ' '
      )
  function ji(e, t) {
    Ii.set(e, t), _e(t, [e])
  }
  for (var Ri = 0; Ri < Mi.length; Ri++) {
    var Di = Mi[Ri]
    ji(Di.toLowerCase(), 'on' + (Di[0].toUpperCase() + Di.slice(1)))
  }
  ji(Pi, 'onAnimationEnd'),
    ji(_i, 'onAnimationIteration'),
    ji(Li, 'onAnimationStart'),
    ji('dblclick', 'onDoubleClick'),
    ji('focusin', 'onFocus'),
    ji('focusout', 'onBlur'),
    ji(Ti, 'onTransitionEnd'),
    Le('onMouseEnter', ['mouseout', 'mouseover']),
    Le('onMouseLeave', ['mouseout', 'mouseover']),
    Le('onPointerEnter', ['pointerout', 'pointerover']),
    Le('onPointerLeave', ['pointerout', 'pointerover']),
    _e('onChange', 'change click focusin focusout input keydown keyup selectionchange'.split(' ')),
    _e('onSelect', 'focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange'.split(' ')),
    _e('onBeforeInput', ['compositionend', 'keypress', 'textInput', 'paste']),
    _e('onCompositionEnd', 'compositionend focusout keydown keypress keyup mousedown'.split(' ')),
    _e('onCompositionStart', 'compositionstart focusout keydown keypress keyup mousedown'.split(' ')),
    _e('onCompositionUpdate', 'compositionupdate focusout keydown keypress keyup mousedown'.split(' '))
  var Ai =
      'abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting'.split(
        ' '
      ),
    zi = new Set('cancel close invalid load scroll toggle'.split(' ').concat(Ai))
  function Ni(e, t, n) {
    var r = e.type || 'unknown-event'
    ;(e.currentTarget = n),
      (function () {
        var e
        nn.apply(this, arguments), Kt && ((e = Qt), (Kt = !1), (Qt = null), Jt || ((Jt = !0), (en = e)))
      })(r, t, void 0, e),
      (e.currentTarget = null)
  }
  function Fi(e, t) {
    t = 0 != (4 & t)
    for (var n = 0; n < e.length; n++) {
      var r = (i = e[n]).event,
        i = i.listeners
      e: {
        var o = void 0
        if (t)
          for (var a = i.length - 1; 0 <= a; a--) {
            var l = (c = i[a]).instance,
              s = c.currentTarget,
              c = c.listener
            if (l !== o && r.isPropagationStopped()) break e
            Ni(r, c, s), (o = l)
          }
        else
          for (a = 0; a < i.length; a++) {
            if (
              ((l = (c = i[a]).instance), (s = c.currentTarget), (c = c.listener), l !== o && r.isPropagationStopped())
            )
              break e
            Ni(r, c, s), (o = l)
          }
      }
    }
    if (Jt) throw ((e = en), (Jt = !1), (en = null), e)
  }
  function Hi(e, t) {
    var n = t[mo],
      r = e + '__bubble'
    ;(n = void 0 === n ? (t[mo] = new Set()) : n).has(r) || (Gi(t, e, 2, !1), n.add(r))
  }
  function Bi(e, t, n) {
    var r = 0
    t && (r |= 4), Gi(n, e, r, t)
  }
  var Vi = '_reactListening' + Math.random().toString(36).slice(2)
  function Wi(e) {
    var t
    e[Vi] ||
      ((e[Vi] = !0),
      ke.forEach(function (t) {
        'selectionchange' !== t && (zi.has(t) || Bi(t, !1, e), Bi(t, !0, e))
      }),
      null === (t = 9 === e.nodeType ? e : e.ownerDocument)) ||
      t[Vi] ||
      Bi('selectionchange', !(t[Vi] = !0), t)
  }
  function Gi(e, t, n, r) {
    switch (ur(t)) {
      case 1:
        var i = or
        break
      case 4:
        i = ar
        break
      default:
        i = lr
    }
    ;(n = i.bind(null, t, n, e)),
      (i = !(!qt || ('touchstart' !== t && 'touchmove' !== t && 'wheel' !== t)) || void 0),
      r
        ? void 0 !== i
          ? e.addEventListener(t, n, { capture: !0, passive: i })
          : e.addEventListener(t, n, !0)
        : void 0 !== i
        ? e.addEventListener(t, n, { passive: i })
        : e.addEventListener(t, n, !1)
  }
  function Zi(e, t, n, r, i) {
    var o = r
    if (0 == (1 & t) && 0 == (2 & t) && null !== r)
      e: for (;;) {
        if (null === r) return
        var a = r.tag
        if (3 === a || 4 === a) {
          var l = r.stateNode.containerInfo
          if (l === i || (8 === l.nodeType && l.parentNode === i)) break
          if (4 === a)
            for (a = r.return; null !== a; ) {
              var s = a.tag
              if (
                (3 === s || 4 === s) &&
                ((s = a.stateNode.containerInfo) === i || (8 === s.nodeType && s.parentNode === i))
              )
                return
              a = a.return
            }
          for (; null !== l; ) {
            if (null === (a = bo(l))) return
            if (5 === (s = a.tag) || 6 === s) {
              r = o = a
              continue e
            }
            l = l.parentNode
          }
        }
        r = r.return
      }
    Xt(function () {
      var r,
        i,
        a,
        l = o,
        s = zt(n),
        c = []
      e: {
        var u = Ii.get(e)
        if (void 0 !== u) {
          var d = xr,
            f = e
          switch (e) {
            case 'keypress':
              if (0 === gr(n)) break e
            case 'keydown':
            case 'keyup':
              d = Dr
              break
            case 'focusin':
              ;(f = 'focus'), (d = kr)
              break
            case 'focusout':
              ;(f = 'blur'), (d = kr)
              break
            case 'beforeblur':
            case 'afterblur':
              d = kr
              break
            case 'click':
              if (2 === n.button) break e
            case 'auxclick':
            case 'dblclick':
            case 'mousedown':
            case 'mousemove':
            case 'mouseup':
            case 'mouseout':
            case 'mouseover':
            case 'contextmenu':
              d = Sr
              break
            case 'drag':
            case 'dragend':
            case 'dragenter':
            case 'dragexit':
            case 'dragleave':
            case 'dragover':
            case 'dragstart':
            case 'drop':
              d = Or
              break
            case 'touchcancel':
            case 'touchend':
            case 'touchmove':
            case 'touchstart':
              d = zr
              break
            case Pi:
            case _i:
            case Li:
              d = Pr
              break
            case Ti:
              d = Nr
              break
            case 'scroll':
              d = Er
              break
            case 'wheel':
              d = Fr
              break
            case 'copy':
            case 'cut':
            case 'paste':
              d = _r
              break
            case 'gotpointercapture':
            case 'lostpointercapture':
            case 'pointercancel':
            case 'pointerdown':
            case 'pointermove':
            case 'pointerout':
            case 'pointerover':
            case 'pointerup':
              d = Ar
          }
          for (
            var h = !(g = 0 != (4 & t)) && 'scroll' === e,
              p = g ? (null !== u ? u + 'Capture' : null) : u,
              g = [],
              m = l;
            null !== m;

          ) {
            var v,
              y = (v = m).stateNode
            if (
              (5 === v.tag && null !== y && ((v = y), null !== p) && null != (y = Yt(m, p)) && g.push(Ui(m, y, v)), h)
            )
              break
            m = m.return
          }
          0 < g.length && ((u = new d(u, f, null, n, s)), c.push({ event: u, listeners: g }))
        }
      }
      if (0 == (7 & t)) {
        if (
          ((d = 'mouseout' === e || 'pointerout' === e),
          (!(u = 'mouseover' === e || 'pointerover' === e) ||
            n === At ||
            !(f = n.relatedTarget || n.fromElement) ||
            (!bo(f) && !f[go])) &&
            (d || u) &&
            ((u = s.window === s ? s : (u = s.ownerDocument) ? u.defaultView || u.parentWindow : window),
            d
              ? ((d = l),
                null !== (f = (f = n.relatedTarget || n.toElement) ? bo(f) : null) &&
                  (f !== (h = rn(f)) || (5 !== f.tag && 6 !== f.tag)) &&
                  (f = null))
              : ((d = null), (f = l)),
            d !== f))
        ) {
          if (
            ((g = Sr),
            (y = 'onMouseLeave'),
            (p = 'onMouseEnter'),
            (m = 'mouse'),
            ('pointerout' !== e && 'pointerover' !== e) ||
              ((g = Ar), (y = 'onPointerLeave'), (p = 'onPointerEnter'), (m = 'pointer')),
            (h = null == d ? u : Co(d)),
            (v = null == f ? u : Co(f)),
            ((u = new g(y, m + 'leave', d, n, s)).target = h),
            (u.relatedTarget = v),
            (y = null),
            bo(s) === l && (((g = new g(p, m + 'enter', f, n, s)).target = v), (g.relatedTarget = h), (y = g)),
            (h = y),
            d && f)
          )
            e: {
              for (p = f, m = 0, v = g = d; v; v = Yi(v)) m++
              for (v = 0, y = p; y; y = Yi(y)) v++
              for (; 0 < m - v; ) (g = Yi(g)), m--
              for (; 0 < v - m; ) (p = Yi(p)), v--
              for (; m--; ) {
                if (g === p || (null !== p && g === p.alternate)) break e
                ;(g = Yi(g)), (p = Yi(p))
              }
              g = null
            }
          else g = null
          null !== d && qi(c, u, d, g, !1), null !== f && null !== h && qi(c, h, f, g, !0)
        }
        switch (
          ('select' === (d = (u = l ? Co(l) : window).nodeName && u.nodeName.toLowerCase()) ||
          ('input' === d && 'file' === u.type)
            ? (r = ni)
            : $r(u)
            ? ri
              ? (r = ci)
              : ((r = li), (i = ai))
            : !(d = u.nodeName) ||
              'input' !== d.toLowerCase() ||
              ('checkbox' !== u.type && 'radio' !== u.type) ||
              (r = si),
          (r = r && r(e, l))
            ? Kr(c, r, n, s)
            : (i && i(e, u, l),
              'focusout' === e &&
                (i = u._wrapperState) &&
                i.controlled &&
                'number' === u.type &&
                mt(u, 'number', u.value)),
          (i = l ? Co(l) : window),
          e)
        ) {
          case 'focusin':
            ;(!$r(i) && 'true' !== i.contentEditable) || ((vi = i), (yi = l), (bi = null))
            break
          case 'focusout':
            bi = yi = vi = null
            break
          case 'mousedown':
            wi = !0
            break
          case 'contextmenu':
          case 'mouseup':
          case 'dragend':
            ;(wi = !1), Ci(c, n, s)
            break
          case 'selectionchange':
            if (mi) break
          case 'keydown':
          case 'keyup':
            Ci(c, n, s)
        }
        if (Br)
          e: {
            switch (e) {
              case 'compositionstart':
                var b = 'onCompositionStart'
                break e
              case 'compositionend':
                b = 'onCompositionEnd'
                break e
              case 'compositionupdate':
                b = 'onCompositionUpdate'
                break e
            }
            b = void 0
          }
        else
          Yr ? Ur(e, n) && (b = 'onCompositionEnd') : 'keydown' === e && 229 === n.keyCode && (b = 'onCompositionStart')
        b &&
          (Wr &&
            'ko' !== n.locale &&
            (Yr || 'onCompositionStart' !== b
              ? 'onCompositionEnd' === b && Yr && (a = pr())
              : ((fr = 'value' in (dr = s) ? dr.value : dr.textContent), (Yr = !0))),
          0 < (i = Xi(l, b)).length) &&
          ((b = new Lr(b, e, null, n, s)), c.push({ event: b, listeners: i }), a || null !== (a = Xr(n))) &&
          (b.data = a),
          (a = (
            Vr
              ? function (e, t) {
                  switch (e) {
                    case 'compositionend':
                      return Xr(t)
                    case 'keypress':
                      return 32 !== t.which ? null : ((Zr = !0), Gr)
                    case 'textInput':
                      return (e = t.data) === Gr && Zr ? null : e
                    default:
                      return null
                  }
                }
              : function (e, t) {
                  if (Yr)
                    return 'compositionend' === e || (!Br && Ur(e, t))
                      ? ((e = pr()), (hr = fr = dr = null), (Yr = !1), e)
                      : null
                  switch (e) {
                    case 'paste':
                    default:
                      return null
                    case 'keypress':
                      if (!(t.ctrlKey || t.altKey || t.metaKey) || (t.ctrlKey && t.altKey)) {
                        if (t.char && 1 < t.char.length) return t.char
                        if (t.which) return String.fromCharCode(t.which)
                      }
                      return null
                    case 'compositionend':
                      return Wr && 'ko' !== t.locale ? null : t.data
                  }
                }
          )(e, n)) &&
            0 < (l = Xi(l, 'onBeforeInput')).length &&
            ((s = new Lr('onBeforeInput', 'beforeinput', null, n, s)), c.push({ event: s, listeners: l }), (s.data = a))
      }
      Fi(c, t)
    })
  }
  function Ui(e, t, n) {
    return { instance: e, listener: t, currentTarget: n }
  }
  function Xi(e, t) {
    for (var n = t + 'Capture', r = []; null !== e; ) {
      var i = e,
        o = i.stateNode
      5 === i.tag &&
        null !== o &&
        ((i = o), null != (o = Yt(e, n)) && r.unshift(Ui(e, o, i)), null != (o = Yt(e, t))) &&
        r.push(Ui(e, o, i)),
        (e = e.return)
    }
    return r
  }
  function Yi(e) {
    if (null === e) return null
    for (; (e = e.return) && 5 !== e.tag; );
    return e || null
  }
  function qi(e, t, n, r, i) {
    for (var o = t._reactName, a = []; null !== n && n !== r; ) {
      var l = n,
        s = l.alternate,
        c = l.stateNode
      if (null !== s && s === r) break
      5 === l.tag &&
        null !== c &&
        ((l = c), i ? null != (s = Yt(n, o)) && a.unshift(Ui(n, s, l)) : null != (s = Yt(n, o)) && a.push(Ui(n, s, l))),
        (n = n.return)
    }
    0 !== a.length && e.push({ event: t, listeners: a })
  }
  var $i = /\r\n?/g,
    Ki = /\u0000|\uFFFD/g
  function Qi(e) {
    return ('string' == typeof e ? e : '' + e).replace($i, '\n').replace(Ki, '')
  }
  function Ji(e, t, n) {
    if (((t = Qi(t)), Qi(e) !== t && n)) throw Error(Oe(425))
  }
  function eo() {}
  var to = null,
    no = null
  function ro(e, t) {
    return (
      'textarea' === e ||
      'noscript' === e ||
      'string' == typeof t.children ||
      'number' == typeof t.children ||
      ('object' == typeof t.dangerouslySetInnerHTML &&
        null !== t.dangerouslySetInnerHTML &&
        null != t.dangerouslySetInnerHTML.__html)
    )
  }
  var io = 'function' == typeof setTimeout ? setTimeout : void 0,
    oo = 'function' == typeof clearTimeout ? clearTimeout : void 0,
    ao = 'function' == typeof Promise ? Promise : void 0,
    lo =
      'function' == typeof queueMicrotask
        ? queueMicrotask
        : void 0 !== ao
        ? function (e) {
            return ao.resolve(null).then(e).catch(so)
          }
        : io
  function so(e) {
    setTimeout(function () {
      throw e
    })
  }
  function co(e, t) {
    var n = t,
      r = 0
    do {
      var i = n.nextSibling
      if ((e.removeChild(n), i && 8 === i.nodeType))
        if ('/$' === (n = i.data)) {
          if (0 === r) return e.removeChild(i), void nr(t)
          r--
        } else ('$' !== n && '$?' !== n && '$!' !== n) || r++
    } while ((n = i))
    nr(t)
  }
  function uo(e) {
    for (; null != e; e = e.nextSibling) {
      var t = e.nodeType
      if (1 === t || 3 === t) break
      if (8 === t) {
        if ('$' === (t = e.data) || '$!' === t || '$?' === t) break
        if ('/$' === t) return null
      }
    }
    return e
  }
  function fo(e) {
    e = e.previousSibling
    for (var t = 0; e; ) {
      if (8 === e.nodeType) {
        var n = e.data
        if ('$' === n || '$!' === n || '$?' === n) {
          if (0 === t) return e
          t--
        } else '/$' === n && t++
      }
      e = e.previousSibling
    }
    return null
  }
  var ho = '__reactFiber$' + ($t = Math.random().toString(36).slice(2)),
    po = '__reactProps$' + $t,
    go = '__reactContainer$' + $t,
    mo = '__reactEvents$' + $t,
    vo = '__reactListeners$' + $t,
    yo = '__reactHandles$' + $t
  function bo(e) {
    var t = e[ho]
    if (t) return t
    for (var n = e.parentNode; n; ) {
      if ((t = n[go] || n[ho])) {
        if (((n = t.alternate), null !== t.child || (null !== n && null !== n.child)))
          for (e = fo(e); null !== e; ) {
            if ((n = e[ho])) return n
            e = fo(e)
          }
        return t
      }
      n = (e = n).parentNode
    }
    return null
  }
  function wo(e) {
    return !(e = e[ho] || e[go]) || (5 !== e.tag && 6 !== e.tag && 13 !== e.tag && 3 !== e.tag) ? null : e
  }
  function Co(e) {
    if (5 === e.tag || 6 === e.tag) return e.stateNode
    throw Error(Oe(33))
  }
  function xo(e) {
    return e[po] || null
  }
  var Eo = [],
    So = -1
  function Oo(e) {
    return { current: e }
  }
  function ko(e) {
    So < 0 || ((e.current = Eo[So]), (Eo[So] = null), So--)
  }
  function Po(e, t) {
    ;(Eo[++So] = e.current), (e.current = t)
  }
  var _o = {},
    Lo = Oo(_o),
    To = Oo(!1),
    Io = _o
  function Mo(e, t) {
    var n = e.type.contextTypes
    if (!n) return _o
    var r = e.stateNode
    if (r && r.__reactInternalMemoizedUnmaskedChildContext === t) return r.__reactInternalMemoizedMaskedChildContext
    var i,
      o = {}
    for (i in n) o[i] = t[i]
    return (
      r &&
        (((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = t),
        (e.__reactInternalMemoizedMaskedChildContext = o)),
      o
    )
  }
  function jo(e) {
    return null != e.childContextTypes
  }
  function Ro() {
    ko(To), ko(Lo)
  }
  function Do(e, t, n) {
    if (Lo.current !== _o) throw Error(Oe(168))
    Po(Lo, t), Po(To, n)
  }
  function Ao(e, t, n) {
    var r,
      i = e.stateNode
    if (((t = t.childContextTypes), 'function' != typeof i.getChildContext)) return n
    for (r in (i = i.getChildContext())) if (!(r in t)) throw Error(Oe(108, ot(e) || 'Unknown', r))
    return tt({}, n, i)
  }
  function zo(e) {
    ;(e = ((e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext) || _o),
      (Io = Lo.current),
      Po(Lo, e),
      Po(To, To.current)
  }
  function No(e, t, n) {
    var r = e.stateNode
    if (!r) throw Error(Oe(169))
    n ? ((e = Ao(e, t, Io)), (r.__reactInternalMemoizedMergedChildContext = e), ko(To), ko(Lo), Po(Lo, e)) : ko(To),
      Po(To, n)
  }
  var Fo = null,
    Ho = !1,
    Bo = !1
  function Vo(e) {
    null === Fo ? (Fo = [e]) : Fo.push(e)
  }
  function Wo() {
    if (!Bo && null !== Fo) {
      Bo = !0
      var e = 0,
        t = jn
      try {
        var n = Fo
        for (jn = 1; e < n.length; e++) for (var r = n[e]; null !== (r = r(!0)); );
        ;(Fo = null), (Ho = !1)
      } catch (i) {
        throw (null !== Fo && (Fo = Fo.slice(e + 1)), sn(pn, Wo), i)
      } finally {
        ;(jn = t), (Bo = !1)
      }
    }
    return null
  }
  var Go = [],
    Zo = 0,
    Uo = null,
    Xo = 0,
    Yo = [],
    qo = 0,
    $o = null,
    Ko = 1,
    Qo = ''
  function Jo(e, t) {
    ;(Go[Zo++] = Xo), (Go[Zo++] = Uo), (Uo = e), (Xo = t)
  }
  function ea(e, t, n) {
    ;(Yo[qo++] = Ko), (Yo[qo++] = Qo), (Yo[qo++] = $o), ($o = e)
    var r,
      i = Ko,
      o = ((e = Qo), 32 - Cn(i) - 1),
      a = ((i &= ~(1 << o)), (n += 1), 32 - Cn(t) + o)
    Qo =
      30 < a
        ? ((a = (i & ((1 << (r = o - (o % 5))) - 1)).toString(32)),
          (i >>= r),
          (o -= r),
          (Ko = (1 << (32 - Cn(t) + o)) | (n << o) | i),
          a + e)
        : ((Ko = (1 << a) | (n << o) | i), e)
  }
  function ta(e) {
    null !== e.return && (Jo(e, 1), ea(e, 1, 0))
  }
  function na(e) {
    for (; e === Uo; ) (Uo = Go[--Zo]), (Go[Zo] = null), (Xo = Go[--Zo]), (Go[Zo] = null)
    for (; e === $o; )
      ($o = Yo[--qo]), (Yo[qo] = null), (Qo = Yo[--qo]), (Yo[qo] = null), (Ko = Yo[--qo]), (Yo[qo] = null)
  }
  var ra = null,
    ia = null,
    oa = !1,
    aa = null
  function la(e, t) {
    var n = gu(5, null, null, 0)
    ;(n.elementType = 'DELETED'),
      (n.stateNode = t),
      null === (t = (n.return = e).deletions) ? ((e.deletions = [n]), (e.flags |= 16)) : t.push(n)
  }
  function sa(e, t) {
    switch (e.tag) {
      case 5:
        var n = e.type
        return (
          null !== (t = 1 !== t.nodeType || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t) &&
          ((e.stateNode = t), (ra = e), (ia = uo(t.firstChild)), 1)
        )
      case 6:
        return (
          null !== (t = '' === e.pendingProps || 3 !== t.nodeType ? null : t) &&
          ((e.stateNode = t), (ra = e), (ia = null), 1)
        )
      case 13:
        return (
          null !== (t = 8 !== t.nodeType ? null : t) &&
          ((n = null !== $o ? { id: Ko, overflow: Qo } : null),
          (e.memoizedState = { dehydrated: t, treeContext: n, retryLane: 1073741824 }),
          ((n = gu(18, null, null, 0)).stateNode = t),
          ((n.return = e).child = n),
          (ra = e),
          (ia = null),
          1)
        )
      default:
        return
    }
  }
  function ca(e) {
    return 0 != (1 & e.mode) && 0 == (128 & e.flags)
  }
  function ua(e) {
    if (oa)
      if (ia) {
        var t = ia
        if (!sa(e, ia)) {
          if (ca(e)) throw Error(Oe(418))
          var n = uo(t.nextSibling),
            r = ra
          n && sa(e, n) ? la(r, t) : ((e.flags = (-4097 & e.flags) | 2), (oa = !1), (ra = e))
        }
      } else {
        if (ca(e)) throw Error(Oe(418))
        ;(e.flags = (-4097 & e.flags) | 2), (oa = !1), (ra = e)
      }
  }
  function da(e) {
    for (e = e.return; null !== e && 5 !== e.tag && 3 !== e.tag && 13 !== e.tag; ) e = e.return
    ra = e
  }
  function fa(e) {
    if (e !== ra) return !1
    if (!oa) return da(e), !(oa = !0)
    var t
    if (
      (t =
        (t =
          (t = 3 !== e.tag) && !(t = 5 !== e.tag)
            ? 'head' !== (t = e.type) && 'body' !== t && !ro(e.type, e.memoizedProps)
            : t) && ia)
    ) {
      if (ca(e)) throw (ha(), Error(Oe(418)))
      for (; t; ) la(e, t), (t = uo(t.nextSibling))
    }
    if ((da(e), 13 === e.tag)) {
      if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null)) throw Error(Oe(317))
      e: {
        for (e = e.nextSibling, t = 0; e; ) {
          if (8 === e.nodeType) {
            var n = e.data
            if ('/$' === n) {
              if (0 === t) {
                ia = uo(e.nextSibling)
                break e
              }
              t--
            } else ('$' !== n && '$!' !== n && '$?' !== n) || t++
          }
          e = e.nextSibling
        }
        ia = null
      }
    } else ia = ra ? uo(e.stateNode.nextSibling) : null
    return !0
  }
  function ha() {
    for (var e = ia; e; ) e = uo(e.nextSibling)
  }
  function pa() {
    ;(ia = ra = null), (oa = !1)
  }
  function ga(e) {
    null === aa ? (aa = [e]) : aa.push(e)
  }
  var ma = c.ReactCurrentBatchConfig
  function va(e, t) {
    if (e && e.defaultProps) for (var n in ((t = tt({}, t)), (e = e.defaultProps))) void 0 === t[n] && (t[n] = e[n])
    return t
  }
  var ya = Oo(null),
    ba = null,
    wa = null,
    Ca = null
  function xa() {
    Ca = wa = ba = null
  }
  function Ea(e) {
    var t = ya.current
    ko(ya), (e._currentValue = t)
  }
  function Sa(e, t, n) {
    for (; null !== e; ) {
      var r = e.alternate
      if (
        ((e.childLanes & t) !== t
          ? ((e.childLanes |= t), null !== r && (r.childLanes |= t))
          : null !== r && (r.childLanes & t) !== t && (r.childLanes |= t),
        e === n)
      )
        break
      e = e.return
    }
  }
  function Oa(e, t) {
    ;(Ca = wa = null) !== (e = (ba = e).dependencies) &&
      null !== e.firstContext &&
      (0 != (e.lanes & t) && (vs = !0), (e.firstContext = null))
  }
  function ka(e) {
    var t = e._currentValue
    if (Ca !== e)
      if (((e = { context: e, memoizedValue: t, next: null }), null === wa)) {
        if (null === ba) throw Error(Oe(308))
        ;(wa = e), (ba.dependencies = { lanes: 0, firstContext: e })
      } else wa = wa.next = e
    return t
  }
  var Pa = null
  function _a(e) {
    null === Pa ? (Pa = [e]) : Pa.push(e)
  }
  function La(e, t, n, r) {
    var i = t.interleaved
    return null === i ? ((n.next = n), _a(t)) : ((n.next = i.next), (i.next = n)), (t.interleaved = n), Ta(e, r)
  }
  function Ta(e, t) {
    e.lanes |= t
    var n = e.alternate
    for (null !== n && (n.lanes |= t), e = (n = e).return; null !== e; )
      (e.childLanes |= t), null !== (n = e.alternate) && (n.childLanes |= t), (e = (n = e).return)
    return 3 === n.tag ? n.stateNode : null
  }
  var Ia = !1
  function Ma(e) {
    e.updateQueue = {
      baseState: e.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, interleaved: null, lanes: 0 },
      effects: null
    }
  }
  function ja(e, t) {
    ;(e = e.updateQueue),
      t.updateQueue === e &&
        (t.updateQueue = {
          baseState: e.baseState,
          firstBaseUpdate: e.firstBaseUpdate,
          lastBaseUpdate: e.lastBaseUpdate,
          shared: e.shared,
          effects: e.effects
        })
  }
  function Ra(e, t) {
    return { eventTime: e, lane: t, tag: 0, payload: null, callback: null, next: null }
  }
  function Da(e, t, n) {
    var r,
      i = e.updateQueue
    return null === i
      ? null
      : ((i = i.shared),
        0 != (2 & vc)
          ? (null === (r = i.pending) ? (t.next = t) : ((t.next = r.next), (r.next = t)), (i.pending = t))
          : (null === (r = i.interleaved) ? ((t.next = t), _a(i)) : ((t.next = r.next), (r.next = t)),
            (i.interleaved = t)),
        Ta(e, n))
  }
  function Aa(e, t, n) {
    var r
    null !== (t = t.updateQueue) &&
      ((t = t.shared), 0 != (4194240 & n)) &&
      ((r = t.lanes), (r &= e.pendingLanes), Mn(e, (t.lanes = n |= r)))
  }
  function za(e, t) {
    var n = e.updateQueue,
      r = e.alternate
    if (null !== r && n === (r = r.updateQueue)) {
      var i = null,
        o = null
      if (null !== (n = n.firstBaseUpdate)) {
        do {
          var a = {
            eventTime: n.eventTime,
            lane: n.lane,
            tag: n.tag,
            payload: n.payload,
            callback: n.callback,
            next: null
          }
        } while ((null === o ? (i = o = a) : (o = o.next = a), null !== (n = n.next)))
        null === o ? (i = o = t) : (o = o.next = t)
      } else i = o = t
      ;(n = { baseState: r.baseState, firstBaseUpdate: i, lastBaseUpdate: o, shared: r.shared, effects: r.effects }),
        (e.updateQueue = n)
    } else null === (e = n.lastBaseUpdate) ? (n.firstBaseUpdate = t) : (e.next = t), (n.lastBaseUpdate = t)
  }
  function Na(e, t, n, r) {
    var i,
      o,
      a = e.updateQueue,
      l = ((Ia = !1), a.firstBaseUpdate),
      s = a.lastBaseUpdate
    if (
      (null !== (d = a.shared.pending) &&
        ((a.shared.pending = null),
        (o = (i = d).next),
        (i.next = null) === s ? (l = o) : (s.next = o),
        (s = i),
        null !== (u = e.alternate)) &&
        (d = (u = u.updateQueue).lastBaseUpdate) !== s &&
        (null === d ? (u.firstBaseUpdate = o) : (d.next = o), (u.lastBaseUpdate = i)),
      null !== l)
    ) {
      for (var c = a.baseState, u = ((s = 0), (o = i = null)), d = l; ; ) {
        var f = d.lane,
          h = d.eventTime
        if ((r & f) === f) {
          null !== u &&
            (u = u.next = { eventTime: h, lane: 0, tag: d.tag, payload: d.payload, callback: d.callback, next: null })
          e: {
            var p = e,
              g = d
            ;(f = t), (h = n)
            switch (g.tag) {
              case 1:
                if ('function' == typeof (p = g.payload)) {
                  c = p.call(h, c, f)
                  break e
                }
                c = p
                break e
              case 3:
                p.flags = (-65537 & p.flags) | 128
              case 0:
                if (null == (f = 'function' == typeof (p = g.payload) ? p.call(h, c, f) : p)) break e
                c = tt({}, c, f)
                break e
              case 2:
                Ia = !0
            }
          }
          null !== d.callback &&
            0 !== d.lane &&
            ((e.flags |= 64), null === (f = a.effects) ? (a.effects = [d]) : f.push(d))
        } else
          (h = { eventTime: h, lane: f, tag: d.tag, payload: d.payload, callback: d.callback, next: null }),
            null === u ? ((o = u = h), (i = c)) : (u = u.next = h),
            (s |= f)
        if (null === (d = d.next)) {
          if (null === (d = a.shared.pending)) break
          ;(d = (f = d).next), (f.next = null), (a.lastBaseUpdate = f), (a.shared.pending = null)
        }
      }
      if (
        (null === u && (i = c),
        (a.baseState = i),
        (a.firstBaseUpdate = o),
        (a.lastBaseUpdate = u),
        null !== (t = a.shared.interleaved))
      )
        for (a = t; (s |= a.lane), (a = a.next) !== t; );
      else null === l && (a.shared.lanes = 0)
      ;(Oc |= s), (e.lanes = s), (e.memoizedState = c)
    }
  }
  function Fa(e, t, n) {
    if (((e = t.effects), (t.effects = null) !== e))
      for (t = 0; t < e.length; t++) {
        var r = e[t],
          i = r.callback
        if (null !== i) {
          if (((r.callback = null), (r = n), 'function' != typeof i)) throw Error(Oe(191, i))
          i.call(r)
        }
      }
  }
  var Ha = new y.Component().refs
  function Ba(e, t, n, r) {
    ;(n = null == (n = n(r, (t = e.memoizedState))) ? t : tt({}, t, n)),
      (e.memoizedState = n),
      0 === e.lanes && (e.updateQueue.baseState = n)
  }
  var Va = {
    isMounted: function (e) {
      return !!(e = e._reactInternals) && rn(e) === e
    },
    enqueueSetState: function (e, t, n) {
      e = e._reactInternals
      var r = Wc(),
        i = Gc(e),
        o = Ra(r, i)
      ;(o.payload = t), null != n && (o.callback = n), null !== (t = Da(e, o, i)) && (Zc(t, e, i, r), Aa(t, e, i))
    },
    enqueueReplaceState: function (e, t, n) {
      e = e._reactInternals
      var r = Wc(),
        i = Gc(e),
        o = Ra(r, i)
      ;(o.tag = 1),
        (o.payload = t),
        null != n && (o.callback = n),
        null !== (t = Da(e, o, i)) && (Zc(t, e, i, r), Aa(t, e, i))
    },
    enqueueForceUpdate: function (e, t) {
      e = e._reactInternals
      var n = Wc(),
        r = Gc(e),
        i = Ra(n, r)
      ;(i.tag = 2), null != t && (i.callback = t), null !== (t = Da(e, i, r)) && (Zc(t, e, r, n), Aa(t, e, r))
    }
  }
  function Wa(e, t, n, r, i, o, a) {
    return 'function' == typeof (e = e.stateNode).shouldComponentUpdate
      ? e.shouldComponentUpdate(r, o, a)
      : !(t.prototype && t.prototype.isPureReactComponent && di(n, r) && di(i, o))
  }
  function Ga(e, t, n) {
    var r = !1,
      i = _o,
      o = t.contextType
    ;(t = new t(
      n,
      (o =
        'object' == typeof o && null !== o
          ? ka(o)
          : ((i = jo(t) ? Io : Lo.current), (r = null != (r = t.contextTypes)) ? Mo(e, i) : _o))
    )),
      (e.memoizedState = null !== t.state && void 0 !== t.state ? t.state : null),
      (t.updater = Va),
      ((e.stateNode = t)._reactInternals = e),
      r &&
        (((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = i),
        (e.__reactInternalMemoizedMaskedChildContext = o))
  }
  function Za(e, t, n, r) {
    ;(e = t.state),
      'function' == typeof t.componentWillReceiveProps && t.componentWillReceiveProps(n, r),
      'function' == typeof t.UNSAFE_componentWillReceiveProps && t.UNSAFE_componentWillReceiveProps(n, r),
      t.state !== e && Va.enqueueReplaceState(t, t.state, null)
  }
  function Ua(e, t, n, r) {
    var i = e.stateNode,
      o = ((i.props = n), (i.state = e.memoizedState), (i.refs = Ha), Ma(e), t.contextType)
    'object' == typeof o && null !== o ? (i.context = ka(o)) : ((o = jo(t) ? Io : Lo.current), (i.context = Mo(e, o))),
      (i.state = e.memoizedState),
      'function' == typeof (o = t.getDerivedStateFromProps) && (Ba(e, 0, o, n), (i.state = e.memoizedState)),
      'function' == typeof t.getDerivedStateFromProps ||
        'function' == typeof i.getSnapshotBeforeUpdate ||
        ('function' != typeof i.UNSAFE_componentWillMount && 'function' != typeof i.componentWillMount) ||
        ((t = i.state),
        'function' == typeof i.componentWillMount && i.componentWillMount(),
        'function' == typeof i.UNSAFE_componentWillMount && i.UNSAFE_componentWillMount(),
        t !== i.state && Va.enqueueReplaceState(i, i.state, null),
        Na(e, n, i, r),
        (i.state = e.memoizedState)),
      'function' == typeof i.componentDidMount && (e.flags |= 4194308)
  }
  function Xa(e, t, n) {
    if (null !== (e = n.ref) && 'function' != typeof e && 'object' != typeof e) {
      if (n._owner) {
        if ((n = n._owner)) {
          if (1 !== n.tag) throw Error(Oe(309))
          var r = n.stateNode
        }
        var i, o
        if (r)
          return (
            (i = r),
            (o = '' + e),
            null !== t && null !== t.ref && 'function' == typeof t.ref && t.ref._stringRef === o
              ? t.ref
              : (((t = function (e) {
                  var t = i.refs
                  t === Ha && (t = i.refs = {}), null === e ? delete t[o] : (t[o] = e)
                })._stringRef = o),
                t)
          )
        throw Error(Oe(147, e))
      }
      if ('string' != typeof e) throw Error(Oe(284))
      if (!n._owner) throw Error(Oe(290, e))
    }
    return e
  }
  function Ya(e, t) {
    throw (
      ((e = Object.prototype.toString.call(t)),
      Error(Oe(31, '[object Object]' === e ? 'object with keys {' + Object.keys(t).join(', ') + '}' : e)))
    )
  }
  function qa(e) {
    return (0, e._init)(e._payload)
  }
  function $a(e) {
    function t(t, n) {
      var r
      e && (null === (r = t.deletions) ? ((t.deletions = [n]), (t.flags |= 16)) : r.push(n))
    }
    function n(n, r) {
      if (e) for (; null !== r; ) t(n, r), (r = r.sibling)
      return null
    }
    function r(e, t) {
      for (e = new Map(); null !== t; ) null !== t.key ? e.set(t.key, t) : e.set(t.index, t), (t = t.sibling)
      return e
    }
    function i(e, t) {
      return ((e = vu(e, t)).index = 0), (e.sibling = null), e
    }
    function o(t, n, r) {
      if (((t.index = r), e)) {
        if (null !== (r = t.alternate)) return (r = r.index) < n ? ((t.flags |= 2), n) : r
        t.flags |= 2
      } else t.flags |= 1048576
      return n
    }
    function a(t) {
      return e && null === t.alternate && (t.flags |= 2), t
    }
    function l(e, t, n, r) {
      return null === t || 6 !== t.tag ? ((t = Cu(n, e.mode, r)).return = e) : ((t = i(t, n)).return = e), t
    }
    function s(e, t, n, r) {
      var o = n.type
      return o === Be
        ? u(e, t, n.props.children, r, n.key)
        : (null !== t &&
          (t.elementType === o || ('object' == typeof o && null !== o && o.$$typeof === $e && qa(o) === t.type))
            ? ((r = i(t, n.props)).ref = Xa(0, t, n))
            : ((r = yu(n.type, n.key, n.props, null, e.mode, r)).ref = Xa(0, t, n)),
          (r.return = e),
          r)
    }
    function c(e, t, n, r) {
      return (
        null === t ||
        4 !== t.tag ||
        t.stateNode.containerInfo !== n.containerInfo ||
        t.stateNode.implementation !== n.implementation
          ? ((t = xu(n, e.mode, r)).return = e)
          : ((t = i(t, n.children || [])).return = e),
        t
      )
    }
    function u(e, t, n, r, o) {
      return null === t || 7 !== t.tag ? ((t = bu(n, e.mode, r, o)).return = e) : ((t = i(t, n)).return = e), t
    }
    function d(e, t, n) {
      if (('string' == typeof t && '' !== t) || 'number' == typeof t) return ((t = Cu('' + t, e.mode, n)).return = e), t
      if ('object' == typeof t && null !== t) {
        switch (t.$$typeof) {
          case Fe:
            return ((n = yu(t.type, t.key, t.props, null, e.mode, n)).ref = Xa(0, null, t)), (n.return = e), n
          case He:
            return ((t = xu(t, e.mode, n)).return = e), t
          case $e:
            return d(e, (0, t._init)(t._payload), n)
        }
        if (vt(t) || Je(t)) return ((t = bu(t, e.mode, n, null)).return = e), t
        Ya(0, t)
      }
      return null
    }
    function f(e, t, n, r) {
      var i = null !== t ? t.key : null
      if (('string' == typeof n && '' !== n) || 'number' == typeof n) return null !== i ? null : l(e, t, '' + n, r)
      if ('object' == typeof n && null !== n) {
        switch (n.$$typeof) {
          case Fe:
            return n.key === i ? s(e, t, n, r) : null
          case He:
            return n.key === i ? c(e, t, n, r) : null
          case $e:
            return f(e, t, (i = n._init)(n._payload), r)
        }
        if (vt(n) || Je(n)) return null !== i ? null : u(e, t, n, r, null)
        Ya(0, n)
      }
      return null
    }
    function h(e, t, n, r, i) {
      if (('string' == typeof r && '' !== r) || 'number' == typeof r) return l(t, (e = e.get(n) || null), '' + r, i)
      if ('object' == typeof r && null !== r) {
        switch (r.$$typeof) {
          case Fe:
            return s(t, (e = e.get(null === r.key ? n : r.key) || null), r, i)
          case He:
            return c(t, (e = e.get(null === r.key ? n : r.key) || null), r, i)
          case $e:
            return h(e, t, n, (0, r._init)(r._payload), i)
        }
        if (vt(r) || Je(r)) return u(t, (e = e.get(n) || null), r, i, null)
        Ya(0, r)
      }
      return null
    }
    return function l(s, c, u, p) {
      if (
        'object' ==
          typeof (u = 'object' == typeof u && null !== u && u.type === Be && null === u.key ? u.props.children : u) &&
        null !== u
      ) {
        switch (u.$$typeof) {
          case Fe:
            e: {
              for (var g = u.key, m = c; null !== m; ) {
                if (m.key === g) {
                  if ((g = u.type) === Be) {
                    if (7 === m.tag) {
                      n(s, m.sibling), ((c = i(m, u.props.children)).return = s), (s = c)
                      break e
                    }
                  } else if (
                    m.elementType === g ||
                    ('object' == typeof g && null !== g && g.$$typeof === $e && qa(g) === m.type)
                  ) {
                    n(s, m.sibling), ((c = i(m, u.props)).ref = Xa(0, m, u)), (c.return = s), (s = c)
                    break e
                  }
                  n(s, m)
                  break
                }
                t(s, m), (m = m.sibling)
              }
              s =
                u.type === Be
                  ? (((c = bu(u.props.children, s.mode, p, u.key)).return = s), c)
                  : (((p = yu(u.type, u.key, u.props, null, s.mode, p)).ref = Xa(0, c, u)), (p.return = s), p)
            }
            return a(s)
          case He:
            e: {
              for (m = u.key; null !== c; ) {
                if (c.key === m) {
                  if (
                    4 === c.tag &&
                    c.stateNode.containerInfo === u.containerInfo &&
                    c.stateNode.implementation === u.implementation
                  ) {
                    n(s, c.sibling), ((c = i(c, u.children || [])).return = s), (s = c)
                    break e
                  }
                  n(s, c)
                  break
                }
                t(s, c), (c = c.sibling)
              }
              ;((c = xu(u, s.mode, p)).return = s), (s = c)
            }
            return a(s)
          case $e:
            return l(s, c, (m = u._init)(u._payload), p)
        }
        if (vt(u)) {
          for (
            var v = s, y = c, b = u, w = p, C = null, x = null, E = y, S = (y = 0), O = null;
            null !== E && S < b.length;
            S++
          ) {
            E.index > S ? ((O = E), (E = null)) : (O = E.sibling)
            var k = f(v, E, b[S], w)
            if (null === k) {
              null === E && (E = O)
              break
            }
            e && E && null === k.alternate && t(v, E),
              (y = o(k, y, S)),
              null === x ? (C = k) : (x.sibling = k),
              (x = k),
              (E = O)
          }
          if (S === b.length) n(v, E)
          else if (null === E)
            for (; S < b.length; S++)
              null !== (E = d(v, b[S], w)) && ((y = o(E, y, S)), null === x ? (C = E) : (x.sibling = E), (x = E))
          else {
            for (E = r(v, E); S < b.length; S++)
              null !== (O = h(E, v, S, b[S], w)) &&
                (e && null !== O.alternate && E.delete(null === O.key ? S : O.key),
                (y = o(O, y, S)),
                null === x ? (C = O) : (x.sibling = O),
                (x = O))
            e &&
              E.forEach(function (e) {
                return t(v, e)
              })
          }
          return oa && Jo(v, S), C
        }
        if (Je(u)) {
          var P = s,
            _ = c,
            L = u,
            T = p,
            I = Je(L)
          if ('function' != typeof I) throw Error(Oe(150))
          if (null == (L = I.call(L))) throw Error(Oe(151))
          for (
            var M = (I = null), j = _, R = (_ = 0), D = null, A = L.next();
            null !== j && !A.done;
            R++, A = L.next()
          ) {
            j.index > R ? ((D = j), (j = null)) : (D = j.sibling)
            var z = f(P, j, A.value, T)
            if (null === z) {
              null === j && (j = D)
              break
            }
            e && j && null === z.alternate && t(P, j),
              (_ = o(z, _, R)),
              null === M ? (I = z) : (M.sibling = z),
              (M = z),
              (j = D)
          }
          if (A.done) n(P, j)
          else if (null === j)
            for (; !A.done; R++, A = L.next())
              null !== (A = d(P, A.value, T)) && ((_ = o(A, _, R)), null === M ? (I = A) : (M.sibling = A), (M = A))
          else {
            for (j = r(P, j); !A.done; R++, A = L.next())
              null !== (A = h(j, P, R, A.value, T)) &&
                (e && null !== A.alternate && j.delete(null === A.key ? R : A.key),
                (_ = o(A, _, R)),
                null === M ? (I = A) : (M.sibling = A),
                (M = A))
            e &&
              j.forEach(function (e) {
                return t(P, e)
              })
          }
          return oa && Jo(P, R), I
        }
        Ya(0, u)
      }
      return ('string' == typeof u && '' !== u) || 'number' == typeof u
        ? ((u = '' + u),
          ((c = null !== c && 6 === c.tag ? (n(s, c.sibling), i(c, u)) : (n(s, c), Cu(u, s.mode, p))).return = s),
          a((s = c)))
        : n(s, c)
    }
  }
  var Ka = $a(!0),
    Qa = $a(!1),
    Ja = {},
    el = Oo(Ja),
    tl = Oo(Ja),
    nl = Oo(Ja)
  function rl(e) {
    if (e === Ja) throw Error(Oe(174))
    return e
  }
  function il(e, t) {
    switch ((Po(nl, t), Po(tl, e), Po(el, Ja), (e = t.nodeType))) {
      case 9:
      case 11:
        t = (t = t.documentElement) ? t.namespaceURI : St(null, '')
        break
      default:
        t = St((t = (e = 8 === e ? t.parentNode : t).namespaceURI || null), (e = e.tagName))
    }
    ko(el), Po(el, t)
  }
  function ol() {
    ko(el), ko(tl), ko(nl)
  }
  function al(e) {
    rl(nl.current)
    var t = rl(el.current),
      n = St(t, e.type)
    t !== n && (Po(tl, e), Po(el, n))
  }
  function ll(e) {
    tl.current === e && (ko(el), ko(tl))
  }
  var sl = Oo(0)
  function cl(e) {
    for (var t = e; null !== t; ) {
      if (13 === t.tag) {
        var n = t.memoizedState
        if (null !== n && (null === (n = n.dehydrated) || '$?' === n.data || '$!' === n.data)) return t
      } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
        if (0 != (128 & t.flags)) return t
      } else if (null !== t.child) {
        t = (t.child.return = t).child
        continue
      }
      if (t === e) break
      for (; null === t.sibling; ) {
        if (null === t.return || t.return === e) return null
        t = t.return
      }
      ;(t.sibling.return = t.return), (t = t.sibling)
    }
    return null
  }
  var ul = []
  function dl() {
    for (var e = 0; e < ul.length; e++) ul[e]._workInProgressVersionPrimary = null
    ul.length = 0
  }
  var fl = c.ReactCurrentDispatcher,
    hl = c.ReactCurrentBatchConfig,
    pl = 0,
    gl = null,
    ml = null,
    vl = null,
    yl = !1,
    bl = !1,
    wl = 0,
    Cl = 0
  function xl() {
    throw Error(Oe(321))
  }
  function El(e, t) {
    if (null !== t) {
      for (var n = 0; n < t.length && n < e.length; n++) if (!ui(e[n], t[n])) return
      return 1
    }
  }
  function Sl(e, t, n, r, i, o) {
    if (
      ((pl = o),
      ((gl = t).memoizedState = null),
      (t.updateQueue = null),
      (t.lanes = 0),
      (fl.current = null === e || null === e.memoizedState ? is : os),
      (e = n(r, i)),
      bl)
    ) {
      o = 0
      do {
        if (((bl = !1), (wl = 0), 25 <= o)) throw Error(Oe(301))
      } while (((o += 1), (vl = ml = null), (t.updateQueue = null), (fl.current = as), (e = n(r, i)), bl))
    }
    if (((fl.current = rs), (t = null !== ml && null !== ml.next), (pl = 0), (vl = ml = gl = null), (yl = !1), t))
      throw Error(Oe(300))
    return e
  }
  function Ol() {
    var e = 0 !== wl
    return (wl = 0), e
  }
  function kl() {
    var e = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null }
    return null === vl ? (gl.memoizedState = vl = e) : (vl = vl.next = e), vl
  }
  function Pl() {
    e = null === ml ? (null !== (e = gl.alternate) ? e.memoizedState : null) : ml.next
    var e,
      t = null === vl ? gl.memoizedState : vl.next
    if (null !== t) (vl = t), (ml = e)
    else {
      if (null === e) throw Error(Oe(310))
      ;(e = {
        memoizedState: (ml = e).memoizedState,
        baseState: ml.baseState,
        baseQueue: ml.baseQueue,
        queue: ml.queue,
        next: null
      }),
        null === vl ? (gl.memoizedState = vl = e) : (vl = vl.next = e)
    }
    return vl
  }
  function _l(e, t) {
    return 'function' == typeof t ? t(e) : t
  }
  function Ll(e) {
    var t = Pl(),
      n = t.queue
    if (null === n) throw Error(Oe(311))
    n.lastRenderedReducer = e
    var r,
      i = (a = ml).baseQueue
    if (
      (null !== (o = n.pending) &&
        (null !== i && ((r = i.next), (i.next = o.next), (o.next = r)), (a.baseQueue = i = o), (n.pending = null)),
      null !== i)
    ) {
      var o = i.next,
        a = a.baseState,
        l = (r = null),
        s = null,
        c = o
      do {
        var u,
          d = c.lane
      } while (
        ((pl & d) === d
          ? (null !== s &&
              (s = s.next =
                { lane: 0, action: c.action, hasEagerState: c.hasEagerState, eagerState: c.eagerState, next: null }),
            (a = c.hasEagerState ? c.eagerState : e(a, c.action)))
          : ((u = { lane: d, action: c.action, hasEagerState: c.hasEagerState, eagerState: c.eagerState, next: null }),
            null === s ? ((l = s = u), (r = a)) : (s = s.next = u),
            (gl.lanes |= d),
            (Oc |= d)),
        null !== (c = c.next) && c !== o)
      )
      null === s ? (r = a) : (s.next = l),
        ui(a, t.memoizedState) || (vs = !0),
        (t.memoizedState = a),
        (t.baseState = r),
        (t.baseQueue = s),
        (n.lastRenderedState = a)
    }
    if (null !== (e = n.interleaved)) for (i = e; (o = i.lane), (gl.lanes |= o), (Oc |= o), (i = i.next) !== e; );
    else null === i && (n.lanes = 0)
    return [t.memoizedState, n.dispatch]
  }
  function Tl(e) {
    var t = Pl(),
      n = t.queue
    if (null === n) throw Error(Oe(311))
    n.lastRenderedReducer = e
    var r = n.dispatch,
      i = n.pending,
      o = t.memoizedState
    if (null !== i) {
      n.pending = null
      for (var a = (i = i.next); (o = e(o, a.action)), (a = a.next) !== i; );
      ui(o, t.memoizedState) || (vs = !0),
        (t.memoizedState = o),
        null === t.baseQueue && (t.baseState = o),
        (n.lastRenderedState = o)
    }
    return [o, r]
  }
  function Il() {}
  function Ml(e, t) {
    var n = gl,
      r = Pl(),
      i = t(),
      o = !ui(r.memoizedState, i)
    if (
      (o && ((r.memoizedState = i), (vs = !0)),
      (r = r.queue),
      Gl(Dl.bind(null, n, r, e), [e]),
      r.getSnapshot !== t || o || (null !== vl && 1 & vl.memoizedState.tag))
    ) {
      if (((n.flags |= 2048), Fl(9, Rl.bind(null, n, r, i, t), void 0, null), null === yc)) throw Error(Oe(349))
      0 == (30 & pl) && jl(n, t, i)
    }
    return i
  }
  function jl(e, t, n) {
    ;(e.flags |= 16384),
      (e = { getSnapshot: t, value: n }),
      null === (t = gl.updateQueue)
        ? ((gl.updateQueue = t = { lastEffect: null, stores: null }).stores = [e])
        : null === (n = t.stores)
        ? (t.stores = [e])
        : n.push(e)
  }
  function Rl(e, t, n, r) {
    ;(t.value = n), (t.getSnapshot = r), Al(t) && zl(e)
  }
  function Dl(e, t, n) {
    return n(function () {
      Al(t) && zl(e)
    })
  }
  function Al(e) {
    var t = e.getSnapshot
    e = e.value
    try {
      var n = t()
      return !ui(e, n)
    } catch (r) {
      return 1
    }
  }
  function zl(e) {
    var t = Ta(e, 1)
    null !== t && Zc(t, e, 1, -1)
  }
  function Nl(e) {
    var t = kl()
    return (
      'function' == typeof e && (e = e()),
      (t.memoizedState = t.baseState = e),
      (e = (t.queue = e =
        {
          pending: null,
          interleaved: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: _l,
          lastRenderedState: e
        }).dispatch =
        function (e, t, n) {
          var r = Gc(e),
            i = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null }
          if (es(e)) ts(t, i)
          else {
            var o = e.alternate
            if (0 === e.lanes && (null === o || 0 === o.lanes) && null !== (o = t.lastRenderedReducer))
              try {
                var a,
                  l = t.lastRenderedState,
                  s = o(l, n)
                if (((i.hasEagerState = !0), (i.eagerState = s), ui(s, l)))
                  return (
                    null === (a = t.interleaved) ? ((i.next = i), _a(t)) : ((i.next = a.next), (a.next = i)),
                    void (t.interleaved = i)
                  )
              } catch (c) {}
            null !== (n = La(e, t, i, r)) && (Zc(n, e, r, (i = Wc())), ns(n, t, r))
          }
        }.bind(null, gl, e)),
      [t.memoizedState, e]
    )
  }
  function Fl(e, t, n, r) {
    return (
      (e = { tag: e, create: t, destroy: n, deps: r, next: null }),
      null === (t = gl.updateQueue)
        ? ((gl.updateQueue = t = { lastEffect: null, stores: null }).lastEffect = e.next = e)
        : null === (n = t.lastEffect)
        ? (t.lastEffect = e.next = e)
        : ((r = n.next), ((n.next = e).next = r), (t.lastEffect = e)),
      e
    )
  }
  function Hl() {
    return Pl().memoizedState
  }
  function Bl(e, t, n, r) {
    var i = kl()
    ;(gl.flags |= e), (i.memoizedState = Fl(1 | t, n, void 0, void 0 === r ? null : r))
  }
  function Vl(e, t, n, r) {
    var i = Pl(),
      o = void (r = void 0 === r ? null : r)
    if (null !== ml) {
      var a = ml.memoizedState
      o = a.destroy
      if (null !== r && El(r, a.deps)) return void (i.memoizedState = Fl(t, n, o, r))
    }
    ;(gl.flags |= e), (i.memoizedState = Fl(1 | t, n, o, r))
  }
  function Wl(e, t) {
    return Bl(8390656, 8, e, t)
  }
  function Gl(e, t) {
    return Vl(2048, 8, e, t)
  }
  function Zl(e, t) {
    return Vl(4, 2, e, t)
  }
  function Ul(e, t) {
    return Vl(4, 4, e, t)
  }
  function Xl(e, t) {
    return 'function' == typeof t
      ? ((e = e()),
        t(e),
        function () {
          t(null)
        })
      : null != t
      ? ((e = e()),
        (t.current = e),
        function () {
          t.current = null
        })
      : void 0
  }
  function Yl(e, t, n) {
    return (n = null != n ? n.concat([e]) : null), Vl(4, 4, Xl.bind(null, t, e), n)
  }
  function ql() {}
  function $l(e, t) {
    var n = Pl(),
      r = ((t = void 0 === t ? null : t), n.memoizedState)
    return null !== r && null !== t && El(t, r[1]) ? r[0] : ((n.memoizedState = [e, t]), e)
  }
  function Kl(e, t) {
    var n = Pl(),
      r = ((t = void 0 === t ? null : t), n.memoizedState)
    return null !== r && null !== t && El(t, r[1]) ? r[0] : ((e = e()), (n.memoizedState = [e, t]), e)
  }
  function Ql(e, t, n) {
    return 0 == (21 & pl)
      ? (e.baseState && ((e.baseState = !1), (vs = !0)), (e.memoizedState = n))
      : (ui(n, t) || ((n = Ln()), (gl.lanes |= n), (Oc |= n), (e.baseState = !0)), t)
  }
  function Jl() {
    return Pl().memoizedState
  }
  function es(e) {
    var t = e.alternate
    return e === gl || (null !== t && t === gl)
  }
  function ts(e, t) {
    bl = yl = !0
    var n = e.pending
    null === n ? (t.next = t) : ((t.next = n.next), (n.next = t)), (e.pending = t)
  }
  function ns(e, t, n) {
    var r
    0 != (4194240 & n) && ((r = t.lanes), (r &= e.pendingLanes), Mn(e, (t.lanes = n |= r)))
  }
  var rs = {
      readContext: ka,
      useCallback: xl,
      useContext: xl,
      useEffect: xl,
      useImperativeHandle: xl,
      useInsertionEffect: xl,
      useLayoutEffect: xl,
      useMemo: xl,
      useReducer: xl,
      useRef: xl,
      useState: xl,
      useDebugValue: xl,
      useDeferredValue: xl,
      useTransition: xl,
      useMutableSource: xl,
      useSyncExternalStore: xl,
      useId: xl,
      unstable_isNewReconciler: !1
    },
    is = {
      readContext: ka,
      useCallback: function (e, t) {
        return (kl().memoizedState = [e, void 0 === t ? null : t]), e
      },
      useContext: ka,
      useEffect: Wl,
      useImperativeHandle: function (e, t, n) {
        return (n = null != n ? n.concat([e]) : null), Bl(4194308, 4, Xl.bind(null, t, e), n)
      },
      useLayoutEffect: function (e, t) {
        return Bl(4194308, 4, e, t)
      },
      useInsertionEffect: function (e, t) {
        return Bl(4, 2, e, t)
      },
      useMemo: function (e, t) {
        var n = kl()
        return (t = void 0 === t ? null : t), (e = e()), (n.memoizedState = [e, t]), e
      },
      useReducer: function (e, t, n) {
        var r = kl()
        return (
          (t = void 0 !== n ? n(t) : t),
          (r.memoizedState = r.baseState = t),
          (e = (r.queue = e =
            {
              pending: null,
              interleaved: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: e,
              lastRenderedState: t
            }).dispatch =
            function (e, t, n) {
              var r = Gc(e)
              ;(n = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null }),
                es(e) ? ts(t, n) : null !== (n = La(e, t, n, r)) && (Zc(n, e, r, Wc()), ns(n, t, r))
            }.bind(null, gl, e)),
          [r.memoizedState, e]
        )
      },
      useRef: function (e) {
        return (kl().memoizedState = { current: e })
      },
      useState: Nl,
      useDebugValue: ql,
      useDeferredValue: function (e) {
        return (kl().memoizedState = e)
      },
      useTransition: function () {
        var e = (t = Nl(!1))[0],
          t = function (e, t) {
            var n = jn,
              r = ((jn = 0 !== n && n < 4 ? n : 4), e(!0), hl.transition)
            hl.transition = {}
            try {
              e(!1), t()
            } finally {
              ;(jn = n), (hl.transition = r)
            }
          }.bind(null, t[1])
        return [e, (kl().memoizedState = t)]
      },
      useMutableSource: function () {},
      useSyncExternalStore: function (e, t, n) {
        var r = gl,
          i = kl()
        if (oa) {
          if (void 0 === n) throw Error(Oe(407))
          n = n()
        } else {
          if (((n = t()), null === yc)) throw Error(Oe(349))
          0 == (30 & pl) && jl(r, t, n)
        }
        var o = { value: (i.memoizedState = n), getSnapshot: t }
        return (
          (i.queue = o),
          Wl(Dl.bind(null, r, o, e), [e]),
          (r.flags |= 2048),
          Fl(9, Rl.bind(null, r, o, n, t), void 0, null),
          n
        )
      },
      useId: function () {
        var e,
          t = kl(),
          n = yc.identifierPrefix
        return (
          oa
            ? ((e = Qo),
              (n = ':' + n + 'R' + (e = (Ko & ~(1 << (32 - Cn(Ko) - 1))).toString(32) + e)),
              0 < (e = wl++) && (n += 'H' + e.toString(32)),
              (n += ':'))
            : (n = ':' + n + 'r' + (e = Cl++).toString(32) + ':'),
          (t.memoizedState = n)
        )
      },
      unstable_isNewReconciler: !1
    },
    os = {
      readContext: ka,
      useCallback: $l,
      useContext: ka,
      useEffect: Gl,
      useImperativeHandle: Yl,
      useInsertionEffect: Zl,
      useLayoutEffect: Ul,
      useMemo: Kl,
      useReducer: Ll,
      useRef: Hl,
      useState: function () {
        return Ll(_l)
      },
      useDebugValue: ql,
      useDeferredValue: function (e) {
        return Ql(Pl(), ml.memoizedState, e)
      },
      useTransition: function () {
        return [Ll(_l)[0], Pl().memoizedState]
      },
      useMutableSource: Il,
      useSyncExternalStore: Ml,
      useId: Jl,
      unstable_isNewReconciler: !1
    },
    as = {
      readContext: ka,
      useCallback: $l,
      useContext: ka,
      useEffect: Gl,
      useImperativeHandle: Yl,
      useInsertionEffect: Zl,
      useLayoutEffect: Ul,
      useMemo: Kl,
      useReducer: Tl,
      useRef: Hl,
      useState: function () {
        return Tl(_l)
      },
      useDebugValue: ql,
      useDeferredValue: function (e) {
        var t = Pl()
        return null === ml ? (t.memoizedState = e) : Ql(t, ml.memoizedState, e)
      },
      useTransition: function () {
        return [Tl(_l)[0], Pl().memoizedState]
      },
      useMutableSource: Il,
      useSyncExternalStore: Ml,
      useId: Jl,
      unstable_isNewReconciler: !1
    }
  function ls(e, t) {
    try {
      for (
        var n = '', r = t;
        (n += (function (e) {
          switch (e.tag) {
            case 5:
              return nt(e.type)
            case 16:
              return nt('Lazy')
            case 13:
              return nt('Suspense')
            case 19:
              return nt('SuspenseList')
            case 0:
            case 2:
            case 15:
              return it(e.type, !1)
            case 11:
              return it(e.type.render, !1)
            case 1:
              return it(e.type, !0)
            default:
              return ''
          }
        })(r)),
          (r = r.return);

      );
      var i = n
    } catch (o) {
      i = '\nError generating stack: ' + o.message + '\n' + o.stack
    }
    return { value: e, source: t, stack: i, digest: null }
  }
  function ss(e, t, n) {
    return { value: e, source: null, stack: null != n ? n : null, digest: null != t ? t : null }
  }
  function cs(e, t) {
    try {
      console.error(t.value)
    } catch (n) {
      setTimeout(function () {
        throw n
      })
    }
  }
  var us = 'function' == typeof WeakMap ? WeakMap : Map
  function ds(e, t, n) {
    ;((n = Ra(-1, n)).tag = 3), (n.payload = { element: null })
    var r = t.value
    return (
      (n.callback = function () {
        jc || ((jc = !0), (Rc = r)), cs(0, t)
      }),
      n
    )
  }
  function fs(e, t, n) {
    ;(n = Ra(-1, n)).tag = 3
    var r,
      i = e.type.getDerivedStateFromError
    return (
      null !==
        (e =
          ('function' == typeof i &&
            ((r = t.value),
            (n.payload = function () {
              return i(r)
            }),
            (n.callback = function () {
              cs(0, t)
            })),
          e.stateNode)) &&
        'function' == typeof e.componentDidCatch &&
        (n.callback = function () {
          cs(0, t), 'function' != typeof i && (null === Dc ? (Dc = new Set([this])) : Dc.add(this))
          var e = t.stack
          this.componentDidCatch(t.value, { componentStack: null !== e ? e : '' })
        }),
      n
    )
  }
  function hs(e, t, n) {
    var r,
      i = e.pingCache
    null === i
      ? ((i = e.pingCache = new us()), (r = new Set()), i.set(t, r))
      : void 0 === (r = i.get(t)) && ((r = new Set()), i.set(t, r)),
      r.has(n) ||
        (r.add(n),
        (e = function (e, t, n) {
          var r = e.pingCache
          null !== r && r.delete(t),
            (t = Wc()),
            (e.pingedLanes |= e.suspendedLanes & n),
            yc === e &&
              (wc & n) === n &&
              (4 === Ec || (3 === Ec && (130023424 & wc) === wc && fn() - Tc < 500) ? tu(e, 0) : (Pc |= n)),
            Uc(e, t)
        }.bind(null, e, t, n)),
        t.then(e, e))
  }
  function ps(e) {
    do {
      var t
      if ((t = (t = 13 === e.tag) ? null === (t = e.memoizedState) || null !== t.dehydrated : t)) return e
    } while (null !== (e = e.return))
    return null
  }
  function gs(e, t, n, r, i) {
    if (0 == (1 & e.mode))
      return e === t
        ? (e.flags |= 65536)
        : ((e.flags |= 128),
          (n.flags |= 131072),
          (n.flags &= -52805),
          1 === n.tag && (null === n.alternate ? (n.tag = 17) : (((t = Ra(-1, 1)).tag = 2), Da(n, t, 1))),
          (n.lanes |= 1))
    ;(e.flags |= 65536), (e.lanes = i)
  }
  var ms = c.ReactCurrentOwner,
    vs = !1
  function ys(e, t, n, r) {
    t.child = null === e ? Qa(t, null, n, r) : Ka(t, e.child, n, r)
  }
  function bs(e, t, n, r, i) {
    n = n.render
    var o = t.ref
    return (
      Oa(t, i),
      (r = Sl(e, t, n, r, o, i)),
      (n = Ol()),
      null === e || vs
        ? (oa && n && ta(t), (t.flags |= 1), ys(e, t, r, i), t.child)
        : ((t.updateQueue = e.updateQueue), (t.flags &= -2053), (e.lanes &= ~i), Ns(e, t, i))
    )
  }
  function ws(e, t, n, r, i) {
    var o
    if (null === e)
      return 'function' != typeof (o = n.type) ||
        mu(o) ||
        void 0 !== o.defaultProps ||
        null !== n.compare ||
        void 0 !== n.defaultProps
        ? (((e = yu(n.type, null, r, t, t.mode, i)).ref = t.ref), ((e.return = t).child = e))
        : ((t.tag = 15), (t.type = o), Cs(e, t, o, r, i))
    if (((o = e.child), 0 == (e.lanes & i))) {
      var a = o.memoizedProps
      if ((n = null !== (n = n.compare) ? n : di)(a, r) && e.ref === t.ref) return Ns(e, t, i)
    }
    return (t.flags |= 1), ((e = vu(o, r)).ref = t.ref), ((e.return = t).child = e)
  }
  function Cs(e, t, n, r, i) {
    if (null !== e) {
      var o = e.memoizedProps
      if (di(o, r) && e.ref === t.ref) {
        if (((vs = !1), (t.pendingProps = r = o), 0 == (e.lanes & i))) return (t.lanes = e.lanes), Ns(e, t, i)
        0 != (131072 & e.flags) && (vs = !0)
      }
    }
    return Ss(e, t, n, r, i)
  }
  function xs(e, t, n) {
    var r = t.pendingProps,
      i = r.children,
      o = null !== e ? e.memoizedState : null
    if ('hidden' === r.mode)
      if (0 == (1 & t.mode))
        (t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }), Po(xc, Cc), (Cc |= n)
      else {
        if (0 == (1073741824 & n))
          return (
            (e = null !== o ? o.baseLanes | n : n),
            (t.lanes = t.childLanes = 1073741824),
            (t.memoizedState = { baseLanes: e, cachePool: null, transitions: null }),
            (t.updateQueue = null),
            Po(xc, Cc),
            (Cc |= e),
            null
          )
        ;(t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }),
          (r = null !== o ? o.baseLanes : n),
          Po(xc, Cc),
          (Cc |= r)
      }
    else null !== o ? ((r = o.baseLanes | n), (t.memoizedState = null)) : (r = n), Po(xc, Cc), (Cc |= r)
    return ys(e, t, i, n), t.child
  }
  function Es(e, t) {
    var n = t.ref
    ;((null === e && null !== n) || (null !== e && e.ref !== n)) && ((t.flags |= 512), (t.flags |= 2097152))
  }
  function Ss(e, t, n, r, i) {
    var o = Mo(t, jo(n) ? Io : Lo.current)
    return (
      Oa(t, i),
      (n = Sl(e, t, n, r, o, i)),
      (r = Ol()),
      null === e || vs
        ? (oa && r && ta(t), (t.flags |= 1), ys(e, t, n, i), t.child)
        : ((t.updateQueue = e.updateQueue), (t.flags &= -2053), (e.lanes &= ~i), Ns(e, t, i))
    )
  }
  function Os(e, t, n, r, i) {
    var o, a, l, s, c, u, d, f, h, p
    return (
      jo(n) ? ((o = !0), zo(t)) : (o = !1),
      Oa(t, i),
      (r =
        null === t.stateNode
          ? (zs(e, t), Ga(t, n, r), Ua(t, n, r, i), !0)
          : null === e
          ? ((a = t.stateNode),
            (l = t.memoizedProps),
            (a.props = l),
            (f = a.context),
            (s = 'object' == typeof (s = n.contextType) && null !== s ? ka(s) : Mo(t, (s = jo(n) ? Io : Lo.current))),
            (u =
              'function' == typeof (c = n.getDerivedStateFromProps) ||
              'function' == typeof a.getSnapshotBeforeUpdate) ||
              ('function' != typeof a.UNSAFE_componentWillReceiveProps &&
                'function' != typeof a.componentWillReceiveProps) ||
              (l === r && f === s) ||
              Za(0, a, r, s),
            (Ia = !1),
            (d = t.memoizedState),
            (a.state = d),
            Na(t, r, a, i),
            (f = t.memoizedState),
            l !== r || d !== f || To.current || Ia
              ? ('function' == typeof c && (Ba(t, 0, c, r), (f = t.memoizedState)),
                (l = Ia || Wa(t, n, l, r, d, f, s))
                  ? (u ||
                      ('function' != typeof a.UNSAFE_componentWillMount && 'function' != typeof a.componentWillMount) ||
                      ('function' == typeof a.componentWillMount && a.componentWillMount(),
                      'function' == typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount()),
                    'function' == typeof a.componentDidMount && (t.flags |= 4194308))
                  : ('function' == typeof a.componentDidMount && (t.flags |= 4194308),
                    (t.memoizedProps = r),
                    (t.memoizedState = f)),
                (a.props = r),
                (a.state = f),
                (a.context = s),
                l)
              : ('function' == typeof a.componentDidMount && (t.flags |= 4194308), !1))
          : ((a = t.stateNode),
            ja(e, t),
            (l = t.memoizedProps),
            (s = t.type === t.elementType ? l : va(t.type, l)),
            (a.props = s),
            (u = t.pendingProps),
            (d = a.context),
            (f = 'object' == typeof (f = n.contextType) && null !== f ? ka(f) : Mo(t, (f = jo(n) ? Io : Lo.current))),
            (c =
              'function' == typeof (h = n.getDerivedStateFromProps) ||
              'function' == typeof a.getSnapshotBeforeUpdate) ||
              ('function' != typeof a.UNSAFE_componentWillReceiveProps &&
                'function' != typeof a.componentWillReceiveProps) ||
              (l === u && d === f) ||
              Za(0, a, r, f),
            (Ia = !1),
            (d = t.memoizedState),
            (a.state = d),
            Na(t, r, a, i),
            (p = t.memoizedState),
            l !== u || d !== p || To.current || Ia
              ? ('function' == typeof h && (Ba(t, 0, h, r), (p = t.memoizedState)),
                (s = Ia || Wa(t, n, s, r, d, p, f) || !1)
                  ? (c ||
                      ('function' != typeof a.UNSAFE_componentWillUpdate &&
                        'function' != typeof a.componentWillUpdate) ||
                      ('function' == typeof a.componentWillUpdate && a.componentWillUpdate(r, p, f),
                      'function' == typeof a.UNSAFE_componentWillUpdate && a.UNSAFE_componentWillUpdate(r, p, f)),
                    'function' == typeof a.componentDidUpdate && (t.flags |= 4),
                    'function' == typeof a.getSnapshotBeforeUpdate && (t.flags |= 1024))
                  : ('function' != typeof a.componentDidUpdate ||
                      (l === e.memoizedProps && d === e.memoizedState) ||
                      (t.flags |= 4),
                    'function' != typeof a.getSnapshotBeforeUpdate ||
                      (l === e.memoizedProps && d === e.memoizedState) ||
                      (t.flags |= 1024),
                    (t.memoizedProps = r),
                    (t.memoizedState = p)),
                (a.props = r),
                (a.state = p),
                (a.context = f),
                s)
              : ('function' != typeof a.componentDidUpdate ||
                  (l === e.memoizedProps && d === e.memoizedState) ||
                  (t.flags |= 4),
                'function' != typeof a.getSnapshotBeforeUpdate ||
                  (l === e.memoizedProps && d === e.memoizedState) ||
                  (t.flags |= 1024),
                !1))),
      ks(e, t, n, r, o, i)
    )
  }
  function ks(e, t, n, r, i, o) {
    Es(e, t)
    var a = 0 != (128 & t.flags)
    if (!r && !a) return i && No(t, n, !1), Ns(e, t, o)
    ;(r = t.stateNode), (ms.current = t)
    var l = a && 'function' != typeof n.getDerivedStateFromError ? null : r.render()
    return (
      (t.flags |= 1),
      null !== e && a ? ((t.child = Ka(t, e.child, null, o)), (t.child = Ka(t, null, l, o))) : ys(e, t, l, o),
      (t.memoizedState = r.state),
      i && No(t, n, !0),
      t.child
    )
  }
  function Ps(e) {
    var t = e.stateNode
    t.pendingContext ? Do(0, t.pendingContext, t.pendingContext !== t.context) : t.context && Do(0, t.context, !1),
      il(e, t.containerInfo)
  }
  function _s(e, t, n, r, i) {
    return pa(), ga(i), (t.flags |= 256), ys(e, t, n, r), t.child
  }
  var Ls = { dehydrated: null, treeContext: null, retryLane: 0 }
  function Ts(e) {
    return { baseLanes: e, cachePool: null, transitions: null }
  }
  function Is(e, t, n) {
    var r,
      i,
      o = t.pendingProps,
      a = sl.current,
      l = !1,
      s = 0 != (128 & t.flags)
    if (
      ((i = (i = s) || ((null === e || null !== e.memoizedState) && 0 != (2 & a)))
        ? ((l = !0), (t.flags &= -129))
        : (null !== e && null === e.memoizedState) || (a |= 1),
      Po(sl, 1 & a),
      null === e)
    )
      return (
        ua(t),
        null !== (e = t.memoizedState) && null !== (e = e.dehydrated)
          ? (0 == (1 & t.mode) ? (t.lanes = 1) : '$!' === e.data ? (t.lanes = 8) : (t.lanes = 1073741824), null)
          : ((s = o.children),
            (e = o.fallback),
            l
              ? ((o = t.mode),
                (l = t.child),
                (s = { mode: 'hidden', children: s }),
                0 == (1 & o) && null !== l ? ((l.childLanes = 0), (l.pendingProps = s)) : (l = wu(s, o, 0, null)),
                (e = bu(e, o, n, null)),
                (l.return = t),
                (e.return = t),
                (l.sibling = e),
                (t.child = l),
                (t.child.memoizedState = Ts(n)),
                (t.memoizedState = Ls),
                e)
              : Ms(t, s))
      )
    if (null === (a = e.memoizedState) || null === (i = a.dehydrated))
      return (
        l
          ? ((l = o.fallback),
            (s = t.mode),
            (i = (a = e.child).sibling),
            (c = { mode: 'hidden', children: o.children }),
            0 == (1 & s) && t.child !== a
              ? (((o = t.child).childLanes = 0), (o.pendingProps = c), (t.deletions = null))
              : ((o = vu(a, c)).subtreeFlags = 14680064 & a.subtreeFlags),
            null !== i ? (l = vu(i, l)) : ((l = bu(l, s, n, null)).flags |= 2),
            (l.return = t),
            (o.return = t),
            (o.sibling = l),
            (t.child = o),
            (o = l),
            (l = t.child),
            (s =
              null === (s = e.child.memoizedState)
                ? Ts(n)
                : { baseLanes: s.baseLanes | n, cachePool: null, transitions: s.transitions }),
            (l.memoizedState = s),
            (l.childLanes = e.childLanes & ~n),
            (t.memoizedState = Ls))
          : ((e = (l = e.child).sibling),
            (o = vu(l, { mode: 'visible', children: o.children })),
            0 == (1 & t.mode) && (o.lanes = n),
            (o.return = t),
            (o.sibling = null) !== e &&
              (null === (n = t.deletions) ? ((t.deletions = [e]), (t.flags |= 16)) : n.push(e)),
            (t.child = o),
            (t.memoizedState = null)),
        o
      )
    var c = e,
      u = ((l = t), (e = o), i)
    ;(t = a), (o = n)
    if (s)
      return 256 & l.flags
        ? ((l.flags &= -257), js(c, l, o, (e = ss(Error(Oe(422))))))
        : null !== l.memoizedState
        ? ((l.child = c.child), (l.flags |= 128), null)
        : ((t = e.fallback),
          (u = l.mode),
          (e = wu({ mode: 'visible', children: e.children }, u, 0, null)),
          ((t = bu(t, u, o, null)).flags |= 2),
          (e.return = l),
          (t.return = l),
          (e.sibling = t),
          (l.child = e),
          0 != (1 & l.mode) && Ka(l, c.child, null, o),
          (l.child.memoizedState = Ts(o)),
          (l.memoizedState = Ls),
          t)
    if (0 == (1 & l.mode)) return js(c, l, o, null)
    if ('$!' === u.data)
      return (
        (e = r = (e = u.nextSibling && u.nextSibling.dataset) ? e.dgst : r),
        js(c, l, o, (e = ss((t = Error(Oe(419))), e, void 0)))
      )
    if (((r = 0 != (o & c.childLanes)), vs || r)) {
      if (null !== (e = yc)) {
        switch (o & -o) {
          case 4:
            u = 2
            break
          case 16:
            u = 8
            break
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            u = 32
            break
          case 536870912:
            u = 268435456
            break
          default:
            u = 0
        }
        0 !== (u = 0 != (u & (e.suspendedLanes | o)) ? 0 : u) &&
          u !== t.retryLane &&
          ((t.retryLane = u), Ta(c, u), Zc(e, c, u, -1))
      }
      return iu(), js(c, l, o, (e = ss(Error(Oe(421)))))
    }
    return '$?' === u.data
      ? ((l.flags |= 128),
        (l.child = c.child),
        (l = function (e) {
          var t = e.memoizedState,
            n = 0
          null !== t && (n = t.retryLane), fu(e, n)
        }.bind(null, c)),
        (u._reactRetry = l),
        null)
      : ((c = t.treeContext),
        (ia = uo(u.nextSibling)),
        (ra = l),
        (oa = !0),
        (aa = null) !== c &&
          ((Yo[qo++] = Ko), (Yo[qo++] = Qo), (Yo[qo++] = $o), (Ko = c.id), (Qo = c.overflow), ($o = l)),
        ((l = Ms(l, e.children)).flags |= 4096),
        l)
  }
  function Ms(e, t) {
    return (((t = wu({ mode: 'visible', children: t }, e.mode, 0, null)).return = e).child = t)
  }
  function js(e, t, n, r) {
    return (
      null !== r && ga(r),
      Ka(t, e.child, null, n),
      ((e = Ms(t, t.pendingProps.children)).flags |= 2),
      (t.memoizedState = null),
      e
    )
  }
  function Rs(e, t, n) {
    e.lanes |= t
    var r = e.alternate
    null !== r && (r.lanes |= t), Sa(e.return, t, n)
  }
  function Ds(e, t, n, r, i) {
    var o = e.memoizedState
    null === o
      ? (e.memoizedState = { isBackwards: t, rendering: null, renderingStartTime: 0, last: r, tail: n, tailMode: i })
      : ((o.isBackwards = t),
        (o.rendering = null),
        (o.renderingStartTime = 0),
        (o.last = r),
        (o.tail = n),
        (o.tailMode = i))
  }
  function As(e, t, n) {
    var r = t.pendingProps,
      i = r.revealOrder,
      o = r.tail
    if ((ys(e, t, r.children, n), 0 != (2 & (r = sl.current)))) (r = (1 & r) | 2), (t.flags |= 128)
    else {
      if (null !== e && 0 != (128 & e.flags))
        e: for (e = t.child; null !== e; ) {
          if (13 === e.tag) null !== e.memoizedState && Rs(e, n, t)
          else if (19 === e.tag) Rs(e, n, t)
          else if (null !== e.child) {
            e = (e.child.return = e).child
            continue
          }
          if (e === t) break
          for (; null === e.sibling; ) {
            if (null === e.return || e.return === t) break e
            e = e.return
          }
          ;(e.sibling.return = e.return), (e = e.sibling)
        }
      r &= 1
    }
    if ((Po(sl, r), 0 == (1 & t.mode))) t.memoizedState = null
    else
      switch (i) {
        case 'forwards':
          for (n = t.child, i = null; null !== n; )
            null !== (e = n.alternate) && null === cl(e) && (i = n), (n = n.sibling)
          null === (n = i) ? ((i = t.child), (t.child = null)) : ((i = n.sibling), (n.sibling = null)),
            Ds(t, !1, i, n, o)
          break
        case 'backwards':
          for (i = t.child, t.child = n = null; null !== i; ) {
            if (null !== (e = i.alternate) && null === cl(e)) {
              t.child = i
              break
            }
            ;(e = i.sibling), (i.sibling = n), (n = i), (i = e)
          }
          Ds(t, !0, n, null, o)
          break
        case 'together':
          Ds(t, !1, null, null, void 0)
          break
        default:
          t.memoizedState = null
      }
    return t.child
  }
  function zs(e, t) {
    0 == (1 & t.mode) && null !== e && ((e.alternate = null), (t.alternate = null), (t.flags |= 2))
  }
  function Ns(e, t, n) {
    if ((null !== e && (t.dependencies = e.dependencies), (Oc |= t.lanes), 0 == (n & t.childLanes))) return null
    if (null !== e && t.child !== e.child) throw Error(Oe(153))
    if (null !== t.child) {
      for (n = vu((e = t.child), e.pendingProps), (t.child = n).return = t; null !== e.sibling; )
        (e = e.sibling), ((n = n.sibling = vu(e, e.pendingProps)).return = t)
      n.sibling = null
    }
    return t.child
  }
  function Fs(e, t) {
    if (!oa)
      switch (e.tailMode) {
        case 'hidden':
          t = e.tail
          for (var n = null; null !== t; ) null !== t.alternate && (n = t), (t = t.sibling)
          null === n ? (e.tail = null) : (n.sibling = null)
          break
        case 'collapsed':
          n = e.tail
          for (var r = null; null !== n; ) null !== n.alternate && (r = n), (n = n.sibling)
          null === r ? (t || null === e.tail ? (e.tail = null) : (e.tail.sibling = null)) : (r.sibling = null)
      }
  }
  function Hs(e) {
    var t = 0,
      n = 0
    if (null !== e.alternate && e.alternate.child === e.child)
      for (var r = e.child; null !== r; )
        (t |= r.lanes | r.childLanes),
          (n = (n |= 14680064 & r.subtreeFlags) | (14680064 & r.flags)),
          (r.return = e),
          (r = r.sibling)
    else
      for (r = e.child; null !== r; )
        (t |= r.lanes | r.childLanes), (n = (n |= r.subtreeFlags) | r.flags), (r.return = e), (r = r.sibling)
    ;(e.subtreeFlags |= n), (e.childLanes = t)
  }
  var Bs = function (e, t) {
      for (var n = t.child; null !== n; ) {
        if (5 === n.tag || 6 === n.tag) e.appendChild(n.stateNode)
        else if (4 !== n.tag && null !== n.child) {
          n = (n.child.return = n).child
          continue
        }
        if (n === t) break
        for (; null === n.sibling; ) {
          if (null === n.return || n.return === t) return
          n = n.return
        }
        ;(n.sibling.return = n.return), (n = n.sibling)
      }
    },
    Vs = function (e, t, n, r) {
      var i = e.memoizedProps
      if (i !== r) {
        ;(e = t.stateNode), rl(el.current)
        var o,
          a = null
        switch (n) {
          case 'input':
            ;(i = dt(e, i)), (r = dt(e, r)), (a = [])
            break
          case 'select':
            ;(i = tt({}, i, { value: void 0 })), (r = tt({}, r, { value: void 0 })), (a = [])
            break
          case 'textarea':
            ;(i = bt(e, i)), (r = bt(e, r)), (a = [])
            break
          default:
            'function' != typeof i.onClick && 'function' == typeof r.onClick && (e.onclick = eo)
        }
        for (c in (Rt(n, r), (n = null), i))
          if (!r.hasOwnProperty(c) && i.hasOwnProperty(c) && null != i[c])
            if ('style' === c) {
              var l = i[c]
              for (o in l) l.hasOwnProperty(o) && ((n = n || {})[o] = '')
            } else
              'dangerouslySetInnerHTML' !== c &&
                'children' !== c &&
                'suppressContentEditableWarning' !== c &&
                'suppressHydrationWarning' !== c &&
                'autoFocus' !== c &&
                (Pe.hasOwnProperty(c) ? (a = a || []) : (a = a || []).push(c, null))
        for (c in r) {
          var s = r[c]
          l = null != i ? i[c] : void 0
          if (r.hasOwnProperty(c) && s !== l && (null != s || null != l))
            if ('style' === c)
              if (l) {
                for (o in l) !l.hasOwnProperty(o) || (s && s.hasOwnProperty(o)) || ((n = n || {})[o] = '')
                for (o in s) s.hasOwnProperty(o) && l[o] !== s[o] && ((n = n || {})[o] = s[o])
              } else n || (a = a || []).push(c, n), (n = s)
            else
              'dangerouslySetInnerHTML' === c
                ? ((s = s ? s.__html : void 0),
                  (l = l ? l.__html : void 0),
                  null != s && l !== s && (a = a || []).push(c, s))
                : 'children' === c
                ? ('string' != typeof s && 'number' != typeof s) || (a = a || []).push(c, '' + s)
                : 'suppressContentEditableWarning' !== c &&
                  'suppressHydrationWarning' !== c &&
                  (Pe.hasOwnProperty(c)
                    ? (null != s && 'onScroll' === c && Hi('scroll', e), a || l === s || (a = []))
                    : (a = a || []).push(c, s))
        }
        n && (a = a || []).push('style', n)
        var c = a
        ;(t.updateQueue = c) && (t.flags |= 4)
      }
    },
    Ws = function (e, t, n, r) {
      n !== r && (t.flags |= 4)
    },
    Gs = !1,
    Zs = !1,
    Us = 'function' == typeof WeakSet ? WeakSet : Set,
    Xs = null
  function Ys(e, t) {
    var n = e.ref
    if (null !== n)
      if ('function' == typeof n)
        try {
          n(null)
        } catch (r) {
          du(e, t, r)
        }
      else n.current = null
  }
  function qs(e, t, n) {
    try {
      n()
    } catch (r) {
      du(e, t, r)
    }
  }
  var $s = !1
  function Ks(e, t, n) {
    var r = t.updateQueue
    if (null !== (r = null !== r ? r.lastEffect : null)) {
      var i,
        o = (r = r.next)
      do {} while (
        ((o.tag & e) === e && ((i = o.destroy), (o.destroy = void 0) !== i) && qs(t, n, i), (o = o.next) !== r)
      )
    }
  }
  function Qs(e, t) {
    if (null !== (t = null !== (t = t.updateQueue) ? t.lastEffect : null)) {
      var n,
        r = (t = t.next)
      do {} while (((r.tag & e) === e && ((n = r.create), (r.destroy = n())), (r = r.next) !== t))
    }
  }
  function Js(e) {
    var t,
      n = e.ref
    null !== n && ((t = e.stateNode), e.tag, (e = t), 'function' == typeof n ? n(e) : (n.current = e))
  }
  function ec(e) {
    return 5 === e.tag || 3 === e.tag || 4 === e.tag
  }
  function tc(e) {
    e: for (;;) {
      for (; null === e.sibling; ) {
        if (null === e.return || ec(e.return)) return null
        e = e.return
      }
      for (e.sibling.return = e.return, e = e.sibling; 5 !== e.tag && 6 !== e.tag && 18 !== e.tag; ) {
        if (2 & e.flags) continue e
        if (null === e.child || 4 === e.tag) continue e
        e = (e.child.return = e).child
      }
      if (!(2 & e.flags)) return e.stateNode
    }
  }
  var nc = null,
    rc = !1
  function ic(e, t, n) {
    for (n = n.child; null !== n; ) oc(e, t, n), (n = n.sibling)
  }
  function oc(e, t, n) {
    if (wn && 'function' == typeof wn.onCommitFiberUnmount)
      try {
        wn.onCommitFiberUnmount(bn, n)
      } catch (l) {}
    switch (n.tag) {
      case 5:
        Zs || Ys(n, t)
      case 6:
        var r = nc,
          i = rc
        ;(nc = null),
          ic(e, t, n),
          (rc = i),
          null !== (nc = r) &&
            (rc
              ? ((e = nc), (n = n.stateNode), (8 === e.nodeType ? e.parentNode : e).removeChild(n))
              : nc.removeChild(n.stateNode))
        break
      case 18:
        null !== nc &&
          (rc
            ? ((e = nc),
              (n = n.stateNode),
              8 === e.nodeType ? co(e.parentNode, n) : 1 === e.nodeType && co(e, n),
              nr(e))
            : co(nc, n.stateNode))
        break
      case 4:
        ;(r = nc), (i = rc), (nc = n.stateNode.containerInfo), (rc = !0), ic(e, t, n), (nc = r), (rc = i)
        break
      case 0:
      case 11:
      case 14:
      case 15:
        if (!Zs && null !== (r = n.updateQueue) && null !== (r = r.lastEffect)) {
          i = r = r.next
          do {
            var o = i.destroy,
              a = i.tag
          } while ((void 0 === o || (0 == (2 & a) && 0 == (4 & a)) || qs(n, t, o), (i = i.next) !== r))
        }
        ic(e, t, n)
        break
      case 1:
        if (!Zs && (Ys(n, t), 'function' == typeof (r = n.stateNode).componentWillUnmount))
          try {
            ;(r.props = n.memoizedProps), (r.state = n.memoizedState), r.componentWillUnmount()
          } catch (l) {
            du(n, t, l)
          }
        ic(e, t, n)
        break
      case 21:
        ic(e, t, n)
        break
      case 22:
        1 & n.mode ? ((Zs = (r = Zs) || null !== n.memoizedState), ic(e, t, n), (Zs = r)) : ic(e, t, n)
        break
      default:
        ic(e, t, n)
    }
  }
  function ac(e) {
    var t,
      n = e.updateQueue
    null !== n &&
      ((e.updateQueue = null) === (t = e.stateNode) && (t = e.stateNode = new Us()),
      n.forEach(function (n) {
        var r = function (e, t) {
          var n = 0
          switch (e.tag) {
            case 13:
              var r = e.stateNode,
                i = e.memoizedState
              null !== i && (n = i.retryLane)
              break
            case 19:
              r = e.stateNode
              break
            default:
              throw Error(Oe(314))
          }
          null !== r && r.delete(t), fu(e, n)
        }.bind(null, e, n)
        t.has(n) || (t.add(n), n.then(r, r))
      }))
  }
  function lc(e, t) {
    var n = t.deletions
    if (null !== n)
      for (var r = 0; r < n.length; r++) {
        var i = n[r]
        try {
          var o = e,
            a = t,
            l = a
          e: for (; null !== l; ) {
            switch (l.tag) {
              case 5:
                ;(nc = l.stateNode), (rc = !1)
                break e
              case 3:
              case 4:
                ;(nc = l.stateNode.containerInfo), (rc = !0)
                break e
            }
            l = l.return
          }
          if (null === nc) throw Error(Oe(160))
          oc(o, a, i), (nc = null), (rc = !1)
          var s = i.alternate
          null !== s && (s.return = null), (i.return = null)
        } catch (c) {
          du(i, t, c)
        }
      }
    if (12854 & t.subtreeFlags) for (t = t.child; null !== t; ) sc(t, e), (t = t.sibling)
  }
  function sc(e, t) {
    var n = e.alternate,
      r = e.flags
    switch (e.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if ((lc(t, e), cc(e), 4 & r)) {
          try {
            Ks(3, e, e.return), Qs(3, e)
          } catch (g) {
            du(e, e.return, g)
          }
          try {
            Ks(5, e, e.return)
          } catch (g) {
            du(e, e.return, g)
          }
        }
        break
      case 1:
        lc(t, e), cc(e), 512 & r && null !== n && Ys(n, n.return)
        break
      case 5:
        if ((lc(t, e), cc(e), 512 & r && null !== n && Ys(n, n.return), 32 & e.flags)) {
          var i = e.stateNode
          try {
            _t(i, '')
          } catch (g) {
            du(e, e.return, g)
          }
        }
        if (4 & r && null != (i = e.stateNode)) {
          var o = e.memoizedProps,
            a = null !== n ? n.memoizedProps : o,
            l = e.type,
            s = e.updateQueue
          if ((e.updateQueue = null) !== s)
            try {
              'input' === l && 'radio' === o.type && null != o.name && ht(i, o), Dt(l, a)
              var c = Dt(l, o)
              for (a = 0; a < s.length; a += 2) {
                var u = s[a],
                  d = s[a + 1]
                'style' === u
                  ? Mt(i, d)
                  : 'dangerouslySetInnerHTML' === u
                  ? Pt(i, d)
                  : 'children' === u
                  ? _t(i, d)
                  : Ne(i, u, d, c)
              }
              switch (l) {
                case 'input':
                  pt(i, o)
                  break
                case 'textarea':
                  Ct(i, o)
                  break
                case 'select':
                  var f = i._wrapperState.wasMultiple,
                    h = ((i._wrapperState.wasMultiple = !!o.multiple), o.value)
                  null != h
                    ? yt(i, !!o.multiple, h, !1)
                    : f !== !!o.multiple &&
                      (null != o.defaultValue
                        ? yt(i, !!o.multiple, o.defaultValue, !0)
                        : yt(i, !!o.multiple, o.multiple ? [] : '', !1))
              }
              i[po] = o
            } catch (g) {
              du(e, e.return, g)
            }
        }
        break
      case 6:
        if ((lc(t, e), cc(e), 4 & r)) {
          if (null === e.stateNode) throw Error(Oe(162))
          ;(i = e.stateNode), (o = e.memoizedProps)
          try {
            i.nodeValue = o
          } catch (g) {
            du(e, e.return, g)
          }
        }
        break
      case 3:
        if ((lc(t, e), cc(e), 4 & r && null !== n && n.memoizedState.isDehydrated))
          try {
            nr(t.containerInfo)
          } catch (g) {
            du(e, e.return, g)
          }
        break
      case 4:
      default:
        lc(t, e), cc(e)
        break
      case 13:
        lc(t, e),
          cc(e),
          8192 & (i = e.child).flags &&
            ((o = null !== i.memoizedState),
            !(i.stateNode.isHidden = o) || (null !== i.alternate && null !== i.alternate.memoizedState) || (Tc = fn())),
          4 & r && ac(e)
        break
      case 22:
        if (
          ((u = null !== n && null !== n.memoizedState),
          1 & e.mode ? ((Zs = (c = Zs) || u), lc(t, e), (Zs = c)) : lc(t, e),
          cc(e),
          8192 & r)
        ) {
          if (((c = null !== e.memoizedState), (e.stateNode.isHidden = c) && !u && 0 != (1 & e.mode)))
            for (u = (Xs = e).child; null !== u; ) {
              for (d = Xs = u; null !== Xs; ) {
                switch (((h = (f = Xs).child), f.tag)) {
                  case 0:
                  case 11:
                  case 14:
                  case 15:
                    Ks(4, f, f.return)
                    break
                  case 1:
                    Ys(f, f.return)
                    var p = f.stateNode
                    if ('function' == typeof p.componentWillUnmount) {
                      n = (r = f).return
                      try {
                        ;(t = r), (p.props = t.memoizedProps), (p.state = t.memoizedState), p.componentWillUnmount()
                      } catch (g) {
                        du(r, n, g)
                      }
                    }
                    break
                  case 5:
                    Ys(f, f.return)
                    break
                  case 22:
                    if (null !== f.memoizedState) {
                      dc(d)
                      continue
                    }
                }
                null !== h ? ((h.return = f), (Xs = h)) : dc(d)
              }
              u = u.sibling
            }
          e: for (u = null, d = e; ; ) {
            if (5 === d.tag) {
              if (null === u) {
                u = d
                try {
                  ;(i = d.stateNode),
                    c
                      ? 'function' == typeof (o = i.style).setProperty
                        ? o.setProperty('display', 'none', 'important')
                        : (o.display = 'none')
                      : ((l = d.stateNode),
                        (a = null != (s = d.memoizedProps.style) && s.hasOwnProperty('display') ? s.display : null),
                        (l.style.display = It('display', a)))
                } catch (g) {
                  du(e, e.return, g)
                }
              }
            } else if (6 === d.tag) {
              if (null === u)
                try {
                  d.stateNode.nodeValue = c ? '' : d.memoizedProps
                } catch (g) {
                  du(e, e.return, g)
                }
            } else if (((22 !== d.tag && 23 !== d.tag) || null === d.memoizedState || d === e) && null !== d.child) {
              d = (d.child.return = d).child
              continue
            }
            if (d === e) break
            for (; null === d.sibling; ) {
              if (null === d.return || d.return === e) break e
              u === d && (u = null), (d = d.return)
            }
            u === d && (u = null), (d.sibling.return = d.return), (d = d.sibling)
          }
        }
        break
      case 19:
        lc(t, e), cc(e), 4 & r && ac(e)
      case 21:
    }
  }
  function cc(e) {
    var t = e.flags
    if (2 & t) {
      try {
        e: {
          for (var n = e.return; null !== n; ) {
            if (ec(n)) {
              var r = n
              break e
            }
            n = n.return
          }
          throw Error(Oe(160))
        }
        switch (r.tag) {
          case 5:
            var i = r.stateNode
            32 & r.flags && (_t(i, ''), (r.flags &= -33)),
              (function e(t, n, r) {
                var i = t.tag
                if (5 === i || 6 === i) (t = t.stateNode), n ? r.insertBefore(t, n) : r.appendChild(t)
                else if (4 !== i && null !== (t = t.child))
                  for (e(t, n, r), t = t.sibling; null !== t; ) e(t, n, r), (t = t.sibling)
              })(e, tc(e), i)
            break
          case 3:
          case 4:
            var o = r.stateNode.containerInfo
            !(function e(t, n, r) {
              var i = t.tag
              if (5 === i || 6 === i)
                (t = t.stateNode),
                  n
                    ? (8 === r.nodeType ? r.parentNode : r).insertBefore(t, n)
                    : (8 === r.nodeType ? (n = r.parentNode).insertBefore(t, r) : (n = r).appendChild(t),
                      null == (r = r._reactRootContainer) && null === n.onclick && (n.onclick = eo))
              else if (4 !== i && null !== (t = t.child))
                for (e(t, n, r), t = t.sibling; null !== t; ) e(t, n, r), (t = t.sibling)
            })(e, tc(e), o)
            break
          default:
            throw Error(Oe(161))
        }
      } catch (a) {
        du(e, e.return, a)
      }
      e.flags &= -3
    }
    4096 & t && (e.flags &= -4097)
  }
  function uc(e) {
    for (; null !== Xs; ) {
      var t = Xs
      if (0 != (8772 & t.flags)) {
        var n,
          r,
          i,
          o = t.alternate
        try {
          if (0 != (8772 & t.flags))
            switch (t.tag) {
              case 0:
              case 11:
              case 15:
                Zs || Qs(5, t)
                break
              case 1:
                var a,
                  l = t.stateNode,
                  s =
                    (4 & t.flags &&
                      !Zs &&
                      (null === o
                        ? l.componentDidMount()
                        : ((a = t.elementType === t.type ? o.memoizedProps : va(t.type, o.memoizedProps)),
                          l.componentDidUpdate(a, o.memoizedState, l.__reactInternalSnapshotBeforeUpdate))),
                    t.updateQueue)
                null !== s && Fa(0, s, l)
                break
              case 3:
                var c = t.updateQueue
                if (null !== c) {
                  if ((o = null) !== t.child)
                    switch (t.child.tag) {
                      case 5:
                      case 1:
                        o = t.child.stateNode
                    }
                  Fa(0, c, o)
                }
                break
              case 5:
                var u = t.stateNode
                if (null === o && 4 & t.flags) {
                  o = u
                  var d = t.memoizedProps
                  switch (t.type) {
                    case 'button':
                    case 'input':
                    case 'select':
                    case 'textarea':
                      d.autoFocus && o.focus()
                      break
                    case 'img':
                      d.src && (o.src = d.src)
                  }
                }
                break
              case 6:
              case 4:
              case 12:
              case 19:
              case 17:
              case 21:
              case 22:
              case 23:
              case 25:
                break
              case 13:
                null === t.memoizedState &&
                  null !== (n = t.alternate) &&
                  null !== (r = n.memoizedState) &&
                  null !== (i = r.dehydrated) &&
                  nr(i)
                break
              default:
                throw Error(Oe(163))
            }
          Zs || (512 & t.flags && Js(t))
        } catch (f) {
          du(t, t.return, f)
        }
      }
      if (t === e) {
        Xs = null
        break
      }
      if (null !== (o = t.sibling)) {
        ;(o.return = t.return), (Xs = o)
        break
      }
      Xs = t.return
    }
  }
  function dc(e) {
    for (; null !== Xs; ) {
      var t = Xs
      if (t === e) {
        Xs = null
        break
      }
      var n = t.sibling
      if (null !== n) {
        ;(n.return = t.return), (Xs = n)
        break
      }
      Xs = t.return
    }
  }
  function fc(e) {
    for (; null !== Xs; ) {
      var t = Xs
      try {
        switch (t.tag) {
          case 0:
          case 11:
          case 15:
            var n = t.return
            try {
              Qs(4, t)
            } catch (s) {
              du(t, n, s)
            }
            break
          case 1:
            var r = t.stateNode
            if ('function' == typeof r.componentDidMount) {
              var i = t.return
              try {
                r.componentDidMount()
              } catch (s) {
                du(t, i, s)
              }
            }
            var o = t.return
            try {
              Js(t)
            } catch (s) {
              du(t, o, s)
            }
            break
          case 5:
            var a = t.return
            try {
              Js(t)
            } catch (s) {
              du(t, a, s)
            }
        }
      } catch (s) {
        du(t, t.return, s)
      }
      if (t === e) {
        Xs = null
        break
      }
      var l = t.sibling
      if (null !== l) {
        ;(l.return = t.return), (Xs = l)
        break
      }
      Xs = t.return
    }
  }
  var hc = Math.ceil,
    pc = c.ReactCurrentDispatcher,
    gc = c.ReactCurrentOwner,
    mc = c.ReactCurrentBatchConfig,
    vc = 0,
    yc = null,
    bc = null,
    wc = 0,
    Cc = 0,
    xc = Oo(0),
    Ec = 0,
    Sc = null,
    Oc = 0,
    kc = 0,
    Pc = 0,
    _c = null,
    Lc = null,
    Tc = 0,
    Ic = 1 / 0,
    Mc = null,
    jc = !1,
    Rc = null,
    Dc = null,
    Ac = !1,
    zc = null,
    Nc = 0,
    Fc = 0,
    Hc = null,
    Bc = -1,
    Vc = 0
  function Wc() {
    return 0 != (6 & vc) ? fn() : -1 !== Bc ? Bc : (Bc = fn())
  }
  function Gc(e) {
    return 0 == (1 & e.mode)
      ? 1
      : 0 != (2 & vc) && 0 !== wc
      ? wc & -wc
      : null !== ma.transition
      ? (Vc = 0 === Vc ? Ln() : Vc)
      : 0 === (e = jn)
      ? void 0 === (e = window.event)
        ? 16
        : ur(e.type)
      : e
  }
  function Zc(e, t, n, r) {
    if (50 < Fc) throw ((Fc = 0), (Hc = null), Error(Oe(185)))
    In(e, n, r),
      (0 != (2 & vc) && e === yc) ||
        (e === yc && (0 == (2 & vc) && (kc |= n), 4 === Ec) && $c(e, wc),
        Uc(e, r),
        1 === n && 0 === vc && 0 == (1 & t.mode) && ((Ic = fn() + 500), Ho) && Wo())
  }
  function Uc(e, t) {
    var n,
      r = e.callbackNode,
      i =
        ((function (e, t) {
          for (var n = e.suspendedLanes, r = e.pingedLanes, i = e.expirationTimes, o = e.pendingLanes; 0 < o; ) {
            var a = 31 - Cn(o),
              l = 1 << a,
              s = i[a]
            ;-1 === s
              ? (0 != (l & n) && 0 == (l & r)) ||
                (i[a] = (function (e, t) {
                  switch (e) {
                    case 1:
                    case 2:
                    case 4:
                      return t + 250
                    case 8:
                    case 16:
                    case 32:
                    case 64:
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                      return t + 5e3
                    default:
                      return -1
                  }
                })(l, t))
              : s <= t && (e.expiredLanes |= l),
              (o &= ~l)
          }
        })(e, t),
        Pn(e, e === yc ? wc : 0))
    if (0 === i) null !== r && cn(r), (e.callbackNode = null), (e.callbackPriority = 0)
    else if (e.callbackPriority !== (t = i & -i)) {
      if ((null != r && cn(r), 1 === t))
        0 === e.tag ? ((n = Kc.bind(null, e)), (Ho = !0), Vo(n)) : Vo(Kc.bind(null, e)),
          lo(function () {
            0 == (6 & vc) && Wo()
          }),
          (r = null)
      else {
        switch (Rn(i)) {
          case 1:
            r = pn
            break
          case 4:
            r = gn
            break
          case 16:
          default:
            r = mn
            break
          case 536870912:
            r = yn
        }
        r = hu(r, Xc.bind(null, e))
      }
      ;(e.callbackPriority = t), (e.callbackNode = r)
    }
  }
  function Xc(e, t) {
    if (((Bc = -1), (Vc = 0) != (6 & vc))) throw Error(Oe(327))
    var n = e.callbackNode
    if (cu() && e.callbackNode !== n) return null
    var r = Pn(e, e === yc ? wc : 0)
    if (0 === r) return null
    if (0 != (30 & r) || 0 != (r & e.expiredLanes) || t) t = ou(e, r)
    else {
      t = r
      var i = vc,
        o = ((vc |= 2), ru())
      for ((yc === e && wc === t) || ((Mc = null), (Ic = fn() + 500), tu(e, t)); ; )
        try {
          for (; null !== bc && !un(); ) au(bc)
          break
        } catch (l) {
          nu(e, l)
        }
      xa(), (pc.current = o), (vc = i), (t = null !== bc ? 0 : ((yc = null), (wc = 0), Ec))
    }
    if (0 !== t) {
      if (1 === (t = 2 === t && 0 !== (i = _n(e)) ? Yc(e, (r = i)) : t))
        throw ((n = Sc), tu(e, 0), $c(e, r), Uc(e, fn()), n)
      if (6 === t) $c(e, r)
      else {
        if (
          ((i = e.current.alternate),
          0 == (30 & r) &&
            !(function (e) {
              for (var t = e; ; ) {
                if (16384 & t.flags) {
                  var n = t.updateQueue
                  if (null !== n && null !== (n = n.stores))
                    for (var r = 0; r < n.length; r++) {
                      var i = n[r],
                        o = i.getSnapshot
                      i = i.value
                      try {
                        if (!ui(o(), i)) return
                      } catch (a) {
                        return
                      }
                    }
                }
                if (((n = t.child), 16384 & t.subtreeFlags && null !== n)) (n.return = t), (t = n)
                else {
                  if (t === e) break
                  for (; null === t.sibling; ) {
                    if (null === t.return || t.return === e) return 1
                    t = t.return
                  }
                  ;(t.sibling.return = t.return), (t = t.sibling)
                }
              }
              return 1
            })(i) &&
            1 === (t = 2 === (t = ou(e, r)) && 0 !== (o = _n(e)) ? Yc(e, (r = o)) : t))
        )
          throw ((n = Sc), tu(e, 0), $c(e, r), Uc(e, fn()), n)
        switch (((e.finishedWork = i), (e.finishedLanes = r), t)) {
          case 0:
          case 1:
            throw Error(Oe(345))
          case 2:
          case 5:
            su(e, Lc, Mc)
            break
          case 3:
            if (($c(e, r), (130023424 & r) === r && 10 < (t = Tc + 500 - fn()))) {
              if (0 !== Pn(e, 0)) break
              if (((i = e.suspendedLanes) & r) !== r) {
                Wc(), (e.pingedLanes |= e.suspendedLanes & i)
                break
              }
              e.timeoutHandle = io(su.bind(null, e, Lc, Mc), t)
            } else su(e, Lc, Mc)
            break
          case 4:
            if (($c(e, r), (4194240 & r) !== r)) {
              for (t = e.eventTimes, i = -1; 0 < r; ) {
                var a = 31 - Cn(r)
                o = 1 << a
                i < (a = t[a]) && (i = a), (r &= ~o)
              }
              ;(r = i),
                10 <
                (r =
                  ((r = fn() - r) < 120
                    ? 120
                    : r < 480
                    ? 480
                    : r < 1080
                    ? 1080
                    : r < 1920
                    ? 1920
                    : r < 3e3
                    ? 3e3
                    : r < 4320
                    ? 4320
                    : 1960 * hc(r / 1960)) - r)
                  ? (e.timeoutHandle = io(su.bind(null, e, Lc, Mc), r))
                  : su(e, Lc, Mc)
            }
            break
          default:
            throw Error(Oe(329))
        }
      }
    }
    return Uc(e, fn()), e.callbackNode === n ? Xc.bind(null, e) : null
  }
  function Yc(e, t) {
    var n = _c
    return (
      e.current.memoizedState.isDehydrated && (tu(e, t).flags |= 256),
      2 !== (e = ou(e, t)) && ((t = Lc), (Lc = n), null !== t) && qc(t),
      e
    )
  }
  function qc(e) {
    null === Lc ? (Lc = e) : Lc.push.apply(Lc, e)
  }
  function $c(e, t) {
    for (t = t & ~Pc & ~kc, e.suspendedLanes |= t, e.pingedLanes &= ~t, e = e.expirationTimes; 0 < t; ) {
      var n = 31 - Cn(t),
        r = 1 << n
      ;(e[n] = -1), (t &= ~r)
    }
  }
  function Kc(e) {
    if (0 != (6 & vc)) throw Error(Oe(327))
    cu()
    var t = Pn(e, 0)
    if (0 != (1 & t)) {
      var n,
        r = ou(e, t)
      if (1 === (r = 0 !== e.tag && 2 === r && 0 !== (n = _n(e)) ? Yc(e, (t = n)) : r))
        throw ((r = Sc), tu(e, 0), $c(e, t), Uc(e, fn()), r)
      if (6 === r) throw Error(Oe(345))
      ;(e.finishedWork = e.current.alternate), (e.finishedLanes = t), su(e, Lc, Mc)
    }
    return Uc(e, fn()), null
  }
  function Qc(e, t) {
    var n = vc
    vc |= 1
    try {
      return e(t)
    } finally {
      0 === (vc = n) && ((Ic = fn() + 500), Ho) && Wo()
    }
  }
  function Jc(e) {
    null !== zc && 0 === zc.tag && 0 == (6 & vc) && cu()
    var t = vc,
      n = ((vc |= 1), mc.transition),
      r = jn
    try {
      if (((mc.transition = null), (jn = 1), e)) return e()
    } finally {
      ;(jn = r), (mc.transition = n), 0 == (6 & (vc = t)) && Wo()
    }
  }
  function eu() {
    ;(Cc = xc.current), ko(xc)
  }
  function tu(e, t) {
    ;(e.finishedWork = null), (e.finishedLanes = 0)
    var n,
      r,
      i,
      o = e.timeoutHandle
    if ((-1 !== o && ((e.timeoutHandle = -1), oo(o)), null !== bc))
      for (o = bc.return; null !== o; ) {
        var a = o
        switch ((na(a), a.tag)) {
          case 1:
            null != (a = a.type.childContextTypes) && Ro()
            break
          case 3:
            ol(), ko(To), ko(Lo), dl()
            break
          case 5:
            ll(a)
            break
          case 4:
            ol()
            break
          case 13:
          case 19:
            ko(sl)
            break
          case 10:
            Ea(a.type._context)
            break
          case 22:
          case 23:
            eu()
        }
        o = o.return
      }
    if (((bc = e = vu((yc = e).current, null)), (wc = Cc = t), (Pc = kc = Oc = Ec = 0), (Lc = _c = Sc = null) !== Pa)) {
      for (t = 0; t < Pa.length; t++)
        null !== (a = (o = Pa[t]).interleaved) &&
          ((o.interleaved = null),
          (n = a.next),
          null !== (r = o.pending) && ((i = r.next), (r.next = n), (a.next = i)),
          (o.pending = a))
      Pa = null
    }
    return e
  }
  function nu(e, t) {
    for (;;) {
      var n = bc
      try {
        if ((xa(), (fl.current = rs), yl)) {
          for (var r = gl.memoizedState; null !== r; ) {
            var i = r.queue
            null !== i && (i.pending = null), (r = r.next)
          }
          yl = !1
        }
        if (((vl = ml = gl = null), (bl = !1), (wl = pl = 0), (gc.current = null) === n || null === n.return)) {
          ;(Ec = 1), (Sc = t), (bc = null)
          break
        }
        e: {
          var o = e,
            a = n.return,
            l = t
          if (((t = wc), ((m = n).flags |= 32768), null !== l && 'object' == typeof l && 'function' == typeof l.then)) {
            var s,
              c = l,
              u = m,
              d = u.tag,
              f =
                (0 != (1 & u.mode) ||
                  (0 !== d && 11 !== d && 15 !== d) ||
                  ((s = u.alternate)
                    ? ((u.updateQueue = s.updateQueue), (u.memoizedState = s.memoizedState), (u.lanes = s.lanes))
                    : ((u.updateQueue = null), (u.memoizedState = null))),
                ps(a))
            if (null !== f) {
              ;(f.flags &= -257), gs(f, a, m, 0, t), 1 & f.mode && hs(o, c, t)
              l = c
              var h,
                p = (t = f).updateQueue
              null === p ? ((h = new Set()).add(l), (t.updateQueue = h)) : p.add(l)
              break e
            }
            if (0 == (1 & t)) {
              hs(o, c, t), iu()
              break e
            }
            l = Error(Oe(426))
          } else if (oa && 1 & m.mode) {
            var g = ps(a)
            if (null !== g) {
              0 == (65536 & g.flags) && (g.flags |= 256), gs(g, a, m, 0, t), ga(ls(l, m))
              break e
            }
          }
          ;(o = l = ls(l, m)), 4 !== Ec && (Ec = 2), null === _c ? (_c = [o]) : _c.push(o), (o = a)
          do {
            switch (o.tag) {
              case 3:
                ;(o.flags |= 65536), (t &= -t), (o.lanes |= t), za(o, ds(0, l, t))
                break e
              case 1:
                var m = l,
                  v = o.type,
                  y = o.stateNode
                if (
                  0 == (128 & o.flags) &&
                  ('function' == typeof v.getDerivedStateFromError ||
                    (null !== y && 'function' == typeof y.componentDidCatch && (null === Dc || !Dc.has(y))))
                ) {
                  ;(o.flags |= 65536), (t &= -t), (o.lanes |= t), za(o, fs(o, m, t))
                  break e
                }
            }
          } while (null !== (o = o.return))
        }
        lu(n)
      } catch (b) {
        ;(t = b), bc === n && null !== n && (bc = n.return)
        continue
      }
      break
    }
  }
  function ru() {
    var e = pc.current
    return (pc.current = rs), null === e ? rs : e
  }
  function iu() {
    ;(0 !== Ec && 3 !== Ec && 2 !== Ec) || (Ec = 4),
      null === yc || (0 == (268435455 & Oc) && 0 == (268435455 & kc)) || $c(yc, wc)
  }
  function ou(e, t) {
    var n = vc,
      r = ((vc |= 2), ru())
    for ((yc === e && wc === t) || ((Mc = null), tu(e, t)); ; )
      try {
        for (; null !== bc; ) au(bc)
        break
      } catch (i) {
        nu(e, i)
      }
    if ((xa(), (vc = n), (pc.current = r), null !== bc)) throw Error(Oe(261))
    return (yc = null), (wc = 0), Ec
  }
  function au(e) {
    var t = Iu(e.alternate, e, Cc)
    ;(e.memoizedProps = e.pendingProps), null === t ? lu(e) : (bc = t), (gc.current = null)
  }
  function lu(e) {
    var t = e
    do {
      var n = t.alternate
      if (((e = t.return), 0 == (32768 & t.flags))) {
        if (
          null !==
          (n = (function (e, t, n) {
            var r = t.pendingProps
            switch ((na(t), t.tag)) {
              case 2:
              case 16:
              case 15:
              case 0:
              case 11:
              case 7:
              case 8:
              case 12:
              case 9:
              case 14:
                return Hs(t), null
              case 1:
              case 17:
                return jo(t.type) && Ro(), Hs(t), null
              case 3:
                return (
                  (r = t.stateNode),
                  ol(),
                  ko(To),
                  ko(Lo),
                  dl(),
                  r.pendingContext && ((r.context = r.pendingContext), (r.pendingContext = null)),
                  (null !== e && null !== e.child) ||
                    (fa(t)
                      ? (t.flags |= 4)
                      : null === e ||
                        (e.memoizedState.isDehydrated && 0 == (256 & t.flags)) ||
                        ((t.flags |= 1024), null !== aa && (qc(aa), (aa = null)))),
                  Hs(t),
                  null
                )
              case 5:
                ll(t)
                var i,
                  o = rl(nl.current)
                if (((n = t.type), null !== e && null != t.stateNode))
                  Vs(e, t, n, r), e.ref !== t.ref && ((t.flags |= 512), (t.flags |= 2097152))
                else {
                  if (!r) {
                    if (null === t.stateNode) throw Error(Oe(166))
                    return Hs(t), null
                  }
                  if (((e = rl(el.current)), fa(t))) {
                    ;(r = t.stateNode), (n = t.type)
                    var a,
                      l,
                      s = t.memoizedProps
                    switch (((r[ho] = t), (r[po] = s), (e = 0 != (1 & t.mode)), n)) {
                      case 'dialog':
                        Hi('cancel', r), Hi('close', r)
                        break
                      case 'iframe':
                      case 'object':
                      case 'embed':
                        Hi('load', r)
                        break
                      case 'video':
                      case 'audio':
                        for (o = 0; o < Ai.length; o++) Hi(Ai[o], r)
                        break
                      case 'source':
                        Hi('error', r)
                        break
                      case 'img':
                      case 'image':
                      case 'link':
                        Hi('error', r), Hi('load', r)
                        break
                      case 'details':
                        Hi('toggle', r)
                        break
                      case 'input':
                        ft(r, s), Hi('invalid', r)
                        break
                      case 'select':
                        ;(r._wrapperState = { wasMultiple: !!s.multiple }), Hi('invalid', r)
                        break
                      case 'textarea':
                        wt(r, s), Hi('invalid', r)
                    }
                    for (a in (Rt(n, s), (o = null), s))
                      s.hasOwnProperty(a) &&
                        ((l = s[a]),
                        'children' === a
                          ? 'string' == typeof l
                            ? r.textContent !== l &&
                              (!0 !== s.suppressHydrationWarning && Ji(r.textContent, l, e), (o = ['children', l]))
                            : 'number' == typeof l &&
                              r.textContent !== '' + l &&
                              (!0 !== s.suppressHydrationWarning && Ji(r.textContent, l, e), (o = ['children', '' + l]))
                          : Pe.hasOwnProperty(a) && null != l && 'onScroll' === a && Hi('scroll', r))
                    switch (n) {
                      case 'input':
                        st(r), gt(r, s, !0)
                        break
                      case 'textarea':
                        st(r), xt(r)
                        break
                      case 'select':
                      case 'option':
                        break
                      default:
                        'function' == typeof s.onClick && (r.onclick = eo)
                    }
                    ;(r = o), null !== (t.updateQueue = r) && (t.flags |= 4)
                  } else {
                    ;(a = 9 === o.nodeType ? o : o.ownerDocument),
                      'http://www.w3.org/1999/xhtml' === (e = 'http://www.w3.org/1999/xhtml' === e ? Et(n) : e)
                        ? 'script' === n
                          ? (((e = a.createElement('div')).innerHTML = '<script></script>'),
                            (e = e.removeChild(e.firstChild)))
                          : 'string' == typeof r.is
                          ? (e = a.createElement(n, { is: r.is }))
                          : ((e = a.createElement(n)),
                            'select' === n && ((a = e), r.multiple ? (a.multiple = !0) : r.size && (a.size = r.size)))
                        : (e = a.createElementNS(e, n)),
                      (e[ho] = t),
                      (e[po] = r),
                      Bs(e, t),
                      (t.stateNode = e)
                    e: {
                      switch (((a = Dt(n, r)), n)) {
                        case 'dialog':
                          Hi('cancel', e), Hi('close', e), (o = r)
                          break
                        case 'iframe':
                        case 'object':
                        case 'embed':
                          Hi('load', e), (o = r)
                          break
                        case 'video':
                        case 'audio':
                          for (o = 0; o < Ai.length; o++) Hi(Ai[o], e)
                          o = r
                          break
                        case 'source':
                          Hi('error', e), (o = r)
                          break
                        case 'img':
                        case 'image':
                        case 'link':
                          Hi('error', e), Hi('load', e), (o = r)
                          break
                        case 'details':
                          Hi('toggle', e), (o = r)
                          break
                        case 'input':
                          ft(e, r), (o = dt(e, r)), Hi('invalid', e)
                          break
                        case 'option':
                        default:
                          o = r
                          break
                        case 'select':
                          ;(e._wrapperState = { wasMultiple: !!r.multiple }),
                            (o = tt({}, r, { value: void 0 })),
                            Hi('invalid', e)
                          break
                        case 'textarea':
                          wt(e, r), (o = bt(e, r)), Hi('invalid', e)
                      }
                      for (s in (Rt(n, o), (l = o)))
                        l.hasOwnProperty(s) &&
                          ((i = l[s]),
                          'style' === s
                            ? Mt(e, i)
                            : 'dangerouslySetInnerHTML' === s
                            ? null != (i = i ? i.__html : void 0) && Pt(e, i)
                            : 'children' === s
                            ? 'string' == typeof i
                              ? ('textarea' === n && '' === i) || _t(e, i)
                              : 'number' == typeof i && _t(e, '' + i)
                            : 'suppressContentEditableWarning' !== s &&
                              'suppressHydrationWarning' !== s &&
                              'autoFocus' !== s &&
                              (Pe.hasOwnProperty(s)
                                ? null != i && 'onScroll' === s && Hi('scroll', e)
                                : null != i && Ne(e, s, i, a)))
                      switch (n) {
                        case 'input':
                          st(e), gt(e, r, !1)
                          break
                        case 'textarea':
                          st(e), xt(e)
                          break
                        case 'option':
                          null != r.value && e.setAttribute('value', '' + at(r.value))
                          break
                        case 'select':
                          ;(e.multiple = !!r.multiple),
                            null != (s = r.value)
                              ? yt(e, !!r.multiple, s, !1)
                              : null != r.defaultValue && yt(e, !!r.multiple, r.defaultValue, !0)
                          break
                        default:
                          'function' == typeof o.onClick && (e.onclick = eo)
                      }
                      switch (n) {
                        case 'button':
                        case 'input':
                        case 'select':
                        case 'textarea':
                          r = !!r.autoFocus
                          break e
                        case 'img':
                          r = !0
                          break e
                        default:
                          r = !1
                      }
                    }
                    r && (t.flags |= 4)
                  }
                  null !== t.ref && ((t.flags |= 512), (t.flags |= 2097152))
                }
                return Hs(t), null
              case 6:
                if (e && null != t.stateNode) Ws(0, t, e.memoizedProps, r)
                else {
                  if ('string' != typeof r && null === t.stateNode) throw Error(Oe(166))
                  if (((n = rl(nl.current)), rl(el.current), fa(t))) {
                    if (
                      ((r = t.stateNode),
                      (n = t.memoizedProps),
                      (r[ho] = t),
                      (s = r.nodeValue !== n) && null !== (e = ra))
                    )
                      switch (e.tag) {
                        case 3:
                          Ji(r.nodeValue, n, 0 != (1 & e.mode))
                          break
                        case 5:
                          !0 !== e.memoizedProps.suppressHydrationWarning && Ji(r.nodeValue, n, 0 != (1 & e.mode))
                      }
                    s && (t.flags |= 4)
                  } else ((r = (9 === n.nodeType ? n : n.ownerDocument).createTextNode(r))[ho] = t).stateNode = r
                }
                return Hs(t), null
              case 13:
                if (
                  (ko(sl),
                  (r = t.memoizedState),
                  null === e || (null !== e.memoizedState && null !== e.memoizedState.dehydrated))
                ) {
                  if (oa && null !== ia && 0 != (1 & t.mode) && 0 == (128 & t.flags))
                    ha(), pa(), (t.flags |= 98560), (s = !1)
                  else if (((s = fa(t)), null !== r && null !== r.dehydrated)) {
                    if (null === e) {
                      if (!s) throw Error(Oe(318))
                      if (!(s = null !== (s = t.memoizedState) ? s.dehydrated : null)) throw Error(Oe(317))
                      s[ho] = t
                    } else pa(), 0 == (128 & t.flags) && (t.memoizedState = null), (t.flags |= 4)
                    Hs(t), (s = !1)
                  } else null !== aa && (qc(aa), (aa = null)), (s = !0)
                  if (!s) return 65536 & t.flags ? t : null
                }
                return 0 != (128 & t.flags)
                  ? ((t.lanes = n), t)
                  : ((r = null !== r) != (null !== e && null !== e.memoizedState) &&
                      r &&
                      ((t.child.flags |= 8192), 0 != (1 & t.mode)) &&
                      (null === e || 0 != (1 & sl.current) ? 0 === Ec && (Ec = 3) : iu()),
                    null !== t.updateQueue && (t.flags |= 4),
                    Hs(t),
                    null)
              case 4:
                return ol(), null === e && Wi(t.stateNode.containerInfo), Hs(t), null
              case 10:
                return Ea(t.type._context), Hs(t), null
              case 19:
                if ((ko(sl), null === (s = t.memoizedState)));
                else {
                  if (((r = 0 != (128 & t.flags)), null === (a = s.rendering)))
                    if (r) Fs(s, !1)
                    else {
                      if (0 !== Ec || (null !== e && 0 != (128 & e.flags)))
                        for (e = t.child; null !== e; ) {
                          if (null !== (a = cl(e))) {
                            for (
                              t.flags |= 128,
                                Fs(s, !1),
                                null !== (r = a.updateQueue) && ((t.updateQueue = r), (t.flags |= 4)),
                                t.subtreeFlags = 0,
                                r = n,
                                n = t.child;
                              null !== n;

                            )
                              (e = r),
                                ((s = n).flags &= 14680066),
                                null === (a = s.alternate)
                                  ? ((s.childLanes = 0),
                                    (s.lanes = e),
                                    (s.child = null),
                                    (s.subtreeFlags = 0),
                                    (s.memoizedProps = null),
                                    (s.memoizedState = null),
                                    (s.updateQueue = null),
                                    (s.dependencies = null),
                                    (s.stateNode = null))
                                  : ((s.childLanes = a.childLanes),
                                    (s.lanes = a.lanes),
                                    (s.child = a.child),
                                    (s.subtreeFlags = 0),
                                    (s.deletions = null),
                                    (s.memoizedProps = a.memoizedProps),
                                    (s.memoizedState = a.memoizedState),
                                    (s.updateQueue = a.updateQueue),
                                    (s.type = a.type),
                                    (e = a.dependencies),
                                    (s.dependencies =
                                      null === e ? null : { lanes: e.lanes, firstContext: e.firstContext })),
                                (n = n.sibling)
                            return Po(sl, (1 & sl.current) | 2), t.child
                          }
                          e = e.sibling
                        }
                      null !== s.tail && fn() > Ic && ((t.flags |= 128), Fs(s, !(r = !0)), (t.lanes = 4194304))
                    }
                  else {
                    if (!r)
                      if (null !== (e = cl(a))) {
                        if (
                          ((t.flags |= 128),
                          (r = !0),
                          null !== (n = e.updateQueue) && ((t.updateQueue = n), (t.flags |= 4)),
                          Fs(s, !0),
                          null === s.tail && 'hidden' === s.tailMode && !a.alternate && !oa)
                        )
                          return Hs(t), null
                      } else
                        2 * fn() - s.renderingStartTime > Ic &&
                          1073741824 !== n &&
                          ((t.flags |= 128), Fs(s, !(r = !0)), (t.lanes = 4194304))
                    s.isBackwards
                      ? ((a.sibling = t.child), (t.child = a))
                      : (null !== (n = s.last) ? (n.sibling = a) : (t.child = a), (s.last = a))
                  }
                  if (null !== s.tail)
                    return (
                      (t = s.tail),
                      (s.rendering = t),
                      (s.tail = t.sibling),
                      (s.renderingStartTime = fn()),
                      (t.sibling = null),
                      (n = sl.current),
                      Po(sl, r ? (1 & n) | 2 : 1 & n),
                      t
                    )
                }
                return Hs(t), null
              case 22:
              case 23:
                return (
                  eu(),
                  (r = null !== t.memoizedState),
                  null !== e && (null !== e.memoizedState) !== r && (t.flags |= 8192),
                  r && 0 != (1 & t.mode)
                    ? 0 != (1073741824 & Cc) && (Hs(t), 6 & t.subtreeFlags) && (t.flags |= 8192)
                    : Hs(t),
                  null
                )
              case 24:
              case 25:
                return null
            }
            throw Error(Oe(156, t.tag))
          })(n, t, Cc))
        )
          return void (bc = n)
      } else {
        if (
          null !==
          (n = (function (e, t) {
            switch ((na(t), t.tag)) {
              case 1:
                return jo(t.type) && Ro(), 65536 & (e = t.flags) ? ((t.flags = (-65537 & e) | 128), t) : null
              case 3:
                return (
                  ol(),
                  ko(To),
                  ko(Lo),
                  dl(),
                  0 != (65536 & (e = t.flags)) && 0 == (128 & e) ? ((t.flags = (-65537 & e) | 128), t) : null
                )
              case 5:
                return ll(t), null
              case 13:
                if ((ko(sl), null !== (e = t.memoizedState) && null !== e.dehydrated)) {
                  if (null === t.alternate) throw Error(Oe(340))
                  pa()
                }
                return 65536 & (e = t.flags) ? ((t.flags = (-65537 & e) | 128), t) : null
              case 19:
                return ko(sl), null
              case 4:
                return ol(), null
              case 10:
                return Ea(t.type._context), null
              case 22:
              case 23:
                return eu(), null
              default:
                return null
            }
          })(n, t))
        )
          return (n.flags &= 32767), void (bc = n)
        if (null === e) return (Ec = 6), void (bc = null)
        ;(e.flags |= 32768), (e.subtreeFlags = 0), (e.deletions = null)
      }
      if (null !== (t = t.sibling)) return void (bc = t)
    } while (((bc = t = e), null !== t))
    0 === Ec && (Ec = 5)
  }
  function su(e, t, n) {
    var r = jn,
      i = mc.transition
    try {
      ;(mc.transition = null), (jn = 1)
      for (var o = e, a = t, l = n, s = r; cu(), null !== zc; );
      if (0 != (6 & vc)) throw Error(Oe(327))
      l = o.finishedWork
      var c = o.finishedLanes
      if (null !== l) {
        if (((o.finishedWork = null), (o.finishedLanes = 0), l === o.current)) throw Error(Oe(177))
        ;(o.callbackNode = null), (o.callbackPriority = 0)
        var u,
          d,
          f = l.lanes | l.childLanes
        if (
          ((function (e, t) {
            var n = e.pendingLanes & ~t,
              r =
                ((e.pendingLanes = t),
                (e.suspendedLanes = 0),
                (e.pingedLanes = 0),
                (e.expiredLanes &= t),
                (e.mutableReadLanes &= t),
                (e.entangledLanes &= t),
                (t = e.entanglements),
                e.eventTimes)
            for (e = e.expirationTimes; 0 < n; ) {
              var i = 31 - Cn(n),
                o = 1 << i
              ;(t[i] = 0), (r[i] = -1), (e[i] = -1), (n &= ~o)
            }
          })(o, f),
          o === yc && ((bc = yc = null), (wc = 0)),
          (0 == (2064 & l.subtreeFlags) && 0 == (2064 & l.flags)) ||
            Ac ||
            ((Ac = !0),
            hu(mn, function () {
              return cu(), null
            })),
          (f = 0 != (15990 & l.flags)),
          0 != (15990 & l.subtreeFlags) || f
            ? ((f = mc.transition),
              (mc.transition = null),
              (u = jn),
              (jn = 1),
              (d = vc),
              (vc |= 4),
              (gc.current = null),
              (function (e, t) {
                if (((to = ir), gi((e = pi())))) {
                  if ('selectionStart' in e) var n = { start: e.selectionStart, end: e.selectionEnd }
                  else
                    e: if (
                      (o = (n = ((n = e.ownerDocument) && n.defaultView) || window).getSelection && n.getSelection()) &&
                      0 !== o.rangeCount
                    ) {
                      n = o.anchorNode
                      var r = o.anchorOffset,
                        i = o.focusNode,
                        o = o.focusOffset
                      try {
                        n.nodeType, i.nodeType
                      } catch (w) {
                        n = null
                        break e
                      }
                      var a,
                        l = 0,
                        s = -1,
                        c = -1,
                        u = 0,
                        d = 0,
                        f = e,
                        h = null
                      t: for (;;) {
                        for (
                          ;
                          f !== n || (0 !== r && 3 !== f.nodeType) || (s = l + r),
                            f !== i || (0 !== o && 3 !== f.nodeType) || (c = l + o),
                            3 === f.nodeType && (l += f.nodeValue.length),
                            null !== (a = f.firstChild);

                        )
                          (h = f), (f = a)
                        for (;;) {
                          if (f === e) break t
                          if (
                            (h === n && ++u === r && (s = l),
                            h === i && ++d === o && (c = l),
                            null !== (a = f.nextSibling))
                          )
                            break
                          h = (f = h).parentNode
                        }
                        f = a
                      }
                      n = -1 === s || -1 === c ? null : { start: s, end: c }
                    } else n = null
                  n = n || { start: 0, end: 0 }
                } else n = null
                for (ir = !(no = { focusedElem: e, selectionRange: n }), Xs = t; null !== Xs; )
                  if (((e = (t = Xs).child), 0 != (1028 & t.subtreeFlags) && null !== e)) (e.return = t), (Xs = e)
                  else
                    for (; null !== Xs; ) {
                      t = Xs
                      try {
                        var p,
                          g,
                          m,
                          v,
                          y = t.alternate
                        if (0 != (1024 & t.flags))
                          switch (t.tag) {
                            case 0:
                            case 11:
                            case 15:
                            case 5:
                            case 6:
                            case 4:
                            case 17:
                              break
                            case 1:
                              null !== y &&
                                ((p = y.memoizedProps),
                                (g = y.memoizedState),
                                (v = (m = t.stateNode).getSnapshotBeforeUpdate(
                                  t.elementType === t.type ? p : va(t.type, p),
                                  g
                                )),
                                (m.__reactInternalSnapshotBeforeUpdate = v))
                              break
                            case 3:
                              var b = t.stateNode.containerInfo
                              1 === b.nodeType
                                ? (b.textContent = '')
                                : 9 === b.nodeType && b.documentElement && b.removeChild(b.documentElement)
                              break
                            default:
                              throw Error(Oe(163))
                          }
                      } catch (w) {
                        du(t, t.return, w)
                      }
                      if (null !== (e = t.sibling)) {
                        ;(e.return = t.return), (Xs = e)
                        break
                      }
                      Xs = t.return
                    }
                ;(y = $s), ($s = !1)
              })(o, l),
              sc(l, o),
              (function (e) {
                var t,
                  n,
                  r,
                  i = pi(),
                  o = e.focusedElem,
                  a = e.selectionRange
                if (
                  i !== o &&
                  o &&
                  o.ownerDocument &&
                  (function e(t, n) {
                    return (
                      !(!t || !n) &&
                      (t === n ||
                        ((!t || 3 !== t.nodeType) &&
                          (n && 3 === n.nodeType
                            ? e(t, n.parentNode)
                            : 'contains' in t
                            ? t.contains(n)
                            : !!t.compareDocumentPosition && !!(16 & t.compareDocumentPosition(n)))))
                    )
                  })(o.ownerDocument.documentElement, o)
                ) {
                  null !== a &&
                    gi(o) &&
                    ((i = a.start),
                    void 0 === (e = a.end) && (e = i),
                    'selectionStart' in o
                      ? ((o.selectionStart = i), (o.selectionEnd = Math.min(e, o.value.length)))
                      : (e = ((i = o.ownerDocument || document) && i.defaultView) || window).getSelection &&
                        ((e = e.getSelection()),
                        (n = o.textContent.length),
                        (t = Math.min(a.start, n)),
                        (a = void 0 === a.end ? t : Math.min(a.end, n)),
                        !e.extend && a < t && ((n = a), (a = t), (t = n)),
                        (n = hi(o, t)),
                        (r = hi(o, a)),
                        n) &&
                        r &&
                        (1 !== e.rangeCount ||
                          e.anchorNode !== n.node ||
                          e.anchorOffset !== n.offset ||
                          e.focusNode !== r.node ||
                          e.focusOffset !== r.offset) &&
                        ((i = i.createRange()).setStart(n.node, n.offset),
                        e.removeAllRanges(),
                        a < t
                          ? (e.addRange(i), e.extend(r.node, r.offset))
                          : (i.setEnd(r.node, r.offset), e.addRange(i)))),
                    (i = [])
                  for (e = o; (e = e.parentNode); )
                    1 === e.nodeType && i.push({ element: e, left: e.scrollLeft, top: e.scrollTop })
                  for ('function' == typeof o.focus && o.focus(), o = 0; o < i.length; o++)
                    ((e = i[o]).element.scrollLeft = e.left), (e.element.scrollTop = e.top)
                }
              })(no),
              (ir = !!to),
              (no = to = null),
              (function (e) {
                !(function e(t, n, r) {
                  for (var i = 0 != (1 & t.mode); null !== Xs; ) {
                    var o = Xs,
                      a = o.child
                    if (22 === o.tag && i) {
                      var l = null !== o.memoizedState || Gs
                      if (!l) {
                        var s = o.alternate,
                          c = (null !== s && null !== s.memoizedState) || Zs,
                          u = ((s = Gs), Zs)
                        if (((Gs = l), (Zs = c) && !u))
                          for (Xs = o; null !== Xs; )
                            (c = (l = Xs).child),
                              (22 === l.tag && null !== l.memoizedState) || null === c
                                ? fc(o)
                                : ((c.return = l), (Xs = c))
                        for (; null !== a; ) e((Xs = a)), (a = a.sibling)
                        ;(Xs = o), (Gs = s), (Zs = u)
                      }
                      uc(t)
                    } else 0 != (8772 & o.subtreeFlags) && null !== a ? ((a.return = o), (Xs = a)) : uc(t)
                  }
                })((Xs = e))
              })((o.current = l)),
              dn(),
              (vc = d),
              (jn = u),
              (mc.transition = f))
            : (o.current = l),
          Ac && ((Ac = !1), (zc = o), (Nc = c)),
          0 === (f = o.pendingLanes) && (Dc = null),
          (function (e) {
            if (wn && 'function' == typeof wn.onCommitFiberRoot)
              try {
                wn.onCommitFiberRoot(bn, e, void 0, 128 == (128 & e.current.flags))
              } catch (t) {}
          })(l.stateNode),
          Uc(o, fn()),
          null !== a)
        )
          for (s = o.onRecoverableError, l = 0; l < a.length; l++)
            s((c = a[l]).value, { componentStack: c.stack, digest: c.digest })
        if (jc) throw ((jc = !1), (o = Rc), (Rc = null), o)
        0 != (1 & Nc) && 0 !== o.tag && cu(),
          0 != (1 & (f = o.pendingLanes)) ? (o === Hc ? Fc++ : ((Fc = 0), (Hc = o))) : (Fc = 0),
          Wo()
      }
    } finally {
      ;(mc.transition = i), (jn = r)
    }
    return null
  }
  function cu() {
    if (null !== zc) {
      var e = Rn(Nc),
        t = mc.transition,
        n = jn
      try {
        if (((mc.transition = null), (jn = e < 16 ? 16 : e), null === zc)) var r = !1
        else {
          if (((e = zc), (zc = null), (Nc = 0) != (6 & vc))) throw Error(Oe(331))
          var i = vc
          for (vc |= 4, Xs = e.current; null !== Xs; ) {
            var o = Xs,
              a = o.child
            if (0 != (16 & Xs.flags)) {
              var l = o.deletions
              if (null !== l) {
                for (var s = 0; s < l.length; s++) {
                  var c = l[s]
                  for (Xs = c; null !== Xs; ) {
                    switch ((d = Xs).tag) {
                      case 0:
                      case 11:
                      case 15:
                        Ks(8, d, o)
                    }
                    var u = d.child
                    if (null !== u) (u.return = d), (Xs = u)
                    else
                      for (; null !== Xs; ) {
                        var d,
                          f = (d = Xs).sibling,
                          h = d.return
                        if (
                          ((function e(t) {
                            var n = t.alternate
                            null !== n && ((t.alternate = null), e(n)),
                              (t.child = null),
                              (t.deletions = null),
                              (t.sibling = null),
                              5 === t.tag &&
                                null !== (n = t.stateNode) &&
                                (delete n[ho], delete n[po], delete n[mo], delete n[vo], delete n[yo]),
                              (t.stateNode = null),
                              (t.return = null),
                              (t.dependencies = null),
                              (t.memoizedProps = null),
                              (t.memoizedState = null),
                              (t.pendingProps = null),
                              (t.stateNode = null),
                              (t.updateQueue = null)
                          })(d),
                          d === c)
                        ) {
                          Xs = null
                          break
                        }
                        if (null !== f) {
                          ;(f.return = h), (Xs = f)
                          break
                        }
                        Xs = h
                      }
                  }
                }
                var p = o.alternate
                if (null !== p) {
                  var g = p.child
                  if (null !== g) {
                    p.child = null
                    do {
                      var m = g.sibling
                    } while ((g.sibling = null) !== (g = m))
                  }
                }
                Xs = o
              }
            }
            if (0 != (2064 & o.subtreeFlags) && null !== a) (a.return = o), (Xs = a)
            else
              for (; null !== Xs; ) {
                if (0 != (2048 & (o = Xs).flags))
                  switch (o.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Ks(9, o, o.return)
                  }
                var v = o.sibling
                if (null !== v) {
                  ;(v.return = o.return), (Xs = v)
                  break
                }
                Xs = o.return
              }
          }
          var y = e.current
          for (Xs = y; null !== Xs; ) {
            var b = (a = Xs).child
            if (0 != (2064 & a.subtreeFlags) && null !== b) (b.return = a), (Xs = b)
            else
              for (a = y; null !== Xs; ) {
                if (0 != (2048 & (l = Xs).flags))
                  try {
                    switch (l.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Qs(9, l)
                    }
                  } catch (C) {
                    du(l, l.return, C)
                  }
                if (l === a) {
                  Xs = null
                  break
                }
                var w = l.sibling
                if (null !== w) {
                  ;(w.return = l.return), (Xs = w)
                  break
                }
                Xs = l.return
              }
          }
          if (((vc = i), Wo(), wn && 'function' == typeof wn.onPostCommitFiberRoot))
            try {
              wn.onPostCommitFiberRoot(bn, e)
            } catch (C) {}
          r = !0
        }
        return r
      } finally {
        ;(jn = n), (mc.transition = t)
      }
    }
  }
  function uu(e, t, n) {
    ;(e = Da(e, (t = ds(0, (t = ls(n, t)), 1)), 1)), (t = Wc()), null !== e && (In(e, 1, t), Uc(e, t))
  }
  function du(e, t, n) {
    if (3 === e.tag) uu(e, e, n)
    else
      for (; null !== t; ) {
        if (3 === t.tag) {
          uu(t, e, n)
          break
        }
        if (1 === t.tag) {
          var r = t.stateNode
          if (
            'function' == typeof t.type.getDerivedStateFromError ||
            ('function' == typeof r.componentDidCatch && (null === Dc || !Dc.has(r)))
          ) {
            ;(t = Da(t, (e = fs(t, (e = ls(n, e)), 1)), 1)), (e = Wc()), null !== t && (In(t, 1, e), Uc(t, e))
            break
          }
        }
        t = t.return
      }
  }
  function fu(e, t) {
    0 === t && (0 == (1 & e.mode) ? (t = 1) : ((t = On), 0 == (130023424 & (On <<= 1)) && (On = 4194304)))
    var n = Wc()
    null !== (e = Ta(e, t)) && (In(e, t, n), Uc(e, n))
  }
  function hu(e, t) {
    return sn(e, t)
  }
  function pu(e, t, n, r) {
    ;(this.tag = e),
      (this.key = n),
      (this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null),
      (this.index = 0),
      (this.ref = null),
      (this.pendingProps = t),
      (this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null),
      (this.mode = r),
      (this.subtreeFlags = this.flags = 0),
      (this.deletions = null),
      (this.childLanes = this.lanes = 0),
      (this.alternate = null)
  }
  function gu(e, t, n, r) {
    return new pu(e, t, n, r)
  }
  function mu(e) {
    return (e = e.prototype) && e.isReactComponent
  }
  function vu(e, t) {
    var n = e.alternate
    return (
      null === n
        ? (((n = gu(e.tag, t, e.key, e.mode)).elementType = e.elementType),
          (n.type = e.type),
          (n.stateNode = e.stateNode),
          ((n.alternate = e).alternate = n))
        : ((n.pendingProps = t), (n.type = e.type), (n.flags = 0), (n.subtreeFlags = 0), (n.deletions = null)),
      (n.flags = 14680064 & e.flags),
      (n.childLanes = e.childLanes),
      (n.lanes = e.lanes),
      (n.child = e.child),
      (n.memoizedProps = e.memoizedProps),
      (n.memoizedState = e.memoizedState),
      (n.updateQueue = e.updateQueue),
      (t = e.dependencies),
      (n.dependencies = null === t ? null : { lanes: t.lanes, firstContext: t.firstContext }),
      (n.sibling = e.sibling),
      (n.index = e.index),
      (n.ref = e.ref),
      n
    )
  }
  function yu(e, t, n, r, i, o) {
    var a = 2
    if ('function' == typeof (r = e)) mu(e) && (a = 1)
    else if ('string' == typeof e) a = 5
    else
      e: switch (e) {
        case Be:
          return bu(n.children, i, o, t)
        case Ve:
          i |= a = 8
          break
        case We:
          return ((e = gu(12, n, t, 2 | i)).elementType = We), (e.lanes = o), e
        case Xe:
          return ((e = gu(13, n, t, i)).elementType = Xe), (e.lanes = o), e
        case Ye:
          return ((e = gu(19, n, t, i)).elementType = Ye), (e.lanes = o), e
        case Ke:
          return wu(n, i, o, t)
        default:
          if ('object' == typeof e && null !== e)
            switch (e.$$typeof) {
              case Ge:
                a = 10
                break e
              case Ze:
                a = 9
                break e
              case Ue:
                a = 11
                break e
              case qe:
                a = 14
                break e
              case $e:
                ;(a = 16), (r = null)
                break e
            }
          throw Error(Oe(130, null == e ? e : typeof e, ''))
      }
    return ((t = gu(a, n, t, i)).elementType = e), (t.type = r), (t.lanes = o), t
  }
  function bu(e, t, n, r) {
    return ((e = gu(7, e, r, t)).lanes = n), e
  }
  function wu(e, t, n, r) {
    return ((e = gu(22, e, r, t)).elementType = Ke), (e.lanes = n), (e.stateNode = { isHidden: !1 }), e
  }
  function Cu(e, t, n) {
    return ((e = gu(6, e, null, t)).lanes = n), e
  }
  function xu(e, t, n) {
    return (
      ((t = gu(4, null !== e.children ? e.children : [], e.key, t)).lanes = n),
      (t.stateNode = { containerInfo: e.containerInfo, pendingChildren: null, implementation: e.implementation }),
      t
    )
  }
  function Eu(e, t, n, r, i) {
    ;(this.tag = t),
      (this.containerInfo = e),
      (this.finishedWork = this.pingCache = this.current = this.pendingChildren = null),
      (this.timeoutHandle = -1),
      (this.callbackNode = this.pendingContext = this.context = null),
      (this.callbackPriority = 0),
      (this.eventTimes = Tn(0)),
      (this.expirationTimes = Tn(-1)),
      (this.entangledLanes =
        this.finishedLanes =
        this.mutableReadLanes =
        this.expiredLanes =
        this.pingedLanes =
        this.suspendedLanes =
        this.pendingLanes =
          0),
      (this.entanglements = Tn(0)),
      (this.identifierPrefix = r),
      (this.onRecoverableError = i),
      (this.mutableSourceEagerHydrationData = null)
  }
  function Su(e, t, n, r, i, o, a, l, s) {
    return (
      (e = new Eu(e, t, 0, l, s)),
      1 === t ? ((t = 1), !0 === o && (t |= 8)) : (t = 0),
      (o = gu(3, null, null, t)),
      ((e.current = o).stateNode = e),
      (o.memoizedState = {
        element: r,
        isDehydrated: n,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
      }),
      Ma(o),
      e
    )
  }
  function Ou(e) {
    if (!e) return _o
    e: {
      if (rn((e = e._reactInternals)) !== e || 1 !== e.tag) throw Error(Oe(170))
      var t = e
      do {
        switch (t.tag) {
          case 3:
            t = t.stateNode.context
            break e
          case 1:
            if (jo(t.type)) {
              t = t.stateNode.__reactInternalMemoizedMergedChildContext
              break e
            }
        }
      } while (null !== (t = t.return))
      throw Error(Oe(171))
    }
    if (1 === e.tag) {
      var n = e.type
      if (jo(n)) return Ao(e, n, t)
    }
    return t
  }
  function ku(e, t, n, r, i, o, a, l, s) {
    return (
      ((e = Su(n, r, !0, e, 0, o, 0, l, s)).context = Ou(null)),
      (n = e.current),
      ((o = Ra((r = Wc()), (i = Gc(n)))).callback = null != t ? t : null),
      Da(n, o, i),
      (e.current.lanes = i),
      In(e, i, r),
      Uc(e, r),
      e
    )
  }
  function Pu(e, t, n, r) {
    var i = t.current,
      o = Wc(),
      a = Gc(i)
    ;(n = Ou(n)),
      null === t.context ? (t.context = n) : (t.pendingContext = n),
      ((t = Ra(o, a)).payload = { element: e }),
      null !== (r = void 0 === r ? null : r) && (t.callback = r),
      null !== (e = Da(i, t, a)) && (Zc(e, i, a, o), Aa(e, i, a))
  }
  function _u(e) {
    return (e = e.current).child ? (e.child.tag, e.child.stateNode) : null
  }
  function Lu(e, t) {
    var n
    null !== (e = e.memoizedState) &&
      null !== e.dehydrated &&
      ((n = e.retryLane), (e.retryLane = 0 !== n && n < t ? n : t))
  }
  function Tu(e, t) {
    Lu(e, t), (e = e.alternate) && Lu(e, t)
  }
  var Iu = function (e, t, n) {
      if (null !== e)
        if (e.memoizedProps !== t.pendingProps || To.current) vs = !0
        else {
          if (0 == (e.lanes & n) && 0 == (128 & t.flags)) {
            vs = !1
            var r = e,
              i = t,
              o = n
            switch (i.tag) {
              case 3:
                Ps(i), pa()
                break
              case 5:
                al(i)
                break
              case 1:
                jo(i.type) && zo(i)
                break
              case 4:
                il(i, i.stateNode.containerInfo)
                break
              case 10:
                var a = i.type._context,
                  l = i.memoizedProps.value
                Po(ya, a._currentValue), (a._currentValue = l)
                break
              case 13:
                if (null !== (a = i.memoizedState))
                  return null !== a.dehydrated
                    ? (Po(sl, 1 & sl.current), (i.flags |= 128), null)
                    : 0 != (o & i.child.childLanes)
                    ? Is(r, i, o)
                    : (Po(sl, 1 & sl.current), null !== (r = Ns(r, i, o)) ? r.sibling : null)
                Po(sl, 1 & sl.current)
                break
              case 19:
                if (((a = 0 != (o & i.childLanes)), 0 != (128 & r.flags))) {
                  if (a) return As(r, i, o)
                  i.flags |= 128
                }
                if (
                  (null !== (l = i.memoizedState) && ((l.rendering = null), (l.tail = null), (l.lastEffect = null)),
                  Po(sl, sl.current),
                  a)
                )
                  break
                return null
              case 22:
              case 23:
                return (i.lanes = 0), xs(r, i, o)
            }
            return Ns(r, i, o)
          }
          vs = 0 != (131072 & e.flags)
        }
      else (vs = !1), oa && 0 != (1048576 & t.flags) && ea(t, Xo, t.index)
      switch (((t.lanes = 0), t.tag)) {
        case 2:
          var s = t.type,
            c = (zs(e, t), (e = t.pendingProps), Mo(t, Lo.current)),
            u = (Oa(t, n), (c = Sl(null, t, s, e, c, n)), Ol())
          return (
            (t.flags |= 1),
            'object' == typeof c && null !== c && 'function' == typeof c.render && void 0 === c.$$typeof
              ? ((t.tag = 1),
                (t.memoizedState = null),
                (t.updateQueue = null),
                jo(s) ? ((u = !0), zo(t)) : (u = !1),
                (t.memoizedState = null !== c.state && void 0 !== c.state ? c.state : null),
                Ma(t),
                (c.updater = Va),
                Ua(((t.stateNode = c)._reactInternals = t), s, e, n),
                ks(null, t, s, !0, u, n))
              : ((t.tag = 0), oa && u && ta(t), ys(null, t, c, n), t.child)
          )
        case 16:
          s = t.elementType
          e: {
            switch (
              (zs(e, t),
              (e = t.pendingProps),
              (s = (c = s._init)(s._payload)),
              (t.type = s),
              (c = t.tag =
                (function (e) {
                  if ('function' == typeof e) return mu(e) ? 1 : 0
                  if (null != e) {
                    if ((e = e.$$typeof) === Ue) return 11
                    if (e === qe) return 14
                  }
                  return 2
                })(s)),
              (e = va(s, e)),
              c)
            ) {
              case 0:
                t = Ss(null, t, s, e, n)
                break e
              case 1:
                t = Os(null, t, s, e, n)
                break e
              case 11:
                t = bs(null, t, s, e, n)
                break e
              case 14:
                t = ws(null, t, s, va(s.type, e), n)
                break e
            }
            throw Error(Oe(306, s, ''))
          }
          return t
        case 0:
          return (s = t.type), (c = t.pendingProps), Ss(e, t, s, (c = t.elementType === s ? c : va(s, c)), n)
        case 1:
          return (s = t.type), (c = t.pendingProps), Os(e, t, s, (c = t.elementType === s ? c : va(s, c)), n)
        case 3:
          e: {
            if ((Ps(t), null === e)) throw Error(Oe(387))
            ;(s = t.pendingProps), (c = (u = t.memoizedState).element), ja(e, t), Na(t, s, null, n)
            s = (p = t.memoizedState).element
            if (u.isDehydrated) {
              if (
                ((u = {
                  element: s,
                  isDehydrated: !1,
                  cache: p.cache,
                  pendingSuspenseBoundaries: p.pendingSuspenseBoundaries,
                  transitions: p.transitions
                }),
                (t.updateQueue.baseState = u),
                (t.memoizedState = u),
                256 & t.flags)
              ) {
                t = _s(e, t, s, n, (c = ls(Error(Oe(423)), t)))
                break e
              }
              if (s !== c) {
                t = _s(e, t, s, n, (c = ls(Error(Oe(424)), t)))
                break e
              }
              for (
                ia = uo(t.stateNode.containerInfo.firstChild),
                  oa = !0,
                  n = Qa((ra = t), (aa = null), s, n),
                  t.child = n;
                n;

              )
                (n.flags = (-3 & n.flags) | 4096), (n = n.sibling)
            } else {
              if ((pa(), s === c)) {
                t = Ns(e, t, n)
                break e
              }
              ys(e, t, s, n)
            }
            t = t.child
          }
          return t
        case 5:
          return (
            al(t),
            null === e && ua(t),
            (s = t.type),
            (c = t.pendingProps),
            (u = null !== e ? e.memoizedProps : null),
            (p = c.children),
            ro(s, c) ? (p = null) : null !== u && ro(s, u) && (t.flags |= 32),
            Es(e, t),
            ys(e, t, p, n),
            t.child
          )
        case 6:
          return null === e && ua(t), null
        case 13:
          return Is(e, t, n)
        case 4:
          return (
            il(t, t.stateNode.containerInfo),
            (s = t.pendingProps),
            null === e ? (t.child = Ka(t, null, s, n)) : ys(e, t, s, n),
            t.child
          )
        case 11:
          return (s = t.type), (c = t.pendingProps), bs(e, t, s, (c = t.elementType === s ? c : va(s, c)), n)
        case 7:
          return ys(e, t, t.pendingProps, n), t.child
        case 8:
        case 12:
          return ys(e, t, t.pendingProps.children, n), t.child
        case 10:
          e: {
            if (
              ((s = t.type._context),
              (c = t.pendingProps),
              (u = t.memoizedProps),
              (p = c.value),
              Po(ya, s._currentValue),
              (s._currentValue = p),
              null !== u)
            )
              if (ui(u.value, p)) {
                if (u.children === c.children && !To.current) {
                  t = Ns(e, t, n)
                  break e
                }
              } else
                for (null !== (u = t.child) && (u.return = t); null !== u; ) {
                  var d = u.dependencies
                  if (null !== d)
                    for (var f, h, p = u.child, g = d.firstContext; null !== g; ) {
                      if (g.context === s) {
                        1 === u.tag &&
                          (((g = Ra(-1, n & -n)).tag = 2), null !== (f = u.updateQueue)) &&
                          (null === (h = (f = f.shared).pending) ? (g.next = g) : ((g.next = h.next), (h.next = g)),
                          (f.pending = g)),
                          (u.lanes |= n),
                          null !== (g = u.alternate) && (g.lanes |= n),
                          Sa(u.return, n, t),
                          (d.lanes |= n)
                        break
                      }
                      g = g.next
                    }
                  else if (10 === u.tag) p = u.type === t.type ? null : u.child
                  else if (18 === u.tag) {
                    if (null === (p = u.return)) throw Error(Oe(341))
                    ;(p.lanes |= n), null !== (d = p.alternate) && (d.lanes |= n), Sa(p, n, t), (p = u.sibling)
                  } else p = u.child
                  if (null !== p) p.return = u
                  else
                    for (p = u; null !== p; ) {
                      if (p === t) {
                        p = null
                        break
                      }
                      if (null !== (u = p.sibling)) {
                        ;(u.return = p.return), (p = u)
                        break
                      }
                      p = p.return
                    }
                  u = p
                }
            ys(e, t, c.children, n), (t = t.child)
          }
          return t
        case 9:
          return (
            (c = t.type),
            (s = t.pendingProps.children),
            Oa(t, n),
            (s = s((c = ka(c)))),
            (t.flags |= 1),
            ys(e, t, s, n),
            t.child
          )
        case 14:
          return (c = va((s = t.type), t.pendingProps)), ws(e, t, s, (c = va(s.type, c)), n)
        case 15:
          return Cs(e, t, t.type, t.pendingProps, n)
        case 17:
          return (
            (s = t.type),
            (c = t.pendingProps),
            (c = t.elementType === s ? c : va(s, c)),
            zs(e, t),
            (t.tag = 1),
            jo(s) ? ((e = !0), zo(t)) : (e = !1),
            Oa(t, n),
            Ga(t, s, c),
            Ua(t, s, c, n),
            ks(null, t, s, !0, e, n)
          )
        case 19:
          return As(e, t, n)
        case 22:
          return xs(e, t, n)
      }
      throw Error(Oe(156, t.tag))
    },
    Mu =
      'function' == typeof reportError
        ? reportError
        : function (e) {
            console.error(e)
          }
  function ju(e) {
    this._internalRoot = e
  }
  function Ru(e) {
    this._internalRoot = e
  }
  function Du(e) {
    return e && (1 === e.nodeType || 9 === e.nodeType || 11 === e.nodeType)
  }
  function Au(e) {
    return (
      e &&
      (1 === e.nodeType ||
        9 === e.nodeType ||
        11 === e.nodeType ||
        (8 === e.nodeType && ' react-mount-point-unstable ' === e.nodeValue))
    )
  }
  function zu() {}
  function Nu(e, t, n, r, i) {
    var o,
      a,
      l = n._reactRootContainer
    return (
      l
        ? ('function' == typeof i &&
            ((a = i),
            (i = function () {
              var e = _u(o)
              a.call(e)
            })),
          Pu(t, (o = l), e, i))
        : (o = (function (e, t, n, r, i) {
            var o, a, l
            if (i)
              return (
                'function' == typeof r &&
                  ((o = r),
                  (r = function () {
                    var e = _u(a)
                    o.call(e)
                  })),
                (a = ku(t, r, e, 0, null, !1, 0, '', zu)),
                (e._reactRootContainer = a),
                (e[go] = a.current),
                Wi(8 === e.nodeType ? e.parentNode : e),
                Jc(),
                a
              )
            for (; (i = e.lastChild); ) e.removeChild(i)
            'function' == typeof r &&
              ((l = r),
              (r = function () {
                var e = _u(s)
                l.call(e)
              }))
            var s = Su(e, 0, !1, null, 0, !1, 0, '', zu)
            return (
              (e._reactRootContainer = s),
              (e[go] = s.current),
              Wi(8 === e.nodeType ? e.parentNode : e),
              Jc(function () {
                Pu(t, s, n, r)
              }),
              s
            )
          })(n, t, e, i, r)),
      _u(o)
    )
  }
  ;(Ru.prototype.render = ju.prototype.render =
    function (e) {
      var t = this._internalRoot
      if (null === t) throw Error(Oe(409))
      Pu(e, t, null, null)
    }),
    (Ru.prototype.unmount = ju.prototype.unmount =
      function () {
        var e,
          t = this._internalRoot
        null !== t &&
          ((this._internalRoot = null),
          (e = t.containerInfo),
          Jc(function () {
            Pu(null, t, null, null)
          }),
          (e[go] = null))
      }),
    (Ru.prototype.unstable_scheduleHydration = function (e) {
      if (e) {
        var t = Nn()
        e = { blockedOn: null, target: e, priority: t }
        for (var n = 0; n < Xn.length && 0 !== t && t < Xn[n].priority; n++);
        Xn.splice(n, 0, e), 0 === n && Kn(e)
      }
    }),
    (Dn = function (e) {
      switch (e.tag) {
        case 3:
          var t,
            n = e.stateNode
          n.current.memoizedState.isDehydrated &&
            0 !== (t = kn(n.pendingLanes)) &&
            (Mn(n, 1 | t), Uc(n, fn()), 0 == (6 & vc)) &&
            ((Ic = fn() + 500), Wo())
          break
        case 13:
          Jc(function () {
            var t,
              n = Ta(e, 1)
            null !== n && ((t = Wc()), Zc(n, e, 1, t))
          }),
            Tu(e, 1)
      }
    }),
    (An = function (e) {
      var t
      13 === e.tag && (null !== (t = Ta(e, 134217728)) && Zc(t, e, 134217728, Wc()), Tu(e, 134217728))
    }),
    (zn = function (e) {
      var t, n
      13 === e.tag && (null !== (n = Ta(e, (t = Gc(e)))) && Zc(n, e, t, Wc()), Tu(e, t))
    }),
    (Nn = function () {
      return jn
    }),
    (Fn = function (e, t) {
      var n = jn
      try {
        return (jn = e), t()
      } finally {
        jn = n
      }
    }),
    (Zt = Jc)
  var Fu
  ;(h = {
    usingClientEntryPoint: !(Nt = function (e, t, n) {
      switch (t) {
        case 'input':
          if ((pt(e, n), (t = n.name), 'radio' === n.type && null != t)) {
            for (n = e; n.parentNode; ) n = n.parentNode
            for (
              n = n.querySelectorAll('input[name=' + JSON.stringify('' + t) + '][type="radio"]'), t = 0;
              t < n.length;
              t++
            ) {
              var r = n[t]
              if (r !== e && r.form === e.form) {
                var i = xo(r)
                if (!i) throw Error(Oe(90))
                ct(r), pt(r, i)
              }
            }
          }
          break
        case 'textarea':
          Ct(e, n)
          break
        case 'select':
          null != (t = n.value) && yt(e, !!n.multiple, t, !1)
      }
    }),
    Events: [wo, Co, xo, Vt, Wt, (Gt = Qc)]
  }),
    (ce = {
      bundleType: (p = {
        findFiberByHostInstance: bo,
        bundleType: 0,
        version: '18.2.0',
        rendererPackageName: 'react-dom'
      }).bundleType,
      version: p.version,
      rendererPackageName: p.rendererPackageName,
      rendererConfig: p.rendererConfig,
      overrideHookState: null,
      overrideHookStateDeletePath: null,
      overrideHookStateRenamePath: null,
      overrideProps: null,
      overridePropsDeletePath: null,
      overridePropsRenamePath: null,
      setErrorHandler: null,
      setSuspenseHandler: null,
      scheduleUpdate: null,
      currentDispatcherRef: c.ReactCurrentDispatcher,
      findHostInstanceByFiber: function (e) {
        return null === (e = ln(e)) ? null : e.stateNode
      },
      findFiberByHostInstance:
        p.findFiberByHostInstance ||
        function () {
          return null
        },
      findHostInstancesForRefresh: null,
      scheduleRefresh: null,
      scheduleRoot: null,
      setRefreshHandler: null,
      getCurrentFiber: null,
      reconcilerVersion: '18.2.0-next-9e3b772b8-20220608'
    })
  if (
    'undefined' != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ &&
    !($t = __REACT_DEVTOOLS_GLOBAL_HOOK__).isDisabled &&
    $t.supportsFiber
  )
    try {
      ;(bn = $t.inject(ce)), (wn = $t)
    } catch (sD) {}
  function Hu(e, t) {
    if (null == e) return {}
    var n,
      r = (function (e, t) {
        if (null == e) return {}
        for (var n, r = {}, i = Object.keys(e), o = 0; o < i.length; o++) (n = i[o]), 0 <= t.indexOf(n) || (r[n] = e[n])
        return r
      })(e, t)
    if (Object.getOwnPropertySymbols)
      for (var i = Object.getOwnPropertySymbols(e), o = 0; o < i.length; o++)
        (n = i[o]), 0 <= t.indexOf(n) || (Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]))
    return r
  }
  function Bu() {}
  function Vu() {}
  function Wu(e, t, n, r, i, o) {
    if ('SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED' !== o)
      throw (
        (((o = new Error(
          'Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types'
        )).name = 'Invariant Violation'),
        o)
      )
  }
  function Gu() {
    return Wu
  }
  ;(f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = h),
    (f.createPortal = function (e, t) {
      if (Du(t))
        return (function (e, t, n, r) {
          return {
            $$typeof: He,
            key: null == (r = 3 < arguments.length && void 0 !== r ? r : null) ? null : '' + r,
            children: e,
            containerInfo: t,
            implementation: n
          }
        })(e, t, null, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null)
      throw Error(Oe(200))
    }),
    (f.createRoot = function (e, t) {
      var n, r, i
      if (Du(e))
        return (
          (n = !1),
          (r = ''),
          (i = Mu),
          null != t &&
            (!0 === t.unstable_strictMode && (n = !0),
            void 0 !== t.identifierPrefix && (r = t.identifierPrefix),
            void 0 !== t.onRecoverableError) &&
            (i = t.onRecoverableError),
          (t = Su(e, 1, !1, null, 0, n, 0, r, i)),
          (e[go] = t.current),
          Wi(8 === e.nodeType ? e.parentNode : e),
          new ju(t)
        )
      throw Error(Oe(299))
    }),
    (f.findDOMNode = function (e) {
      if (null == e) return null
      if (1 !== e.nodeType) {
        var t = e._reactInternals
        if (void 0 === t) {
          if ('function' == typeof e.render) throw Error(Oe(188))
          throw ((e = Object.keys(e).join(',')), Error(Oe(268, e)))
        }
        e = null === (e = ln(t)) ? null : e.stateNode
      }
      return e
    }),
    (f.flushSync = Jc),
    (f.hydrate = function (e, t, n) {
      if (Au(t)) return Nu(null, e, t, !0, n)
      throw Error(Oe(200))
    }),
    (f.hydrateRoot = function (e, t, n) {
      if (!Du(e)) throw Error(Oe(405))
      var r = (null != n && n.hydratedSources) || null,
        i = !1,
        o = '',
        a = Mu
      if (
        (null != n &&
          (!0 === n.unstable_strictMode && (i = !0),
          void 0 !== n.identifierPrefix && (o = n.identifierPrefix),
          void 0 !== n.onRecoverableError) &&
          (a = n.onRecoverableError),
        (t = ku(t, null, e, 1, null != n ? n : null, i, 0, o, a)),
        (e[go] = t.current),
        Wi(e),
        r)
      )
        for (e = 0; e < r.length; e++)
          (i = (i = (n = r[e])._getVersion)(n._source)),
            null == t.mutableSourceEagerHydrationData
              ? (t.mutableSourceEagerHydrationData = [n, i])
              : t.mutableSourceEagerHydrationData.push(n, i)
      return new Ru(t)
    }),
    (f.render = function (e, t, n) {
      if (Au(t)) return Nu(null, e, t, !1, n)
      throw Error(Oe(200))
    }),
    (f.unmountComponentAtNode = function (e) {
      if (Au(e))
        return (
          !!e._reactRootContainer &&
          (Jc(function () {
            Nu(null, null, e, !1, function () {
              ;(e._reactRootContainer = null), (e[go] = null)
            })
          }),
          !0)
        )
      throw Error(Oe(40))
    }),
    (f.unstable_batchedUpdates = Qc),
    (f.unstable_renderSubtreeIntoContainer = function (e, t, n, r) {
      if (!Au(n)) throw Error(Oe(200))
      if (null == e || void 0 === e._reactInternals) throw Error(Oe(38))
      return Nu(e, t, n, !1, r)
    }),
    (f.version = '18.2.0-next-9e3b772b8-20220608'),
    (function e() {
      if (
        'undefined' != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ &&
        'function' == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE
      )
        try {
          __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e)
        } catch (t) {
          console.error(t)
        }
    })(),
    (de.exports = f),
    (y = de.exports),
    (Fu = y.createRoot),
    y.hydrateRoot,
    (c = { exports: {} }),
    (Vu.resetWarningCache = Bu),
    (c.exports = (p = {
      array: (Wu.isRequired = Wu),
      bigint: Wu,
      bool: Wu,
      func: Wu,
      number: Wu,
      object: Wu,
      string: Wu,
      symbol: Wu,
      any: Wu,
      arrayOf: Gu,
      element: Wu,
      elementType: Wu,
      instanceOf: Gu,
      node: Wu,
      objectOf: Gu,
      oneOf: Gu,
      oneOfType: Gu,
      shape: Gu,
      exact: Gu,
      checkPropTypes: Vu,
      resetWarningCache: Bu
    }).PropTypes =
      p)
  ce = c.exports
  var Zu = { exports: {} },
    Uu = (($t = {}), (h = 'function' == typeof Symbol && Symbol.for) ? Symbol.for('react.element') : 60103),
    Xu = h ? Symbol.for('react.portal') : 60106,
    Yu = h ? Symbol.for('react.fragment') : 60107,
    qu = h ? Symbol.for('react.strict_mode') : 60108,
    $u = h ? Symbol.for('react.profiler') : 60114,
    Ku = h ? Symbol.for('react.provider') : 60109,
    Qu = h ? Symbol.for('react.context') : 60110,
    Ju = h ? Symbol.for('react.async_mode') : 60111,
    ed = h ? Symbol.for('react.concurrent_mode') : 60111,
    td = h ? Symbol.for('react.forward_ref') : 60112,
    nd = h ? Symbol.for('react.suspense') : 60113,
    rd = h ? Symbol.for('react.suspense_list') : 60120,
    id = h ? Symbol.for('react.memo') : 60115,
    od = h ? Symbol.for('react.lazy') : 60116,
    ad = h ? Symbol.for('react.block') : 60121,
    ld = h ? Symbol.for('react.fundamental') : 60117,
    sd = h ? Symbol.for('react.responder') : 60118,
    cd = h ? Symbol.for('react.scope') : 60119
  function ud(e) {
    if ('object' == typeof e && null !== e) {
      var t = e.$$typeof
      switch (t) {
        case Uu:
          switch ((e = e.type)) {
            case Ju:
            case ed:
            case Yu:
            case $u:
            case qu:
            case nd:
              return e
            default:
              switch ((e = e && e.$$typeof)) {
                case Qu:
                case td:
                case od:
                case id:
                case Ku:
                  return e
                default:
                  return t
              }
          }
        case Xu:
          return t
      }
    }
  }
  function dd(e) {
    return ud(e) === ed
  }
  ;($t.AsyncMode = Ju),
    ($t.ConcurrentMode = ed),
    ($t.ContextConsumer = Qu),
    ($t.ContextProvider = Ku),
    ($t.Element = Uu),
    ($t.ForwardRef = td),
    ($t.Fragment = Yu),
    ($t.Lazy = od),
    ($t.Memo = id),
    ($t.Portal = Xu),
    ($t.Profiler = $u),
    ($t.StrictMode = qu),
    ($t.Suspense = nd),
    ($t.isAsyncMode = function (e) {
      return dd(e) || ud(e) === Ju
    }),
    ($t.isConcurrentMode = dd),
    ($t.isContextConsumer = function (e) {
      return ud(e) === Qu
    }),
    ($t.isContextProvider = function (e) {
      return ud(e) === Ku
    }),
    ($t.isElement = function (e) {
      return 'object' == typeof e && null !== e && e.$$typeof === Uu
    }),
    ($t.isForwardRef = function (e) {
      return ud(e) === td
    }),
    ($t.isFragment = function (e) {
      return ud(e) === Yu
    }),
    ($t.isLazy = function (e) {
      return ud(e) === od
    }),
    ($t.isMemo = function (e) {
      return ud(e) === id
    }),
    ($t.isPortal = function (e) {
      return ud(e) === Xu
    }),
    ($t.isProfiler = function (e) {
      return ud(e) === $u
    }),
    ($t.isStrictMode = function (e) {
      return ud(e) === qu
    }),
    ($t.isSuspense = function (e) {
      return ud(e) === nd
    }),
    ($t.isValidElementType = function (e) {
      return (
        'string' == typeof e ||
        'function' == typeof e ||
        e === Yu ||
        e === ed ||
        e === $u ||
        e === qu ||
        e === nd ||
        e === rd ||
        ('object' == typeof e &&
          null !== e &&
          (e.$$typeof === od ||
            e.$$typeof === id ||
            e.$$typeof === Ku ||
            e.$$typeof === Qu ||
            e.$$typeof === td ||
            e.$$typeof === ld ||
            e.$$typeof === sd ||
            e.$$typeof === cd ||
            e.$$typeof === ad))
      )
    }),
    ($t.typeOf = ud),
    (Zu.exports = $t)
  var fd = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
  }
  var hd,
    pd,
    gd =
      /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
    md =
      ((hd = function (e) {
        return gd.test(e) || (111 === e.charCodeAt(0) && 110 === e.charCodeAt(1) && e.charCodeAt(2) < 91)
      }),
      (pd = Object.create(null)),
      function (e) {
        return void 0 === pd[e] && (pd[e] = hd(e)), pd[e]
      }),
    vd = Zu.exports,
    yd = {
      childContextTypes: !0,
      contextType: !0,
      contextTypes: !0,
      defaultProps: !0,
      displayName: !0,
      getDefaultProps: !0,
      getDerivedStateFromError: !0,
      getDerivedStateFromProps: !0,
      mixins: !0,
      propTypes: !0,
      type: !0
    },
    bd = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 },
    wd = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 },
    Cd = {}
  function xd(e) {
    return vd.isMemo(e) ? wd : Cd[e.$$typeof] || yd
  }
  ;(Cd[vd.ForwardRef] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }),
    (Cd[vd.Memo] = wd)
  var Ed = Object.defineProperty,
    Sd = Object.getOwnPropertyNames,
    Od = Object.getOwnPropertySymbols,
    kd = Object.getOwnPropertyDescriptor,
    Pd = Object.getPrototypeOf,
    _d = Object.prototype,
    Ld = function e(t, n, r) {
      if ('string' != typeof n) {
        _d && (i = Pd(n)) && i !== _d && e(t, i, r)
        for (var i, o = Sd(n), a = (Od && (o = o.concat(Od(n))), xd(t)), l = xd(n), s = 0; s < o.length; ++s) {
          var c = o[s]
          if (!(bd[c] || (r && r[c]) || (l && l[c]) || (a && a[c]))) {
            var u = kd(n, c)
            try {
              Ed(t, c, u)
            } catch (d) {}
          }
        }
      }
      return t
    }
  function Td() {
    return (Td =
      Object.assign ||
      function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n,
            r = arguments[t]
          for (n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
        }
        return e
      }).apply(this, arguments)
  }
  var Id = function (e, t) {
      for (var n = [e[0]], r = 0, i = t.length; r < i; r += 1) n.push(t[r], e[r + 1])
      return n
    },
    Md = function (e) {
      return (
        null !== e &&
        'object' == typeof e &&
        '[object Object]' === (e.toString ? e.toString() : Object.prototype.toString.call(e)) &&
        !Zu.exports.typeOf(e)
      )
    },
    jd = Object.freeze([]),
    Rd = Object.freeze({})
  function Dd(e) {
    return 'function' == typeof e
  }
  function Ad(e) {
    return e.displayName || e.name || 'Component'
  }
  function zd(e) {
    return e && 'string' == typeof e.styledComponentId
  }
  var Nd = ('undefined' != typeof process && ({}.REACT_APP_SC_ATTR || {}.SC_ATTR)) || 'data-styled',
    Fd = 'undefined' != typeof window && 'HTMLElement' in window,
    Hd =
      ((f = Boolean(
        'boolean' == typeof SC_DISABLE_SPEEDY
          ? SC_DISABLE_SPEEDY
          : 'undefined' != typeof process &&
            void 0 !== {}.REACT_APP_SC_DISABLE_SPEEDY &&
            '' !== {}.REACT_APP_SC_DISABLE_SPEEDY
          ? 'false' !== {}.REACT_APP_SC_DISABLE_SPEEDY && {}.REACT_APP_SC_DISABLE_SPEEDY
          : 'undefined' != typeof process &&
            void 0 !== {}.SC_DISABLE_SPEEDY &&
            '' !== {}.SC_DISABLE_SPEEDY &&
            'false' !== {}.SC_DISABLE_SPEEDY &&
            {}.SC_DISABLE_SPEEDY
      )),
      {})
  function Bd(e) {
    for (var t = arguments.length, n = new Array(1 < t ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r]
    throw new Error(
      'An error occurred. See https://git.io/JUIaE#' +
        e +
        ' for more information.' +
        (0 < n.length ? ' Args: ' + n.join(', ') : '')
    )
  }
  function Vd(e) {
    if (Ud.has(e)) return Ud.get(e)
    for (; Xd.has(Yd); ) Yd++
    var t = Yd++
    return Ud.set(e, t), Xd.set(t, e), t
  }
  function Wd(e) {
    var t = document.head,
      n = e || t,
      r =
        ((e = document.createElement('style')),
        (t =
          void 0 !==
          (t = (function () {
            for (var e = n.childNodes, t = e.length; 0 <= t; t--) {
              var r = e[t]
              if (r && 1 === r.nodeType && r.hasAttribute(Nd)) return r
            }
          })())
            ? t.nextSibling
            : null),
        e.setAttribute(Nd, 'active'),
        e.setAttribute('data-styled-version', '5.3.5'),
        Jd())
    return r && e.setAttribute('nonce', r), n.insertBefore(e, t), e
  }
  function Gd(e) {
    return String.fromCharCode(e + (25 < e ? 39 : 97))
  }
  ;((y = ff.prototype).indexOfGroup = function (e) {
    for (var t = 0, n = 0; n < e; n++) t += this.groupSizes[n]
    return t
  }),
    (y.insertRules = function (e, t) {
      if (e >= this.groupSizes.length) {
        for (var n = this.groupSizes, r = n.length, i = r; i <= e; ) (i <<= 1) < 0 && Bd(16, '' + e)
        ;(this.groupSizes = new Uint32Array(i)), this.groupSizes.set(n), (this.length = i)
        for (var o = r; o < i; o++) this.groupSizes[o] = 0
      }
      for (var a = this.indexOfGroup(e + 1), l = 0, s = t.length; l < s; l++)
        this.tag.insertRule(a, t[l]) && (this.groupSizes[e]++, a++)
    }),
    (y.clearGroup = function (e) {
      if (e < this.length) {
        var t = this.groupSizes[e],
          n = this.indexOfGroup(e),
          r = n + t
        this.groupSizes[e] = 0
        for (var i = n; i < r; i++) this.tag.deleteRule(n)
      }
    }),
    (y.getGroup = function (e) {
      var t = ''
      if (!(e >= this.length || 0 === this.groupSizes[e]))
        for (var n = this.groupSizes[e], r = (e = this.indexOfGroup(e)) + n, i = e; i < r; i++)
          t += this.tag.getRule(i) + '/*!sc*/\n'
      return t
    })
  var Zd = ff,
    Ud = new Map(),
    Xd = new Map(),
    Yd = 1,
    qd = function (e, t) {
      Yd <= t && (Yd = t + 1), Ud.set(e, t), Xd.set(t, e)
    },
    $d = 'style[' + Nd + '][data-styled-version="5.3.5"]',
    Kd = new RegExp('^' + Nd + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),
    Qd = function (e, t, n) {
      for (var r, i = n.split(','), o = 0, a = i.length; o < a; o++) (r = i[o]) && e.registerName(t, r)
    },
    Jd = function () {
      return 'undefined' != typeof window && void 0 !== window.__webpack_nonce__ ? window.__webpack_nonce__ : null
    },
    ef =
      (((p = df.prototype).insertRule = function (e, t) {
        try {
          return this.sheet.insertRule(t, e), this.length++, !0
        } catch (n) {
          return !1
        }
      }),
      (p.deleteRule = function (e) {
        this.sheet.deleteRule(e), this.length--
      }),
      (p.getRule = function (e) {
        return void 0 !== (e = this.sheet.cssRules[e]) && 'string' == typeof e.cssText ? e.cssText : ''
      }),
      df),
    tf =
      (((c = uf.prototype).insertRule = function (e, t) {
        return (
          e <= this.length &&
          0 <= e &&
          ((t = document.createTextNode(t)),
          (e = this.nodes[e]),
          this.element.insertBefore(t, e || null),
          this.length++,
          !0)
        )
      }),
      (c.deleteRule = function (e) {
        this.element.removeChild(this.nodes[e]), this.length--
      }),
      (c.getRule = function (e) {
        return e < this.length ? this.nodes[e].textContent : ''
      }),
      uf),
    nf =
      (((h = cf.prototype).insertRule = function (e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0)
      }),
      (h.deleteRule = function (e) {
        this.rules.splice(e, 1), this.length--
      }),
      (h.getRule = function (e) {
        return e < this.length ? this.rules[e] : ''
      }),
      cf),
    rf = Fd,
    of = { isServer: !Fd, useCSSOMInjection: !f },
    af =
      ((sf.registerId = Vd),
      (($t = sf.prototype).reconstructWithOptions = function (e, t) {
        return void 0 === t && (t = !0), new sf(Td({}, this.options, {}, e), this.gs, (t && this.names) || void 0)
      }),
      ($t.allocateGSInstance = function (e) {
        return (this.gs[e] = (this.gs[e] || 0) + 1)
      }),
      ($t.getTag = function () {
        return (
          this.tag ||
          (this.tag =
            ((e = (n = this.options).isServer),
            (t = n.useCSSOMInjection),
            (n = n.target),
            (e = new (e ? nf : t ? ef : tf)(n)),
            new Zd(e)))
        )
        var e, t, n
      }),
      ($t.hasNameForId = function (e, t) {
        return this.names.has(e) && this.names.get(e).has(t)
      }),
      ($t.registerName = function (e, t) {
        var n
        Vd(e), this.names.has(e) ? this.names.get(e).add(t) : ((n = new Set()).add(t), this.names.set(e, n))
      }),
      ($t.insertRules = function (e, t, n) {
        this.registerName(e, t), this.getTag().insertRules(Vd(e), n)
      }),
      ($t.clearNames = function (e) {
        this.names.has(e) && this.names.get(e).clear()
      }),
      ($t.clearRules = function (e) {
        this.getTag().clearGroup(Vd(e)), this.clearNames(e)
      }),
      ($t.clearTag = function () {
        this.tag = void 0
      }),
      ($t.toString = function () {
        for (var e = this.getTag(), t = e.length, n = '', r = 0; r < t; r++) {
          l = r
          var i,
            o,
            a,
            l = Xd.get(l)
          void 0 !== l &&
            ((i = this.names.get(l)), (o = e.getGroup(r)), i) &&
            o &&
            i.size &&
            ((l = Nd + '.g' + r + '[id="' + l + '"]'),
            (a = ''),
            void 0 !== i &&
              i.forEach(function (e) {
                0 < e.length && (a += e + ',')
              }),
            (n += o + l + '{content:"' + a + '"}/*!sc*/\n'))
        }
        return n
      }),
      sf),
    lf = /(a)(d)/gi
  function sf(e, t, n) {
    if (
      (void 0 === e && (e = Rd),
      void 0 === t && (t = {}),
      (this.options = Td({}, of, {}, e)),
      (this.gs = t),
      (this.names = new Map(n)),
      (this.server = !!e.isServer),
      !this.server && Fd && rf)
    ) {
      rf = !1
      for (var r = document.querySelectorAll($d), i = 0, o = r.length; i < o; i++) {
        var a = r[i]
        a &&
          'active' !== a.getAttribute(Nd) &&
          ((function (e, t) {
            for (var n = (t.textContent || '').split('/*!sc*/\n'), r = [], i = 0, o = n.length; i < o; i++) {
              var a,
                l,
                s,
                c = n[i].trim()
              c &&
                ((a = c.match(Kd))
                  ? ((l = 0 | parseInt(a[1], 10)),
                    (s = a[2]),
                    0 != l && (qd(s, l), Qd(e, s, a[3]), e.getTag().insertRules(l, r)),
                    (r.length = 0))
                  : r.push(c))
            }
          })(this, a),
          a.parentNode) &&
          a.parentNode.removeChild(a)
      }
    }
  }
  function cf(e) {
    ;(this.rules = []), (this.length = 0)
  }
  function uf(e) {
    ;(e = this.element = Wd(e)), (this.nodes = e.childNodes), (this.length = 0)
  }
  function df(e) {
    ;(e = this.element = Wd(e)).appendChild(document.createTextNode('')),
      (this.sheet = (function (e) {
        if (e.sheet) return e.sheet
        for (var t = document.styleSheets, n = 0, r = t.length; n < r; n++) {
          var i = t[n]
          if (i.ownerNode === e) return i
        }
        Bd(17)
      })(e)),
      (this.length = 0)
  }
  function ff(e) {
    ;(this.groupSizes = new Uint32Array(512)), (this.length = 512), (this.tag = e)
  }
  function hf(e) {
    for (var t = '', n = Math.abs(e); 52 < n; n = (n / 52) | 0) t = Gd(n % 52) + t
    return (Gd(n % 52) + t).replace(lf, '$1-$2')
  }
  function pf(e, t) {
    for (var n = t.length; n; ) e = (33 * e) ^ t.charCodeAt(--n)
    return e
  }
  var gf = function (e) {
    return pf(5381, e)
  }
  function mf(e) {
    for (var t = 0; t < e.length; t += 1) {
      var n = e[t]
      if (Dd(n) && !zd(n)) return !1
    }
    return !0
  }
  var vf = gf('5.3.5'),
    yf =
      ((Cf.prototype.generateAndInjectStyles = function (e, t, n) {
        var r = this.componentId,
          i = []
        if ((this.baseStyle && i.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash))
          this.staticRulesId && t.hasNameForId(r, this.staticRulesId)
            ? i.push(this.staticRulesId)
            : ((o = Uf(this.rules, e, t, n).join('')),
              (a = hf(pf(this.baseHash, o) >>> 0)),
              t.hasNameForId(r, a) || ((o = n(o, '.' + a, void 0, r)), t.insertRules(r, a, o)),
              i.push(a),
              (this.staticRulesId = a))
        else {
          for (var o, a, l = this.rules.length, s = pf(this.baseHash, n.hash), c = '', u = 0; u < l; u++) {
            var d = this.rules[u]
            'string' == typeof d
              ? (c += d)
              : d && ((d = Uf(d, e, t, n)), (s = pf(s, (d = Array.isArray(d) ? d.join('') : d) + u)), (c += d))
          }
          c &&
            ((o = hf(s >>> 0)),
            t.hasNameForId(r, o) || ((a = n(c, '.' + o, void 0, r)), t.insertRules(r, o, a)),
            i.push(o))
        }
        return i.join(' ')
      }),
      Cf),
    bf = /^\s*\/\/.*$/gm,
    wf = [':', '[', '.', '#']
  function Cf(e, t, n) {
    ;(this.rules = e),
      (this.staticRulesId = ''),
      (this.isStatic = (void 0 === n || n.isStatic) && mf(e)),
      (this.componentId = t),
      (this.baseHash = pf(vf, t)),
      (this.baseStyle = n),
      af.registerId(t)
  }
  var xf,
    Ef,
    Sf,
    Of,
    kf,
    Pf,
    _f,
    Lf = ue.createContext(),
    Tf = (Lf.Consumer, ue.createContext()),
    If = (Tf.Consumer, new af()),
    Mf =
      ((y = void 0 === (y = (mg = void 0 === mg ? Rd : mg).options) ? Rd : y),
      (mg = void 0 === (mg = mg.plugins) ? jd : mg),
      (Pf = new (function (e) {
        function t(e, t, r) {
          var i = t.trim().split(p),
            o = (t = i).length,
            a = e.length
          switch (a) {
            case 0:
            case 1:
              var l = 0
              for (e = 0 === a ? '' : e[0] + ' '; l < o; ++l) t[l] = n(e, t[l], r).trim()
              break
            default:
              var s = (l = 0)
              for (t = []; l < o; ++l) for (var c = 0; c < a; ++c) t[s++] = n(e[c] + ' ', i[l], r).trim()
          }
          return t
        }
        function n(e, t, n) {
          var r = t.charCodeAt(0)
          switch ((r = r < 33 ? (t = t.trim()).charCodeAt(0) : r)) {
            case 38:
              return t.replace(g, '$1' + e.trim())
            case 58:
              return e.trim() + t.replace(g, '$1' + e.trim())
            default:
              if (0 < +n && 0 < t.indexOf('\f')) return t.replace(g, (58 === e.charCodeAt(0) ? '' : '$1') + e.trim())
          }
          return e + t
        }
        function r(e, t, n, o) {
          var a,
            l = e + ';',
            s = 2 * t + 3 * n + 4 * o
          if (944 == s)
            return (
              (e = l.indexOf(':', 9) + 1),
              (a = l.substring(e, l.length - 1).trim()),
              (a = l.substring(0, e).trim() + a + ';'),
              1 === L || (2 === L && i(a, 1)) ? '-webkit-' + a + a : a
            )
          if (0 !== L && (2 !== L || i(l, 1)))
            switch (s) {
              case 1015:
                return 97 === l.charCodeAt(10) ? '-webkit-' + l + l : l
              case 951:
                return 116 === l.charCodeAt(3) ? '-webkit-' + l + l : l
              case 963:
                return 110 === l.charCodeAt(5) ? '-webkit-' + l + l : l
              case 1009:
                if (100 !== l.charCodeAt(4)) break
              case 969:
              case 942:
                return '-webkit-' + l + l
              case 978:
                return '-webkit-' + l + '-moz-' + l + l
              case 1019:
              case 983:
                return '-webkit-' + l + '-moz-' + l + '-ms-' + l + l
              case 883:
                if (45 === l.charCodeAt(8)) return '-webkit-' + l + l
                if (0 < l.indexOf('image-set(', 11)) return l.replace(O, '$1-webkit-$2') + l
                break
              case 932:
                if (45 === l.charCodeAt(4))
                  switch (l.charCodeAt(5)) {
                    case 103:
                      return (
                        '-webkit-box-' +
                        l.replace('-grow', '') +
                        '-webkit-' +
                        l +
                        '-ms-' +
                        l.replace('grow', 'positive') +
                        l
                      )
                    case 115:
                      return '-webkit-' + l + '-ms-' + l.replace('shrink', 'negative') + l
                    case 98:
                      return '-webkit-' + l + '-ms-' + l.replace('basis', 'preferred-size') + l
                  }
                return '-webkit-' + l + '-ms-' + l + l
              case 964:
                return '-webkit-' + l + '-ms-flex-' + l + l
              case 1023:
                if (99 !== l.charCodeAt(8)) break
                return (
                  '-webkit-box-pack' +
                  (a = l.substring(l.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')) +
                  '-webkit-' +
                  l +
                  '-ms-flex-pack' +
                  a +
                  l
                )
              case 1005:
                return f.test(l) ? l.replace(d, ':-webkit-') + l.replace(d, ':-moz-') + l : l
              case 1e3:
                switch (((t = (a = l.substring(13).trim()).indexOf('-') + 1), a.charCodeAt(0) + a.charCodeAt(t))) {
                  case 226:
                    a = l.replace(b, 'tb')
                    break
                  case 232:
                    a = l.replace(b, 'tb-rl')
                    break
                  case 220:
                    a = l.replace(b, 'lr')
                    break
                  default:
                    return l
                }
                return '-webkit-' + l + '-ms-' + a + l
              case 1017:
                if (-1 === l.indexOf('sticky', 9)) break
              case 975:
                switch (
                  ((t = (l = e).length - 10),
                  (s =
                    (a = (33 === l.charCodeAt(t) ? l.substring(0, t) : l)
                      .substring(e.indexOf(':', 7) + 1)
                      .trim()).charCodeAt(0) +
                    (0 | a.charCodeAt(7))))
                ) {
                  case 203:
                    if (a.charCodeAt(8) < 111) break
                  case 115:
                    l = l.replace(a, '-webkit-' + a) + ';' + l
                    break
                  case 207:
                  case 102:
                    l =
                      l.replace(a, '-webkit-' + (102 < s ? 'inline-' : '') + 'box') +
                      ';' +
                      l.replace(a, '-webkit-' + a) +
                      ';' +
                      l.replace(a, '-ms-' + a + 'box') +
                      ';' +
                      l
                }
                return l + ';'
              case 938:
                if (45 === l.charCodeAt(5))
                  switch (l.charCodeAt(6)) {
                    case 105:
                      return (a = l.replace('-items', '')), '-webkit-' + l + '-webkit-box-' + a + '-ms-flex-' + a + l
                    case 115:
                      return '-webkit-' + l + '-ms-flex-item-' + l.replace(x, '') + l
                    default:
                      return '-webkit-' + l + '-ms-flex-line-pack' + l.replace('align-content', '').replace(x, '') + l
                  }
                break
              case 973:
              case 989:
                if (45 !== l.charCodeAt(3) || 122 === l.charCodeAt(4)) break
              case 931:
              case 953:
                if (!0 === S.test(e))
                  return 115 === (a = e.substring(e.indexOf(':') + 1)).charCodeAt(0)
                    ? r(e.replace('stretch', 'fill-available'), t, n, o).replace(':fill-available', ':stretch')
                    : l.replace(a, '-webkit-' + a) + l.replace(a, '-moz-' + a.replace('fill-', '')) + l
                break
              case 962:
                if (
                  ((l = '-webkit-' + l + (102 === l.charCodeAt(5) ? '-ms-' + l : '') + l),
                  211 === n + o && 105 === l.charCodeAt(13) && 0 < l.indexOf('transform', 10))
                )
                  return l.substring(0, l.indexOf(';', 27) + 1).replace(h, '$1-webkit-$2') + l
            }
          return l
        }
        function i(e, t) {
          var n = e.indexOf(1 === t ? ':' : '{'),
            r = e.substring(0, 3 !== t ? n : 10)
          n = e.substring(n + 1, e.length - 1)
          return j(2 !== t ? r : r.replace(E, '$1'), n, t)
        }
        function o(e, t) {
          var n = r(t, t.charCodeAt(0), t.charCodeAt(1), t.charCodeAt(2))
          return n !== t + ';' ? n.replace(C, ' or ($1)').substring(4) : '(' + t + ')'
        }
        function a(e, t, n, r, i, o, a, l, c, u) {
          for (var d, f = 0, h = t; f < M; ++f)
            switch ((d = I[f].call(s, e, h, n, r, i, o, a, l, c, u))) {
              case void 0:
              case !1:
              case !0:
              case null:
                break
              default:
                h = d
            }
          if (h !== t) return h
        }
        function l(e) {
          return (
            void 0 !== (e = e.prefix) &&
              ((j = null), e ? ('function' != typeof e ? (L = 1) : ((L = 2), (j = e))) : (L = 0)),
            l
          )
        }
        function s(e, n) {
          ;(e = [(e = e.charCodeAt(0) < 33 ? e.trim() : e)]),
            0 < M && void 0 !== (l = a(-1, n, e, e, P, k, 0, 0, 0, 0)) && 'string' == typeof l && (n = l)
          var l
          n = (function e(n, l, s, d, f) {
            for (
              var h,
                p,
                g,
                b,
                C,
                x = 0,
                E = 0,
                S = 0,
                O = 0,
                I = 0,
                j = 0,
                D = (g = h = 0),
                A = 0,
                z = 0,
                N = 0,
                F = 0,
                H = s.length,
                B = H - 1,
                V = '',
                W = '',
                G = '',
                Z = '';
              A < H;

            ) {
              if (
                ((p = s.charCodeAt(A)),
                A === B && 0 !== E + O + S + x && (0 !== E && (p = 47 === E ? 10 : 47), (O = S = x = 0), H++, B++),
                0 === E + O + S + x)
              ) {
                if (A === B && 0 < (V = 0 < z ? V.replace(u, '') : V).trim().length) {
                  switch (p) {
                    case 32:
                    case 9:
                    case 59:
                    case 13:
                    case 10:
                      break
                    default:
                      V += s.charAt(A)
                  }
                  p = 59
                }
                switch (p) {
                  case 123:
                    for (h = (V = V.trim()).charCodeAt(0), g = 1, F = ++A; A < H; ) {
                      switch ((p = s.charCodeAt(A))) {
                        case 123:
                          g++
                          break
                        case 125:
                          g--
                          break
                        case 47:
                          switch ((p = s.charCodeAt(A + 1))) {
                            case 42:
                            case 47:
                              e: {
                                for (D = A + 1; D < B; ++D)
                                  switch (s.charCodeAt(D)) {
                                    case 47:
                                      if (42 !== p || 42 !== s.charCodeAt(D - 1) || A + 2 === D) break
                                      A = D + 1
                                      break e
                                    case 10:
                                      if (47 === p) {
                                        A = D + 1
                                        break e
                                      }
                                  }
                                A = D
                              }
                          }
                          break
                        case 91:
                          p++
                        case 40:
                          p++
                        case 34:
                        case 39:
                          for (; A++ < B && s.charCodeAt(A) !== p; );
                      }
                      if (0 === g) break
                      A++
                    }
                    if (
                      ((g = s.substring(F, A)), 64 === (h = 0 === h ? (V = V.replace(c, '').trim()).charCodeAt(0) : h))
                    ) {
                      switch ((p = (V = 0 < z ? V.replace(u, '') : V).charCodeAt(1))) {
                        case 100:
                        case 109:
                        case 115:
                        case 45:
                          z = l
                          break
                        default:
                          z = T
                      }
                      if (
                        ((F = (g = e(l, z, g, p, f + 1)).length),
                        0 < M &&
                          ((C = a(3, g, (z = t(T, V, N)), l, P, k, F, p, f, d)), (V = z.join('')), void 0 !== C) &&
                          0 === (F = (g = C.trim()).length) &&
                          ((p = 0), (g = '')),
                        0 < F)
                      )
                        switch (p) {
                          case 115:
                            V = V.replace(w, o)
                          case 100:
                          case 109:
                          case 45:
                            g = V + '{' + g + '}'
                            break
                          case 107:
                            ;(g = (V = V.replace(m, '$1 $2')) + '{' + g + '}'),
                              (g = 1 === L || (2 === L && i('@' + g, 3)) ? '@-webkit-' + g + '@' + g : '@' + g)
                            break
                          default:
                            ;(g = V + g), 112 === d && ((W += g), (g = ''))
                        }
                      else g = ''
                    } else g = e(l, t(l, V, N), g, d, f + 1)
                    ;(G += g), (g = N = z = D = h = 0), (V = ''), (p = s.charCodeAt(++A))
                    break
                  case 125:
                  case 59:
                    if (1 < (F = (V = (0 < z ? V.replace(u, '') : V).trim()).length))
                      switch (
                        (0 === D &&
                          ((h = V.charCodeAt(0)), 45 === h || (96 < h && h < 123)) &&
                          (F = (V = V.replace(' ', ':')).length),
                        0 < M &&
                          void 0 !== (C = a(1, V, l, n, P, k, W.length, d, f, d)) &&
                          0 === (F = (V = C.trim()).length) &&
                          (V = '\0\0'),
                        (h = V.charCodeAt(0)),
                        (p = V.charCodeAt(1)),
                        h)
                      ) {
                        case 0:
                          break
                        case 64:
                          if (105 === p || 99 === p) {
                            Z += V + s.charAt(A)
                            break
                          }
                        default:
                          58 !== V.charCodeAt(F - 1) && (W += r(V, h, p, V.charCodeAt(2)))
                      }
                    ;(N = z = D = h = 0), (V = ''), (p = s.charCodeAt(++A))
                }
              }
              switch (p) {
                case 13:
                case 10:
                  47 === E ? (E = 0) : 0 === 1 + h && 107 !== d && 0 < V.length && ((z = 1), (V += '\0')),
                    0 < M * R && a(0, V, l, n, P, k, W.length, d, f, d),
                    (k = 1),
                    P++
                  break
                case 59:
                case 125:
                  if (0 === E + O + S + x) {
                    k++
                    break
                  }
                default:
                  switch ((k++, (b = s.charAt(A)), p)) {
                    case 9:
                    case 32:
                      if (0 === O + x + E)
                        switch (I) {
                          case 44:
                          case 58:
                          case 9:
                          case 32:
                            b = ''
                            break
                          default:
                            32 !== p && (b = ' ')
                        }
                      break
                    case 0:
                      b = '\\0'
                      break
                    case 12:
                      b = '\\f'
                      break
                    case 11:
                      b = '\\v'
                      break
                    case 38:
                      0 === O + E + x && ((z = N = 1), (b = '\f' + b))
                      break
                    case 108:
                      if (0 === O + E + x + _ && 0 < D)
                        switch (A - D) {
                          case 2:
                            112 === I && 58 === s.charCodeAt(A - 3) && (_ = I)
                          case 8:
                            111 === j && (_ = j)
                        }
                      break
                    case 58:
                      0 === O + E + x && (D = A)
                      break
                    case 44:
                      0 === E + S + O + x && ((z = 1), (b += '\r'))
                      break
                    case 34:
                    case 39:
                      0 === E && (O = O === p ? 0 : 0 === O ? p : O)
                      break
                    case 91:
                      0 === O + E + S && x++
                      break
                    case 93:
                      0 === O + E + S && x--
                      break
                    case 41:
                      0 === O + E + x && S--
                      break
                    case 40:
                      0 === O + E + x && (0 === h && 2 * I + 3 * j != 533 && (h = 1), S++)
                      break
                    case 64:
                      0 === E + S + O + x + D + g && (g = 1)
                      break
                    case 42:
                    case 47:
                      if (!(0 < O + x + S))
                        switch (E) {
                          case 0:
                            switch (2 * p + 3 * s.charCodeAt(A + 1)) {
                              case 235:
                                E = 47
                                break
                              case 220:
                                ;(F = A), (E = 42)
                            }
                            break
                          case 42:
                            47 === p &&
                              42 === I &&
                              F + 2 !== A &&
                              (33 === s.charCodeAt(F + 2) && (W += s.substring(F, A + 1)), (b = ''), (E = 0))
                        }
                  }
                  0 === E && (V += b)
              }
              ;(j = I), (I = p), A++
            }
            if (0 < (F = W.length)) {
              if (((z = l), 0 < M && void 0 !== (C = a(2, W, z, n, P, k, F, d, f, d)) && 0 === (W = C).length))
                return Z + W + G
              if (((W = z.join(',') + '{' + W + '}'), 0 != L * _)) {
                switch ((_ = 2 !== L || i(W, 2) ? _ : 0)) {
                  case 111:
                    W = W.replace(y, ':-moz-$1') + W
                    break
                  case 112:
                    W =
                      W.replace(v, '::-webkit-input-$1') + W.replace(v, '::-moz-$1') + W.replace(v, ':-ms-input-$1') + W
                }
                _ = 0
              }
            }
            return Z + W + G
          })(T, e, n, 0, 0)
          return 0 < M && void 0 !== (l = a(-2, n, e, e, P, k, n.length, 0, 0, 0)) && (n = l), (_ = 0), (k = P = 1), n
        }
        var c = /^\0+/g,
          u = /[\0\r\f]/g,
          d = /: */g,
          f = /zoo|gra/,
          h = /([,: ])(transform)/g,
          p = /,\r+?/g,
          g = /([\t\r\n ])*\f?&/g,
          m = /@(k\w+)\s*(\S*)\s*/,
          v = /::(place)/g,
          y = /:(read-only)/g,
          b = /[svh]\w+-[tblr]{2}/,
          w = /\(\s*(.*)\s*\)/g,
          C = /([\s\S]*?);/g,
          x = /-self|flex-/g,
          E = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
          S = /stretch|:\s*\w+\-(?:conte|avail)/,
          O = /([^-])(image-set\()/,
          k = 1,
          P = 1,
          _ = 0,
          L = 1,
          T = [],
          I = [],
          M = 0,
          j = null,
          R = 0
        return (
          (s.use = function e(t) {
            switch (t) {
              case void 0:
              case null:
                M = I.length = 0
                break
              default:
                if ('function' == typeof t) I[M++] = t
                else if ('object' == typeof t) for (var n = 0, r = t.length; n < r; ++n) e(t[n])
                else R = 0 | !!t
            }
            return e
          }),
          (s.set = l),
          void 0 !== e && l(e),
          s
        )
      })(y)),
      (_f = []),
      (kf = function (e) {
        _f.push(e)
      }),
      Pf.use(
        [].concat(mg, [
          function (e, t, n) {
            2 === e && n.length && 0 < n[0].lastIndexOf(Ef) && (n[0] = n[0].replace(Sf, jf))
          },
          function (e, t, n, r, i, o, a, l, s, c) {
            switch (e) {
              case 1:
                if (0 === s && 64 === t.charCodeAt(0)) return kf(t + ';'), ''
                break
              case 2:
                if (0 === l) return t + '/*|*/'
                break
              case 3:
                switch (l) {
                  case 102:
                  case 112:
                    return kf(n[0] + t), ''
                  default:
                    return t + (0 === c ? '/*|*/' : '')
                }
              case -2:
                t.split('/*|*/}').forEach(Rf)
            }
          },
          function (e) {
            if (-2 === e) return (e = _f), (_f = []), e
          }
        ])
      ),
      (Df.hash = mg.length
        ? mg
            .reduce(function (e, t) {
              return t.name || Bd(15), pf(e, t.name)
            }, 5381)
            .toString()
        : ''),
      Df)
  function jf(e, t, n) {
    return (0 === t && -1 !== wf.indexOf(n[Ef.length])) || n.match(Of) ? e : '.' + xf
  }
  function Rf(e) {
    if (e)
      try {
        kf(e + '}')
      } catch (t) {}
  }
  function Df(e, t, n, r) {
    return (
      void 0 === r && (r = '&'),
      (e = e.replace(bf, '')),
      (e = t && n ? n + ' ' + t + ' { ' + e + ' }' : e),
      (xf = r),
      (Ef = t),
      (Sf = new RegExp('\\' + Ef + '\\b', 'g')),
      (Of = new RegExp('(\\' + Ef + '\\b){2,}')),
      Pf(n || !t ? '' : t, e)
    )
  }
  function Af() {
    return s.exports.useContext(Lf) || If
  }
  function zf() {
    return s.exports.useContext(Tf) || Mf
  }
  Wf.prototype.getName = function (e) {
    return void 0 === e && (e = Mf), this.name + e.hash
  }
  var Nf = Wf,
    Ff = /([A-Z])/,
    Hf = /([A-Z])/g,
    Bf = /^ms-/,
    Vf = function (e) {
      return '-' + e.toLowerCase()
    }
  function Wf(e, t) {
    var n = this
    ;(this.inject = function (e, t) {
      void 0 === t && (t = Mf)
      var r = n.name + t.hash
      e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, '@keyframes'))
    }),
      (this.toString = function () {
        return Bd(12, String(n.name))
      }),
      (this.name = e),
      (this.id = 'sc-keyframes-' + e),
      (this.rules = t)
  }
  function Gf(e) {
    return Ff.test(e) ? e.replace(Hf, Vf).replace(Bf, '-ms-') : e
  }
  var Zf = function (e) {
    return null == e || !1 === e || '' === e
  }
  function Uf(e, t, n, r) {
    if (Array.isArray(e)) {
      for (var i, o = [], a = 0, l = e.length; a < l; a += 1)
        '' !== (i = Uf(e[a], t, n, r)) && (Array.isArray(i) ? o.push.apply(o, i) : o.push(i))
      return o
    }
    return Zf(e)
      ? ''
      : zd(e)
      ? '.' + e.styledComponentId
      : Dd(e)
      ? 'function' != typeof e || (e.prototype && e.prototype.isReactComponent) || !t
        ? e
        : Uf(e(t), t, n, r)
      : e instanceof Nf
      ? n
        ? (e.inject(n, r), e.getName(r))
        : e
      : Md(e)
      ? (function e(t, n) {
          var r,
            i,
            o,
            a = []
          for (o in t)
            t.hasOwnProperty(o) &&
              !Zf(t[o]) &&
              ((Array.isArray(t[o]) && t[o].isCss) || Dd(t[o])
                ? a.push(Gf(o) + ':', t[o], ';')
                : Md(t[o])
                ? a.push.apply(a, e(t[o], o))
                : a.push(
                    Gf(o) +
                      ': ' +
                      ((r = o),
                      (null == (i = t[o]) || 'boolean' == typeof i || '' === i
                        ? ''
                        : 'number' != typeof i || 0 === i || r in fd
                        ? String(i).trim()
                        : i + 'px') + ';')
                  ))
          return n ? [n + ' {'].concat(a, ['}']) : a
        })(e)
      : e.toString()
  }
  var Xf = function (e) {
    return Array.isArray(e) && (e.isCss = !0), e
  }
  function Yf(e) {
    for (var t = arguments.length, n = new Array(1 < t ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r]
    return Dd(e) || Md(e)
      ? Xf(Uf(Id(jd, [e].concat(n))))
      : 0 === n.length && 1 === e.length && 'string' == typeof e[0]
      ? e
      : Xf(Uf(Id(e, n)))
  }
  var qf = function (e, t, n) {
      return void 0 === n && (n = Rd), (e.theme !== n.theme && e.theme) || t || n.theme
    },
    $f = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,
    Kf = /(^-|-$)/g
  function Qf(e) {
    return e.replace($f, '-').replace(Kf, '')
  }
  var Jf = function (e) {
    return hf(gf(e) >>> 0)
  }
  function eh(e) {
    return 'string' == typeof e && !0
  }
  var th = function (e) {
      return 'function' == typeof e || ('object' == typeof e && null !== e && !Array.isArray(e))
    },
    nh = function (e) {
      return '__proto__' !== e && 'constructor' !== e && 'prototype' !== e
    }
  function rh(e) {
    for (var t = arguments.length, n = new Array(1 < t ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r]
    for (var i, o, a, l = 0, s = n; l < s.length; l++) {
      var c = s[l]
      if (th(c))
        for (var u in c)
          nh(u) && ((i = e), (o = c[u]), (a = void 0), (a = i[u]), th(o) && th(a) ? rh(a, o) : (i[u] = o))
    }
    return e
  }
  var ih = ue.createContext()
  function oh(e) {
    var t = s.exports.useContext(ih),
      n = s.exports.useMemo(
        function () {
          return (
            (n = e.theme),
            (r = t),
            n ? (Dd(n) ? n(r) : Array.isArray(n) || 'object' != typeof n ? Bd(8) : r ? Td({}, r, {}, n) : n) : Bd(14)
          )
          var n, r
        },
        [e.theme, t]
      )
    return e.children ? ue.createElement(ih.Provider, { value: n }, e.children) : null
  }
  ih.Consumer
  var ah = {}
  function lh(e, t, n) {
    var r,
      i,
      o = zd(e),
      a = !eh(e),
      l = void 0 === (l = t.attrs) ? jd : l,
      c =
        void 0 === (c = t.componentId)
          ? ((r = t.displayName),
            (i = t.parentComponentId),
            (r = 'string' != typeof r ? 'sc' : Qf(r)),
            (ah[r] = (ah[r] || 0) + 1),
            (r = r + '-' + Jf('5.3.5' + r + ah[r])),
            i ? i + '-' + r : r)
          : c,
      u = void 0 === (u = t.displayName) ? (eh(e) ? 'styled.' + e : 'Styled(' + Ad(e) + ')') : u,
      d =
        ((c = t.displayName && t.componentId ? Qf(t.displayName) + '-' + t.componentId : t.componentId || c),
        o && e.attrs ? Array.prototype.concat(e.attrs, l).filter(Boolean) : l),
      f = t.shouldForwardProp
    function h(e, t) {
      var n,
        r,
        i,
        o,
        a,
        l = m,
        c = (v = p).attrs,
        u = v.componentStyle,
        d = v.defaultProps,
        f = v.foldedComponentIds,
        h = v.shouldForwardProp,
        g = v.styledComponentId,
        v = v.target,
        y =
          ((c =
            ((d = qf(e, s.exports.useContext(ih), d) || Rd),
            (i = Td({}, e, { theme: (d = void 0 === d ? Rd : d) })),
            (o = {}),
            c.forEach(function (e) {
              var t,
                n,
                r,
                a = e
              for (t in (a = Dd(a) ? a(i) : a))
                i[t] = o[t] = 'className' === t ? ((n = o[t]), (r = a[t]), n && r ? n + ' ' + r : n || r) : a[t]
            }),
            (d = [i, o])[1])),
          (l =
            ((d = d[0]),
            (n = Af()),
            (r = zf()),
            l ? u.generateAndInjectStyles(Rd, n, r) : u.generateAndInjectStyles(d, n, r))),
          (u = t),
          c.$as || e.$as || c.as || e.as || v),
        b = eh(y),
        w = c !== e ? Td({}, e, {}, c) : e,
        C = {}
      for (a in w)
        '$' !== a[0] &&
          'as' !== a &&
          ('forwardedAs' === a ? (C.as = w[a]) : (h ? h(a, md, y) : !b || md(a)) && (C[a] = w[a]))
      return (
        e.style && c.style !== e.style && (C.style = Td({}, e.style, {}, c.style)),
        (C.className = Array.prototype
          .concat(f, g, l !== g ? l : null, e.className, c.className)
          .filter(Boolean)
          .join(' ')),
        (C.ref = u),
        s.exports.createElement(y, C)
      )
    }
    o &&
      e.shouldForwardProp &&
      (f = t.shouldForwardProp
        ? function (n, r, i) {
            return e.shouldForwardProp(n, r, i) && t.shouldForwardProp(n, r, i)
          }
        : e.shouldForwardProp)
    var p,
      g = new yf(n, c, o ? e.componentStyle : void 0),
      m = g.isStatic && 0 === l.length
    return (
      (h.displayName = u),
      ((p = ue.forwardRef(h)).attrs = d),
      (p.componentStyle = g),
      (p.displayName = u),
      (p.shouldForwardProp = f),
      (p.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : jd),
      (p.styledComponentId = c),
      (p.target = o ? e.target : e),
      (p.withComponent = function (e) {
        var r = t.componentId,
          i = (function (e, t) {
            if (null == e) return {}
            for (var n, r = {}, i = Object.keys(e), o = 0; o < i.length; o++)
              (n = i[o]), 0 <= t.indexOf(n) || (r[n] = e[n])
            return r
          })(t, ['componentId'])
        r = r && r + '-' + (eh(e) ? e : Qf(Ad(e)))
        return lh(e, Td({}, i, { attrs: d, componentId: r }), n)
      }),
      Object.defineProperty(p, 'defaultProps', {
        get: function () {
          return this._foldedDefaultProps
        },
        set: function (t) {
          this._foldedDefaultProps = o ? rh({}, e.defaultProps, t) : t
        }
      }),
      (p.toString = function () {
        return '.' + p.styledComponentId
      }),
      a &&
        Ld(p, e, {
          attrs: !0,
          componentStyle: !0,
          displayName: !0,
          foldedComponentIds: !0,
          shouldForwardProp: !0,
          styledComponentId: !0,
          target: !0,
          withComponent: !0
        }),
      p
    )
  }
  function sh(e) {
    return (function e(t, n, r) {
      var i
      return (
        void 0 === r && (r = Rd),
        Zu.exports.isValidElementType(n)
          ? (((i = function () {
              return t(n, r, Yf.apply(void 0, arguments))
            }).withConfig = function (i) {
              return e(t, n, Td({}, r, {}, i))
            }),
            (i.attrs = function (i) {
              return e(t, n, Td({}, r, { attrs: Array.prototype.concat(r.attrs, i).filter(Boolean) }))
            }),
            i)
          : Bd(1, String(n))
      )
    })(lh, e)
  }
  ;[
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'marker',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'textPath',
    'tspan'
  ].forEach(function (e) {
    sh[e] = sh(e)
  }),
    ((p = uh.prototype).createStyles = function (e, t, n, r) {
      ;(t = r(Uf(this.rules, t, n, r).join(''), '')), (r = this.componentId + e), n.insertRules(r, r, t)
    }),
    (p.removeStyles = function (e, t) {
      t.clearRules(this.componentId + e)
    }),
    (p.renderStyles = function (e, t, n, r) {
      2 < e && af.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r)
    })
  var ch = uh
  function uh(e, t) {
    ;(this.rules = e), (this.componentId = t), (this.isStatic = mf(e)), af.registerId(this.componentId + 1)
  }
  function dh(e) {
    for (var t = arguments.length, n = new Array(1 < t ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r]
    e = Yf.apply(void 0, [e].concat(n))
    var i = 'sc-global-' + Jf(JSON.stringify(e)),
      o = new ch(e, i)
    function a(e) {
      var t = Af(),
        n = zf(),
        r = s.exports.useContext(ih),
        a = s.exports.useRef(t.allocateGSInstance(i)).current
      return (
        t.server && l(a, e, t, r, n),
        s.exports.useLayoutEffect(
          function () {
            if (!t.server)
              return (
                l(a, e, t, r, n),
                function () {
                  return o.removeStyles(a, t)
                }
              )
          },
          [a, e, t, r, n]
        ),
        null
      )
    }
    function l(e, t, n, r, i) {
      o.isStatic
        ? o.renderStyles(e, Hd, n, i)
        : ((t = Td({}, t, { theme: qf(t, r, a.defaultProps) })), o.renderStyles(e, t, n, i))
    }
    return ue.memo(a)
  }
  var fh,
    hh,
    ph,
    gh,
    mh,
    vh,
    yh,
    bh,
    wh,
    Ch,
    xh,
    Eh,
    Sh,
    Oh,
    kh,
    Ph,
    _h,
    Lh,
    Th,
    Ih,
    Mh,
    jh,
    Rh,
    Dh,
    Ah,
    zh,
    Nh,
    Fh,
    Hh,
    Bh,
    Vh,
    Wh,
    Gh,
    Zh,
    Uh,
    Xh,
    Yh,
    qh,
    $h,
    Kh,
    Qh,
    Jh,
    ep,
    tp,
    np,
    rp,
    ip,
    op
  c = sh
  function ap() {}
  function lp(e) {
    var t = -1,
      n = null == e ? 0 : e.length
    for (this.clear(); ++t < n; ) {
      var r = e[t]
      this.set(r[0], r[1])
    }
  }
  function sp(e) {
    var t = -1,
      n = null == e ? 0 : e.length
    for (this.clear(); ++t < n; ) {
      var r = e[t]
      this.set(r[0], r[1])
    }
  }
  function cp(e) {
    var t = -1,
      n = null == e ? 0 : e.length
    for (this.clear(); ++t < n; ) {
      var r = e[t]
      this.set(r[0], r[1])
    }
  }
  function up(e) {
    ;(e = this.__data__ = new sp(e)), (this.size = e.size)
  }
  function dp(e, t, n) {
    ;((void 0 === n || xp(e[t], n)) && (void 0 !== n || t in e)) || hp(e, t, n)
  }
  function fp(e, t) {
    for (var n = e.length; n--; ) if (xp(e[n][0], t)) return n
    return -1
  }
  function hp(e, t, n) {
    '__proto__' == t && Wh ? Wh(e, t, { configurable: !0, enumerable: !0, value: n, writable: !0 }) : (e[t] = n)
  }
  function pp(e) {
    if (null == e) return void 0 === e ? Ch : yh
    if (Vh && Vh in Object(e)) {
      var t = e,
        n = Ih.call(t, Vh),
        r = t[Vh]
      try {
        var i = !(t[Vh] = void 0)
      } catch (a) {}
      var o = jh.call(t)
      return i && (n ? (t[Vh] = r) : delete t[Vh]), o
    }
    return jh.call(e)
  }
  function gp(e) {
    return Pp(e) && pp(e) == ph
  }
  function mp(e, t, n, r, i) {
    e !== t &&
      qh(
        t,
        function (o, a) {
          var l, s, c, u, d, f, h, p, g, m, v, y, b, w
          ;(i = i || new up()),
            kp(o)
              ? ((s = t),
                (u = n),
                (d = mp),
                (f = r),
                (h = i),
                (v = Cp((l = e), (c = a))),
                (y = Cp(s, c)),
                (b = h.get(y)) ||
                  ((s = void 0 === (b = f ? f(v, y, c + '', l, s, h) : void 0)) &&
                    ((g = !(p = tp(y)) && np(y)),
                    (m = !p && !g && ip(y)),
                    (b = y),
                    p || g || m
                      ? (b = tp(v)
                          ? v
                          : Pp((w = v)) && Ep(w)
                          ? (function (e, t) {
                              var n = -1,
                                r = e.length
                              for (t = t || Array(r); ++n < r; ) t[n] = e[n]
                              return t
                            })(v)
                          : g
                          ? (function (e, t) {
                              return t
                                ? e.slice()
                                : ((t = e.length), (t = zh ? zh(t) : new e.constructor(t)), e.copy(t), t)
                            })(y, !(s = !1))
                          : m
                          ? (function (e, t) {
                              var n, r
                              return (
                                (t = t
                                  ? ((n = e.buffer), (r = new n.constructor(n.byteLength)), new Ah(r).set(new Ah(n)), r)
                                  : e.buffer),
                                new e.constructor(t, e.byteOffset, e.length)
                              )
                            })(y, !(s = !1))
                          : [])
                      : (function (e) {
                          if (Pp(e) && pp(e) == bh)
                            return null === (e = Nh(e))
                              ? 1
                              : 'function' == typeof (e = Ih.call(e, 'constructor') && e.constructor) &&
                                  e instanceof e &&
                                  Th.call(e) == Rh
                        })(y) || ep(y)
                      ? ep((b = v))
                        ? (b = (function (e) {
                            return (function (e, t, n, r) {
                              for (var i = !n, o = ((n = n || {}), -1), a = t.length; ++o < a; ) {
                                var l = t[o],
                                  s = void 0
                                void 0 === s && (s = e[l]),
                                  (i
                                    ? hp
                                    : function (e, t, n) {
                                        var r = e[t]
                                        ;(Ih.call(e, t) && xp(r, n) && (void 0 !== n || t in e)) || hp(e, t, n)
                                      })(n, l, s)
                              }
                              return n
                            })(e, _p(e))
                          })(v))
                        : (kp(v) && !Sp(v)) ||
                          (b = (function (e) {
                            return 'function' != typeof e.constructor || wp(e) ? {} : Yh(Nh(e))
                          })(y))
                      : (s = !1)),
                  s && (h.set(y, b), d(b, y, u, f, h), h.delete(y))),
                dp(l, c, b))
              : ((p = r ? r(Cp(e, a), o, a + '', e, t, i) : void 0), dp(e, a, (p = void 0 === p ? o : p)))
        },
        _p
      )
  }
  function vp(e, t) {
    var n, r
    e = e.__data__
    return (
      'string' == (r = typeof (n = t)) || 'number' == r || 'symbol' == r || 'boolean' == r
        ? '__proto__' !== n
        : null === n
    )
      ? e['string' == typeof t ? 'string' : 'hash']
      : e.map
  }
  function yp(e, t) {
    return (function (e) {
      return (
        kp(e) &&
        !(Mh && Mh in e) &&
        (Sp(e) ? Dh : xh).test(
          (function (e) {
            if (null != e) {
              try {
                return Th.call(e)
              } catch (t) {}
              try {
                return e + ''
              } catch (t) {}
            }
            return ''
          })(e)
        )
      )
    })((e = null == e ? void 0 : e[t]))
      ? e
      : void 0
  }
  function bp(e, t) {
    var n = typeof e
    return (t = null == t ? hh : t) && ('number' == n || ('symbol' != n && Eh.test(e))) && -1 < e && e % 1 == 0 && e < t
  }
  function wp(e) {
    var t = e && e.constructor
    return e === (('function' == typeof t && t.prototype) || Lh)
  }
  function Cp(e, t) {
    if (('constructor' !== t || 'function' != typeof e[t]) && '__proto__' != t) return e[t]
  }
  function xp(e, t) {
    return e === t || (e != e && t != t)
  }
  function Ep(e) {
    return null != e && Op(e.length) && !Sp(e)
  }
  function Sp(e) {
    if (kp(e)) return (e = pp(e)) == mh || e == vh || e == gh || e == wh
  }
  function Op(e) {
    return 'number' == typeof e && -1 < e && e % 1 == 0 && e <= hh
  }
  function kp(e) {
    var t = typeof e
    return null != e && ('object' == t || 'function' == t)
  }
  function Pp(e) {
    return null != e && 'object' == typeof e
  }
  function _p(e) {
    return Ep(e)
      ? (function (e, t) {
          var n,
            r = tp(e),
            i = !r && ep(e),
            o = !r && !i && np(e),
            a = !r && !i && !o && ip(e),
            l = r || i || o || a,
            s = l
              ? (function (e, t) {
                  for (var n = -1, r = Array(e); ++n < e; ) r[n] = t(n)
                  return r
                })(e.length, String)
              : [],
            c = s.length
          for (n in e)
            (!t && !Ih.call(e, n)) ||
              (l &&
                ('length' == n ||
                  (o && ('offset' == n || 'parent' == n)) ||
                  (a && ('buffer' == n || 'byteLength' == n || 'byteOffset' == n)) ||
                  bp(n, c))) ||
              s.push(n)
          return s
        })(e, !0)
      : (function (e) {
          if (!kp(e)) {
            var t = e,
              n = []
            if (null != t) for (var r in Object(t)) n.push(r)
            return n
          }
          var i,
            o = wp(e),
            a = []
          for (i in e) ('constructor' != i || (!o && Ih.call(e, i))) && a.push(i)
          return a
        })(e)
  }
  function Lp(e) {
    return e
  }
  function Tp(e, t) {
    return e.reduce(function (e, n) {
      return Object.assign(e, r({}, n, t))
    }, {})
  }
  ;(y = (f = h = { exports: {} }).exports),
    (fh = '__lodash_hash_undefined__'),
    (hh = 9007199254740991),
    (ph = '[object Arguments]'),
    (gh = '[object AsyncFunction]'),
    (mh = '[object Function]'),
    (vh = '[object GeneratorFunction]'),
    (yh = '[object Null]'),
    (bh = '[object Object]'),
    (wh = '[object Proxy]'),
    (Ch = '[object Undefined]'),
    (xh = /^\[object .+?Constructor\]$/),
    (Eh = /^(?:0|[1-9]\d*)$/),
    ((Sh = {})['[object Float32Array]'] =
      Sh['[object Float64Array]'] =
      Sh['[object Int8Array]'] =
      Sh['[object Int16Array]'] =
      Sh['[object Int32Array]'] =
      Sh['[object Uint8Array]'] =
      Sh['[object Uint8ClampedArray]'] =
      Sh['[object Uint16Array]'] =
      Sh['[object Uint32Array]'] =
        !0),
    (Sh[ph] =
      Sh['[object Array]'] =
      Sh['[object ArrayBuffer]'] =
      Sh['[object Boolean]'] =
      Sh['[object DataView]'] =
      Sh['[object Date]'] =
      Sh['[object Error]'] =
      Sh[mh] =
      Sh['[object Map]'] =
      Sh['[object Number]'] =
      Sh[bh] =
      Sh['[object RegExp]'] =
      Sh['[object Set]'] =
      Sh['[object String]'] =
      Sh['[object WeakMap]'] =
        !1),
    (mg = 'object' == typeof l && l && l.Object === Object && l),
    (p = 'object' == typeof self && self && self.Object === Object && self),
    (p = mg || p || Function('return this')()),
    (y = y && !y.nodeType && y),
    (y = (Oh = y && f && !f.nodeType && f) && Oh.exports === y),
    (kh = y && mg.process),
    (mg =
      (mg = (function () {
        try {
          var e = Oh && Oh.require && Oh.require('util').types
          return e || (kh && kh.binding && kh.binding('util'))
        } catch (t) {}
      })()) && mg.isTypedArray),
    (l = Array.prototype),
    (ug = Function.prototype),
    (Lh = Object.prototype),
    (Og = p['__core-js_shared__']),
    (Th = ug.toString),
    (Ih = Lh.hasOwnProperty),
    (Mh = (ug = /[^.]+$/.exec((Og && Og.keys && Og.keys.IE_PROTO) || '')) ? 'Symbol(src)_1.' + ug : ''),
    (jh = Lh.toString),
    (Rh = Th.call(Object)),
    (Dh = RegExp(
      '^' +
        Th.call(Ih)
          .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
          .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') +
        '$'
    )),
    (Og = y ? p.Buffer : void 0),
    (ug = p.Symbol),
    (Ah = p.Uint8Array),
    (zh = Og ? Og.allocUnsafe : void 0),
    (Ph = Object.getPrototypeOf),
    (_h = Object),
    (Nh = function (e) {
      return Ph(_h(e))
    }),
    (Fh = Object.create),
    (Hh = Lh.propertyIsEnumerable),
    (Bh = l.splice),
    (Vh = ug ? ug.toStringTag : void 0),
    (Wh = (function () {
      try {
        var e = yp(Object, 'defineProperty')
        return e({}, '', {}), e
      } catch (t) {}
    })()),
    (y = Og ? Og.isBuffer : void 0),
    (Gh = Math.max),
    (Zh = Date.now),
    (Uh = yp(p, 'Map')),
    (Xh = yp(Object, 'create')),
    (Yh = function (e) {
      return kp(e) ? (Fh ? Fh(e) : ((ap.prototype = e), (e = new ap()), (ap.prototype = void 0), e)) : {}
    }),
    (lp.prototype.clear = function () {
      ;(this.__data__ = Xh ? Xh(null) : {}), (this.size = 0)
    }),
    (lp.prototype.delete = function (e) {
      return (e = this.has(e) && delete this.__data__[e]), (this.size -= e ? 1 : 0), e
    }),
    (lp.prototype.get = function (e) {
      var t,
        n = this.__data__
      return Xh ? ((t = n[e]) === fh ? void 0 : t) : Ih.call(n, e) ? n[e] : void 0
    }),
    (lp.prototype.has = function (e) {
      var t = this.__data__
      return Xh ? void 0 !== t[e] : Ih.call(t, e)
    }),
    (lp.prototype.set = function (e, t) {
      var n = this.__data__
      return (this.size += this.has(e) ? 0 : 1), (n[e] = Xh && void 0 === t ? fh : t), this
    }),
    (sp.prototype.clear = function () {
      ;(this.__data__ = []), (this.size = 0)
    }),
    (sp.prototype.delete = function (e) {
      var t = this.__data__
      return !((e = fp(t, e)) < 0 || (e == t.length - 1 ? t.pop() : Bh.call(t, e, 1), --this.size, 0))
    }),
    (sp.prototype.get = function (e) {
      var t = this.__data__
      return (e = fp(t, e)) < 0 ? void 0 : t[e][1]
    }),
    (sp.prototype.has = function (e) {
      return -1 < fp(this.__data__, e)
    }),
    (sp.prototype.set = function (e, t) {
      var n = this.__data__,
        r = fp(n, e)
      return r < 0 ? (++this.size, n.push([e, t])) : (n[r][1] = t), this
    }),
    (cp.prototype.clear = function () {
      ;(this.size = 0), (this.__data__ = { hash: new lp(), map: new (Uh || sp)(), string: new lp() })
    }),
    (cp.prototype.delete = function (e) {
      return (e = vp(this, e).delete(e)), (this.size -= e ? 1 : 0), e
    }),
    (cp.prototype.get = function (e) {
      return vp(this, e).get(e)
    }),
    (cp.prototype.has = function (e) {
      return vp(this, e).has(e)
    }),
    (cp.prototype.set = function (e, t) {
      var n = vp(this, e),
        r = n.size
      return n.set(e, t), (this.size += n.size == r ? 0 : 1), this
    }),
    (up.prototype.clear = function () {
      ;(this.__data__ = new sp()), (this.size = 0)
    }),
    (up.prototype.delete = function (e) {
      var t = this.__data__
      e = t.delete(e)
      return (this.size = t.size), e
    }),
    (up.prototype.get = function (e) {
      return this.__data__.get(e)
    }),
    (up.prototype.has = function (e) {
      return this.__data__.has(e)
    }),
    (up.prototype.set = function (e, t) {
      var n = this.__data__
      if (n instanceof sp) {
        var r = n.__data__
        if (!Uh || r.length < 199) return r.push([e, t]), (this.size = ++n.size), this
        n = this.__data__ = new cp(r)
      }
      return n.set(e, t), (this.size = n.size), this
    }),
    (qh = function (e, t, n) {
      for (var r = -1, i = Object(e), o = n(e), a = o.length; a--; ) {
        var l = o[++r]
        if (!1 === t(i[l], l, i)) break
      }
      return e
    }),
    ($h = Wh
      ? function (e, t) {
          return Wh(e, 'toString', {
            configurable: !0,
            enumerable: !1,
            value:
              ((n = t),
              function () {
                return n
              }),
            writable: !0
          })
          var n
        }
      : Lp),
    (Qh = Kh = 0),
    (Jh = function () {
      var e = Zh(),
        t = 16 - (e - Qh)
      if (((Qh = e), 0 < t)) {
        if (800 <= ++Kh) return arguments[0]
      } else Kh = 0
      return $h.apply(void 0, arguments)
    }),
    (ep = gp(
      (function () {
        return arguments
      })()
    )
      ? gp
      : function (e) {
          return Pp(e) && Ih.call(e, 'callee') && !Hh.call(e, 'callee')
        }),
    (tp = Array.isArray),
    (np =
      y ||
      function () {
        return !1
      }),
    (ip = mg
      ? ((rp = mg),
        function (e) {
          return rp(e)
        })
      : function (e) {
          return Pp(e) && Op(e.length) && !!Sh[pp(e)]
        }),
    (op = function (e, t, n) {
      mp(e, t, n)
    }),
    (l = (function (e, t) {
      return Jh(
        ((n = e),
        (i = Lp),
        (r = Gh(void 0 === (r = t) ? n.length - 1 : r, 0)),
        function () {
          for (var e = arguments, t = -1, o = Gh(e.length - r, 0), a = Array(o); ++t < o; ) a[t] = e[r + t]
          t = -1
          for (var l = Array(r + 1); ++t < r; ) l[t] = e[t]
          l[r] = i(a)
          var s = n,
            c = this,
            u = l
          switch (u.length) {
            case 0:
              return s.call(c)
            case 1:
              return s.call(c, u[0])
            case 2:
              return s.call(c, u[0], u[1])
            case 3:
              return s.call(c, u[0], u[1], u[2])
          }
          return s.apply(c, u)
        }),
        e + ''
      )
      var n, r, i
    })(function (e, t) {
      var n = -1,
        r = t.length,
        i = 1 < r ? t[r - 1] : void 0,
        o = 2 < r ? t[2] : void 0
      i = 3 < op.length && 'function' == typeof i ? (r--, i) : void 0
      for (
        o &&
          (function (e, t, n) {
            if (kp(n)) {
              var r = typeof t
              if ('number' == r ? Ep(n) && bp(t, n.length) : 'string' == r && (t in n)) return xp(n[t], e)
            }
          })(t[0], t[1], o) &&
          ((i = r < 3 ? void 0 : i), (r = 1)),
          e = Object(e);
        ++n < r;

      ) {
        var a = t[n]
        a && op(e, a, n)
      }
      return e
    })),
    (f.exports = l)
  var Ip = h.exports
  function Mp(e, t) {
    ;(null == t || t > e.length) && (t = e.length)
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n]
    return r
  }
  function jp(e) {
    if (('undefined' != typeof Symbol && null != e[Symbol.iterator]) || null != e['@@iterator']) return Array.from(e)
  }
  function Rp(e, t) {
    var n
    if (e)
      return 'string' == typeof e
        ? Mp(e, t)
        : 'Map' ===
            (n =
              'Object' === (n = Object.prototype.toString.call(e).slice(8, -1)) && e.constructor
                ? e.constructor.name
                : n) || 'Set' === n
        ? Array.from(e)
        : 'Arguments' === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
        ? Mp(e, t)
        : void 0
  }
  function Dp(e) {
    return (
      (function (e) {
        if (Array.isArray(e)) return Mp(e)
      })(e) ||
      jp(e) ||
      Rp(e) ||
      (function () {
        throw new TypeError(
          'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
        )
      })()
    )
  }
  function Ap(e, t) {
    function n(t) {
      return 'Sfx'.concat(e).concat(t ? '-'.concat(t) : '')
    }
    var r = []
    return (
      t &&
        (Array.isArray(t)
          ? r.push.apply(
              r,
              Dp(
                t
                  .filter(function (e) {
                    return 'string' == typeof e
                  })
                  .map(n)
              )
            )
          : 'string' == typeof t && r.push(n(t))),
      0 === r.length && r.push(n()),
      r.join(' ')
    )
  }
  function zp(e, t) {
    var n = s.exports.forwardRef(e)
    return (n.displayName = t || e.name), n
  }
  function Np(e) {
    return Object.keys(e)
  }
  function Fp(e) {
    return Object.values(e)
  }
  function Hp(e) {
    return Object.keys(e).reduce(function (t, n) {
      var i = e[n]
      return (i.displayName = ''.concat(n)), Object.assign(t, r({}, n, i))
    }, {})
  }
  function Bp(e, t) {
    'function' == typeof e ? e(t) : e && (e.current = t)
  }
  function Vp(e, t) {
    return s.exports.useMemo(
      function () {
        return null == e && null == t
          ? null
          : function (n) {
              Bp(e, n), Bp(t, n)
            }
      },
      [e, t]
    )
  }
  function Wp(e, t, n) {
    return (
      (t = 1 < arguments.length && void 0 !== t ? t : 0),
      (n = (2 < arguments.length ? n : void 0) || 1e6),
      Math.min(Math.max(t, +e), n)
    )
  }
  function Gp(e, t, n, r, i) {
    return ((e - t) * (i - r)) / (n - t) + r
  }
  function Zp() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n]
    return '#'.concat(t.map(Kp).join(''))
  }
  function Up(e) {
    var t
    return e.startsWith('#')
      ? (4 === (t = e).length &&
          (t = '#'.concat(e[1]).concat(e[1]).concat(e[2]).concat(e[2]).concat(e[3]).concat(e[3])),
        Qp.apply(void 0, Dp($p(t))))
      : e.startsWith('rgb')
      ? ((t = qp(e)), Qp.apply(void 0, Dp(t)))
      : 'string' == typeof e
      ? [0, 0, 0]
      : e
  }
  function Xp(e) {
    return e.startsWith('#')
      ? 7 === e.length
        ? e
        : '#'.concat(e[0]).concat(e[0]).concat(e[1]).concat(e[1]).concat(e[2]).concat(e[2])
      : e.startsWith('rgb')
      ? Zp.apply(void 0, Dp(qp(e)))
      : 'string' == typeof e
      ? '#000000'
      : e
  }
  function Yp(e) {
    return /^#[\da-f]{6}$/i.test(e)
  }
  var qp = function (e) {
      return e
        .replaceAll(/[^\d,]/gi, '')
        .split(',')
        .map(function (e) {
          return +e
        })
    },
    $p = function (e) {
      return e
        ? [Number.parseInt(e.slice(1, 3), 16), Number.parseInt(e.slice(3, 5), 16), Number.parseInt(e.slice(5, 7), 16)]
        : [0, 0, 0]
    },
    Kp = function (e) {
      return e.toString(16).padStart(2, '0')
    },
    Qp = function () {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n]
      var r,
        i = t[0],
        o = t[1],
        a = t[2],
        l = ((i /= 255), (o /= 255), (a /= 255), Math.min(i, o, a)),
        s = Math.max(i, o, a),
        c = (s + l) / 2
      if (s === l) d = r = 0
      else {
        var u = s - l,
          d = 0.5 < c ? u / (2 - s - l) : u / (s + l)
        switch (s) {
          case i:
            r = (o - a) / u + (o < a ? 6 : 0)
            break
          case o:
            r = (a - i) / u + 2
            break
          case a:
            r = (i - o) / u + 4
            break
          default:
            r = 0
        }
        r /= 6
      }
      return [Math.round(360 * r), Math.round(100 * d), Math.round(100 * c)]
    },
    Jp = function (e, t) {
      return 0 === t && (0 === e || 1 === e)
    },
    eg = function (e, t) {
      return 0 === e && 1 === t
    }
  function tg(e) {
    var t, n, r, i, o
    return e
      ? ((e = e.getBoundingClientRect()),
        (i = document.body),
        (r = document.documentElement),
        (o = window.pageYOffset || r.scrollTop || i.scrollTop),
        (t = window.pageXOffset || r.scrollLeft || i.scrollLeft),
        (n = r.clientTop || i.clientTop || 0),
        (r = r.clientLeft || i.clientLeft || 0),
        (i = e.top + o - n),
        (o = e.left + t - r),
        { top: Math.round(i), left: Math.round(o), width: e.width, height: e.height })
      : null
  }
  function ng(e, t) {
    return e - t
  }
  function rg(e, t, n) {
    return (100 * (e - t)) / (n - t)
  }
  function ig(e) {
    var t = e.values,
      n = e.newValue
    e = e.index
    return ((t = t.slice())[e] = n), t.sort(ng)
  }
  function og(e) {
    return (e && e.ownerDocument) || document
  }
  function ag(e, t, n) {
    return null == e ? t : Math.min(Math.max(t, e), n)
  }
  function lg(e, t) {
    if (void 0 !== t.current && e.changedTouches) {
      for (var n = 0; n < e.changedTouches.length; n += 1) {
        var r = e.changedTouches[n]
        if (r.identifier === t.current) return { x: r.clientX, y: r.clientY }
      }
      return !1
    }
    return { x: e.clientX, y: e.clientY }
  }
  var sg = {
    horizontal: {
      offset: function (e) {
        return { left: ''.concat(e, '%') }
      },
      leap: function (e) {
        return { width: ''.concat(e, '%') }
      }
    },
    'horizontal-reverse': {
      offset: function (e) {
        return { right: ''.concat(e, '%') }
      },
      leap: function (e) {
        return { width: ''.concat(e, '%') }
      }
    },
    vertical: {
      offset: function (e) {
        return { bottom: ''.concat(e, '%') }
      },
      leap: function (e) {
        return { height: ''.concat(e, '%') }
      }
    }
  }
  function cg(e) {
    var t = e.sliderRef,
      n = e.activeIndex,
      r = ((e = e.setActive), og(t.current))
    ;(t.current.contains(r.activeElement) && Number(r.activeElement.getAttribute('data-index')) === n) ||
      (null != (r = t.current.querySelector('[type="range"][data-index="'.concat(n, '"]'))) && r.focus()),
      e && e(n)
  }
  var ug = { Xs: 'xs', Sm: 'sm', Md: 'md', Lg: 'lg', Xl: 'xl' },
    dg = {
      TextPrimary: 'txt-primary',
      TextPrimaryInvert: 'txt-primary-invert',
      TextSecondary: 'txt-secondary',
      TextSecondaryInvert: 'txt-secondary-invert',
      TextPlaceholder: 'txt-placeholder',
      AccentPrimary: 'accent-primary',
      AccentPrimaryHover: 'accent-primary-hover',
      AccentPrimaryActive: 'accent-primary-active',
      AccentPrimaryDisabled: 'accent-primary-disabled',
      BackgroundPrimary: 'bg-primary',
      BackgroundPrimaryHover: 'bg-primary-hover',
      BackgroundPrimaryActive: 'bg-primary-active',
      BackgroundPrimary_0_5_Opacity: 'bg-primary-0-5-opacity',
      BackgroundSecondary: 'bg-secondary',
      IconsPrimary: 'icons-primary',
      IconsPrimaryOpacity_0_6: 'icons-primary-opacity-0-6',
      IconsSecondary: 'icons-secondary',
      IconsPlaceholder: 'icons-placeholder',
      ButtonPrimaryText: 'btn-primary-text',
      ButtonDisabledText: 'btn-disabled-text',
      LinkPrimary: 'link-primary',
      LinkHover: 'link-hover',
      LinkActive: 'link-active',
      BordersPrimary: 'borders-primary',
      BordersSecondary: 'borders-secondary',
      BordersStrong: 'borders-strong',
      BordersInvert: 'borders-invert',
      BorderActiveBottom: 'border-active-bottom',
      ActiveSecondary: 'active-secondary',
      ActiveSecondaryHover: 'active-secondary-hover',
      ActiveSecondaryActive: 'active-secondary-active',
      Tag: 'tag',
      Error: 'error',
      Success: 'success',
      Warning: 'warning',
      Info: 'info',
      LightShadow: 'light-shadow'
    },
    fg = {
      TextExtraSmall: 'text-extra-small',
      TextSmall: 'text-small',
      TextNormal: 'text-normal',
      TextEmphasis: 'text-emphasis',
      TextExtraLarge: 'text-extra-large',
      LabelExtraSmall: 'label-extra-small',
      LabelSmall: 'label-small',
      LabelNormal: 'label-normal',
      LabelEmphasis: 'label-emphasis',
      LabelExtraLarge: 'label-extra-large',
      ButtonXs: 'btn-xs',
      ButtonSm: 'btn-sm',
      ButtonMd: 'btn-md',
      ButtonLg: 'btn-lg',
      ButtonXl: 'btn-xl',
      InputSm: 'input-sm',
      InputMd: 'input-md'
    },
    hg = { Sm: 'sm', Md: 'md', Lg: 'lg' }
  function pg(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function gg(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {}
      t % 2
        ? pg(Object(n), !0).forEach(function (t) {
            r(e, t, n[t])
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
        : pg(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
          })
    }
    return e
  }
  var mg =
      (r(
        (y = {}),
        fg.LabelExtraSmall,
        gg(
          gg({}, (p = { fontFamily: (Og = '"Roboto"'), fontStyle: 'normal', fontWeight: 'normal' })),
          {},
          { fontSize: '10px', lineHeight: '12px' }
        )
      ),
      r(y, fg.LabelSmall, gg(gg({}, p), {}, { fontSize: '12px', lineHeight: '14px' })),
      r(y, fg.LabelNormal, gg(gg({}, p), {}, { fontSize: '14px', lineHeight: '16px' })),
      r(y, fg.LabelEmphasis, gg(gg({}, p), {}, { fontWeight: '500', fontSize: '14px', lineHeight: '16px' })),
      r(y, fg.LabelExtraLarge, gg(gg({}, p), {}, { fontWeight: '500', fontSize: '24px', lineHeight: '28px' })),
      y),
    vg = {
      breakpoints: {
        keys: [ug.Xs, ug.Sm, ug.Md, ug.Lg, ug.Xl],
        values: (r((f = {}), ug.Xs, 0), r(f, ug.Sm, 768), r(f, ug.Md, 1201), r(f, ug.Lg, 1921), r(f, ug.Xl, 2560), f),
        classes:
          (r((l = {}), ug.Xs, '.sfx-breakpoint-xs'),
          r(l, ug.Sm, '.sfx-breakpoint-sm'),
          r(l, ug.Md, '.sfx-breakpoint-md'),
          r(l, ug.Lg, '.sfx-breakpoint-lg'),
          r(l, ug.Xl, '.sfx-breakpoint-xl'),
          l),
        getBreakpointClass: function () {
          return ''
        },
        up: function () {
          return ''
        },
        down: function () {
          return ''
        },
        between: function () {
          return ''
        },
        only: function () {
          return ''
        }
      },
      typography: {
        fontFamily: Og,
        baseLineHeight: 1.375,
        font: gg(
          gg({}, mg),
          {},
          (r((h = {}), fg.TextExtraSmall, gg(gg({}, mg[fg.LabelExtraSmall]), {}, { lineHeight: '1.3' })),
          r(h, fg.TextSmall, gg(gg({}, mg[fg.LabelSmall]), {}, { lineHeight: '1.3' })),
          r(h, fg.TextNormal, gg(gg({}, mg[fg.LabelNormal]), {}, { lineHeight: '1.3' })),
          r(h, fg.TextEmphasis, gg(gg({}, mg[fg.LabelEmphasis]), {}, { lineHeight: '1.3' })),
          r(h, fg.TextExtraLarge, gg(gg({}, mg[fg.LabelExtraLarge]), {}, { lineHeight: '1.3' })),
          r(h, fg.ButtonXs, gg(gg({}, p), {}, { fontWeight: '500', fontSize: '12px', lineHeight: '14px' })),
          r(h, fg.ButtonSm, gg(gg({}, p), {}, { fontWeight: '500', fontSize: '13px', lineHeight: '16px' })),
          r(h, fg.ButtonMd, gg(gg({}, p), {}, { fontWeight: '500', fontSize: '15px', lineHeight: '16px' })),
          r(h, fg.ButtonLg, gg(gg({}, p), {}, { fontWeight: '500', fontSize: '15px', lineHeight: '16px' })),
          r(h, fg.ButtonXl, gg(gg({}, p), {}, { fontWeight: '500', fontSize: '16px', lineHeight: '16px' })),
          r(h, fg.InputSm, gg(gg({}, p), {}, { fontSize: '13px', lineHeight: '16px' })),
          r(h, fg.InputMd, gg(gg({}, p), {}, { fontSize: '14px', lineHeight: '16px' })),
          h)
        )
      },
      shape: { borderRadius: (r((y = {}), hg.Sm, '2px'), r(y, hg.Md, '4px'), r(y, hg.Lg, '8px'), y) }
    },
    yg = dh(['', ';'], function (e) {
      return Yf(['h1,h2,h3,h4,h5,h6,p,small{line-height:', ';}'], e.theme.typography.baseLineHeight)
    }),
    bg = dh([
      '@keyframes spinner{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}.Menu-open{overflow:hidden;}.Modal-open{overflow:hidden;}'
    ])
  r((f = {}), dg.TextPrimary, 'rgba(55,65,75,1)'),
    r(f, dg.TextPrimaryInvert, 'rgba(255,255,255,1)'),
    r(f, dg.TextSecondary, 'rgba(118,129,132,1)'),
    r(f, dg.TextSecondaryInvert, 'rgba(213,216,220,1)'),
    r(f, dg.TextPlaceholder, 'rgba(181,188,190,1)'),
    r(f, dg.AccentPrimary, 'rgba(104,121,235,1)'),
    r(f, dg.AccentPrimaryHover, 'rgba(96,111,209,1)'),
    r(f, dg.AccentPrimaryActive, 'rgba(73,88,188,1)'),
    r(f, dg.AccentPrimaryDisabled, '#E9EEF2'),
    r(f, dg.BackgroundPrimary, 'rgba(248,250,251,1)'),
    r(f, dg.BackgroundPrimaryHover, 'rgba(239,243,246,1)'),
    r(f, dg.BackgroundPrimaryActive, 'rgba(93,109,126,1)'),
    r(f, dg.BackgroundPrimary_0_5_Opacity, 'rgba(255,255,255,0.500)'),
    r(f, dg.BackgroundSecondary, 'rgba(255,255,255,1)'),
    r(f, dg.IconsPrimary, 'rgba(93,109,126,1)'),
    r(f, dg.IconsPrimaryOpacity_0_6, 'rgba(93,109,126,0.600)'),
    r(f, dg.IconsSecondary, '#959DA8'),
    r(f, dg.IconsPlaceholder, '#DEE6ED'),
    r(f, dg.ButtonPrimaryText, 'rgba(255,255,255,1)'),
    r(f, dg.ButtonDisabledText, '#A9B6C2'),
    r(f, dg.LinkPrimary, '#5D6D7E'),
    r(f, dg.LinkHover, '#768A9F'),
    r(f, dg.LinkActive, '#92A6BC'),
    r(f, dg.BordersPrimary, 'rgba(223,231,237,1)'),
    r(f, dg.BordersSecondary, 'rgba(223,231,237,1)'),
    r(f, dg.BordersStrong, 'rgba(223,231,237,1)'),
    r(f, dg.BordersInvert, 'rgba(85,99,115,1)'),
    r(f, dg.BorderActiveBottom, '#6879EB'),
    r(f, dg.ActiveSecondary, '#E9EEF2'),
    r(f, dg.ActiveSecondaryHover, '#DFE4E9'),
    r(f, dg.ActiveSecondaryActive, '#CBD3DA'),
    r(f, dg.Tag, '#889AAC'),
    r(f, dg.Error, 'rgba(232,91,70,1)'),
    r(f, dg.Success, 'rgba(62,207,139,1)'),
    r(f, dg.Warning, 'rgba(255,172,74,1)'),
    r(f, dg.Info, 'rgba(110,123,178,1)'),
    r(f, dg.LightShadow, 'rgba(77, 78, 78, 0.25)')
  var wg = f,
    Cg = function (e) {
      function t(e) {
        return (e = 'number' == typeof i[e] ? i[e] : e), '@media (min-width:'.concat(e).concat('px', ')')
      }
      function n(e, t) {
        return (
          (t = a.indexOf(t)),
          '@media (min-width:'.concat(i[e]).concat('px', ') and (max-width:').concat(i[a[t]]).concat('px', ')')
        )
      }
      var r,
        i = void 0 === (r = e.values) ? vg.breakpoints.values : r,
        o = void 0 === (r = e.classes) ? vg.breakpoints.classes : r,
        a = Object.keys(i)
      return {
        keys: a,
        values: i,
        classes: o,
        getBreakpointClass: function (e, t) {
          function n(e) {
            return e.slice(1)
          }
          return e >= i.xs && e <= i.sm
            ? t
              ? n(o.xs)
              : o.xs
            : e >= i.sm && e < i.md
            ? t
              ? n(o.sm)
              : o.sm
            : e >= i.md && e < i.lg
            ? t
              ? n(o.md)
              : o.md
            : e >= i.lg && e < i.xl
            ? t
              ? n(o.lg)
              : o.lg
            : e >= i.xl
            ? t
              ? n(o.xl)
              : o.xl
            : t
            ? n(o.md)
            : o.md
        },
        up: t,
        down: function (e) {
          return (e = i[e]), '@media (max-width:'.concat(e).concat('px', ')')
        },
        between: n,
        only: function (e) {
          return a.indexOf(e) + 1 < a.length ? n(e, a[a.indexOf(e) + 1]) : t(e)
        }
      }
    }
  function xg(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function Eg(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {}
      t % 2
        ? xg(Object(n), !0).forEach(function (t) {
            r(e, t, n[t])
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
        : xg(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
          })
    }
    return e
  }
  function Sg(e) {
    var t = e.children,
      n = void 0 === (a = (e = void 0 === (e = e.theme) ? {} : e).palette) ? {} : a,
      r = void 0 === (a = e.breakpoints) ? {} : a,
      i = void 0 === (a = e.typography) ? {} : a,
      o = void 0 === (a = e.shape) ? {} : a,
      a = s.exports.useMemo(
        function () {
          return {
            palette: Eg(Eg({}, wg), n),
            breakpoints: Cg(r),
            typography: Eg({}, Ip(Eg({}, vg.typography), Eg({}, i))),
            shape: Eg({}, Ip(Eg({}, vg.shape), Eg({}, o)))
          }
        },
        [JSON.stringify(e)]
      )
    return ue.createElement(
      oh,
      { theme: a },
      ue.createElement(
        ue.Fragment,
        null,
        (function (e) {
          for (var t = arguments.length, n = new Array(1 < t ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r]
          return 'function' == typeof e ? e.apply(void 0, n) : e
        })(t, a),
        ue.createElement(bg, null),
        ue.createElement(yg, null)
      )
    )
  }
  var Og = ((l = vg.typography).baseLineHeight, l.font, Hu(l, ['baseLineHeight', 'font'])),
    kg =
      ((Sg.propTypes = {
        children: ce.oneOfType([ce.node, ce.func, ce.arrayOf(ce.node)]).isRequired,
        theme: ce.exact({
          breakpoints: ce.exact({
            keys: ce.arrayOf(ce.string),
            values: ce.exact(Tp(Fp(ug), ce.number)),
            classes: ce.exact(
              Tp(
                Np({
                  Xs: '.sfx-breakpoint-xs',
                  Sm: '.sfx-breakpoint-sm',
                  Md: '.sfx-breakpoint-md',
                  Lg: '.sfx-breakpoint-lg',
                  Xl: '.sfx-breakpoint-xl'
                }),
                ce.string
              )
            ),
            getBreakpointClass: ce.func,
            up: ce.func,
            down: ce.func,
            between: ce.func,
            only: ce.func
          }),
          palette: ce.exact(Tp(Fp(dg), ce.string)),
          shape: ce.exact({ borderRadius: ce.exact(Tp(Fp(hg), ce.string)) }),
          typography: ce.exact(
            Eg(
              { baseLineHeight: ce.oneOfType([ce.string, ce.number]), font: ce.exact(Tp(Fp(fg), ce.object)) },
              Tp(Np(Og), ce.string)
            )
          )
        })
      }),
      Sg)
  function Pg(e) {
    if (Array.isArray(e)) return e
  }
  function _g() {
    throw new TypeError(
      'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
    )
  }
  function Lg(e, t) {
    return (
      Pg(e) ||
      (function (e, t) {
        var n = null == e ? null : ('undefined' != typeof Symbol && e[Symbol.iterator]) || e['@@iterator']
        if (null != n) {
          var r,
            i,
            o,
            a,
            l = [],
            s = !0,
            c = !1
          try {
            if (((o = (n = n.call(e)).next), 0 === t)) {
              if (Object(n) !== n) return
              s = !1
            } else for (; !(s = (r = o.call(n)).done) && (l.push(r.value), l.length !== t); s = !0);
          } catch (u) {
            ;(c = !0), (i = u)
          } finally {
            try {
              if (!s && null != n.return && ((a = n.return()), Object(a) !== a)) return
            } finally {
              if (c) throw i
            }
          }
          return l
        }
      })(e, t) ||
      Rp(e, t) ||
      _g()
    )
  }
  function Tg() {
    return (Tg = Object.assign
      ? Object.assign.bind()
      : function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n,
              r = arguments[t]
            for (n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
          }
          return e
        }).apply(this, arguments)
  }
  var Ig = Math.PI / 180
  const Mg =
      'undefined' != typeof global
        ? global
        : 'undefined' != typeof window
        ? window
        : 'undefined' != typeof WorkerGlobalScope
        ? self
        : {},
    jg = {
      _global: Mg,
      isBrowser:
        'undefined' != typeof window &&
        ('[object Window]' === {}.toString.call(window) || '[object global]' === {}.toString.call(window)),
      isUnminified: /param/.test(function (e) {}.toString()),
      dblClickWindow: 400,
      getAngle: e => (jg.angleDeg ? e * Ig : e),
      enableTrace: !1,
      pointerEventsEnabled: !0,
      autoDrawEnabled: !0,
      hitOnDragEnabled: !1,
      capturePointerEventsEnabled: !1,
      _mouseListenClick: !1,
      _touchListenClick: !1,
      _pointerListenClick: !1,
      _mouseInDblClickWindow: !1,
      _touchInDblClickWindow: !1,
      _pointerInDblClickWindow: !1,
      _mouseDblClickPointerId: null,
      _touchDblClickPointerId: null,
      _pointerDblClickPointerId: null,
      pixelRatio: ('undefined' != typeof window && window.devicePixelRatio) || 1,
      dragDistance: 3,
      angleDeg: !0,
      showWarnings: !0,
      dragButtons: [0, 1],
      isDragging: () => jg.DD.isDragging,
      isDragReady: () => !!jg.DD.node,
      releaseCanvasOnDestroy: !0,
      document: Mg.document,
      _injectGlobal(e) {
        Mg.Konva = e
      }
    }
  ;(mg = e => {
    jg[e.prototype.getClassName()] = e
  }),
    jg._injectGlobal(jg)
  class Rg {
    constructor(e = [1, 0, 0, 1, 0, 0]) {
      ;(this.dirty = !1), (this.m = (e && e.slice()) || [1, 0, 0, 1, 0, 0])
    }
    reset() {
      ;(this.m[0] = 1), (this.m[1] = 0), (this.m[2] = 0), (this.m[3] = 1), (this.m[4] = 0), (this.m[5] = 0)
    }
    copy() {
      return new Rg(this.m)
    }
    copyInto(e) {
      ;(e.m[0] = this.m[0]),
        (e.m[1] = this.m[1]),
        (e.m[2] = this.m[2]),
        (e.m[3] = this.m[3]),
        (e.m[4] = this.m[4]),
        (e.m[5] = this.m[5])
    }
    point(e) {
      var t = this.m
      return { x: t[0] * e.x + t[2] * e.y + t[4], y: t[1] * e.x + t[3] * e.y + t[5] }
    }
    translate(e, t) {
      return (this.m[4] += this.m[0] * e + this.m[2] * t), (this.m[5] += this.m[1] * e + this.m[3] * t), this
    }
    scale(e, t) {
      return (this.m[0] *= e), (this.m[1] *= e), (this.m[2] *= t), (this.m[3] *= t), this
    }
    rotate(e) {
      var t = Math.cos(e),
        n = ((e = Math.sin(e)), this.m[0] * t + this.m[2] * e),
        r = this.m[1] * t + this.m[3] * e,
        i = this.m[0] * -e + this.m[2] * t
      e = this.m[1] * -e + this.m[3] * t
      return (this.m[0] = n), (this.m[1] = r), (this.m[2] = i), (this.m[3] = e), this
    }
    getTranslation() {
      return { x: this.m[4], y: this.m[5] }
    }
    skew(e, t) {
      var n = this.m[0] + this.m[2] * t,
        r = ((t = this.m[1] + this.m[3] * t), this.m[2] + this.m[0] * e)
      e = this.m[3] + this.m[1] * e
      return (this.m[0] = n), (this.m[1] = t), (this.m[2] = r), (this.m[3] = e), this
    }
    multiply(e) {
      var t = this.m[0] * e.m[0] + this.m[2] * e.m[1],
        n = this.m[1] * e.m[0] + this.m[3] * e.m[1],
        r = this.m[0] * e.m[2] + this.m[2] * e.m[3],
        i = this.m[1] * e.m[2] + this.m[3] * e.m[3],
        o = this.m[0] * e.m[4] + this.m[2] * e.m[5] + this.m[4]
      e = this.m[1] * e.m[4] + this.m[3] * e.m[5] + this.m[5]
      return (this.m[0] = t), (this.m[1] = n), (this.m[2] = r), (this.m[3] = i), (this.m[4] = o), (this.m[5] = e), this
    }
    invert() {
      var e = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]),
        t = this.m[3] * e,
        n = -this.m[1] * e,
        r = -this.m[2] * e,
        i = this.m[0] * e,
        o = e * (this.m[2] * this.m[5] - this.m[3] * this.m[4])
      e *= this.m[1] * this.m[4] - this.m[0] * this.m[5]
      return (this.m[0] = t), (this.m[1] = n), (this.m[2] = r), (this.m[3] = i), (this.m[4] = o), (this.m[5] = e), this
    }
    getMatrix() {
      return this.m
    }
    decompose() {
      var e,
        t = this.m[0],
        n = this.m[1],
        r = this.m[2],
        i = this.m[3],
        o = t * i - n * r,
        a = { x: this.m[4], y: this.m[5], rotation: 0, scaleX: 0, scaleY: 0, skewX: 0, skewY: 0 }
      return (
        0 != t || 0 != n
          ? ((e = Math.sqrt(t * t + n * n)),
            (a.rotation = 0 < n ? Math.acos(t / e) : -Math.acos(t / e)),
            (a.scaleX = e),
            (a.scaleY = o / e),
            (a.skewX = (t * r + n * i) / o),
            (a.skewY = 0))
          : (0 == r && 0 == i) ||
            ((e = Math.sqrt(r * r + i * i)),
            (a.rotation = Math.PI / 2 - (0 < i ? Math.acos(-r / e) : -Math.acos(r / e))),
            (a.scaleX = o / e),
            (a.scaleY = e),
            (a.skewX = 0),
            (a.skewY = (t * r + n * i) / o)),
        (a.rotation = Vg._getRotation(a.rotation)),
        a
      )
    }
  }
  var Dg = Math.PI / 180,
    Ag = 180 / Math.PI,
    zg = 'Konva error: ',
    Ng = {
      aliceblue: [240, 248, 255],
      antiquewhite: [250, 235, 215],
      aqua: [0, 255, 255],
      aquamarine: [127, 255, 212],
      azure: [240, 255, 255],
      beige: [245, 245, 220],
      bisque: [255, 228, 196],
      black: [0, 0, 0],
      blanchedalmond: [255, 235, 205],
      blue: [0, 0, 255],
      blueviolet: [138, 43, 226],
      brown: [165, 42, 42],
      burlywood: [222, 184, 135],
      cadetblue: [95, 158, 160],
      chartreuse: [127, 255, 0],
      chocolate: [210, 105, 30],
      coral: [255, 127, 80],
      cornflowerblue: [100, 149, 237],
      cornsilk: [255, 248, 220],
      crimson: [220, 20, 60],
      cyan: [0, 255, 255],
      darkblue: [0, 0, 139],
      darkcyan: [0, 139, 139],
      darkgoldenrod: [184, 132, 11],
      darkgray: [169, 169, 169],
      darkgreen: [0, 100, 0],
      darkgrey: [169, 169, 169],
      darkkhaki: [189, 183, 107],
      darkmagenta: [139, 0, 139],
      darkolivegreen: [85, 107, 47],
      darkorange: [255, 140, 0],
      darkorchid: [153, 50, 204],
      darkred: [139, 0, 0],
      darksalmon: [233, 150, 122],
      darkseagreen: [143, 188, 143],
      darkslateblue: [72, 61, 139],
      darkslategray: [47, 79, 79],
      darkslategrey: [47, 79, 79],
      darkturquoise: [0, 206, 209],
      darkviolet: [148, 0, 211],
      deeppink: [255, 20, 147],
      deepskyblue: [0, 191, 255],
      dimgray: [105, 105, 105],
      dimgrey: [105, 105, 105],
      dodgerblue: [30, 144, 255],
      firebrick: [178, 34, 34],
      floralwhite: [255, 255, 240],
      forestgreen: [34, 139, 34],
      fuchsia: [255, 0, 255],
      gainsboro: [220, 220, 220],
      ghostwhite: [248, 248, 255],
      gold: [255, 215, 0],
      goldenrod: [218, 165, 32],
      gray: [128, 128, 128],
      green: [0, 128, 0],
      greenyellow: [173, 255, 47],
      grey: [128, 128, 128],
      honeydew: [240, 255, 240],
      hotpink: [255, 105, 180],
      indianred: [205, 92, 92],
      indigo: [75, 0, 130],
      ivory: [255, 255, 240],
      khaki: [240, 230, 140],
      lavender: [230, 230, 250],
      lavenderblush: [255, 240, 245],
      lawngreen: [124, 252, 0],
      lemonchiffon: [255, 250, 205],
      lightblue: [173, 216, 230],
      lightcoral: [240, 128, 128],
      lightcyan: [224, 255, 255],
      lightgoldenrodyellow: [250, 250, 210],
      lightgray: [211, 211, 211],
      lightgreen: [144, 238, 144],
      lightgrey: [211, 211, 211],
      lightpink: [255, 182, 193],
      lightsalmon: [255, 160, 122],
      lightseagreen: [32, 178, 170],
      lightskyblue: [135, 206, 250],
      lightslategray: [119, 136, 153],
      lightslategrey: [119, 136, 153],
      lightsteelblue: [176, 196, 222],
      lightyellow: [255, 255, 224],
      lime: [0, 255, 0],
      limegreen: [50, 205, 50],
      linen: [250, 240, 230],
      magenta: [255, 0, 255],
      maroon: [128, 0, 0],
      mediumaquamarine: [102, 205, 170],
      mediumblue: [0, 0, 205],
      mediumorchid: [186, 85, 211],
      mediumpurple: [147, 112, 219],
      mediumseagreen: [60, 179, 113],
      mediumslateblue: [123, 104, 238],
      mediumspringgreen: [0, 250, 154],
      mediumturquoise: [72, 209, 204],
      mediumvioletred: [199, 21, 133],
      midnightblue: [25, 25, 112],
      mintcream: [245, 255, 250],
      mistyrose: [255, 228, 225],
      moccasin: [255, 228, 181],
      navajowhite: [255, 222, 173],
      navy: [0, 0, 128],
      oldlace: [253, 245, 230],
      olive: [128, 128, 0],
      olivedrab: [107, 142, 35],
      orange: [255, 165, 0],
      orangered: [255, 69, 0],
      orchid: [218, 112, 214],
      palegoldenrod: [238, 232, 170],
      palegreen: [152, 251, 152],
      paleturquoise: [175, 238, 238],
      palevioletred: [219, 112, 147],
      papayawhip: [255, 239, 213],
      peachpuff: [255, 218, 185],
      peru: [205, 133, 63],
      pink: [255, 192, 203],
      plum: [221, 160, 203],
      powderblue: [176, 224, 230],
      purple: [128, 0, 128],
      rebeccapurple: [102, 51, 153],
      red: [255, 0, 0],
      rosybrown: [188, 143, 143],
      royalblue: [65, 105, 225],
      saddlebrown: [139, 69, 19],
      salmon: [250, 128, 114],
      sandybrown: [244, 164, 96],
      seagreen: [46, 139, 87],
      seashell: [255, 245, 238],
      sienna: [160, 82, 45],
      silver: [192, 192, 192],
      skyblue: [135, 206, 235],
      slateblue: [106, 90, 205],
      slategray: [119, 128, 144],
      slategrey: [119, 128, 144],
      snow: [255, 255, 250],
      springgreen: [0, 255, 127],
      steelblue: [70, 130, 180],
      tan: [210, 180, 140],
      teal: [0, 128, 128],
      thistle: [216, 191, 216],
      transparent: [255, 255, 255, 0],
      tomato: [255, 99, 71],
      turquoise: [64, 224, 208],
      violet: [238, 130, 238],
      wheat: [245, 222, 179],
      white: [255, 255, 255],
      whitesmoke: [245, 245, 245],
      yellow: [255, 255, 0],
      yellowgreen: [154, 205, 5]
    },
    Fg = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/,
    Hg = []
  const Bg =
      ('undefined' != typeof requestAnimationFrame && requestAnimationFrame) ||
      function (e) {
        setTimeout(e, 60)
      },
    Vg = {
      _isElement: e => !(!e || 1 != e.nodeType),
      _isFunction: e => !!(e && e.constructor && e.call && e.apply),
      _isPlainObject: e => !!e && e.constructor === Object,
      _isArray: e => '[object Array]' === Object.prototype.toString.call(e),
      _isNumber: e => '[object Number]' === Object.prototype.toString.call(e) && !isNaN(e) && isFinite(e),
      _isString: e => '[object String]' === Object.prototype.toString.call(e),
      _isBoolean: e => '[object Boolean]' === Object.prototype.toString.call(e),
      isObject: e => e instanceof Object,
      isValidSelector: e => 'string' == typeof e && ('#' === (e = e[0]) || '.' === e || e === e.toUpperCase()),
      _sign: e => (0 === e || 0 < e ? 1 : -1),
      requestAnimFrame(e) {
        Hg.push(e),
          1 === Hg.length &&
            Bg(function () {
              var e = Hg
              ;(Hg = []),
                e.forEach(function (e) {
                  e()
                })
            })
      },
      createCanvasElement() {
        var e = document.createElement('canvas')
        try {
          e.style = e.style || {}
        } catch (t) {}
        return e
      },
      createImageElement: () => document.createElement('img'),
      _isInDocument(e) {
        for (; (e = e.parentNode); ) if (e == document) return !0
        return !1
      },
      _urlToImage(e, t) {
        var n = Vg.createImageElement()
        ;(n.onload = function () {
          t(n)
        }),
          (n.src = e)
      },
      _rgbToHex: (e, t, n) => ((1 << 24) + (e << 16) + (t << 8) + n).toString(16).slice(1),
      _hexToRgb: e => (
        (e = e.replace('#', '')), { r: ((e = parseInt(e, 16)) >> 16) & 255, g: (e >> 8) & 255, b: 255 & e }
      ),
      getRandomColor() {
        for (var e = ((16777215 * Math.random()) << 0).toString(16); e.length < 6; ) e = '0' + e
        return '#' + e
      },
      getRGB(e) {
        var t
        return e in Ng
          ? { r: (t = Ng[e])[0], g: t[1], b: t[2] }
          : '#' === e[0]
          ? this._hexToRgb(e.substring(1))
          : 'rgb(' === e.substr(0, 4)
          ? ((t = Fg.exec(e.replace(/ /g, ''))),
            { r: parseInt(t[1], 10), g: parseInt(t[2], 10), b: parseInt(t[3], 10) })
          : { r: 0, g: 0, b: 0 }
      },
      colorToRGBA: e => (
        (e = e || 'black'),
        Vg._namedColorToRBA(e) ||
          Vg._hex3ColorToRGBA(e) ||
          Vg._hex4ColorToRGBA(e) ||
          Vg._hex6ColorToRGBA(e) ||
          Vg._hex8ColorToRGBA(e) ||
          Vg._rgbColorToRGBA(e) ||
          Vg._rgbaColorToRGBA(e) ||
          Vg._hslColorToRGBA(e)
      ),
      _namedColorToRBA: e => ((e = Ng[e.toLowerCase()]) ? { r: e[0], g: e[1], b: e[2], a: 1 } : null),
      _rgbColorToRGBA(e) {
        if (0 === e.indexOf('rgb('))
          return { r: (e = (e = e.match(/rgb\(([^)]+)\)/)[1]).split(/ *, */).map(Number))[0], g: e[1], b: e[2], a: 1 }
      },
      _rgbaColorToRGBA(e) {
        if (0 === e.indexOf('rgba('))
          return {
            r: (e = (e = e.match(/rgba\(([^)]+)\)/)[1])
              .split(/ *, */)
              .map((e, t) =>
                '%' === e.slice(-1) ? (3 === t ? parseInt(e) / 100 : (parseInt(e) / 100) * 255) : Number(e)
              ))[0],
            g: e[1],
            b: e[2],
            a: e[3]
          }
      },
      _hex8ColorToRGBA(e) {
        if ('#' === e[0] && 9 === e.length)
          return {
            r: parseInt(e.slice(1, 3), 16),
            g: parseInt(e.slice(3, 5), 16),
            b: parseInt(e.slice(5, 7), 16),
            a: parseInt(e.slice(7, 9), 16) / 255
          }
      },
      _hex6ColorToRGBA(e) {
        if ('#' === e[0] && 7 === e.length)
          return {
            r: parseInt(e.slice(1, 3), 16),
            g: parseInt(e.slice(3, 5), 16),
            b: parseInt(e.slice(5, 7), 16),
            a: 1
          }
      },
      _hex4ColorToRGBA(e) {
        if ('#' === e[0] && 5 === e.length)
          return {
            r: parseInt(e[1] + e[1], 16),
            g: parseInt(e[2] + e[2], 16),
            b: parseInt(e[3] + e[3], 16),
            a: parseInt(e[4] + e[4], 16) / 255
          }
      },
      _hex3ColorToRGBA(e) {
        if ('#' === e[0] && 4 === e.length)
          return { r: parseInt(e[1] + e[1], 16), g: parseInt(e[2] + e[2], 16), b: parseInt(e[3] + e[3], 16), a: 1 }
      },
      _hslColorToRGBA(e) {
        if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(e)) {
          var [, ...e] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(e),
            t = Number(e[0]) / 360,
            n = Number(e[1]) / 100
          e = Number(e[2]) / 100
          let o, a, l
          if (0 == n) return (l = 255 * e), { r: Math.round(l), g: Math.round(l), b: Math.round(l), a: 1 }
          var r = 2 * e - (o = e < 0.5 ? e * (1 + n) : e + n - e * n),
            i = [0, 0, 0]
          for (let e = 0; e < 3; e++)
            (a = t + (1 / 3) * -(e - 1)) < 0 && a++,
              1 < a && a--,
              (l = 6 * a < 1 ? r + 6 * (o - r) * a : 2 * a < 1 ? o : 3 * a < 2 ? r + (o - r) * (2 / 3 - a) * 6 : r),
              (i[e] = 255 * l)
          return { r: Math.round(i[0]), g: Math.round(i[1]), b: Math.round(i[2]), a: 1 }
        }
      },
      haveIntersection: (e, t) =>
        !(t.x > e.x + e.width || t.x + t.width < e.x || t.y > e.y + e.height || t.y + t.height < e.y),
      cloneObject(e) {
        var t,
          n = {}
        for (t in e)
          this._isPlainObject(e[t])
            ? (n[t] = this.cloneObject(e[t]))
            : this._isArray(e[t])
            ? (n[t] = this.cloneArray(e[t]))
            : (n[t] = e[t])
        return n
      },
      cloneArray: e => e.slice(0),
      degToRad: e => e * Dg,
      radToDeg: e => e * Ag,
      _degToRad: e => (Vg.warn('Util._degToRad is removed. Please use public Util.degToRad instead.'), Vg.degToRad(e)),
      _radToDeg: e => (Vg.warn('Util._radToDeg is removed. Please use public Util.radToDeg instead.'), Vg.radToDeg(e)),
      _getRotation: e => (jg.angleDeg ? Vg.radToDeg(e) : e),
      _capitalize: e => e.charAt(0).toUpperCase() + e.slice(1),
      throw(e) {
        throw new Error(zg + e)
      },
      error(e) {
        console.error(zg + e)
      },
      warn(e) {
        jg.showWarnings && console.warn('Konva warning: ' + e)
      },
      each(e, t) {
        for (var n in e) t(n, e[n])
      },
      _inRange: (e, t, n) => t <= e && e < n,
      _getProjectionToSegment(e, t, n, r, i, o) {
        var a,
          l,
          s = (e - n) * (e - n) + (t - r) * (t - r)
        return (
          (n =
            0 == s
              ? ((a = e), (l = t), (i - n) * (i - n) + (o - r) * (o - r))
              : (s = ((i - e) * (n - e) + (o - t) * (r - t)) / s) < 0
              ? ((a = e) - i) * (e - i) + ((l = t) - o) * (t - o)
              : 1 < s
              ? ((a = n) - i) * (n - i) + ((l = r) - o) * (r - o)
              : ((a = e + s * (n - e)) - i) * (a - i) + ((l = t + s * (r - t)) - o) * (l - o)),
          [a, l, n]
        )
      },
      _getProjectionToLine(e, t, n) {
        var r = Vg.cloneObject(e),
          i = Number.MAX_VALUE
        return (
          t.forEach(function (o, a) {
            var l
            ;(n || a !== t.length - 1) &&
              ((a = t[(a + 1) % t.length]),
              (a = (o = Vg._getProjectionToSegment(o.x, o.y, a.x, a.y, e.x, e.y))[0]),
              (l = o[1]),
              (o = o[2]) < i) &&
              ((r.x = a), (r.y = l), (i = o))
          }),
          r
        )
      },
      _prepareArrayForTween(e, t, n) {
        var r,
          i,
          o = [],
          a = []
        for (e.length > t.length && ((i = t), (t = e), (e = i)), r = 0; r < e.length; r += 2)
          o.push({ x: e[r], y: e[r + 1] })
        for (r = 0; r < t.length; r += 2) a.push({ x: t[r], y: t[r + 1] })
        var l = []
        return (
          a.forEach(function (e) {
            ;(e = Vg._getProjectionToLine(e, o, n)), l.push(e.x), l.push(e.y)
          }),
          l
        )
      },
      _prepareToStringify(e) {
        var t, n
        for (n in ((e.visitedByCircularReferenceRemoval = !0), e))
          if (e.hasOwnProperty(n) && e[n] && 'object' == typeof e[n])
            if (
              ((t = Object.getOwnPropertyDescriptor(e, n)),
              e[n].visitedByCircularReferenceRemoval || Vg._isElement(e[n]))
            ) {
              if (!t.configurable) return null
              delete e[n]
            } else if (null === Vg._prepareToStringify(e[n])) {
              if (!t.configurable) return null
              delete e[n]
            }
        return delete e.visitedByCircularReferenceRemoval, e
      },
      _assign(e, t) {
        for (var n in t) e[n] = t[n]
        return e
      },
      _getFirstPointerId: e => (e.touches ? e.changedTouches[0].identifier : e.pointerId || 999),
      releaseCanvas(...e) {
        jg.releaseCanvasOnDestroy &&
          e.forEach(e => {
            ;(e.width = 0), (e.height = 0)
          })
      },
      drawRoundedRectPath(e, t, n, r) {
        let i = 0,
          o = 0,
          a = 0,
          l = 0
        'number' == typeof r
          ? (i = o = a = l = Math.min(r, t / 2, n / 2))
          : ((i = Math.min(r[0] || 0, t / 2, n / 2)),
            (o = Math.min(r[1] || 0, t / 2, n / 2)),
            (l = Math.min(r[2] || 0, t / 2, n / 2)),
            (a = Math.min(r[3] || 0, t / 2, n / 2))),
          e.moveTo(i, 0),
          e.lineTo(t - o, 0),
          e.arc(t - o, o, o, (3 * Math.PI) / 2, 0, !1),
          e.lineTo(t, n - l),
          e.arc(t - l, n - l, l, 0, Math.PI / 2, !1),
          e.lineTo(a, n),
          e.arc(a, n - a, a, Math.PI / 2, Math.PI, !1),
          e.lineTo(0, i),
          e.arc(i, i, i, Math.PI, (3 * Math.PI) / 2, !1)
      }
    }
  function Wg(e) {
    return Vg._isString(e)
      ? '"' + e + '"'
      : '[object Number]' === Object.prototype.toString.call(e) || Vg._isBoolean(e)
      ? e
      : Object.prototype.toString.call(e)
  }
  function Gg(e) {
    return 255 < e ? 255 : e < 0 ? 0 : Math.round(e)
  }
  function Zg() {
    if (jg.isUnminified)
      return function (e, t) {
        return (
          Vg._isNumber(e) ||
            Vg.warn(Wg(e) + ' is a not valid value for "' + t + '" attribute. The value should be a number.'),
          e
        )
      }
  }
  function Ug(e) {
    if (jg.isUnminified)
      return function (t, n) {
        var r = Vg._isNumber(t),
          i = Vg._isArray(t) && t.length == e
        return (
          r ||
            i ||
            Vg.warn(
              Wg(t) +
                ' is a not valid value for "' +
                n +
                '" attribute. The value should be a number or Array<number>(' +
                e +
                ')'
            ),
          t
        )
      }
  }
  function Xg() {
    if (jg.isUnminified)
      return function (e, t) {
        return (
          Vg._isNumber(e) ||
            'auto' === e ||
            Vg.warn(Wg(e) + ' is a not valid value for "' + t + '" attribute. The value should be a number or "auto".'),
          e
        )
      }
  }
  function Yg() {
    if (jg.isUnminified)
      return function (e, t) {
        return (
          Vg._isString(e) ||
            Vg.warn(Wg(e) + ' is a not valid value for "' + t + '" attribute. The value should be a string.'),
          e
        )
      }
  }
  function qg() {
    if (jg.isUnminified)
      return function (e, t) {
        var n = Vg._isString(e),
          r = '[object CanvasGradient]' === Object.prototype.toString.call(e) || (e && e.addColorStop)
        return (
          n ||
            r ||
            Vg.warn(
              Wg(e) +
                ' is a not valid value for "' +
                t +
                '" attribute. The value should be a string or a native gradient.'
            ),
          e
        )
      }
  }
  function $g() {
    if (jg.isUnminified)
      return function (e, t) {
        return (
          !0 === e ||
            !1 === e ||
            Vg.warn(Wg(e) + ' is a not valid value for "' + t + '" attribute. The value should be a boolean.'),
          e
        )
      }
  }
  var Kg = 'get',
    Qg = 'set'
  const Jg = {
    addGetterSetter(e, t, n, r, i) {
      Jg.addGetter(e, t, n), Jg.addSetter(e, t, r, i), Jg.addOverloadedGetterSetter(e, t)
    },
    addGetter(e, t, n) {
      var r = Kg + Vg._capitalize(t)
      e.prototype[r] =
        e.prototype[r] ||
        function () {
          var e = this.attrs[t]
          return void 0 === e ? n : e
        }
    },
    addSetter(e, t, n, r) {
      var i = Qg + Vg._capitalize(t)
      e.prototype[i] || Jg.overWriteSetter(e, t, n, r)
    },
    overWriteSetter(e, t, n, r) {
      var i = Qg + Vg._capitalize(t)
      e.prototype[i] = function (e) {
        return n && null != e && (e = n.call(this, e, t)), this._setAttr(t, e), r && r.call(this), this
      }
    },
    addComponentsGetterSetter(e, t, n, r, i) {
      var o,
        a,
        l = n.length,
        s = Vg._capitalize,
        c = Kg + s(t),
        u = Qg + s(t),
        d =
          ((e.prototype[c] = function () {
            var e = {}
            for (o = 0; o < l; o++) e[(a = n[o])] = this.getAttr(t + s(a))
            return e
          }),
          (function (e) {
            if (jg.isUnminified)
              return function (t, n) {
                return (
                  null == t ||
                    Vg.isObject(t) ||
                    Vg.warn(
                      Wg(t) +
                        ' is a not valid value for "' +
                        n +
                        '" attribute. The value should be an object with properties ' +
                        e
                    ),
                  t
                )
              }
          })(n))
      ;(e.prototype[u] = function (e) {
        var o,
          a = this.attrs[t]
        for (o in (r && (e = r.call(this, e)), d && d.call(this, e, t), e))
          e.hasOwnProperty(o) && this._setAttr(t + s(o), e[o])
        return (
          e ||
            n.forEach(e => {
              this._setAttr(t + s(e), void 0)
            }),
          this._fireChangeEvent(t, a, e),
          i && i.call(this),
          this
        )
      }),
        Jg.addOverloadedGetterSetter(e, t)
    },
    addOverloadedGetterSetter(e, t) {
      var n = Vg._capitalize(t),
        r = Qg + n,
        i = Kg + n
      e.prototype[t] = function () {
        return arguments.length ? (this[r](arguments[0]), this) : this[i]()
      }
    },
    addDeprecatedGetterSetter(e, t, n, r) {
      Vg.error('Adding deprecated ' + t)
      var i = Kg + Vg._capitalize(t),
        o = t + ' property is deprecated and will be removed soon. Look at Konva change log for more information.'
      ;(e.prototype[i] = function () {
        Vg.error(o)
        var e = this.attrs[t]
        return void 0 === e ? n : e
      }),
        Jg.addSetter(e, t, r, function () {
          Vg.error(o)
        }),
        Jg.addOverloadedGetterSetter(e, t)
    },
    backCompat(e, t) {
      Vg.each(t, function (t, n) {
        var r = e.prototype[n],
          i = Kg + Vg._capitalize(t),
          o = Qg + Vg._capitalize(t)
        function a() {
          r.apply(this, arguments),
            Vg.error('"' + t + '" method is deprecated and will be removed soon. Use ""' + n + '" instead.')
        }
        ;(e.prototype[t] = a), (e.prototype[i] = a), (e.prototype[o] = a)
      })
    },
    afterSetFilter() {
      this._filterUpToDate = !1
    }
  }
  var em,
    tm = [
      'arc',
      'arcTo',
      'beginPath',
      'bezierCurveTo',
      'clearRect',
      'clip',
      'closePath',
      'createLinearGradient',
      'createPattern',
      'createRadialGradient',
      'drawImage',
      'ellipse',
      'fill',
      'fillText',
      'getImageData',
      'createImageData',
      'lineTo',
      'moveTo',
      'putImageData',
      'quadraticCurveTo',
      'rect',
      'restore',
      'rotate',
      'save',
      'scale',
      'setLineDash',
      'setTransform',
      'stroke',
      'strokeText',
      'transform',
      'translate'
    ]
  class nm {
    constructor(e) {
      ;(this.canvas = e), jg.enableTrace && ((this.traceArr = []), this._enableTrace())
    }
    fillShape(e) {
      e.fillEnabled() && this._fill(e)
    }
    _fill(e) {}
    strokeShape(e) {
      e.hasStroke() && this._stroke(e)
    }
    _stroke(e) {}
    fillStrokeShape(e) {
      e.attrs.fillAfterStrokeEnabled
        ? (this.strokeShape(e), this.fillShape(e))
        : (this.fillShape(e), this.strokeShape(e))
    }
    getTrace(e, t) {
      for (var n, r, i, o = this.traceArr, a = o.length, l = '', s = 0; s < a; s++)
        (r = (n = o[s]).method)
          ? ((i = n.args),
            (l += r),
            e
              ? (l += '()')
              : Vg._isArray(i[0])
              ? (l += '([' + i.join(',') + '])')
              : (l += '(' + (i = t ? i.map(e => ('number' == typeof e ? Math.floor(e) : e)) : i).join(',') + ')'))
          : ((l += n.property), e || (l += '=' + n.val)),
          (l += ';')
      return l
    }
    clearTrace() {
      this.traceArr = []
    }
    _trace(e) {
      var t = this.traceArr
      t.push(e), 100 <= t.length && t.shift()
    }
    reset() {
      var e = this.getCanvas().getPixelRatio()
      this.setTransform(+e, 0, 0, +e, 0, 0)
    }
    getCanvas() {
      return this.canvas
    }
    clear(e) {
      var t = this.getCanvas()
      e
        ? this.clearRect(e.x || 0, e.y || 0, e.width || 0, e.height || 0)
        : this.clearRect(0, 0, t.getWidth() / t.pixelRatio, t.getHeight() / t.pixelRatio)
    }
    _applyLineCap(e) {
      ;(e = e.attrs.lineCap) && this.setAttr('lineCap', e)
    }
    _applyOpacity(e) {
      1 !== (e = e.getAbsoluteOpacity()) && this.setAttr('globalAlpha', e)
    }
    _applyLineJoin(e) {
      ;(e = e.attrs.lineJoin) && this.setAttr('lineJoin', e)
    }
    setAttr(e, t) {
      this._context[e] = t
    }
    arc(e, t, n, r, i, o) {
      this._context.arc(e, t, n, r, i, o)
    }
    arcTo(e, t, n, r, i) {
      this._context.arcTo(e, t, n, r, i)
    }
    beginPath() {
      this._context.beginPath()
    }
    bezierCurveTo(e, t, n, r, i, o) {
      this._context.bezierCurveTo(e, t, n, r, i, o)
    }
    clearRect(e, t, n, r) {
      this._context.clearRect(e, t, n, r)
    }
    clip() {
      this._context.clip()
    }
    closePath() {
      this._context.closePath()
    }
    createImageData(e, t) {
      var n = arguments
      return 2 === n.length
        ? this._context.createImageData(e, t)
        : 1 === n.length
        ? this._context.createImageData(e)
        : void 0
    }
    createLinearGradient(e, t, n, r) {
      return this._context.createLinearGradient(e, t, n, r)
    }
    createPattern(e, t) {
      return this._context.createPattern(e, t)
    }
    createRadialGradient(e, t, n, r, i, o) {
      return this._context.createRadialGradient(e, t, n, r, i, o)
    }
    drawImage(e, t, n, r, i, o, a, l, s) {
      var c = arguments,
        u = this._context
      3 === c.length
        ? u.drawImage(e, t, n)
        : 5 === c.length
        ? u.drawImage(e, t, n, r, i)
        : 9 === c.length && u.drawImage(e, t, n, r, i, o, a, l, s)
    }
    ellipse(e, t, n, r, i, o, a, l) {
      this._context.ellipse(e, t, n, r, i, o, a, l)
    }
    isPointInPath(e, t, n, r) {
      return n ? this._context.isPointInPath(n, e, t, r) : this._context.isPointInPath(e, t, r)
    }
    fill(e) {
      e ? this._context.fill(e) : this._context.fill()
    }
    fillRect(e, t, n, r) {
      this._context.fillRect(e, t, n, r)
    }
    strokeRect(e, t, n, r) {
      this._context.strokeRect(e, t, n, r)
    }
    fillText(e, t, n, r) {
      r ? this._context.fillText(e, t, n, r) : this._context.fillText(e, t, n)
    }
    measureText(e) {
      return this._context.measureText(e)
    }
    getImageData(e, t, n, r) {
      return this._context.getImageData(e, t, n, r)
    }
    lineTo(e, t) {
      this._context.lineTo(e, t)
    }
    moveTo(e, t) {
      this._context.moveTo(e, t)
    }
    rect(e, t, n, r) {
      this._context.rect(e, t, n, r)
    }
    putImageData(e, t, n) {
      this._context.putImageData(e, t, n)
    }
    quadraticCurveTo(e, t, n, r) {
      this._context.quadraticCurveTo(e, t, n, r)
    }
    restore() {
      this._context.restore()
    }
    rotate(e) {
      this._context.rotate(e)
    }
    save() {
      this._context.save()
    }
    scale(e, t) {
      this._context.scale(e, t)
    }
    setLineDash(e) {
      this._context.setLineDash
        ? this._context.setLineDash(e)
        : 'mozDash' in this._context
        ? (this._context.mozDash = e)
        : 'webkitLineDash' in this._context && (this._context.webkitLineDash = e)
    }
    getLineDash() {
      return this._context.getLineDash()
    }
    setTransform(e, t, n, r, i, o) {
      this._context.setTransform(e, t, n, r, i, o)
    }
    stroke(e) {
      e ? this._context.stroke(e) : this._context.stroke()
    }
    strokeText(e, t, n, r) {
      this._context.strokeText(e, t, n, r)
    }
    transform(e, t, n, r, i, o) {
      this._context.transform(e, t, n, r, i, o)
    }
    translate(e, t) {
      this._context.translate(e, t)
    }
    _enableTrace() {
      for (
        var e,
          t = this,
          n = tm.length,
          r = this.setAttr,
          i = function (n) {
            var r,
              i = t[n]
            t[n] = function () {
              return (
                (e = (function (e) {
                  for (var t, n = [], r = e.length, i = Vg, o = 0; o < r; o++)
                    (t = e[o]),
                      i._isNumber(t) ? (t = Math.round(1e3 * t) / 1e3) : i._isString(t) || (t += ''),
                      n.push(t)
                  return n
                })(Array.prototype.slice.call(arguments, 0))),
                (r = i.apply(t, arguments)),
                t._trace({ method: n, args: e }),
                r
              )
            }
          },
          o = 0;
        o < n;
        o++
      )
        i(tm[o])
      t.setAttr = function () {
        r.apply(t, arguments)
        var e = arguments[0],
          n = arguments[1]
        ;('shadowOffsetX' !== e && 'shadowOffsetY' !== e && 'shadowBlur' !== e) || (n /= this.canvas.getPixelRatio()),
          t._trace({ property: e, val: n })
      }
    }
    _applyGlobalCompositeOperation(e) {
      ;(e = e.attrs.globalCompositeOperation) && 'source-over' !== e && this.setAttr('globalCompositeOperation', e)
    }
  }
  ;[
    'fillStyle',
    'strokeStyle',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY',
    'lineCap',
    'lineDashOffset',
    'lineJoin',
    'lineWidth',
    'miterLimit',
    'font',
    'textAlign',
    'textBaseline',
    'globalAlpha',
    'globalCompositeOperation',
    'imageSmoothingEnabled'
  ].forEach(function (e) {
    Object.defineProperty(nm.prototype, e, {
      get() {
        return this._context[e]
      },
      set(t) {
        this._context[e] = t
      }
    })
  })
  class rm extends nm {
    constructor(e) {
      super(e), (this._context = e._canvas.getContext('2d'))
    }
    _fillColor(e) {
      var t = e.fill()
      this.setAttr('fillStyle', t), e._fillFunc(this)
    }
    _fillPattern(e) {
      this.setAttr('fillStyle', e._getFillPattern()), e._fillFunc(this)
    }
    _fillLinearGradient(e) {
      var t = e._getLinearGradient()
      t && (this.setAttr('fillStyle', t), e._fillFunc(this))
    }
    _fillRadialGradient(e) {
      var t = e._getRadialGradient()
      t && (this.setAttr('fillStyle', t), e._fillFunc(this))
    }
    _fill(e) {
      var t,
        n,
        r,
        i = e.fill(),
        o = e.getFillPriority()
      i && 'color' === o
        ? this._fillColor(e)
        : (t = e.getFillPatternImage()) && 'pattern' === o
        ? this._fillPattern(e)
        : (n = e.getFillLinearGradientColorStops()) && 'linear-gradient' === o
        ? this._fillLinearGradient(e)
        : (r = e.getFillRadialGradientColorStops()) && 'radial-gradient' === o
        ? this._fillRadialGradient(e)
        : i
        ? this._fillColor(e)
        : t
        ? this._fillPattern(e)
        : n
        ? this._fillLinearGradient(e)
        : r && this._fillRadialGradient(e)
    }
    _strokeLinearGradient(e) {
      var t = e.getStrokeLinearGradientStartPoint(),
        n = e.getStrokeLinearGradientEndPoint(),
        r = e.getStrokeLinearGradientColorStops(),
        i = this.createLinearGradient(t.x, t.y, n.x, n.y)
      if (r) {
        for (var o = 0; o < r.length; o += 2) i.addColorStop(r[o], r[o + 1])
        this.setAttr('strokeStyle', i)
      }
    }
    _stroke(e) {
      var t,
        n = e.dash(),
        r = e.getStrokeScaleEnabled()
      e.hasStroke() &&
        (r || (this.save(), (t = this.getCanvas().getPixelRatio()), this.setTransform(t, 0, 0, t, 0, 0)),
        this._applyLineCap(e),
        n && e.dashEnabled() && (this.setLineDash(n), this.setAttr('lineDashOffset', e.dashOffset())),
        this.setAttr('lineWidth', e.strokeWidth()),
        e.getShadowForStrokeEnabled() || this.setAttr('shadowColor', 'rgba(0,0,0,0)'),
        e.getStrokeLinearGradientColorStops() ? this._strokeLinearGradient(e) : this.setAttr('strokeStyle', e.stroke()),
        e._strokeFunc(this),
        r || this.restore())
    }
    _applyShadow(e) {
      var t = null != (t = e.getShadowRGBA()) ? t : 'black',
        n = null != (n = e.getShadowBlur()) ? n : 5,
        r = null != (r = e.getShadowOffset()) ? r : { x: 0, y: 0 },
        i = ((e = e.getAbsoluteScale()), this.canvas.getPixelRatio()),
        o = e.x * i
      e = e.y * i
      this.setAttr('shadowColor', t),
        this.setAttr('shadowBlur', n * Math.min(Math.abs(o), Math.abs(e))),
        this.setAttr('shadowOffsetX', r.x * o),
        this.setAttr('shadowOffsetY', r.y * e)
    }
  }
  class im extends nm {
    constructor(e) {
      super(e), (this._context = e._canvas.getContext('2d', { willReadFrequently: !0 }))
    }
    _fill(e) {
      this.save(), this.setAttr('fillStyle', e.colorKey), e._fillFuncHit(this), this.restore()
    }
    strokeShape(e) {
      e.hasHitStroke() && this._stroke(e)
    }
    _stroke(e) {
      var t, n
      e.hasHitStroke() &&
        ((t = e.getStrokeScaleEnabled()) ||
          (this.save(), (n = this.getCanvas().getPixelRatio()), this.setTransform(n, 0, 0, n, 0, 0)),
        this._applyLineCap(e),
        (n = 'auto' === (n = e.hitStrokeWidth()) ? e.strokeWidth() : n),
        this.setAttr('lineWidth', n),
        this.setAttr('strokeStyle', e.colorKey),
        e._strokeFuncHit(this),
        t || this.restore())
    }
  }
  class om {
    constructor(e) {
      ;(this.pixelRatio = 1), (this.width = 0), (this.height = 0), (this.isCache = !1)
      var t =
        (e || {}).pixelRatio ||
        jg.pixelRatio ||
        (em ||
          ((t = (e = Vg.createCanvasElement()).getContext('2d')),
          (em =
            (jg._global.devicePixelRatio || 1) /
            (t.webkitBackingStorePixelRatio ||
              t.mozBackingStorePixelRatio ||
              t.msBackingStorePixelRatio ||
              t.oBackingStorePixelRatio ||
              t.backingStorePixelRatio ||
              1)),
          Vg.releaseCanvas(e)),
        em)
      ;(this.pixelRatio = t),
        (this._canvas = Vg.createCanvasElement()),
        (this._canvas.style.padding = '0'),
        (this._canvas.style.margin = '0'),
        (this._canvas.style.border = '0'),
        (this._canvas.style.background = 'transparent'),
        (this._canvas.style.position = 'absolute'),
        (this._canvas.style.top = '0'),
        (this._canvas.style.left = '0')
    }
    getContext() {
      return this.context
    }
    getPixelRatio() {
      return this.pixelRatio
    }
    setPixelRatio(e) {
      var t = this.pixelRatio
      ;(this.pixelRatio = e), this.setSize(this.getWidth() / t, this.getHeight() / t)
    }
    setWidth(e) {
      ;(this.width = this._canvas.width = e * this.pixelRatio),
        (this._canvas.style.width = e + 'px'),
        (e = this.pixelRatio),
        this.getContext()._context.scale(e, e)
    }
    setHeight(e) {
      ;(this.height = this._canvas.height = e * this.pixelRatio),
        (this._canvas.style.height = e + 'px'),
        (e = this.pixelRatio),
        this.getContext()._context.scale(e, e)
    }
    getWidth() {
      return this.width
    }
    getHeight() {
      return this.height
    }
    setSize(e, t) {
      this.setWidth(e || 0), this.setHeight(t || 0)
    }
    toDataURL(e, t) {
      try {
        return this._canvas.toDataURL(e, t)
      } catch (n) {
        try {
          return this._canvas.toDataURL()
        } catch (r) {
          return (
            Vg.error(
              'Unable to get data URL. ' +
                r.message +
                ' For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html.'
            ),
            ''
          )
        }
      }
    }
  }
  Jg.addGetterSetter(om, 'pixelRatio', void 0, Zg())
  class am extends om {
    constructor(e = { width: 0, height: 0 }) {
      super(e), (this.context = new rm(this)), this.setSize(e.width, e.height)
    }
  }
  class lm extends om {
    constructor(e = { width: 0, height: 0 }) {
      super(e), (this.hitCanvas = !0), (this.context = new im(this)), this.setSize(e.width, e.height)
    }
  }
  const sm = {
    get isDragging() {
      var e = !1
      return (
        sm._dragElements.forEach(t => {
          'dragging' === t.dragStatus && (e = !0)
        }),
        e
      )
    },
    justDragged: !1,
    get node() {
      var e
      return (
        sm._dragElements.forEach(t => {
          e = t.node
        }),
        e
      )
    },
    _dragElements: new Map(),
    _drag(e) {
      const t = []
      sm._dragElements.forEach((n, r) => {
        var i,
          o = n.node
        if (
          (i =
            ((i = o.getStage()).setPointersPositions(e),
            void 0 === n.pointerId && (n.pointerId = Vg._getFirstPointerId(e)),
            i._changedPointerPositions.find(e => e.id === n.pointerId)))
        ) {
          if ('dragging' !== n.dragStatus) {
            var a = o.dragDistance()
            if (Math.max(Math.abs(i.x - n.startPointerPos.x), Math.abs(i.y - n.startPointerPos.y)) < a) return
            if ((o.startDrag({ evt: e }), !o.isDragging())) return
          }
          o._setDragPosition(e, n), t.push(o)
        }
      }),
        t.forEach(t => {
          t.fire('dragmove', { type: 'dragmove', target: t, evt: e }, !0)
        })
    },
    _endDragBefore(e) {
      const t = []
      sm._dragElements.forEach(n => {
        var r = (r = n.node).getStage()
        ;(r = (e && r.setPointersPositions(e), r._changedPointerPositions.find(e => e.id === n.pointerId))) &&
          (('dragging' !== n.dragStatus && 'stopped' !== n.dragStatus) ||
            ((sm.justDragged = !0),
            (jg._mouseListenClick = !1),
            (jg._touchListenClick = !1),
            (jg._pointerListenClick = !1),
            (n.dragStatus = 'stopped')),
          (r = n.node.getLayer() || (n.node instanceof jg.Stage && n.node))) &&
          -1 === t.indexOf(r) &&
          t.push(r)
      }),
        t.forEach(e => {
          e.draw()
        })
    },
    _endDragAfter(e) {
      sm._dragElements.forEach((t, n) => {
        'stopped' === t.dragStatus && t.node.fire('dragend', { type: 'dragend', target: t.node, evt: e }, !0),
          'dragging' !== t.dragStatus && sm._dragElements.delete(n)
      })
    }
  }
  jg.isBrowser &&
    (window.addEventListener('mouseup', sm._endDragBefore, !0),
    window.addEventListener('touchend', sm._endDragBefore, !0),
    window.addEventListener('mousemove', sm._drag),
    window.addEventListener('touchmove', sm._drag),
    window.addEventListener('mouseup', sm._endDragAfter, !1),
    window.addEventListener('touchend', sm._endDragAfter, !1))
  var cm = 'absoluteOpacity',
    um = 'allEventListeners',
    dm = 'absoluteTransform',
    fm = 'absoluteScale',
    hm = 'canvas',
    pm = 'listening',
    gm = 'mouseenter',
    mm = 'mouseleave',
    vm = 'transform',
    ym = 'visible'
  p = [
    'xChange.konva',
    'yChange.konva',
    'scaleXChange.konva',
    'scaleYChange.konva',
    'skewXChange.konva',
    'skewYChange.konva',
    'rotationChange.konva',
    'offsetXChange.konva',
    'offsetYChange.konva',
    'transformsEnabledChange.konva'
  ].join(' ')
  let bm = 1
  class wm {
    constructor(e) {
      ;(this._id = bm++),
        (this.eventListeners = {}),
        (this.attrs = {}),
        (this.index = 0),
        (this._allEventListeners = null),
        (this.parent = null),
        (this._cache = new Map()),
        (this._attachedDepsListeners = new Map()),
        (this._lastPos = null),
        (this._batchingTransformChange = !1),
        (this._needClearTransformCache = !1),
        (this._filterUpToDate = !1),
        (this._isUnderCache = !1),
        (this._dragEventId = null),
        (this._shouldFireChangeEvents = !1),
        this.setAttrs(e),
        (this._shouldFireChangeEvents = !0)
    }
    hasChildren() {
      return !1
    }
    _clearCache(e) {
      ;(e !== vm && e !== dm) || !this._cache.get(e)
        ? e
          ? this._cache.delete(e)
          : this._cache.clear()
        : (this._cache.get(e).dirty = !0)
    }
    _getCache(e, t) {
      var n = this._cache.get(e)
      return (
        (void 0 === n || ((e === vm || e === dm) && !0 === n.dirty)) && ((n = t.call(this)), this._cache.set(e, n)), n
      )
    }
    _calculate(e, t, n) {
      return (
        this._attachedDepsListeners.get(e) ||
          ((t = t.map(e => e + 'Change.konva').join(' ')),
          this.on(t, () => {
            this._clearCache(e)
          }),
          this._attachedDepsListeners.set(e, !0)),
        this._getCache(e, n)
      )
    }
    _getCanvasCache() {
      return this._cache.get(hm)
    }
    _clearSelfAndDescendantCache(e) {
      this._clearCache(e), e === dm && this.fire('absoluteTransformChange')
    }
    clearCache() {
      var e, t, n
      return (
        this._cache.has(hm) &&
          (({ scene: e, filter: t, hit: n } = this._cache.get(hm)), Vg.releaseCanvas(e, t, n), this._cache.delete(hm)),
        this._clearSelfAndDescendantCache(),
        this._requestDraw(),
        this
      )
    }
    cache(e) {
      var t,
        n,
        r = {},
        i =
          ((void 0 !== (e = e || {}).x && void 0 !== e.y && void 0 !== e.width && void 0 !== e.height) ||
            (r = this.getClientRect({ skipTransform: !0, relativeTo: this.getParent() })),
          Math.ceil(e.width || r.width)),
        o = Math.ceil(e.height || r.height),
        a = e.pixelRatio,
        l = void 0 === e.x ? Math.floor(r.x) : e.x,
        s = ((r = void 0 === e.y ? Math.floor(r.y) : e.y), e.offset || 0),
        c = e.drawBorder || !1,
        u = e.hitCanvasPixelRatio || 1
      if (i && o)
        return (
          (l -= s),
          (r -= s),
          (s = new am({ pixelRatio: a, width: (i += 2 * s + 1), height: (o += 2 * s + 1) })),
          (a = new am({ pixelRatio: a, width: 0, height: 0 })),
          (u = new lm({ pixelRatio: u, width: i, height: o })),
          (t = s.getContext()),
          (n = u.getContext()),
          (u.isCache = !0),
          (s.isCache = !0),
          this._cache.delete(hm),
          (this._filterUpToDate = !1) === e.imageSmoothingEnabled &&
            ((s.getContext()._context.imageSmoothingEnabled = !1),
            (a.getContext()._context.imageSmoothingEnabled = !1)),
          t.save(),
          n.save(),
          t.translate(-l, -r),
          n.translate(-l, -r),
          (this._isUnderCache = !0),
          this._clearSelfAndDescendantCache(cm),
          this._clearSelfAndDescendantCache(fm),
          this.drawScene(s, this),
          this.drawHit(u, this),
          (this._isUnderCache = !1),
          t.restore(),
          n.restore(),
          c &&
            (t.save(),
            t.beginPath(),
            t.rect(0, 0, i, o),
            t.closePath(),
            t.setAttr('strokeStyle', 'red'),
            t.setAttr('lineWidth', 5),
            t.stroke(),
            t.restore()),
          this._cache.set(hm, { scene: s, filter: a, hit: u, x: l, y: r }),
          this._requestDraw(),
          this
        )
      Vg.error('Can not cache the node. Width or height of the node equals 0. Caching is skipped.')
    }
    isCached() {
      return this._cache.has(hm)
    }
    getClientRect(e) {
      throw new Error('abstract "getClientRect" method call')
    }
    _transformedRect(e, t) {
      e = [
        { x: e.x, y: e.y },
        { x: e.x + e.width, y: e.y },
        { x: e.x + e.width, y: e.y + e.height },
        { x: e.x, y: e.y + e.height }
      ]
      var n,
        r,
        i,
        o,
        a = this.getAbsoluteTransform(t)
      return (
        e.forEach(function (e) {
          ;(e = a.point(e)),
            void 0 === n && ((n = i = e.x), (r = o = e.y)),
            (n = Math.min(n, e.x)),
            (r = Math.min(r, e.y)),
            (i = Math.max(i, e.x)),
            (o = Math.max(o, e.y))
        }),
        { x: n, y: r, width: i - n, height: o - r }
      )
    }
    _drawCachedSceneCanvas(e) {
      e.save(), e._applyOpacity(this), e._applyGlobalCompositeOperation(this)
      var t = this._getCanvasCache(),
        n = (t = (e.translate(t.x, t.y), this._getCachedSceneCanvas())).pixelRatio
      e.drawImage(t._canvas, 0, 0, t.width / n, t.height / n), e.restore()
    }
    _drawCachedHitCanvas(e) {
      var t = this._getCanvasCache(),
        n = t.hit
      e.save(),
        e.translate(t.x, t.y),
        e.drawImage(n._canvas, 0, 0, n.width / n.pixelRatio, n.height / n.pixelRatio),
        e.restore()
    }
    _getCachedSceneCanvas() {
      var e,
        t,
        n,
        r,
        i,
        o = this.filters(),
        a = (i = this._getCanvasCache()).scene,
        l = (i = i.filter).getContext()
      if (o) {
        if (!this._filterUpToDate) {
          var s = a.pixelRatio
          i.setSize(a.width / a.pixelRatio, a.height / a.pixelRatio)
          try {
            for (
              e = o.length,
                l.clear(),
                l.drawImage(a._canvas, 0, 0, a.getWidth() / s, a.getHeight() / s),
                t = l.getImageData(0, 0, i.getWidth(), i.getHeight()),
                n = 0;
              n < e;
              n++
            )
              'function' != typeof (r = o[n])
                ? Vg.error(
                    'Filter should be type of function, but got ' + typeof r + ' instead. Please check correct filters'
                  )
                : (r.call(this, t), l.putImageData(t, 0, 0))
          } catch (c) {
            Vg.error(
              'Unable to apply filter. ' +
                c.message +
                ' This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.'
            )
          }
          this._filterUpToDate = !0
        }
        return i
      }
      return a
    }
    on(e, t) {
      if ((this._cache && this._cache.delete(um), 3 === arguments.length)) return this._delegate.apply(this, arguments)
      for (var n, r, i = e.split(' '), o = i.length, a = 0; a < o; a++)
        (n = (r = i[a].split('.'))[0]),
          (r = r[1] || ''),
          this.eventListeners[n] || (this.eventListeners[n] = []),
          this.eventListeners[n].push({ name: r, handler: t })
      return this
    }
    off(e, t) {
      var n,
        r,
        i,
        o,
        a,
        l = (e || '').split(' '),
        s = l.length
      if ((this._cache && this._cache.delete(um), !e)) for (r in this.eventListeners) this._off(r)
      for (n = 0; n < s; n++)
        if (((o = (i = l[n].split('.'))[0]), (a = i[1]), o)) this.eventListeners[o] && this._off(o, a, t)
        else for (r in this.eventListeners) this._off(r, a, t)
      return this
    }
    dispatchEvent(e) {
      var t = { target: this, type: e.type, evt: e }
      return this.fire(e.type, t), this
    }
    addEventListener(e, t) {
      return (
        this.on(e, function (e) {
          t.call(this, e.evt)
        }),
        this
      )
    }
    removeEventListener(e) {
      return this.off(e), this
    }
    _delegate(e, t, n) {
      var r = this
      this.on(e, function (e) {
        for (var i = e.target.findAncestors(t, !0, r), o = 0; o < i.length; o++)
          ((e = Vg.cloneObject(e)).currentTarget = i[o]), n.call(i[o], e)
      })
    }
    remove() {
      return this.isDragging() && this.stopDrag(), sm._dragElements.delete(this._id), this._remove(), this
    }
    _clearCaches() {
      this._clearSelfAndDescendantCache(dm),
        this._clearSelfAndDescendantCache(cm),
        this._clearSelfAndDescendantCache(fm),
        this._clearSelfAndDescendantCache('stage'),
        this._clearSelfAndDescendantCache(ym),
        this._clearSelfAndDescendantCache(pm)
    }
    _remove() {
      this._clearCaches()
      var e = this.getParent()
      e && e.children && (e.children.splice(this.index, 1), e._setChildrenIndices(), (this.parent = null))
    }
    destroy() {
      return this.remove(), this.clearCache(), this
    }
    getAttr(e) {
      var t = 'get' + Vg._capitalize(e)
      return Vg._isFunction(this[t]) ? this[t]() : this.attrs[e]
    }
    getAncestors() {
      for (var e = this.getParent(), t = []; e; ) t.push(e), (e = e.getParent())
      return t
    }
    getAttrs() {
      return this.attrs || {}
    }
    setAttrs(e) {
      return (
        this._batchTransformChanges(() => {
          var t, n
          if (!e) return this
          for (t in e)
            'children' !== t &&
              ((n = 'set' + Vg._capitalize(t)), Vg._isFunction(this[n]) ? this[n](e[t]) : this._setAttr(t, e[t]))
        }),
        this
      )
    }
    isListening() {
      return this._getCache(pm, this._isListening)
    }
    _isListening(e) {
      var t
      return !!this.listening() && (!(t = this.getParent()) || t === e || this === e || t._isListening(e))
    }
    isVisible() {
      return this._getCache(ym, this._isVisible)
    }
    _isVisible(e) {
      var t
      return !!this.visible() && (!(t = this.getParent()) || t === e || this === e || t._isVisible(e))
    }
    shouldDrawHit(e, t = !1) {
      var n, r
      return e
        ? this._isVisible(e) && this._isListening(e)
        : ((n = this.getLayer()),
          (r = !1),
          sm._dragElements.forEach(e => {
            'dragging' === e.dragStatus && (('Stage' !== e.node.nodeType && e.node.getLayer() !== n) || (r = !0))
          }),
          (e = !t && !jg.hitOnDragEnabled && r),
          this.isListening() && this.isVisible() && !e)
    }
    show() {
      return this.visible(!0), this
    }
    hide() {
      return this.visible(!1), this
    }
    getZIndex() {
      return this.index || 0
    }
    getAbsoluteZIndex() {
      var e,
        t,
        n,
        r,
        i = this.getDepth(),
        o = this,
        a = 0
      return (
        'Stage' !== o.nodeType &&
          (function l(s) {
            for (e = [], t = s.length, n = 0; n < t; n++)
              (r = s[n]),
                a++,
                'Shape' !== r.nodeType && (e = e.concat(r.getChildren().slice())),
                r._id === o._id && (n = t)
            0 < e.length && e[0].getDepth() <= i && l(e)
          })(o.getStage().getChildren()),
        a
      )
    }
    getDepth() {
      for (var e = 0, t = this.parent; t; ) e++, (t = t.parent)
      return e
    }
    _batchTransformChanges(e) {
      ;(this._batchingTransformChange = !0),
        e(),
        (this._batchingTransformChange = !1),
        this._needClearTransformCache && (this._clearCache(vm), this._clearSelfAndDescendantCache(dm)),
        (this._needClearTransformCache = !1)
    }
    setPosition(e) {
      return (
        this._batchTransformChanges(() => {
          this.x(e.x), this.y(e.y)
        }),
        this
      )
    }
    getPosition() {
      return { x: this.x(), y: this.y() }
    }
    getRelativePointerPosition() {
      var e, t
      return this.getStage() && (e = this.getStage().getPointerPosition())
        ? ((t = this.getAbsoluteTransform().copy()).invert(), t.point(e))
        : null
    }
    getAbsolutePosition(e) {
      let t = !1,
        n = this.parent
      for (; n; ) {
        if (n.isCached()) {
          t = !0
          break
        }
        n = n.parent
      }
      t && !e && (e = !0)
      e = this.getAbsoluteTransform(e).getMatrix()
      var r = new Rg(),
        i = this.offset()
      return (r.m = e.slice()), r.translate(i.x, i.y), r.getTranslation()
    }
    setAbsolutePosition(e) {
      var t = this._clearTransform(),
        n =
          ((this.attrs.x = t.x),
          (this.attrs.y = t.y),
          delete t.x,
          delete t.y,
          this._clearCache(vm),
          this._getAbsoluteTransform().copy())
      return (
        n.invert(),
        n.translate(e.x, e.y),
        (e = { x: this.attrs.x + n.getTranslation().x, y: this.attrs.y + n.getTranslation().y }),
        this._setTransform(t),
        this.setPosition({ x: e.x, y: e.y }),
        this._clearCache(vm),
        this._clearSelfAndDescendantCache(dm),
        this
      )
    }
    _setTransform(e) {
      for (var t in e) this.attrs[t] = e[t]
    }
    _clearTransform() {
      var e = {
        x: this.x(),
        y: this.y(),
        rotation: this.rotation(),
        scaleX: this.scaleX(),
        scaleY: this.scaleY(),
        offsetX: this.offsetX(),
        offsetY: this.offsetY(),
        skewX: this.skewX(),
        skewY: this.skewY()
      }
      return (
        (this.attrs.x = 0),
        (this.attrs.y = 0),
        (this.attrs.rotation = 0),
        (this.attrs.scaleX = 1),
        (this.attrs.scaleY = 1),
        (this.attrs.offsetX = 0),
        (this.attrs.offsetY = 0),
        (this.attrs.skewX = 0),
        (this.attrs.skewY = 0),
        e
      )
    }
    move(e) {
      var t = e.x,
        n = ((e = e.y), this.x()),
        r = this.y()
      return void 0 !== t && (n += t), void 0 !== e && (r += e), this.setPosition({ x: n, y: r }), this
    }
    _eachAncestorReverse(e, t) {
      var n,
        r,
        i = [],
        o = this.getParent()
      if (!t || t._id !== this._id) {
        for (i.unshift(this); o && (!t || o._id !== t._id); ) i.unshift(o), (o = o.parent)
        for (n = i.length, r = 0; r < n; r++) e(i[r])
      }
    }
    rotate(e) {
      return this.rotation(this.rotation() + e), this
    }
    moveToTop() {
      var e
      return this.parent
        ? (e = this.index) < this.parent.getChildren().length - 1 &&
            (this.parent.children.splice(e, 1), this.parent.children.push(this), this.parent._setChildrenIndices(), !0)
        : (Vg.warn('Node has no parent. moveToTop function is ignored.'), !1)
    }
    moveUp() {
      var e
      return this.parent
        ? (e = this.index) < this.parent.getChildren().length - 1 &&
            (this.parent.children.splice(e, 1),
            this.parent.children.splice(e + 1, 0, this),
            this.parent._setChildrenIndices(),
            !0)
        : (Vg.warn('Node has no parent. moveUp function is ignored.'), !1)
    }
    moveDown() {
      var e
      return this.parent
        ? 0 < (e = this.index) &&
            (this.parent.children.splice(e, 1),
            this.parent.children.splice(e - 1, 0, this),
            this.parent._setChildrenIndices(),
            !0)
        : (Vg.warn('Node has no parent. moveDown function is ignored.'), !1)
    }
    moveToBottom() {
      var e
      return this.parent
        ? 0 < (e = this.index) &&
            (this.parent.children.splice(e, 1),
            this.parent.children.unshift(this),
            this.parent._setChildrenIndices(),
            !0)
        : (Vg.warn('Node has no parent. moveToBottom function is ignored.'), !1)
    }
    setZIndex(e) {
      var t
      return (
        this.parent
          ? ((e < 0 || e >= this.parent.children.length) &&
              Vg.warn(
                'Unexpected value ' +
                  e +
                  ' for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to ' +
                  (this.parent.children.length - 1) +
                  '.'
              ),
            (t = this.index),
            this.parent.children.splice(t, 1),
            this.parent.children.splice(e, 0, this),
            this.parent._setChildrenIndices())
          : Vg.warn('Node has no parent. zIndex parameter is ignored.'),
        this
      )
    }
    getAbsoluteOpacity() {
      return this._getCache(cm, this._getAbsoluteOpacity)
    }
    _getAbsoluteOpacity() {
      var e = this.opacity(),
        t = this.getParent()
      return t && !t._isUnderCache && (e *= t.getAbsoluteOpacity()), e
    }
    moveTo(e) {
      return this.getParent() !== e && (this._remove(), e.add(this)), this
    }
    toObject() {
      var e,
        t,
        n,
        r = {},
        i = this.getAttrs()
      for (e in ((r.attrs = {}), i))
        (t = i[e]),
          (Vg.isObject(t) && !Vg._isPlainObject(t) && !Vg._isArray(t)) ||
            ((n = 'function' == typeof this[e] && this[e]),
            delete i[e],
            (n ? n.call(this) : null) !== (i[e] = t) && (r.attrs[e] = t))
      return (r.className = this.getClassName()), Vg._prepareToStringify(r)
    }
    toJSON() {
      return JSON.stringify(this.toObject())
    }
    getParent() {
      return this.parent
    }
    findAncestors(e, t, n) {
      for (var r = [], i = (t && this._isMatch(e) && r.push(this), this.parent); i; ) {
        if (i === n) return r
        i._isMatch(e) && r.push(i), (i = i.parent)
      }
      return r
    }
    isAncestorOf(e) {
      return !1
    }
    findAncestor(e, t, n) {
      return this.findAncestors(e, t, n)[0]
    }
    _isMatch(e) {
      if (e) {
        if ('function' == typeof e) return e(this)
        for (var t, n = e.replace(/ /g, '').split(','), r = n.length, i = 0; i < r; i++)
          if (
            ((t = n[i]),
            Vg.isValidSelector(t) ||
              (Vg.warn('Selector "' + t + '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".'),
              Vg.warn(
                'If you have a custom shape with such className, please change it to start with upper letter like "Triangle".'
              ),
              Vg.warn('Konva is awesome, right?')),
            '#' === t.charAt(0))
          ) {
            if (this.id() === t.slice(1)) return !0
          } else if ('.' === t.charAt(0)) {
            if (this.hasName(t.slice(1))) return !0
          } else if (this.className === t || this.nodeType === t) return !0
      }
      return !1
    }
    getLayer() {
      var e = this.getParent()
      return e ? e.getLayer() : null
    }
    getStage() {
      return this._getCache('stage', this._getStage)
    }
    _getStage() {
      var e = this.getParent()
      if (e) return e.getStage()
    }
    fire(e, t = {}, n) {
      return (t.target = t.target || this), n ? this._fireAndBubble(e, t) : this._fire(e, t), this
    }
    getAbsoluteTransform(e) {
      return e ? this._getAbsoluteTransform(e) : this._getCache(dm, this._getAbsoluteTransform)
    }
    _getAbsoluteTransform(e) {
      var t, n, r, i
      return (
        e
          ? ((t = new Rg()),
            this._eachAncestorReverse(function (e) {
              var n = e.transformsEnabled()
              'all' === n
                ? t.multiply(e.getTransform())
                : 'position' === n && t.translate(e.x() - e.offsetX(), e.y() - e.offsetY())
            }, e))
          : ((t = this._cache.get(dm) || new Rg()),
            this.parent ? this.parent.getAbsoluteTransform().copyInto(t) : t.reset(),
            'all' === (e = this.transformsEnabled())
              ? t.multiply(this.getTransform())
              : 'position' === e &&
                ((e = this.attrs.x || 0),
                (n = this.attrs.y || 0),
                (r = this.attrs.offsetX || 0),
                (i = this.attrs.offsetY || 0),
                t.translate(e - r, n - i)),
            (t.dirty = !1)),
        t
      )
    }
    getAbsoluteScale(e) {
      for (var t = this; t; ) t._isUnderCache && (e = t), (t = t.getParent())
      var n = this.getAbsoluteTransform(e).decompose()
      return { x: n.scaleX, y: n.scaleY }
    }
    getAbsoluteRotation() {
      return this.getAbsoluteTransform().decompose().rotation
    }
    getTransform() {
      return this._getCache(vm, this._getTransform)
    }
    _getTransform() {
      var e = this._cache.get(vm) || new Rg(),
        t = (e.reset(), this.x()),
        n = this.y(),
        r = jg.getAngle(this.rotation()),
        i = null != (i = this.attrs.scaleX) ? i : 1,
        o = null != (o = this.attrs.scaleY) ? o : 1,
        a = this.attrs.skewX || 0,
        l = this.attrs.skewY || 0,
        s = this.attrs.offsetX || 0,
        c = this.attrs.offsetY || 0
      return (
        (0 === t && 0 === n) || e.translate(t, n),
        0 !== r && e.rotate(r),
        (0 === a && 0 === l) || e.skew(a, l),
        (1 === i && 1 === o) || e.scale(i, o),
        (0 === s && 0 === c) || e.translate(-1 * s, -1 * c),
        (e.dirty = !1),
        e
      )
    }
    clone(e) {
      var t,
        n,
        r,
        i,
        o,
        a = Vg.cloneObject(this.attrs)
      for (t in e) a[t] = e[t]
      var l = new this.constructor(a)
      for (t in this.eventListeners)
        for (r = (n = this.eventListeners[t]).length, i = 0; i < r; i++)
          (o = n[i]).name.indexOf('konva') < 0 &&
            (l.eventListeners[t] || (l.eventListeners[t] = []), l.eventListeners[t].push(o))
      return l
    }
    _toKonvaCanvas(e) {
      e = e || {}
      var t = this.getClientRect(),
        n = this.getStage(),
        r = void 0 !== e.x ? e.x : Math.floor(t.x),
        i = void 0 !== e.y ? e.y : Math.floor(t.y),
        o = e.pixelRatio || 1
      n = (t = new am({
        width: e.width || Math.ceil(t.width) || (n ? n.width() : 0),
        height: e.height || Math.ceil(t.height) || (n ? n.height() : 0),
        pixelRatio: o
      })).getContext()
      return (
        !1 === e.imageSmoothingEnabled && (n._context.imageSmoothingEnabled = !1),
        n.save(),
        (r || i) && n.translate(-1 * r, -1 * i),
        this.drawScene(t),
        n.restore(),
        t
      )
    }
    toCanvas(e) {
      return this._toKonvaCanvas(e)._canvas
    }
    toDataURL(e) {
      var t = (e = e || {}).mimeType || null,
        n = e.quality || null
      t = this._toKonvaCanvas(e).toDataURL(t, n)
      return e.callback && e.callback(t), t
    }
    toImage(e) {
      return new Promise((t, n) => {
        try {
          const n = null == e ? void 0 : e.callback
          n && delete e.callback,
            Vg._urlToImage(this.toDataURL(e), function (e) {
              t(e), null != n && n(e)
            })
        } catch (r) {
          n(r)
        }
      })
    }
    toBlob(e) {
      return new Promise((t, n) => {
        try {
          const n = null == e ? void 0 : e.callback
          n && delete e.callback,
            this.toCanvas(e).toBlob(e => {
              t(e), null != n && n(e)
            })
        } catch (r) {
          n(r)
        }
      })
    }
    setSize(e) {
      return this.width(e.width), this.height(e.height), this
    }
    getSize() {
      return { width: this.width(), height: this.height() }
    }
    getClassName() {
      return this.className || this.nodeType
    }
    getType() {
      return this.nodeType
    }
    getDragDistance() {
      return void 0 !== this.attrs.dragDistance
        ? this.attrs.dragDistance
        : this.parent
        ? this.parent.getDragDistance()
        : jg.dragDistance
    }
    _off(e, t, n) {
      for (var r, i, o = this.eventListeners[e], a = 0; a < o.length; a++)
        if (
          ((r = o[a].name), (i = o[a].handler), !(('konva' === r && 'konva' !== t) || (t && r !== t) || (n && n !== i)))
        ) {
          if ((o.splice(a, 1), 0 === o.length)) {
            delete this.eventListeners[e]
            break
          }
          a--
        }
    }
    _fireChangeEvent(e, t, n) {
      this._fire(e + 'Change', { oldVal: t, newVal: n })
    }
    addName(e) {
      var t
      return this.hasName(e) || ((t = this.name()), this.name(t ? t + ' ' + e : e)), this
    }
    hasName(e) {
      var t
      return !!e && !!(t = this.name()) && -1 !== (t || '').split(/\s/g).indexOf(e)
    }
    removeName(e) {
      var t = (this.name() || '').split(/\s/g)
      return -1 !== (e = t.indexOf(e)) && (t.splice(e, 1), this.name(t.join(' '))), this
    }
    setAttr(e, t) {
      var n = this['set' + Vg._capitalize(e)]
      return Vg._isFunction(n) ? n.call(this, t) : this._setAttr(e, t), this
    }
    _requestDraw() {
      var e
      jg.autoDrawEnabled && null != (e = this.getLayer() || this.getStage()) && e.batchDraw()
    }
    _setAttr(e, t) {
      var n = this.attrs[e]
      ;(n === t && !Vg.isObject(t)) ||
        (null == t ? delete this.attrs[e] : (this.attrs[e] = t),
        this._shouldFireChangeEvents && this._fireChangeEvent(e, n, t),
        this._requestDraw())
    }
    _setComponentAttr(e, t, n) {
      var r
      void 0 !== n &&
        ((r = this.attrs[e]) || (this.attrs[e] = this.getAttr(e)),
        (this.attrs[e][t] = n),
        this._fireChangeEvent(e, r, n))
    }
    _fireAndBubble(e, t, n) {
      var r
      t && 'Shape' === this.nodeType && (t.target = this),
        ((e === gm || e === mm) &&
          ((n && (this === n || (this.isAncestorOf && this.isAncestorOf(n)))) || ('Stage' === this.nodeType && !n))) ||
          (this._fire(e, t),
          (r = (e === gm || e === mm) && n && n.isAncestorOf && n.isAncestorOf(this) && !n.isAncestorOf(this.parent)),
          ((t && !t.cancelBubble) || !t) &&
            this.parent &&
            this.parent.isListening() &&
            !r &&
            (n && n.parent
              ? this._fireAndBubble.call(this.parent, e, t, n)
              : this._fireAndBubble.call(this.parent, e, t)))
    }
    _getProtoListeners(e) {
      let t = this._cache.get(um)
      if (!t) {
        t = {}
        let e = Object.getPrototypeOf(this)
        for (; e; ) {
          if (e.eventListeners)
            for (var n in e.eventListeners) {
              var r = e.eventListeners[n],
                i = t[n] || []
              t[n] = r.concat(i)
            }
          e = Object.getPrototypeOf(e)
        }
        this._cache.set(um, t)
      }
      return t[e]
    }
    _fire(e, t) {
      ;((t = t || {}).currentTarget = this), (t.type = e)
      var n = this._getProtoListeners(e)
      if (n) for (var r = 0; r < n.length; r++) n[r].handler.call(this, t)
      var i = this.eventListeners[e]
      if (i) for (r = 0; r < i.length; r++) i[r].handler.call(this, t)
    }
    draw() {
      return this.drawScene(), this.drawHit(), this
    }
    _createDragElement(e) {
      e = e ? e.pointerId : void 0
      var t = this.getStage(),
        n = this.getAbsolutePosition()
      t = t._getPointerById(e) || t._changedPointerPositions[0] || n
      sm._dragElements.set(this._id, {
        node: this,
        startPointerPos: t,
        offset: { x: t.x - n.x, y: t.y - n.y },
        dragStatus: 'ready',
        pointerId: e
      })
    }
    startDrag(e, t = !0) {
      sm._dragElements.has(this._id) || this._createDragElement(e),
        (sm._dragElements.get(this._id).dragStatus = 'dragging'),
        this.fire('dragstart', { type: 'dragstart', target: this, evt: e && e.evt }, t)
    }
    _setDragPosition(e, t) {
      var n = this.getStage()._getPointerById(t.pointerId)
      n &&
        ((n = { x: n.x - t.offset.x, y: n.y - t.offset.y }),
        void 0 !== (t = this.dragBoundFunc()) &&
          ((t = t.call(this, n, e))
            ? (n = t)
            : Vg.warn(
                'dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.'
              )),
        (this._lastPos && this._lastPos.x === n.x && this._lastPos.y === n.y) ||
          (this.setAbsolutePosition(n), this._requestDraw()),
        (this._lastPos = n))
    }
    stopDrag(e) {
      var t = sm._dragElements.get(this._id)
      t && (t.dragStatus = 'stopped'), sm._endDragBefore(e), sm._endDragAfter(e)
    }
    setDraggable(e) {
      this._setAttr('draggable', e), this._dragChange()
    }
    isDragging() {
      var e = sm._dragElements.get(this._id)
      return !!e && 'dragging' === e.dragStatus
    }
    _listenDrag() {
      this._dragCleanup(),
        this.on('mousedown.konva touchstart.konva', function (e) {
          var t
          ;(void 0 !== e.evt.button && !(0 <= jg.dragButtons.indexOf(e.evt.button))) ||
            this.isDragging() ||
            ((t = !1),
            sm._dragElements.forEach(e => {
              this.isAncestorOf(e.node) && (t = !0)
            }),
            t) ||
            this._createDragElement(e)
        })
    }
    _dragChange() {
      var e, t
      this.attrs.draggable
        ? this._listenDrag()
        : (this._dragCleanup(),
          this.getStage() &&
            ((e = (t = sm._dragElements.get(this._id)) && 'dragging' === t.dragStatus),
            (t = t && 'ready' === t.dragStatus),
            e ? this.stopDrag() : t && sm._dragElements.delete(this._id)))
    }
    _dragCleanup() {
      this.off('mousedown.konva'), this.off('touchstart.konva')
    }
    isClientRectOnScreen(e = { x: 0, y: 0 }) {
      var t = this.getStage()
      return (
        !!t &&
        ((t = { x: -e.x, y: -e.y, width: t.width() + 2 * e.x, height: t.height() + 2 * e.y }),
        Vg.haveIntersection(t, this.getClientRect()))
      )
    }
    static create(e, t) {
      return Vg._isString(e) && (e = JSON.parse(e)), this._createNode(e, t)
    }
    static _createNode(e, t) {
      var n,
        r,
        i = wm.prototype.getClassName.call(e),
        o = e.children
      t && (e.attrs.container = t),
        jg[i] || (Vg.warn('Can not find a node with class name "' + i + '". Fallback to "Shape".'), (i = 'Shape'))
      var a = new jg[i](e.attrs)
      if (o) for (n = o.length, r = 0; r < n; r++) a.add(wm._createNode(o[r]))
      return a
    }
  }
  ;(wm.prototype.nodeType = 'Node'),
    (wm.prototype._attrsAffectingSize = []),
    (wm.prototype.eventListeners = {}),
    wm.prototype.on.call(wm.prototype, p, function () {
      this._batchingTransformChange
        ? (this._needClearTransformCache = !0)
        : (this._clearCache(vm), this._clearSelfAndDescendantCache(dm))
    }),
    wm.prototype.on.call(wm.prototype, 'visibleChange.konva', function () {
      this._clearSelfAndDescendantCache(ym)
    }),
    wm.prototype.on.call(wm.prototype, 'listeningChange.konva', function () {
      this._clearSelfAndDescendantCache(pm)
    }),
    wm.prototype.on.call(wm.prototype, 'opacityChange.konva', function () {
      this._clearSelfAndDescendantCache(cm)
    }),
    (h = Jg.addGetterSetter)(wm, 'zIndex'),
    h(wm, 'absolutePosition'),
    h(wm, 'position'),
    h(wm, 'x', 0, Zg()),
    h(wm, 'y', 0, Zg()),
    h(wm, 'globalCompositeOperation', 'source-over', Yg()),
    h(wm, 'opacity', 1, Zg()),
    h(wm, 'name', '', Yg()),
    h(wm, 'id', '', Yg()),
    h(wm, 'rotation', 0, Zg()),
    Jg.addComponentsGetterSetter(wm, 'scale', ['x', 'y']),
    h(wm, 'scaleX', 1, Zg()),
    h(wm, 'scaleY', 1, Zg()),
    Jg.addComponentsGetterSetter(wm, 'skew', ['x', 'y']),
    h(wm, 'skewX', 0, Zg()),
    h(wm, 'skewY', 0, Zg()),
    Jg.addComponentsGetterSetter(wm, 'offset', ['x', 'y']),
    h(wm, 'offsetX', 0, Zg()),
    h(wm, 'offsetY', 0, Zg()),
    h(wm, 'dragDistance', null, Zg()),
    h(wm, 'width', 0, Zg()),
    h(wm, 'height', 0, Zg()),
    h(wm, 'listening', !0, $g()),
    h(wm, 'preventDefault', !0, $g()),
    h(wm, 'filters', null, function (e) {
      return (this._filterUpToDate = !1), e
    }),
    h(wm, 'visible', !0, $g()),
    h(wm, 'transformsEnabled', 'all', Yg()),
    h(wm, 'size'),
    h(wm, 'dragBoundFunc'),
    h(wm, 'draggable', !1, $g()),
    Jg.backCompat(wm, { rotateDeg: 'rotate', setRotationDeg: 'setRotation', getRotationDeg: 'getRotation' })
  class Cm extends wm {
    constructor() {
      super(...arguments), (this.children = [])
    }
    getChildren(e) {
      var t, n
      return e
        ? ((t = this.children || []),
          (n = []),
          t.forEach(function (t) {
            e(t) && n.push(t)
          }),
          n)
        : this.children || []
    }
    hasChildren() {
      return 0 < this.getChildren().length
    }
    removeChildren() {
      return (
        this.getChildren().forEach(e => {
          ;(e.parent = null), (e.index = 0), e.remove()
        }),
        (this.children = []),
        this._requestDraw(),
        this
      )
    }
    destroyChildren() {
      return (
        this.getChildren().forEach(e => {
          ;(e.parent = null), (e.index = 0), e.destroy()
        }),
        (this.children = []),
        this._requestDraw(),
        this
      )
    }
    add(...e) {
      if (0 !== e.length)
        if (1 < e.length) for (var t = 0; t < e.length; t++) this.add(e[t])
        else {
          var n = e[0]
          n.getParent()
            ? n.moveTo(this)
            : (this._validateAdd(n),
              (n.index = this.getChildren().length),
              (n.parent = this),
              n._clearCaches(),
              this.getChildren().push(n),
              this._fire('add', { child: n }),
              this._requestDraw())
        }
      return this
    }
    destroy() {
      return this.hasChildren() && this.destroyChildren(), super.destroy(), this
    }
    find(e) {
      return this._generalFind(e, !1)
    }
    findOne(e) {
      return 0 < (e = this._generalFind(e, !0)).length ? e[0] : void 0
    }
    _generalFind(e, t) {
      var n = []
      return (
        this._descendants(r => {
          var i = r._isMatch(e)
          return i && n.push(r), !(!i || !t)
        }),
        n
      )
    }
    _descendants(e) {
      for (const t of this.getChildren()) {
        if (e(t)) return !0
        if (t.hasChildren() && t._descendants(e)) return !0
      }
      return !1
    }
    toObject() {
      var e = wm.prototype.toObject.call(this)
      return (
        (e.children = []),
        this.getChildren().forEach(t => {
          e.children.push(t.toObject())
        }),
        e
      )
    }
    isAncestorOf(e) {
      for (var t = e.getParent(); t; ) {
        if (t._id === this._id) return !0
        t = t.getParent()
      }
      return !1
    }
    clone(e) {
      var t = wm.prototype.clone.call(this, e)
      return (
        this.getChildren().forEach(function (e) {
          t.add(e.clone())
        }),
        t
      )
    }
    getAllIntersections(e) {
      var t = []
      return (
        this.find('Shape').forEach(function (n) {
          n.isVisible() && n.intersects(e) && t.push(n)
        }),
        t
      )
    }
    _clearSelfAndDescendantCache(e) {
      var t
      super._clearSelfAndDescendantCache(e),
        this.isCached() ||
          (null != (t = this.children) &&
            t.forEach(function (t) {
              t._clearSelfAndDescendantCache(e)
            }))
    }
    _setChildrenIndices() {
      var e
      null != (e = this.children) &&
        e.forEach(function (e, t) {
          e.index = t
        }),
        this._requestDraw()
    }
    drawScene(e, t) {
      var n = this.getLayer(),
        r = ((n = (e = e || (n && n.getCanvas())) && e.getContext()), (r = this._getCanvasCache()) && r.scene),
        i = e && e.isCache
      return (
        (this.isVisible() || i) &&
          (r
            ? (n.save(),
              (i = this.getAbsoluteTransform(t).getMatrix()),
              n.transform(i[0], i[1], i[2], i[3], i[4], i[5]),
              this._drawCachedSceneCanvas(n),
              n.restore())
            : this._drawChildren('drawScene', e, t)),
        this
      )
    }
    drawHit(e, t) {
      var n, r
      return (
        this.shouldDrawHit(t) &&
          ((n = this.getLayer()),
          (n = (e = e || (n && n.hitCanvas)) && e.getContext()),
          (r = this._getCanvasCache()) && r.hit
            ? (n.save(),
              (r = this.getAbsoluteTransform(t).getMatrix()),
              n.transform(r[0], r[1], r[2], r[3], r[4], r[5]),
              this._drawCachedHitCanvas(n),
              n.restore())
            : this._drawChildren('drawHit', e, t)),
        this
      )
    }
    _drawChildren(e, t, n) {
      var r,
        i,
        o,
        a = t && t.getContext(),
        l = this.clipWidth(),
        s = this.clipHeight(),
        c = this.clipFunc(),
        u = (l && s) || c,
        d = n === this
      ;(c =
        (u &&
          (a.save(),
          (i = (r = this.getAbsoluteTransform(n)).getMatrix()),
          a.transform(i[0], i[1], i[2], i[3], i[4], i[5]),
          a.beginPath(),
          c ? c.call(this, a, this) : ((c = this.clipX()), (o = this.clipY()), a.rect(c, o, l, s)),
          a.clip(),
          (i = r.copy().invert().getMatrix()),
          a.transform(i[0], i[1], i[2], i[3], i[4], i[5])),
        !d && 'source-over' !== this.globalCompositeOperation() && 'drawScene' === e)) &&
        (a.save(), a._applyGlobalCompositeOperation(this)),
        null != (o = this.children) &&
          o.forEach(function (r) {
            r[e](t, n)
          }),
        c && a.restore(),
        u && a.restore()
    }
    getClientRect(e) {
      for (
        var t,
          n,
          r,
          i,
          o,
          a,
          l = (e = e || {}).skipTransform,
          s = e.relativeTo,
          c = this,
          u =
            (null != (t = this.children) &&
              t.forEach(function (t) {
                !t.visible() ||
                  (0 ===
                    (t = t.getClientRect({ relativeTo: c, skipShadow: e.skipShadow, skipStroke: e.skipStroke }))
                      .width &&
                    0 === t.height) ||
                  (o =
                    void 0 === n
                      ? ((n = t.x), (r = t.y), (i = t.x + t.width), t.y + t.height)
                      : ((n = Math.min(n, t.x)),
                        (r = Math.min(r, t.y)),
                        (i = Math.max(i, t.x + t.width)),
                        Math.max(o, t.y + t.height)))
              }),
            this.find('Shape')),
          d = !1,
          f = 0;
        f < u.length;
        f++
      )
        if (u[f]._isVisible(this)) {
          d = !0
          break
        }
      return (
        (a = d && void 0 !== n ? { x: n, y: r, width: i - n, height: o - r } : { x: 0, y: 0, width: 0, height: 0 }),
        l ? a : this._transformedRect(a, s)
      )
    }
  }
  Jg.addComponentsGetterSetter(Cm, 'clip', ['x', 'y', 'width', 'height']),
    Jg.addGetterSetter(Cm, 'clipX', void 0, Zg()),
    Jg.addGetterSetter(Cm, 'clipY', void 0, Zg()),
    Jg.addGetterSetter(Cm, 'clipWidth', void 0, Zg()),
    Jg.addGetterSetter(Cm, 'clipHeight', void 0, Zg()),
    Jg.addGetterSetter(Cm, 'clipFunc')
  const xm = new Map(),
    Em = void 0 !== jg._global.PointerEvent
  function Sm(e) {
    return xm.get(e)
  }
  function Om(e) {
    return { evt: e, pointerId: e.pointerId }
  }
  function km(e, t) {
    return xm.get(e) === t
  }
  function Pm(e, t) {
    _m(e), t.getStage() && (xm.set(e, t), Em) && t._fire('gotpointercapture', Om(new PointerEvent('gotpointercapture')))
  }
  function _m(e) {
    var t,
      n = xm.get(e)
    n &&
      ((t = n.getStage()) && t.content, xm.delete(e), Em) &&
      n._fire('lostpointercapture', Om(new PointerEvent('lostpointercapture')))
  }
  var Lm = 'pointerup',
    Tm = 'contextmenu',
    Im = 'wheel',
    Mm = [
      [(l = 'mouseenter'), '_pointerenter'],
      [(Og = 'mousedown'), '_pointerdown'],
      [(ug = 'mousemove'), '_pointermove'],
      [(p = 'mouseup'), '_pointerup'],
      [(y = 'mouseleave'), '_pointerleave'],
      [(Qy = 'touchstart'), '_pointerdown'],
      [(Fj = 'touchmove'), '_pointermove'],
      [(Jy = 'touchend'), '_pointerup'],
      [(dS = 'touchcancel'), '_pointercancel'],
      [(f = 'mouseover'), '_pointerover'],
      [Im, '_wheel'],
      [Tm, '_contextmenu'],
      [(cC = 'pointerdown'), '_pointerdown'],
      [(h = 'pointermove'), '_pointermove'],
      [Lm, '_pointerup'],
      [(wS = 'pointercancel'), '_pointercancel'],
      ['lostpointercapture', '_lostpointercapture']
    ]
  const jm = {
      mouse: {
        pointerout: 'mouseout',
        pointerleave: y,
        pointerover: f,
        pointerenter: l,
        pointermove: ug,
        pointerdown: Og,
        pointerup: p,
        pointercancel: 'mousecancel',
        pointerclick: 'click',
        pointerdblclick: 'dblclick'
      },
      touch: {
        pointerout: 'touchout',
        pointerleave: 'touchleave',
        pointerover: 'touchover',
        pointerenter: 'touchenter',
        pointermove: Fj,
        pointerdown: Qy,
        pointerup: Jy,
        pointercancel: dS,
        pointerclick: 'tap',
        pointerdblclick: 'dbltap'
      },
      pointer: {
        pointerout: (rC = 'pointerout'),
        pointerleave: (iC = 'pointerleave'),
        pointerover: (oC = 'pointerover'),
        pointerenter: (aC = 'pointerenter'),
        pointermove: h,
        pointerdown: cC,
        pointerup: Lm,
        pointercancel: wS,
        pointerclick: 'pointerclick',
        pointerdblclick: 'pointerdblclick'
      }
    },
    Rm = e => (0 <= e.indexOf('pointer') ? 'pointer' : 0 <= e.indexOf('touch') ? 'touch' : 'mouse'),
    Dm = e =>
      'pointer' === (e = Rm(e))
        ? jg.pointerEventsEnabled && jm.pointer
        : 'touch' === e
        ? jm.touch
        : 'mouse' === e
        ? jm.mouse
        : void 0
  function Am(e = {}) {
    return (
      (e.clipFunc || e.clipWidth || e.clipHeight) &&
        Vg.warn('Stage does not support clipping. Please use clip for Layers or Groups.'),
      e
    )
  }
  const zm = []
  class Nm extends Cm {
    constructor(e) {
      super(Am(e)),
        (this._pointerPositions = []),
        (this._changedPointerPositions = []),
        this._buildDOM(),
        this._bindContentEvents(),
        zm.push(this),
        this.on('widthChange.konva heightChange.konva', this._resizeDOM),
        this.on('visibleChange.konva', this._checkVisibility),
        this.on('clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva', () => {
          Am(this.attrs)
        }),
        this._checkVisibility()
    }
    _validateAdd(e) {
      var t = 'Layer' === e.getType()
      e = 'FastLayer' === e.getType()
      t || e || Vg.throw('You may only add layers to the stage.')
    }
    _checkVisibility() {
      var e
      this.content && ((e = this.visible() ? '' : 'none'), (this.content.style.display = e))
    }
    setContainer(e) {
      var t, n
      if (
        'string' == typeof e &&
        !(e =
          '.' === e.charAt(0)
            ? ((t = e.slice(1)), document.getElementsByClassName(t)[0])
            : ((n = '#' !== e.charAt(0) ? e : e.slice(1)), document.getElementById(n)))
      )
        throw 'Can not find container in document with id ' + n
      return (
        this._setAttr('container', e),
        this.content &&
          (this.content.parentElement && this.content.parentElement.removeChild(this.content),
          e.appendChild(this.content)),
        this
      )
    }
    shouldDrawHit() {
      return !0
    }
    clear() {
      for (var e = this.children, t = e.length, n = 0; n < t; n++) e[n].clear()
      return this
    }
    clone(e) {
      return (
        ((e = e || {}).container = 'undefined' != typeof document && document.createElement('div')),
        Cm.prototype.clone.call(this, e)
      )
    }
    destroy() {
      var e
      return (
        super.destroy(),
        -1 < (e = ((e = this.content) && Vg._isInDocument(e) && this.container().removeChild(e), zm.indexOf(this))) &&
          zm.splice(e, 1),
        Vg.releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas),
        this
      )
    }
    getPointerPosition() {
      var e = this._pointerPositions[0] || this._changedPointerPositions[0]
      return e
        ? { x: e.x, y: e.y }
        : (Vg.warn(
            'Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);'
          ),
          null)
    }
    _getPointerById(e) {
      return this._pointerPositions.find(t => t.id === e)
    }
    getPointersPositions() {
      return this._pointerPositions
    }
    getStage() {
      return this
    }
    getContent() {
      return this.content
    }
    _toKonvaCanvas(e) {
      ;((e = e || {}).x = e.x || 0),
        (e.y = e.y || 0),
        (e.width = e.width || this.width()),
        (e.height = e.height || this.height())
      var t = new am({ width: e.width, height: e.height, pixelRatio: e.pixelRatio || 1 }),
        n = t.getContext()._context,
        r = this.children
      return (
        (e.x || e.y) && n.translate(-1 * e.x, -1 * e.y),
        r.forEach(function (t) {
          t.isVisible() &&
            ((t = t._toKonvaCanvas(e)),
            n.drawImage(t._canvas, e.x, e.y, t.getWidth() / t.getPixelRatio(), t.getHeight() / t.getPixelRatio()))
        }),
        t
      )
    }
    getIntersection(e) {
      if (e)
        for (var t = this.children, n = t.length - 1; 0 <= n; n--) {
          var r = t[n].getIntersection(e)
          if (r) return r
        }
      return null
    }
    _resizeDOM() {
      var e = this.width(),
        t = this.height()
      this.content && ((this.content.style.width = e + 'px'), (this.content.style.height = t + 'px')),
        this.bufferCanvas.setSize(e, t),
        this.bufferHitCanvas.setSize(e, t),
        this.children.forEach(n => {
          n.setSize({ width: e, height: t }), n.draw()
        })
    }
    add(e) {
      if (1 < arguments.length) for (var t = 0; t < arguments.length; t++) this.add(arguments[t])
      else {
        super.add(e)
        var n = this.children.length
        5 < n &&
          Vg.warn(
            'The stage has ' +
              n +
              ' layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group.'
          ),
          e.setSize({ width: this.width(), height: this.height() }),
          e.draw(),
          jg.isBrowser && this.content.appendChild(e.canvas._canvas)
      }
      return this
    }
    getParent() {
      return null
    }
    getLayer() {
      return null
    }
    hasPointerCapture(e) {
      return km(e, this)
    }
    setPointerCapture(e) {
      Pm(e, this)
    }
    releaseCapture(e) {
      _m(e)
    }
    getLayers() {
      return this.children
    }
    _bindContentEvents() {
      jg.isBrowser &&
        Mm.forEach(([e, t]) => {
          this.content.addEventListener(
            e,
            e => {
              this[t](e)
            },
            { passive: !1 }
          )
        })
    }
    _pointerenter(e) {
      this.setPointersPositions(e)
      var t = Dm(e.type)
      this._fire(t.pointerenter, { evt: e, target: this, currentTarget: this })
    }
    _pointerover(e) {
      this.setPointersPositions(e)
      var t = Dm(e.type)
      this._fire(t.pointerover, { evt: e, target: this, currentTarget: this })
    }
    _getTargetShape(e) {
      let t = this[e + 'targetShape']
      return t && !t.getStage() ? null : t
    }
    _pointerleave(e) {
      var t,
        n,
        r = Dm(e.type),
        i = Rm(e.type)
      r &&
        (this.setPointersPositions(e),
        (t = this._getTargetShape(i)),
        (n = !sm.isDragging || jg.hitOnDragEnabled),
        t && n
          ? (t._fireAndBubble(r.pointerout, { evt: e }),
            t._fireAndBubble(r.pointerleave, { evt: e }),
            this._fire(r.pointerleave, { evt: e, target: this, currentTarget: this }),
            (this[i + 'targetShape'] = null))
          : n &&
            (this._fire(r.pointerleave, { evt: e, target: this, currentTarget: this }),
            this._fire(r.pointerout, { evt: e, target: this, currentTarget: this })),
        (this.pointerPos = void 0),
        (this._pointerPositions = []))
    }
    _pointerdown(e) {
      const t = Dm(e.type),
        n = Rm(e.type)
      var r
      t &&
        (this.setPointersPositions(e),
        (r = !1),
        this._changedPointerPositions.forEach(i => {
          var o = this.getIntersection(i),
            a = ((sm.justDragged = !1), (jg['_' + n + 'ListenClick'] = !0), o && o.isListening())
          a &&
            (jg.capturePointerEventsEnabled && o.setPointerCapture(i.id),
            (this[n + 'ClickStartShape'] = o)._fireAndBubble(t.pointerdown, { evt: e, pointerId: i.id }),
            (r = !0),
            (a = 0 <= e.type.indexOf('touch')),
            o.preventDefault()) &&
            e.cancelable &&
            a &&
            e.preventDefault()
        }),
        r ||
          this._fire(t.pointerdown, {
            evt: e,
            target: this,
            currentTarget: this,
            pointerId: this._pointerPositions[0].id
          }))
    }
    _pointermove(e) {
      const t = Dm(e.type),
        n = Rm(e.type)
      if (
        t &&
        (sm.isDragging && sm.node.preventDefault() && e.cancelable && e.preventDefault(),
        this.setPointersPositions(e),
        !sm.isDragging || jg.hitOnDragEnabled)
      ) {
        var r = {}
        let o = !1
        var i = this._getTargetShape(n)
        this._changedPointerPositions.forEach(a => {
          var l = Sm(a.id) || this.getIntersection(a),
            s = ((a = a.id), { evt: e, pointerId: a }),
            c = i !== l
          if (
            (c &&
              i &&
              (i._fireAndBubble(t.pointerout, Object.assign({}, s), l),
              i._fireAndBubble(t.pointerleave, Object.assign({}, s), l)),
            l)
          ) {
            if (r[l._id]) return
            r[l._id] = !0
          }
          l && l.isListening()
            ? ((o = !0),
              c &&
                (l._fireAndBubble(t.pointerover, Object.assign({}, s), i),
                l._fireAndBubble(t.pointerenter, Object.assign({}, s), i),
                (this[n + 'targetShape'] = l)),
              l._fireAndBubble(t.pointermove, Object.assign({}, s)))
            : i &&
              (this._fire(t.pointerover, { evt: e, target: this, currentTarget: this, pointerId: a }),
              (this[n + 'targetShape'] = null))
        }),
          o ||
            this._fire(t.pointermove, {
              evt: e,
              target: this,
              currentTarget: this,
              pointerId: this._changedPointerPositions[0].id
            })
      }
    }
    _pointerup(e) {
      const t = Dm(e.type),
        n = Rm(e.type)
      if (t) {
        this.setPointersPositions(e)
        const i = this[n + 'ClickStartShape'],
          o = this[n + 'ClickEndShape']
        var r = {}
        let a = !1
        this._changedPointerPositions.forEach(l => {
          var s = Sm(l.id) || this.getIntersection(l)
          if (s) {
            if ((s.releaseCapture(l.id), r[s._id])) return
            r[s._id] = !0
          }
          l = l.id
          var c = { evt: e, pointerId: l }
          let u = !1
          jg['_' + n + 'InDblClickWindow']
            ? ((u = !0), clearTimeout(this[n + 'DblTimeout']))
            : sm.justDragged || ((jg['_' + n + 'InDblClickWindow'] = !0), clearTimeout(this[n + 'DblTimeout'])),
            (this[n + 'DblTimeout'] = setTimeout(function () {
              jg['_' + n + 'InDblClickWindow'] = !1
            }, jg.dblClickWindow)),
            s && s.isListening()
              ? ((a = !0),
                (this[n + 'ClickEndShape'] = s)._fireAndBubble(t.pointerup, Object.assign({}, c)),
                jg['_' + n + 'ListenClick'] &&
                  i &&
                  i === s &&
                  (s._fireAndBubble(t.pointerclick, Object.assign({}, c)), u) &&
                  o &&
                  o === s &&
                  s._fireAndBubble(t.pointerdblclick, Object.assign({}, c)))
              : ((this[n + 'ClickEndShape'] = null),
                jg['_' + n + 'ListenClick'] &&
                  this._fire(t.pointerclick, { evt: e, target: this, currentTarget: this, pointerId: l }),
                u && this._fire(t.pointerdblclick, { evt: e, target: this, currentTarget: this, pointerId: l }))
        }),
          a ||
            this._fire(t.pointerup, {
              evt: e,
              target: this,
              currentTarget: this,
              pointerId: this._changedPointerPositions[0].id
            }),
          (jg['_' + n + 'ListenClick'] = !1),
          e.cancelable && 'touch' !== n && e.preventDefault()
      }
    }
    _contextmenu(e) {
      this.setPointersPositions(e)
      var t = this.getIntersection(this.getPointerPosition())
      t && t.isListening()
        ? t._fireAndBubble(Tm, { evt: e })
        : this._fire(Tm, { evt: e, target: this, currentTarget: this })
    }
    _wheel(e) {
      this.setPointersPositions(e)
      var t = this.getIntersection(this.getPointerPosition())
      t && t.isListening()
        ? t._fireAndBubble(Im, { evt: e })
        : this._fire(Im, { evt: e, target: this, currentTarget: this })
    }
    _pointercancel(e) {
      this.setPointersPositions(e)
      var t = Sm(e.pointerId) || this.getIntersection(this.getPointerPosition())
      t && t._fireAndBubble(Lm, Om(e)), _m(e.pointerId)
    }
    _lostpointercapture(e) {
      _m(e.pointerId)
    }
    setPointersPositions(e) {
      var t,
        n,
        r = this._getContentPosition()
      void 0 !== (e = e || window.event).touches
        ? ((this._pointerPositions = []),
          (this._changedPointerPositions = []),
          Array.prototype.forEach.call(e.touches, e => {
            this._pointerPositions.push({
              id: e.identifier,
              x: (e.clientX - r.left) / r.scaleX,
              y: (e.clientY - r.top) / r.scaleY
            })
          }),
          Array.prototype.forEach.call(e.changedTouches || e.touches, e => {
            this._changedPointerPositions.push({
              id: e.identifier,
              x: (e.clientX - r.left) / r.scaleX,
              y: (e.clientY - r.top) / r.scaleY
            })
          }))
        : ((t = (e.clientX - r.left) / r.scaleX),
          (n = (e.clientY - r.top) / r.scaleY),
          (this.pointerPos = { x: t, y: n }),
          (this._pointerPositions = [{ x: t, y: n, id: Vg._getFirstPointerId(e) }]),
          (this._changedPointerPositions = [{ x: t, y: n, id: Vg._getFirstPointerId(e) }]))
    }
    _setPointerPosition(e) {
      Vg.warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.'),
        this.setPointersPositions(e)
    }
    _getContentPosition() {
      var e
      return this.content && this.content.getBoundingClientRect
        ? {
            top: (e = this.content.getBoundingClientRect()).top,
            left: e.left,
            scaleX: e.width / this.content.clientWidth || 1,
            scaleY: e.height / this.content.clientHeight || 1
          }
        : { top: 0, left: 0, scaleX: 1, scaleY: 1 }
    }
    _buildDOM() {
      if (
        ((this.bufferCanvas = new am({ width: this.width(), height: this.height() })),
        (this.bufferHitCanvas = new lm({ pixelRatio: 1, width: this.width(), height: this.height() })),
        jg.isBrowser)
      ) {
        var e = this.container()
        if (!e) throw 'Stage has no container. A container is required.'
        ;(e.innerHTML = ''),
          (this.content = document.createElement('div')),
          (this.content.style.position = 'relative'),
          (this.content.style.userSelect = 'none'),
          (this.content.className = 'konvajs-content'),
          this.content.setAttribute('role', 'presentation'),
          e.appendChild(this.content),
          this._resizeDOM()
      }
    }
    cache() {
      return (
        Vg.warn('Cache function is not allowed for stage. You may use cache only for layers, groups and shapes.'), this
      )
    }
    clearCache() {
      return this
    }
    batchDraw() {
      return (
        this.getChildren().forEach(function (e) {
          e.batchDraw()
        }),
        this
      )
    }
  }
  ;(Nm.prototype.nodeType = 'Stage'), mg(Nm), Jg.addGetterSetter(Nm, 'container')
  var Fm = 'hasShadow',
    Hm = 'shadowRGBA',
    Bm = 'patternImage',
    Vm = 'linearGradient',
    Wm = 'radialGradient'
  let Gm
  function Zm() {
    return (Gm = Gm || Vg.createCanvasElement().getContext('2d'))
  }
  const Um = {}
  class Xm extends wm {
    constructor(e) {
      let t
      for (super(e); !(t = Vg.getRandomColor()) || t in Um; );
      ;(this.colorKey = t), (Um[t] = this)
    }
    getContext() {
      return Vg.warn('shape.getContext() method is deprecated. Please do not use it.'), this.getLayer().getContext()
    }
    getCanvas() {
      return Vg.warn('shape.getCanvas() method is deprecated. Please do not use it.'), this.getLayer().getCanvas()
    }
    getSceneFunc() {
      return this.attrs.sceneFunc || this._sceneFunc
    }
    getHitFunc() {
      return this.attrs.hitFunc || this._hitFunc
    }
    hasShadow() {
      return this._getCache(Fm, this._hasShadow)
    }
    _hasShadow() {
      return (
        this.shadowEnabled() &&
        0 !== this.shadowOpacity() &&
        !!(this.shadowColor() || this.shadowBlur() || this.shadowOffsetX() || this.shadowOffsetY())
      )
    }
    _getFillPattern() {
      return this._getCache(Bm, this.__getFillPattern)
    }
    __getFillPattern() {
      var e, t
      if (this.fillPatternImage())
        return (
          (e = Zm().createPattern(this.fillPatternImage(), this.fillPatternRepeat() || 'repeat')) &&
            e.setTransform &&
            ((t = new Rg()).translate(this.fillPatternX(), this.fillPatternY()),
            t.rotate(jg.getAngle(this.fillPatternRotation())),
            t.scale(this.fillPatternScaleX(), this.fillPatternScaleY()),
            t.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY()),
            (t = t.getMatrix()),
            (t =
              'undefined' == typeof DOMMatrix
                ? { a: t[0], b: t[1], c: t[2], d: t[3], e: t[4], f: t[5] }
                : new DOMMatrix(t)),
            e.setTransform(t)),
          e
        )
    }
    _getLinearGradient() {
      return this._getCache(Vm, this.__getLinearGradient)
    }
    __getLinearGradient() {
      var e = this.fillLinearGradientColorStops()
      if (e) {
        for (
          var t = Zm(),
            n = this.fillLinearGradientStartPoint(),
            r = this.fillLinearGradientEndPoint(),
            i = t.createLinearGradient(n.x, n.y, r.x, r.y),
            o = 0;
          o < e.length;
          o += 2
        )
          i.addColorStop(e[o], e[o + 1])
        return i
      }
    }
    _getRadialGradient() {
      return this._getCache(Wm, this.__getRadialGradient)
    }
    __getRadialGradient() {
      var e = this.fillRadialGradientColorStops()
      if (e) {
        for (
          var t = Zm(),
            n = this.fillRadialGradientStartPoint(),
            r = this.fillRadialGradientEndPoint(),
            i = t.createRadialGradient(
              n.x,
              n.y,
              this.fillRadialGradientStartRadius(),
              r.x,
              r.y,
              this.fillRadialGradientEndRadius()
            ),
            o = 0;
          o < e.length;
          o += 2
        )
          i.addColorStop(e[o], e[o + 1])
        return i
      }
    }
    getShadowRGBA() {
      return this._getCache(Hm, this._getShadowRGBA)
    }
    _getShadowRGBA() {
      var e
      return this.hasShadow() && (e = Vg.colorToRGBA(this.shadowColor()))
        ? 'rgba(' + e.r + ',' + e.g + ',' + e.b + ',' + e.a * (this.shadowOpacity() || 1) + ')'
        : void 0
    }
    hasFill() {
      return this._calculate(
        'hasFill',
        ['fillEnabled', 'fill', 'fillPatternImage', 'fillLinearGradientColorStops', 'fillRadialGradientColorStops'],
        () =>
          this.fillEnabled() &&
          !!(
            this.fill() ||
            this.fillPatternImage() ||
            this.fillLinearGradientColorStops() ||
            this.fillRadialGradientColorStops()
          )
      )
    }
    hasStroke() {
      return this._calculate(
        'hasStroke',
        ['strokeEnabled', 'strokeWidth', 'stroke', 'strokeLinearGradientColorStops'],
        () => this.strokeEnabled() && this.strokeWidth() && !(!this.stroke() && !this.strokeLinearGradientColorStops())
      )
    }
    hasHitStroke() {
      var e = this.hitStrokeWidth()
      return 'auto' === e ? this.hasStroke() : this.strokeEnabled() && !!e
    }
    intersects(e) {
      var t = this.getStage().bufferHitCanvas
      return (
        t.getContext().clear(),
        this.drawHit(t, null, !0),
        0 < t.context.getImageData(Math.round(e.x), Math.round(e.y), 1, 1).data[3]
      )
    }
    destroy() {
      return wm.prototype.destroy.call(this), delete Um[this.colorKey], delete this.colorKey, this
    }
    _useBufferCanvas(e) {
      var t, n, r
      return (
        !!this.getStage() &&
        !(
          (null != (t = this.attrs.perfectDrawEnabled) && !t) ||
          ((t = e || this.hasFill()),
          (e = this.hasStroke()),
          (n = 1 !== this.getAbsoluteOpacity()),
          !((t && e && n) || ((n = this.hasShadow()), (r = this.shadowForStrokeEnabled()), t && e && n && r)))
        )
      )
    }
    setStrokeHitEnabled(e) {
      Vg.warn('strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead.'),
        e ? this.hitStrokeWidth('auto') : this.hitStrokeWidth(0)
    }
    getStrokeHitEnabled() {
      return 0 !== this.hitStrokeWidth()
    }
    getSelfRect() {
      var e = this.size()
      return {
        x: this._centroid ? -e.width / 2 : 0,
        y: this._centroid ? -e.height / 2 : 0,
        width: e.width,
        height: e.height
      }
    }
    getClientRect(e = {}) {
      var t = e.skipTransform,
        n = e.relativeTo,
        r = this.getSelfRect(),
        i = (!e.skipStroke && this.hasStroke() && this.strokeWidth()) || 0,
        o = r.width + i,
        a = r.height + i,
        l = (e = !e.skipShadow && this.hasShadow()) ? this.shadowOffsetX() : 0,
        s = e ? this.shadowOffsetY() : 0
      ;(o += Math.abs(l)),
        (a += Math.abs(s)),
        (o = {
          width: o + 2 * (e = (e && this.shadowBlur()) || 0),
          height: a + 2 * e,
          x: -(i / 2 + e) + Math.min(l, 0) + r.x,
          y: -(i / 2 + e) + Math.min(s, 0) + r.y
        })
      return t ? o : this._transformedRect(o, n)
    }
    drawScene(e, t) {
      var n,
        r = this.getLayer(),
        i = ((r = (e = e || r.getCanvas()).getContext()), this._getCanvasCache()),
        o = this.getSceneFunc(),
        a = this.hasShadow(),
        l = ((e = e.isCache), t === this)
      return (
        (this.isVisible() || l) &&
          (i
            ? (r.save(),
              (i = this.getAbsoluteTransform(t).getMatrix()),
              r.transform(i[0], i[1], i[2], i[3], i[4], i[5]),
              this._drawCachedSceneCanvas(r),
              r.restore())
            : o &&
              (r.save(),
              this._useBufferCanvas() && !e
                ? ((e = (i = this.getStage().bufferCanvas).getContext()).clear(),
                  e.save(),
                  e._applyLineJoin(this),
                  (n = this.getAbsoluteTransform(t).getMatrix()),
                  e.transform(n[0], n[1], n[2], n[3], n[4], n[5]),
                  o.call(this, e, this),
                  e.restore(),
                  (e = i.pixelRatio),
                  a && r._applyShadow(this),
                  r._applyOpacity(this),
                  r._applyGlobalCompositeOperation(this),
                  r.drawImage(i._canvas, 0, 0, i.width / e, i.height / e))
                : (r._applyLineJoin(this),
                  l ||
                    ((n = this.getAbsoluteTransform(t).getMatrix()),
                    r.transform(n[0], n[1], n[2], n[3], n[4], n[5]),
                    r._applyOpacity(this),
                    r._applyGlobalCompositeOperation(this)),
                  a && r._applyShadow(this),
                  o.call(this, r, this)),
              r.restore())),
        this
      )
    }
    drawHit(e, t, n = !1) {
      var r
      return (
        this.shouldDrawHit(t, n) &&
          ((n = this.getLayer()),
          (n = (e = e || n.hitCanvas) && e.getContext()),
          (e = this.hitFunc() || this.sceneFunc()),
          (r = (r = this._getCanvasCache()) && r.hit),
          this.colorKey ||
            Vg.warn(
              'Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()'
            ),
          r
            ? (n.save(),
              (r = this.getAbsoluteTransform(t).getMatrix()),
              n.transform(r[0], r[1], r[2], r[3], r[4], r[5]),
              this._drawCachedHitCanvas(n),
              n.restore())
            : e &&
              (n.save(),
              n._applyLineJoin(this),
              this !== t &&
                ((r = this.getAbsoluteTransform(t).getMatrix()), n.transform(r[0], r[1], r[2], r[3], r[4], r[5])),
              e.call(this, n, this),
              n.restore())),
        this
      )
    }
    drawHitFromCache(e = 0) {
      var t,
        n,
        r,
        i,
        o,
        a = this._getCanvasCache(),
        l = this._getCachedSceneCanvas(),
        s = (a = a.hit).getContext(),
        c = a.getWidth()
      a = a.getHeight()
      s.clear(), s.drawImage(l._canvas, 0, 0, c, a)
      try {
        for (
          r = (n = (t = s.getImageData(0, 0, c, a)).data).length, i = Vg._hexToRgb(this.colorKey), o = 0;
          o < r;
          o += 4
        )
          e < n[o + 3] ? ((n[o] = i.r), (n[o + 1] = i.g), (n[o + 2] = i.b), (n[o + 3] = 255)) : (n[o + 3] = 0)
        s.putImageData(t, 0, 0)
      } catch (u) {
        Vg.error('Unable to draw hit graph from cached scene canvas. ' + u.message)
      }
      return this
    }
    hasPointerCapture(e) {
      return km(e, this)
    }
    setPointerCapture(e) {
      Pm(e, this)
    }
    releaseCapture(e) {
      _m(e)
    }
  }
  ;(Xm.prototype._fillFunc = function (e) {
    e.fill()
  }),
    (Xm.prototype._strokeFunc = function (e) {
      e.stroke()
    }),
    (Xm.prototype._fillFuncHit = function (e) {
      e.fill()
    }),
    (Xm.prototype._strokeFuncHit = function (e) {
      e.stroke()
    }),
    (Xm.prototype._centroid = !1),
    (Xm.prototype.nodeType = 'Shape'),
    mg(Xm),
    (Xm.prototype.eventListeners = {}),
    Xm.prototype.on.call(
      Xm.prototype,
      'shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva',
      function () {
        this._clearCache(Fm)
      }
    ),
    Xm.prototype.on.call(
      Xm.prototype,
      'shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva',
      function () {
        this._clearCache(Hm)
      }
    ),
    Xm.prototype.on.call(
      Xm.prototype,
      'fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva',
      function () {
        this._clearCache(Bm)
      }
    ),
    Xm.prototype.on.call(
      Xm.prototype,
      'fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva',
      function () {
        this._clearCache(Vm)
      }
    ),
    Xm.prototype.on.call(
      Xm.prototype,
      'fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva',
      function () {
        this._clearCache(Wm)
      }
    ),
    Jg.addGetterSetter(Xm, 'stroke', void 0, qg()),
    Jg.addGetterSetter(Xm, 'strokeWidth', 2, Zg()),
    Jg.addGetterSetter(Xm, 'fillAfterStrokeEnabled', !1),
    Jg.addGetterSetter(Xm, 'hitStrokeWidth', 'auto', Xg()),
    Jg.addGetterSetter(Xm, 'strokeHitEnabled', !0, $g()),
    Jg.addGetterSetter(Xm, 'perfectDrawEnabled', !0, $g()),
    Jg.addGetterSetter(Xm, 'shadowForStrokeEnabled', !0, $g()),
    Jg.addGetterSetter(Xm, 'lineJoin'),
    Jg.addGetterSetter(Xm, 'lineCap'),
    Jg.addGetterSetter(Xm, 'sceneFunc'),
    Jg.addGetterSetter(Xm, 'hitFunc'),
    Jg.addGetterSetter(Xm, 'dash'),
    Jg.addGetterSetter(Xm, 'dashOffset', 0, Zg()),
    Jg.addGetterSetter(Xm, 'shadowColor', void 0, Yg()),
    Jg.addGetterSetter(Xm, 'shadowBlur', 0, Zg()),
    Jg.addGetterSetter(Xm, 'shadowOpacity', 1, Zg()),
    Jg.addComponentsGetterSetter(Xm, 'shadowOffset', ['x', 'y']),
    Jg.addGetterSetter(Xm, 'shadowOffsetX', 0, Zg()),
    Jg.addGetterSetter(Xm, 'shadowOffsetY', 0, Zg()),
    Jg.addGetterSetter(Xm, 'fillPatternImage'),
    Jg.addGetterSetter(Xm, 'fill', void 0, qg()),
    Jg.addGetterSetter(Xm, 'fillPatternX', 0, Zg()),
    Jg.addGetterSetter(Xm, 'fillPatternY', 0, Zg()),
    Jg.addGetterSetter(Xm, 'fillLinearGradientColorStops'),
    Jg.addGetterSetter(Xm, 'strokeLinearGradientColorStops'),
    Jg.addGetterSetter(Xm, 'fillRadialGradientStartRadius', 0),
    Jg.addGetterSetter(Xm, 'fillRadialGradientEndRadius', 0),
    Jg.addGetterSetter(Xm, 'fillRadialGradientColorStops'),
    Jg.addGetterSetter(Xm, 'fillPatternRepeat', 'repeat'),
    Jg.addGetterSetter(Xm, 'fillEnabled', !0),
    Jg.addGetterSetter(Xm, 'strokeEnabled', !0),
    Jg.addGetterSetter(Xm, 'shadowEnabled', !0),
    Jg.addGetterSetter(Xm, 'dashEnabled', !0),
    Jg.addGetterSetter(Xm, 'strokeScaleEnabled', !0),
    Jg.addGetterSetter(Xm, 'fillPriority', 'color'),
    Jg.addComponentsGetterSetter(Xm, 'fillPatternOffset', ['x', 'y']),
    Jg.addGetterSetter(Xm, 'fillPatternOffsetX', 0, Zg()),
    Jg.addGetterSetter(Xm, 'fillPatternOffsetY', 0, Zg()),
    Jg.addComponentsGetterSetter(Xm, 'fillPatternScale', ['x', 'y']),
    Jg.addGetterSetter(Xm, 'fillPatternScaleX', 1, Zg()),
    Jg.addGetterSetter(Xm, 'fillPatternScaleY', 1, Zg()),
    Jg.addComponentsGetterSetter(Xm, 'fillLinearGradientStartPoint', ['x', 'y']),
    Jg.addComponentsGetterSetter(Xm, 'strokeLinearGradientStartPoint', ['x', 'y']),
    Jg.addGetterSetter(Xm, 'fillLinearGradientStartPointX', 0),
    Jg.addGetterSetter(Xm, 'strokeLinearGradientStartPointX', 0),
    Jg.addGetterSetter(Xm, 'fillLinearGradientStartPointY', 0),
    Jg.addGetterSetter(Xm, 'strokeLinearGradientStartPointY', 0),
    Jg.addComponentsGetterSetter(Xm, 'fillLinearGradientEndPoint', ['x', 'y']),
    Jg.addComponentsGetterSetter(Xm, 'strokeLinearGradientEndPoint', ['x', 'y']),
    Jg.addGetterSetter(Xm, 'fillLinearGradientEndPointX', 0),
    Jg.addGetterSetter(Xm, 'strokeLinearGradientEndPointX', 0),
    Jg.addGetterSetter(Xm, 'fillLinearGradientEndPointY', 0),
    Jg.addGetterSetter(Xm, 'strokeLinearGradientEndPointY', 0),
    Jg.addComponentsGetterSetter(Xm, 'fillRadialGradientStartPoint', ['x', 'y']),
    Jg.addGetterSetter(Xm, 'fillRadialGradientStartPointX', 0),
    Jg.addGetterSetter(Xm, 'fillRadialGradientStartPointY', 0),
    Jg.addComponentsGetterSetter(Xm, 'fillRadialGradientEndPoint', ['x', 'y']),
    Jg.addGetterSetter(Xm, 'fillRadialGradientEndPointX', 0),
    Jg.addGetterSetter(Xm, 'fillRadialGradientEndPointY', 0),
    Jg.addGetterSetter(Xm, 'fillPatternRotation', 0),
    Jg.backCompat(Xm, {
      dashArray: 'dash',
      getDashArray: 'getDash',
      setDashArray: 'getDash',
      drawFunc: 'sceneFunc',
      getDrawFunc: 'getSceneFunc',
      setDrawFunc: 'setSceneFunc',
      drawHitFunc: 'hitFunc',
      getDrawHitFunc: 'getHitFunc',
      setDrawHitFunc: 'setHitFunc'
    })
  var Ym = [
      { x: 0, y: 0 },
      { x: -1, y: -1 },
      { x: 1, y: -1 },
      { x: 1, y: 1 },
      { x: -1, y: 1 }
    ],
    qm = Ym.length
  class $m extends Cm {
    constructor(e) {
      super(e),
        (this.canvas = new am()),
        (this.hitCanvas = new lm({ pixelRatio: 1 })),
        (this._waitingForDraw = !1),
        this.on('visibleChange.konva', this._checkVisibility),
        this._checkVisibility(),
        this.on('imageSmoothingEnabledChange.konva', this._setSmoothEnabled),
        this._setSmoothEnabled()
    }
    createPNGStream() {
      return this.canvas._canvas.createPNGStream()
    }
    getCanvas() {
      return this.canvas
    }
    getNativeCanvasElement() {
      return this.canvas._canvas
    }
    getHitCanvas() {
      return this.hitCanvas
    }
    getContext() {
      return this.getCanvas().getContext()
    }
    clear(e) {
      return this.getContext().clear(e), this.getHitCanvas().getContext().clear(e), this
    }
    setZIndex(e) {
      super.setZIndex(e)
      var t = this.getStage()
      return (
        t &&
          t.content &&
          (t.content.removeChild(this.getNativeCanvasElement()),
          e < t.children.length - 1
            ? t.content.insertBefore(this.getNativeCanvasElement(), t.children[e + 1].getCanvas()._canvas)
            : t.content.appendChild(this.getNativeCanvasElement())),
        this
      )
    }
    moveToTop() {
      wm.prototype.moveToTop.call(this)
      var e = this.getStage()
      return (
        e &&
          e.content &&
          (e.content.removeChild(this.getNativeCanvasElement()), e.content.appendChild(this.getNativeCanvasElement())),
        !0
      )
    }
    moveUp() {
      var e
      return (
        !!wm.prototype.moveUp.call(this) &&
        !(
          !(e = this.getStage()) ||
          !e.content ||
          (e.content.removeChild(this.getNativeCanvasElement()),
          this.index < e.children.length - 1
            ? e.content.insertBefore(this.getNativeCanvasElement(), e.children[this.index + 1].getCanvas()._canvas)
            : e.content.appendChild(this.getNativeCanvasElement()),
          0)
        )
      )
    }
    moveDown() {
      var e, t
      return (
        !!wm.prototype.moveDown.call(this) &&
        ((e = this.getStage()) &&
          ((t = e.children), e.content) &&
          (e.content.removeChild(this.getNativeCanvasElement()),
          e.content.insertBefore(this.getNativeCanvasElement(), t[this.index + 1].getCanvas()._canvas)),
        !0)
      )
    }
    moveToBottom() {
      var e, t
      return (
        !!wm.prototype.moveToBottom.call(this) &&
        ((e = this.getStage()) &&
          ((t = e.children), e.content) &&
          (e.content.removeChild(this.getNativeCanvasElement()),
          e.content.insertBefore(this.getNativeCanvasElement(), t[1].getCanvas()._canvas)),
        !0)
      )
    }
    getLayer() {
      return this
    }
    remove() {
      var e = this.getNativeCanvasElement()
      return (
        wm.prototype.remove.call(this), e && e.parentNode && Vg._isInDocument(e) && e.parentNode.removeChild(e), this
      )
    }
    getStage() {
      return this.parent
    }
    setSize({ width: e, height: t }) {
      return this.canvas.setSize(e, t), this.hitCanvas.setSize(e, t), this._setSmoothEnabled(), this
    }
    _validateAdd(e) {
      'Group' !== (e = e.getType()) && 'Shape' !== e && Vg.throw('You may only add groups and shapes to a layer.')
    }
    _toKonvaCanvas(e) {
      return (
        ((e = e || {}).width = e.width || this.getWidth()),
        (e.height = e.height || this.getHeight()),
        (e.x = void 0 !== e.x ? e.x : this.x()),
        (e.y = void 0 !== e.y ? e.y : this.y()),
        wm.prototype._toKonvaCanvas.call(this, e)
      )
    }
    _checkVisibility() {
      var e = this.visible()
      this.canvas._canvas.style.display = e ? 'block' : 'none'
    }
    _setSmoothEnabled() {
      this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled()
    }
    getWidth() {
      if (this.parent) return this.parent.width()
    }
    setWidth() {
      Vg.warn('Can not change width of layer. Use "stage.width(value)" function instead.')
    }
    getHeight() {
      if (this.parent) return this.parent.height()
    }
    setHeight() {
      Vg.warn('Can not change height of layer. Use "stage.height(value)" function instead.')
    }
    batchDraw() {
      return (
        this._waitingForDraw ||
          ((this._waitingForDraw = !0),
          Vg.requestAnimFrame(() => {
            this.draw(), (this._waitingForDraw = !1)
          })),
        this
      )
    }
    getIntersection(e) {
      if (!this.isListening() || !this.isVisible()) return null
      for (var t = 1, n = !1; ; ) {
        for (let o = 0; o < qm; o++) {
          var r = Ym[o],
            i = (r = this._getIntersection({ x: e.x + r.x * t, y: e.y + r.y * t })).shape
          if (i) return i
          if (((n = !!r.antialiased), !r.antialiased)) break
        }
        if (!n) return null
        t += 1
      }
    }
    _getIntersection(e) {
      var t = this.hitCanvas.pixelRatio
      return 255 ===
        (t = (e = this.hitCanvas.context.getImageData(Math.round(e.x * t), Math.round(e.y * t), 1, 1).data)[3])
        ? ((e = Vg._rgbToHex(e[0], e[1], e[2])), (e = Um['#' + e]) ? { shape: e } : { antialiased: !0 })
        : 0 < t
        ? { antialiased: !0 }
        : {}
    }
    drawScene(e, t) {
      var n = this.getLayer()
      e = e || (n && n.getCanvas())
      return (
        this._fire('beforeDraw', { node: this }),
        this.clearBeforeDraw() && e.getContext().clear(),
        Cm.prototype.drawScene.call(this, e, t),
        this._fire('draw', { node: this }),
        this
      )
    }
    drawHit(e, t) {
      var n = this.getLayer()
      e = e || (n && n.hitCanvas)
      return (
        n && n.clearBeforeDraw() && n.getHitCanvas().getContext().clear(), Cm.prototype.drawHit.call(this, e, t), this
      )
    }
    enableHitGraph() {
      return this.hitGraphEnabled(!0), this
    }
    disableHitGraph() {
      return this.hitGraphEnabled(!1), this
    }
    setHitGraphEnabled(e) {
      Vg.warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.'), this.listening(e)
    }
    getHitGraphEnabled(e) {
      return Vg.warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.'), this.listening()
    }
    toggleHitCanvas() {
      var e
      this.parent &&
        this.parent.content &&
        ((e = this.parent),
        this.hitCanvas._canvas.parentNode
          ? e.content.removeChild(this.hitCanvas._canvas)
          : e.content.appendChild(this.hitCanvas._canvas))
    }
    destroy() {
      return Vg.releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas), super.destroy()
    }
  }
  ;($m.prototype.nodeType = 'Layer'),
    mg($m),
    Jg.addGetterSetter($m, 'imageSmoothingEnabled', !0),
    Jg.addGetterSetter($m, 'clearBeforeDraw', !0),
    Jg.addGetterSetter($m, 'hitGraphEnabled', !0, $g())
  class Km extends $m {
    constructor(e) {
      super(e),
        this.listening(!1),
        Vg.warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.')
    }
  }
  ;(Km.prototype.nodeType = 'FastLayer'), mg(Km)
  class Qm extends Cm {
    _validateAdd(e) {
      'Group' !== (e = e.getType()) && 'Shape' !== e && Vg.throw('You may only add groups and shapes to groups.')
    }
  }
  ;(Qm.prototype.nodeType = 'Group'), mg(Qm)
  var Jm =
    Mg.performance && Mg.performance.now
      ? function () {
          return Mg.performance.now()
        }
      : function () {
          return new Date().getTime()
        }
  class ev {
    constructor(e, t) {
      ;(this.id = ev.animIdCounter++),
        (this.frame = { time: 0, timeDiff: 0, lastTime: Jm(), frameRate: 0 }),
        (this.func = e),
        this.setLayers(t)
    }
    setLayers(e) {
      var t = e ? (0 < e.length ? e : [e]) : []
      return (this.layers = t), this
    }
    getLayers() {
      return this.layers
    }
    addLayer(e) {
      for (var t = this.layers, n = t.length, r = 0; r < n; r++) if (t[r]._id === e._id) return !1
      return this.layers.push(e), !0
    }
    isRunning() {
      for (var e = ev.animations, t = e.length, n = 0; n < t; n++) if (e[n].id === this.id) return !0
      return !1
    }
    start() {
      return this.stop(), (this.frame.timeDiff = 0), (this.frame.lastTime = Jm()), ev._addAnimation(this), this
    }
    stop() {
      return ev._removeAnimation(this), this
    }
    _updateFrameObject(e) {
      ;(this.frame.timeDiff = e - this.frame.lastTime),
        (this.frame.lastTime = e),
        (this.frame.time += this.frame.timeDiff),
        (this.frame.frameRate = 1e3 / this.frame.timeDiff)
    }
    static _addAnimation(e) {
      this.animations.push(e), this._handleAnimation()
    }
    static _removeAnimation(e) {
      for (var t = e.id, n = this.animations, r = n.length, i = 0; i < r; i++)
        if (n[i].id === t) {
          this.animations.splice(i, 1)
          break
        }
    }
    static _runFrames() {
      for (var e, t, n, r, i, o, a, l = {}, s = this.animations, c = 0; c < s.length; c++)
        if (
          ((t = (e = s[c]).layers),
          (n = e.func),
          e._updateFrameObject(Jm()),
          (i = t.length),
          !n || !1 !== n.call(e, e.frame))
        )
          for (r = 0; r < i; r++) void 0 !== (o = t[r])._id && (l[o._id] = o)
      for (a in l) l.hasOwnProperty(a) && l[a].batchDraw()
    }
    static _animationLoop() {
      var e = ev
      e.animations.length ? (e._runFrames(), Vg.requestAnimFrame(e._animationLoop)) : (e.animRunning = !1)
    }
    static _handleAnimation() {
      this.animRunning || ((this.animRunning = !0), Vg.requestAnimFrame(this._animationLoop))
    }
  }
  ;(ev.animations = []), (ev.animIdCounter = 0), (ev.animRunning = !1)
  var tv = { node: 1, duration: 1, easing: 1, onFinish: 1, yoyo: 1 },
    nv = 0,
    rv = ['fill', 'stroke', 'shadowColor']
  class iv {
    constructor(e, t, n, r, i, o, a) {
      ;(this.prop = e),
        (this.propFunc = t),
        (this.begin = r),
        (this._pos = r),
        (this.duration = o),
        (this._change = 0),
        (this.prevPos = 0),
        (this.yoyo = a),
        (this._time = 0),
        (this._position = 0),
        (this._startTime = 0),
        (this._finish = 0),
        (this.func = n),
        (this._change = i - this.begin),
        this.pause()
    }
    fire(e) {
      ;(e = this[e]) && e()
    }
    setTime(e) {
      e > this.duration
        ? this.yoyo
          ? ((this._time = this.duration), this.reverse())
          : this.finish()
        : e < 0
        ? this.yoyo
          ? ((this._time = 0), this.play())
          : this.reset()
        : ((this._time = e), this.update())
    }
    getTime() {
      return this._time
    }
    setPosition(e) {
      ;(this.prevPos = this._pos), this.propFunc(e), (this._pos = e)
    }
    getPosition(e) {
      return void 0 === e && (e = this._time), this.func(e, this.begin, this._change, this.duration)
    }
    play() {
      ;(this.state = 2), (this._startTime = this.getTimer() - this._time), this.onEnterFrame(), this.fire('onPlay')
    }
    reverse() {
      ;(this.state = 3),
        (this._time = this.duration - this._time),
        (this._startTime = this.getTimer() - this._time),
        this.onEnterFrame(),
        this.fire('onReverse')
    }
    seek(e) {
      this.pause(), (this._time = e), this.update(), this.fire('onSeek')
    }
    reset() {
      this.pause(), (this._time = 0), this.update(), this.fire('onReset')
    }
    finish() {
      this.pause(), (this._time = this.duration), this.update(), this.fire('onFinish')
    }
    update() {
      this.setPosition(this.getPosition(this._time)), this.fire('onUpdate')
    }
    onEnterFrame() {
      var e = this.getTimer() - this._startTime
      2 === this.state ? this.setTime(e) : 3 === this.state && this.setTime(this.duration - e)
    }
    pause() {
      ;(this.state = 1), this.fire('onPause')
    }
    getTimer() {
      return new Date().getTime()
    }
  }
  class ov {
    constructor(e) {
      var t,
        n = this,
        r = (l = e.node)._id,
        i = e.easing || av.Linear,
        o = !!e.yoyo,
        a = void 0 === e.duration ? 0.3 : 0 === e.duration ? 0.001 : e.duration,
        l = ((this.node = l), (this._id = nv++), l.getLayer() || (l instanceof jg.Stage ? l.getLayers() : null))
      for (t in (l ||
        Vg.error('Tween constructor have `node` that is not in a layer. Please add node into layer first.'),
      (this.anim = new ev(function () {
        n.tween.onEnterFrame()
      }, l)),
      (this.tween = new iv(
        t,
        function (e) {
          n._tweenFunc(e)
        },
        i,
        0,
        1,
        1e3 * a,
        o
      )),
      this._addListeners(),
      ov.attrs[r] || (ov.attrs[r] = {}),
      ov.attrs[r][this._id] || (ov.attrs[r][this._id] = {}),
      ov.tweens[r] || (ov.tweens[r] = {}),
      e))
        void 0 === tv[t] && this._addAttr(t, e[t])
      this.reset(), (this.onFinish = e.onFinish), (this.onReset = e.onReset), (this.onUpdate = e.onUpdate)
    }
    _addAttr(e, t) {
      var n,
        r,
        i,
        o,
        a,
        l,
        s,
        c,
        u = this.node,
        d = u._id,
        f = ov.tweens[d][e]
      if ((f && delete ov.attrs[d][f][e], (n = u.getAttr(e)), Vg._isArray(t)))
        if (
          ((r = []),
          (o = Math.max(t.length, n.length)),
          'points' === e &&
            t.length !== n.length &&
            (t.length > n.length
              ? ((l = n), (n = Vg._prepareArrayForTween(n, t, u.closed())))
              : ((a = t), (t = Vg._prepareArrayForTween(t, n, u.closed())))),
          0 === e.indexOf('fill'))
        )
          for (i = 0; i < o; i++)
            i % 2 == 0
              ? r.push(t[i] - n[i])
              : ((s = Vg.colorToRGBA(n[i])),
                (c = Vg.colorToRGBA(t[i])),
                (n[i] = s),
                r.push({ r: c.r - s.r, g: c.g - s.g, b: c.b - s.b, a: c.a - s.a }))
        else for (i = 0; i < o; i++) r.push(t[i] - n[i])
      else
        r =
          -1 !== rv.indexOf(e)
            ? ((n = Vg.colorToRGBA(n)),
              { r: (c = Vg.colorToRGBA(t)).r - n.r, g: c.g - n.g, b: c.b - n.b, a: c.a - n.a })
            : t - n
      ;(ov.attrs[d][this._id][e] = { start: n, diff: r, end: t, trueEnd: a, trueStart: l }),
        (ov.tweens[d][e] = this._id)
    }
    _tweenFunc(e) {
      var t,
        n,
        r,
        i,
        o,
        a,
        l,
        s = this.node,
        c = ov.attrs[s._id][this._id]
      for (t in c) {
        if (((n = (l = c[t]).start), (r = l.diff), (l = l.end), Vg._isArray(n)))
          if (((i = []), (a = Math.max(n.length, l.length)), 0 === t.indexOf('fill')))
            for (o = 0; o < a; o++)
              o % 2 == 0
                ? i.push((n[o] || 0) + r[o] * e)
                : i.push(
                    'rgba(' +
                      Math.round(n[o].r + r[o].r * e) +
                      ',' +
                      Math.round(n[o].g + r[o].g * e) +
                      ',' +
                      Math.round(n[o].b + r[o].b * e) +
                      ',' +
                      (n[o].a + r[o].a * e) +
                      ')'
                  )
          else for (o = 0; o < a; o++) i.push((n[o] || 0) + r[o] * e)
        else
          i =
            -1 !== rv.indexOf(t)
              ? 'rgba(' +
                Math.round(n.r + r.r * e) +
                ',' +
                Math.round(n.g + r.g * e) +
                ',' +
                Math.round(n.b + r.b * e) +
                ',' +
                (n.a + r.a * e) +
                ')'
              : n + r * e
        s.setAttr(t, i)
      }
    }
    _addListeners() {
      ;(this.tween.onPlay = () => {
        this.anim.start()
      }),
        (this.tween.onReverse = () => {
          this.anim.start()
        }),
        (this.tween.onPause = () => {
          this.anim.stop()
        }),
        (this.tween.onFinish = () => {
          var e = this.node,
            t = ov.attrs[e._id][this._id]
          t.points && t.points.trueEnd && e.setAttr('points', t.points.trueEnd),
            this.onFinish && this.onFinish.call(this)
        }),
        (this.tween.onReset = () => {
          var e = this.node,
            t = ov.attrs[e._id][this._id]
          t.points && t.points.trueStart && e.points(t.points.trueStart), this.onReset && this.onReset()
        }),
        (this.tween.onUpdate = () => {
          this.onUpdate && this.onUpdate.call(this)
        })
    }
    play() {
      return this.tween.play(), this
    }
    reverse() {
      return this.tween.reverse(), this
    }
    reset() {
      return this.tween.reset(), this
    }
    seek(e) {
      return this.tween.seek(1e3 * e), this
    }
    pause() {
      return this.tween.pause(), this
    }
    finish() {
      return this.tween.finish(), this
    }
    destroy() {
      var e,
        t = this.node._id,
        n = this._id,
        r = ov.tweens[t]
      for (e in (this.pause(), r)) delete ov.tweens[t][e]
      delete ov.attrs[t][n]
    }
  }
  ;(ov.attrs = {}),
    (ov.tweens = {}),
    (wm.prototype.to = function (e) {
      var t = e.onFinish
      ;(e.node = this),
        (e.onFinish = function () {
          this.destroy(), t && t()
        }),
        new ov(e).play()
    })
  const av = {
      BackEaseIn: (e, t, n, r) => n * (e /= r) * e * (2.70158 * e - 1.70158) + t,
      BackEaseOut: (e, t, n, r) => n * ((e = e / r - 1) * e * (2.70158 * e + 1.70158) + 1) + t,
      BackEaseInOut(e, t, n, r) {
        var i = 1.70158
        return (e /= r / 2) < 1
          ? (n / 2) * (e * e * ((1 + (i *= 1.525)) * e - i)) + t
          : (n / 2) * ((e -= 2) * e * ((1 + (i *= 1.525)) * e + i) + 2) + t
      },
      ElasticEaseIn(e, t, n, r, i, o) {
        var a = 0
        return 0 === e
          ? t
          : 1 == (e /= r)
          ? t + n
          : ((o = o || 0.3 * r),
            (a = !i || i < Math.abs(n) ? ((i = n), o / 4) : (o / (2 * Math.PI)) * Math.asin(n / i)),
            -i * Math.pow(2, 10 * --e) * Math.sin(((e * r - a) * (2 * Math.PI)) / o) + t)
      },
      ElasticEaseOut(e, t, n, r, i, o) {
        var a = 0
        return 0 === e
          ? t
          : 1 == (e /= r)
          ? t + n
          : ((o = o || 0.3 * r),
            (a = !i || i < Math.abs(n) ? ((i = n), o / 4) : (o / (2 * Math.PI)) * Math.asin(n / i)),
            i * Math.pow(2, -10 * e) * Math.sin(((e * r - a) * (2 * Math.PI)) / o) + n + t)
      },
      ElasticEaseInOut(e, t, n, r, i, o) {
        var a = 0
        return 0 === e
          ? t
          : 2 == (e /= r / 2)
          ? t + n
          : ((o = o || r * (0.3 * 1.5)),
            (a = !i || i < Math.abs(n) ? ((i = n), o / 4) : (o / (2 * Math.PI)) * Math.asin(n / i)),
            e < 1
              ? i * Math.pow(2, 10 * --e) * Math.sin(((e * r - a) * (2 * Math.PI)) / o) * -0.5 + t
              : i * Math.pow(2, -10 * --e) * Math.sin(((e * r - a) * (2 * Math.PI)) / o) * 0.5 + n + t)
      },
      BounceEaseOut: (e, t, n, r) =>
        (e /= r) < 1 / 2.75
          ? n * (7.5625 * e * e) + t
          : e < 2 / 2.75
          ? n * (7.5625 * (e -= 1.5 / 2.75) * e + 0.75) + t
          : e < 2.5 / 2.75
          ? n * (7.5625 * (e -= 2.25 / 2.75) * e + 0.9375) + t
          : n * (7.5625 * (e -= 2.625 / 2.75) * e + 0.984375) + t,
      BounceEaseIn: (e, t, n, r) => n - av.BounceEaseOut(r - e, 0, n, r) + t,
      BounceEaseInOut: (e, t, n, r) =>
        e < r / 2
          ? 0.5 * av.BounceEaseIn(2 * e, 0, n, r) + t
          : 0.5 * av.BounceEaseOut(2 * e - r, 0, n, r) + 0.5 * n + t,
      EaseIn: (e, t, n, r) => n * (e /= r) * e + t,
      EaseOut: (e, t, n, r) => -n * (e /= r) * (e - 2) + t,
      EaseInOut: (e, t, n, r) => ((e /= r / 2) < 1 ? (n / 2) * e * e + t : (-n / 2) * (--e * (e - 2) - 1) + t),
      StrongEaseIn: (e, t, n, r) => n * (e /= r) * e * e * e * e + t,
      StrongEaseOut: (e, t, n, r) => n * ((e = e / r - 1) * e * e * e * e + 1) + t,
      StrongEaseInOut: (e, t, n, r) =>
        (e /= r / 2) < 1 ? (n / 2) * e * e * e * e * e + t : (n / 2) * ((e -= 2) * e * e * e * e + 2) + t,
      Linear: (e, t, n, r) => (n * e) / r + t
    },
    lv = Vg._assign(jg, {
      Util: Vg,
      Transform: Rg,
      Node: wm,
      Container: Cm,
      Stage: Nm,
      stages: zm,
      Layer: $m,
      FastLayer: Km,
      Group: Qm,
      DD: sm,
      Shape: Xm,
      shapes: Um,
      Animation: ev,
      Tween: ov,
      Easings: av,
      Context: nm,
      Canvas: om
    })
  class sv extends Xm {
    _sceneFunc(e) {
      var t = jg.getAngle(this.angle()),
        n = this.clockwise()
      e.beginPath(),
        e.arc(0, 0, this.outerRadius(), 0, t, n),
        e.arc(0, 0, this.innerRadius(), t, 0, !n),
        e.closePath(),
        e.fillStrokeShape(this)
    }
    getWidth() {
      return 2 * this.outerRadius()
    }
    getHeight() {
      return 2 * this.outerRadius()
    }
    setWidth(e) {
      this.outerRadius(e / 2)
    }
    setHeight(e) {
      this.outerRadius(e / 2)
    }
    getSelfRect() {
      var e = this.innerRadius(),
        t = this.outerRadius(),
        n = this.clockwise(),
        r = jg.getAngle(n ? 360 - this.angle() : this.angle()),
        i = Math.cos(Math.min(r, Math.PI)),
        o = (o = Math.sin(Math.min(Math.max(Math.PI, r), (3 * Math.PI) / 2))) * (0 < o ? e : t)
      r = (r = Math.sin(Math.min(r, Math.PI / 2))) * (0 < r ? t : e)
      return { x: (i = i * (0 < i ? e : t)), y: n ? -1 * r : o, width: +t - i, height: r - o }
    }
  }
  function cv(e, t, n, r, i, o, a) {
    var l = Math.sqrt(Math.pow(n - e, 2) + Math.pow(r - t, 2)),
      s = Math.sqrt(Math.pow(i - n, 2) + Math.pow(o - r, 2)),
      c = (a * l) / (l + s)
    return [n - c * (i - e), r - c * (o - t), n + (a = (a * s) / (l + s)) * (i - e), r + a * (o - t)]
  }
  function uv(e, t) {
    for (var n, r = e.length, i = [], o = 2; o < r - 2; o += 2)
      (n = cv(e[o - 2], e[o - 1], e[o], e[o + 1], e[o + 2], e[o + 3], t)),
        isNaN(n[0]) || (i.push(n[0]), i.push(n[1]), i.push(e[o]), i.push(e[o + 1]), i.push(n[2]), i.push(n[3]))
    return i
  }
  ;(sv.prototype._centroid = !0),
    (sv.prototype.className = 'Arc'),
    (sv.prototype._attrsAffectingSize = ['innerRadius', 'outerRadius']),
    mg(sv),
    Jg.addGetterSetter(sv, 'innerRadius', 0, Zg()),
    Jg.addGetterSetter(sv, 'outerRadius', 0, Zg()),
    Jg.addGetterSetter(sv, 'angle', 0, Zg()),
    Jg.addGetterSetter(sv, 'clockwise', !1, $g())
  class dv extends Xm {
    constructor(e) {
      super(e),
        this.on('pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva', function () {
          this._clearCache('tensionPoints')
        })
    }
    _sceneFunc(e) {
      var t,
        n,
        r,
        i = this.points(),
        o = i.length,
        a = this.tension(),
        l = this.closed(),
        s = this.bezier()
      if (o) {
        if ((e.beginPath(), e.moveTo(i[0], i[1]), 0 !== a && 4 < o)) {
          for (
            n = (t = this.getTensionPoints()).length, r = l ? 0 : 4, l || e.quadraticCurveTo(t[0], t[1], t[2], t[3]);
            r < n - 2;

          )
            e.bezierCurveTo(t[r++], t[r++], t[r++], t[r++], t[r++], t[r++])
          l || e.quadraticCurveTo(t[n - 2], t[n - 1], i[o - 2], i[o - 1])
        } else if (s) for (r = 2; r < o; ) e.bezierCurveTo(i[r++], i[r++], i[r++], i[r++], i[r++], i[r++])
        else for (r = 2; r < o; r += 2) e.lineTo(i[r], i[r + 1])
        l ? (e.closePath(), e.fillStrokeShape(this)) : e.strokeShape(this)
      }
    }
    getTensionPoints() {
      return this._getCache('tensionPoints', this._getTensionPoints)
    }
    _getTensionPoints() {
      return this.closed() ? this._getTensionPointsClosed() : uv(this.points(), this.tension())
    }
    _getTensionPointsClosed() {
      var e = this.points(),
        t = e.length,
        n = this.tension(),
        r = cv(e[t - 2], e[t - 1], e[0], e[1], e[2], e[3], n),
        i = cv(e[t - 4], e[t - 3], e[t - 2], e[t - 1], e[0], e[1], n)
      n = uv(e, n)
      return [r[2], r[3]].concat(n).concat([i[0], i[1], e[t - 2], e[t - 1], i[2], i[3], r[0], r[1], e[0], e[1]])
    }
    getWidth() {
      return this.getSelfRect().width
    }
    getHeight() {
      return this.getSelfRect().height
    }
    getSelfRect() {
      var e = this.points()
      if (e.length < 4) return { x: e[0] || 0, y: e[1] || 0, width: 0, height: 0 }
      for (
        var t,
          n,
          r = (e =
            0 !== this.tension()
              ? [e[0], e[1], ...this._getTensionPoints(), e[e.length - 2], e[e.length - 1]]
              : this.points())[0],
          i = e[0],
          o = e[1],
          a = e[1],
          l = 0;
        l < e.length / 2;
        l++
      )
        (t = e[2 * l]),
          (n = e[2 * l + 1]),
          (r = Math.min(r, t)),
          (i = Math.max(i, t)),
          (o = Math.min(o, n)),
          (a = Math.max(a, n))
      return { x: r, y: o, width: i - r, height: a - o }
    }
  }
  ;(dv.prototype.className = 'Line'),
    (dv.prototype._attrsAffectingSize = ['points', 'bezier', 'tension']),
    mg(dv),
    Jg.addGetterSetter(dv, 'closed', !1),
    Jg.addGetterSetter(dv, 'bezier', !1),
    Jg.addGetterSetter(dv, 'tension', 0, Zg()),
    Jg.addGetterSetter(
      dv,
      'points',
      [],
      (function () {
        if (jg.isUnminified)
          return function (e, t) {
            var n = Int8Array ? Object.getPrototypeOf(Int8Array) : null
            return (
              (n && e instanceof n) ||
                (Vg._isArray(e)
                  ? e.forEach(function (e) {
                      Vg._isNumber(e) ||
                        Vg.warn(
                          '"' +
                            t +
                            '" attribute has non numeric element ' +
                            e +
                            '. Make sure that all elements are numbers.'
                        )
                    })
                  : Vg.warn(
                      Wg(e) + ' is a not valid value for "' + t + '" attribute. The value should be a array of numbers.'
                    )),
              e
            )
          }
      })()
    )
  class fv extends Xm {
    constructor(e) {
      super(e), (this.dataArray = []), (this.pathLength = 0), (this.dataArray = fv.parsePathData(this.data()))
      for (var t = (this.pathLength = 0); t < this.dataArray.length; ++t)
        this.pathLength += this.dataArray[t].pathLength
      this.on('dataChange.konva', function () {
        this.dataArray = fv.parsePathData(this.data())
        for (var e = (this.pathLength = 0); e < this.dataArray.length; ++e)
          this.pathLength += this.dataArray[e].pathLength
      })
    }
    _sceneFunc(e) {
      for (var t = this.dataArray, n = (e.beginPath(), !1), r = 0; r < t.length; r++) {
        var i = t[r].command,
          o = t[r].points
        switch (i) {
          case 'L':
            e.lineTo(o[0], o[1])
            break
          case 'M':
            e.moveTo(o[0], o[1])
            break
          case 'C':
            e.bezierCurveTo(o[0], o[1], o[2], o[3], o[4], o[5])
            break
          case 'Q':
            e.quadraticCurveTo(o[0], o[1], o[2], o[3])
            break
          case 'A':
            var a = o[0],
              l = o[1],
              s = o[2],
              c = o[3],
              u = o[4],
              d = o[5],
              f = o[6],
              h = o[7],
              p = c < s ? s : c,
              g = c < s ? 1 : s / c
            c = c < s ? c / s : 1
            e.translate(a, l),
              e.rotate(f),
              e.scale(g, c),
              e.arc(0, 0, p, u, u + d, 1 - h),
              e.scale(1 / g, 1 / c),
              e.rotate(-f),
              e.translate(-a, -l)
            break
          case 'z':
            ;(n = !0), e.closePath()
        }
      }
      n || this.hasFill() ? e.fillStrokeShape(this) : e.strokeShape(this)
    }
    getSelfRect() {
      for (
        var e,
          t,
          n = [],
          r =
            (this.dataArray.forEach(function (e) {
              if ('A' === e.command) {
                var t = e.points[4],
                  r = e.points[5],
                  i = e.points[4] + r,
                  o = Math.PI / 180
                if ((Math.abs(t - i) < o && (o = Math.abs(t - i)), r < 0))
                  for (let r = t - o; r > i; r -= o) {
                    var a = fv.getPointOnEllipticalArc(e.points[0], e.points[1], e.points[2], e.points[3], r, 0)
                    n.push(a.x, a.y)
                  }
                else
                  for (let r = t + o; r < i; r += o) {
                    var l = fv.getPointOnEllipticalArc(e.points[0], e.points[1], e.points[2], e.points[3], r, 0)
                    n.push(l.x, l.y)
                  }
              } else if ('C' === e.command)
                for (let c = 0; c <= 1; c += 0.01) {
                  var s = fv.getPointOnCubicBezier(
                    c,
                    e.start.x,
                    e.start.y,
                    e.points[0],
                    e.points[1],
                    e.points[2],
                    e.points[3],
                    e.points[4],
                    e.points[5]
                  )
                  n.push(s.x, s.y)
                }
              else n = n.concat(e.points)
            }),
            n[0]),
          i = n[0],
          o = n[1],
          a = n[1],
          l = 0;
        l < n.length / 2;
        l++
      )
        (e = n[2 * l]),
          (t = n[2 * l + 1]),
          isNaN(e) || ((r = Math.min(r, e)), (i = Math.max(i, e))),
          isNaN(t) || ((o = Math.min(o, t)), (a = Math.max(a, t)))
      return { x: r, y: o, width: i - r, height: a - o }
    }
    getLength() {
      return this.pathLength
    }
    getPointAtLength(e) {
      var t,
        n = 0,
        r = this.dataArray.length
      if (r) {
        for (; n < r && e > this.dataArray[n].pathLength; ) (e -= this.dataArray[n].pathLength), ++n
        if (n === r) return { x: (t = this.dataArray[n - 1].points.slice(-2))[0], y: t[1] }
        if (e < 0.01) return { x: (t = this.dataArray[n].points.slice(0, 2))[0], y: t[1] }
        var i = this.dataArray[n],
          o = i.points
        switch (i.command) {
          case 'L':
            return fv.getPointOnLine(e, i.start.x, i.start.y, o[0], o[1])
          case 'C':
            return fv.getPointOnCubicBezier(e / i.pathLength, i.start.x, i.start.y, o[0], o[1], o[2], o[3], o[4], o[5])
          case 'Q':
            return fv.getPointOnQuadraticBezier(e / i.pathLength, i.start.x, i.start.y, o[0], o[1], o[2], o[3])
          case 'A':
            var a = o[0],
              l = o[1],
              s = o[2],
              c = o[3],
              u = o[4],
              d = o[5],
              f = o[6]
            return (u += (d * e) / i.pathLength), fv.getPointOnEllipticalArc(a, l, s, c, u, f)
        }
      }
      return null
    }
    static getLineLength(e, t, n, r) {
      return Math.sqrt((n - e) * (n - e) + (r - t) * (r - t))
    }
    static getPointOnLine(e, t, n, r, i, o, a) {
      void 0 === o && (o = t), void 0 === a && (a = n)
      var l,
        s = (i - n) / (r - t + 1e-8),
        c = Math.sqrt((e * e) / (1 + s * s)),
        u = (r < t && (c *= -1), s * c)
      return (i =
        r === t
          ? { x: o, y: a + u }
          : (a - n) / (o - t + 1e-8) == s
          ? { x: o + c, y: a + u }
          : ((u = this.getLineLength(t, n, r, i)),
            (l = (o - t) * (r - t) + (a - n) * (i - n)),
            (u = this.getLineLength(o, a, (o = t + (l /= u * u) * (r - t)), (a = n + l * (i - n)))),
            (l = Math.sqrt(e * e - u * u)),
            (c = Math.sqrt((l * l) / (1 + s * s))),
            r < t && (c *= -1),
            { x: o + c, y: a + s * c }))
    }
    static getPointOnCubicBezier(e, t, n, r, i, o, a, l, s) {
      function c(e) {
        return e * e * e
      }
      function u(e) {
        return 3 * e * e * (1 - e)
      }
      function d(e) {
        return 3 * e * (1 - e) * (1 - e)
      }
      function f(e) {
        return (1 - e) * (1 - e) * (1 - e)
      }
      return { x: l * c(e) + o * u(e) + r * d(e) + t * f(e), y: s * c(e) + a * u(e) + i * d(e) + n * f(e) }
    }
    static getPointOnQuadraticBezier(e, t, n, r, i, o, a) {
      function l(e) {
        return e * e
      }
      function s(e) {
        return 2 * e * (1 - e)
      }
      function c(e) {
        return (1 - e) * (1 - e)
      }
      return { x: o * l(e) + r * s(e) + t * c(e), y: a * l(e) + i * s(e) + n * c(e) }
    }
    static getPointOnEllipticalArc(e, t, n, r, i, o) {
      var a = Math.cos(o)
      o = Math.sin(o)
      return { x: e + ((n = n * Math.cos(i)) * a - (r = r * Math.sin(i)) * o), y: t + (n * o + r * a) }
    }
    static parsePathData(e) {
      if (!e) return []
      for (
        var t = ['m', 'M', 'l', 'L', 'v', 'V', 'h', 'H', 'z', 'Z', 'c', 'C', 'q', 'Q', 't', 'T', 's', 'S', 'a', 'A'],
          n = (n = e).replace(new RegExp(' ', 'g'), ','),
          r = 0;
        r < t.length;
        r++
      )
        n = n.replace(new RegExp(t[r], 'g'), '|' + t[r])
      var i,
        o = n.split('|'),
        a = [],
        l = [],
        s = 0,
        c = 0,
        u = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi
      for (r = 1; r < o.length; r++) {
        var d = (f = o[r]).charAt(0),
          f = f.slice(1)
        for (l.length = 0; (i = u.exec(f)); ) l.push(i[0])
        for (var h, p = [], g = 0, m = l.length; g < m; g++)
          '00' === l[g] ? p.push(0, 0) : ((h = parseFloat(l[g])), isNaN(h) ? p.push(0) : p.push(h))
        for (; 0 < p.length && !isNaN(p[0]); ) {
          var v,
            y,
            b,
            w,
            C,
            x,
            E,
            S,
            O,
            k,
            P = null,
            _ = [],
            L = s,
            T = c
          switch (d) {
            case 'l':
              ;(s += p.shift()), (c += p.shift()), (P = 'L'), _.push(s, c)
              break
            case 'L':
              ;(s = p.shift()), (c = p.shift()), _.push(s, c)
              break
            case 'm':
              var I = p.shift(),
                M = p.shift()
              if (((s += I), (c += M), (P = 'M'), 2 < a.length && 'z' === a[a.length - 1].command))
                for (var j = a.length - 2; 0 <= j; j--)
                  if ('M' === a[j].command) {
                    ;(s = a[j].points[0] + I), (c = a[j].points[1] + M)
                    break
                  }
              _.push(s, c), (d = 'l')
              break
            case 'M':
              ;(s = p.shift()), (c = p.shift()), (P = 'M'), _.push(s, c), (d = 'L')
              break
            case 'h':
              ;(s += p.shift()), (P = 'L'), _.push(s, c)
              break
            case 'H':
              ;(s = p.shift()), (P = 'L'), _.push(s, c)
              break
            case 'v':
              ;(c += p.shift()), (P = 'L'), _.push(s, c)
              break
            case 'V':
              ;(c = p.shift()), (P = 'L'), _.push(s, c)
              break
            case 'C':
              _.push(p.shift(), p.shift(), p.shift(), p.shift()), (s = p.shift()), (c = p.shift()), _.push(s, c)
              break
            case 'c':
              _.push(s + p.shift(), c + p.shift(), s + p.shift(), c + p.shift()),
                (s += p.shift()),
                (c += p.shift()),
                (P = 'C'),
                _.push(s, c)
              break
            case 'S':
              ;(y = s),
                (b = c),
                'C' === (v = a[a.length - 1]).command && ((y = s + (s - v.points[2])), (b = c + (c - v.points[3]))),
                _.push(y, b, p.shift(), p.shift()),
                (s = p.shift()),
                (c = p.shift()),
                (P = 'C'),
                _.push(s, c)
              break
            case 's':
              ;(y = s),
                (b = c),
                'C' === (v = a[a.length - 1]).command && ((y = s + (s - v.points[2])), (b = c + (c - v.points[3]))),
                _.push(y, b, s + p.shift(), c + p.shift()),
                (s += p.shift()),
                (c += p.shift()),
                (P = 'C'),
                _.push(s, c)
              break
            case 'Q':
              _.push(p.shift(), p.shift()), (s = p.shift()), (c = p.shift()), _.push(s, c)
              break
            case 'q':
              _.push(s + p.shift(), c + p.shift()), (s += p.shift()), (c += p.shift()), (P = 'Q'), _.push(s, c)
              break
            case 'T':
              ;(y = s),
                (b = c),
                'Q' === (v = a[a.length - 1]).command && ((y = s + (s - v.points[0])), (b = c + (c - v.points[1]))),
                (s = p.shift()),
                (c = p.shift()),
                (P = 'Q'),
                _.push(y, b, s, c)
              break
            case 't':
              ;(y = s),
                (b = c),
                'Q' === (v = a[a.length - 1]).command && ((y = s + (s - v.points[0])), (b = c + (c - v.points[1]))),
                (s += p.shift()),
                (c += p.shift()),
                (P = 'Q'),
                _.push(y, b, s, c)
              break
            case 'A':
              ;(w = p.shift()),
                (C = p.shift()),
                (x = p.shift()),
                (E = p.shift()),
                (S = p.shift()),
                (O = s),
                (k = c),
                (s = p.shift()),
                (c = p.shift()),
                (P = 'A'),
                (_ = this.convertEndpointToCenterParameterization(O, k, s, c, E, S, w, C, x))
              break
            case 'a':
              ;(w = p.shift()),
                (C = p.shift()),
                (x = p.shift()),
                (E = p.shift()),
                (S = p.shift()),
                (O = s),
                (k = c),
                (s += p.shift()),
                (c += p.shift()),
                (P = 'A'),
                (_ = this.convertEndpointToCenterParameterization(O, k, s, c, E, S, w, C, x))
          }
          a.push({ command: P || d, points: _, start: { x: L, y: T }, pathLength: this.calcLength(L, T, P || d, _) })
        }
        ;('z' !== d && 'Z' !== d) || a.push({ command: 'z', points: [], start: void 0, pathLength: 0 })
      }
      return a
    }
    static calcLength(e, t, n, r) {
      var i,
        o,
        a,
        l = fv
      switch (n) {
        case 'L':
          return l.getLineLength(e, t, r[0], r[1])
        case 'C':
          for (
            i = l.getPointOnCubicBezier((s = 0), e, t, r[0], r[1], r[2], r[3], r[4], r[5]), a = 0.01;
            a <= 1;
            a += 0.01
          )
            (o = l.getPointOnCubicBezier(a, e, t, r[0], r[1], r[2], r[3], r[4], r[5])),
              (s += l.getLineLength(i.x, i.y, o.x, o.y)),
              (i = o)
          return s
        case 'Q':
          for (i = l.getPointOnQuadraticBezier((s = 0), e, t, r[0], r[1], r[2], r[3]), a = 0.01; a <= 1; a += 0.01)
            (o = l.getPointOnQuadraticBezier(a, e, t, r[0], r[1], r[2], r[3])),
              (s += l.getLineLength(i.x, i.y, o.x, o.y)),
              (i = o)
          return s
        case 'A':
          var s = 0,
            c = r[4],
            u = r[5],
            d = r[4] + u,
            f = Math.PI / 180
          if (
            (Math.abs(c - d) < f && (f = Math.abs(c - d)),
            (i = l.getPointOnEllipticalArc(r[0], r[1], r[2], r[3], c, 0)),
            u < 0)
          )
            for (a = c - f; d < a; a -= f)
              (o = l.getPointOnEllipticalArc(r[0], r[1], r[2], r[3], a, 0)),
                (s += l.getLineLength(i.x, i.y, o.x, o.y)),
                (i = o)
          else
            for (a = c + f; a < d; a += f)
              (o = l.getPointOnEllipticalArc(r[0], r[1], r[2], r[3], a, 0)),
                (s += l.getLineLength(i.x, i.y, o.x, o.y)),
                (i = o)
          return (o = l.getPointOnEllipticalArc(r[0], r[1], r[2], r[3], d, 0)), s + l.getLineLength(i.x, i.y, o.x, o.y)
      }
      return 0
    }
    static convertEndpointToCenterParameterization(e, t, n, r, i, o, a, l, s) {
      function c(e, t) {
        return (e[0] * t[0] + e[1] * t[1]) / (p(e) * p(t))
      }
      function u(e, t) {
        return (e[0] * t[1] < e[1] * t[0] ? -1 : 1) * Math.acos(c(e, t))
      }
      s *= Math.PI / 180
      var d = (Math.cos(s) * (e - n)) / 2 + (Math.sin(s) * (t - r)) / 2,
        f = (-1 * Math.sin(s) * (e - n)) / 2 + (Math.cos(s) * (t - r)) / 2,
        h =
          (1 < (h = (d * d) / (a * a) + (f * f) / (l * l)) && ((a *= Math.sqrt(h)), (l *= Math.sqrt(h))),
          Math.sqrt((a * a * (l * l) - a * a * (f * f) - l * l * (d * d)) / (a * a * (f * f) + l * l * (d * d)))),
        p =
          ((i = (i === o && (h *= -1), ((h = isNaN(h) ? 0 : h) * a * f) / l)),
          (h = (h * -l * d) / a),
          (e = (e + n) / 2 + Math.cos(s) * i - Math.sin(s) * h),
          (n = (t + r) / 2 + Math.sin(s) * i + Math.cos(s) * h),
          function (e) {
            return Math.sqrt(e[0] * e[0] + e[1] * e[1])
          })
      ;(t = u([1, 0], [(d - i) / a, (f - h) / l])),
        (i = u((r = [(d - i) / a, (f - h) / l]), (d = [(-1 * d - i) / a, (-1 * f - h) / l])))
      return (
        c(r, d) <= -1 && (i = Math.PI),
        1 <= c(r, d) && (i = 0),
        0 === o && 0 < i && (i -= 2 * Math.PI),
        1 === o && i < 0 && (i += 2 * Math.PI),
        [e, n, a, l, t, i, s, o]
      )
    }
  }
  ;(fv.prototype.className = 'Path'),
    (fv.prototype._attrsAffectingSize = ['data']),
    mg(fv),
    Jg.addGetterSetter(fv, 'data')
  class hv extends dv {
    _sceneFunc(e) {
      super._sceneFunc(e)
      var t,
        n,
        r = 2 * Math.PI,
        i = this.points(),
        o = i,
        a = 0 !== this.tension() && 4 < i.length,
        l = (a && (o = this.getTensionPoints()), this.pointerLength()),
        s = i.length,
        c =
          ((n = a
            ? ((t = [o[o.length - 4], o[o.length - 3], o[o.length - 2], o[o.length - 1], i[s - 2], i[s - 1]]),
              (n = fv.calcLength(o[o.length - 4], o[o.length - 3], 'C', t)),
              (n = fv.getPointOnQuadraticBezier(Math.min(1, 1 - l / n), t[0], t[1], t[2], t[3], t[4], t[5])),
              (t = i[s - 2] - n.x),
              i[s - 1] - n.y)
            : ((t = i[s - 2] - i[s - 4]), i[s - 1] - i[s - 3])),
          (Math.atan2(n, t) + r) % r),
        u = this.pointerWidth()
      this.pointerAtEnding() &&
        (e.save(),
        e.beginPath(),
        e.translate(i[s - 2], i[s - 1]),
        e.rotate(c),
        e.moveTo(0, 0),
        e.lineTo(-l, u / 2),
        e.lineTo(-l, -u / 2),
        e.closePath(),
        e.restore(),
        this.__fillStroke(e)),
        this.pointerAtBeginning() &&
          (e.save(),
          e.beginPath(),
          e.translate(i[0], i[1]),
          (n = a ? ((t = (o[0] + o[2]) / 2 - i[0]), (o[1] + o[3]) / 2 - i[1]) : ((t = i[2] - i[0]), i[3] - i[1])),
          e.rotate((Math.atan2(-n, -t) + r) % r),
          e.moveTo(0, 0),
          e.lineTo(-l, u / 2),
          e.lineTo(-l, -u / 2),
          e.closePath(),
          e.restore(),
          this.__fillStroke(e))
    }
    __fillStroke(e) {
      var t = this.dashEnabled()
      t && ((this.attrs.dashEnabled = !1), e.setLineDash([])),
        e.fillStrokeShape(this),
        t && (this.attrs.dashEnabled = !0)
    }
    getSelfRect() {
      var e = super.getSelfRect(),
        t = this.pointerWidth() / 2
      return { x: e.x - t, y: e.y - t, width: e.width + 2 * t, height: e.height + 2 * t }
    }
  }
  ;(hv.prototype.className = 'Arrow'),
    mg(hv),
    Jg.addGetterSetter(hv, 'pointerLength', 10, Zg()),
    Jg.addGetterSetter(hv, 'pointerWidth', 10, Zg()),
    Jg.addGetterSetter(hv, 'pointerAtBeginning', !1),
    Jg.addGetterSetter(hv, 'pointerAtEnding', !0)
  class pv extends Xm {
    _sceneFunc(e) {
      e.beginPath(), e.arc(0, 0, this.attrs.radius || 0, 0, 2 * Math.PI, !1), e.closePath(), e.fillStrokeShape(this)
    }
    getWidth() {
      return 2 * this.radius()
    }
    getHeight() {
      return 2 * this.radius()
    }
    setWidth(e) {
      this.radius() !== e / 2 && this.radius(e / 2)
    }
    setHeight(e) {
      this.radius() !== e / 2 && this.radius(e / 2)
    }
  }
  ;(pv.prototype._centroid = !0),
    (pv.prototype.className = 'Circle'),
    (pv.prototype._attrsAffectingSize = ['radius']),
    mg(pv),
    Jg.addGetterSetter(pv, 'radius', 0, Zg())
  class gv extends Xm {
    _sceneFunc(e) {
      var t = this.radiusX(),
        n = this.radiusY()
      e.beginPath(),
        e.save(),
        t !== n && e.scale(1, n / t),
        e.arc(0, 0, t, 0, 2 * Math.PI, !1),
        e.restore(),
        e.closePath(),
        e.fillStrokeShape(this)
    }
    getWidth() {
      return 2 * this.radiusX()
    }
    getHeight() {
      return 2 * this.radiusY()
    }
    setWidth(e) {
      this.radiusX(e / 2)
    }
    setHeight(e) {
      this.radiusY(e / 2)
    }
  }
  ;(gv.prototype.className = 'Ellipse'),
    (gv.prototype._centroid = !0),
    (gv.prototype._attrsAffectingSize = ['radiusX', 'radiusY']),
    mg(gv),
    Jg.addComponentsGetterSetter(gv, 'radius', ['x', 'y']),
    Jg.addGetterSetter(gv, 'radiusX', 0, Zg()),
    Jg.addGetterSetter(gv, 'radiusY', 0, Zg())
  class mv extends Xm {
    constructor(e) {
      super(e),
        this.on('imageChange.konva', () => {
          this._setImageLoad()
        }),
        this._setImageLoad()
    }
    _setImageLoad() {
      var e = this.image()
      ;(e && e.complete) ||
        (e && 4 === e.readyState) ||
        (e &&
          e.addEventListener &&
          e.addEventListener('load', () => {
            this._requestDraw()
          }))
    }
    _useBufferCanvas() {
      return super._useBufferCanvas(!0)
    }
    _sceneFunc(e) {
      var t,
        n,
        r = this.getWidth(),
        i = this.getHeight(),
        o = this.cornerRadius(),
        a = this.attrs.image
      let l
      a &&
        ((t = this.attrs.cropWidth),
        (n = this.attrs.cropHeight),
        (l = t && n ? [a, this.cropX(), this.cropY(), t, n, 0, 0, r, i] : [a, 0, 0, r, i])),
        (this.hasFill() || this.hasStroke() || o) &&
          (e.beginPath(),
          o ? Vg.drawRoundedRectPath(e, r, i, o) : e.rect(0, 0, r, i),
          e.closePath(),
          e.fillStrokeShape(this)),
        a && (o && e.clip(), e.drawImage.apply(e, l))
    }
    _hitFunc(e) {
      var t = this.width(),
        n = this.height(),
        r = this.cornerRadius()
      e.beginPath(), r ? Vg.drawRoundedRectPath(e, t, n, r) : e.rect(0, 0, t, n), e.closePath(), e.fillStrokeShape(this)
    }
    getWidth() {
      var e
      return null != (e = this.attrs.width) ? e : null == (e = this.image()) ? void 0 : e.width
    }
    getHeight() {
      var e
      return null != (e = this.attrs.height) ? e : null == (e = this.image()) ? void 0 : e.height
    }
    static fromURL(e, t, n = null) {
      var r = Vg.createImageElement()
      ;(r.onload = function () {
        var e = new mv({ image: r })
        t(e)
      }),
        (r.onerror = n),
        (r.crossOrigin = 'Anonymous'),
        (r.src = e)
    }
  }
  ;(mv.prototype.className = 'Image'),
    mg(mv),
    Jg.addGetterSetter(mv, 'cornerRadius', 0, Ug(4)),
    Jg.addGetterSetter(mv, 'image'),
    Jg.addComponentsGetterSetter(mv, 'crop', ['x', 'y', 'width', 'height']),
    Jg.addGetterSetter(mv, 'cropX', 0, Zg()),
    Jg.addGetterSetter(mv, 'cropY', 0, Zg()),
    Jg.addGetterSetter(mv, 'cropWidth', 0, Zg()),
    Jg.addGetterSetter(mv, 'cropHeight', 0, Zg())
  var vv = [
      'fontFamily',
      'fontSize',
      'fontStyle',
      'padding',
      'lineHeight',
      'text',
      'width',
      'height',
      'pointerDirection',
      'pointerWidth',
      'pointerHeight'
    ],
    yv = 'right',
    bv = 'down',
    wv = 'left',
    Cv = vv.length
  class xv extends Qm {
    constructor(e) {
      super(e),
        this.on('add.konva', function (e) {
          this._addListeners(e.child), this._sync()
        })
    }
    getText() {
      return this.find('Text')[0]
    }
    getTag() {
      return this.find('Tag')[0]
    }
    _addListeners(e) {
      for (
        var t = this,
          n = function () {
            t._sync()
          },
          r = 0;
        r < Cv;
        r++
      )
        e.on(vv[r] + 'Change.konva', n)
    }
    getWidth() {
      return this.getText().width()
    }
    getHeight() {
      return this.getText().height()
    }
    _sync() {
      var e,
        t,
        n,
        r,
        i,
        o,
        a,
        l = this.getText(),
        s = this.getTag()
      if (l && s) {
        switch (
          ((e = l.width()),
          (t = l.height()),
          (n = s.pointerDirection()),
          (r = s.pointerWidth()),
          (a = s.pointerHeight()),
          (o = i = 0),
          n)
        ) {
          case 'up':
            ;(i = e / 2), (o = -1 * a)
            break
          case yv:
            ;(i = e + r), (o = t / 2)
            break
          case bv:
            ;(i = e / 2), (o = t + a)
            break
          case wv:
            ;(i = -1 * r), (o = t / 2)
        }
        s.setAttrs({ x: -1 * i, y: -1 * o, width: e, height: t }), l.setAttrs({ x: -1 * i, y: -1 * o })
      }
    }
  }
  ;(xv.prototype.className = 'Label'), mg(xv)
  class Ev extends Xm {
    _sceneFunc(e) {
      var t = this.width(),
        n = this.height(),
        r = this.pointerDirection(),
        i = this.pointerWidth(),
        o = this.pointerHeight(),
        a = this.cornerRadius()
      let l = 0,
        s = 0,
        c = 0,
        u = 0
      'number' == typeof a
        ? (l = s = c = u = Math.min(a, t / 2, n / 2))
        : ((l = Math.min(a[0] || 0, t / 2, n / 2)),
          (s = Math.min(a[1] || 0, t / 2, n / 2)),
          (u = Math.min(a[2] || 0, t / 2, n / 2)),
          (c = Math.min(a[3] || 0, t / 2, n / 2))),
        e.beginPath(),
        e.moveTo(l, 0),
        'up' === r && (e.lineTo((t - i) / 2, 0), e.lineTo(t / 2, -1 * o), e.lineTo((t + i) / 2, 0)),
        e.lineTo(t - s, 0),
        e.arc(t - s, s, s, (3 * Math.PI) / 2, 0, !1),
        r === yv && (e.lineTo(t, (n - o) / 2), e.lineTo(t + i, n / 2), e.lineTo(t, (n + o) / 2)),
        e.lineTo(t, n - u),
        e.arc(t - u, n - u, u, 0, Math.PI / 2, !1),
        r === bv && (e.lineTo((t + i) / 2, n), e.lineTo(t / 2, n + o), e.lineTo((t - i) / 2, n)),
        e.lineTo(c, n),
        e.arc(c, n - c, c, Math.PI / 2, Math.PI, !1),
        r === wv && (e.lineTo(0, (n + o) / 2), e.lineTo(-1 * i, n / 2), e.lineTo(0, (n - o) / 2)),
        e.lineTo(0, l),
        e.arc(l, l, l, Math.PI, (3 * Math.PI) / 2, !1),
        e.closePath(),
        e.fillStrokeShape(this)
    }
    getSelfRect() {
      var e = 0,
        t = 0,
        n = this.pointerWidth(),
        r = this.pointerHeight(),
        i = this.pointerDirection(),
        o = this.width(),
        a = this.height()
      return (
        'up' === i
          ? ((t -= r), (a += r))
          : i === bv
          ? (a += r)
          : i === wv
          ? ((e -= 1.5 * n), (o += n))
          : i === yv && (o += 1.5 * n),
        { x: e, y: t, width: o, height: a }
      )
    }
  }
  ;(Ev.prototype.className = 'Tag'),
    mg(Ev),
    Jg.addGetterSetter(Ev, 'pointerDirection', 'none'),
    Jg.addGetterSetter(Ev, 'pointerWidth', 0, Zg()),
    Jg.addGetterSetter(Ev, 'pointerHeight', 0, Zg()),
    Jg.addGetterSetter(Ev, 'cornerRadius', 0, Ug(4))
  class Sv extends Xm {
    _sceneFunc(e) {
      var t = this.cornerRadius(),
        n = this.width(),
        r = this.height()
      e.beginPath(), t ? Vg.drawRoundedRectPath(e, n, r, t) : e.rect(0, 0, n, r), e.closePath(), e.fillStrokeShape(this)
    }
  }
  ;(Sv.prototype.className = 'Rect'), mg(Sv), Jg.addGetterSetter(Sv, 'cornerRadius', 0, Ug(4))
  class Ov extends Xm {
    _sceneFunc(e) {
      var t = this._getPoints()
      e.beginPath(), e.moveTo(t[0].x, t[0].y)
      for (var n = 1; n < t.length; n++) e.lineTo(t[n].x, t[n].y)
      e.closePath(), e.fillStrokeShape(this)
    }
    _getPoints() {
      for (var e = this.attrs.sides, t = this.attrs.radius || 0, n = [], r = 0; r < e; r++)
        n.push({ x: t * Math.sin((2 * r * Math.PI) / e), y: -1 * t * Math.cos((2 * r * Math.PI) / e) })
      return n
    }
    getSelfRect() {
      var e = this._getPoints(),
        t = e[0].x,
        n = e[0].y,
        r = e[0].x,
        i = e[0].y
      return (
        e.forEach(e => {
          ;(t = Math.min(t, e.x)), (n = Math.max(n, e.x)), (r = Math.min(r, e.y)), (i = Math.max(i, e.y))
        }),
        { x: t, y: r, width: n - t, height: i - r }
      )
    }
    getWidth() {
      return 2 * this.radius()
    }
    getHeight() {
      return 2 * this.radius()
    }
    setWidth(e) {
      this.radius(e / 2)
    }
    setHeight(e) {
      this.radius(e / 2)
    }
  }
  ;(Ov.prototype.className = 'RegularPolygon'),
    (Ov.prototype._centroid = !0),
    (Ov.prototype._attrsAffectingSize = ['radius']),
    mg(Ov),
    Jg.addGetterSetter(Ov, 'radius', 0, Zg()),
    Jg.addGetterSetter(Ov, 'sides', 0, Zg())
  var kv = 2 * Math.PI
  class Pv extends Xm {
    _sceneFunc(e) {
      e.beginPath(),
        e.arc(0, 0, this.innerRadius(), 0, kv, !1),
        e.moveTo(this.outerRadius(), 0),
        e.arc(0, 0, this.outerRadius(), kv, 0, !0),
        e.closePath(),
        e.fillStrokeShape(this)
    }
    getWidth() {
      return 2 * this.outerRadius()
    }
    getHeight() {
      return 2 * this.outerRadius()
    }
    setWidth(e) {
      this.outerRadius(e / 2)
    }
    setHeight(e) {
      this.outerRadius(e / 2)
    }
  }
  ;(Pv.prototype.className = 'Ring'),
    (Pv.prototype._centroid = !0),
    (Pv.prototype._attrsAffectingSize = ['innerRadius', 'outerRadius']),
    mg(Pv),
    Jg.addGetterSetter(Pv, 'innerRadius', 0, Zg()),
    Jg.addGetterSetter(Pv, 'outerRadius', 0, Zg())
  class _v extends Xm {
    constructor(e) {
      super(e),
        (this._updated = !0),
        (this.anim = new ev(() => {
          var e = this._updated
          return (this._updated = !1), e
        })),
        this.on('animationChange.konva', function () {
          this.frameIndex(0)
        }),
        this.on('frameIndexChange.konva', function () {
          this._updated = !0
        }),
        this.on('frameRateChange.konva', function () {
          this.anim.isRunning() && (clearInterval(this.interval), this._setInterval())
        })
    }
    _sceneFunc(e) {
      var t = this.animation(),
        n = this.frameIndex(),
        r = 4 * n,
        i = this.animations()[t],
        o = this.frameOffsets(),
        a = i[0 + r],
        l = i[1 + r],
        s = i[2 + r]
      ;(i = i[3 + r]), (r = this.image())
      ;(this.hasFill() || this.hasStroke()) &&
        (e.beginPath(), e.rect(0, 0, s, i), e.closePath(), e.fillStrokeShape(this)),
        r &&
          (o
            ? ((o = o[t]), e.drawImage(r, a, l, s, i, o[0 + (t = 2 * n)], o[1 + t], s, i))
            : e.drawImage(r, a, l, s, i, 0, 0, s, i))
    }
    _hitFunc(e) {
      var t = this.animation(),
        n = this.frameIndex(),
        r = 4 * n,
        i = this.animations()[t],
        o = this.frameOffsets(),
        a = i[2 + r]
      i = i[3 + r]
      e.beginPath(),
        o ? ((r = o[t]), e.rect(r[0 + (o = 2 * n)], r[1 + o], a, i)) : e.rect(0, 0, a, i),
        e.closePath(),
        e.fillShape(this)
    }
    _useBufferCanvas() {
      return super._useBufferCanvas(!0)
    }
    _setInterval() {
      var e = this
      this.interval = setInterval(function () {
        e._updateIndex()
      }, 1e3 / this.frameRate())
    }
    start() {
      var e
      this.isRunning() || ((e = this.getLayer()), this.anim.setLayers(e), this._setInterval(), this.anim.start())
    }
    stop() {
      this.anim.stop(), clearInterval(this.interval)
    }
    isRunning() {
      return this.anim.isRunning()
    }
    _updateIndex() {
      var e = this.frameIndex(),
        t = this.animation()
      e < this.animations()[t].length / 4 - 1 ? this.frameIndex(e + 1) : this.frameIndex(0)
    }
  }
  ;(_v.prototype.className = 'Sprite'),
    mg(_v),
    Jg.addGetterSetter(_v, 'animation'),
    Jg.addGetterSetter(_v, 'animations'),
    Jg.addGetterSetter(_v, 'frameOffsets'),
    Jg.addGetterSetter(_v, 'image'),
    Jg.addGetterSetter(_v, 'frameIndex', 0, Zg()),
    Jg.addGetterSetter(_v, 'frameRate', 17, Zg()),
    Jg.backCompat(_v, { index: 'frameIndex', getIndex: 'getFrameIndex', setIndex: 'setFrameIndex' })
  class Lv extends Xm {
    _sceneFunc(e) {
      var t = this.innerRadius(),
        n = this.outerRadius(),
        r = this.numPoints()
      e.beginPath(), e.moveTo(0, 0 - n)
      for (var i = 1; i < 2 * r; i++) {
        var o = (a = i % 2 == 0 ? n : t) * Math.sin((i * Math.PI) / r),
          a = -1 * a * Math.cos((i * Math.PI) / r)
        e.lineTo(o, a)
      }
      e.closePath(), e.fillStrokeShape(this)
    }
    getWidth() {
      return 2 * this.outerRadius()
    }
    getHeight() {
      return 2 * this.outerRadius()
    }
    setWidth(e) {
      this.outerRadius(e / 2)
    }
    setHeight(e) {
      this.outerRadius(e / 2)
    }
  }
  function Tv(e) {
    return Array.from(e)
  }
  ;(Lv.prototype.className = 'Star'),
    (Lv.prototype._centroid = !0),
    (Lv.prototype._attrsAffectingSize = ['innerRadius', 'outerRadius']),
    mg(Lv),
    Jg.addGetterSetter(Lv, 'numPoints', 5, Zg()),
    Jg.addGetterSetter(Lv, 'innerRadius', 0, Zg()),
    Jg.addGetterSetter(Lv, 'outerRadius', 0, Zg())
  var Iv,
    Mv = 'auto',
    jv = 'justify',
    Rv = [
      'fontFamily',
      'fontSize',
      'fontStyle',
      'fontVariant',
      'padding',
      'align',
      'verticalAlign',
      'lineHeight',
      'text',
      'width',
      'height',
      'wrap',
      'ellipsis',
      'letterSpacing'
    ],
    Dv = Rv.length
  function Av() {
    return (Iv = Iv || Vg.createCanvasElement().getContext('2d'))
  }
  class zv extends Xm {
    constructor(e) {
      super(
        ((e = e || {}).fillLinearGradientColorStops ||
          e.fillRadialGradientColorStops ||
          e.fillPatternImage ||
          (e.fill = e.fill || 'black'),
        e)
      ),
        (this._partialTextX = 0)
      for (var t = (this._partialTextY = 0); t < Dv; t++) this.on(Rv[t] + 'Change.konva', this._setTextData)
      this._setTextData()
    }
    _sceneFunc(e) {
      var t = this.textArr,
        n = t.length
      if (this.text()) {
        var r,
          i = this.padding(),
          o = this.fontSize(),
          a = this.lineHeight() * o,
          l = this.verticalAlign(),
          s = 0,
          c = this.align(),
          u = this.getWidth(),
          d = this.letterSpacing(),
          f = this.fill(),
          h = this.textDecoration(),
          p = -1 !== h.indexOf('underline'),
          g = -1 !== h.indexOf('line-through'),
          m = 0,
          v = ((m = a / 2), 0)
        for (
          e.setAttr('font', this._getContextFont()),
            e.setAttr('textBaseline', 'middle'),
            e.setAttr('textAlign', 'left'),
            'middle' === l
              ? (s = (this.getHeight() - n * a - 2 * i) / 2)
              : 'bottom' === l && (s = this.getHeight() - n * a - 2 * i),
            e.translate(i, s + i),
            r = 0;
          r < n;
          r++
        ) {
          v = 0
          var y,
            b,
            w = t[r],
            C = w.text,
            x = w.width,
            E = w.lastInParagraph
          if (
            (e.save(),
            'right' === c ? (v += u - x - 2 * i) : 'center' === c && (v += (u - x - 2 * i) / 2),
            p &&
              (e.save(),
              e.beginPath(),
              e.moveTo(v, m + 0 + Math.round(o / 2)),
              (y = 0 == (S = C.split(' ').length - 1)),
              (b = c !== jv || E ? x : u - 2 * i),
              e.lineTo(v + Math.round(b), m + 0 + Math.round(o / 2)),
              (e.lineWidth = o / 15),
              (w = this._getLinearGradient()),
              (e.strokeStyle = w || f),
              e.stroke(),
              e.restore()),
            g &&
              (e.save(),
              e.beginPath(),
              e.moveTo(v, m + 0),
              (y = 0 == (S = C.split(' ').length - 1)),
              (b = c === jv && E && !y ? u - 2 * i : x),
              e.lineTo(v + Math.round(b), m + 0),
              (e.lineWidth = o / 15),
              (w = this._getLinearGradient()),
              (e.strokeStyle = w || f),
              e.stroke(),
              e.restore()),
            0 !== d || c === jv)
          )
            for (var S = C.split(' ').length - 1, O = Tv(C), k = 0; k < O.length; k++) {
              var P = O[k]
              ' ' !== P || E || c !== jv || (v += (u - 2 * i - x) / S),
                (this._partialTextX = v),
                (this._partialTextY = m + 0),
                (this._partialText = P),
                e.fillStrokeShape(this),
                (v += this.measureSize(P).width + d)
            }
          else (this._partialTextX = v), (this._partialTextY = m + 0), (this._partialText = C), e.fillStrokeShape(this)
          e.restore(), 1 < n && (m += a)
        }
      }
    }
    _hitFunc(e) {
      var t = this.getWidth(),
        n = this.getHeight()
      e.beginPath(), e.rect(0, 0, t, n), e.closePath(), e.fillStrokeShape(this)
    }
    setText(e) {
      return (e = Vg._isString(e) ? e : null == e ? '' : e + ''), this._setAttr('text', e), this
    }
    getWidth() {
      return this.attrs.width === Mv || void 0 === this.attrs.width
        ? this.getTextWidth() + 2 * this.padding()
        : this.attrs.width
    }
    getHeight() {
      return this.attrs.height === Mv || void 0 === this.attrs.height
        ? this.fontSize() * this.textArr.length * this.lineHeight() + 2 * this.padding()
        : this.attrs.height
    }
    getTextWidth() {
      return this.textWidth
    }
    getTextHeight() {
      return (
        Vg.warn(
          'text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.'
        ),
        this.textHeight
      )
    }
    measureSize(e) {
      var t = Av(),
        n = this.fontSize()
      return (
        t.save(), (t.font = this._getContextFont()), (e = t.measureText(e)), t.restore(), { width: e.width, height: n }
      )
    }
    _getContextFont() {
      return (
        this.fontStyle() +
        ' ' +
        this.fontVariant() +
        ' ' +
        this.fontSize() +
        'px ' +
        this.fontFamily()
          .split(',')
          .map(e => {
            var t = 0 <= (e = e.trim()).indexOf(' '),
              n = 0 <= e.indexOf('"') || 0 <= e.indexOf("'")
            return t && !n ? `"${e}"` : e
          })
          .join(', ')
      )
    }
    _addTextLine(e) {
      this.align() === jv && (e = e.trim())
      var t = this._getTextWidth(e)
      return this.textArr.push({ text: e, width: t, lastInParagraph: !1 })
    }
    _getTextWidth(e) {
      var t = this.letterSpacing(),
        n = e.length
      return Av().measureText(e).width + (n ? t * (n - 1) : 0)
    }
    _setTextData() {
      for (
        var e = this.text().split('\n'),
          t = +this.fontSize(),
          n = 0,
          r = this.lineHeight() * t,
          i = this.attrs.width,
          o = this.attrs.height,
          a = i !== Mv && void 0 !== i,
          l = o !== Mv && void 0 !== o,
          s = this.padding(),
          c = i - 2 * s,
          u = o - 2 * s,
          d = 0,
          f = 'char' !== (i = this.wrap()) && 'none' !== i,
          h =
            ((o = this.ellipsis()),
            (this.textArr = []),
            (Av().font = this._getContextFont()),
            o ? this._getTextWidth('…') : 0),
          p = 0,
          g = e.length;
        p < g;
        ++p
      ) {
        var m = e[p],
          v = this._getTextWidth(m)
        if (a && c < v)
          for (; 0 < m.length; ) {
            for (var y, b = 0, w = m.length, C = '', x = 0; b < w; ) {
              var E = (b + w) >>> 1,
                S = m.slice(0, 1 + E),
                O = this._getTextWidth(S) + h
              O <= c ? ((b = 1 + E), (C = S), (x = O)) : (w = E)
            }
            if (!C) break
            if (
              (f &&
                0 <
                  (y =
                    (' ' === (y = m[C.length]) || '-' === y) && x <= c
                      ? C.length
                      : Math.max(C.lastIndexOf(' '), C.lastIndexOf('-')) + 1) &&
                ((b = y), (C = C.slice(0, b)), (x = this._getTextWidth(C))),
              (C = C.trimRight()),
              this._addTextLine(C),
              (n = Math.max(n, x)),
              (d += r),
              this._shouldHandleEllipsis(d))
            ) {
              this._tryToAddEllipsisToLastLine()
              break
            }
            if (0 < (m = (m = m.slice(b)).trimLeft()).length && (v = this._getTextWidth(m)) <= c) {
              this._addTextLine(m), (d += r), (n = Math.max(n, v))
              break
            }
          }
        else
          this._addTextLine(m),
            (d += r),
            (n = Math.max(n, v)),
            this._shouldHandleEllipsis(d) && p < g - 1 && this._tryToAddEllipsisToLastLine()
        if (
          (this.textArr[this.textArr.length - 1] && (this.textArr[this.textArr.length - 1].lastInParagraph = !0),
          l && u < d + r)
        )
          break
      }
      ;(this.textHeight = t), (this.textWidth = n)
    }
    _shouldHandleEllipsis(e) {
      var t = +this.fontSize(),
        n = ((t = this.lineHeight() * t), (r = this.attrs.height) !== Mv && void 0 !== r),
        r = r - 2 * this.padding()
      return !('none' !== this.wrap()) || (n && r < e + t)
    }
    _tryToAddEllipsisToLastLine() {
      var e = (t = this.attrs.width) !== Mv && void 0 !== t,
        t = t - 2 * this.padding(),
        n = this.ellipsis(),
        r = this.textArr[this.textArr.length - 1]
      r &&
        n &&
        (!e || this._getTextWidth(r.text + '…') < t || (r.text = r.text.slice(0, r.text.length - 3)),
        this.textArr.splice(this.textArr.length - 1, 1),
        this._addTextLine(r.text + '…'))
    }
    getStrokeScaleEnabled() {
      return !0
    }
  }
  function Nv(e) {
    e.fillText(this.partialText, 0, 0)
  }
  function Fv(e) {
    e.strokeText(this.partialText, 0, 0)
  }
  ;(zv.prototype._fillFunc = function (e) {
    e.fillText(this._partialText, this._partialTextX, this._partialTextY)
  }),
    (zv.prototype._strokeFunc = function (e) {
      e.strokeText(this._partialText, this._partialTextX, this._partialTextY)
    }),
    (zv.prototype.className = 'Text'),
    (zv.prototype._attrsAffectingSize = ['text', 'fontSize', 'padding', 'wrap', 'lineHeight', 'letterSpacing']),
    mg(zv),
    Jg.overWriteSetter(zv, 'width', Xg()),
    Jg.overWriteSetter(zv, 'height', Xg()),
    Jg.addGetterSetter(zv, 'fontFamily', 'Arial'),
    Jg.addGetterSetter(zv, 'fontSize', 12, Zg()),
    Jg.addGetterSetter(zv, 'fontStyle', 'normal'),
    Jg.addGetterSetter(zv, 'fontVariant', 'normal'),
    Jg.addGetterSetter(zv, 'padding', 0, Zg()),
    Jg.addGetterSetter(zv, 'align', 'left'),
    Jg.addGetterSetter(zv, 'verticalAlign', 'top'),
    Jg.addGetterSetter(zv, 'lineHeight', 1, Zg()),
    Jg.addGetterSetter(zv, 'wrap', 'word'),
    Jg.addGetterSetter(zv, 'ellipsis', !1, $g()),
    Jg.addGetterSetter(zv, 'letterSpacing', 0, Zg()),
    Jg.addGetterSetter(zv, 'text', '', Yg()),
    Jg.addGetterSetter(zv, 'textDecoration', '')
  class Hv extends Xm {
    constructor(e) {
      super(e),
        (this.dummyCanvas = Vg.createCanvasElement()),
        (this.dataArray = []),
        (this.dataArray = fv.parsePathData(this.attrs.data)),
        this.on('dataChange.konva', function () {
          ;(this.dataArray = fv.parsePathData(this.attrs.data)), this._setTextData()
        }),
        this.on(
          'textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva fontSizeChange.konva fontFamilyChange.konva',
          this._setTextData
        ),
        this._setTextData()
    }
    _sceneFunc(e) {
      e.setAttr('font', this._getContextFont()),
        e.setAttr('textBaseline', this.textBaseline()),
        e.setAttr('textAlign', 'left'),
        e.save()
      var t = this.textDecoration(),
        n = this.fill(),
        r = this.fontSize(),
        i = this.glyphInfo
      'underline' === t && e.beginPath()
      for (var o = 0; o < i.length; o++) {
        e.save()
        var a = i[o].p0
        e.translate(a.x, a.y),
          e.rotate(i[o].rotation),
          (this.partialText = i[o].text),
          e.fillStrokeShape(this),
          'underline' === t && (0 === o && e.moveTo(0, r / 2 + 1), e.lineTo(r, r / 2 + 1)),
          e.restore()
      }
      'underline' === t && ((e.strokeStyle = n), (e.lineWidth = r / 20), e.stroke()), e.restore()
    }
    _hitFunc(e) {
      e.beginPath()
      var t,
        n = this.glyphInfo
      1 <= n.length && ((t = n[0].p0), e.moveTo(t.x, t.y))
      for (var r = 0; r < n.length; r++) {
        var i = n[r].p1
        e.lineTo(i.x, i.y)
      }
      e.setAttr('lineWidth', this.fontSize()), e.setAttr('strokeStyle', this.colorKey), e.stroke()
    }
    getTextWidth() {
      return this.textWidth
    }
    getTextHeight() {
      return (
        Vg.warn(
          'text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.'
        ),
        this.textHeight
      )
    }
    setText(e) {
      return zv.prototype.setText.call(this, e)
    }
    _getContextFont() {
      return zv.prototype._getContextFont.call(this)
    }
    _getTextSize(e) {
      var t = this.dummyCanvas.getContext('2d')
      t.save(), (t.font = this._getContextFont()), (e = t.measureText(e))
      return t.restore(), { width: e.width, height: parseInt(this.attrs.fontSize, 10) }
    }
    _setTextData() {
      for (
        var e = this,
          t = this._getTextSize(this.attrs.text),
          n = this.letterSpacing(),
          r = this.align(),
          i = this.kerningFunc(),
          o =
            ((this.textWidth = t.width),
            (this.textHeight = t.height),
            Math.max(this.textWidth + ((this.attrs.text || '').length - 1) * n, 0)),
          a = ((this.glyphInfo = []), 0),
          l = 0;
        l < e.dataArray.length;
        l++
      )
        0 < e.dataArray[l].pathLength && (a += e.dataArray[l].pathLength)
      t = 0
      for (
        var s,
          c,
          u,
          d =
            ('center' === r && (t = Math.max(0, a / 2 - o / 2)),
            'right' === r && (t = Math.max(0, a - o)),
            Tv(this.text())),
          f = this.text().split(' ').length - 1,
          h = -1,
          p = 0,
          g = function () {
            p = 0
            for (var t = e.dataArray, n = h + 1; n < t.length; n++) {
              if (0 < t[n].pathLength) return t[(h = n)]
              'M' === t[n].command && (s = { x: t[n].points[0], y: t[n].points[1] })
            }
            return {}
          },
          m = function (t) {
            var i = e._getTextSize(t).width + n,
              l = (' ' === t && 'justify' === r && (i += (a - o) / f), 0),
              d = 0
            for (c = void 0; 0.01 < Math.abs(i - l) / i && d < 20; ) {
              d++
              for (var h = l; void 0 === u; ) (u = g()) && h + u.pathLength < i && ((h += u.pathLength), (u = void 0))
              if (0 === Object.keys(u).length || void 0 === s) return
              var m = !1
              switch (u.command) {
                case 'L':
                  fv.getLineLength(s.x, s.y, u.points[0], u.points[1]) > i
                    ? (c = fv.getPointOnLine(i, s.x, s.y, u.points[0], u.points[1], s.x, s.y))
                    : (u = void 0)
                  break
                case 'A':
                  var v = u.points[4],
                    y = u.points[5],
                    b = u.points[4] + y
                  0 === p
                    ? (p = v + 1e-8)
                    : l < i
                    ? (p += ((Math.PI / 180) * y) / Math.abs(y))
                    : (p -= ((Math.PI / 360) * y) / Math.abs(y)),
                    ((y < 0 && p < b) || (0 <= y && b < p)) && ((p = b), (m = !0)),
                    (c = fv.getPointOnEllipticalArc(u.points[0], u.points[1], u.points[2], u.points[3], p, u.points[6]))
                  break
                case 'C':
                  0 === p
                    ? (p = i > u.pathLength ? 1e-8 : i / u.pathLength)
                    : l < i
                    ? (p += (i - l) / u.pathLength / 2)
                    : (p = Math.max(p - (l - i) / u.pathLength / 2, 0)),
                    1 < p && ((p = 1), (m = !0)),
                    (c = fv.getPointOnCubicBezier(
                      p,
                      u.start.x,
                      u.start.y,
                      u.points[0],
                      u.points[1],
                      u.points[2],
                      u.points[3],
                      u.points[4],
                      u.points[5]
                    ))
                  break
                case 'Q':
                  0 === p
                    ? (p = i / u.pathLength)
                    : l < i
                    ? (p += (i - l) / u.pathLength)
                    : (p -= (l - i) / u.pathLength),
                    1 < p && ((p = 1), (m = !0)),
                    (c = fv.getPointOnQuadraticBezier(
                      p,
                      u.start.x,
                      u.start.y,
                      u.points[0],
                      u.points[1],
                      u.points[2],
                      u.points[3]
                    ))
              }
              void 0 !== c && (l = fv.getLineLength(s.x, s.y, c.x, c.y)), m && ((m = !1), (u = void 0))
            }
          },
          v = t / (e._getTextSize('C').width + n) - 1,
          y = 0;
        y < v && (m('C'), void 0 !== s) && void 0 !== c;
        y++
      )
        s = c
      for (var b = 0; b < d.length && (m(d[b]), void 0 !== s && void 0 !== c); b++) {
        var w = fv.getLineLength(s.x, s.y, c.x, c.y),
          C = 0
        if (i)
          try {
            C = i(d[b - 1], d[b]) * this.fontSize()
          } catch (x) {
            C = 0
          }
        ;(s.x += C),
          (c.x += C),
          (this.textWidth += C),
          (C = fv.getPointOnLine(C + w / 2, s.x, s.y, c.x, c.y)),
          (w = Math.atan2(c.y - s.y, c.x - s.x)),
          this.glyphInfo.push({ transposeX: C.x, transposeY: C.y, text: d[b], rotation: w, p0: s, p1: c }),
          (s = c)
      }
    }
    getSelfRect() {
      if (!this.glyphInfo.length) return { x: 0, y: 0, width: 0, height: 0 }
      for (
        var e,
          t,
          n = [],
          r =
            (this.glyphInfo.forEach(function (e) {
              n.push(e.p0.x), n.push(e.p0.y), n.push(e.p1.x), n.push(e.p1.y)
            }),
            n[0] || 0),
          i = n[0] || 0,
          o = n[1] || 0,
          a = n[1] || 0,
          l = 0;
        l < n.length / 2;
        l++
      )
        (e = n[2 * l]),
          (t = n[2 * l + 1]),
          (r = Math.min(r, e)),
          (i = Math.max(i, e)),
          (o = Math.min(o, t)),
          (a = Math.max(a, t))
      var s = this.fontSize()
      return { x: r - s / 2, y: o - s / 2, width: i - r + s, height: a - o + s }
    }
    destroy() {
      return Vg.releaseCanvas(this.dummyCanvas), super.destroy()
    }
  }
  ;(Hv.prototype._fillFunc = Nv),
    (Hv.prototype._strokeFunc = Fv),
    (Hv.prototype._fillFuncHit = Nv),
    (Hv.prototype._strokeFuncHit = Fv),
    (Hv.prototype.className = 'TextPath'),
    (Hv.prototype._attrsAffectingSize = ['text', 'fontSize', 'data']),
    mg(Hv),
    Jg.addGetterSetter(Hv, 'data'),
    Jg.addGetterSetter(Hv, 'fontFamily', 'Arial'),
    Jg.addGetterSetter(Hv, 'fontSize', 12, Zg()),
    Jg.addGetterSetter(Hv, 'fontStyle', 'normal'),
    Jg.addGetterSetter(Hv, 'align', 'left'),
    Jg.addGetterSetter(Hv, 'letterSpacing', 0, Zg()),
    Jg.addGetterSetter(Hv, 'textBaseline', 'middle'),
    Jg.addGetterSetter(Hv, 'fontVariant', 'normal'),
    Jg.addGetterSetter(Hv, 'text', ''),
    Jg.addGetterSetter(Hv, 'textDecoration', null),
    Jg.addGetterSetter(Hv, 'kerningFunc', null)
  var Bv = 'tr-konva',
    Vv = [
      'resizeEnabledChange',
      'rotateAnchorOffsetChange',
      'rotateEnabledChange',
      'enabledAnchorsChange',
      'anchorSizeChange',
      'borderEnabledChange',
      'borderStrokeChange',
      'borderStrokeWidthChange',
      'borderDashChange',
      'anchorStrokeChange',
      'anchorStrokeWidthChange',
      'anchorFillChange',
      'anchorCornerRadiusChange',
      'ignoreStrokeChange'
    ]
      .map(e => e + '.' + Bv)
      .join(' '),
    Wv = 'nodesRect',
    Gv = [
      'widthChange',
      'heightChange',
      'scaleXChange',
      'scaleYChange',
      'skewXChange',
      'skewYChange',
      'rotationChange',
      'offsetXChange',
      'offsetYChange',
      'transformsEnabledChange',
      'strokeWidthChange'
    ],
    Zv = {
      'top-left': -45,
      'top-center': 0,
      'top-right': 45,
      'middle-right': -90,
      'middle-left': 90,
      'bottom-left': -135,
      'bottom-center': 180,
      'bottom-right': 135
    }
  const Uv = 'ontouchstart' in jg._global
  var Xv = [
    'top-left',
    'top-center',
    'top-right',
    'middle-right',
    'middle-left',
    'bottom-left',
    'bottom-center',
    'bottom-right'
  ]
  function Yv(e, t, n) {
    var r = n.x + (e.x - n.x) * Math.cos(t) - (e.y - n.y) * Math.sin(t)
    n = n.y + (e.x - n.x) * Math.sin(t) + (e.y - n.y) * Math.cos(t)
    return Object.assign(Object.assign({}, e), { rotation: e.rotation + t, x: r, y: n })
  }
  class qv extends Qm {
    constructor(e) {
      super(e),
        (this._transforming = !1),
        this._createElements(),
        (this._handleMouseMove = this._handleMouseMove.bind(this)),
        (this._handleMouseUp = this._handleMouseUp.bind(this)),
        (this.update = this.update.bind(this)),
        this.on(Vv, this.update),
        this.getNode() && this.update()
    }
    attachTo(e) {
      return this.setNode(e), this
    }
    setNode(e) {
      return (
        Vg.warn(
          'tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead.'
        ),
        this.setNodes([e])
      )
    }
    getNode() {
      return this._nodes && this._nodes[0]
    }
    _getEventNamespace() {
      return Bv + this._id
    }
    setNodes(e = []) {
      this._nodes && this._nodes.length && this.detach()
      var t = e.filter(
        e =>
          !e.isAncestorOf(this) ||
          (Vg.error('Konva.Transformer cannot be an a child of the node you are trying to attach'), !1)
      )
      return (
        (this._nodes = e = t),
        1 === e.length && this.useSingleNodeRotation() ? this.rotation(e[0].getAbsoluteRotation()) : this.rotation(0),
        this._nodes.forEach(e => {
          var t = () => {
              1 === this.nodes().length &&
                this.useSingleNodeRotation() &&
                this.rotation(this.nodes()[0].getAbsoluteRotation()),
                this._resetTransformCache(),
                this._transforming || this.isDragging() || this.update()
            },
            n = e._attrsAffectingSize.map(e => e + 'Change.' + this._getEventNamespace()).join(' ')
          e.on(n, t),
            e.on(Gv.map(e => e + '.' + this._getEventNamespace()).join(' '), t),
            e.on('absoluteTransformChange.' + this._getEventNamespace(), t),
            this._proxyDrag(e)
        }),
        this._resetTransformCache(),
        !this.findOne('.top-left') || this.update(),
        this
      )
    }
    _proxyDrag(e) {
      let t
      e.on('dragstart.' + this._getEventNamespace(), n => {
        ;(t = e.getAbsolutePosition()), this.isDragging() || e === this.findOne('.back') || this.startDrag(n, !1)
      }),
        e.on('dragmove.' + this._getEventNamespace(), n => {
          if (t) {
            var r = e.getAbsolutePosition()
            const i = r.x - t.x,
              o = r.y - t.y
            this.nodes().forEach(t => {
              var r
              t === e ||
                t.isDragging() ||
                ((r = t.getAbsolutePosition()), t.setAbsolutePosition({ x: r.x + i, y: r.y + o }), t.startDrag(n))
            }),
              (t = null)
          }
        })
    }
    getNodes() {
      return this._nodes || []
    }
    getActiveAnchor() {
      return this._movingAnchorName
    }
    detach() {
      this._nodes &&
        this._nodes.forEach(e => {
          e.off('.' + this._getEventNamespace())
        }),
        (this._nodes = []),
        this._resetTransformCache()
    }
    _resetTransformCache() {
      this._clearCache(Wv), this._clearCache('transform'), this._clearSelfAndDescendantCache('absoluteTransform')
    }
    _getNodeRect() {
      return this._getCache(Wv, this.__getNodeRect)
    }
    __getNodeShape(e, t = this.rotation(), n) {
      var r = e.getClientRect({ skipTransform: !0, skipShadow: !0, skipStroke: this.ignoreStroke() }),
        i = e.getAbsoluteScale(n),
        o = ((n = e.getAbsolutePosition(n)), r.x * i.x - e.offsetX() * i.x),
        a = r.y * i.y - e.offsetY() * i.y
      e = (jg.getAngle(e.getAbsoluteRotation()) + 2 * Math.PI) % (2 * Math.PI)
      return Yv(
        {
          x: n.x + o * Math.cos(e) + a * Math.sin(-e),
          y: n.y + a * Math.cos(e) + o * Math.sin(e),
          width: r.width * i.x,
          height: r.height * i.y,
          rotation: e
        },
        -jg.getAngle(t),
        { x: 0, y: 0 }
      )
    }
    __getNodeRect() {
      var e, t, n, r
      if (!this.getNode()) return { x: -1e8, y: -1e8, width: 0, height: 0, rotation: 0 }
      const i = [],
        o =
          (this.nodes().map(e => {
            var t = [
                {
                  x: (t = e.getClientRect({ skipTransform: !0, skipShadow: !0, skipStroke: this.ignoreStroke() })).x,
                  y: t.y
                },
                { x: t.x + t.width, y: t.y },
                { x: t.x + t.width, y: t.y + t.height },
                { x: t.x, y: t.y + t.height }
              ],
              n = e.getAbsoluteTransform()
            t.forEach(function (e) {
              ;(e = n.point(e)), i.push(e)
            })
          }),
          new Rg())
      o.rotate(-jg.getAngle(this.rotation())),
        i.forEach(function (i) {
          ;(i = o.point(i)),
            void 0 === e && ((e = n = i.x), (t = r = i.y)),
            (e = Math.min(e, i.x)),
            (t = Math.min(t, i.y)),
            (n = Math.max(n, i.x)),
            (r = Math.max(r, i.y))
        }),
        o.invert()
      var a = o.point({ x: e, y: t })
      return { x: a.x, y: a.y, width: n - e, height: r - t, rotation: jg.getAngle(this.rotation()) }
    }
    getX() {
      return this._getNodeRect().x
    }
    getY() {
      return this._getNodeRect().y
    }
    getWidth() {
      return this._getNodeRect().width
    }
    getHeight() {
      return this._getNodeRect().height
    }
    _createElements() {
      this._createBack(),
        Xv.forEach(
          function (e) {
            this._createAnchor(e)
          }.bind(this)
        ),
        this._createAnchor('rotater')
    }
    _createAnchor(e) {
      var t = new Sv({
          stroke: 'rgb(0, 161, 255)',
          fill: 'white',
          strokeWidth: 1,
          name: e + ' _anchor',
          dragDistance: 0,
          draggable: !0,
          hitStrokeWidth: Uv ? 10 : 'auto'
        }),
        n = this
      t.on('mousedown touchstart', function (e) {
        n._handleMouseDown(e)
      }),
        t.on('dragstart', e => {
          t.stopDrag(), (e.cancelBubble = !0)
        }),
        t.on('dragend', e => {
          e.cancelBubble = !0
        }),
        t.on('mouseenter', () => {
          var n,
            r = jg.getAngle(this.rotation())
          r =
            'rotater' === (n = e)
              ? 'crosshair'
              : ((r += Vg.degToRad(Zv[n] || 0)),
                (n = ((Vg.radToDeg(r) % 360) + 360) % 360),
                Vg._inRange(n, 337.5, 360) || Vg._inRange(n, 0, 22.5)
                  ? 'ns-resize'
                  : Vg._inRange(n, 22.5, 67.5)
                  ? 'nesw-resize'
                  : Vg._inRange(n, 67.5, 112.5)
                  ? 'ew-resize'
                  : Vg._inRange(n, 112.5, 157.5)
                  ? 'nwse-resize'
                  : Vg._inRange(n, 157.5, 202.5)
                  ? 'ns-resize'
                  : Vg._inRange(n, 202.5, 247.5)
                  ? 'nesw-resize'
                  : Vg._inRange(n, 247.5, 292.5)
                  ? 'ew-resize'
                  : Vg._inRange(n, 292.5, 337.5)
                  ? 'nwse-resize'
                  : (Vg.error('Transformer has unknown angle for cursor detection: ' + n), 'pointer'))
          t.getStage().content && (t.getStage().content.style.cursor = r), (this._cursorChange = !0)
        }),
        t.on('mouseout', () => {
          t.getStage().content && (t.getStage().content.style.cursor = ''), (this._cursorChange = !1)
        }),
        this.add(t)
    }
    _createBack() {
      var e = new Xm({
        name: 'back',
        width: 0,
        height: 0,
        draggable: !0,
        sceneFunc(e) {
          var t = this.getParent(),
            n = t.padding()
          e.beginPath(),
            e.rect(-n, -n, this.width() + 2 * n, this.height() + 2 * n),
            e.moveTo(this.width() / 2, -n),
            t.rotateEnabled() && e.lineTo(this.width() / 2, -t.rotateAnchorOffset() * Vg._sign(this.height()) - n),
            e.fillStrokeShape(this)
        },
        hitFunc: (e, t) => {
          var n
          this.shouldOverdrawWholeArea() &&
            ((n = this.padding()),
            e.beginPath(),
            e.rect(-n, -n, t.width() + 2 * n, t.height() + 2 * n),
            e.fillStrokeShape(t))
        }
      })
      this.add(e),
        this._proxyDrag(e),
        e.on('dragstart', e => {
          e.cancelBubble = !0
        }),
        e.on('dragmove', e => {
          e.cancelBubble = !0
        }),
        e.on('dragend', e => {
          e.cancelBubble = !0
        }),
        this.on('dragmove', e => {
          this.update()
        })
    }
    _handleMouseDown(e) {
      this._movingAnchorName = e.target.name().split(' ')[0]
      var t = (n = this._getNodeRect()).width,
        n = n.height,
        r = Math.sqrt(Math.pow(t, 2) + Math.pow(n, 2))
      ;(this.sin = Math.abs(n / r)),
        (this.cos = Math.abs(t / r)),
        'undefined' != typeof window &&
          (window.addEventListener('mousemove', this._handleMouseMove),
          window.addEventListener('touchmove', this._handleMouseMove),
          window.addEventListener('mouseup', this._handleMouseUp, !0),
          window.addEventListener('touchend', this._handleMouseUp, !0)),
        (this._transforming = !0),
        (n = e.target.getAbsolutePosition()),
        (t = e.target.getStage().getPointerPosition())
      ;(this._anchorDragOffset = { x: t.x - n.x, y: t.y - n.y }),
        this._fire('transformstart', { evt: e.evt, target: this.getNode() }),
        this._nodes.forEach(t => {
          t._fire('transformstart', { evt: e.evt, target: t })
        })
    }
    _handleMouseMove(e) {
      var t = this.findOne('.' + this._movingAnchorName)
      let n = {
        x: (r = ((r = t.getStage()).setPointersPositions(e), r.getPointerPosition())).x - this._anchorDragOffset.x,
        y: r.y - this._anchorDragOffset.y
      }
      var r = t.getAbsolutePosition(),
        i =
          (this.anchorDragBoundFunc() && (n = this.anchorDragBoundFunc()(r, n, e)),
          t.setAbsolutePosition(n),
          t.getAbsolutePosition())
      if (r.x !== i.x || r.y !== i.y)
        if ('rotater' === this._movingAnchorName) {
          r = this._getNodeRect()
          var o = t.x() - r.width / 2,
            a = -t.y() + r.height / 2
          let n = Math.atan2(-a, o) + Math.PI / 2
          r.height < 0 && (n -= Math.PI)
          i = jg.getAngle(this.rotation()) + n
          var l = jg.getAngle(this.rotationSnapTolerance())
          i = (function (e, t) {
            var n = {
              x: (n = e).x + (n.width / 2) * Math.cos(n.rotation) + (n.height / 2) * Math.sin(-n.rotation),
              y: n.y + (n.height / 2) * Math.cos(n.rotation) + (n.width / 2) * Math.sin(n.rotation)
            }
            return Yv(e, t, n)
          })(
            r,
            (function (e, t, n) {
              let r = t
              for (let a = 0; a < e.length; a++) {
                var i = jg.getAngle(e[a]),
                  o = Math.abs(i - t) % (2 * Math.PI)
                Math.min(o, 2 * Math.PI - o) < n && (r = i)
              }
              return r
            })(this.rotationSnaps(), i, l) - r.rotation
          )
          this._fitNodesInto(i, e)
        } else {
          ;(l = this.keepRatio() || e.shiftKey),
            (r = this.centeredScaling() || e.altKey),
            'top-left' === this._movingAnchorName
              ? l &&
                ((f = r
                  ? { x: this.width() / 2, y: this.height() / 2 }
                  : { x: this.findOne('.bottom-right').x(), y: this.findOne('.bottom-right').y() }),
                (u = Math.sqrt(Math.pow(f.x - t.x(), 2) + Math.pow(f.y - t.y(), 2))),
                (c = this.findOne('.top-left').x() > f.x ? -1 : 1),
                (d = this.findOne('.top-left').y() > f.y ? -1 : 1),
                (o = u * this.cos * c),
                (a = u * this.sin * d),
                this.findOne('.top-left').x(f.x - o),
                this.findOne('.top-left').y(f.y - a))
              : 'top-center' === this._movingAnchorName
              ? this.findOne('.top-left').y(t.y())
              : 'top-right' === this._movingAnchorName
              ? (l &&
                  ((f = r
                    ? { x: this.width() / 2, y: this.height() / 2 }
                    : { x: this.findOne('.bottom-left').x(), y: this.findOne('.bottom-left').y() }),
                  (u = Math.sqrt(Math.pow(t.x() - f.x, 2) + Math.pow(f.y - t.y(), 2))),
                  (c = this.findOne('.top-right').x() < f.x ? -1 : 1),
                  (d = this.findOne('.top-right').y() > f.y ? -1 : 1),
                  (o = u * this.cos * c),
                  (a = u * this.sin * d),
                  this.findOne('.top-right').x(f.x + o),
                  this.findOne('.top-right').y(f.y - a)),
                (s = t.position()),
                this.findOne('.top-left').y(s.y),
                this.findOne('.bottom-right').x(s.x))
              : 'middle-left' === this._movingAnchorName
              ? this.findOne('.top-left').x(t.x())
              : 'middle-right' === this._movingAnchorName
              ? this.findOne('.bottom-right').x(t.x())
              : 'bottom-left' === this._movingAnchorName
              ? (l &&
                  ((f = r
                    ? { x: this.width() / 2, y: this.height() / 2 }
                    : { x: this.findOne('.top-right').x(), y: this.findOne('.top-right').y() }),
                  (u = Math.sqrt(Math.pow(f.x - t.x(), 2) + Math.pow(t.y() - f.y, 2))),
                  (c = f.x < t.x() ? -1 : 1),
                  (d = t.y() < f.y ? -1 : 1),
                  (o = u * this.cos * c),
                  (a = u * this.sin * d),
                  t.x(f.x - o),
                  t.y(f.y + a)),
                (s = t.position()),
                this.findOne('.top-left').x(s.x),
                this.findOne('.bottom-right').y(s.y))
              : 'bottom-center' === this._movingAnchorName
              ? this.findOne('.bottom-right').y(t.y())
              : 'bottom-right' === this._movingAnchorName
              ? l &&
                ((f = r
                  ? { x: this.width() / 2, y: this.height() / 2 }
                  : { x: this.findOne('.top-left').x(), y: this.findOne('.top-left').y() }),
                (u = Math.sqrt(Math.pow(t.x() - f.x, 2) + Math.pow(t.y() - f.y, 2))),
                (c = this.findOne('.bottom-right').x() < f.x ? -1 : 1),
                (d = this.findOne('.bottom-right').y() < f.y ? -1 : 1),
                (o = u * this.cos * c),
                (a = u * this.sin * d),
                this.findOne('.bottom-right').x(f.x + o),
                this.findOne('.bottom-right').y(f.y + a))
              : console.error(new Error('Wrong position argument of selection resizer: ' + this._movingAnchorName)),
            (this.centeredScaling() || e.altKey) &&
              ((i = this.findOne('.top-left')),
              (s = this.findOne('.bottom-right')),
              (l = i.x()),
              (r = i.y()),
              (t = this.getWidth() - s.x()),
              (c = this.getHeight() - s.y()),
              s.move({ x: -l, y: -r }),
              i.move({ x: t, y: c }))
          var s,
            c,
            u = this.findOne('.top-left').getAbsolutePosition(),
            d = ((o = u.x), (a = u.y), this.findOne('.bottom-right').x() - this.findOne('.top-left').x()),
            f = this.findOne('.bottom-right').y() - this.findOne('.top-left').y()
          this._fitNodesInto({ x: o, y: a, width: d, height: f, rotation: jg.getAngle(this.rotation()) }, e)
        }
    }
    _handleMouseUp(e) {
      this._removeEvents(e)
    }
    getAbsoluteTransform() {
      return this.getTransform()
    }
    _removeEvents(e) {
      var t
      this._transforming &&
        ((this._transforming = !1),
        'undefined' != typeof window &&
          (window.removeEventListener('mousemove', this._handleMouseMove),
          window.removeEventListener('touchmove', this._handleMouseMove),
          window.removeEventListener('mouseup', this._handleMouseUp, !0),
          window.removeEventListener('touchend', this._handleMouseUp, !0)),
        (t = this.getNode()),
        this._fire('transformend', { evt: e, target: t }),
        t &&
          this._nodes.forEach(t => {
            t._fire('transformend', { evt: e, target: t })
          }),
        (this._movingAnchorName = null))
    }
    _fitNodesInto(e, t) {
      var n = this._getNodeRect()
      if (Vg._inRange(e.width, 2 * -this.padding() - 1, 1)) this.update()
      else if (Vg._inRange(e.height, 2 * -this.padding() - 1, 1)) this.update()
      else {
        var r = this.flipEnabled(),
          i = new Rg()
        if (
          (i.rotate(jg.getAngle(this.rotation())),
          this._movingAnchorName && e.width < 0 && 0 <= this._movingAnchorName.indexOf('left'))
        ) {
          var o = i.point({ x: 2 * -this.padding(), y: 0 })
          if (
            ((e.x += o.x),
            (e.y += o.y),
            (e.width += 2 * this.padding()),
            (this._movingAnchorName = this._movingAnchorName.replace('left', 'right')),
            (this._anchorDragOffset.x -= o.x),
            (this._anchorDragOffset.y -= o.y),
            !r)
          )
            return void this.update()
        } else if (
          this._movingAnchorName &&
          e.width < 0 &&
          0 <= this._movingAnchorName.indexOf('right') &&
          ((o = i.point({ x: 2 * this.padding(), y: 0 })),
          (this._movingAnchorName = this._movingAnchorName.replace('right', 'left')),
          (this._anchorDragOffset.x -= o.x),
          (this._anchorDragOffset.y -= o.y),
          (e.width += 2 * this.padding()),
          !r)
        )
          return void this.update()
        if (this._movingAnchorName && e.height < 0 && 0 <= this._movingAnchorName.indexOf('top')) {
          if (
            ((o = i.point({ x: 0, y: 2 * -this.padding() })),
            (e.x += o.x),
            (e.y += o.y),
            (this._movingAnchorName = this._movingAnchorName.replace('top', 'bottom')),
            (this._anchorDragOffset.x -= o.x),
            (this._anchorDragOffset.y -= o.y),
            (e.height += 2 * this.padding()),
            !r)
          )
            return void this.update()
        } else if (
          this._movingAnchorName &&
          e.height < 0 &&
          0 <= this._movingAnchorName.indexOf('bottom') &&
          ((o = i.point({ x: 0, y: 2 * this.padding() })),
          (this._movingAnchorName = this._movingAnchorName.replace('bottom', 'top')),
          (this._anchorDragOffset.x -= o.x),
          (this._anchorDragOffset.y -= o.y),
          (e.height += 2 * this.padding()),
          !r)
        )
          return void this.update()
        this.boundBoxFunc() &&
          ((i = this.boundBoxFunc()(n, e))
            ? (e = i)
            : Vg.warn('boundBoxFunc returned falsy. You should return new bound rect from it!')),
          (o = new Rg()).translate(n.x, n.y),
          o.rotate(n.rotation),
          o.scale(n.width / 1e7, n.height / 1e7),
          (r = new Rg()).translate(e.x, e.y),
          r.rotate(e.rotation),
          r.scale(e.width / 1e7, e.height / 1e7)
        const a = r.multiply(o.invert())
        this._nodes.forEach(e => {
          var n = e.getParent().getAbsoluteTransform(),
            r = e.getTransform().copy(),
            i = (r.translate(e.offsetX(), e.offsetY()), new Rg())
          i.multiply(n.copy().invert()).multiply(a).multiply(n).multiply(r), (n = i.decompose())
          e.setAttrs(n),
            this._fire('transform', { evt: t, target: e }),
            e._fire('transform', { evt: t, target: e }),
            null != (r = e.getLayer()) && r.batchDraw()
        }),
          this.rotation(Vg._getRotation(e.rotation)),
          this._resetTransformCache(),
          this.update(),
          this.getLayer().batchDraw()
      }
    }
    forceUpdate() {
      this._resetTransformCache(), this.update()
    }
    _batchChangeChild(e, t) {
      this.findOne(e).setAttrs(t)
    }
    update() {
      var e = this._getNodeRect(),
        t = (this.rotation(Vg._getRotation(e.rotation)), e.width),
        n = ((e = e.height), this.enabledAnchors()),
        r = this.resizeEnabled(),
        i = this.padding(),
        o = this.anchorSize()
      this.find('._anchor').forEach(e => {
        e.setAttrs({
          width: o,
          height: o,
          offsetX: o / 2,
          offsetY: o / 2,
          stroke: this.anchorStroke(),
          strokeWidth: this.anchorStrokeWidth(),
          fill: this.anchorFill(),
          cornerRadius: this.anchorCornerRadius()
        })
      }),
        this._batchChangeChild('.top-left', {
          x: 0,
          y: 0,
          offsetX: o / 2 + i,
          offsetY: o / 2 + i,
          visible: r && 0 <= n.indexOf('top-left')
        }),
        this._batchChangeChild('.top-center', {
          x: t / 2,
          y: 0,
          offsetY: o / 2 + i,
          visible: r && 0 <= n.indexOf('top-center')
        }),
        this._batchChangeChild('.top-right', {
          x: t,
          y: 0,
          offsetX: o / 2 - i,
          offsetY: o / 2 + i,
          visible: r && 0 <= n.indexOf('top-right')
        }),
        this._batchChangeChild('.middle-left', {
          x: 0,
          y: e / 2,
          offsetX: o / 2 + i,
          visible: r && 0 <= n.indexOf('middle-left')
        }),
        this._batchChangeChild('.middle-right', {
          x: t,
          y: e / 2,
          offsetX: o / 2 - i,
          visible: r && 0 <= n.indexOf('middle-right')
        }),
        this._batchChangeChild('.bottom-left', {
          x: 0,
          y: e,
          offsetX: o / 2 + i,
          offsetY: o / 2 - i,
          visible: r && 0 <= n.indexOf('bottom-left')
        }),
        this._batchChangeChild('.bottom-center', {
          x: t / 2,
          y: e,
          offsetY: o / 2 - i,
          visible: r && 0 <= n.indexOf('bottom-center')
        }),
        this._batchChangeChild('.bottom-right', {
          x: t,
          y: e,
          offsetX: o / 2 - i,
          offsetY: o / 2 - i,
          visible: r && 0 <= n.indexOf('bottom-right')
        }),
        this._batchChangeChild('.rotater', {
          x: t / 2,
          y: -this.rotateAnchorOffset() * Vg._sign(e) - i,
          visible: this.rotateEnabled()
        }),
        this._batchChangeChild('.back', {
          width: t,
          height: e,
          visible: this.borderEnabled(),
          stroke: this.borderStroke(),
          strokeWidth: this.borderStrokeWidth(),
          dash: this.borderDash(),
          x: 0,
          y: 0
        }),
        null != (r = this.getLayer()) && r.batchDraw()
    }
    isTransforming() {
      return this._transforming
    }
    stopTransform() {
      var e
      this._transforming && (this._removeEvents(), (e = this.findOne('.' + this._movingAnchorName))) && e.stopDrag()
    }
    destroy() {
      return (
        this.getStage() && this._cursorChange && this.getStage().content && (this.getStage().content.style.cursor = ''),
        Qm.prototype.destroy.call(this),
        this.detach(),
        this._removeEvents(),
        this
      )
    }
    toObject() {
      return wm.prototype.toObject.call(this)
    }
    clone(e) {
      return wm.prototype.clone.call(this, e)
    }
    getClientRect() {
      return 0 < this.nodes().length ? super.getClientRect() : { x: 0, y: 0, width: 0, height: 0 }
    }
  }
  ;(qv.prototype.className = 'Transformer'),
    mg(qv),
    Jg.addGetterSetter(qv, 'enabledAnchors', Xv, function (e) {
      return (
        e instanceof Array || Vg.warn('enabledAnchors value should be an array'),
        e instanceof Array &&
          e.forEach(function (e) {
            ;-1 === Xv.indexOf(e) && Vg.warn('Unknown anchor name: ' + e + '. Available names are: ' + Xv.join(', '))
          }),
        e || []
      )
    }),
    Jg.addGetterSetter(qv, 'flipEnabled', !0, $g()),
    Jg.addGetterSetter(qv, 'resizeEnabled', !0),
    Jg.addGetterSetter(qv, 'anchorSize', 10, Zg()),
    Jg.addGetterSetter(qv, 'rotateEnabled', !0),
    Jg.addGetterSetter(qv, 'rotationSnaps', []),
    Jg.addGetterSetter(qv, 'rotateAnchorOffset', 50, Zg()),
    Jg.addGetterSetter(qv, 'rotationSnapTolerance', 5, Zg()),
    Jg.addGetterSetter(qv, 'borderEnabled', !0),
    Jg.addGetterSetter(qv, 'anchorStroke', 'rgb(0, 161, 255)'),
    Jg.addGetterSetter(qv, 'anchorStrokeWidth', 1, Zg()),
    Jg.addGetterSetter(qv, 'anchorFill', 'white'),
    Jg.addGetterSetter(qv, 'anchorCornerRadius', 0, Zg()),
    Jg.addGetterSetter(qv, 'borderStroke', 'rgb(0, 161, 255)'),
    Jg.addGetterSetter(qv, 'borderStrokeWidth', 1, Zg()),
    Jg.addGetterSetter(qv, 'borderDash'),
    Jg.addGetterSetter(qv, 'keepRatio', !0),
    Jg.addGetterSetter(qv, 'centeredScaling', !1),
    Jg.addGetterSetter(qv, 'ignoreStroke', !1),
    Jg.addGetterSetter(qv, 'padding', 0, Zg()),
    Jg.addGetterSetter(qv, 'node'),
    Jg.addGetterSetter(qv, 'nodes'),
    Jg.addGetterSetter(qv, 'boundBoxFunc'),
    Jg.addGetterSetter(qv, 'anchorDragBoundFunc'),
    Jg.addGetterSetter(qv, 'shouldOverdrawWholeArea', !1),
    Jg.addGetterSetter(qv, 'useSingleNodeRotation', !0),
    Jg.backCompat(qv, {
      lineEnabled: 'borderEnabled',
      rotateHandlerOffset: 'rotateAnchorOffset',
      enabledHandlers: 'enabledAnchors'
    })
  class $v extends Xm {
    _sceneFunc(e) {
      e.beginPath(),
        e.arc(0, 0, this.radius(), 0, jg.getAngle(this.angle()), this.clockwise()),
        e.lineTo(0, 0),
        e.closePath(),
        e.fillStrokeShape(this)
    }
    getWidth() {
      return 2 * this.radius()
    }
    getHeight() {
      return 2 * this.radius()
    }
    setWidth(e) {
      this.radius(e / 2)
    }
    setHeight(e) {
      this.radius(e / 2)
    }
  }
  function Kv() {
    ;(this.r = 0), (this.g = 0), (this.b = 0), (this.a = 0), (this.next = null)
  }
  ;($v.prototype.className = 'Wedge'),
    ($v.prototype._centroid = !0),
    ($v.prototype._attrsAffectingSize = ['radius']),
    mg($v),
    Jg.addGetterSetter($v, 'radius', 0, Zg()),
    Jg.addGetterSetter($v, 'angle', 0, Zg()),
    Jg.addGetterSetter($v, 'clockwise', !1),
    Jg.backCompat($v, { angleDeg: 'angle', getAngleDeg: 'getAngle', setAngleDeg: 'setAngle' })
  var Qv = [
      512, 512, 456, 512, 328, 456, 335, 512, 405, 328, 271, 456, 388, 335, 292, 512, 454, 405, 364, 328, 298, 271, 496,
      456, 420, 388, 360, 335, 312, 292, 273, 512, 482, 454, 428, 405, 383, 364, 345, 328, 312, 298, 284, 271, 259, 496,
      475, 456, 437, 420, 404, 388, 374, 360, 347, 335, 323, 312, 302, 292, 282, 273, 265, 512, 497, 482, 468, 454, 441,
      428, 417, 405, 394, 383, 373, 364, 354, 345, 337, 328, 320, 312, 305, 298, 291, 284, 278, 271, 265, 259, 507, 496,
      485, 475, 465, 456, 446, 437, 428, 420, 412, 404, 396, 388, 381, 374, 367, 360, 354, 347, 341, 335, 329, 323, 318,
      312, 307, 302, 297, 292, 287, 282, 278, 273, 269, 265, 261, 512, 505, 497, 489, 482, 475, 468, 461, 454, 447, 441,
      435, 428, 422, 417, 411, 405, 399, 394, 389, 383, 378, 373, 368, 364, 359, 354, 350, 345, 341, 337, 332, 328, 324,
      320, 316, 312, 309, 305, 301, 298, 294, 291, 287, 284, 281, 278, 274, 271, 268, 265, 262, 259, 257, 507, 501, 496,
      491, 485, 480, 475, 470, 465, 460, 456, 451, 446, 442, 437, 433, 428, 424, 420, 416, 412, 408, 404, 400, 396, 392,
      388, 385, 381, 377, 374, 370, 367, 363, 360, 357, 354, 350, 347, 344, 341, 338, 335, 332, 329, 326, 323, 320, 318,
      315, 312, 310, 307, 304, 302, 299, 297, 294, 292, 289, 287, 285, 282, 280, 278, 275, 273, 271, 269, 267, 265, 263,
      261, 259
    ],
    Jv = [
      9, 11, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18,
      18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20,
      20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21,
      21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22,
      22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23,
      23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23,
      23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
      24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
      24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
      24, 24
    ]
  function ey(e, t, n, r, i) {
    return (i -= r), 0 == (n -= t) ? r + i / 2 : 0 == i ? r : i * ((e - t) / n) + r
  }
  function ty(e, t, n) {
    return (n = 4 * (n * e.width + t)), (t = []).push(e.data[n++], e.data[n++], e.data[n++], e.data[+n]), t
  }
  function ny(e, t) {
    return Math.sqrt(Math.pow(e[0] - t[0], 2) + Math.pow(e[1] - t[1], 2) + Math.pow(e[2] - t[2], 2))
  }
  Jg.addGetterSetter(wm, 'blurRadius', 0, Zg(), Jg.afterSetFilter),
    Jg.addGetterSetter(wm, 'brightness', 0, Zg(), Jg.afterSetFilter),
    Jg.addGetterSetter(wm, 'contrast', 0, Zg(), Jg.afterSetFilter),
    Jg.addGetterSetter(wm, 'embossStrength', 0.5, Zg(), Jg.afterSetFilter),
    Jg.addGetterSetter(wm, 'embossWhiteLevel', 0.5, Zg(), Jg.afterSetFilter),
    Jg.addGetterSetter(wm, 'embossDirection', 'top-left', null, Jg.afterSetFilter),
    Jg.addGetterSetter(wm, 'embossBlend', !1, null, Jg.afterSetFilter),
    Jg.addGetterSetter(wm, 'enhance', 0, Zg(), Jg.afterSetFilter),
    Jg.addGetterSetter(wm, 'hue', 0, Zg(), Jg.afterSetFilter),
    Jg.addGetterSetter(wm, 'saturation', 0, Zg(), Jg.afterSetFilter),
    Jg.addGetterSetter(wm, 'luminance', 0, Zg(), Jg.afterSetFilter),
    Jg.addGetterSetter(wm, 'hue', 0, Zg(), Jg.afterSetFilter),
    Jg.addGetterSetter(wm, 'saturation', 0, Zg(), Jg.afterSetFilter),
    Jg.addGetterSetter(wm, 'value', 0, Zg(), Jg.afterSetFilter),
    Jg.addGetterSetter(wm, 'kaleidoscopePower', 2, Zg(), Jg.afterSetFilter),
    Jg.addGetterSetter(wm, 'kaleidoscopeAngle', 0, Zg(), Jg.afterSetFilter),
    Jg.addGetterSetter(wm, 'threshold', 0, Zg(), Jg.afterSetFilter),
    Jg.addGetterSetter(wm, 'noise', 0.2, Zg(), Jg.afterSetFilter),
    Jg.addGetterSetter(wm, 'pixelSize', 8, Zg(), Jg.afterSetFilter),
    Jg.addGetterSetter(wm, 'levels', 0.5, Zg(), Jg.afterSetFilter),
    Jg.addGetterSetter(wm, 'red', 0, function (e) {
      return (this._filterUpToDate = !1), 255 < e ? 255 : e < 0 ? 0 : Math.round(e)
    }),
    Jg.addGetterSetter(wm, 'green', 0, function (e) {
      return (this._filterUpToDate = !1), 255 < e ? 255 : e < 0 ? 0 : Math.round(e)
    }),
    Jg.addGetterSetter(wm, 'blue', 0, Gg, Jg.afterSetFilter),
    Jg.addGetterSetter(wm, 'red', 0, function (e) {
      return (this._filterUpToDate = !1), 255 < e ? 255 : e < 0 ? 0 : Math.round(e)
    }),
    Jg.addGetterSetter(wm, 'green', 0, function (e) {
      return (this._filterUpToDate = !1), 255 < e ? 255 : e < 0 ? 0 : Math.round(e)
    }),
    Jg.addGetterSetter(wm, 'blue', 0, Gg, Jg.afterSetFilter),
    Jg.addGetterSetter(wm, 'alpha', 1, function (e) {
      return (this._filterUpToDate = !1), 1 < e ? 1 : e < 0 ? 0 : e
    }),
    Jg.addGetterSetter(wm, 'threshold', 0.5, Zg(), Jg.afterSetFilter)
  const ry = lv.Util._assign(lv, {
    Arc: sv,
    Arrow: hv,
    Circle: pv,
    Ellipse: gv,
    Image: mv,
    Label: xv,
    Tag: Ev,
    Line: dv,
    Path: fv,
    Rect: Sv,
    RegularPolygon: Ov,
    Ring: Pv,
    Sprite: _v,
    Star: Lv,
    Text: zv,
    TextPath: Hv,
    Transformer: qv,
    Wedge: $v,
    Filters: {
      Blur: function (e) {
        var t = Math.round(this.blurRadius())
        if (0 < t) {
          for (
            var n,
              r,
              i,
              o,
              a,
              l,
              s,
              c,
              u,
              d,
              f,
              h,
              p,
              g,
              m,
              v,
              y,
              b,
              w,
              C,
              x,
              E,
              S,
              O = t,
              k = e.data,
              P = e.width,
              _ = e.height,
              L = O + O + 1,
              T = P - 1,
              I = _ - 1,
              M = O + 1,
              j = (M * (M + 1)) / 2,
              R = new Kv(),
              D = null,
              A = R,
              z = null,
              N = null,
              F = Qv[O],
              H = Jv[O],
              B = 1;
            B < L;
            B++
          )
            (A = A.next = new Kv()), B === M && (D = A)
          for (A.next = R, r = l = a = 0; r < _; r++) {
            for (
              m = v = y = b = s = c = u = d = 0,
                f = M * (w = k[a]),
                h = M * (C = k[a + 1]),
                p = M * (x = k[a + 2]),
                g = M * (E = k[a + 3]),
                s += j * w,
                c += j * C,
                u += j * x,
                d += j * E,
                A = R,
                B = 0;
              B < M;
              B++
            )
              (A.r = w), (A.g = C), (A.b = x), (A.a = E), (A = A.next)
            for (B = 1; B < M; B++)
              (s += (A.r = w = k[(i = a + ((T < B ? T : B) << 2))]) * (S = M - B)),
                (c += (A.g = C = k[i + 1]) * S),
                (u += (A.b = x = k[i + 2]) * S),
                (d += (A.a = E = k[i + 3]) * S),
                (m += w),
                (v += C),
                (y += x),
                (b += E),
                (A = A.next)
            for (z = R, N = D, n = 0; n < P; n++)
              (k[a + 3] = E = (d * F) >> H),
                0 !== E
                  ? ((k[a] = ((s * F) >> H) * (E = 255 / E)),
                    (k[a + 1] = ((c * F) >> H) * E),
                    (k[a + 2] = ((u * F) >> H) * E))
                  : (k[a] = k[a + 1] = k[a + 2] = 0),
                (s -= f),
                (c -= h),
                (u -= p),
                (d -= g),
                (f -= z.r),
                (h -= z.g),
                (p -= z.b),
                (g -= z.a),
                (i = (l + ((i = n + O + 1) < T ? i : T)) << 2),
                (s += m += z.r = k[i]),
                (c += v += z.g = k[i + 1]),
                (u += y += z.b = k[i + 2]),
                (d += b += z.a = k[i + 3]),
                (z = z.next),
                (f += w = N.r),
                (h += C = N.g),
                (p += x = N.b),
                (g += E = N.a),
                (m -= w),
                (v -= C),
                (y -= x),
                (b -= E),
                (N = N.next),
                (a += 4)
            l += P
          }
          for (n = 0; n < P; n++) {
            for (
              v = y = b = m = c = u = d = s = 0,
                f = M * (w = k[(a = n << 2)]),
                h = M * (C = k[a + 1]),
                p = M * (x = k[a + 2]),
                g = M * (E = k[a + 3]),
                s += j * w,
                c += j * C,
                u += j * x,
                d += j * E,
                A = R,
                B = 0;
              B < M;
              B++
            )
              (A.r = w), (A.g = C), (A.b = x), (A.a = E), (A = A.next)
            for (o = P, B = 1; B <= O; B++)
              (s += (A.r = w = k[(a = (o + n) << 2)]) * (S = M - B)),
                (c += (A.g = C = k[a + 1]) * S),
                (u += (A.b = x = k[a + 2]) * S),
                (d += (A.a = E = k[a + 3]) * S),
                (m += w),
                (v += C),
                (y += x),
                (b += E),
                (A = A.next),
                B < I && (o += P)
            for (a = n, z = R, N = D, r = 0; r < _; r++)
              (k[3 + (i = a << 2)] = E = (d * F) >> H),
                0 < E
                  ? ((k[i] = ((s * F) >> H) * (E = 255 / E)),
                    (k[i + 1] = ((c * F) >> H) * E),
                    (k[i + 2] = ((u * F) >> H) * E))
                  : (k[i] = k[i + 1] = k[i + 2] = 0),
                (s -= f),
                (c -= h),
                (u -= p),
                (d -= g),
                (f -= z.r),
                (h -= z.g),
                (p -= z.b),
                (g -= z.a),
                (i = (n + ((i = r + M) < I ? i : I) * P) << 2),
                (s += m += z.r = k[i]),
                (c += v += z.g = k[i + 1]),
                (u += y += z.b = k[i + 2]),
                (d += b += z.a = k[i + 3]),
                (z = z.next),
                (f += w = N.r),
                (h += C = N.g),
                (p += x = N.b),
                (g += E = N.a),
                (m -= w),
                (v -= C),
                (y -= x),
                (b -= E),
                (N = N.next),
                (a += P)
          }
        }
      },
      Brighten: function (e) {
        for (var t = 255 * this.brightness(), n = e.data, r = n.length, i = 0; i < r; i += 4)
          (n[i] += t), (n[i + 1] += t), (n[i + 2] += t)
      },
      Contrast: function (e) {
        for (
          var t = Math.pow((this.contrast() + 100) / 100, 2),
            n = e.data,
            r = n.length,
            i = 150,
            o = 150,
            a = 150,
            l = 0;
          l < r;
          l += 4
        )
          (i = n[l]),
            (o = n[l + 1]),
            (a = n[l + 2]),
            (i = 255 * (((i /= 255) - 0.5) * t + 0.5)),
            (o = (o = 255 * (0.5 + (o = ((o /= 255) - 0.5) * t))) < 0 ? 0 : 255 < o ? 255 : o),
            (a = (a = 255 * (0.5 + (a = ((a /= 255) - 0.5) * t))) < 0 ? 0 : 255 < a ? 255 : a),
            (n[l] = i = i < 0 ? 0 : 255 < i ? 255 : i),
            (n[l + 1] = o),
            (n[l + 2] = a)
      },
      Emboss: function (e) {
        var t = 10 * this.embossStrength(),
          n = 255 * this.embossWhiteLevel(),
          r = this.embossDirection(),
          i = this.embossBlend(),
          o = 0,
          a = 0,
          l = e.data,
          s = e.width,
          c = e.height,
          u = 4 * s,
          d = c
        switch (r) {
          case 'top-left':
            a = o = -1
            break
          case 'top':
            ;(o = -1), (a = 0)
            break
          case 'top-right':
            ;(o = -1), (a = 1)
            break
          case 'right':
            ;(o = 0), (a = 1)
            break
          case 'bottom-right':
            a = o = 1
            break
          case 'bottom':
            ;(o = 1), (a = 0)
            break
          case 'bottom-left':
            a = -(o = 1)
            break
          case 'left':
            ;(o = 0), (a = -1)
            break
          default:
            Vg.error('Unknown emboss direction: ' + r)
        }
        do {
          var f = (d - 1) * u,
            h = o,
            p = (d - 1 + (h = c < d + (h = d + o < 1 ? 0 : o) ? 0 : h)) * s * 4,
            g = s
          do {
            var m = f + 4 * (g - 1),
              v = a,
              y = ((v = p + 4 * (g - 1 + (v = s < g + (v = g + a < 1 ? 0 : a) ? 0 : v))), l[m] - l[v]),
              b = l[1 + m] - l[1 + v],
              w = ((v = l[2 + m] - l[2 + v]), 0 < y ? y : -y)
          } while (
            (w < (0 < b ? b : -b) && (y = b),
            w < (0 < v ? v : -v) && (y = v),
            (y *= t),
            i
              ? ((b = l[m] + y),
                (w = l[1 + m] + y),
                (v = l[2 + m] + y),
                (l[m] = 255 < b ? 255 : b < 0 ? 0 : b),
                (l[1 + m] = 255 < w ? 255 : w < 0 ? 0 : w),
                (l[2 + m] = 255 < v ? 255 : v < 0 ? 0 : v))
              : ((b = n - y) < 0 ? (b = 0) : 255 < b && (b = 255), (l[m] = l[1 + m] = l[2 + m] = b)),
            --g)
          )
        } while (--d)
      },
      Enhance: function (e) {
        var t,
          n,
          r,
          i,
          o,
          a,
          l,
          s,
          c,
          u = e.data,
          d = u.length,
          f = u[0],
          h = f,
          p = u[1],
          g = p,
          m = u[2],
          v = m
        if (0 !== (e = this.enhance())) {
          for (n = 0; n < d; n += 4)
            (t = u[n + 0]) < f ? (f = t) : h < t && (h = t),
              (t = u[n + 1]) < p ? (p = t) : g < t && (g = t),
              (t = u[n + 2]) < m ? (m = t) : v < t && (v = t)
          for (
            h === f && ((h = 255), (f = 0)),
              g === p && ((g = 255), (p = 0)),
              v === m && ((v = 255), (m = 0)),
              c =
                0 < e
                  ? ((r = h + e * (255 - h)),
                    (i = f - e * +f),
                    (o = g + e * (255 - g)),
                    (a = p - e * +p),
                    (s = v + e * (255 - v)),
                    m - e * +m)
                  : ((r = h + e * (h - (l = 0.5 * (h + f)))),
                    (i = f + e * (f - l)),
                    (o = g + e * (g - (l = 0.5 * (g + p)))),
                    (a = p + e * (p - l)),
                    (s = v + e * (v - (l = 0.5 * (v + m)))),
                    m + e * (m - l)),
              n = 0;
            n < d;
            n += 4
          )
            (u[n + 0] = ey(u[n + 0], f, h, i, r)),
              (u[n + 1] = ey(u[n + 1], p, g, a, o)),
              (u[n + 2] = ey(u[n + 2], m, v, c, s))
        }
      },
      Grayscale: function (e) {
        for (var t, n = e.data, r = n.length, i = 0; i < r; i += 4)
          (t = 0.34 * n[i] + 0.5 * n[i + 1] + 0.16 * n[i + 2]), (n[i] = t), (n[i + 1] = t), (n[i + 2] = t)
      },
      HSL: function (e) {
        for (
          var t,
            n,
            r,
            i,
            o = e.data,
            a = o.length,
            l = ((e = Math.pow(2, this.saturation())), Math.abs(this.hue() + 360) % 360),
            s = 127 * this.luminance(),
            c = +e * Math.cos((l * Math.PI) / 180),
            u = 0.299 + 0.701 * c + 0.167 * (e = +e * Math.sin((l * Math.PI) / 180)),
            d = 0.587 - 0.587 * c + 0.33 * e,
            f = 0.114 - 0.114 * c - 0.497 * e,
            h = 0.299 - 0.299 * c - 0.328 * e,
            p = 0.587 + 0.413 * c + 0.035 * e,
            g = 0.114 - 0.114 * c + 0.293 * e,
            m = 0.299 - 0.3 * c + 1.25 * e,
            v = 0.587 - 0.586 * c - 1.05 * e,
            y = 0.114 + 0.886 * c - 0.2 * e,
            b = 0;
          b < a;
          b += 4
        )
          (t = o[b + 0]),
            (n = o[b + 1]),
            (r = o[b + 2]),
            (i = o[b + 3]),
            (o[b + 0] = u * t + d * n + f * r + s),
            (o[b + 1] = h * t + p * n + g * r + s),
            (o[b + 2] = m * t + v * n + y * r + s),
            (o[b + 3] = i)
      },
      HSV: function (e) {
        for (
          var t,
            n,
            r,
            i,
            o = e.data,
            a = o.length,
            l = ((e = Math.pow(2, this.value())), Math.pow(2, this.saturation())),
            s = Math.abs(this.hue() + 360) % 360,
            c = e * l * Math.cos((s * Math.PI) / 180),
            u = 0.299 * e + 0.701 * c + 0.167 * (l = e * l * Math.sin((s * Math.PI) / 180)),
            d = 0.587 * e - 0.587 * c + 0.33 * l,
            f = 0.114 * e - 0.114 * c - 0.497 * l,
            h = 0.299 * e - 0.299 * c - 0.328 * l,
            p = 0.587 * e + 0.413 * c + 0.035 * l,
            g = 0.114 * e - 0.114 * c + 0.293 * l,
            m = 0.299 * e - 0.3 * c + 1.25 * l,
            v = 0.587 * e - 0.586 * c - 1.05 * l,
            y = 0.114 * e + 0.886 * c - 0.2 * l,
            b = 0;
          b < a;
          b += 4
        )
          (t = o[b + 0]),
            (n = o[b + 1]),
            (r = o[b + 2]),
            (i = o[b + 3]),
            (o[b + 0] = u * t + d * n + f * r),
            (o[b + 1] = h * t + p * n + g * r),
            (o[b + 2] = m * t + v * n + y * r),
            (o[b + 3] = i)
      },
      Invert: function (e) {
        for (var t = e.data, n = t.length, r = 0; r < n; r += 4)
          (t[r] = 255 - t[r]), (t[r + 1] = 255 - t[r + 1]), (t[r + 2] = 255 - t[r + 2])
      },
      Kaleidoscope: function (e) {
        var t,
          n,
          r,
          i,
          o,
          a,
          l,
          s,
          c,
          u,
          d = e.width,
          f = e.height,
          h = Math.round(this.kaleidoscopePower()),
          p = Math.round(this.kaleidoscopeAngle()),
          g = Math.floor((d * (p % 360)) / 360)
        if (!(h < 1)) {
          var m =
            (((p = Vg.createCanvasElement()).width = d), (p.height = f), p.getContext('2d').getImageData(0, 0, d, f))
          Vg.releaseCanvas(p)
          p = m
          for (
            var v,
              y,
              b,
              w,
              C,
              x,
              E,
              S,
              O = { polarCenterX: d / 2, polarCenterY: f / 2 },
              k = (M = e).data,
              P = p.data,
              _ = M.width,
              L = ((p = M.height), O.polarCenterX || _ / 2),
              T = O.polarCenterY || p / 2,
              I = _ - L,
              M = p - T,
              j = (j = Math.sqrt(L * L + T * T)) < (O = Math.sqrt(I * I + M * M)) ? O : j,
              R = p,
              D = _,
              A = ((360 / D) * Math.PI) / 180,
              z = 0;
            z < D;
            z += 1
          )
            for (E = Math.sin(z * A), S = Math.cos(z * A), x = 0; x < R; x += 1)
              (I = Math.floor(L + ((j * x) / R) * S)),
                (y = k[0 + (v = 4 * (Math.floor(T + ((j * x) / R) * E) * _ + I))]),
                (b = k[1 + v]),
                (w = k[2 + v]),
                (C = k[3 + v]),
                (P[0 + (v = 4 * (z + x * _))] = y),
                (P[1 + v] = b),
                (P[2 + v] = w),
                (P[3 + v] = C)
          for (var N = d / Math.pow(2, h); N <= 8; ) (N *= 2), --h
          var F = (N = Math.ceil(N)),
            H = 0,
            B = F,
            V = 1
          for (d < g + N && ((H = F), (B = 0), (V = -1)), n = 0; n < f; n += 1)
            for (t = H; t !== B; t += V)
              (r = Math.round(t + g) % d),
                (o = m.data[0 + (c = 4 * (d * n + r))]),
                (a = m.data[c + 1]),
                (l = m.data[c + 2]),
                (s = m.data[c + 3]),
                (m.data[0 + (u = 4 * (d * n + t))] = o),
                (m.data[u + 1] = a),
                (m.data[u + 2] = l),
                (m.data[u + 3] = s)
          for (n = 0; n < f; n += 1)
            for (F = Math.floor(N), i = 0; i < h; i += 1) {
              for (t = 0; t < F + 1; t += 1)
                (o = m.data[0 + (c = 4 * (d * n + t))]),
                  (a = m.data[c + 1]),
                  (l = m.data[c + 2]),
                  (s = m.data[c + 3]),
                  (m.data[0 + (u = 4 * (d * n + 2 * F - t - 1))] = o),
                  (m.data[u + 1] = a),
                  (m.data[u + 2] = l),
                  (m.data[u + 3] = s)
              F *= 2
            }
          ;(O = e), (p = { polarRotation: 0 })
          var W,
            G,
            Z,
            U,
            X,
            Y = (M = m).data,
            q = O.data,
            $ = M.width,
            K = M.height,
            Q = p.polarCenterX || $ / 2,
            J = p.polarCenterY || K / 2,
            ee = $ - Q,
            te = K - J,
            ne = (ne = Math.sqrt(Q * Q + J * J)) < (O = Math.sqrt(ee * ee + te * te)) ? O : ne,
            re = K,
            ie = $,
            oe = p.polarRotation || 0
          for (ee = 0; ee < $; ee += 1)
            for (te = 0; te < K; te += 1)
              (X = ee - Q),
                (U = te - J),
                (Z = (Math.sqrt(X * X + U * U) * re) / ne),
                (U = ((180 * Math.atan2(U, X)) / Math.PI + 360 + oe) % 360),
                (X = Math.floor((U * ie) / 360)),
                (Z = Y[0 + (U = 4 * (Math.floor(Z) * $ + X))]),
                (X = Y[1 + U]),
                (W = Y[2 + U]),
                (G = Y[3 + U]),
                (q[0 + (U = 4 * (te * $ + ee))] = Z),
                (q[1 + U] = X),
                (q[2 + U] = W),
                (q[3 + U] = G)
        }
      },
      Mask: function (e) {
        if (
          (t = (function (e, t) {
            var n = ty(e, 0, 0),
              r = ty(e, e.width - 1, 0),
              i = ty(e, 0, e.height - 1),
              o = ty(e, e.width - 1, e.height - 1),
              a = t || 10
            if (ny(n, r) < a && ny(r, o) < a && ny(o, i) < a && ny(i, n) < a) {
              for (
                var l = (function (e) {
                    for (var t = [0, 0, 0], n = 0; n < e.length; n++)
                      (t[0] += e[n][0]), (t[1] += e[n][1]), (t[2] += e[n][2])
                    return (t[0] /= e.length), (t[1] /= e.length), (t[2] /= e.length), t
                  })([r, n, o, i]),
                  s = [],
                  c = 0;
                c < e.width * e.height;
                c++
              ) {
                var u = ny(l, [e.data[4 * c], e.data[4 * c + 1], e.data[4 * c + 2]])
                s[c] = u < a ? 0 : 255
              }
              return s
            }
          })(e, this.threshold()))
        )
          for (
            var t = (function (e, t, n) {
                for (
                  var r = [1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9],
                    i = Math.round(Math.sqrt(r.length)),
                    o = Math.floor(i / 2),
                    a = [],
                    l = 0;
                  l < n;
                  l++
                )
                  for (var s = 0; s < t; s++) {
                    for (var c = l * t + s, u = 0, d = 0; d < i; d++)
                      for (var f = 0; f < i; f++) {
                        var h = l + d - o,
                          p = s + f - o
                        0 <= h && h < n && 0 <= p && p < t && (u += e[h * t + p] * r[d * i + f])
                      }
                    a[c] = u
                  }
                return a
              })(
                (function (e, t, n) {
                  for (
                    var r = [1, 1, 1, 1, 1, 1, 1, 1, 1],
                      i = Math.round(Math.sqrt(r.length)),
                      o = Math.floor(i / 2),
                      a = [],
                      l = 0;
                    l < n;
                    l++
                  )
                    for (var s = 0; s < t; s++) {
                      for (var c = l * t + s, u = 0, d = 0; d < i; d++)
                        for (var f = 0; f < i; f++) {
                          var h = l + d - o,
                            p = s + f - o
                          0 <= h && h < n && 0 <= p && p < t && (u += e[h * t + p] * r[d * i + f])
                        }
                      a[c] = 1020 <= u ? 255 : 0
                    }
                  return a
                })(
                  (function (e, t, n) {
                    for (
                      var r = [1, 1, 1, 1, 0, 1, 1, 1, 1],
                        i = Math.round(Math.sqrt(r.length)),
                        o = Math.floor(i / 2),
                        a = [],
                        l = 0;
                      l < n;
                      l++
                    )
                      for (var s = 0; s < t; s++) {
                        for (var c = l * t + s, u = 0, d = 0; d < i; d++)
                          for (var f = 0; f < i; f++) {
                            var h = l + d - o,
                              p = s + f - o
                            0 <= h && h < n && 0 <= p && p < t && (u += e[h * t + p] * r[d * i + f])
                          }
                        a[c] = 2040 === u ? 255 : 0
                      }
                    return a
                  })(t, e.width, e.height),
                  e.width,
                  e.height
                ),
                e.width,
                e.height
              ),
              n = e,
              r = t,
              i = 0;
            i < n.width * n.height;
            i++
          )
            n.data[4 * i + 3] = r[i]
        return e
      },
      Noise: function (e) {
        for (var t = 255 * this.noise(), n = e.data, r = n.length, i = t / 2, o = 0; o < r; o += 4)
          (n[o + 0] += i - 2 * i * Math.random()),
            (n[o + 1] += i - 2 * i * Math.random()),
            (n[o + 2] += i - 2 * i * Math.random())
      },
      Pixelate: function (e) {
        var t,
          n,
          r,
          i,
          o,
          a,
          l,
          s,
          c,
          u,
          d,
          f,
          h,
          p,
          g = Math.ceil(this.pixelSize()),
          m = e.width,
          v = e.height,
          y = Math.ceil(m / g),
          b = Math.ceil(v / g),
          w = e.data
        if (g <= 0) Vg.error('pixelSize value can not be <= 0')
        else
          for (f = 0; f < y; f += 1)
            for (h = 0; h < b; h += 1) {
              for (c = (s = f * g) + g, d = (u = h * g) + g, p = l = a = o = i = 0, t = s; t < c; t += 1)
                if (!(m <= t))
                  for (n = u; n < d; n += 1)
                    v <= n ||
                      ((i += w[0 + (r = 4 * (m * n + t))]), (o += w[r + 1]), (a += w[r + 2]), (l += w[r + 3]), (p += 1))
              for (i /= p, o /= p, a /= p, l /= p, t = s; t < c; t += 1)
                if (!(m <= t))
                  for (n = u; n < d; n += 1)
                    v <= n || ((w[0 + (r = 4 * (m * n + t))] = i), (w[r + 1] = o), (w[r + 2] = a), (w[r + 3] = l))
            }
      },
      Posterize: function (e) {
        for (var t = Math.round(254 * this.levels()) + 1, n = e.data, r = n.length, i = 255 / t, o = 0; o < r; o += 1)
          n[o] = Math.floor(n[o] / i) * i
      },
      RGB: function (e) {
        for (var t, n = e.data, r = n.length, i = this.red(), o = this.green(), a = this.blue(), l = 0; l < r; l += 4)
          (t = (0.34 * n[l] + 0.5 * n[l + 1] + 0.16 * n[l + 2]) / 255),
            (n[l] = t * i),
            (n[l + 1] = t * o),
            (n[l + 2] = t * a),
            (n[l + 3] = n[l + 3])
      },
      RGBA: function (e) {
        for (
          var t, n = e.data, r = n.length, i = this.red(), o = this.green(), a = this.blue(), l = this.alpha(), s = 0;
          s < r;
          s += 4
        )
          (n[s] = i * l + n[s] * (t = 1 - l)), (n[s + 1] = o * l + n[s + 1] * t), (n[s + 2] = a * l + n[s + 2] * t)
      },
      Sepia: function (e) {
        for (var t, n, r, i = e.data, o = i.length, a = 0; a < o; a += 4)
          (t = i[a + 0]),
            (n = i[a + 1]),
            (r = i[a + 2]),
            (i[a + 0] = Math.min(255, 0.393 * t + 0.769 * n + 0.189 * r)),
            (i[a + 1] = Math.min(255, 0.349 * t + 0.686 * n + 0.168 * r)),
            (i[a + 2] = Math.min(255, 0.272 * t + 0.534 * n + 0.131 * r))
      },
      Solarize: function (e) {
        var t = e.data,
          n = e.width,
          r = 4 * n,
          i = e.height
        do {
          var o = (i - 1) * r,
            a = n
          do {
            var l = o + 4 * (a - 1),
              s = t[l],
              c = t[1 + l],
              u = t[2 + l]
          } while (
            (127 < s && (s = 255 - s),
            127 < c && (c = 255 - c),
            127 < u && (u = 255 - u),
            (t[l] = s),
            (t[1 + l] = c),
            (t[2 + l] = u),
            --a)
          )
        } while (--i)
      },
      Threshold: function (e) {
        for (var t = 255 * this.threshold(), n = e.data, r = n.length, i = 0; i < r; i += 1) n[i] = n[i] < t ? 0 : 255
      }
    }
  })
  ;((y = { exports: {} }).exports = function (e) {
    var t = {},
      n = s.exports,
      r = fe.exports,
      i = Object.assign
    function o(e) {
      for (var t = 'https://reactjs.org/docs/error-decoder.html?invariant=' + e, n = 1; n < arguments.length; n++)
        t += '&args[]=' + encodeURIComponent(arguments[n])
      return (
        'Minified React error #' +
        e +
        '; visit ' +
        t +
        ' for the full message or use the non-minified dev environment for full errors and additional helpful warnings.'
      )
    }
    var a = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
      l = Symbol.for('react.element'),
      c = Symbol.for('react.portal'),
      u = Symbol.for('react.fragment'),
      d = Symbol.for('react.strict_mode'),
      f = Symbol.for('react.profiler'),
      h = Symbol.for('react.provider'),
      p = Symbol.for('react.context'),
      g = Symbol.for('react.forward_ref'),
      m = Symbol.for('react.suspense'),
      v = Symbol.for('react.suspense_list'),
      y = Symbol.for('react.memo'),
      b = Symbol.for('react.lazy'),
      w = Symbol.for('react.offscreen'),
      C = Symbol.iterator
    function x(e) {
      return null !== e && 'object' == typeof e && 'function' == typeof (e = (C && e[C]) || e['@@iterator']) ? e : null
    }
    function E(e) {
      if (null != e) {
        if ('function' == typeof e) return e.displayName || e.name || null
        if ('string' == typeof e) return e
        switch (e) {
          case u:
            return 'Fragment'
          case c:
            return 'Portal'
          case f:
            return 'Profiler'
          case d:
            return 'StrictMode'
          case m:
            return 'Suspense'
          case v:
            return 'SuspenseList'
        }
        if ('object' == typeof e)
          switch (e.$$typeof) {
            case p:
              return (e.displayName || 'Context') + '.Consumer'
            case h:
              return (e._context.displayName || 'Context') + '.Provider'
            case g:
              var t = e.render
              return (e = e.displayName)
                ? e
                : '' !== (e = t.displayName || t.name || '')
                ? 'ForwardRef(' + e + ')'
                : 'ForwardRef'
            case y:
              return null !== (t = e.displayName || null) ? t : E(e.type) || 'Memo'
            case b:
              ;(t = e._payload), (e = e._init)
              try {
                return E(e(t))
              } catch (n) {}
          }
      }
      return null
    }
    function S(e) {
      var t = e,
        n = e
      if (e.alternate) for (; t.return; ) t = t.return
      else for (e = t; 0 != (4098 & (t = e).flags) && (n = t.return), (e = t.return); );
      return 3 === t.tag ? n : null
    }
    function O(e) {
      if (S(e) !== e) throw Error(o(188))
    }
    function k(e) {
      var t = e.alternate
      if (!t) {
        if (null === (t = S(e))) throw Error(o(188))
        return t !== e ? null : e
      }
      for (var n = e, r = t; ; ) {
        var i = n.return
        if (null === i) break
        var a = i.alternate
        if (null === a) {
          if (null === (r = i.return)) break
          n = r
        } else {
          if (i.child === a.child) {
            for (a = i.child; a; ) {
              if (a === n) return O(i), e
              if (a === r) return O(i), t
              a = a.sibling
            }
            throw Error(o(188))
          }
          if (n.return !== r.return) (n = i), (r = a)
          else {
            for (var l = !1, s = i.child; s; ) {
              if (s === n) {
                ;(l = !0), (n = i), (r = a)
                break
              }
              if (s === r) {
                ;(l = !0), (r = i), (n = a)
                break
              }
              s = s.sibling
            }
            if (!l) {
              for (s = a.child; s; ) {
                if (s === n) {
                  ;(l = !0), (n = a), (r = i)
                  break
                }
                if (s === r) {
                  ;(l = !0), (r = a), (n = i)
                  break
                }
                s = s.sibling
              }
              if (!l) throw Error(o(189))
            }
          }
          if (n.alternate !== r) throw Error(o(190))
        }
      }
      if (3 !== n.tag) throw Error(o(188))
      return n.stateNode.current === n ? e : t
    }
    function P(e) {
      return null !== (e = k(e))
        ? (function e(t) {
            if (5 === t.tag || 6 === t.tag) return t
            for (t = t.child; null !== t; ) {
              var n = e(t)
              if (null !== n) return n
              t = t.sibling
            }
            return null
          })(e)
        : null
    }
    var _,
      L = Array.isArray,
      T = e.getPublicInstance,
      I = e.getRootHostContext,
      M = e.getChildHostContext,
      j = e.prepareForCommit,
      R = e.resetAfterCommit,
      D = e.createInstance,
      A = e.appendInitialChild,
      z = e.finalizeInitialChildren,
      N = e.prepareUpdate,
      F = e.shouldSetTextContent,
      H = e.createTextInstance,
      B = e.scheduleTimeout,
      V = e.cancelTimeout,
      W = e.noTimeout,
      G = e.isPrimaryRenderer,
      Z = e.supportsMutation,
      U = e.supportsPersistence,
      X = e.supportsHydration,
      Y = e.getInstanceFromNode,
      q = e.preparePortalMount,
      $ = e.getCurrentEventPriority,
      K = e.detachDeletedInstance,
      Q = e.supportsMicrotasks,
      J = e.scheduleMicrotask,
      ee = e.supportsTestSelectors,
      te = e.findFiberRoot,
      ne = e.getBoundingRect,
      re = e.getTextContent,
      ie = e.isHiddenSubtree,
      oe = e.matchAccessibilityRole,
      ae = e.setFocusIfFocusable,
      le = e.setupIntersectionObserver,
      se = e.appendChild,
      ce = e.appendChildToContainer,
      ue = e.commitTextUpdate,
      de = e.commitMount,
      he = e.commitUpdate,
      pe = e.insertBefore,
      ge = e.insertInContainerBefore,
      me = e.removeChild,
      ve = e.removeChildFromContainer,
      ye = e.resetTextContent,
      be = e.hideInstance,
      we = e.hideTextInstance,
      Ce = e.unhideInstance,
      xe = e.unhideTextInstance,
      Ee = e.clearContainer,
      Se = e.cloneInstance,
      Oe = e.createContainerChildSet,
      ke = e.appendChildToContainerChildSet,
      Pe = e.finalizeContainerChildren,
      _e = e.replaceContainerChildren,
      Le = e.cloneHiddenInstance,
      Te = e.cloneHiddenTextInstance,
      Ie = e.canHydrateInstance,
      Me = e.canHydrateTextInstance,
      je = e.canHydrateSuspenseInstance,
      Re = e.isSuspenseInstancePending,
      De = e.isSuspenseInstanceFallback,
      Ae = e.getSuspenseInstanceFallbackErrorDetails,
      ze = e.registerSuspenseInstanceRetry,
      Ne = e.getNextHydratableSibling,
      Fe = e.getFirstHydratableChild,
      He = e.getFirstHydratableChildWithinContainer,
      Be = e.getFirstHydratableChildWithinSuspenseInstance,
      Ve = e.hydrateInstance,
      We = e.hydrateTextInstance,
      Ge = e.hydrateSuspenseInstance,
      Ze = e.getNextHydratableInstanceAfterSuspenseInstance,
      Ue = e.commitHydratedContainer,
      Xe = e.commitHydratedSuspenseInstance,
      Ye = e.clearSuspenseBoundary,
      qe = e.clearSuspenseBoundaryFromContainer,
      $e = e.shouldDeleteUnhydratedTailInstances,
      Ke = e.didNotMatchHydratedContainerTextInstance,
      Qe = e.didNotMatchHydratedTextInstance
    function Je(e) {
      if (void 0 === _)
        try {
          throw Error()
        } catch (n) {
          var t = n.stack.trim().match(/\n( *(at )?)/)
          _ = (t && t[1]) || ''
        }
      return '\n' + _ + e
    }
    var et = !1
    function tt(e, t) {
      if (!e || et) return ''
      et = !0
      var n = Error.prepareStackTrace
      Error.prepareStackTrace = void 0
      try {
        if (t)
          if (
            ((t = function () {
              throw Error()
            }),
            Object.defineProperty(t.prototype, 'props', {
              set: function () {
                throw Error()
              }
            }),
            'object' == typeof Reflect && Reflect.construct)
          ) {
            try {
              Reflect.construct(t, [])
            } catch (c) {
              var r = c
            }
            Reflect.construct(e, [], t)
          } else {
            try {
              t.call()
            } catch (c) {
              r = c
            }
            e.call(t.prototype)
          }
        else {
          try {
            throw Error()
          } catch (c) {
            r = c
          }
          e()
        }
      } catch (c) {
        if (c && r && 'string' == typeof c.stack) {
          for (
            var i, o = c.stack.split('\n'), a = r.stack.split('\n'), l = o.length - 1, s = a.length - 1;
            1 <= l && 0 <= s && o[l] !== a[s];

          )
            s--
          for (; 1 <= l && 0 <= s; l--, s--)
            if (o[l] !== a[s]) {
              if (1 !== l || 1 !== s)
                do {
                  if ((l--, --s < 0 || o[l] !== a[s]))
                    return (
                      (i = '\n' + o[l].replace(' at new ', ' at ')),
                      (i = e.displayName && i.includes('<anonymous>') ? i.replace('<anonymous>', e.displayName) : i)
                    )
                } while (1 <= l && 0 <= s)
              break
            }
        }
      } finally {
        ;(et = !1), (Error.prepareStackTrace = n)
      }
      return (e = e ? e.displayName || e.name : '') ? Je(e) : ''
    }
    var nt = Object.prototype.hasOwnProperty,
      rt = [],
      it = -1
    function ot(e) {
      return { current: e }
    }
    function at(e) {
      it < 0 || ((e.current = rt[it]), (rt[it] = null), it--)
    }
    function lt(e, t) {
      ;(rt[++it] = e.current), (e.current = t)
    }
    var st = {},
      ct = ot(st),
      ut = ot(!1),
      dt = st
    function ft(e, t) {
      var n = e.type.contextTypes
      if (!n) return st
      var r = e.stateNode
      if (r && r.__reactInternalMemoizedUnmaskedChildContext === t) return r.__reactInternalMemoizedMaskedChildContext
      var i,
        o = {}
      for (i in n) o[i] = t[i]
      return (
        r &&
          (((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = t),
          (e.__reactInternalMemoizedMaskedChildContext = o)),
        o
      )
    }
    function ht(e) {
      return null != e.childContextTypes
    }
    function pt() {
      at(ut), at(ct)
    }
    function gt(e, t, n) {
      if (ct.current !== st) throw Error(o(168))
      lt(ct, t), lt(ut, n)
    }
    function mt(e, t, n) {
      var r,
        a = e.stateNode
      if (((t = t.childContextTypes), 'function' != typeof a.getChildContext)) return n
      for (r in (a = a.getChildContext()))
        if (!(r in t))
          throw Error(
            o(
              108,
              (function (e) {
                var t = e.type
                switch (e.tag) {
                  case 24:
                    return 'Cache'
                  case 9:
                    return (t.displayName || 'Context') + '.Consumer'
                  case 10:
                    return (t._context.displayName || 'Context') + '.Provider'
                  case 18:
                    return 'DehydratedFragment'
                  case 11:
                    return (
                      (e = (e = t.render).displayName || e.name || ''),
                      t.displayName || ('' !== e ? 'ForwardRef(' + e + ')' : 'ForwardRef')
                    )
                  case 7:
                    return 'Fragment'
                  case 5:
                    return t
                  case 4:
                    return 'Portal'
                  case 3:
                    return 'Root'
                  case 6:
                    return 'Text'
                  case 16:
                    return E(t)
                  case 8:
                    return t === d ? 'StrictMode' : 'Mode'
                  case 22:
                    return 'Offscreen'
                  case 12:
                    return 'Profiler'
                  case 21:
                    return 'Scope'
                  case 13:
                    return 'Suspense'
                  case 19:
                    return 'SuspenseList'
                  case 25:
                    return 'TracingMarker'
                  case 1:
                  case 0:
                  case 17:
                  case 2:
                  case 14:
                  case 15:
                    if ('function' == typeof t) return t.displayName || t.name || null
                    if ('string' == typeof t) return t
                }
                return null
              })(e) || 'Unknown',
              r
            )
          )
      return i({}, n, a)
    }
    function vt(e) {
      ;(e = ((e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext) || st),
        (dt = ct.current),
        lt(ct, e),
        lt(ut, ut.current)
    }
    function yt(e, t, n) {
      var r = e.stateNode
      if (!r) throw Error(o(169))
      n ? ((e = mt(e, t, dt)), (r.__reactInternalMemoizedMergedChildContext = e), at(ut), at(ct), lt(ct, e)) : at(ut),
        lt(ut, n)
    }
    var bt =
        Math.clz32 ||
        function (e) {
          return 0 == (e >>>= 0) ? 32 : (31 - ((wt(e) / Ct) | 0)) | 0
        },
      wt = Math.log,
      Ct = Math.LN2,
      xt = 64,
      Et = 4194304
    function St(e) {
      switch (e & -e) {
        case 1:
          return 1
        case 2:
          return 2
        case 4:
          return 4
        case 8:
          return 8
        case 16:
          return 16
        case 32:
          return 32
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return 4194240 & e
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          return 130023424 & e
        case 134217728:
          return 134217728
        case 268435456:
          return 268435456
        case 536870912:
          return 536870912
        case 1073741824:
          return 1073741824
        default:
          return e
      }
    }
    function Ot(e, t) {
      var n = e.pendingLanes
      if (0 === n) return 0
      var r,
        i = 0,
        o = e.suspendedLanes,
        a = e.pingedLanes,
        l = 268435455 & n
      if (
        (0 != l
          ? 0 != (r = l & ~o)
            ? (i = St(r))
            : 0 != (a &= l) && (i = St(a))
          : 0 != (l = n & ~o)
          ? (i = St(l))
          : 0 !== a && (i = St(a)),
        0 === i)
      )
        return 0
      if (0 !== t && t !== i && 0 == (t & o) && ((a = t & -t) <= (o = i & -i) || (16 === o && 0 != (4194240 & a))))
        return t
      if ((0 != (4 & i) && (i |= 16 & n), 0 !== (t = e.entangledLanes)))
        for (e = e.entanglements, t &= i; 0 < t; ) (i |= e[(n = 31 - bt(t))]), (t &= ~(o = 1 << n))
      return i
    }
    function kt(e) {
      return 0 != (e = -1073741825 & e.pendingLanes) ? e : 1073741824 & e ? 1073741824 : 0
    }
    function Pt() {
      var e = xt
      return 0 == (4194240 & (xt <<= 1)) && (xt = 64), e
    }
    function _t(e) {
      for (var t = [], n = 0; n < 31; n++) t.push(e)
      return t
    }
    function Lt(e, t, n) {
      ;(e.pendingLanes |= t),
        536870912 !== t && ((e.suspendedLanes = 0), (e.pingedLanes = 0)),
        ((e = e.eventTimes)[(t = 31 - bt(t))] = n)
    }
    function Tt(e, t) {
      var n = (e.entangledLanes |= t)
      for (e = e.entanglements; n; ) {
        var r = 31 - bt(n),
          i = 1 << r
        ;(i & t) | (e[r] & t) && (e[r] |= t), (n &= ~i)
      }
    }
    var It = 0
    function Mt(e) {
      return 1 < (e &= -e) ? (4 < e ? (0 != (268435455 & e) ? 16 : 536870912) : 4) : 1
    }
    var jt = r.unstable_scheduleCallback,
      Rt = r.unstable_cancelCallback,
      Dt = r.unstable_shouldYield,
      At = r.unstable_requestPaint,
      zt = r.unstable_now,
      Nt = r.unstable_ImmediatePriority,
      Ft = r.unstable_UserBlockingPriority,
      Ht = r.unstable_NormalPriority,
      Bt = r.unstable_IdlePriority,
      Vt = null,
      Wt = null,
      Gt =
        'function' == typeof Object.is
          ? Object.is
          : function (e, t) {
              return (e === t && (0 !== e || 1 / e == 1 / t)) || (e != e && t != t)
            },
      Zt = null,
      Ut = !1,
      Xt = !1
    function Yt(e) {
      null === Zt ? (Zt = [e]) : Zt.push(e)
    }
    function qt() {
      if (!Xt && null !== Zt) {
        Xt = !0
        var e = 0,
          t = It
        try {
          var n = Zt
          for (It = 1; e < n.length; e++) for (var r = n[e]; null !== (r = r(!0)); );
          ;(Zt = null), (Ut = !1)
        } catch (i) {
          throw (null !== Zt && (Zt = Zt.slice(e + 1)), jt(Nt, qt), i)
        } finally {
          ;(It = t), (Xt = !1)
        }
      }
      return null
    }
    var $t = [],
      Kt = 0,
      Qt = null,
      Jt = 0,
      en = [],
      tn = 0,
      nn = null,
      rn = 1,
      on = ''
    function an(e, t) {
      ;($t[Kt++] = Jt), ($t[Kt++] = Qt), (Qt = e), (Jt = t)
    }
    function ln(e, t, n) {
      ;(en[tn++] = rn), (en[tn++] = on), (en[tn++] = nn), (nn = e)
      var r,
        i = rn,
        o = ((e = on), 32 - bt(i) - 1),
        a = ((i &= ~(1 << o)), (n += 1), 32 - bt(t) + o)
      on =
        30 < a
          ? ((a = (i & ((1 << (r = o - (o % 5))) - 1)).toString(32)),
            (i >>= r),
            (o -= r),
            (rn = (1 << (32 - bt(t) + o)) | (n << o) | i),
            a + e)
          : ((rn = (1 << a) | (n << o) | i), e)
    }
    function sn(e) {
      null !== e.return && (an(e, 1), ln(e, 1, 0))
    }
    function cn(e) {
      for (; e === Qt; ) (Qt = $t[--Kt]), ($t[Kt] = null), (Jt = $t[--Kt]), ($t[Kt] = null)
      for (; e === nn; )
        (nn = en[--tn]), (en[tn] = null), (on = en[--tn]), (en[tn] = null), (rn = en[--tn]), (en[tn] = null)
    }
    var un = null,
      dn = null,
      fn = !1,
      hn = !1,
      pn = null
    function gn(e, t) {
      var n = Ba(5, null, null, 0)
      ;(n.elementType = 'DELETED'),
        (n.stateNode = t),
        null === (t = (n.return = e).deletions) ? ((e.deletions = [n]), (e.flags |= 16)) : t.push(n)
    }
    function mn(e, t) {
      switch (e.tag) {
        case 5:
          return null !== (t = Ie(t, e.type, e.pendingProps)) && ((e.stateNode = t), (un = e), (dn = Fe(t)), 1)
        case 6:
          return null !== (t = Me(t, e.pendingProps)) && ((e.stateNode = t), (un = e), (dn = null), 1)
        case 13:
          var n
          return null !== (t = je(t))
            ? ((n = null !== nn ? { id: rn, overflow: on } : null),
              (e.memoizedState = { dehydrated: t, treeContext: n, retryLane: 1073741824 }),
              ((n = Ba(18, null, null, 0)).stateNode = t),
              ((n.return = e).child = n),
              (un = e),
              (dn = null),
              1)
            : void 0
        default:
          return
      }
    }
    function vn(e) {
      return 0 != (1 & e.mode) && 0 == (128 & e.flags)
    }
    function yn(e) {
      if (fn)
        if (dn) {
          var t = dn
          if (!mn(e, dn)) {
            if (vn(e)) throw Error(o(418))
            var n = Ne(t),
              r = un
            n && mn(e, n) ? gn(r, t) : ((e.flags = (-4097 & e.flags) | 2), (fn = !1), (un = e))
          }
        } else {
          if (vn(e)) throw Error(o(418))
          ;(e.flags = (-4097 & e.flags) | 2), (fn = !1), (un = e)
        }
    }
    function bn(e) {
      for (e = e.return; null !== e && 5 !== e.tag && 3 !== e.tag && 13 !== e.tag; ) e = e.return
      un = e
    }
    function wn(e) {
      if (!X || e !== un) return !1
      if (!fn) return bn(e), !(fn = !0)
      if (3 !== e.tag && (5 !== e.tag || ($e(e.type) && !F(e.type, e.memoizedProps)))) {
        var t = dn
        if (t) {
          if (vn(e)) throw (Cn(), Error(o(418)))
          for (; t; ) gn(e, t), (t = Ne(t))
        }
      }
      if ((bn(e), 13 === e.tag)) {
        if (!X) throw Error(o(316))
        if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null)) throw Error(o(317))
        dn = Ze(e)
      } else dn = un ? Ne(e.stateNode) : null
      return !0
    }
    function Cn() {
      for (var e = dn; e; ) e = Ne(e)
    }
    function xn() {
      X && ((dn = un = null), (hn = fn = !1))
    }
    function En(e) {
      null === pn ? (pn = [e]) : pn.push(e)
    }
    var Sn = a.ReactCurrentBatchConfig
    function On(e, t) {
      if (!Gt(e, t)) {
        if ('object' != typeof e || null === e || 'object' != typeof t || null === t) return !1
        var n = Object.keys(e),
          r = Object.keys(t)
        if (n.length !== r.length) return !1
        for (r = 0; r < n.length; r++) {
          var i = n[r]
          if (!nt.call(t, i) || !Gt(e[i], t[i])) return !1
        }
      }
      return !0
    }
    function kn(e, t) {
      if (e && e.defaultProps) for (var n in ((t = i({}, t)), (e = e.defaultProps))) void 0 === t[n] && (t[n] = e[n])
      return t
    }
    var Pn = ot(null),
      _n = null,
      Ln = null,
      Tn = null
    function In() {
      Tn = Ln = _n = null
    }
    function Mn(e, t, n) {
      G ? (lt(Pn, t._currentValue), (t._currentValue = n)) : (lt(Pn, t._currentValue2), (t._currentValue2 = n))
    }
    function jn(e) {
      var t = Pn.current
      at(Pn), G ? (e._currentValue = t) : (e._currentValue2 = t)
    }
    function Rn(e, t, n) {
      for (; null !== e; ) {
        var r = e.alternate
        if (
          ((e.childLanes & t) !== t
            ? ((e.childLanes |= t), null !== r && (r.childLanes |= t))
            : null !== r && (r.childLanes & t) !== t && (r.childLanes |= t),
          e === n)
        )
          break
        e = e.return
      }
    }
    function Dn(e, t) {
      ;(Tn = Ln = null) !== (e = (_n = e).dependencies) &&
        null !== e.firstContext &&
        (0 != (e.lanes & t) && (Pi = !0), (e.firstContext = null))
    }
    function An(e) {
      var t = G ? e._currentValue : e._currentValue2
      if (Tn !== e)
        if (((e = { context: e, memoizedValue: t, next: null }), null === Ln)) {
          if (null === _n) throw Error(o(308))
          ;(Ln = e), (_n.dependencies = { lanes: 0, firstContext: e })
        } else Ln = Ln.next = e
      return t
    }
    var zn = null
    function Nn(e) {
      null === zn ? (zn = [e]) : zn.push(e)
    }
    function Fn(e, t, n, r) {
      var i = t.interleaved
      return null === i ? ((n.next = n), Nn(t)) : ((n.next = i.next), (i.next = n)), (t.interleaved = n), Hn(e, r)
    }
    function Hn(e, t) {
      e.lanes |= t
      var n = e.alternate
      for (null !== n && (n.lanes |= t), e = (n = e).return; null !== e; )
        (e.childLanes |= t), null !== (n = e.alternate) && (n.childLanes |= t), (e = (n = e).return)
      return 3 === n.tag ? n.stateNode : null
    }
    var Bn = !1
    function Vn(e) {
      e.updateQueue = {
        baseState: e.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: { pending: null, interleaved: null, lanes: 0 },
        effects: null
      }
    }
    function Wn(e, t) {
      ;(e = e.updateQueue),
        t.updateQueue === e &&
          (t.updateQueue = {
            baseState: e.baseState,
            firstBaseUpdate: e.firstBaseUpdate,
            lastBaseUpdate: e.lastBaseUpdate,
            shared: e.shared,
            effects: e.effects
          })
    }
    function Gn(e, t) {
      return { eventTime: e, lane: t, tag: 0, payload: null, callback: null, next: null }
    }
    function Zn(e, t, n) {
      var r,
        i = e.updateQueue
      return null === i
        ? null
        : ((i = i.shared),
          0 != (2 & Vo)
            ? (null === (r = i.pending) ? (t.next = t) : ((t.next = r.next), (r.next = t)), (i.pending = t))
            : (null === (r = i.interleaved) ? ((t.next = t), Nn(i)) : ((t.next = r.next), (r.next = t)),
              (i.interleaved = t)),
          Hn(e, n))
    }
    function Un(e, t, n) {
      var r
      null !== (t = t.updateQueue) &&
        ((t = t.shared), 0 != (4194240 & n)) &&
        ((r = t.lanes), (r &= e.pendingLanes), Tt(e, (t.lanes = n |= r)))
    }
    function Xn(e, t) {
      var n = e.updateQueue,
        r = e.alternate
      if (null !== r && n === (r = r.updateQueue)) {
        var i = null,
          o = null
        if (null !== (n = n.firstBaseUpdate)) {
          do {
            var a = {
              eventTime: n.eventTime,
              lane: n.lane,
              tag: n.tag,
              payload: n.payload,
              callback: n.callback,
              next: null
            }
          } while ((null === o ? (i = o = a) : (o = o.next = a), null !== (n = n.next)))
          null === o ? (i = o = t) : (o = o.next = t)
        } else i = o = t
        ;(n = { baseState: r.baseState, firstBaseUpdate: i, lastBaseUpdate: o, shared: r.shared, effects: r.effects }),
          (e.updateQueue = n)
      } else null === (e = n.lastBaseUpdate) ? (n.firstBaseUpdate = t) : (e.next = t), (n.lastBaseUpdate = t)
    }
    function Yn(e, t, n, r) {
      var o,
        a,
        l = e.updateQueue,
        s = ((Bn = !1), l.firstBaseUpdate),
        c = l.lastBaseUpdate
      if (
        (null !== (f = l.shared.pending) &&
          ((l.shared.pending = null),
          (a = (o = f).next),
          (o.next = null) === c ? (s = a) : (c.next = a),
          (c = o),
          null !== (d = e.alternate)) &&
          (f = (d = d.updateQueue).lastBaseUpdate) !== c &&
          (null === f ? (d.firstBaseUpdate = a) : (f.next = a), (d.lastBaseUpdate = o)),
        null !== s)
      ) {
        for (var u = l.baseState, d = ((c = 0), (a = o = null)), f = s; ; ) {
          var h = f.lane,
            p = f.eventTime
          if ((r & h) === h) {
            null !== d &&
              (d = d.next = { eventTime: p, lane: 0, tag: f.tag, payload: f.payload, callback: f.callback, next: null })
            e: {
              var g = e,
                m = f
              ;(h = t), (p = n)
              switch (m.tag) {
                case 1:
                  if ('function' == typeof (g = m.payload)) {
                    u = g.call(p, u, h)
                    break e
                  }
                  u = g
                  break e
                case 3:
                  g.flags = (-65537 & g.flags) | 128
                case 0:
                  if (null == (h = 'function' == typeof (g = m.payload) ? g.call(p, u, h) : g)) break e
                  u = i({}, u, h)
                  break e
                case 2:
                  Bn = !0
              }
            }
            null !== f.callback &&
              0 !== f.lane &&
              ((e.flags |= 64), null === (h = l.effects) ? (l.effects = [f]) : h.push(f))
          } else
            (p = { eventTime: p, lane: h, tag: f.tag, payload: f.payload, callback: f.callback, next: null }),
              null === d ? ((a = d = p), (o = u)) : (d = d.next = p),
              (c |= h)
          if (null === (f = f.next)) {
            if (null === (f = l.shared.pending)) break
            ;(f = (h = f).next), (h.next = null), (l.lastBaseUpdate = h), (l.shared.pending = null)
          }
        }
        if (
          (null === d && (o = u),
          (l.baseState = o),
          (l.firstBaseUpdate = a),
          (l.lastBaseUpdate = d),
          null !== (t = l.shared.interleaved))
        )
          for (l = t; (c |= l.lane), (l = l.next) !== t; );
        else null === s && (l.shared.lanes = 0)
        ;($o |= c), (e.lanes = c), (e.memoizedState = u)
      }
    }
    function qn(e, t, n) {
      if (((e = t.effects), (t.effects = null) !== e))
        for (t = 0; t < e.length; t++) {
          var r = e[t],
            i = r.callback
          if (null !== i) {
            if (((r.callback = null), (r = n), 'function' != typeof i)) throw Error(o(191, i))
            i.call(r)
          }
        }
    }
    var $n = new n.Component().refs
    function Kn(e, t, n, r) {
      ;(n = null == (n = n(r, (t = e.memoizedState))) ? t : i({}, t, n)),
        (e.memoizedState = n),
        0 === e.lanes && (e.updateQueue.baseState = n)
    }
    var Qn = {
      isMounted: function (e) {
        return !!(e = e._reactInternals) && S(e) === e
      },
      enqueueSetState: function (e, t, n) {
        e = e._reactInternals
        var r = ma(),
          i = va(e),
          o = Gn(r, i)
        ;(o.payload = t), null != n && (o.callback = n), null !== (t = Zn(e, o, i)) && (ya(t, e, i, r), Un(t, e, i))
      },
      enqueueReplaceState: function (e, t, n) {
        e = e._reactInternals
        var r = ma(),
          i = va(e),
          o = Gn(r, i)
        ;(o.tag = 1),
          (o.payload = t),
          null != n && (o.callback = n),
          null !== (t = Zn(e, o, i)) && (ya(t, e, i, r), Un(t, e, i))
      },
      enqueueForceUpdate: function (e, t) {
        e = e._reactInternals
        var n = ma(),
          r = va(e),
          i = Gn(n, r)
        ;(i.tag = 2), null != t && (i.callback = t), null !== (t = Zn(e, i, r)) && (ya(t, e, r, n), Un(t, e, r))
      }
    }
    function Jn(e, t, n, r, i, o, a) {
      return 'function' == typeof (e = e.stateNode).shouldComponentUpdate
        ? e.shouldComponentUpdate(r, o, a)
        : !(t.prototype && t.prototype.isPureReactComponent && On(n, r) && On(i, o))
    }
    function er(e, t, n) {
      var r = !1,
        i = st,
        o = t.contextType
      ;(t = new t(
        n,
        (o =
          'object' == typeof o && null !== o
            ? An(o)
            : ((i = ht(t) ? dt : ct.current), (r = null != (r = t.contextTypes)) ? ft(e, i) : st))
      )),
        (e.memoizedState = null !== t.state && void 0 !== t.state ? t.state : null),
        (t.updater = Qn),
        ((e.stateNode = t)._reactInternals = e),
        r &&
          (((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = i),
          (e.__reactInternalMemoizedMaskedChildContext = o))
    }
    function tr(e, t, n, r) {
      ;(e = t.state),
        'function' == typeof t.componentWillReceiveProps && t.componentWillReceiveProps(n, r),
        'function' == typeof t.UNSAFE_componentWillReceiveProps && t.UNSAFE_componentWillReceiveProps(n, r),
        t.state !== e && Qn.enqueueReplaceState(t, t.state, null)
    }
    function nr(e, t, n, r) {
      var i = e.stateNode,
        o = ((i.props = n), (i.state = e.memoizedState), (i.refs = $n), Vn(e), t.contextType)
      'object' == typeof o && null !== o
        ? (i.context = An(o))
        : ((o = ht(t) ? dt : ct.current), (i.context = ft(e, o))),
        (i.state = e.memoizedState),
        'function' == typeof (o = t.getDerivedStateFromProps) && (Kn(e, 0, o, n), (i.state = e.memoizedState)),
        'function' == typeof t.getDerivedStateFromProps ||
          'function' == typeof i.getSnapshotBeforeUpdate ||
          ('function' != typeof i.UNSAFE_componentWillMount && 'function' != typeof i.componentWillMount) ||
          ((t = i.state),
          'function' == typeof i.componentWillMount && i.componentWillMount(),
          'function' == typeof i.UNSAFE_componentWillMount && i.UNSAFE_componentWillMount(),
          t !== i.state && Qn.enqueueReplaceState(i, i.state, null),
          Yn(e, n, i, r),
          (i.state = e.memoizedState)),
        'function' == typeof i.componentDidMount && (e.flags |= 4194308)
    }
    function rr(e, t, n) {
      if (null !== (e = n.ref) && 'function' != typeof e && 'object' != typeof e) {
        if (n._owner) {
          if ((n = n._owner)) {
            if (1 !== n.tag) throw Error(o(309))
            var r = n.stateNode
          }
          var i, a
          if (r)
            return (
              (i = r),
              (a = '' + e),
              null !== t && null !== t.ref && 'function' == typeof t.ref && t.ref._stringRef === a
                ? t.ref
                : (((t = function (e) {
                    var t = i.refs
                    t === $n && (t = i.refs = {}), null === e ? delete t[a] : (t[a] = e)
                  })._stringRef = a),
                  t)
            )
          throw Error(o(147, e))
        }
        if ('string' != typeof e) throw Error(o(284))
        if (!n._owner) throw Error(o(290, e))
      }
      return e
    }
    function ir(e, t) {
      throw (
        ((e = Object.prototype.toString.call(t)),
        Error(o(31, '[object Object]' === e ? 'object with keys {' + Object.keys(t).join(', ') + '}' : e)))
      )
    }
    function or(e) {
      return (0, e._init)(e._payload)
    }
    function ar(e) {
      function t(t, n) {
        var r
        e && (null === (r = t.deletions) ? ((t.deletions = [n]), (t.flags |= 16)) : r.push(n))
      }
      function n(n, r) {
        if (e) for (; null !== r; ) t(n, r), (r = r.sibling)
        return null
      }
      function r(e, t) {
        for (e = new Map(); null !== t; ) null !== t.key ? e.set(t.key, t) : e.set(t.index, t), (t = t.sibling)
        return e
      }
      function i(e, t) {
        return ((e = Wa(e, t)).index = 0), (e.sibling = null), e
      }
      function a(t, n, r) {
        if (((t.index = r), e)) {
          if (null !== (r = t.alternate)) return (r = r.index) < n ? ((t.flags |= 2), n) : r
          t.flags |= 2
        } else t.flags |= 1048576
        return n
      }
      function s(t) {
        return e && null === t.alternate && (t.flags |= 2), t
      }
      function d(e, t, n, r) {
        return null === t || 6 !== t.tag ? ((t = Xa(n, e.mode, r)).return = e) : ((t = i(t, n)).return = e), t
      }
      function f(e, t, n, r) {
        var o = n.type
        return o === u
          ? p(e, t, n.props.children, r, n.key)
          : (null !== t &&
            (t.elementType === o || ('object' == typeof o && null !== o && o.$$typeof === b && or(o) === t.type))
              ? ((r = i(t, n.props)).ref = rr(0, t, n))
              : ((r = Ga(n.type, n.key, n.props, null, e.mode, r)).ref = rr(0, t, n)),
            (r.return = e),
            r)
      }
      function h(e, t, n, r) {
        return (
          null === t ||
          4 !== t.tag ||
          t.stateNode.containerInfo !== n.containerInfo ||
          t.stateNode.implementation !== n.implementation
            ? ((t = Ya(n, e.mode, r)).return = e)
            : ((t = i(t, n.children || [])).return = e),
          t
        )
      }
      function p(e, t, n, r, o) {
        return null === t || 7 !== t.tag ? ((t = Za(n, e.mode, r, o)).return = e) : ((t = i(t, n)).return = e), t
      }
      function g(e, t, n) {
        if (('string' == typeof t && '' !== t) || 'number' == typeof t)
          return ((t = Xa('' + t, e.mode, n)).return = e), t
        if ('object' == typeof t && null !== t) {
          switch (t.$$typeof) {
            case l:
              return ((n = Ga(t.type, t.key, t.props, null, e.mode, n)).ref = rr(0, null, t)), (n.return = e), n
            case c:
              return ((t = Ya(t, e.mode, n)).return = e), t
            case b:
              return g(e, (0, t._init)(t._payload), n)
          }
          if (L(t) || x(t)) return ((t = Za(t, e.mode, n, null)).return = e), t
          ir(0, t)
        }
        return null
      }
      function m(e, t, n, r) {
        var i = null !== t ? t.key : null
        if (('string' == typeof n && '' !== n) || 'number' == typeof n) return null !== i ? null : d(e, t, '' + n, r)
        if ('object' == typeof n && null !== n) {
          switch (n.$$typeof) {
            case l:
              return n.key === i ? f(e, t, n, r) : null
            case c:
              return n.key === i ? h(e, t, n, r) : null
            case b:
              return m(e, t, (i = n._init)(n._payload), r)
          }
          if (L(n) || x(n)) return null !== i ? null : p(e, t, n, r, null)
          ir(0, n)
        }
        return null
      }
      function v(e, t, n, r, i) {
        if (('string' == typeof r && '' !== r) || 'number' == typeof r) return d(t, (e = e.get(n) || null), '' + r, i)
        if ('object' == typeof r && null !== r) {
          switch (r.$$typeof) {
            case l:
              return f(t, (e = e.get(null === r.key ? n : r.key) || null), r, i)
            case c:
              return h(t, (e = e.get(null === r.key ? n : r.key) || null), r, i)
            case b:
              return v(e, t, n, (0, r._init)(r._payload), i)
          }
          if (L(r) || x(r)) return p(t, (e = e.get(n) || null), r, i, null)
          ir(0, r)
        }
        return null
      }
      return function d(f, h, p, y) {
        if (
          'object' ==
            typeof (p = 'object' == typeof p && null !== p && p.type === u && null === p.key ? p.props.children : p) &&
          null !== p
        ) {
          switch (p.$$typeof) {
            case l:
              e: {
                for (var w = p.key, C = h; null !== C; ) {
                  if (C.key === w) {
                    if ((w = p.type) === u) {
                      if (7 === C.tag) {
                        n(f, C.sibling), ((h = i(C, p.props.children)).return = f), (f = h)
                        break e
                      }
                    } else if (
                      C.elementType === w ||
                      ('object' == typeof w && null !== w && w.$$typeof === b && or(w) === C.type)
                    ) {
                      n(f, C.sibling), ((h = i(C, p.props)).ref = rr(0, C, p)), (h.return = f), (f = h)
                      break e
                    }
                    n(f, C)
                    break
                  }
                  t(f, C), (C = C.sibling)
                }
                f =
                  p.type === u
                    ? (((h = Za(p.props.children, f.mode, y, p.key)).return = f), h)
                    : (((y = Ga(p.type, p.key, p.props, null, f.mode, y)).ref = rr(0, h, p)), (y.return = f), y)
              }
              return s(f)
            case c:
              e: {
                for (C = p.key; null !== h; ) {
                  if (h.key === C) {
                    if (
                      4 === h.tag &&
                      h.stateNode.containerInfo === p.containerInfo &&
                      h.stateNode.implementation === p.implementation
                    ) {
                      n(f, h.sibling), ((h = i(h, p.children || [])).return = f), (f = h)
                      break e
                    }
                    n(f, h)
                    break
                  }
                  t(f, h), (h = h.sibling)
                }
                ;((h = Ya(p, f.mode, y)).return = f), (f = h)
              }
              return s(f)
            case b:
              return d(f, h, (C = p._init)(p._payload), y)
          }
          if (L(p)) {
            for (
              var E = f, S = h, O = p, k = y, P = null, _ = null, T = S, I = (S = 0), M = null;
              null !== T && I < O.length;
              I++
            ) {
              T.index > I ? ((M = T), (T = null)) : (M = T.sibling)
              var j = m(E, T, O[I], k)
              if (null === j) {
                null === T && (T = M)
                break
              }
              e && T && null === j.alternate && t(E, T),
                (S = a(j, S, I)),
                null === _ ? (P = j) : (_.sibling = j),
                (_ = j),
                (T = M)
            }
            if (I === O.length) n(E, T)
            else if (null === T)
              for (; I < O.length; I++)
                null !== (T = g(E, O[I], k)) && ((S = a(T, S, I)), null === _ ? (P = T) : (_.sibling = T), (_ = T))
            else {
              for (T = r(E, T); I < O.length; I++)
                null !== (M = v(T, E, I, O[I], k)) &&
                  (e && null !== M.alternate && T.delete(null === M.key ? I : M.key),
                  (S = a(M, S, I)),
                  null === _ ? (P = M) : (_.sibling = M),
                  (_ = M))
              e &&
                T.forEach(function (e) {
                  return t(E, e)
                })
            }
            return fn && an(E, I), P
          }
          if (x(p)) {
            var R = f,
              D = h,
              A = p,
              z = y,
              N = x(A)
            if ('function' != typeof N) throw Error(o(150))
            if (null == (A = N.call(A))) throw Error(o(151))
            for (
              var F = (N = null), H = D, B = (D = 0), V = null, W = A.next();
              null !== H && !W.done;
              B++, W = A.next()
            ) {
              H.index > B ? ((V = H), (H = null)) : (V = H.sibling)
              var G = m(R, H, W.value, z)
              if (null === G) {
                null === H && (H = V)
                break
              }
              e && H && null === G.alternate && t(R, H),
                (D = a(G, D, B)),
                null === F ? (N = G) : (F.sibling = G),
                (F = G),
                (H = V)
            }
            if (W.done) n(R, H)
            else if (null === H)
              for (; !W.done; B++, W = A.next())
                null !== (W = g(R, W.value, z)) && ((D = a(W, D, B)), null === F ? (N = W) : (F.sibling = W), (F = W))
            else {
              for (H = r(R, H); !W.done; B++, W = A.next())
                null !== (W = v(H, R, B, W.value, z)) &&
                  (e && null !== W.alternate && H.delete(null === W.key ? B : W.key),
                  (D = a(W, D, B)),
                  null === F ? (N = W) : (F.sibling = W),
                  (F = W))
              e &&
                H.forEach(function (e) {
                  return t(R, e)
                })
            }
            return fn && an(R, B), N
          }
          ir(0, p)
        }
        return ('string' == typeof p && '' !== p) || 'number' == typeof p
          ? ((p = '' + p),
            ((h = null !== h && 6 === h.tag ? (n(f, h.sibling), i(h, p)) : (n(f, h), Xa(p, f.mode, y))).return = f),
            s((f = h)))
          : n(f, h)
      }
    }
    var lr = ar(!0),
      sr = ar(!1),
      cr = {},
      ur = ot(cr),
      dr = ot(cr),
      fr = ot(cr)
    function hr(e) {
      if (e === cr) throw Error(o(174))
      return e
    }
    function pr(e, t) {
      lt(fr, t), lt(dr, e), lt(ur, cr), (e = I(t)), at(ur), lt(ur, e)
    }
    function gr() {
      at(ur), at(dr), at(fr)
    }
    function mr(e) {
      var t = hr(fr.current),
        n = hr(ur.current)
      n !== (t = M(n, e.type, t)) && (lt(dr, e), lt(ur, t))
    }
    function vr(e) {
      dr.current === e && (at(ur), at(dr))
    }
    var yr = ot(0)
    function br(e) {
      for (var t = e; null !== t; ) {
        if (13 === t.tag) {
          var n = t.memoizedState
          if (null !== n && (null === (n = n.dehydrated) || Re(n) || De(n))) return t
        } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
          if (0 != (128 & t.flags)) return t
        } else if (null !== t.child) {
          t = (t.child.return = t).child
          continue
        }
        if (t === e) break
        for (; null === t.sibling; ) {
          if (null === t.return || t.return === e) return null
          t = t.return
        }
        ;(t.sibling.return = t.return), (t = t.sibling)
      }
      return null
    }
    var wr = []
    function Cr() {
      for (var e = 0; e < wr.length; e++) {
        var t = wr[e]
        G ? (t._workInProgressVersionPrimary = null) : (t._workInProgressVersionSecondary = null)
      }
      wr.length = 0
    }
    var xr = a.ReactCurrentDispatcher,
      Er = a.ReactCurrentBatchConfig,
      Sr = 0,
      Or = null,
      kr = null,
      Pr = null,
      _r = !1,
      Lr = !1,
      Tr = 0,
      Ir = 0
    function Mr() {
      throw Error(o(321))
    }
    function jr(e, t) {
      if (null !== t) {
        for (var n = 0; n < t.length && n < e.length; n++) if (!Gt(e[n], t[n])) return
        return 1
      }
    }
    function Rr(e, t, n, r, i, a) {
      if (
        ((Sr = a),
        ((Or = t).memoizedState = null),
        (t.updateQueue = null),
        (t.lanes = 0),
        (xr.current = null === e || null === e.memoizedState ? pi : gi),
        (e = n(r, i)),
        Lr)
      ) {
        a = 0
        do {
          if (((Lr = !1), (Tr = 0), 25 <= a)) throw Error(o(301))
        } while (((a += 1), (Pr = kr = null), (t.updateQueue = null), (xr.current = mi), (e = n(r, i)), Lr))
      }
      if (((xr.current = hi), (t = null !== kr && null !== kr.next), (Sr = 0), (Pr = kr = Or = null), (_r = !1), t))
        throw Error(o(300))
      return e
    }
    function Dr() {
      var e = 0 !== Tr
      return (Tr = 0), e
    }
    function Ar() {
      var e = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null }
      return null === Pr ? (Or.memoizedState = Pr = e) : (Pr = Pr.next = e), Pr
    }
    function zr() {
      e = null === kr ? (null !== (e = Or.alternate) ? e.memoizedState : null) : kr.next
      var e,
        t = null === Pr ? Or.memoizedState : Pr.next
      if (null !== t) (Pr = t), (kr = e)
      else {
        if (null === e) throw Error(o(310))
        ;(e = {
          memoizedState: (kr = e).memoizedState,
          baseState: kr.baseState,
          baseQueue: kr.baseQueue,
          queue: kr.queue,
          next: null
        }),
          null === Pr ? (Or.memoizedState = Pr = e) : (Pr = Pr.next = e)
      }
      return Pr
    }
    function Nr(e, t) {
      return 'function' == typeof t ? t(e) : t
    }
    function Fr(e) {
      var t = zr(),
        n = t.queue
      if (null === n) throw Error(o(311))
      n.lastRenderedReducer = e
      var r,
        i = (l = kr).baseQueue
      if (
        (null !== (a = n.pending) &&
          (null !== i && ((r = i.next), (i.next = a.next), (a.next = r)), (l.baseQueue = i = a), (n.pending = null)),
        null !== i)
      ) {
        var a = i.next,
          l = l.baseState,
          s = (r = null),
          c = null,
          u = a
        do {
          var d,
            f = u.lane
        } while (
          ((Sr & f) === f
            ? (null !== c &&
                (c = c.next =
                  { lane: 0, action: u.action, hasEagerState: u.hasEagerState, eagerState: u.eagerState, next: null }),
              (l = u.hasEagerState ? u.eagerState : e(l, u.action)))
            : ((d = {
                lane: f,
                action: u.action,
                hasEagerState: u.hasEagerState,
                eagerState: u.eagerState,
                next: null
              }),
              null === c ? ((s = c = d), (r = l)) : (c = c.next = d),
              (Or.lanes |= f),
              ($o |= f)),
          null !== (u = u.next) && u !== a)
        )
        null === c ? (r = l) : (c.next = s),
          Gt(l, t.memoizedState) || (Pi = !0),
          (t.memoizedState = l),
          (t.baseState = r),
          (t.baseQueue = c),
          (n.lastRenderedState = l)
      }
      if (null !== (e = n.interleaved)) for (i = e; (a = i.lane), (Or.lanes |= a), ($o |= a), (i = i.next) !== e; );
      else null === i && (n.lanes = 0)
      return [t.memoizedState, n.dispatch]
    }
    function Hr(e) {
      var t = zr(),
        n = t.queue
      if (null === n) throw Error(o(311))
      n.lastRenderedReducer = e
      var r = n.dispatch,
        i = n.pending,
        a = t.memoizedState
      if (null !== i) {
        n.pending = null
        for (var l = (i = i.next); (a = e(a, l.action)), (l = l.next) !== i; );
        Gt(a, t.memoizedState) || (Pi = !0),
          (t.memoizedState = a),
          null === t.baseQueue && (t.baseState = a),
          (n.lastRenderedState = a)
      }
      return [a, r]
    }
    function Br() {}
    function Vr(e, t) {
      var n = Or,
        r = zr(),
        i = t(),
        a = !Gt(r.memoizedState, i)
      if (
        (a && ((r.memoizedState = i), (Pi = !0)),
        (r = r.queue),
        ei(Zr.bind(null, n, r, e), [e]),
        r.getSnapshot !== t || a || (null !== Pr && 1 & Pr.memoizedState.tag))
      ) {
        if (((n.flags |= 2048), qr(9, Gr.bind(null, n, r, i, t), void 0, null), null === Wo)) throw Error(o(349))
        0 == (30 & Sr) && Wr(n, t, i)
      }
      return i
    }
    function Wr(e, t, n) {
      ;(e.flags |= 16384),
        (e = { getSnapshot: t, value: n }),
        null === (t = Or.updateQueue)
          ? ((Or.updateQueue = t = { lastEffect: null, stores: null }).stores = [e])
          : null === (n = t.stores)
          ? (t.stores = [e])
          : n.push(e)
    }
    function Gr(e, t, n, r) {
      ;(t.value = n), (t.getSnapshot = r), Ur(t) && Xr(e)
    }
    function Zr(e, t, n) {
      return n(function () {
        Ur(t) && Xr(e)
      })
    }
    function Ur(e) {
      var t = e.getSnapshot
      e = e.value
      try {
        var n = t()
        return !Gt(e, n)
      } catch (r) {
        return 1
      }
    }
    function Xr(e) {
      var t = Hn(e, 1)
      null !== t && ya(t, e, 1, -1)
    }
    function Yr(e) {
      var t = Ar()
      return (
        'function' == typeof e && (e = e()),
        (t.memoizedState = t.baseState = e),
        (e = (t.queue = e =
          {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: Nr,
            lastRenderedState: e
          }).dispatch =
          function (e, t, n) {
            var r = va(e),
              i = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null }
            if (ui(e)) di(t, i)
            else {
              var o = e.alternate
              if (0 === e.lanes && (null === o || 0 === o.lanes) && null !== (o = t.lastRenderedReducer))
                try {
                  var a,
                    l = t.lastRenderedState,
                    s = o(l, n)
                  if (((i.hasEagerState = !0), (i.eagerState = s), Gt(s, l)))
                    return (
                      null === (a = t.interleaved) ? ((i.next = i), Nn(t)) : ((i.next = a.next), (a.next = i)),
                      void (t.interleaved = i)
                    )
                } catch (c) {}
              null !== (n = Fn(e, t, i, r)) && (ya(n, e, r, (i = ma())), fi(n, t, r))
            }
          }.bind(null, Or, e)),
        [t.memoizedState, e]
      )
    }
    function qr(e, t, n, r) {
      return (
        (e = { tag: e, create: t, destroy: n, deps: r, next: null }),
        null === (t = Or.updateQueue)
          ? ((Or.updateQueue = t = { lastEffect: null, stores: null }).lastEffect = e.next = e)
          : null === (n = t.lastEffect)
          ? (t.lastEffect = e.next = e)
          : ((r = n.next), ((n.next = e).next = r), (t.lastEffect = e)),
        e
      )
    }
    function $r() {
      return zr().memoizedState
    }
    function Kr(e, t, n, r) {
      var i = Ar()
      ;(Or.flags |= e), (i.memoizedState = qr(1 | t, n, void 0, void 0 === r ? null : r))
    }
    function Qr(e, t, n, r) {
      var i = zr(),
        o = void (r = void 0 === r ? null : r)
      if (null !== kr) {
        var a = kr.memoizedState
        o = a.destroy
        if (null !== r && jr(r, a.deps)) return void (i.memoizedState = qr(t, n, o, r))
      }
      ;(Or.flags |= e), (i.memoizedState = qr(1 | t, n, o, r))
    }
    function Jr(e, t) {
      return Kr(8390656, 8, e, t)
    }
    function ei(e, t) {
      return Qr(2048, 8, e, t)
    }
    function ti(e, t) {
      return Qr(4, 2, e, t)
    }
    function ni(e, t) {
      return Qr(4, 4, e, t)
    }
    function ri(e, t) {
      return 'function' == typeof t
        ? ((e = e()),
          t(e),
          function () {
            t(null)
          })
        : null != t
        ? ((e = e()),
          (t.current = e),
          function () {
            t.current = null
          })
        : void 0
    }
    function ii(e, t, n) {
      return (n = null != n ? n.concat([e]) : null), Qr(4, 4, ri.bind(null, t, e), n)
    }
    function oi() {}
    function ai(e, t) {
      var n = zr(),
        r = ((t = void 0 === t ? null : t), n.memoizedState)
      return null !== r && null !== t && jr(t, r[1]) ? r[0] : ((n.memoizedState = [e, t]), e)
    }
    function li(e, t) {
      var n = zr(),
        r = ((t = void 0 === t ? null : t), n.memoizedState)
      return null !== r && null !== t && jr(t, r[1]) ? r[0] : ((e = e()), (n.memoizedState = [e, t]), e)
    }
    function si(e, t, n) {
      return 0 == (21 & Sr)
        ? (e.baseState && ((e.baseState = !1), (Pi = !0)), (e.memoizedState = n))
        : (Gt(n, t) || ((n = Pt()), (Or.lanes |= n), ($o |= n), (e.baseState = !0)), t)
    }
    function ci() {
      return zr().memoizedState
    }
    function ui(e) {
      var t = e.alternate
      return e === Or || (null !== t && t === Or)
    }
    function di(e, t) {
      Lr = _r = !0
      var n = e.pending
      null === n ? (t.next = t) : ((t.next = n.next), (n.next = t)), (e.pending = t)
    }
    function fi(e, t, n) {
      var r
      0 != (4194240 & n) && ((r = t.lanes), (r &= e.pendingLanes), Tt(e, (t.lanes = n |= r)))
    }
    var hi = {
        readContext: An,
        useCallback: Mr,
        useContext: Mr,
        useEffect: Mr,
        useImperativeHandle: Mr,
        useInsertionEffect: Mr,
        useLayoutEffect: Mr,
        useMemo: Mr,
        useReducer: Mr,
        useRef: Mr,
        useState: Mr,
        useDebugValue: Mr,
        useDeferredValue: Mr,
        useTransition: Mr,
        useMutableSource: Mr,
        useSyncExternalStore: Mr,
        useId: Mr,
        unstable_isNewReconciler: !1
      },
      pi = {
        readContext: An,
        useCallback: function (e, t) {
          return (Ar().memoizedState = [e, void 0 === t ? null : t]), e
        },
        useContext: An,
        useEffect: Jr,
        useImperativeHandle: function (e, t, n) {
          return (n = null != n ? n.concat([e]) : null), Kr(4194308, 4, ri.bind(null, t, e), n)
        },
        useLayoutEffect: function (e, t) {
          return Kr(4194308, 4, e, t)
        },
        useInsertionEffect: function (e, t) {
          return Kr(4, 2, e, t)
        },
        useMemo: function (e, t) {
          var n = Ar()
          return (t = void 0 === t ? null : t), (e = e()), (n.memoizedState = [e, t]), e
        },
        useReducer: function (e, t, n) {
          var r = Ar()
          return (
            (t = void 0 !== n ? n(t) : t),
            (r.memoizedState = r.baseState = t),
            (e = (r.queue = e =
              {
                pending: null,
                interleaved: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: e,
                lastRenderedState: t
              }).dispatch =
              function (e, t, n) {
                var r = va(e)
                ;(n = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null }),
                  ui(e) ? di(t, n) : null !== (n = Fn(e, t, n, r)) && (ya(n, e, r, ma()), fi(n, t, r))
              }.bind(null, Or, e)),
            [r.memoizedState, e]
          )
        },
        useRef: function (e) {
          return (Ar().memoizedState = { current: e })
        },
        useState: Yr,
        useDebugValue: oi,
        useDeferredValue: function (e) {
          return (Ar().memoizedState = e)
        },
        useTransition: function () {
          var e = (t = Yr(!1))[0],
            t = function (e, t) {
              var n = It,
                r = ((It = 0 !== n && n < 4 ? n : 4), e(!0), Er.transition)
              Er.transition = {}
              try {
                e(!1), t()
              } finally {
                ;(It = n), (Er.transition = r)
              }
            }.bind(null, t[1])
          return [e, (Ar().memoizedState = t)]
        },
        useMutableSource: function () {},
        useSyncExternalStore: function (e, t, n) {
          var r = Or,
            i = Ar()
          if (fn) {
            if (void 0 === n) throw Error(o(407))
            n = n()
          } else {
            if (((n = t()), null === Wo)) throw Error(o(349))
            0 == (30 & Sr) && Wr(r, t, n)
          }
          var a = { value: (i.memoizedState = n), getSnapshot: t }
          return (
            (i.queue = a),
            Jr(Zr.bind(null, r, a, e), [e]),
            (r.flags |= 2048),
            qr(9, Gr.bind(null, r, a, n, t), void 0, null),
            n
          )
        },
        useId: function () {
          var e,
            t = Ar(),
            n = Wo.identifierPrefix
          return (
            fn
              ? ((e = on),
                (n = ':' + n + 'R' + (e = (rn & ~(1 << (32 - bt(rn) - 1))).toString(32) + e)),
                0 < (e = Tr++) && (n += 'H' + e.toString(32)),
                (n += ':'))
              : (n = ':' + n + 'r' + (e = Ir++).toString(32) + ':'),
            (t.memoizedState = n)
          )
        },
        unstable_isNewReconciler: !1
      },
      gi = {
        readContext: An,
        useCallback: ai,
        useContext: An,
        useEffect: ei,
        useImperativeHandle: ii,
        useInsertionEffect: ti,
        useLayoutEffect: ni,
        useMemo: li,
        useReducer: Fr,
        useRef: $r,
        useState: function () {
          return Fr(Nr)
        },
        useDebugValue: oi,
        useDeferredValue: function (e) {
          return si(zr(), kr.memoizedState, e)
        },
        useTransition: function () {
          return [Fr(Nr)[0], zr().memoizedState]
        },
        useMutableSource: Br,
        useSyncExternalStore: Vr,
        useId: ci,
        unstable_isNewReconciler: !1
      },
      mi = {
        readContext: An,
        useCallback: ai,
        useContext: An,
        useEffect: ei,
        useImperativeHandle: ii,
        useInsertionEffect: ti,
        useLayoutEffect: ni,
        useMemo: li,
        useReducer: Hr,
        useRef: $r,
        useState: function () {
          return Hr(Nr)
        },
        useDebugValue: oi,
        useDeferredValue: function (e) {
          var t = zr()
          return null === kr ? (t.memoizedState = e) : si(t, kr.memoizedState, e)
        },
        useTransition: function () {
          return [Hr(Nr)[0], zr().memoizedState]
        },
        useMutableSource: Br,
        useSyncExternalStore: Vr,
        useId: ci,
        unstable_isNewReconciler: !1
      }
    function vi(e, t) {
      try {
        for (
          var n = '', r = t;
          (n += (function (e) {
            switch (e.tag) {
              case 5:
                return Je(e.type)
              case 16:
                return Je('Lazy')
              case 13:
                return Je('Suspense')
              case 19:
                return Je('SuspenseList')
              case 0:
              case 2:
              case 15:
                return tt(e.type, !1)
              case 11:
                return tt(e.type.render, !1)
              case 1:
                return tt(e.type, !0)
              default:
                return ''
            }
          })(r)),
            (r = r.return);

        );
        var i = n
      } catch (o) {
        i = '\nError generating stack: ' + o.message + '\n' + o.stack
      }
      return { value: e, source: t, stack: i, digest: null }
    }
    function yi(e, t, n) {
      return { value: e, source: null, stack: null != n ? n : null, digest: null != t ? t : null }
    }
    function bi(e, t) {
      try {
        console.error(t.value)
      } catch (n) {
        setTimeout(function () {
          throw n
        })
      }
    }
    var wi = 'function' == typeof WeakMap ? WeakMap : Map
    function Ci(e, t, n) {
      ;((n = Gn(-1, n)).tag = 3), (n.payload = { element: null })
      var r = t.value
      return (
        (n.callback = function () {
          aa || ((aa = !0), (la = r)), bi(0, t)
        }),
        n
      )
    }
    function xi(e, t, n) {
      ;(n = Gn(-1, n)).tag = 3
      var r,
        i = e.type.getDerivedStateFromError
      return (
        null !==
          (e =
            ('function' == typeof i &&
              ((r = t.value),
              (n.payload = function () {
                return i(r)
              }),
              (n.callback = function () {
                bi(0, t)
              })),
            e.stateNode)) &&
          'function' == typeof e.componentDidCatch &&
          (n.callback = function () {
            bi(0, t), 'function' != typeof i && (null === sa ? (sa = new Set([this])) : sa.add(this))
            var e = t.stack
            this.componentDidCatch(t.value, { componentStack: null !== e ? e : '' })
          }),
        n
      )
    }
    function Ei(e, t, n) {
      var r,
        i = e.pingCache
      null === i
        ? ((i = e.pingCache = new wi()), (r = new Set()), i.set(t, r))
        : void 0 === (r = i.get(t)) && ((r = new Set()), i.set(t, r)),
        r.has(n) ||
          (r.add(n),
          (e = function (e, t, n) {
            var r = e.pingCache
            null !== r && r.delete(t),
              (t = ma()),
              (e.pingedLanes |= e.suspendedLanes & n),
              Wo === e &&
                (Zo & n) === n &&
                (4 === Yo || (3 === Yo && (130023424 & Zo) === Zo && zt() - ta < 500) ? Pa(e, 0) : (Qo |= n)),
              ba(e, t)
          }.bind(null, e, t, n)),
          t.then(e, e))
    }
    function Si(e) {
      do {
        var t
        if ((t = (t = 13 === e.tag) ? null === (t = e.memoizedState) || null !== t.dehydrated : t)) return e
      } while (null !== (e = e.return))
      return null
    }
    function Oi(e, t, n, r, i) {
      if (0 == (1 & e.mode))
        return e === t
          ? (e.flags |= 65536)
          : ((e.flags |= 128),
            (n.flags |= 131072),
            (n.flags &= -52805),
            1 === n.tag && (null === n.alternate ? (n.tag = 17) : (((t = Gn(-1, 1)).tag = 2), Zn(n, t, 1))),
            (n.lanes |= 1))
      ;(e.flags |= 65536), (e.lanes = i)
    }
    var ki = a.ReactCurrentOwner,
      Pi = !1
    function _i(e, t, n, r) {
      t.child = null === e ? sr(t, null, n, r) : lr(t, e.child, n, r)
    }
    function Li(e, t, n, r, i) {
      n = n.render
      var o = t.ref
      return (
        Dn(t, i),
        (r = Rr(e, t, n, r, o, i)),
        (n = Dr()),
        null === e || Pi
          ? (fn && n && sn(t), (t.flags |= 1), _i(e, t, r, i), t.child)
          : ((t.updateQueue = e.updateQueue), (t.flags &= -2053), (e.lanes &= ~i), Ji(e, t, i))
      )
    }
    function Ti(e, t, n, r, i) {
      var o
      if (null === e)
        return 'function' != typeof (o = n.type) ||
          Va(o) ||
          void 0 !== o.defaultProps ||
          null !== n.compare ||
          void 0 !== n.defaultProps
          ? (((e = Ga(n.type, null, r, t, t.mode, i)).ref = t.ref), ((e.return = t).child = e))
          : ((t.tag = 15), (t.type = o), Ii(e, t, o, r, i))
      if (((o = e.child), 0 == (e.lanes & i))) {
        var a = o.memoizedProps
        if ((n = null !== (n = n.compare) ? n : On)(a, r) && e.ref === t.ref) return Ji(e, t, i)
      }
      return (t.flags |= 1), ((e = Wa(o, r)).ref = t.ref), ((e.return = t).child = e)
    }
    function Ii(e, t, n, r, i) {
      if (null !== e) {
        var o = e.memoizedProps
        if (On(o, r) && e.ref === t.ref) {
          if (((Pi = !1), (t.pendingProps = r = o), 0 == (e.lanes & i))) return (t.lanes = e.lanes), Ji(e, t, i)
          0 != (131072 & e.flags) && (Pi = !0)
        }
      }
      return Ri(e, t, n, r, i)
    }
    function Mi(e, t, n) {
      var r = t.pendingProps,
        i = r.children,
        o = null !== e ? e.memoizedState : null
      if ('hidden' === r.mode)
        if (0 == (1 & t.mode))
          (t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }), lt(Xo, Uo), (Uo |= n)
        else {
          if (0 == (1073741824 & n))
            return (
              (e = null !== o ? o.baseLanes | n : n),
              (t.lanes = t.childLanes = 1073741824),
              (t.memoizedState = { baseLanes: e, cachePool: null, transitions: null }),
              (t.updateQueue = null),
              lt(Xo, Uo),
              (Uo |= e),
              null
            )
          ;(t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }),
            (r = null !== o ? o.baseLanes : n),
            lt(Xo, Uo),
            (Uo |= r)
        }
      else null !== o ? ((r = o.baseLanes | n), (t.memoizedState = null)) : (r = n), lt(Xo, Uo), (Uo |= r)
      return _i(e, t, i, n), t.child
    }
    function ji(e, t) {
      var n = t.ref
      ;((null === e && null !== n) || (null !== e && e.ref !== n)) && ((t.flags |= 512), (t.flags |= 2097152))
    }
    function Ri(e, t, n, r, i) {
      var o = ft(t, ht(n) ? dt : ct.current)
      return (
        Dn(t, i),
        (n = Rr(e, t, n, r, o, i)),
        (r = Dr()),
        null === e || Pi
          ? (fn && r && sn(t), (t.flags |= 1), _i(e, t, n, i), t.child)
          : ((t.updateQueue = e.updateQueue), (t.flags &= -2053), (e.lanes &= ~i), Ji(e, t, i))
      )
    }
    function Di(e, t, n, r, i) {
      var o, a, l, s, c, u, d, f, h, p
      return (
        ht(n) ? ((o = !0), vt(t)) : (o = !1),
        Dn(t, i),
        (r =
          null === t.stateNode
            ? (Qi(e, t), er(t, n, r), nr(t, n, r, i), !0)
            : null === e
            ? ((a = t.stateNode),
              (l = t.memoizedProps),
              (a.props = l),
              (f = a.context),
              (s = 'object' == typeof (s = n.contextType) && null !== s ? An(s) : ft(t, (s = ht(n) ? dt : ct.current))),
              (u =
                'function' == typeof (c = n.getDerivedStateFromProps) ||
                'function' == typeof a.getSnapshotBeforeUpdate) ||
                ('function' != typeof a.UNSAFE_componentWillReceiveProps &&
                  'function' != typeof a.componentWillReceiveProps) ||
                (l === r && f === s) ||
                tr(0, a, r, s),
              (Bn = !1),
              (d = t.memoizedState),
              (a.state = d),
              Yn(t, r, a, i),
              (f = t.memoizedState),
              l !== r || d !== f || ut.current || Bn
                ? ('function' == typeof c && (Kn(t, 0, c, r), (f = t.memoizedState)),
                  (l = Bn || Jn(t, n, l, r, d, f, s))
                    ? (u ||
                        ('function' != typeof a.UNSAFE_componentWillMount &&
                          'function' != typeof a.componentWillMount) ||
                        ('function' == typeof a.componentWillMount && a.componentWillMount(),
                        'function' == typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount()),
                      'function' == typeof a.componentDidMount && (t.flags |= 4194308))
                    : ('function' == typeof a.componentDidMount && (t.flags |= 4194308),
                      (t.memoizedProps = r),
                      (t.memoizedState = f)),
                  (a.props = r),
                  (a.state = f),
                  (a.context = s),
                  l)
                : ('function' == typeof a.componentDidMount && (t.flags |= 4194308), !1))
            : ((a = t.stateNode),
              Wn(e, t),
              (l = t.memoizedProps),
              (s = t.type === t.elementType ? l : kn(t.type, l)),
              (a.props = s),
              (u = t.pendingProps),
              (d = a.context),
              (f = 'object' == typeof (f = n.contextType) && null !== f ? An(f) : ft(t, (f = ht(n) ? dt : ct.current))),
              (c =
                'function' == typeof (h = n.getDerivedStateFromProps) ||
                'function' == typeof a.getSnapshotBeforeUpdate) ||
                ('function' != typeof a.UNSAFE_componentWillReceiveProps &&
                  'function' != typeof a.componentWillReceiveProps) ||
                (l === u && d === f) ||
                tr(0, a, r, f),
              (Bn = !1),
              (d = t.memoizedState),
              (a.state = d),
              Yn(t, r, a, i),
              (p = t.memoizedState),
              l !== u || d !== p || ut.current || Bn
                ? ('function' == typeof h && (Kn(t, 0, h, r), (p = t.memoizedState)),
                  (s = Bn || Jn(t, n, s, r, d, p, f) || !1)
                    ? (c ||
                        ('function' != typeof a.UNSAFE_componentWillUpdate &&
                          'function' != typeof a.componentWillUpdate) ||
                        ('function' == typeof a.componentWillUpdate && a.componentWillUpdate(r, p, f),
                        'function' == typeof a.UNSAFE_componentWillUpdate && a.UNSAFE_componentWillUpdate(r, p, f)),
                      'function' == typeof a.componentDidUpdate && (t.flags |= 4),
                      'function' == typeof a.getSnapshotBeforeUpdate && (t.flags |= 1024))
                    : ('function' != typeof a.componentDidUpdate ||
                        (l === e.memoizedProps && d === e.memoizedState) ||
                        (t.flags |= 4),
                      'function' != typeof a.getSnapshotBeforeUpdate ||
                        (l === e.memoizedProps && d === e.memoizedState) ||
                        (t.flags |= 1024),
                      (t.memoizedProps = r),
                      (t.memoizedState = p)),
                  (a.props = r),
                  (a.state = p),
                  (a.context = f),
                  s)
                : ('function' != typeof a.componentDidUpdate ||
                    (l === e.memoizedProps && d === e.memoizedState) ||
                    (t.flags |= 4),
                  'function' != typeof a.getSnapshotBeforeUpdate ||
                    (l === e.memoizedProps && d === e.memoizedState) ||
                    (t.flags |= 1024),
                  !1))),
        Ai(e, t, n, r, o, i)
      )
    }
    function Ai(e, t, n, r, i, o) {
      ji(e, t)
      var a = 0 != (128 & t.flags)
      if (!r && !a) return i && yt(t, n, !1), Ji(e, t, o)
      ;(r = t.stateNode), (ki.current = t)
      var l = a && 'function' != typeof n.getDerivedStateFromError ? null : r.render()
      return (
        (t.flags |= 1),
        null !== e && a ? ((t.child = lr(t, e.child, null, o)), (t.child = lr(t, null, l, o))) : _i(e, t, l, o),
        (t.memoizedState = r.state),
        i && yt(t, n, !0),
        t.child
      )
    }
    function zi(e) {
      var t = e.stateNode
      t.pendingContext ? gt(0, t.pendingContext, t.pendingContext !== t.context) : t.context && gt(0, t.context, !1),
        pr(e, t.containerInfo)
    }
    function Ni(e, t, n, r, i) {
      return xn(), En(i), (t.flags |= 256), _i(e, t, n, r), t.child
    }
    var Fi,
      Hi,
      Bi,
      Vi,
      Wi,
      Gi = { dehydrated: null, treeContext: null, retryLane: 0 }
    function Zi(e) {
      return { baseLanes: e, cachePool: null, transitions: null }
    }
    function Ui(e, t, n) {
      var r,
        i = t.pendingProps,
        a = yr.current,
        l = !1
      if (
        ((r = (r = u = 0 != (128 & t.flags)) || ((null === e || null !== e.memoizedState) && 0 != (2 & a)))
          ? ((l = !0), (t.flags &= -129))
          : (null !== e && null === e.memoizedState) || (a |= 1),
        lt(yr, 1 & a),
        null === e)
      )
        return (
          yn(t),
          null !== (e = t.memoizedState) && null !== (e = e.dehydrated)
            ? (0 == (1 & t.mode) ? (t.lanes = 1) : De(e) ? (t.lanes = 8) : (t.lanes = 1073741824), null)
            : ((u = i.children),
              (e = i.fallback),
              l
                ? ((i = t.mode),
                  (l = t.child),
                  (u = { mode: 'hidden', children: u }),
                  0 == (1 & i) && null !== l ? ((l.childLanes = 0), (l.pendingProps = u)) : (l = Ua(u, i, 0, null)),
                  (e = Za(e, i, n, null)),
                  (l.return = t),
                  (e.return = t),
                  (l.sibling = e),
                  (t.child = l),
                  (t.child.memoizedState = Zi(n)),
                  (t.memoizedState = Gi),
                  e)
                : Xi(t, u))
        )
      if (null === (a = e.memoizedState) || null === (r = a.dehydrated))
        return (
          l
            ? ((l = i.fallback),
              (u = t.mode),
              (r = (a = e.child).sibling),
              (s = { mode: 'hidden', children: i.children }),
              0 == (1 & u) && t.child !== a
                ? (((i = t.child).childLanes = 0), (i.pendingProps = s), (t.deletions = null))
                : ((i = Wa(a, s)).subtreeFlags = 14680064 & a.subtreeFlags),
              null !== r ? (l = Wa(r, l)) : ((l = Za(l, u, n, null)).flags |= 2),
              (l.return = t),
              (i.return = t),
              (i.sibling = l),
              (t.child = i),
              (i = l),
              (l = t.child),
              (u =
                null === (u = e.child.memoizedState)
                  ? Zi(n)
                  : { baseLanes: u.baseLanes | n, cachePool: null, transitions: u.transitions }),
              (l.memoizedState = u),
              (l.childLanes = e.childLanes & ~n),
              (t.memoizedState = Gi))
            : ((e = (l = e.child).sibling),
              (i = Wa(l, { mode: 'visible', children: i.children })),
              0 == (1 & t.mode) && (i.lanes = n),
              (i.return = t),
              (i.sibling = null) !== e &&
                (null === (n = t.deletions) ? ((t.deletions = [e]), (t.flags |= 16)) : n.push(e)),
              (t.child = i),
              (t.memoizedState = null)),
          i
        )
      var s = e,
        c = ((l = t), (e = u), (t = i), r),
        u = a
      i = n
      if (e)
        return 256 & l.flags
          ? ((l.flags &= -257), Yi(s, l, i, (t = yi(Error(o(422))))))
          : null !== l.memoizedState
          ? ((l.child = s.child), (l.flags |= 128), null)
          : ((u = t.fallback),
            (c = l.mode),
            (t = Ua({ mode: 'visible', children: t.children }, c, 0, null)),
            ((u = Za(u, c, i, null)).flags |= 2),
            (t.return = l),
            (u.return = l),
            (t.sibling = u),
            (l.child = t),
            0 != (1 & l.mode) && lr(l, s.child, null, i),
            (l.child.memoizedState = Zi(i)),
            (l.memoizedState = Gi),
            u)
      if (0 == (1 & l.mode)) return Yi(s, l, i, null)
      if (De(c)) return (t = Ae(c).digest), Yi(s, l, i, (t = yi((u = Error(o(419))), t, void 0)))
      if (((e = 0 != (i & s.childLanes)), Pi || e)) {
        if (null !== (t = Wo)) {
          switch (i & -i) {
            case 4:
              c = 2
              break
            case 16:
              c = 8
              break
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
              c = 32
              break
            case 536870912:
              c = 268435456
              break
            default:
              c = 0
          }
          0 !== (c = 0 != (c & (t.suspendedLanes | i)) ? 0 : c) &&
            c !== u.retryLane &&
            ((u.retryLane = c), Hn(s, c), ya(t, s, c, -1))
        }
        return Ta(), Yi(s, l, i, (t = yi(Error(o(421)))))
      }
      return Re(c)
        ? ((l.flags |= 128),
          (l.child = s.child),
          (l = function (e) {
            var t = e.memoizedState,
              n = 0
            null !== t && (n = t.retryLane), Na(e, n)
          }.bind(null, s)),
          ze(c, l),
          null)
        : ((s = u.treeContext),
          X &&
            ((dn = Be(c)), (un = l), (hn = !(fn = !0)), (pn = null) !== s) &&
            ((en[tn++] = rn), (en[tn++] = on), (en[tn++] = nn), (rn = s.id), (on = s.overflow), (nn = l)),
          ((l = Xi(l, t.children)).flags |= 4096),
          l)
    }
    function Xi(e, t) {
      return (((t = Ua({ mode: 'visible', children: t }, e.mode, 0, null)).return = e).child = t)
    }
    function Yi(e, t, n, r) {
      return (
        null !== r && En(r),
        lr(t, e.child, null, n),
        ((e = Xi(t, t.pendingProps.children)).flags |= 2),
        (t.memoizedState = null),
        e
      )
    }
    function qi(e, t, n) {
      e.lanes |= t
      var r = e.alternate
      null !== r && (r.lanes |= t), Rn(e.return, t, n)
    }
    function $i(e, t, n, r, i) {
      var o = e.memoizedState
      null === o
        ? (e.memoizedState = { isBackwards: t, rendering: null, renderingStartTime: 0, last: r, tail: n, tailMode: i })
        : ((o.isBackwards = t),
          (o.rendering = null),
          (o.renderingStartTime = 0),
          (o.last = r),
          (o.tail = n),
          (o.tailMode = i))
    }
    function Ki(e, t, n) {
      var r = t.pendingProps,
        i = r.revealOrder,
        o = r.tail
      if ((_i(e, t, r.children, n), 0 != (2 & (r = yr.current)))) (r = (1 & r) | 2), (t.flags |= 128)
      else {
        if (null !== e && 0 != (128 & e.flags))
          e: for (e = t.child; null !== e; ) {
            if (13 === e.tag) null !== e.memoizedState && qi(e, n, t)
            else if (19 === e.tag) qi(e, n, t)
            else if (null !== e.child) {
              e = (e.child.return = e).child
              continue
            }
            if (e === t) break
            for (; null === e.sibling; ) {
              if (null === e.return || e.return === t) break e
              e = e.return
            }
            ;(e.sibling.return = e.return), (e = e.sibling)
          }
        r &= 1
      }
      if ((lt(yr, r), 0 == (1 & t.mode))) t.memoizedState = null
      else
        switch (i) {
          case 'forwards':
            for (n = t.child, i = null; null !== n; )
              null !== (e = n.alternate) && null === br(e) && (i = n), (n = n.sibling)
            null === (n = i) ? ((i = t.child), (t.child = null)) : ((i = n.sibling), (n.sibling = null)),
              $i(t, !1, i, n, o)
            break
          case 'backwards':
            for (i = t.child, t.child = n = null; null !== i; ) {
              if (null !== (e = i.alternate) && null === br(e)) {
                t.child = i
                break
              }
              ;(e = i.sibling), (i.sibling = n), (n = i), (i = e)
            }
            $i(t, !0, n, null, o)
            break
          case 'together':
            $i(t, !1, null, null, void 0)
            break
          default:
            t.memoizedState = null
        }
      return t.child
    }
    function Qi(e, t) {
      0 == (1 & t.mode) && null !== e && ((e.alternate = null), (t.alternate = null), (t.flags |= 2))
    }
    function Ji(e, t, n) {
      if ((null !== e && (t.dependencies = e.dependencies), ($o |= t.lanes), 0 == (n & t.childLanes))) return null
      if (null !== e && t.child !== e.child) throw Error(o(153))
      if (null !== t.child) {
        for (n = Wa((e = t.child), e.pendingProps), (t.child = n).return = t; null !== e.sibling; )
          (e = e.sibling), ((n = n.sibling = Wa(e, e.pendingProps)).return = t)
        n.sibling = null
      }
      return t.child
    }
    function eo(e) {
      e.flags |= 4
    }
    function to(e, t) {
      if (null === e || e.child !== t.child) {
        if (0 != (16 & t.flags)) return !1
        for (e = t.child; null !== e; ) {
          if (0 != (12854 & e.flags) || 0 != (12854 & e.subtreeFlags)) return !1
          e = e.sibling
        }
      }
      return !0
    }
    function no(e, t) {
      if (!fn)
        switch (e.tailMode) {
          case 'hidden':
            t = e.tail
            for (var n = null; null !== t; ) null !== t.alternate && (n = t), (t = t.sibling)
            null === n ? (e.tail = null) : (n.sibling = null)
            break
          case 'collapsed':
            n = e.tail
            for (var r = null; null !== n; ) null !== n.alternate && (r = n), (n = n.sibling)
            null === r ? (t || null === e.tail ? (e.tail = null) : (e.tail.sibling = null)) : (r.sibling = null)
        }
    }
    function ro(e) {
      var t = 0,
        n = 0
      if (null !== e.alternate && e.alternate.child === e.child)
        for (var r = e.child; null !== r; )
          (t |= r.lanes | r.childLanes),
            (n = (n |= 14680064 & r.subtreeFlags) | (14680064 & r.flags)),
            (r.return = e),
            (r = r.sibling)
      else
        for (r = e.child; null !== r; )
          (t |= r.lanes | r.childLanes), (n = (n |= r.subtreeFlags) | r.flags), (r.return = e), (r = r.sibling)
      ;(e.subtreeFlags |= n), (e.childLanes = t)
    }
    Wi = Z
      ? ((Fi = function (e, t) {
          for (var n = t.child; null !== n; ) {
            if (5 === n.tag || 6 === n.tag) A(e, n.stateNode)
            else if (4 !== n.tag && null !== n.child) {
              n = (n.child.return = n).child
              continue
            }
            if (n === t) break
            for (; null === n.sibling; ) {
              if (null === n.return || n.return === t) return
              n = n.return
            }
            ;(n.sibling.return = n.return), (n = n.sibling)
          }
        }),
        (Bi = function () {}),
        (Vi = function (e, t, n, r, i) {
          var o, a
          ;(e = e.memoizedProps) !== r &&
            ((o = t.stateNode), (a = hr(ur.current)), (n = N(o, n, e, r, i, a)), (t.updateQueue = n)) &&
            eo(t)
        }),
        function (e, t, n, r) {
          n !== r && eo(t)
        })
      : U
      ? ((Fi = function (e, t, n, r) {
          for (var i = t.child; null !== i; ) {
            if (5 === i.tag) {
              var o = i.stateNode
              n && r && (o = Le(o, i.type, i.memoizedProps, i)), A(e, o)
            } else if (6 === i.tag) (o = i.stateNode), n && r && (o = Te(o, i.memoizedProps, i)), A(e, o)
            else if (4 !== i.tag)
              if (22 === i.tag && null !== i.memoizedState) null !== (o = i.child) && (o.return = i), Fi(e, i, !0, !0)
              else if (null !== i.child) {
                i = (i.child.return = i).child
                continue
              }
            if (i === t) break
            for (; null === i.sibling; ) {
              if (null === i.return || i.return === t) return
              i = i.return
            }
            ;(i.sibling.return = i.return), (i = i.sibling)
          }
        }),
        (Hi = function (e, t, n, r) {
          for (var i = t.child; null !== i; ) {
            if (5 === i.tag) {
              var o = i.stateNode
              n && r && (o = Le(o, i.type, i.memoizedProps, i)), ke(e, o)
            } else if (6 === i.tag) (o = i.stateNode), n && r && (o = Te(o, i.memoizedProps, i)), ke(e, o)
            else if (4 !== i.tag)
              if (22 === i.tag && null !== i.memoizedState) null !== (o = i.child) && (o.return = i), Hi(e, i, !0, !0)
              else if (null !== i.child) {
                i = (i.child.return = i).child
                continue
              }
            if (i === t) break
            for (; null === i.sibling; ) {
              if (null === i.return || i.return === t) return
              i = i.return
            }
            ;(i.sibling.return = i.return), (i = i.sibling)
          }
        }),
        (Bi = function (e, t) {
          var n,
            r = t.stateNode
          to(e, t) || ((e = r.containerInfo), (n = Oe(e)), Hi(n, t, !1, !1), (r.pendingChildren = n), eo(t), Pe(e, n))
        }),
        (Vi = function (e, t, n, r, i) {
          var o,
            a,
            l,
            s = e.stateNode,
            c = e.memoizedProps
          ;((e = to(e, t)) && c === r) ||
          ((o = t.stateNode), (a = hr(ur.current)), (l = null), c !== r && (l = N(o, n, c, r, i, a)), e && null === l)
            ? (t.stateNode = s)
            : ((s = Se(s, l, n, c, r, t, e, o)),
              z(s, n, r, i, a) && eo(t),
              (t.stateNode = s),
              e ? eo(t) : Fi(s, t, !1, !1))
        }),
        function (e, t, n, r) {
          n !== r
            ? ((e = hr(fr.current)), (n = hr(ur.current)), (t.stateNode = H(r, e, n, t)), eo(t))
            : (t.stateNode = e.stateNode)
        })
      : ((Bi = function () {}), (Vi = function () {}), function () {})
    var io = !1,
      oo = !1,
      ao = 'function' == typeof WeakSet ? WeakSet : Set,
      lo = null
    function so(e, t) {
      var n = e.ref
      if (null !== n)
        if ('function' == typeof n)
          try {
            n(null)
          } catch (r) {
            za(e, t, r)
          }
        else n.current = null
    }
    function co(e, t, n) {
      try {
        n()
      } catch (r) {
        za(e, t, r)
      }
    }
    var uo = !1
    function fo(e, t, n) {
      var r = t.updateQueue
      if (null !== (r = null !== r ? r.lastEffect : null)) {
        var i,
          o = (r = r.next)
        do {} while (
          ((o.tag & e) === e && ((i = o.destroy), (o.destroy = void 0) !== i) && co(t, n, i), (o = o.next) !== r)
        )
      }
    }
    function ho(e, t) {
      if (null !== (t = null !== (t = t.updateQueue) ? t.lastEffect : null)) {
        var n,
          r = (t = t.next)
        do {} while (((r.tag & e) === e && ((n = r.create), (r.destroy = n())), (r = r.next) !== t))
      }
    }
    function po(e) {
      var t,
        n = e.ref
      null !== n && ((t = e.stateNode), (e = 5 === e.tag ? T(t) : t), 'function' == typeof n ? n(e) : (n.current = e))
    }
    function go(e) {
      return 5 === e.tag || 3 === e.tag || 4 === e.tag
    }
    function mo(e) {
      e: for (;;) {
        for (; null === e.sibling; ) {
          if (null === e.return || go(e.return)) return null
          e = e.return
        }
        for (e.sibling.return = e.return, e = e.sibling; 5 !== e.tag && 6 !== e.tag && 18 !== e.tag; ) {
          if (2 & e.flags) continue e
          if (null === e.child || 4 === e.tag) continue e
          e = (e.child.return = e).child
        }
        if (!(2 & e.flags)) return e.stateNode
      }
    }
    var vo = null,
      yo = !1
    function bo(e, t, n) {
      for (n = n.child; null !== n; ) wo(e, t, n), (n = n.sibling)
    }
    function wo(e, t, n) {
      if (Wt && 'function' == typeof Wt.onCommitFiberUnmount)
        try {
          Wt.onCommitFiberUnmount(Vt, n)
        } catch (l) {}
      switch (n.tag) {
        case 5:
          oo || so(n, t)
        case 6:
          var r, i
          Z
            ? ((r = vo),
              (i = yo),
              (vo = null),
              bo(e, t, n),
              (yo = i),
              null !== (vo = r) && (yo ? ve : me)(vo, n.stateNode))
            : bo(e, t, n)
          break
        case 18:
          Z && null !== vo && (yo ? qe : Ye)(vo, n.stateNode)
          break
        case 4:
          Z
            ? ((r = vo), (i = yo), (vo = n.stateNode.containerInfo), (yo = !0), bo(e, t, n), (vo = r), (yo = i))
            : (U && ((r = n.stateNode.containerInfo), (i = Oe(r)), _e(r, i)), bo(e, t, n))
          break
        case 0:
        case 11:
        case 14:
        case 15:
          if (!oo && null !== (r = n.updateQueue) && null !== (r = r.lastEffect)) {
            i = r = r.next
            do {
              var o = i.destroy,
                a = i.tag
            } while ((void 0 === o || (0 == (2 & a) && 0 == (4 & a)) || co(n, t, o), (i = i.next) !== r))
          }
          bo(e, t, n)
          break
        case 1:
          if (!oo && (so(n, t), 'function' == typeof (r = n.stateNode).componentWillUnmount))
            try {
              ;(r.props = n.memoizedProps), (r.state = n.memoizedState), r.componentWillUnmount()
            } catch (l) {
              za(n, t, l)
            }
          bo(e, t, n)
          break
        case 21:
          bo(e, t, n)
          break
        case 22:
          1 & n.mode ? ((oo = (r = oo) || null !== n.memoizedState), bo(e, t, n), (oo = r)) : bo(e, t, n)
          break
        default:
          bo(e, t, n)
      }
    }
    function Co(e) {
      var t,
        n = e.updateQueue
      null !== n &&
        ((e.updateQueue = null) === (t = e.stateNode) && (t = e.stateNode = new ao()),
        n.forEach(function (n) {
          var r = function (e, t) {
            var n = 0
            switch (e.tag) {
              case 13:
                var r = e.stateNode,
                  i = e.memoizedState
                null !== i && (n = i.retryLane)
                break
              case 19:
                r = e.stateNode
                break
              default:
                throw Error(o(314))
            }
            null !== r && r.delete(t), Na(e, n)
          }.bind(null, e, n)
          t.has(n) || (t.add(n), n.then(r, r))
        }))
    }
    function xo(e, t) {
      var n = t.deletions
      if (null !== n)
        for (var r = 0; r < n.length; r++) {
          var i = n[r]
          try {
            var a = e,
              l = t
            if (Z) {
              var s = l
              e: for (; null !== s; ) {
                switch (s.tag) {
                  case 5:
                    ;(vo = s.stateNode), (yo = !1)
                    break e
                  case 3:
                  case 4:
                    ;(vo = s.stateNode.containerInfo), (yo = !0)
                    break e
                }
                s = s.return
              }
              if (null === vo) throw Error(o(160))
              wo(a, l, i), (vo = null), (yo = !1)
            } else wo(a, l, i)
            var c = i.alternate
            null !== c && (c.return = null), (i.return = null)
          } catch (u) {
            za(i, t, u)
          }
        }
      if (12854 & t.subtreeFlags) for (t = t.child; null !== t; ) Eo(t, e), (t = t.sibling)
    }
    function Eo(e, t) {
      var n = e.alternate,
        r = e.flags
      switch (e.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          if ((xo(t, e), So(e), 4 & r)) {
            try {
              fo(3, e, e.return), ho(3, e)
            } catch (h) {
              za(e, e.return, h)
            }
            try {
              fo(5, e, e.return)
            } catch (h) {
              za(e, e.return, h)
            }
          }
          break
        case 1:
          xo(t, e), So(e), 512 & r && null !== n && so(n, n.return)
          break
        case 5:
          if ((xo(t, e), So(e), 512 & r && null !== n && so(n, n.return), Z)) {
            if (32 & e.flags) {
              var i = e.stateNode
              try {
                ye(i)
              } catch (h) {
                za(e, e.return, h)
              }
            }
            if (4 & r && null != (i = e.stateNode)) {
              var a = e.memoizedProps
              ;(n = null !== n ? n.memoizedProps : a), (r = e.type)
              if (((t = e.updateQueue), (e.updateQueue = null) !== t))
                try {
                  he(i, t, r, n, a, e)
                } catch (h) {
                  za(e, e.return, h)
                }
            }
          }
          break
        case 6:
          if ((xo(t, e), So(e), 4 & r && Z)) {
            if (null === e.stateNode) throw Error(o(162))
            ;(i = e.stateNode), (a = e.memoizedProps), (n = null !== n ? n.memoizedProps : a)
            try {
              ue(i, n, a)
            } catch (h) {
              za(e, e.return, h)
            }
          }
          break
        case 3:
          if ((xo(t, e), So(e), 4 & r)) {
            if (Z && X && null !== n && n.memoizedState.isDehydrated)
              try {
                Ue(t.containerInfo)
              } catch (h) {
                za(e, e.return, h)
              }
            if (U) {
              ;(i = t.containerInfo), (a = t.pendingChildren)
              try {
                _e(i, a)
              } catch (h) {
                za(e, e.return, h)
              }
            }
          }
          break
        case 4:
          if ((xo(t, e), So(e), 4 & r && U)) {
            ;(i = (a = e.stateNode).containerInfo), (a = a.pendingChildren)
            try {
              _e(i, a)
            } catch (h) {
              za(e, e.return, h)
            }
          }
          break
        case 13:
          xo(t, e),
            So(e),
            8192 & (i = e.child).flags &&
              ((a = null !== i.memoizedState),
              !(i.stateNode.isHidden = a) ||
                (null !== i.alternate && null !== i.alternate.memoizedState) ||
                (ta = zt())),
            4 & r && Co(e)
          break
        case 22:
          var l = null !== n && null !== n.memoizedState
          if ((1 & e.mode ? ((oo = (n = oo) || l), xo(t, e), (oo = n)) : xo(t, e), So(e), 8192 & r)) {
            if (((n = null !== e.memoizedState), (e.stateNode.isHidden = n) && !l && 0 != (1 & e.mode)))
              for (r = (lo = e).child; null !== r; ) {
                for (t = lo = r; null !== lo; ) {
                  var s = (l = lo).child
                  switch (l.tag) {
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                      fo(4, l, l.return)
                      break
                    case 1:
                      so(l, l.return)
                      var c = l.stateNode
                      if ('function' == typeof c.componentWillUnmount) {
                        var u = l,
                          d = l.return
                        try {
                          var f = u
                          ;(c.props = f.memoizedProps), (c.state = f.memoizedState), c.componentWillUnmount()
                        } catch (h) {
                          za(u, d, h)
                        }
                      }
                      break
                    case 5:
                      so(l, l.return)
                      break
                    case 22:
                      if (null !== l.memoizedState) {
                        ko(t)
                        continue
                      }
                  }
                  null !== s ? ((s.return = l), (lo = s)) : ko(t)
                }
                r = r.sibling
              }
            if (Z)
              e: if (((r = null), Z))
                for (t = e; ; ) {
                  if (5 === t.tag) {
                    if (null === r) {
                      r = t
                      try {
                        ;(i = t.stateNode), n ? be(i) : Ce(t.stateNode, t.memoizedProps)
                      } catch (h) {
                        za(e, e.return, h)
                      }
                    }
                  } else if (6 === t.tag) {
                    if (null === r)
                      try {
                        ;(a = t.stateNode), n ? we(a) : xe(a, t.memoizedProps)
                      } catch (h) {
                        za(e, e.return, h)
                      }
                  } else if (
                    ((22 !== t.tag && 23 !== t.tag) || null === t.memoizedState || t === e) &&
                    null !== t.child
                  ) {
                    t = (t.child.return = t).child
                    continue
                  }
                  if (t === e) break e
                  for (; null === t.sibling; ) {
                    if (null === t.return || t.return === e) break e
                    r === t && (r = null), (t = t.return)
                  }
                  r === t && (r = null), (t.sibling.return = t.return), (t = t.sibling)
                }
          }
          break
        case 19:
          xo(t, e), So(e), 4 & r && Co(e)
          break
        case 21:
          break
        default:
          xo(t, e), So(e)
      }
    }
    function So(e) {
      var t = e.flags
      if (2 & t) {
        try {
          if (Z) {
            e: {
              for (var n = e.return; null !== n; ) {
                if (go(n)) {
                  var r = n
                  break e
                }
                n = n.return
              }
              throw Error(o(160))
            }
            switch (r.tag) {
              case 5:
                var i = r.stateNode
                32 & r.flags && (ye(i), (r.flags &= -33)),
                  (function e(t, n, r) {
                    var i = t.tag
                    if (5 === i || 6 === i) (t = t.stateNode), n ? pe(r, t, n) : se(r, t)
                    else if (4 !== i && null !== (t = t.child))
                      for (e(t, n, r), t = t.sibling; null !== t; ) e(t, n, r), (t = t.sibling)
                  })(e, mo(e), i)
                break
              case 3:
              case 4:
                var a = r.stateNode.containerInfo
                !(function e(t, n, r) {
                  var i = t.tag
                  if (5 === i || 6 === i) (t = t.stateNode), n ? ge(r, t, n) : ce(r, t)
                  else if (4 !== i && null !== (t = t.child))
                    for (e(t, n, r), t = t.sibling; null !== t; ) e(t, n, r), (t = t.sibling)
                })(e, mo(e), a)
                break
              default:
                throw Error(o(161))
            }
          }
        } catch (l) {
          za(e, e.return, l)
        }
        e.flags &= -3
      }
      4096 & t && (e.flags &= -4097)
    }
    function Oo(e) {
      for (; null !== lo; ) {
        var t = lo
        if (0 != (8772 & t.flags)) {
          var n,
            r,
            i,
            a = t.alternate
          try {
            if (0 != (8772 & t.flags))
              switch (t.tag) {
                case 0:
                case 11:
                case 15:
                  oo || ho(5, t)
                  break
                case 1:
                  var l,
                    s = t.stateNode,
                    c =
                      (4 & t.flags &&
                        !oo &&
                        (null === a
                          ? s.componentDidMount()
                          : ((l = t.elementType === t.type ? a.memoizedProps : kn(t.type, a.memoizedProps)),
                            s.componentDidUpdate(l, a.memoizedState, s.__reactInternalSnapshotBeforeUpdate))),
                      t.updateQueue)
                  null !== c && qn(0, c, s)
                  break
                case 3:
                  var u = t.updateQueue
                  if (null !== u) {
                    if ((a = null) !== t.child)
                      switch (t.child.tag) {
                        case 5:
                          a = T(t.child.stateNode)
                          break
                        case 1:
                          a = t.child.stateNode
                      }
                    qn(0, u, a)
                  }
                  break
                case 5:
                  var d = t.stateNode
                  null === a && 4 & t.flags && de(d, t.type, t.memoizedProps, t)
                  break
                case 6:
                case 4:
                case 12:
                case 19:
                case 17:
                case 21:
                case 22:
                case 23:
                case 25:
                  break
                case 13:
                  X &&
                    null === t.memoizedState &&
                    null !== (n = t.alternate) &&
                    null !== (r = n.memoizedState) &&
                    null !== (i = r.dehydrated) &&
                    Xe(i)
                  break
                default:
                  throw Error(o(163))
              }
            oo || (512 & t.flags && po(t))
          } catch (f) {
            za(t, t.return, f)
          }
        }
        if (t === e) {
          lo = null
          break
        }
        if (null !== (a = t.sibling)) {
          ;(a.return = t.return), (lo = a)
          break
        }
        lo = t.return
      }
    }
    function ko(e) {
      for (; null !== lo; ) {
        var t = lo
        if (t === e) {
          lo = null
          break
        }
        var n = t.sibling
        if (null !== n) {
          ;(n.return = t.return), (lo = n)
          break
        }
        lo = t.return
      }
    }
    function Po(e) {
      for (; null !== lo; ) {
        var t = lo
        try {
          switch (t.tag) {
            case 0:
            case 11:
            case 15:
              var n = t.return
              try {
                ho(4, t)
              } catch (s) {
                za(t, n, s)
              }
              break
            case 1:
              var r = t.stateNode
              if ('function' == typeof r.componentDidMount) {
                var i = t.return
                try {
                  r.componentDidMount()
                } catch (s) {
                  za(t, i, s)
                }
              }
              var o = t.return
              try {
                po(t)
              } catch (s) {
                za(t, o, s)
              }
              break
            case 5:
              var a = t.return
              try {
                po(t)
              } catch (s) {
                za(t, a, s)
              }
          }
        } catch (s) {
          za(t, t.return, s)
        }
        if (t === e) {
          lo = null
          break
        }
        var l = t.sibling
        if (null !== l) {
          ;(l.return = t.return), (lo = l)
          break
        }
        lo = t.return
      }
    }
    var _o = 0,
      Lo = 1,
      To = 2,
      Io = 3,
      Mo = 4
    function jo(e) {
      var t = Y(e)
      if (null != t) {
        if ('string' != typeof t.memoizedProps['data-testname']) throw Error(o(364))
        return t
      }
      if (null === (e = te(e))) throw Error(o(362))
      return e.stateNode.current
    }
    function Ro(e, t) {
      switch (t.$$typeof) {
        case _o:
          if (e.type === t.value) return 1
          break
        case Lo:
          e: {
            ;(t = t.value), (e = [e, 0])
            for (var n = 0; n < e.length; ) {
              var r = e[n++],
                i = e[n++],
                a = t[i]
              if (5 !== r.tag || !ie(r)) {
                for (; null != a && Ro(r, a); ) a = t[++i]
                if (i === t.length) {
                  t = !0
                  break e
                }
                for (r = r.child; null !== r; ) e.push(r, i), (r = r.sibling)
              }
            }
            t = !1
          }
          return t
        case To:
          if (5 === e.tag && oe(e.stateNode, t.value)) return 1
          break
        case Mo:
          if ((5 === e.tag || 6 === e.tag) && null !== (e = re(e)) && 0 <= e.indexOf(t.value)) return 1
          break
        case Io:
          if (
            5 === e.tag &&
            'string' == typeof (e = e.memoizedProps['data-testname']) &&
            e.toLowerCase() === t.value.toLowerCase()
          )
            return 1
          break
        default:
          throw Error(o(365))
      }
    }
    function Do(e) {
      switch (e.$$typeof) {
        case _o:
          return '<' + (E(e.value) || 'Unknown') + '>'
        case Lo:
          return ':has(' + (Do(e) || '') + ')'
        case To:
          return '[role="' + e.value + '"]'
        case Mo:
          return '"' + e.value + '"'
        case Io:
          return '[data-testname="' + e.value + '"]'
        default:
          throw Error(o(365))
      }
    }
    function Ao(e, t) {
      var n = []
      e = [e, 0]
      for (var r = 0; r < e.length; ) {
        var i = e[r++],
          o = e[r++],
          a = t[o]
        if (5 !== i.tag || !ie(i)) {
          for (; null != a && Ro(i, a); ) a = t[++o]
          if (o === t.length) n.push(i)
          else for (i = i.child; null !== i; ) e.push(i, o), (i = i.sibling)
        }
      }
      return n
    }
    function zo(e, t) {
      if (!ee) throw Error(o(363))
      ;(e = Ao((e = jo(e)), t)), (t = []), (e = Array.from(e))
      for (var n = 0; n < e.length; ) {
        var r = e[n++]
        if (5 === r.tag) ie(r) || t.push(r.stateNode)
        else for (r = r.child; null !== r; ) e.push(r), (r = r.sibling)
      }
      return t
    }
    'function' == typeof Symbol &&
      Symbol.for &&
      ((_o = (e = Symbol.for)('selector.component')),
      (Lo = e('selector.has_pseudo_class')),
      (To = e('selector.role')),
      (Io = e('selector.test_id')),
      (Mo = e('selector.text')))
    var No = Math.ceil,
      Fo = a.ReactCurrentDispatcher,
      Ho = a.ReactCurrentOwner,
      Bo = a.ReactCurrentBatchConfig,
      Vo = 0,
      Wo = null,
      Go = null,
      Zo = 0,
      Uo = 0,
      Xo = ot(0),
      Yo = 0,
      qo = null,
      $o = 0,
      Ko = 0,
      Qo = 0,
      Jo = null,
      ea = null,
      ta = 0,
      na = 1 / 0,
      ra = null
    function ia() {
      na = zt() + 500
    }
    var oa,
      aa = !1,
      la = null,
      sa = null,
      ca = !1,
      ua = null,
      da = 0,
      fa = 0,
      ha = null,
      pa = -1,
      ga = 0
    function ma() {
      return 0 != (6 & Vo) ? zt() : -1 !== pa ? pa : (pa = zt())
    }
    function va(e) {
      return 0 == (1 & e.mode)
        ? 1
        : 0 != (2 & Vo) && 0 !== Zo
        ? Zo & -Zo
        : null !== Sn.transition
        ? (ga = 0 === ga ? Pt() : ga)
        : 0 !== (e = It)
        ? e
        : $()
    }
    function ya(e, t, n, r) {
      if (50 < fa) throw ((fa = 0), (ha = null), Error(o(185)))
      Lt(e, n, r),
        (0 != (2 & Vo) && e === Wo) ||
          (e === Wo && (0 == (2 & Vo) && (Ko |= n), 4 === Yo) && Ea(e, Zo),
          ba(e, r),
          1 === n && 0 === Vo && 0 == (1 & t.mode) && (ia(), Ut) && qt())
    }
    function ba(e, t) {
      var n,
        r = e.callbackNode,
        i =
          ((function (e, t) {
            for (var n = e.suspendedLanes, r = e.pingedLanes, i = e.expirationTimes, o = e.pendingLanes; 0 < o; ) {
              var a = 31 - bt(o),
                l = 1 << a,
                s = i[a]
              ;-1 === s
                ? (0 != (l & n) && 0 == (l & r)) ||
                  (i[a] = (function (e, t) {
                    switch (e) {
                      case 1:
                      case 2:
                      case 4:
                        return t + 250
                      case 8:
                      case 16:
                      case 32:
                      case 64:
                      case 128:
                      case 256:
                      case 512:
                      case 1024:
                      case 2048:
                      case 4096:
                      case 8192:
                      case 16384:
                      case 32768:
                      case 65536:
                      case 131072:
                      case 262144:
                      case 524288:
                      case 1048576:
                      case 2097152:
                        return t + 5e3
                      default:
                        return -1
                    }
                  })(l, t))
                : s <= t && (e.expiredLanes |= l),
                (o &= ~l)
            }
          })(e, t),
          Ot(e, e === Wo ? Zo : 0))
      if (0 === i) null !== r && Rt(r), (e.callbackNode = null), (e.callbackPriority = 0)
      else if (e.callbackPriority !== (t = i & -i)) {
        if ((null != r && Rt(r), 1 === t))
          0 === e.tag ? ((n = Sa.bind(null, e)), (Ut = !0), Yt(n)) : Yt(Sa.bind(null, e)),
            Q
              ? J(function () {
                  0 == (6 & Vo) && qt()
                })
              : jt(Nt, qt),
            (r = null)
        else {
          switch (Mt(i)) {
            case 1:
              r = Nt
              break
            case 4:
              r = Ft
              break
            case 16:
            default:
              r = Ht
              break
            case 536870912:
              r = Bt
          }
          r = Fa(r, wa.bind(null, e))
        }
        ;(e.callbackPriority = t), (e.callbackNode = r)
      }
    }
    function wa(e, t) {
      if (((pa = -1), (ga = 0) != (6 & Vo))) throw Error(o(327))
      var n = e.callbackNode
      if (Da() && e.callbackNode !== n) return null
      var r = Ot(e, e === Wo ? Zo : 0)
      if (0 === r) return null
      if (0 != (30 & r) || 0 != (r & e.expiredLanes) || t) t = Ia(e, r)
      else {
        t = r
        var i = Vo,
          a = ((Vo |= 2), La())
        for ((Wo === e && Zo === t) || ((ra = null), ia(), Pa(e, t)); ; )
          try {
            for (; null !== Go && !Dt(); ) Ma(Go)
            break
          } catch (s) {
            _a(e, s)
          }
        In(), (Fo.current = a), (Vo = i), (t = null !== Go ? 0 : ((Wo = null), (Zo = 0), Yo))
      }
      if (0 !== t) {
        if (1 === (t = 2 === t && 0 !== (i = kt(e)) ? Ca(e, (r = i)) : t))
          throw ((n = qo), Pa(e, 0), Ea(e, r), ba(e, zt()), n)
        if (6 === t) Ea(e, r)
        else {
          if (
            ((i = e.current.alternate),
            0 == (30 & r) &&
              !(function (e) {
                for (var t = e; ; ) {
                  if (16384 & t.flags) {
                    var n = t.updateQueue
                    if (null !== n && null !== (n = n.stores))
                      for (var r = 0; r < n.length; r++) {
                        var i = n[r],
                          o = i.getSnapshot
                        i = i.value
                        try {
                          if (!Gt(o(), i)) return
                        } catch (a) {
                          return
                        }
                      }
                  }
                  if (((n = t.child), 16384 & t.subtreeFlags && null !== n)) (n.return = t), (t = n)
                  else {
                    if (t === e) break
                    for (; null === t.sibling; ) {
                      if (null === t.return || t.return === e) return 1
                      t = t.return
                    }
                    ;(t.sibling.return = t.return), (t = t.sibling)
                  }
                }
                return 1
              })(i) &&
              1 === (t = 2 === (t = Ia(e, r)) && 0 !== (a = kt(e)) ? Ca(e, (r = a)) : t))
          )
            throw ((n = qo), Pa(e, 0), Ea(e, r), ba(e, zt()), n)
          switch (((e.finishedWork = i), (e.finishedLanes = r), t)) {
            case 0:
            case 1:
              throw Error(o(345))
            case 2:
            case 5:
              Ra(e, ea, ra)
              break
            case 3:
              if ((Ea(e, r), (130023424 & r) === r && 10 < (t = ta + 500 - zt()))) {
                if (0 !== Ot(e, 0)) break
                if (((i = e.suspendedLanes) & r) !== r) {
                  ma(), (e.pingedLanes |= e.suspendedLanes & i)
                  break
                }
                e.timeoutHandle = B(Ra.bind(null, e, ea, ra), t)
              } else Ra(e, ea, ra)
              break
            case 4:
              if ((Ea(e, r), (4194240 & r) !== r)) {
                for (t = e.eventTimes, i = -1; 0 < r; ) {
                  var l = 31 - bt(r)
                  a = 1 << l
                  i < (l = t[l]) && (i = l), (r &= ~a)
                }
                ;(r = i),
                  10 <
                  (r =
                    ((r = zt() - r) < 120
                      ? 120
                      : r < 480
                      ? 480
                      : r < 1080
                      ? 1080
                      : r < 1920
                      ? 1920
                      : r < 3e3
                      ? 3e3
                      : r < 4320
                      ? 4320
                      : 1960 * No(r / 1960)) - r)
                    ? (e.timeoutHandle = B(Ra.bind(null, e, ea, ra), r))
                    : Ra(e, ea, ra)
              }
              break
            default:
              throw Error(o(329))
          }
        }
      }
      return ba(e, zt()), e.callbackNode === n ? wa.bind(null, e) : null
    }
    function Ca(e, t) {
      var n = Jo
      return (
        e.current.memoizedState.isDehydrated && (Pa(e, t).flags |= 256),
        2 !== (e = Ia(e, t)) && ((t = ea), (ea = n), null !== t) && xa(t),
        e
      )
    }
    function xa(e) {
      null === ea ? (ea = e) : ea.push.apply(ea, e)
    }
    function Ea(e, t) {
      for (t = t & ~Qo & ~Ko, e.suspendedLanes |= t, e.pingedLanes &= ~t, e = e.expirationTimes; 0 < t; ) {
        var n = 31 - bt(t),
          r = 1 << n
        ;(e[n] = -1), (t &= ~r)
      }
    }
    function Sa(e) {
      if (0 != (6 & Vo)) throw Error(o(327))
      Da()
      var t = Ot(e, 0)
      if (0 != (1 & t)) {
        var n,
          r = Ia(e, t)
        if (1 === (r = 0 !== e.tag && 2 === r && 0 !== (n = kt(e)) ? Ca(e, (t = n)) : r))
          throw ((r = qo), Pa(e, 0), Ea(e, t), ba(e, zt()), r)
        if (6 === r) throw Error(o(345))
        ;(e.finishedWork = e.current.alternate), (e.finishedLanes = t), Ra(e, ea, ra)
      }
      return ba(e, zt()), null
    }
    function Oa(e) {
      null !== ua && 0 === ua.tag && 0 == (6 & Vo) && Da()
      var t = Vo,
        n = ((Vo |= 1), Bo.transition),
        r = It
      try {
        if (((Bo.transition = null), (It = 1), e)) return e()
      } finally {
        ;(It = r), (Bo.transition = n), 0 == (6 & (Vo = t)) && qt()
      }
    }
    function ka() {
      ;(Uo = Xo.current), at(Xo)
    }
    function Pa(e, t) {
      ;(e.finishedWork = null), (e.finishedLanes = 0)
      var n,
        r,
        i,
        o = e.timeoutHandle
      if ((o !== W && ((e.timeoutHandle = W), V(o)), null !== Go))
        for (o = Go.return; null !== o; ) {
          var a = o
          switch ((cn(a), a.tag)) {
            case 1:
              null != (a = a.type.childContextTypes) && pt()
              break
            case 3:
              gr(), at(ut), at(ct), Cr()
              break
            case 5:
              vr(a)
              break
            case 4:
              gr()
              break
            case 13:
            case 19:
              at(yr)
              break
            case 10:
              jn(a.type._context)
              break
            case 22:
            case 23:
              ka()
          }
          o = o.return
        }
      if (
        ((Go = e = Wa((Wo = e).current, null)), (Zo = Uo = t), (Qo = Ko = $o = Yo = 0), (ea = Jo = qo = null) !== zn)
      ) {
        for (t = 0; t < zn.length; t++)
          null !== (a = (o = zn[t]).interleaved) &&
            ((o.interleaved = null),
            (n = a.next),
            null !== (r = o.pending) && ((i = r.next), (r.next = n), (a.next = i)),
            (o.pending = a))
        zn = null
      }
      return e
    }
    function _a(e, t) {
      for (;;) {
        var n = Go
        try {
          if ((In(), (xr.current = hi), _r)) {
            for (var r = Or.memoizedState; null !== r; ) {
              var i = r.queue
              null !== i && (i.pending = null), (r = r.next)
            }
            _r = !1
          }
          if (((Pr = kr = Or = null), (Lr = !1), (Tr = Sr = 0), (Ho.current = null) === n || null === n.return)) {
            ;(Yo = 1), (qo = t), (Go = null)
            break
          }
          e: {
            var a = e,
              l = n.return,
              s = t
            if (
              ((t = Zo), ((v = n).flags |= 32768), null !== s && 'object' == typeof s && 'function' == typeof s.then)
            ) {
              var c,
                u = s,
                d = v,
                f = d.tag,
                h =
                  (0 != (1 & d.mode) ||
                    (0 !== f && 11 !== f && 15 !== f) ||
                    ((c = d.alternate)
                      ? ((d.updateQueue = c.updateQueue), (d.memoizedState = c.memoizedState), (d.lanes = c.lanes))
                      : ((d.updateQueue = null), (d.memoizedState = null))),
                  Si(l))
              if (null !== h) {
                ;(h.flags &= -257), Oi(h, l, v, 0, t), 1 & h.mode && Ei(a, u, t)
                s = u
                var p,
                  g = (t = h).updateQueue
                null === g ? ((p = new Set()).add(s), (t.updateQueue = p)) : g.add(s)
                break e
              }
              if (0 == (1 & t)) {
                Ei(a, u, t), Ta()
                break e
              }
              s = Error(o(426))
            } else if (fn && 1 & v.mode) {
              var m = Si(l)
              if (null !== m) {
                0 == (65536 & m.flags) && (m.flags |= 256), Oi(m, l, v, 0, t), En(vi(s, v))
                break e
              }
            }
            ;(a = s = vi(s, v)), 4 !== Yo && (Yo = 2), null === Jo ? (Jo = [a]) : Jo.push(a), (a = l)
            do {
              switch (a.tag) {
                case 3:
                  ;(a.flags |= 65536), (t &= -t), (a.lanes |= t), Xn(a, Ci(0, s, t))
                  break e
                case 1:
                  var v = s,
                    y = a.type,
                    b = a.stateNode
                  if (
                    0 == (128 & a.flags) &&
                    ('function' == typeof y.getDerivedStateFromError ||
                      (null !== b && 'function' == typeof b.componentDidCatch && (null === sa || !sa.has(b))))
                  ) {
                    ;(a.flags |= 65536), (t &= -t), (a.lanes |= t), Xn(a, xi(a, v, t))
                    break e
                  }
              }
            } while (null !== (a = a.return))
          }
          ja(n)
        } catch (w) {
          ;(t = w), Go === n && null !== n && (Go = n.return)
          continue
        }
        break
      }
    }
    function La() {
      var e = Fo.current
      return (Fo.current = hi), null === e ? hi : e
    }
    function Ta() {
      ;(0 !== Yo && 3 !== Yo && 2 !== Yo) || (Yo = 4),
        null === Wo || (0 == (268435455 & $o) && 0 == (268435455 & Ko)) || Ea(Wo, Zo)
    }
    function Ia(e, t) {
      var n = Vo,
        r = ((Vo |= 2), La())
      for ((Wo === e && Zo === t) || ((ra = null), Pa(e, t)); ; )
        try {
          for (; null !== Go; ) Ma(Go)
          break
        } catch (i) {
          _a(e, i)
        }
      if ((In(), (Vo = n), (Fo.current = r), null !== Go)) throw Error(o(261))
      return (Wo = null), (Zo = 0), Yo
    }
    function Ma(e) {
      var t = oa(e.alternate, e, Uo)
      ;(e.memoizedProps = e.pendingProps), null === t ? ja(e) : (Go = t), (Ho.current = null)
    }
    function ja(e) {
      var t = e
      do {
        var n = t.alternate
        if (((e = t.return), 0 == (32768 & t.flags))) {
          if (
            null !==
            (n = (function (e, t, n) {
              var r = t.pendingProps
              switch ((cn(t), t.tag)) {
                case 2:
                case 16:
                case 15:
                case 0:
                case 11:
                case 7:
                case 8:
                case 12:
                case 9:
                case 14:
                  return ro(t), null
                case 1:
                case 17:
                  return ht(t.type) && pt(), ro(t), null
                case 3:
                  return (
                    (n = t.stateNode),
                    gr(),
                    at(ut),
                    at(ct),
                    Cr(),
                    n.pendingContext && ((n.context = n.pendingContext), (n.pendingContext = null)),
                    (null !== e && null !== e.child) ||
                      (wn(t)
                        ? eo(t)
                        : null === e ||
                          (e.memoizedState.isDehydrated && 0 == (256 & t.flags)) ||
                          ((t.flags |= 1024), null !== pn && (xa(pn), (pn = null)))),
                    Bi(e, t),
                    ro(t),
                    null
                  )
                case 5:
                  vr(t), (n = hr(fr.current))
                  var i = t.type
                  if (null !== e && null != t.stateNode)
                    Vi(e, t, i, r, n), e.ref !== t.ref && ((t.flags |= 512), (t.flags |= 2097152))
                  else {
                    if (!r) {
                      if (null === t.stateNode) throw Error(o(166))
                      return ro(t), null
                    }
                    if (((e = hr(ur.current)), wn(t))) {
                      if (!X) throw Error(o(175))
                      ;(e = Ve(t.stateNode, t.type, t.memoizedProps, n, e, t, !hn)),
                        null !== (t.updateQueue = e) && eo(t)
                    } else {
                      var a = D(i, r, n, e, t)
                      Fi(a, t, !1, !1), (t.stateNode = a), z(a, i, r, n, e) && eo(t)
                    }
                    null !== t.ref && ((t.flags |= 512), (t.flags |= 2097152))
                  }
                  return ro(t), null
                case 6:
                  if (e && null != t.stateNode) Wi(e, t, e.memoizedProps, r)
                  else {
                    if ('string' != typeof r && null === t.stateNode) throw Error(o(166))
                    if (((e = hr(fr.current)), (n = hr(ur.current)), wn(t))) {
                      if (!X) throw Error(o(176))
                      if (((e = t.stateNode), (n = t.memoizedProps), (r = We(e, n, t, !hn)) && null !== (i = un)))
                        switch (i.tag) {
                          case 3:
                            Ke(i.stateNode.containerInfo, e, n, 0 != (1 & i.mode))
                            break
                          case 5:
                            Qe(i.type, i.memoizedProps, i.stateNode, e, n, 0 != (1 & i.mode))
                        }
                      r && eo(t)
                    } else t.stateNode = H(r, e, n, t)
                  }
                  return ro(t), null
                case 13:
                  if (
                    (at(yr),
                    (r = t.memoizedState),
                    null === e || (null !== e.memoizedState && null !== e.memoizedState.dehydrated))
                  ) {
                    if (fn && null !== dn && 0 != (1 & t.mode) && 0 == (128 & t.flags))
                      Cn(), xn(), (t.flags |= 98560), (i = !1)
                    else if (((i = wn(t)), null !== r && null !== r.dehydrated)) {
                      if (null === e) {
                        if (!i) throw Error(o(318))
                        if (!X) throw Error(o(344))
                        if (!(i = null !== (i = t.memoizedState) ? i.dehydrated : null)) throw Error(o(317))
                        Ge(i, t)
                      } else xn(), 0 == (128 & t.flags) && (t.memoizedState = null), (t.flags |= 4)
                      ro(t), (i = !1)
                    } else null !== pn && (xa(pn), (pn = null)), (i = !0)
                    if (!i) return 65536 & t.flags ? t : null
                  }
                  return 0 != (128 & t.flags)
                    ? ((t.lanes = n), t)
                    : ((n = null !== r) != (null !== e && null !== e.memoizedState) &&
                        n &&
                        ((t.child.flags |= 8192), 0 != (1 & t.mode)) &&
                        (null === e || 0 != (1 & yr.current) ? 0 === Yo && (Yo = 3) : Ta()),
                      null !== t.updateQueue && (t.flags |= 4),
                      ro(t),
                      null)
                case 4:
                  return gr(), Bi(e, t), null === e && q(t.stateNode.containerInfo), ro(t), null
                case 10:
                  return jn(t.type._context), ro(t), null
                case 19:
                  if ((at(yr), null === (i = t.memoizedState)));
                  else {
                    if (((r = 0 != (128 & t.flags)), null === (a = i.rendering)))
                      if (r) no(i, !1)
                      else {
                        if (0 !== Yo || (null !== e && 0 != (128 & e.flags)))
                          for (e = t.child; null !== e; ) {
                            if (null !== (a = br(e))) {
                              for (
                                t.flags |= 128,
                                  no(i, !1),
                                  null !== (e = a.updateQueue) && ((t.updateQueue = e), (t.flags |= 4)),
                                  t.subtreeFlags = 0,
                                  e = n,
                                  n = t.child;
                                null !== n;

                              )
                                (i = e),
                                  ((r = n).flags &= 14680066),
                                  null === (a = r.alternate)
                                    ? ((r.childLanes = 0),
                                      (r.lanes = i),
                                      (r.child = null),
                                      (r.subtreeFlags = 0),
                                      (r.memoizedProps = null),
                                      (r.memoizedState = null),
                                      (r.updateQueue = null),
                                      (r.dependencies = null),
                                      (r.stateNode = null))
                                    : ((r.childLanes = a.childLanes),
                                      (r.lanes = a.lanes),
                                      (r.child = a.child),
                                      (r.subtreeFlags = 0),
                                      (r.deletions = null),
                                      (r.memoizedProps = a.memoizedProps),
                                      (r.memoizedState = a.memoizedState),
                                      (r.updateQueue = a.updateQueue),
                                      (r.type = a.type),
                                      (i = a.dependencies),
                                      (r.dependencies =
                                        null === i ? null : { lanes: i.lanes, firstContext: i.firstContext })),
                                  (n = n.sibling)
                              return lt(yr, (1 & yr.current) | 2), t.child
                            }
                            e = e.sibling
                          }
                        null !== i.tail && zt() > na && ((t.flags |= 128), no(i, !(r = !0)), (t.lanes = 4194304))
                      }
                    else {
                      if (!r)
                        if (null !== (e = br(a))) {
                          if (
                            ((t.flags |= 128),
                            (r = !0),
                            null !== (e = e.updateQueue) && ((t.updateQueue = e), (t.flags |= 4)),
                            no(i, !0),
                            null === i.tail && 'hidden' === i.tailMode && !a.alternate && !fn)
                          )
                            return ro(t), null
                        } else
                          2 * zt() - i.renderingStartTime > na &&
                            1073741824 !== n &&
                            ((t.flags |= 128), no(i, !(r = !0)), (t.lanes = 4194304))
                      i.isBackwards
                        ? ((a.sibling = t.child), (t.child = a))
                        : (null !== (e = i.last) ? (e.sibling = a) : (t.child = a), (i.last = a))
                    }
                    if (null !== i.tail)
                      return (
                        (t = i.tail),
                        (i.rendering = t),
                        (i.tail = t.sibling),
                        (i.renderingStartTime = zt()),
                        (t.sibling = null),
                        (e = yr.current),
                        lt(yr, r ? (1 & e) | 2 : 1 & e),
                        t
                      )
                  }
                  return ro(t), null
                case 22:
                case 23:
                  return (
                    ka(),
                    (n = null !== t.memoizedState),
                    null !== e && (null !== e.memoizedState) !== n && (t.flags |= 8192),
                    n && 0 != (1 & t.mode)
                      ? 0 != (1073741824 & Uo) && (ro(t), Z) && 6 & t.subtreeFlags && (t.flags |= 8192)
                      : ro(t),
                    null
                  )
                case 24:
                case 25:
                  return null
              }
              throw Error(o(156, t.tag))
            })(n, t, Uo))
          )
            return void (Go = n)
        } else {
          if (
            null !==
            (n = (function (e, t) {
              switch ((cn(t), t.tag)) {
                case 1:
                  return ht(t.type) && pt(), 65536 & (e = t.flags) ? ((t.flags = (-65537 & e) | 128), t) : null
                case 3:
                  return (
                    gr(),
                    at(ut),
                    at(ct),
                    Cr(),
                    0 != (65536 & (e = t.flags)) && 0 == (128 & e) ? ((t.flags = (-65537 & e) | 128), t) : null
                  )
                case 5:
                  return vr(t), null
                case 13:
                  if ((at(yr), null !== (e = t.memoizedState) && null !== e.dehydrated)) {
                    if (null === t.alternate) throw Error(o(340))
                    xn()
                  }
                  return 65536 & (e = t.flags) ? ((t.flags = (-65537 & e) | 128), t) : null
                case 19:
                  return at(yr), null
                case 4:
                  return gr(), null
                case 10:
                  return jn(t.type._context), null
                case 22:
                case 23:
                  return ka(), null
                default:
                  return null
              }
            })(n, t))
          )
            return (n.flags &= 32767), void (Go = n)
          if (null === e) return (Yo = 6), void (Go = null)
          ;(e.flags |= 32768), (e.subtreeFlags = 0), (e.deletions = null)
        }
        if (null !== (t = t.sibling)) return void (Go = t)
      } while (((Go = t = e), null !== t))
      0 === Yo && (Yo = 5)
    }
    function Ra(e, t, n) {
      var r = It,
        i = Bo.transition
      try {
        ;(Bo.transition = null), (It = 1)
        for (var a = e, l = t, s = n, c = r; Da(), null !== ua; );
        if (0 != (6 & Vo)) throw Error(o(327))
        s = a.finishedWork
        var u = a.finishedLanes
        if (null !== s) {
          if (((a.finishedWork = null), (a.finishedLanes = 0), s === a.current)) throw Error(o(177))
          ;(a.callbackNode = null), (a.callbackPriority = 0)
          var d,
            f,
            h = s.lanes | s.childLanes
          if (
            ((function (e, t) {
              var n = e.pendingLanes & ~t,
                r =
                  ((e.pendingLanes = t),
                  (e.suspendedLanes = 0),
                  (e.pingedLanes = 0),
                  (e.expiredLanes &= t),
                  (e.mutableReadLanes &= t),
                  (e.entangledLanes &= t),
                  (t = e.entanglements),
                  e.eventTimes)
              for (e = e.expirationTimes; 0 < n; ) {
                var i = 31 - bt(n),
                  o = 1 << i
                ;(t[i] = 0), (r[i] = -1), (e[i] = -1), (n &= ~o)
              }
            })(a, h),
            a === Wo && ((Go = Wo = null), (Zo = 0)),
            (0 == (2064 & s.subtreeFlags) && 0 == (2064 & s.flags)) ||
              ca ||
              ((ca = !0),
              Fa(Ht, function () {
                return Da(), null
              })),
            (h = 0 != (15990 & s.flags)),
            0 != (15990 & s.subtreeFlags) || h
              ? ((h = Bo.transition),
                (Bo.transition = null),
                (d = It),
                (It = 1),
                (f = Vo),
                (Vo |= 4),
                (Ho.current = null),
                (function (e, t) {
                  for (j(e.containerInfo), lo = t; null !== lo; )
                    if (((t = (e = lo).child), 0 != (1028 & e.subtreeFlags) && null !== t)) (t.return = e), (lo = t)
                    else
                      for (; null !== lo; ) {
                        e = lo
                        try {
                          var n,
                            r,
                            i,
                            a,
                            l = e.alternate
                          if (0 != (1024 & e.flags))
                            switch (e.tag) {
                              case 0:
                              case 11:
                              case 15:
                              case 5:
                              case 6:
                              case 4:
                              case 17:
                                break
                              case 1:
                                null !== l &&
                                  ((n = l.memoizedProps),
                                  (r = l.memoizedState),
                                  (a = (i = e.stateNode).getSnapshotBeforeUpdate(
                                    e.elementType === e.type ? n : kn(e.type, n),
                                    r
                                  )),
                                  (i.__reactInternalSnapshotBeforeUpdate = a))
                                break
                              case 3:
                                Z && Ee(e.stateNode.containerInfo)
                                break
                              default:
                                throw Error(o(163))
                            }
                        } catch (s) {
                          za(e, e.return, s)
                        }
                        if (null !== (t = e.sibling)) {
                          ;(t.return = e.return), (lo = t)
                          break
                        }
                        lo = e.return
                      }
                  ;(l = uo), (uo = !1)
                })(a, s),
                Eo(s, a),
                R(a.containerInfo),
                (function (e) {
                  !(function e(t, n, r) {
                    for (var i = 0 != (1 & t.mode); null !== lo; ) {
                      var o = lo,
                        a = o.child
                      if (22 === o.tag && i) {
                        var l = null !== o.memoizedState || io
                        if (!l) {
                          var s = o.alternate,
                            c = (null !== s && null !== s.memoizedState) || oo,
                            u = ((s = io), oo)
                          if (((io = l), (oo = c) && !u))
                            for (lo = o; null !== lo; )
                              (c = (l = lo).child),
                                (22 === l.tag && null !== l.memoizedState) || null === c
                                  ? Po(o)
                                  : ((c.return = l), (lo = c))
                          for (; null !== a; ) e((lo = a)), (a = a.sibling)
                          ;(lo = o), (io = s), (oo = u)
                        }
                        Oo(t)
                      } else 0 != (8772 & o.subtreeFlags) && null !== a ? ((a.return = o), (lo = a)) : Oo(t)
                    }
                  })((lo = e))
                })((a.current = s)),
                At(),
                (Vo = f),
                (It = d),
                (Bo.transition = h))
              : (a.current = s),
            ca && ((ca = !1), (ua = a), (da = u)),
            0 === (h = a.pendingLanes) && (sa = null),
            (function (e) {
              if (Wt && 'function' == typeof Wt.onCommitFiberRoot)
                try {
                  Wt.onCommitFiberRoot(Vt, e, void 0, 128 == (128 & e.current.flags))
                } catch (t) {}
            })(s.stateNode),
            ba(a, zt()),
            null !== l)
          )
            for (c = a.onRecoverableError, s = 0; s < l.length; s++)
              c((u = l[s]).value, { componentStack: u.stack, digest: u.digest })
          if (aa) throw ((aa = !1), (a = la), (la = null), a)
          0 != (1 & da) && 0 !== a.tag && Da(),
            0 != (1 & (h = a.pendingLanes)) ? (a === ha ? fa++ : ((fa = 0), (ha = a))) : (fa = 0),
            qt()
        }
      } finally {
        ;(Bo.transition = i), (It = r)
      }
      return null
    }
    function Da() {
      if (null !== ua) {
        var e = Mt(da),
          t = Bo.transition,
          n = It
        try {
          if (((Bo.transition = null), (It = e < 16 ? 16 : e), null === ua)) var r = !1
          else {
            if (((e = ua), (ua = null), (da = 0) != (6 & Vo))) throw Error(o(331))
            var i = Vo
            for (Vo |= 4, lo = e.current; null !== lo; ) {
              var a = lo,
                l = a.child
              if (0 != (16 & lo.flags)) {
                var s = a.deletions
                if (null !== s) {
                  for (var c = 0; c < s.length; c++) {
                    var u = s[c]
                    for (lo = u; null !== lo; ) {
                      switch ((f = lo).tag) {
                        case 0:
                        case 11:
                        case 15:
                          fo(8, f, a)
                      }
                      var d = f.child
                      if (null !== d) (d.return = f), (lo = d)
                      else
                        for (; null !== lo; ) {
                          var f,
                            h = (f = lo).sibling,
                            p = f.return
                          if (
                            ((function e(t) {
                              var n = t.alternate
                              null !== n && ((t.alternate = null), e(n)),
                                (t.child = null),
                                (t.deletions = null),
                                (t.sibling = null),
                                5 === t.tag && null !== (n = t.stateNode) && K(n),
                                (t.stateNode = null),
                                (t.return = null),
                                (t.dependencies = null),
                                (t.memoizedProps = null),
                                (t.memoizedState = null),
                                (t.pendingProps = null),
                                (t.stateNode = null),
                                (t.updateQueue = null)
                            })(f),
                            f === u)
                          ) {
                            lo = null
                            break
                          }
                          if (null !== h) {
                            ;(h.return = p), (lo = h)
                            break
                          }
                          lo = p
                        }
                    }
                  }
                  var g = a.alternate
                  if (null !== g) {
                    var m = g.child
                    if (null !== m) {
                      g.child = null
                      do {
                        var v = m.sibling
                      } while ((m.sibling = null) !== (m = v))
                    }
                  }
                  lo = a
                }
              }
              if (0 != (2064 & a.subtreeFlags) && null !== l) (l.return = a), (lo = l)
              else
                for (; null !== lo; ) {
                  if (0 != (2048 & (a = lo).flags))
                    switch (a.tag) {
                      case 0:
                      case 11:
                      case 15:
                        fo(9, a, a.return)
                    }
                  var y = a.sibling
                  if (null !== y) {
                    ;(y.return = a.return), (lo = y)
                    break
                  }
                  lo = a.return
                }
            }
            var b = e.current
            for (lo = b; null !== lo; ) {
              var w = (l = lo).child
              if (0 != (2064 & l.subtreeFlags) && null !== w) (w.return = l), (lo = w)
              else
                for (l = b; null !== lo; ) {
                  if (0 != (2048 & (s = lo).flags))
                    try {
                      switch (s.tag) {
                        case 0:
                        case 11:
                        case 15:
                          ho(9, s)
                      }
                    } catch (x) {
                      za(s, s.return, x)
                    }
                  if (s === l) {
                    lo = null
                    break
                  }
                  var C = s.sibling
                  if (null !== C) {
                    ;(C.return = s.return), (lo = C)
                    break
                  }
                  lo = s.return
                }
            }
            if (((Vo = i), qt(), Wt && 'function' == typeof Wt.onPostCommitFiberRoot))
              try {
                Wt.onPostCommitFiberRoot(Vt, e)
              } catch (x) {}
            r = !0
          }
          return r
        } finally {
          ;(It = n), (Bo.transition = t)
        }
      }
      return !1
    }
    function Aa(e, t, n) {
      ;(e = Zn(e, (t = Ci(0, (t = vi(n, t)), 1)), 1)), (t = ma()), null !== e && (Lt(e, 1, t), ba(e, t))
    }
    function za(e, t, n) {
      if (3 === e.tag) Aa(e, e, n)
      else
        for (; null !== t; ) {
          if (3 === t.tag) {
            Aa(t, e, n)
            break
          }
          if (1 === t.tag) {
            var r = t.stateNode
            if (
              'function' == typeof t.type.getDerivedStateFromError ||
              ('function' == typeof r.componentDidCatch && (null === sa || !sa.has(r)))
            ) {
              ;(t = Zn(t, (e = xi(t, (e = vi(n, e)), 1)), 1)), (e = ma()), null !== t && (Lt(t, 1, e), ba(t, e))
              break
            }
          }
          t = t.return
        }
    }
    function Na(e, t) {
      0 === t && (0 == (1 & e.mode) ? (t = 1) : ((t = Et), 0 == (130023424 & (Et <<= 1)) && (Et = 4194304)))
      var n = ma()
      null !== (e = Hn(e, t)) && (Lt(e, t, n), ba(e, n))
    }
    function Fa(e, t) {
      return jt(e, t)
    }
    function Ha(e, t, n, r) {
      ;(this.tag = e),
        (this.key = n),
        (this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null),
        (this.index = 0),
        (this.ref = null),
        (this.pendingProps = t),
        (this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null),
        (this.mode = r),
        (this.subtreeFlags = this.flags = 0),
        (this.deletions = null),
        (this.childLanes = this.lanes = 0),
        (this.alternate = null)
    }
    function Ba(e, t, n, r) {
      return new Ha(e, t, n, r)
    }
    function Va(e) {
      return (e = e.prototype) && e.isReactComponent
    }
    function Wa(e, t) {
      var n = e.alternate
      return (
        null === n
          ? (((n = Ba(e.tag, t, e.key, e.mode)).elementType = e.elementType),
            (n.type = e.type),
            (n.stateNode = e.stateNode),
            ((n.alternate = e).alternate = n))
          : ((n.pendingProps = t), (n.type = e.type), (n.flags = 0), (n.subtreeFlags = 0), (n.deletions = null)),
        (n.flags = 14680064 & e.flags),
        (n.childLanes = e.childLanes),
        (n.lanes = e.lanes),
        (n.child = e.child),
        (n.memoizedProps = e.memoizedProps),
        (n.memoizedState = e.memoizedState),
        (n.updateQueue = e.updateQueue),
        (t = e.dependencies),
        (n.dependencies = null === t ? null : { lanes: t.lanes, firstContext: t.firstContext }),
        (n.sibling = e.sibling),
        (n.index = e.index),
        (n.ref = e.ref),
        n
      )
    }
    function Ga(e, t, n, r, i, a) {
      var l = 2
      if ('function' == typeof (r = e)) Va(e) && (l = 1)
      else if ('string' == typeof e) l = 5
      else
        e: switch (e) {
          case u:
            return Za(n.children, i, a, t)
          case d:
            i |= l = 8
            break
          case f:
            return ((e = Ba(12, n, t, 2 | i)).elementType = f), (e.lanes = a), e
          case m:
            return ((e = Ba(13, n, t, i)).elementType = m), (e.lanes = a), e
          case v:
            return ((e = Ba(19, n, t, i)).elementType = v), (e.lanes = a), e
          case w:
            return Ua(n, i, a, t)
          default:
            if ('object' == typeof e && null !== e)
              switch (e.$$typeof) {
                case h:
                  l = 10
                  break e
                case p:
                  l = 9
                  break e
                case g:
                  l = 11
                  break e
                case y:
                  l = 14
                  break e
                case b:
                  ;(l = 16), (r = null)
                  break e
              }
            throw Error(o(130, null == e ? e : typeof e, ''))
        }
      return ((t = Ba(l, n, t, i)).elementType = e), (t.type = r), (t.lanes = a), t
    }
    function Za(e, t, n, r) {
      return ((e = Ba(7, e, r, t)).lanes = n), e
    }
    function Ua(e, t, n, r) {
      return ((e = Ba(22, e, r, t)).elementType = w), (e.lanes = n), (e.stateNode = { isHidden: !1 }), e
    }
    function Xa(e, t, n) {
      return ((e = Ba(6, e, null, t)).lanes = n), e
    }
    function Ya(e, t, n) {
      return (
        ((t = Ba(4, null !== e.children ? e.children : [], e.key, t)).lanes = n),
        (t.stateNode = { containerInfo: e.containerInfo, pendingChildren: null, implementation: e.implementation }),
        t
      )
    }
    function qa(e, t, n, r, i) {
      ;(this.tag = t),
        (this.containerInfo = e),
        (this.finishedWork = this.pingCache = this.current = this.pendingChildren = null),
        (this.timeoutHandle = W),
        (this.callbackNode = this.pendingContext = this.context = null),
        (this.callbackPriority = 0),
        (this.eventTimes = _t(0)),
        (this.expirationTimes = _t(-1)),
        (this.entangledLanes =
          this.finishedLanes =
          this.mutableReadLanes =
          this.expiredLanes =
          this.pingedLanes =
          this.suspendedLanes =
          this.pendingLanes =
            0),
        (this.entanglements = _t(0)),
        (this.identifierPrefix = r),
        (this.onRecoverableError = i),
        X && (this.mutableSourceEagerHydrationData = null)
    }
    function $a(e, t, n, r, i, o, a, l, s) {
      return (
        (e = new qa(e, t, 0, l, s)),
        1 === t ? ((t = 1), !0 === o && (t |= 8)) : (t = 0),
        (o = Ba(3, null, null, t)),
        ((e.current = o).stateNode = e),
        (o.memoizedState = {
          element: r,
          isDehydrated: n,
          cache: null,
          transitions: null,
          pendingSuspenseBoundaries: null
        }),
        Vn(o),
        e
      )
    }
    function Ka(e) {
      if (!e) return st
      e: {
        if (S((e = e._reactInternals)) !== e || 1 !== e.tag) throw Error(o(170))
        var t = e
        do {
          switch (t.tag) {
            case 3:
              t = t.stateNode.context
              break e
            case 1:
              if (ht(t.type)) {
                t = t.stateNode.__reactInternalMemoizedMergedChildContext
                break e
              }
          }
        } while (null !== (t = t.return))
        throw Error(o(171))
      }
      if (1 === e.tag) {
        var n = e.type
        if (ht(n)) return mt(e, n, t)
      }
      return t
    }
    function Qa(e) {
      var t = e._reactInternals
      if (void 0 !== t) return null === (e = P(t)) ? null : e.stateNode
      if ('function' == typeof e.render) throw Error(o(188))
      throw ((e = Object.keys(e).join(',')), Error(o(268, e)))
    }
    function Ja(e, t) {
      var n
      null !== (e = e.memoizedState) &&
        null !== e.dehydrated &&
        ((n = e.retryLane), (e.retryLane = 0 !== n && n < t ? n : t))
    }
    function el(e, t) {
      Ja(e, t), (e = e.alternate) && Ja(e, t)
    }
    function tl(e) {
      return null === (e = P(e)) ? null : e.stateNode
    }
    function nl() {
      return null
    }
    return (
      (oa = function (e, t, n) {
        if (null !== e)
          if (e.memoizedProps !== t.pendingProps || ut.current) Pi = !0
          else {
            if (0 == (e.lanes & n) && 0 == (128 & t.flags)) {
              Pi = !1
              var r = e,
                i = t,
                a = n
              switch (i.tag) {
                case 3:
                  zi(i), xn()
                  break
                case 5:
                  mr(i)
                  break
                case 1:
                  ht(i.type) && vt(i)
                  break
                case 4:
                  pr(i, i.stateNode.containerInfo)
                  break
                case 10:
                  Mn(0, i.type._context, i.memoizedProps.value)
                  break
                case 13:
                  var l = i.memoizedState
                  if (null !== l)
                    return null !== l.dehydrated
                      ? (lt(yr, 1 & yr.current), (i.flags |= 128), null)
                      : 0 != (a & i.child.childLanes)
                      ? Ui(r, i, a)
                      : (lt(yr, 1 & yr.current), null !== (r = Ji(r, i, a)) ? r.sibling : null)
                  lt(yr, 1 & yr.current)
                  break
                case 19:
                  if (((l = 0 != (a & i.childLanes)), 0 != (128 & r.flags))) {
                    if (l) return Ki(r, i, a)
                    i.flags |= 128
                  }
                  var s = i.memoizedState
                  if (
                    (null !== s && ((s.rendering = null), (s.tail = null), (s.lastEffect = null)),
                    lt(yr, yr.current),
                    l)
                  )
                    break
                  return null
                case 22:
                case 23:
                  return (i.lanes = 0), Mi(r, i, a)
              }
              return Ji(r, i, a)
            }
            Pi = 0 != (131072 & e.flags)
          }
        else (Pi = !1), fn && 0 != (1048576 & t.flags) && ln(t, Jt, t.index)
        switch (((t.lanes = 0), t.tag)) {
          case 2:
            var c = t.type,
              u = (Qi(e, t), (e = t.pendingProps), ft(t, ct.current)),
              d = (Dn(t, n), (u = Rr(null, t, c, e, u, n)), Dr())
            return (
              (t.flags |= 1),
              'object' == typeof u && null !== u && 'function' == typeof u.render && void 0 === u.$$typeof
                ? ((t.tag = 1),
                  (t.memoizedState = null),
                  (t.updateQueue = null),
                  ht(c) ? ((d = !0), vt(t)) : (d = !1),
                  (t.memoizedState = null !== u.state && void 0 !== u.state ? u.state : null),
                  Vn(t),
                  (u.updater = Qn),
                  nr(((t.stateNode = u)._reactInternals = t), c, e, n),
                  Ai(null, t, c, !0, d, n))
                : ((t.tag = 0), fn && d && sn(t), _i(null, t, u, n), t.child)
            )
          case 16:
            c = t.elementType
            e: {
              switch (
                (Qi(e, t),
                (e = t.pendingProps),
                (c = (u = c._init)(c._payload)),
                (t.type = c),
                (u = t.tag =
                  (function (e) {
                    if ('function' == typeof e) return Va(e) ? 1 : 0
                    if (null != e) {
                      if ((e = e.$$typeof) === g) return 11
                      if (e === y) return 14
                    }
                    return 2
                  })(c)),
                (e = kn(c, e)),
                u)
              ) {
                case 0:
                  t = Ri(null, t, c, e, n)
                  break e
                case 1:
                  t = Di(null, t, c, e, n)
                  break e
                case 11:
                  t = Li(null, t, c, e, n)
                  break e
                case 14:
                  t = Ti(null, t, c, kn(c.type, e), n)
                  break e
              }
              throw Error(o(306, c, ''))
            }
            return t
          case 0:
            return (c = t.type), (u = t.pendingProps), Ri(e, t, c, (u = t.elementType === c ? u : kn(c, u)), n)
          case 1:
            return (c = t.type), (u = t.pendingProps), Di(e, t, c, (u = t.elementType === c ? u : kn(c, u)), n)
          case 3:
            e: {
              if ((zi(t), null === e)) throw Error(o(387))
              ;(c = t.pendingProps), (u = (d = t.memoizedState).element), Wn(e, t), Yn(t, c, null, n)
              c = (m = t.memoizedState).element
              if (X && d.isDehydrated) {
                if (
                  ((d = {
                    element: c,
                    isDehydrated: !1,
                    cache: m.cache,
                    pendingSuspenseBoundaries: m.pendingSuspenseBoundaries,
                    transitions: m.transitions
                  }),
                  (t.updateQueue.baseState = d),
                  (t.memoizedState = d),
                  256 & t.flags)
                ) {
                  t = Ni(e, t, c, n, (u = vi(Error(o(423)), t)))
                  break e
                }
                if (c !== u) {
                  t = Ni(e, t, c, n, (u = vi(Error(o(424)), t)))
                  break e
                }
                for (
                  X && ((dn = He(t.stateNode.containerInfo)), (un = t), (hn = !(fn = !(pn = null)))),
                    n = sr(t, null, c, n),
                    t.child = n;
                  n;

                )
                  (n.flags = (-3 & n.flags) | 4096), (n = n.sibling)
              } else {
                if ((xn(), c === u)) {
                  t = Ji(e, t, n)
                  break e
                }
                _i(e, t, c, n)
              }
              t = t.child
            }
            return t
          case 5:
            return (
              mr(t),
              null === e && yn(t),
              (c = t.type),
              (u = t.pendingProps),
              (d = null !== e ? e.memoizedProps : null),
              (m = u.children),
              F(c, u) ? (m = null) : null !== d && F(c, d) && (t.flags |= 32),
              ji(e, t),
              _i(e, t, m, n),
              t.child
            )
          case 6:
            return null === e && yn(t), null
          case 13:
            return Ui(e, t, n)
          case 4:
            return (
              pr(t, t.stateNode.containerInfo),
              (c = t.pendingProps),
              null === e ? (t.child = lr(t, null, c, n)) : _i(e, t, c, n),
              t.child
            )
          case 11:
            return (c = t.type), (u = t.pendingProps), Li(e, t, c, (u = t.elementType === c ? u : kn(c, u)), n)
          case 7:
            return _i(e, t, t.pendingProps, n), t.child
          case 8:
          case 12:
            return _i(e, t, t.pendingProps.children, n), t.child
          case 10:
            e: {
              if (
                ((c = t.type._context),
                (u = t.pendingProps),
                (d = t.memoizedProps),
                Mn(0, c, (m = u.value)),
                null !== d)
              )
                if (Gt(d.value, m)) {
                  if (d.children === u.children && !ut.current) {
                    t = Ji(e, t, n)
                    break e
                  }
                } else
                  for (null !== (d = t.child) && (d.return = t); null !== d; ) {
                    var f = d.dependencies
                    if (null !== f)
                      for (var h, p, m = d.child, v = f.firstContext; null !== v; ) {
                        if (v.context === c) {
                          1 === d.tag &&
                            (((v = Gn(-1, n & -n)).tag = 2), null !== (h = d.updateQueue)) &&
                            (null === (p = (h = h.shared).pending) ? (v.next = v) : ((v.next = p.next), (p.next = v)),
                            (h.pending = v)),
                            (d.lanes |= n),
                            null !== (v = d.alternate) && (v.lanes |= n),
                            Rn(d.return, n, t),
                            (f.lanes |= n)
                          break
                        }
                        v = v.next
                      }
                    else if (10 === d.tag) m = d.type === t.type ? null : d.child
                    else if (18 === d.tag) {
                      if (null === (m = d.return)) throw Error(o(341))
                      ;(m.lanes |= n), null !== (f = m.alternate) && (f.lanes |= n), Rn(m, n, t), (m = d.sibling)
                    } else m = d.child
                    if (null !== m) m.return = d
                    else
                      for (m = d; null !== m; ) {
                        if (m === t) {
                          m = null
                          break
                        }
                        if (null !== (d = m.sibling)) {
                          ;(d.return = m.return), (m = d)
                          break
                        }
                        m = m.return
                      }
                    d = m
                  }
              _i(e, t, u.children, n), (t = t.child)
            }
            return t
          case 9:
            return (
              (u = t.type),
              (c = t.pendingProps.children),
              Dn(t, n),
              (c = c((u = An(u)))),
              (t.flags |= 1),
              _i(e, t, c, n),
              t.child
            )
          case 14:
            return (u = kn((c = t.type), t.pendingProps)), Ti(e, t, c, (u = kn(c.type, u)), n)
          case 15:
            return Ii(e, t, t.type, t.pendingProps, n)
          case 17:
            return (
              (c = t.type),
              (u = t.pendingProps),
              (u = t.elementType === c ? u : kn(c, u)),
              Qi(e, t),
              (t.tag = 1),
              ht(c) ? ((e = !0), vt(t)) : (e = !1),
              Dn(t, n),
              er(t, c, u),
              nr(t, c, u, n),
              Ai(null, t, c, !0, e, n)
            )
          case 19:
            return Ki(e, t, n)
          case 22:
            return Mi(e, t, n)
        }
        throw Error(o(156, t.tag))
      }),
      (t.attemptContinuousHydration = function (e) {
        var t
        13 === e.tag && (null !== (t = Hn(e, 134217728)) && ya(t, e, 134217728, ma()), el(e, 134217728))
      }),
      (t.attemptDiscreteHydration = function (e) {
        var t
        13 === e.tag && (null !== (t = Hn(e, 1)) && ya(t, e, 1, ma()), el(e, 1))
      }),
      (t.attemptHydrationAtCurrentPriority = function (e) {
        var t, n
        13 === e.tag && (null !== (n = Hn(e, (t = va(e)))) && ya(n, e, t, ma()), el(e, t))
      }),
      (t.attemptSynchronousHydration = function (e) {
        switch (e.tag) {
          case 3:
            var t,
              n = e.stateNode
            n.current.memoizedState.isDehydrated &&
              0 !== (t = St(n.pendingLanes)) &&
              (Tt(n, 1 | t), ba(n, zt()), 0 == (6 & Vo)) &&
              (ia(), qt())
            break
          case 13:
            Oa(function () {
              var t,
                n = Hn(e, 1)
              null !== n && ((t = ma()), ya(n, e, 1, t))
            }),
              el(e, 1)
        }
      }),
      (t.batchedUpdates = function (e, t) {
        var n = Vo
        Vo |= 1
        try {
          return e(t)
        } finally {
          0 === (Vo = n) && (ia(), Ut) && qt()
        }
      }),
      (t.createComponentSelector = function (e) {
        return { $$typeof: _o, value: e }
      }),
      (t.createContainer = function (e, t, n, r, i, o, a) {
        return $a(e, t, !1, null, 0, r, 0, o, a)
      }),
      (t.createHasPseudoClassSelector = function (e) {
        return { $$typeof: Lo, value: e }
      }),
      (t.createHydrationContainer = function (e, t, n, r, i, o, a, l, s) {
        return (
          ((e = $a(n, r, !0, e, 0, o, 0, l, s)).context = Ka(null)),
          (n = e.current),
          ((o = Gn((r = ma()), (i = va(n)))).callback = null != t ? t : null),
          Zn(n, o, i),
          (e.current.lanes = i),
          Lt(e, i, r),
          ba(e, r),
          e
        )
      }),
      (t.createPortal = function (e, t, n) {
        var r = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null
        return { $$typeof: c, key: null == r ? null : '' + r, children: e, containerInfo: t, implementation: n }
      }),
      (t.createRoleSelector = function (e) {
        return { $$typeof: To, value: e }
      }),
      (t.createTestNameSelector = function (e) {
        return { $$typeof: Io, value: e }
      }),
      (t.createTextSelector = function (e) {
        return { $$typeof: Mo, value: e }
      }),
      (t.deferredUpdates = function (e) {
        var t = It,
          n = Bo.transition
        try {
          return (Bo.transition = null), (It = 16), e()
        } finally {
          ;(It = t), (Bo.transition = n)
        }
      }),
      (t.discreteUpdates = function (e, t, n, r, i) {
        var o = It,
          a = Bo.transition
        try {
          return (Bo.transition = null), (It = 1), e(t, n, r, i)
        } finally {
          ;(It = o), (Bo.transition = a), 0 === Vo && ia()
        }
      }),
      (t.findAllNodes = zo),
      (t.findBoundingRects = function (e, t) {
        if (!ee) throw Error(o(363))
        ;(t = zo(e, t)), (e = [])
        for (var n = 0; n < t.length; n++) e.push(ne(t[n]))
        for (t = e.length - 1; 0 < t; t--)
          for (var r = (n = e[t]).x, i = r + n.width, a = n.y, l = a + n.height, s = t - 1; 0 <= s; s--)
            if (t !== s) {
              var c = e[s],
                u = c.x,
                d = u + c.width,
                f = c.y,
                h = f + c.height
              if (u <= r && f <= a && i <= d && l <= h) {
                e.splice(t, 1)
                break
              }
              if (!(r !== u || n.width !== c.width || h < a || l < f)) {
                a < f && ((c.height += f - a), (c.y = a)), h < l && (c.height = l - f), e.splice(t, 1)
                break
              }
              if (!(a !== f || n.height !== c.height || d < r || i < u)) {
                r < u && ((c.width += u - r), (c.x = r)), d < i && (c.width = i - u), e.splice(t, 1)
                break
              }
            }
        return e
      }),
      (t.findHostInstance = Qa),
      (t.findHostInstanceWithNoPortals = function (e) {
        return null ===
          (e =
            null !== (e = k(e))
              ? (function e(t) {
                  if (5 === t.tag || 6 === t.tag) return t
                  for (t = t.child; null !== t; ) {
                    if (4 !== t.tag) {
                      var n = e(t)
                      if (null !== n) return n
                    }
                    t = t.sibling
                  }
                  return null
                })(e)
              : null)
          ? null
          : e.stateNode
      }),
      (t.findHostInstanceWithWarning = Qa),
      (t.flushControlled = function (e) {
        var t = Vo,
          n = ((Vo |= 1), Bo.transition),
          r = It
        try {
          ;(Bo.transition = null), (It = 1), e()
        } finally {
          ;(It = r), (Bo.transition = n), 0 === (Vo = t) && (ia(), qt())
        }
      }),
      (t.flushPassiveEffects = Da),
      (t.flushSync = Oa),
      (t.focusWithin = function (e, t) {
        if (!ee) throw Error(o(363))
        for (t = Ao((e = jo(e)), t), t = Array.from(t), e = 0; e < t.length; ) {
          var n = t[e++]
          if (!ie(n)) {
            if (5 === n.tag && ae(n.stateNode)) return !0
            for (n = n.child; null !== n; ) t.push(n), (n = n.sibling)
          }
        }
        return !1
      }),
      (t.getCurrentUpdatePriority = function () {
        return It
      }),
      (t.getFindAllNodesFailureDescription = function (e, t) {
        if (!ee) throw Error(o(363))
        var n = 0,
          r = []
        e = [jo(e), 0]
        for (var i = 0; i < e.length; ) {
          var a = e[i++],
            l = e[i++],
            s = t[l]
          if ((5 !== a.tag || !ie(a)) && (Ro(a, s) && (r.push(Do(s)), n < ++l) && (n = l), l < t.length))
            for (a = a.child; null !== a; ) e.push(a, l), (a = a.sibling)
        }
        if (n < t.length) {
          for (e = []; n < t.length; n++) e.push(Do(t[n]))
          return (
            'findAllNodes was able to match part of the selector:\n  ' +
            r.join(' > ') +
            '\n\nNo matching component was found for:\n  ' +
            e.join(' > ')
          )
        }
        return null
      }),
      (t.getPublicRootInstance = function (e) {
        return (e = e.current).child ? (5 !== e.child.tag ? e.child.stateNode : T(e.child.stateNode)) : null
      }),
      (t.injectIntoDevTools = function (e) {
        if (
          ((e = {
            bundleType: e.bundleType,
            version: e.version,
            rendererPackageName: e.rendererPackageName,
            rendererConfig: e.rendererConfig,
            overrideHookState: null,
            overrideHookStateDeletePath: null,
            overrideHookStateRenamePath: null,
            overrideProps: null,
            overridePropsDeletePath: null,
            overridePropsRenamePath: null,
            setErrorHandler: null,
            setSuspenseHandler: null,
            scheduleUpdate: null,
            currentDispatcherRef: a.ReactCurrentDispatcher,
            findHostInstanceByFiber: tl,
            findFiberByHostInstance: e.findFiberByHostInstance || nl,
            findHostInstancesForRefresh: null,
            scheduleRefresh: null,
            scheduleRoot: null,
            setRefreshHandler: null,
            getCurrentFiber: null,
            reconcilerVersion: '18.2.0'
          }),
          'undefined' == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)
        )
          e = !1
        else {
          var t = __REACT_DEVTOOLS_GLOBAL_HOOK__
          if (t.isDisabled || !t.supportsFiber) e = !0
          else {
            try {
              ;(Vt = t.inject(e)), (Wt = t)
            } catch (n) {}
            e = !!t.checkDCE
          }
        }
        return e
      }),
      (t.isAlreadyRendering = function () {
        return !1
      }),
      (t.observeVisibleRects = function (e, t, n, r) {
        if (!ee) throw Error(o(363))
        e = zo(e, t)
        var i = le(e, n, r).disconnect
        return {
          disconnect: function () {
            i()
          }
        }
      }),
      (t.registerMutableSourceForHydration = function (e, t) {
        var n = (n = t._getVersion)(t._source)
        null == e.mutableSourceEagerHydrationData
          ? (e.mutableSourceEagerHydrationData = [t, n])
          : e.mutableSourceEagerHydrationData.push(t, n)
      }),
      (t.runWithPriority = function (e, t) {
        var n = It
        try {
          return (It = e), t()
        } finally {
          It = n
        }
      }),
      (t.shouldError = function () {
        return null
      }),
      (t.shouldSuspend = function () {
        return !1
      }),
      (t.updateContainer = function (e, t, n, r) {
        var i = t.current,
          o = ma(),
          a = va(i)
        return (
          (n = Ka(n)),
          null === t.context ? (t.context = n) : (t.pendingContext = n),
          ((t = Gn(o, a)).payload = { element: e }),
          null !== (r = void 0 === r ? null : r) && (t.callback = r),
          null !== (e = Zn(i, t, a)) && (ya(e, i, a, o), Un(e, i, a)),
          a
        )
      }),
      t
    )
  }),
    (f = y.exports)
  var iy = { exports: {} }
  l = {
    ConcurrentRoot: 1,
    ContinuousEventPriority: 4,
    DefaultEventPriority: 16,
    DiscreteEventPriority: 1,
    IdleEventPriority: 536870912,
    LegacyRoot: 0
  }
  iy.exports = l
  const oy = {
    children: !0,
    ref: !0,
    key: !0,
    style: !0,
    forwardedRef: !0,
    unstable_applyCache: !0,
    unstable_applyDrawHitFromCache: !0
  }
  let ay = !1,
    ly = !1
  const sy = '.react-konva-event'
  let cy = !1
  const uy = {}
  function dy(e, t, n = uy) {
    var r, i, o
    for (a in (!ay &&
      'zIndex' in t &&
      (console.warn(
        'ReactKonva: You are using "zIndex" attribute for a Konva node.\nreact-konva may get confused with ordering. Just define correct order of elements in your render function of a component.\nFor more info see: https://github.com/konvajs/react-konva/issues/194\n'
      ),
      (ay = !0)),
    !ly &&
      t.draggable &&
      ((r = void 0 !== t.x || void 0 !== t.y), (i = t.onDragEnd || t.onDragMove), r) &&
      !i &&
      (console.warn(
        'ReactKonva: You have a Konva node with draggable = true and position defined but no onDragMove or onDragEnd events are handled.\nPosition of a node will be changed during drag&drop, so you should update state of the react app as well.\nConsider to add onDragMove or onDragEnd events.\nFor more info see: https://github.com/konvajs/react-konva/issues/256\n'
      ),
      (ly = !0)),
    n))
      oy[a] ||
        ((l = 'on' === a.slice(0, 2)),
        (o = n[a] !== t[a]),
        l &&
          o &&
          ('content' === (c = a.substr(2).toLowerCase()).substr(0, 7) &&
            (c = 'content' + c.substr(7, 1).toUpperCase() + c.substr(8)),
          e.off(c, n[a])),
        t.hasOwnProperty(a) || e.setAttr(a, void 0))
    var a,
      l,
      s,
      c,
      u = cy || t._useStrictMode,
      d = {},
      f = !1,
      h = {}
    for (a in t)
      oy[a] ||
        ((l = 'on' === a.slice(0, 2)),
        (s = n[a] !== t[a]),
        l &&
          s &&
          ('content' === (c = a.substr(2).toLowerCase()).substr(0, 7) &&
            (c = 'content' + c.substr(7, 1).toUpperCase() + c.substr(8)),
          t[a]) &&
          (h[c] = t[a]),
        !l && (t[a] !== n[a] || (u && t[a] !== e.getAttr(a))) && ((f = !0), (d[a] = t[a])))
    for (c in (f && (e.setAttrs(d), fy(e)), h)) e.on(c + sy, h[c])
  }
  function fy(e) {
    jg.autoDrawEnabled || ((e = e.getLayer() || e.getStage()) && e.batchDraw())
  }
  const hy = {},
    py = {}
  function gy(e, t, n) {
    t._remove(), e.add(t), t.setZIndex(n.getZIndex()), fy(e)
  }
  ;(lv.Node.prototype._applyProps = dy), (ug = setTimeout), (Og = clearTimeout)
  p = Object.freeze(
    Object.defineProperty(
      {
        __proto__: null,
        appendInitialChild: function (e, t) {
          'string' == typeof t
            ? console.error('Do not use plain text as child of Konva.Node. You are using text: ' + t)
            : (e.add(t), fy(e))
        },
        createInstance: function (e, t, n) {
          let r = lv[e]
          r ||
            (console.error(
              `Konva has no node with the type ${e}. Group will be used instead. If you use minimal version of react-konva, just import required nodes into Konva: "import "konva/lib/shapes/${e}"  If you want to render DOM elements as part of canvas tree take a look into this demo: https://konvajs.github.io/docs/react/DOM_Portal.html`
            ),
            (r = lv.Group))
          var i,
            o = {},
            a = {}
          for (i in t) 'on' === i.slice(0, 2) ? (a[i] = t[i]) : (o[i] = t[i])
          return dy((e = new r(o)), a), e
        },
        createTextInstance: function (e, t, n) {
          console.error(`Text components are not supported for now in ReactKonva. Your text is: "${e}"`)
        },
        finalizeInitialChildren: function (e, t, n) {
          return !1
        },
        getPublicInstance: function (e) {
          return e
        },
        prepareForCommit: function () {
          return null
        },
        preparePortalMount: function () {
          return null
        },
        prepareUpdate: function (e, t, n, r) {
          return py
        },
        resetAfterCommit: function () {},
        resetTextContent: function (e) {},
        shouldDeprioritizeSubtree: function (e, t) {
          return !1
        },
        getRootHostContext: function () {
          return hy
        },
        getChildHostContext: function () {
          return hy
        },
        scheduleTimeout: ug,
        cancelTimeout: Og,
        noTimeout: -1,
        shouldSetTextContent: function (e, t) {
          return !1
        },
        isPrimaryRenderer: !1,
        warnsIfNotActing: !0,
        supportsMutation: !0,
        appendChild: function (e, t) {
          t.parent === e ? t.moveToTop() : e.add(t), fy(e)
        },
        appendChildToContainer: function (e, t) {
          t.parent === e ? t.moveToTop() : e.add(t), fy(e)
        },
        insertBefore: gy,
        insertInContainerBefore: function (e, t, n) {
          gy(e, t, n)
        },
        removeChild: function (e, t) {
          t.destroy(), t.off(sy), fy(e)
        },
        removeChildFromContainer: function (e, t) {
          t.destroy(), t.off(sy), fy(e)
        },
        commitTextUpdate: function (e, t, n) {
          console.error(`Text components are not yet supported in ReactKonva. You text is: "${n}"`)
        },
        commitMount: function (e, t, n) {},
        commitUpdate: function (e, t, n, r, i) {
          dy(e, i, r)
        },
        hideInstance: function (e) {
          e.hide(), fy(e)
        },
        hideTextInstance: function (e) {},
        unhideInstance: function (e, t) {
          ;(null != t.visible && !t.visible) || e.show()
        },
        unhideTextInstance: function (e, t) {},
        clearContainer: function (e) {},
        detachDeletedInstance: function () {},
        getCurrentEventPriority: () => iy.exports.DefaultEventPriority,
        now: fe.exports.unstable_now,
        idlePriority: fe.exports.unstable_IdlePriority,
        run: fe.exports.unstable_runWithPriority
      },
      Symbol.toStringTag,
      { value: 'Module' }
    )
  )
  var my = Object.defineProperty,
    vy = Object.defineProperties,
    yy = Object.getOwnPropertyDescriptors,
    by = Object.getOwnPropertySymbols,
    wy = Object.prototype.hasOwnProperty,
    Cy = Object.prototype.propertyIsEnumerable,
    xy = (e, t, n) => (t in e ? my(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : (e[t] = n)),
    Ey = (e, t) => {
      for (var n in (t = t || {})) wy.call(t, n) && xy(e, n, t[n])
      if (by) for (var n of by(t)) Cy.call(t, n) && xy(e, n, t[n])
      return e
    }
  function Sy(e) {
    try {
      return Object.defineProperties(e, {
        _currentRenderer: { get: () => null, set() {} },
        _currentRenderer2: { get: () => null, set() {} }
      })
    } catch (sD) {
      return e
    }
  }
  const Oy = Sy(s.exports.createContext(null))
  class ky extends s.exports.Component {
    render() {
      return s.exports.createElement(Oy.Provider, { value: this._reactInternals }, this.props.children)
    }
  }
  const { ReactCurrentOwner: Py, ReactCurrentDispatcher: _y } =
    s.exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED
  function Ly() {
    const e = (function () {
      var e,
        t = (function () {
          const e = s.exports.useContext(Oy)
          if (null === e) throw new Error('its-fine: useFiber must be called within a <FiberProvider />!')
          const t = s.exports.useId()
          return s.exports.useMemo(() => {
            var n
            return null != (n = null == Py ? void 0 : Py.current)
              ? n
              : (function e(t, n, r) {
                  if (t) {
                    if (!0 === r(t)) return t
                    let o = n ? t.return : t.child
                    for (; o; ) {
                      var i = e(o, n, r)
                      if (i) return i
                      o = n ? null : o.sibling
                    }
                  }
                })(e, !1, e => {
                  let n = e.memoizedState
                  for (; n; ) {
                    if (n.memoizedState === t) return !0
                    n = n.next
                  }
                })
          }, [e, t])
        })(),
        [n] = s.exports.useState(() => new Map())
      n.clear()
      let r = t
      for (; r; ) {
        var i = null == (i = r.type) ? void 0 : i._context
        i &&
          i !== Oy &&
          !n.has(i) &&
          n.set(i, null == (e = null == _y ? void 0 : _y.current) ? void 0 : e.readContext(Sy(i))),
          (r = r.return)
      }
      return n
    })()
    return s.exports.useMemo(
      () =>
        Array.from(e.keys()).reduce(
          (t, n) => r =>
            s.exports.createElement(
              t,
              null,
              s.exports.createElement(n.Provider, ((e, t) => vy(e, yy(t)))(Ey({}, r), { value: e.get(n) }))
            ),
          e => s.exports.createElement(ky, Ey({}, e))
        ),
      [e]
    )
  }
  const Ty = e => {
      const t = ue.useRef(),
        n = ue.useRef(),
        r = ue.useRef(),
        i = (function (e) {
          const t = ue.useRef()
          return (
            ue.useLayoutEffect(() => {
              t.current = e
            }),
            t.current
          )
        })(e),
        o = Ly(),
        a = t => {
          var n = e.forwardedRef
          n && ('function' == typeof n ? n(t) : (n.current = t))
        }
      return (
        ue.useLayoutEffect(
          () => (
            (n.current = new lv.Stage({ width: e.width, height: e.height, container: t.current })),
            a(n.current),
            (r.current = Dy.createContainer(n.current, iy.exports.LegacyRoot, !1, null)),
            Dy.updateContainer(ue.createElement(o, {}, e.children), r.current),
            () => {
              lv.isBrowser && (a(null), Dy.updateContainer(null, r.current, null), n.current.destroy())
            }
          ),
          []
        ),
        ue.useLayoutEffect(() => {
          a(n.current), dy(n.current, e, i), Dy.updateContainer(ue.createElement(o, {}, e.children), r.current, null)
        }),
        ue.createElement('div', {
          ref: t,
          accessKey: e.accessKey,
          className: e.className,
          role: e.role,
          style: e.style,
          tabIndex: e.tabIndex,
          title: e.title
        })
      )
    },
    Iy = 'Layer',
    My = 'Ellipse',
    jy = 'Image',
    Ry = 'Transformer',
    Dy = f(p)
  Dy.injectIntoDevTools({
    findHostInstanceByFiber: () => null,
    bundleType: 0,
    version: ue.version,
    rendererPackageName: 'react-konva'
  }),
    (Fj = ue.forwardRef((e, t) => ue.createElement(ky, {}, ue.createElement(Ty, { ...e, forwardedRef: t }))))
  function Ay(e, t, n, r) {
    return Math.min(e / n, t / r) || 1
  }
  var zy = 'FIE_root',
    Ny = 'FIE_transformers-layer',
    Fy = 'FIE_original-image',
    Hy = 'FIE_nodes-transformer',
    By = 'watermark',
    Vy = '353297d2-40b4-4684-a875-45a2178a8157',
    Wy = {
      FINETUNE: 'Finetune',
      FILTERS: 'Filters',
      ADJUST: 'Adjust',
      WATERMARK: 'Watermark',
      ANNOTATE: 'Annotate',
      RESIZE: 'Resize'
    },
    Gy = {
      CROP: 'Crop',
      ROTATE: 'Rotate',
      FLIP_X: 'Flip_X',
      FLIP_Y: 'Flip_Y',
      BRIGHTNESS: 'Brightness',
      CONTRAST: 'Contrast',
      HSV: 'HueSaturationValue',
      WARMTH: 'Warmth',
      BLUR: 'Blur',
      THRESHOLD: 'Threshold',
      POSTERIZE: 'Posterize',
      PIXELATE: 'Pixelate',
      NOISE: 'Noise',
      FILTERS: 'Filters',
      RECT: 'Rect',
      ELLIPSE: 'Ellipse',
      POLYGON: 'Polygon',
      TEXT: 'Text',
      LINE: 'Line',
      IMAGE: 'Image',
      ARROW: 'Arrow',
      WATERMARK: 'Watermark',
      PEN: 'Pen',
      RESIZE: 'Resize'
    },
    Zy = ['png', 'jpeg', 'jpg'],
    Uy = [].concat(Zy, ['svg', 'gif', 'avif', 'apng']),
    Xy = Zy[0],
    Yy = { DEFAULT: 'default', DRAW: 'crosshair', SELECT: 'pointer', MOVE: 'move', DRAG: 'GRAB' },
    qy = 'original',
    $y = 'ellipse',
    Ky = {
      TOP_LEFT: 'top-left',
      TOP_CENTER: 'top-center',
      TOP_RIGHT: 'top-right',
      MIDDLE_LEFT: 'middle-left',
      MIDDLE_CENTER: 'middle-center',
      MIDDLE_RIGHT: 'middle-right',
      BOTTOM_LEFT: 'bottom-left',
      BOTTOM_CENTER: 'bottom-center',
      BOTTOM_RIGHT: 'bottom-right'
    },
    Qy = 14,
    Jy = 14,
    eb = 'close-button-clicked',
    tb = 'warning',
    nb = 'error'
  function rb(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function ib(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? rb(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : rb(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var ob = 'ADD_FILTER'
  function ab(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function lb(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? ab(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : ab(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var sb = 'HIDE_LOADER'
  function cb(e) {
    return Pg(e) || jp(e) || Rp(e) || _g()
  }
  r(
    (dS = {
      theme: { palette: { 'bg-primary-active': '#ECF3FF' }, typography: { fontFamily: 'Roboto, Arial' } },
      annotationsCommon: {
        fill: '#000000',
        stroke: '#000000',
        strokeWidth: 0,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        shadowBlur: 0,
        shadowColor: '#000000',
        shadowOpacity: 1,
        opacity: 1
      }
    }),
    Gy.TEXT,
    {
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
      fontFamily: 'Arial',
      fonts: [{ label: 'Arial', value: 'Arial' }, 'Tahoma', 'Sans-serif', { label: 'Comic Sans', value: 'Comic-sans' }],
      fontSize: 14,
      letterSpacing: 0,
      lineHeight: 1,
      align: 'left',
      fontStyle: 'normal',
      onFontChange: void 0
    }
  ),
    r(dS, Gy.IMAGE, { fill: void 0, disableUpload: !1, gallery: [] }),
    r(dS, Gy.RECT, { cornerRadius: 0 }),
    r(dS, Gy.ELLIPSE, {}),
    r(dS, Gy.POLYGON, { sides: 3 }),
    r(dS, Gy.PEN, { strokeWidth: 1, tension: 0.5, lineCap: 'round' }),
    r(dS, Gy.LINE, { lineCap: 'butt', strokeWidth: 1 }),
    r(dS, Gy.ARROW, { strokeWidth: 6, lineCap: 'butt', pointerLength: void 0, pointerWidth: void 0 }),
    r(dS, Gy.WATERMARK, { gallery: [], textScalingRatio: 0.5, imageScalingRatio: 0.5 }),
    r(dS, Gy.CROP, {
      minWidth: Qy,
      minHeight: Jy,
      width: null,
      height: null,
      maxWidth: null,
      maxHeight: null,
      ratio: 'original',
      ratioTitleKey: void 0,
      noPresets: !1,
      autoResize: !1,
      presetsItems: [],
      presetsFolders: []
    }),
    r(dS, Gy.ROTATE, { angle: 60, componentType: 'slider' }),
    r(dS, 'tabsIds', []),
    r(dS, 'defaultTabId', Wy.ADJUST),
    r(dS, 'defaultToolId', Gy.CROP),
    r(dS, 'onClose', void 0),
    r(dS, 'onSave', void 0),
    r(dS, 'onBeforeSave', void 0),
    r(dS, 'closeAfterSave', !1),
    r(dS, 'defaultSavedImageName', void 0),
    r(dS, 'defaultSavedImageType', null),
    r(dS, 'defaultSavedImageQuality', 0.92),
    r(dS, 'forceToPngInEllipticalCrop', !1),
    r(dS, 'useBackendTranslations', !0),
    r(dS, 'translations', null),
    r(dS, 'language', 'en'),
    r(dS, 'avoidChangesNotSavedAlertOnLeave', !1),
    r(dS, 'loadableDesignState', null),
    r(dS, 'moreSaveOptions', []),
    r(dS, 'savingPixelRatio', 4),
    r(dS, 'previewPixelRatio', (window && window.devicePixelRatio) || 1),
    r(dS, 'showBackButton', !1),
    r(dS, 'useCloudimage', !1),
    r(dS, 'cloudimage', {
      token: '',
      dontPrefixUrl: !1,
      domain: 'cloudimg.io',
      version: '',
      loadableQuery: '',
      secureProtocol: !0,
      imageSealing: { enable: !1, salt: '', charCount: 10, includeParams: [] }
    }),
    r(dS, 'observePluginContainerSize', !1),
    r(dS, 'showCanvasOnly', !1),
    r(dS, 'getCurrentImgDataFnRef', void 0),
    r(dS, 'onModify', void 0),
    r(dS, 'useZoomPresetsMenu', !0),
    r(dS, 'disableZooming', !1)
  var ub = dS
  function db(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = 100 < (t[r] + t[r + 1] + t[r + 2]) / 3 ? 255 : 0
      ;(t[r] = i), (t[r + 1] = i), (t[r + 2] = i)
    }
  }
  db.filterName = 'BlackAndWhite'
  var fb = function (e, t) {
      return [e[0] + (t = ~~(255 * ((t = 1 < t ? 1 : t) < -1 ? -1 : t))), e[1] + t, e[2] + t]
    },
    hb = function (e, t) {
      return [
        (t = (259 * (255 + (t *= 255))) / (255 * (259 - t))) * (e[0] - 128) + 128,
        t * (e[1] - 128) + 128,
        t * (e[2] - 128) + 128
      ]
    },
    pb = function (e, t) {
      var n = e[0],
        r = e[1],
        i = 0.2989 * n + 0.587 * r + 0.114 * (e = e[2])
      return [-i * (t = t < -1 ? -1 : t) + n * (1 + t), -i * t + r * (1 + t), -i * t + e * (1 + t)]
    },
    gb = function (e) {
      var t = e[0],
        n = e[1]
      e = e[2]
      return [, , ,].fill(0.2126 * t + 0.7152 * n + 0.0722 * e)
    },
    mb = function (e, t) {
      var n = e[0],
        r = e[1]
      return [
        n * (1 - 0.607 * t) + 0.769 * r * t + 0.189 * (e = e[2]) * t,
        0.349 * n * t + r * (1 - 0.314 * t) + 0.168 * e * t,
        0.272 * n * t + 0.534 * r * t + e * (1 - 0.869 * t)
      ]
    },
    vb = function (e, t) {
      return [e[0] * t[0], e[1] * t[1], e[2] * t[2]]
    },
    yb = function (e, t) {
      var n = e[0],
        r = e[1],
        i = ((e = e[2]), t[3])
      return [n - (n - t[0]) * i, r - (r - t[1]) * i, e - (e - t[2]) * i]
    }
  function bb(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(fb([t[r], t[r + 1], t[r + 2]], 0.1), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(hb([t[r], t[r + 1], t[r + 2]], 0.1), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(pb([t[r], t[r + 1], t[r + 2]], 0.15), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  function wb(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(mb([t[r], t[r + 1], t[r + 2]], 0.04), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(hb([t[r], t[r + 1], t[r + 2]], -0.15), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  function Cb(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(gb([t[r], t[r + 1], t[r + 2]]), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(fb([t[r], t[r + 1], t[r + 2]], 0.1), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  ;(bb.filterName = 'Clarendon'), (wb.filterName = 'Gingham'), (Cb.filterName = 'Moon')
  var xb = [1, 1.03, 1.05]
  function Eb(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(fb([t[r], t[r + 1], t[r + 2]], 0.08), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(vb([t[r], t[r + 1], t[r + 2]], xb), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(pb([t[r], t[r + 1], t[r + 2]], 0.12), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  function Sb(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(mb([t[r], t[r + 1], t[r + 2]], 0.4), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(fb([t[r], t[r + 1], t[r + 2]], 0.13), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(hb([t[r], t[r + 1], t[r + 2]], -0.05), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  ;(Eb.filterName = 'Lark'), (Sb.filterName = 'Reyes')
  var Ob = [1.01, 1.04, 1]
  function kb(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(vb([t[r], t[r + 1], t[r + 2]], Ob), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(pb([t[r], t[r + 1], t[r + 2]], 0.3), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  function Pb(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(fb([t[r], t[r + 1], t[r + 2]], 0.1), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(pb([t[r], t[r + 1], t[r + 2]], -0.5), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  ;(kb.filterName = 'Juno'), (Pb.filterName = 'Slumber')
  var _b = [1.04, 1, 1.02]
  function Lb(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(vb([t[r], t[r + 1], t[r + 2]], _b), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(pb([t[r], t[r + 1], t[r + 2]], -0.05), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  function Tb(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(fb([t[r], t[r + 1], t[r + 2]], 0.05), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(pb([t[r], t[r + 1], t[r + 2]], -0.03), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  ;(Lb.filterName = 'Crema'), (Tb.filterName = 'Ludwig')
  var Ib = [228, 130, 225, 0.13]
  function Mb(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(yb([t[r], t[r + 1], t[r + 2]], Ib), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(pb([t[r], t[r + 1], t[r + 2]], -0.2), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  Mb.filterName = 'Aden'
  var jb = [1.05, 1.1, 1]
  function Rb(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(vb([t[r], t[r + 1], t[r + 2]], jb), 3)
      ;(t[r] = i[0]), (t[r + 1] = i[1]), (t[r + 2] = i[2])
    }
  }
  function Db(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(pb([t[r], t[r + 1], t[r + 2]], 0.3), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(fb([t[r], t[r + 1], t[r + 2]], 0.15), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  ;(Rb.filterName = 'Perpetua'), (Db.filterName = 'Amaro')
  var Ab = [230, 115, 108, 0.05]
  function zb(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(yb([t[r], t[r + 1], t[r + 2]], Ab), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(pb([t[r], t[r + 1], t[r + 2]], 0.15), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  zb.filterName = 'Mayfair'
  var Nb = [255, 170, 0, 0.1]
  function Fb(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(yb([t[r], t[r + 1], t[r + 2]], Nb), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(fb([t[r], t[r + 1], t[r + 2]], 0.09), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(pb([t[r], t[r + 1], t[r + 2]], 0.1), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  Fb.filterName = 'Rise'
  var Hb = [1, 1, 1.25]
  function Bb(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(vb([t[r], t[r + 1], t[r + 2]], Hb), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(hb([t[r], t[r + 1], t[r + 2]], 0.1), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(fb([t[r], t[r + 1], t[r + 2]], 0.15), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  Bb.filterName = 'Hudson'
  var Vb = [255, 225, 80, 0.08]
  function Wb(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(yb([t[r], t[r + 1], t[r + 2]], Vb), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(pb([t[r], t[r + 1], t[r + 2]], 0.1), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(hb([t[r], t[r + 1], t[r + 2]], 0.05), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  Wb.filterName = 'Valencia'
  var Gb = [255, 255, 0, 0.07]
  function Zb(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(yb([t[r], t[r + 1], t[r + 2]], Gb), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(pb([t[r], t[r + 1], t[r + 2]], 0.2), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(hb([t[r], t[r + 1], t[r + 2]], 0.15), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  function Ub(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(hb([t[r], t[r + 1], t[r + 2]], -0.15), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(pb([t[r], t[r + 1], t[r + 2]], 0.1), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  ;(Zb.filterName = 'XPro2'), (Ub.filterName = 'Sierra')
  var Xb = [100, 28, 210, 0.03]
  function Yb(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(gb([t[r], t[r + 1], t[r + 2]]), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(yb([t[r], t[r + 1], t[r + 2]], Xb), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(fb([t[r], t[r + 1], t[r + 2]], 0.1), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  function qb(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(hb([t[r], t[r + 1], t[r + 2]], 0.15), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(pb([t[r], t[r + 1], t[r + 2]], 0.2), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  function $b(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(hb([t[r], t[r + 1], t[r + 2]], 0.1), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(pb([t[r], t[r + 1], t[r + 2]], 0.15), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  ;(Yb.filterName = 'Willow'), (qb.filterName = 'LoFi'), ($b.filterName = 'Hefe')
  var Kb = [220, 115, 188, 0.12]
  function Qb(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(yb([t[r], t[r + 1], t[r + 2]], Kb), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(hb([t[r], t[r + 1], t[r + 2]], -0.05), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  function Jb(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(fb([t[r], t[r + 1], t[r + 2]], 0.1), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(mb([t[r], t[r + 1], t[r + 2]], 0.3), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  ;(Qb.filterName = 'Nashville'), (Jb.filterName = 'Stinson')
  var ew = [255, 225, 0, 0.05]
  function tw(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(yb([t[r], t[r + 1], t[r + 2]], ew), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(fb([t[r], t[r + 1], t[r + 2]], 0.06), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(hb([t[r], t[r + 1], t[r + 2]], 0.06), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  tw.filterName = 'Vesper'
  var nw = [255, 165, 40, 0.2]
  function rw(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(yb([t[r], t[r + 1], t[r + 2]], nw), 3)
      ;(t[r] = i[0]), (t[r + 1] = i[1]), (t[r + 2] = i[2])
    }
  }
  rw.filterName = 'Earlybird'
  var iw = [140, 10, 185, 0.1]
  function ow(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(hb([t[r], t[r + 1], t[r + 2]], 0.2), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(yb([t[r], t[r + 1], t[r + 2]], iw), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  function aw(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(fb([t[r], t[r + 1], t[r + 2]], -0.1), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(pb([t[r], t[r + 1], t[r + 2]], -0.1), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  ;(ow.filterName = 'Brannan'), (aw.filterName = 'Sutro')
  var lw = [255, 145, 0, 0.2]
  function sw(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(mb([t[r], t[r + 1], t[r + 2]], 0.1), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(yb([t[r], t[r + 1], t[r + 2]], lw), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  sw.filterName = 'Toaster'
  var cw = [255, 255, 0, 0.2]
  function uw(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(fb([t[r], t[r + 1], t[r + 2]], 0.1), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(yb([t[r], t[r + 1], t[r + 2]], cw), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  uw.filterName = 'Walden'
  var dw = [255, 25, 0, 0.15]
  function fw(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(yb([t[r], t[r + 1], t[r + 2]], dw), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(fb([t[r], t[r + 1], t[r + 2]], 0.1), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  fw.filterName = 'NinteenSeventySeven'
  var hw = [255, 140, 0, 0.1],
    pw = [1.15, 1.05, 1]
  function gw(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(yb([t[r], t[r + 1], t[r + 2]], hw), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(vb([t[r], t[r + 1], t[r + 2]], pw), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(pb([t[r], t[r + 1], t[r + 2]], 0.35), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  gw.filterName = 'Kelvin'
  var mw = [225, 240, 0, 0.1]
  function vw(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(yb([t[r], t[r + 1], t[r + 2]], mw), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(pb([t[r], t[r + 1], t[r + 2]], 0.25), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(hb([t[r], t[r + 1], t[r + 2]], 0.05), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  function yw(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(mb([t[r], t[r + 1], t[r + 2]], 0.06), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(fb([t[r], t[r + 1], t[r + 2]], 0.1), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  function bw(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(pb([t[r], t[r + 1], t[r + 2]], 0.35), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(fb([t[r], t[r + 1], t[r + 2]], 0.1), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  function ww(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(hb([t[r], t[r + 1], t[r + 2]], 0.15), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(fb([t[r], t[r + 1], t[r + 2]], 0.1), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  ;(vw.filterName = 'Maven'), (yw.filterName = 'Ginza'), (bw.filterName = 'Skyline'), (ww.filterName = 'Dogpatch')
  var Cw = [25, 240, 252, 0.05]
  function xw(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(yb([t[r], t[r + 1], t[r + 2]], Cw), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(mb([t[r], t[r + 1], t[r + 2]], 0.3), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  xw.filterName = 'Brooklyn'
  var Ew = [208, 208, 86, 0.2]
  function Sw(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(yb([t[r], t[r + 1], t[r + 2]], Ew), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(hb([t[r], t[r + 1], t[r + 2]], 0.15), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  Sw.filterName = 'Helena'
  var Ow = [255, 160, 25, 0.1]
  function kw(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(yb([t[r], t[r + 1], t[r + 2]], Ow), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(fb([t[r], t[r + 1], t[r + 2]], 0.1), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  kw.filterName = 'Ashby'
  var Pw = [255, 50, 80, 0.12]
  function _w(e) {
    for (var t = e.data, n = t.length, r = 0; r < n; r += 4) {
      var i = Lg(yb([t[r], t[r + 1], t[r + 2]], Pw), 3)
      ;(t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2]),
        (i = Lg(hb([t[r], t[r + 1], t[r + 2]], 0.05), 3)),
        (t[r] = i[0]),
        (t[r + 1] = i[1]),
        (t[r + 2] = i[2])
    }
  }
  _w.filterName = 'Charmes'
  var Lw = Object.freeze(
      Object.defineProperty(
        {
          __proto__: null,
          BlackAndWhite: db,
          Clarendon: bb,
          Gingham: wb,
          Moon: Cb,
          Lark: Eb,
          Reyes: Sb,
          Juno: kb,
          Slumber: Pb,
          Crema: Lb,
          Ludwig: Tb,
          Aden: Mb,
          Perpetua: Rb,
          Amaro: Db,
          Mayfair: zb,
          Rise: Fb,
          Hudson: Bb,
          Valencia: Wb,
          XPro2: Zb,
          Sierra: Ub,
          Willow: Yb,
          LoFi: qb,
          Hefe: $b,
          Nashville: Qb,
          Stinson: Jb,
          Vesper: tw,
          Earlybird: rw,
          Brannan: ow,
          Sutro: aw,
          Toaster: sw,
          Walden: uw,
          NinteenSeventySeven: fw,
          Kelvin: gw,
          Maven: vw,
          Ginza: yw,
          Skyline: bw,
          Dogpatch: ww,
          Brooklyn: xw,
          Helena: Sw,
          Ashby: kw,
          Charmes: _w
        },
        Symbol.toStringTag,
        { value: 'Module' }
      )
    ),
    Tw = function (e) {
      return e ? Lw[e] || ry.Filters[e] : null
    }
  function Iw(e) {
    for (var t = this.warmth(), n = e.data, r = n.length, i = 0; i < r; i += 4) (n[i] += t), (n[i + 2] -= t)
  }
  function Mw(e) {
    for (var t = this.threshold(), n = e.data, r = n.length, i = 0; i < r; i += 4)
      0 !== t &&
        ((n[i] = n[i] >= t ? 255 : 0), (n[i + 1] = n[i + 1] >= t ? 255 : 0), (n[i + 2] = n[i + 2] >= t ? 255 : 0))
  }
  ;(Iw.finetuneName = 'Warmth'),
    Jg.addGetterSetter(ry.Image, 'warmth', 0, Zg(), Jg.afterSetFilter),
    (Mw.finetuneName = 'CustomThreshold'),
    Jg.addGetterSetter(ry.Image, 'threshold', 0, Zg, Jg.afterSetFilter)
  var jw = Object.freeze(
      Object.defineProperty({ __proto__: null, Warmth: Iw, CustomThreshold: Mw }, Symbol.toStringTag, {
        value: 'Module'
      })
    ),
    Rw = function (e) {
      return Array.isArray(e) && 0 < e.length
        ? e.map(function (e) {
            return ry.Filters[e] || jw[e]
          })
        : []
    }
  function Dw(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function Aw(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? Dw(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : Dw(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var zw = function () {
      var e,
        t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
        n = Aw({}, t.loadableDesignState)
      return (
        Array.isArray(n.finetunes) && (n.finetunes = Rw(n.finetunes)),
        n.filter && (n.filter = Tw(n.filter)),
        Aw(
          Aw(
            {
              imgSrc: 'string' == typeof t.source ? t.source : (null == (e = t.source) ? void 0 : e.src) || '',
              finetunes: [],
              finetunesProps: {},
              filter: null,
              adjustments: {
                crop: {
                  ratio: t[Gy.CROP].ratio,
                  ratioTitleKey: null != (e = t[Gy.CROP].ratioTitleKey) ? e : t[Gy.CROP].ratio,
                  width: null,
                  height: null,
                  x: 0,
                  y: 0
                },
                isFlippedX: !1,
                isFlippedY: !1,
                rotation: 0
              },
              annotations: {},
              resize: {},
              shownImageDimensions: {}
            },
            n
          ),
          {},
          {
            pointerCssIcon: Yy.DEFAULT,
            canvasScale: 1,
            zoom: { factor: 1, x: null, y: null },
            isLoadingGlobally: !0,
            selectionsIds: [],
            tabId: t.defaultTabId || null,
            toolId: t.defaultToolId || null,
            feedback: {},
            pastDesignStates: [],
            futureDesignStates: [],
            isResetted: !0,
            haveNotSavedChanges: !1,
            latestColors: {}
          }
        )
      )
    },
    Nw = function (e, t) {
      return (
        (t = zw(t ? e : ub)),
        {
          imgSrc: e.imgSrc || t.imgSrc,
          finetunes: e.finetunes || t.finetunes,
          finetunesProps: e.finetunesProps || t.finetunesProps,
          filter: e.filter || t.filter,
          adjustments: e.adjustments || t.adjustments,
          annotations: e.annotations || t.annotations,
          resize: e.resize || t.resize
        }
      )
    }
  function Fw(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function Hw(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? Fw(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : Fw(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var Bw = 'REDO'
  function Vw(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function Ww(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? Vw(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : Vw(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var Gw = 'RESET'
  function Zw(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function Uw(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? Zw(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : Zw(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var Xw = 'SET_FEEDBACK'
  function Yw(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function qw(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? Yw(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : Yw(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var $w = 'SHOW_LOADER'
  function Kw(e, t) {
    var n = s.exports.forwardRef(e)
    return (n.displayName = t || e.name), n
  }
  function Qw(e) {
    return Yf(['color:', ' !important;'], e.theme.palette[dg.Error])
  }
  function Jw(e) {
    var t = e.id,
      n = e.label,
      r = e.onClick,
      i = e.Icon,
      o = e.isSelected,
      a = e.children
    e = e.className
    return ue.createElement(
      hC,
      {
        className: e,
        onClick: function (e) {
          r(t, e)
        },
        'aria-selected': o
      },
      ue.createElement(i, { size: 16 }),
      n && ue.createElement(pC, null, n),
      a
    )
  }
  function eC(e) {
    var t = e.selectTool,
      n = e.isSelected
    e = e.t
    return ue.createElement(mC, {
      className: 'FIE_brightness-tool-button',
      id: Gy.BRIGHTNESS,
      label: e('brightnessTool'),
      Icon: nC,
      onClick: t,
      isSelected: n
    })
  }
  var tC = ['color', 'stroke', 'size'],
    nC = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.stroke) ? 'currentColor' : r,
        i = void 0 === (i = e.size) ? 14 : i
      e = Hu(e, tC)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: i, height: i, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M23.54 1.53186C23.54 0.96198 24.002 0.5 24.5719 0.5C25.1417 0.5 25.6037 0.961981 25.6037 1.53186V5.82108C25.6037 6.39096 25.1417 6.85294 24.5719 6.85294C24.002 6.85294 23.54 6.39096 23.54 5.82108V1.53186ZM23.54 43.1985C23.54 42.6287 24.002 42.1667 24.5719 42.1667C25.1417 42.1667 25.6037 42.6287 25.6037 43.1985V47.4877C25.6037 48.0576 25.1417 48.5196 24.5719 48.5196C24.002 48.5196 23.54 48.0576 23.54 47.4877V43.1985ZM47.4876 23.5397C48.0574 23.5397 48.5194 24.0017 48.5194 24.5716C48.5194 25.1415 48.0574 25.6034 47.4876 25.6034H43.1983C42.6285 25.6034 42.1665 25.1415 42.1665 24.5716C42.1665 24.0017 42.6285 23.5397 43.1984 23.5397H47.4876ZM5.8209 23.5397C6.39078 23.5397 6.85276 24.0017 6.85276 24.5716C6.85276 25.1415 6.39078 25.6034 5.82089 25.6034H1.53168C0.961798 25.6034 0.499817 25.1415 0.499817 24.5716C0.499817 24.0017 0.961797 23.5397 1.53168 23.5397H5.8209ZM41.6177 39.8976C42.0207 40.3006 42.0207 40.9539 41.6177 41.3569C41.2147 41.7599 40.5614 41.7599 40.1584 41.3569L37.1255 38.324C36.7225 37.921 36.7225 37.2677 37.1255 36.8647C37.5285 36.4617 38.1818 36.4617 38.5848 36.8647L41.6177 39.8976ZM12.1551 10.4347C12.558 10.8377 12.558 11.491 12.1551 11.894C11.7521 12.297 11.0988 12.297 10.6958 11.894L7.66285 8.86105C7.25989 8.45808 7.25989 7.80474 7.66286 7.40178C8.06582 6.99881 8.71916 6.99881 9.12213 7.40178L12.1551 10.4347ZM9.12179 41.617C8.71882 42.0199 8.06548 42.0199 7.66251 41.617C7.25955 41.214 7.25955 40.5607 7.66251 40.1577L10.6954 37.1248C11.0984 36.7218 11.7518 36.7218 12.1547 37.1248C12.5577 37.5277 12.5577 38.1811 12.1547 38.584L9.12179 41.617ZM38.5862 12.1549C38.1832 12.5579 37.5299 12.5579 37.1269 12.1549C36.724 11.752 36.724 11.0986 37.1269 10.6957L40.1599 7.66274C40.5628 7.25977 41.2162 7.25977 41.6191 7.66274C42.0221 8.06571 42.0221 8.71905 41.6191 9.12201L38.5862 12.1549ZM38.7161 24.5098C38.7161 32.3555 32.3559 38.7157 24.5102 38.7157C16.6645 38.7157 10.3043 32.3555 10.3043 24.5098C10.3043 16.6641 16.6645 10.3039 24.5102 10.3039C32.3559 10.3039 38.7161 16.6641 38.7161 24.5098ZM24.5102 36.652C31.2161 36.652 36.6524 31.2157 36.6524 24.5098C36.6524 17.8039 31.2161 12.3676 24.5102 12.3676C17.8043 12.3676 12.3681 17.8039 12.3681 24.5098C12.3681 31.2157 17.8043 36.652 24.5102 36.652Z',
          fill: n,
          stroke: r
        })
      )
    }),
    rC = { Default: 'default', Localization: 'localization' },
    iC = 'Label',
    oC = c.label.attrs({ className: Ap(iC, 'root') }).withConfig({ componentId: 'sc-16k2ql4-0' })(function (e) {
      var t = e.error,
        n = e.htmlFor
      return Yf(
        [
          'display:flex;align-items:center;color:',
          ';font-style:normal;font-weight:normal;font-size:12px;line-height:14px;cursor:',
          ';',
          ';'
        ],
        e.theme.palette[dg.TextSecondary],
        n && 'pointer',
        void 0 !== t && t && Qw
      )
    }),
    aC = c.span.attrs({ className: Ap(iC, 'text') }).withConfig({ componentId: 'sc-16k2ql4-1' })([
      'white-space:nowrap;text-overflow:ellipsis;overflow:hidden;'
    ]),
    lC = Hp({
      Label: oC,
      Icon: c.span.attrs({ className: Ap(iC, 'Icon') }).withConfig({ componentId: 'sc-16k2ql4-2' })(function (e) {
        var t = e.error,
          n = e.theme.palette
        return Yf(
          ['display:flex;', ';color:', ';', ''],
          void 0 !== (e = e.$end) && e ? 'margin-left: 4px' : 'margin-right: 4px',
          n[dg.IconsPrimary],
          void 0 !== t && t ? 'color: '.concat(n[dg.Error], ';') : ''
        )
      }),
      Text: aC
    }),
    sC = ['children', 'iconStart', 'iconEnd', 'error', 'type'],
    cC =
      ((h = zp(function (e, t) {
        function n(e, t) {
          return ue.createElement(lC.Icon, { error: Boolean(a), $end: t }, 'function' == typeof e ? e() : e)
        }
        var r = e.children,
          i = e.iconStart,
          o = e.iconEnd,
          a = e.error,
          l = e.type,
          c = ((e = Hu(e, sC)), s.exports.useRef(null)),
          u = Lg(s.exports.useState(!1), 2),
          d = u[0],
          f = u[1]
        return ue.createElement(
          lC.Label,
          Tg({ ref: t, error: a, type: l }, e),
          i && n(i, !1),
          ue.createElement(
            lC.Text,
            {
              title: (function () {
                if ('string' == typeof r && d) return r
              })(),
              onMouseOver: function () {
                var e
                null !== c.current &&
                  c.current &&
                  f(
                    (null == c || null == (e = c.current) ? void 0 : e.offsetWidth) <
                      (null == c || null == (e = c.current) ? void 0 : e.scrollWidth)
                  )
              },
              ref: c
            },
            r
          ),
          o && n(o, !0)
        )
      })),
      (h.defaultProps = { type: rC.Default, error: !1 }),
      {
        type: ce.oneOf(Fp(rC)),
        iconStart: ce.oneOfType([ce.node, ce.func]),
        iconEnd: ce.oneOfType([ce.node, ce.func]),
        error: ce.bool,
        htmlFor: ce.string
      }),
    uC = ((h.propTypes = cC), h),
    dC = c.div.withConfig({ componentId: 'sc-dwg14p-0' })([
      "padding:8px 1px 0;width:fit-content;margin:0 auto;max-width:99.5%;max-height:92px;[data-phone='true'] &{padding:0;margin-top:8px;max-height:initial;}"
    ]),
    fC = c.div.withConfig({ componentId: 'sc-dwg14p-1' })(
      ["display:flex;align-items:center;overflow-x:auto;[data-phone='true'] &{background:", ';}'],
      function (e) {
        return e.theme.palette['bg-primary']
      }
    ),
    hC = c.div.withConfig({ componentId: 'sc-dwg14p-2' })(function (e) {
      return (
        (e = e.theme),
        '\n    display: flex;\n    border-radius: 2px;\n    align-items: center;\n    justify-content: center;\n    padding: 8px;\n\n    &:not(:last-child) {\n      margin-right: 8px;\n    }\n\n    &,\n    * {\n      cursor: pointer;\n    }\n\n    &:hover {\n      background: '
          .concat(e.palette['bg-primary-active'], ";\n    }\n\n    &[aria-selected='true'] {\n      background: ")
          .concat(e.palette['bg-primary-active'], ';\n\n      * {\n        color: ')
          .concat(e.palette['accent-primary-active'], ';\n      }\n    }\n  ')
      )
    }),
    pC = c(uC).withConfig({ componentId: 'sc-dwg14p-3' })(['margin-left:6px;']),
    gC = c.div.withConfig({ componentId: 'sc-dwg14p-4' })(
      [
        'position:relative;width:100%;transition:max-height 100ms ease-in-out;display:flex;justify-content:center;align-items:center;',
        ';'
      ],
      function (e) {
        return '\n      max-height: '
          .concat(e.hasChildren ? '40px' : 0, ';\n      margin: ')
          .concat(e.hasChildren ? '0 auto 8px' : 0, ';\n    ')
      }
    ),
    mC = ((Jw.defaultProps = { isSelected: !1, id: void 0, children: null, label: '' }), s.exports.memo(Jw)),
    vC = ((eC.defaultProps = { isSelected: !1 }), s.exports.createContext({})),
    yC = {
      name: 'Name',
      save: 'Save',
      saveAs: 'Save as',
      back: 'Back',
      loading: 'Loading...',
      resetOperations: 'Reset/delete all operations',
      changesLoseConfirmation: 'All changes will be lost',
      changesLoseConfirmationHint: 'Are you sure you want to continue?',
      cancel: 'Cancel',
      continue: 'Continue',
      undoTitle: 'Undo last operation',
      redoTitle: 'Redo last operation',
      showImageTitle: 'Show original image',
      zoomInTitle: 'Zoom in',
      zoomOutTitle: 'Zoom out',
      toggleZoomMenuTitle: 'Toggle zoom menu',
      adjustTab: 'Adjust',
      finetuneTab: 'Finetune',
      filtersTab: 'Filters',
      watermarkTab: 'Watermark',
      annotateTab: 'Draw',
      resize: 'Resize',
      resizeTab: 'Resize',
      invalidImageError: 'Invalid image provided.',
      uploadImageError: 'Error while uploading the image.',
      areNotImages: 'are not images',
      isNotImage: 'is not image',
      toBeUploaded: 'to be uploaded',
      cropTool: 'Crop',
      original: 'Original',
      custom: 'Custom',
      square: 'Square',
      landscape: 'Landscape',
      portrait: 'Portrait',
      ellipse: 'Ellipse',
      classicTv: 'Classic TV',
      cinemascope: 'Cinemascope',
      arrowTool: 'Arrow',
      blurTool: 'Blur',
      brightnessTool: 'Brightness',
      contrastTool: 'Contrast',
      ellipseTool: 'Ellipse',
      unFlipX: 'Un-Flip X',
      flipX: 'Flip X',
      unFlipY: 'Un-Flip Y',
      flipY: 'Flip Y',
      hsvTool: 'HSV',
      hue: 'Hue',
      saturation: 'Saturation',
      value: 'Value',
      imageTool: 'Image',
      importing: 'Importing...',
      addImage: '+ Add image',
      uploadImage: 'Upload image',
      fromGallery: 'From gallery',
      lineTool: 'Line',
      penTool: 'Pen',
      polygonTool: 'Polygon',
      sides: 'Sides',
      rectangleTool: 'Rectangle',
      cornerRadius: 'Corner Radius',
      resizeWidthTitle: 'Width in pixels',
      resizeHeightTitle: 'Height in pixels',
      toggleRatioLockTitle: 'Toggle ratio lock',
      reset: 'Reset',
      resetSize: 'Reset to original image size',
      rotateTool: 'Rotate',
      textTool: 'Text',
      textSpacings: 'Text spacings',
      textAlignment: 'Text alignment',
      fontFamily: 'Font family',
      size: 'Size',
      letterSpacing: 'Letter Spacing',
      lineHeight: 'Line height',
      warmthTool: 'Warmth',
      addWatermark: '+ Add watermark',
      addWatermarkTitle: 'Choose the watermark type',
      uploadWatermark: 'Upload watermark',
      addWatermarkAsText: 'Add as text',
      padding: 'Padding',
      shadow: 'Shadow',
      horizontal: 'Horizontal',
      vertical: 'Vertical',
      blur: 'Blur',
      opacity: 'Opacity',
      position: 'Position',
      stroke: 'Stroke',
      saveAsModalLabel: 'Save the image as',
      extension: 'Extension',
      nameIsRequired: 'Name is required.',
      quality: 'Quality',
      imageDimensionsHoverTitle: 'Saved image size (width x height)',
      cropSizeLowerThanResizedWarning:
        'Note, the selected crop area is lower than the applied resize which might cause quality decrease',
      actualSize: 'Actual size (100%)',
      fitSize: 'Fit size',
      addImageTitle: 'Select image to add...'
    }
  function bC(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function wC(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? bC(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : bC(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function CC(e) {
    return SC[e] || e || ''
  }
  function xC(e, t) {
    return (QI[t.type] && QI[t.type](e, t.payload)) || e
  }
  var EC = {},
    SC = wC({}, yC),
    OC = 'Error while loading translations from backend.',
    kC = function () {
      var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
        t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 'en'
      return Object.assign(SC, EC[null == t ? void 0 : t.toLowerCase()] || {}, e)
    },
    PC = function () {
      var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : []
      return new Promise(function (t, n) {
        var r = new XMLHttpRequest()
        ;(r.responseType = 'json'),
          (r.onload = function () {
            var e
            200 <= r.status && r.status < 300
              ? t(r.response)
              : (console.warn(
                  'Error in sending translation key to backend '
                    .concat(null == (e = r.response) ? void 0 : e.hint, ', ')
                    .concat(r.status)
                ),
                n())
          }),
          (r.onerror = function () {
            var e
            console.warn(
              'Error in sending translation key to backend '
                .concat(null == (e = r.response) ? void 0 : e.hint, ', ')
                .concat(r.status)
            ),
              n()
          }),
          r.open('POST', 'https://neo.wordplex.io/api/import/request-translations?grid_uuid='.concat(Vy)),
          r.send(JSON.stringify({ grid_uuid: Vy, translations_requests: e }))
      })
    }
  function _C(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function LC(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? _C(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : _C(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function TC(e) {
    var t = e.children,
      n = void 0 === (e = e.config) ? {} : e,
      r = (e = Lg(wx(xC, zw(n), n), 2))[0],
      i = e[1],
      o =
        (s.exports.useEffect(function () {
          return (
            (IC = !0),
            function () {
              IC = !1
            }
          )
        }, []),
        s.exports.useCallback(
          function () {
            IC && i.apply(void 0, arguments)
          },
          [i]
        )),
      a =
        (s.exports.useEffect(
          function () {
            kC(n.translations, n.language)
          },
          [n.useBackendTranslations, n.language, n.translations]
        ),
        s.exports.useContext(ih))
    e = s.exports.useMemo(
      function () {
        return LC(LC({}, r), {}, { config: n, theme: a, dispatch: o, t: CC })
      },
      [n, r]
    )
    return ue.createElement(vC.Provider, { value: e }, t)
  }
  var IC = !0,
    MC =
      ((TC.defaultProps = { config: {} }),
      function (e) {
        var t = e.children
        e = e.overridingValue
        return ue.createElement(vC.Provider, { value: e }, t)
      }),
    jC = function () {
      return s.exports.useContext(vC)
    }
  function RC(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function DC(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? RC(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : RC(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function AC(e, t) {
    var n = jC(),
      r = n.dispatch,
      i = n.finetunes,
      o = n.finetunesProps,
      a = s.exports.useCallback(function (t) {
        r({ type: HT, payload: { finetune: e, finetuneProps: t } })
      }, [])
    return (
      s.exports.useEffect(function () {
        i.includes(e) || a(DC(DC({}, t), o))
      }, []),
      s.exports.useMemo(
        function () {
          return [o, a]
        },
        [o]
      )
    )
  }
  function zC(e) {
    var t, n, r, i, o
    return e
      ? ((e = e.getBoundingClientRect()),
        (i = document.body),
        (o = (t = VC()).topOffset),
        (t = t.leftOffset),
        (n = (r = document.documentElement).clientTop || i.clientTop || 0),
        (r = r.clientLeft || i.clientLeft || 0),
        (i = e.top + o - n),
        (o = e.left + t - r),
        { top: Math.round(i), left: Math.round(o), width: e.width, height: e.height })
      : null
  }
  function NC() {
    var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
      t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
      n = (e = e.parent).getStage(),
      r = n.attrs.zoomFactor,
      i = e.getRelativePointerPosition()
    return {
      offsetX: WC(i.x, 0, t.width / (n.scaleX() / r)) + e.attrs.xPadding,
      offsetY: WC(i.y, 0, t.height / (n.scaleY() / r)) + e.attrs.yPadding
    }
  }
  function FC() {
    var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
      t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
      n = {},
      r = (2 < arguments.length ? arguments[2] : void 0).parent.attrs
    return (
      (n.x = Math.min(e.offsetX, t.startedX) - r.xPadding || 0),
      (n.y = Math.min(e.offsetY, t.startedY) - r.yPadding || 0),
      (n.width = e.offsetX - t.startedX),
      (n.height = e.offsetY - t.startedY),
      (n.startedX = t.startedX - r.xPadding || 0),
      (n.startedY = t.startedY - r.yPadding || 0),
      n
    )
  }
  var HC = function () {
      var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : ''
      return ''
        .concat(e)
        .concat(e ? '-' : '')
        .concat(parseInt(Date.now() * Math.random(), 10))
    },
    BC = function (e) {
      var t,
        n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 300
      return function () {
        var r
        clearTimeout(t)
        for (var i = arguments.length, o = Array(i), a = 0; a < i; a++) o[a] = arguments[a]
        var l = o[0],
          s = o.slice(1)
        t = setTimeout(
          e.bind.apply(
            e,
            [null, null != (r = null == l || null == (r = l.target) ? void 0 : r.value) ? r : l].concat(Dp(s))
          ),
          n
        )
      }
    },
    VC = function () {
      var e,
        t = document.body,
        n = document.documentElement
      return {
        topOffset: (null == (e = window) ? void 0 : e.pageYOffset) || n.scrollTop || t.scrollTop,
        leftOffset: (null == (e = window) ? void 0 : e.pageXOffset) || n.scrollLeft || t.scrollLeft
      }
    },
    WC = function (e) {
      var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 0,
        n = 2 < arguments.length ? arguments[2] : void 0
      return Math.min(Math.max(t, +e), n || 1e6)
    },
    GC = ['width', 'height', 'startedX', 'startedY']
  function ZC(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function UC(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? ZC(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : ZC(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function XC(e) {
    var t
    return new YC[
      e.name
    ](UC(UC({}, e), {}, { opacity: null != (t = e.opacity) ? t : 0.7, x: null != (t = e.x) ? t : 0, y: null != (t = e.y) ? t : 0, width: Math.abs(e.width) || 0, height: Math.abs(e.height) || 0 }, qC.includes(e.name) ? { stroke: e.stroke || '#000000' } : {}))
  }
  r((wS = {}), Gy.RECT, ry.Rect),
    r(wS, Gy.ELLIPSE, ry.Ellipse),
    r(wS, Gy.POLYGON, ry.RegularPolygon),
    r(wS, Gy.LINE, ry.Line),
    r(wS, Gy.IMAGE, ry.Image),
    r(wS, Gy.TEXT, ry.Text),
    r(wS, Gy.ARROW, ry.Arrow)
  var YC = wS,
    qC = [Gy.LINE, Gy.ARROW],
    $C = [].concat(qC, [Gy.ELLIPSE, Gy.POLYGON]),
    KC = ['id', 'x', 'y', 'points'],
    QC = ['startedX', 'startedY', 'offsetX', 'offsetY', 'width', 'height']
  function JC(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function ex(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? JC(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : JC(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var tx = { startedX: void 0, startedY: void 0, isOutOfCanvas: !1 },
    nx = { passive: !0 },
    rx = null,
    ix = null,
    ox = null,
    ax = function (e, t, n, r) {
      function i(t) {
        t.evt.preventDefault(),
          t.target.attrs.draggable ||
            1 < (null == (t = t.evt.touches) ? void 0 : t.length) ||
            (s(),
            (t = NC(n, o())),
            (tx.startedX = t.offsetX),
            (tx.startedY = t.offsetY),
            (tx.isOutOfCanvas = !1),
            e.on('mousemove touchmove', c),
            e.on('mouseleave touchcancel', u),
            document.addEventListener('mouseup', d, nx),
            document.addEventListener('touchend', d, nx),
            document.addEventListener('mouseleave', d, nx),
            document.addEventListener('touchcancel', d, nx))
      }
      var o = function () {
          return zC(e.content)
        },
        a = function (e, t) {
          ;(n = ox.name),
            (r = e.width),
            (i = e.height),
            (o = e.startedX),
            (a = e.startedY),
            (e = Hu(e, GC)),
            (l = Math.abs(r)),
            (s = Math.abs(i)),
            (u = r < 0),
            (c = i < 0),
            n === Gy.RECT
              ? t
                ? ((e.width = Math.sqrt(l * l + s * s)),
                  (e.height = e.width),
                  (e.x -= u ? e.width - l : 0),
                  (e.y -= c ? e.height - s : 0))
                : ((e.width = l), (e.height = s))
              : n === Gy.ELLIPSE
              ? (t
                  ? ((e.radiusX = Math.sqrt(l * l + s * s) / 2),
                    (e.radiusY = e.radiusX),
                    (e.x -= u ? 2 * e.radiusX - l : 0),
                    (e.y -= c ? 2 * e.radiusY - s : 0))
                  : ((e.radiusX = l / 2), (e.radiusY = s / 2)),
                (e.offsetX = -e.radiusX),
                (e.offsetY = -e.radiusY))
              : n === Gy.POLYGON
              ? ((e.radius = (l + s) / 2),
                (e.x -= u ? 2 * e.radius - l : 0),
                (e.y -= c ? 2 * e.radius - s : 0),
                (e.offsetX = -e.radius),
                (e.offsetY = -e.radius))
              : n === Gy.LINE || n === Gy.ARROW
              ? ((e.x = o),
                (e.y = a),
                (e.points = [0, 0]),
                t ? e.points.push(s <= l ? r : 0, l < s ? i : 0) : (e.points = [0, 0, r, i]))
              : ((e.width = l), (e.height = s))
          var n,
            r,
            i,
            o,
            a,
            l,
            s,
            c,
            u = e
          ix && ix.setAttrs(u), rx.setAttrs(u), (ox = ex(ex({}, ox), u))
        },
        l = function (e) {
          var t = NC(n, o())
          a(FC(t, tx, n), e.shiftKey)
        },
        s = function () {
          n && rx && n.destroyChildren()
        },
        c = function (e) {
          var r
          1 < (null == (r = e.evt.touches) ? void 0 : r.length) ||
            ((r = NC(n, o())),
            tx.isOutOfCanvas &&
              (document.removeEventListener('mousemove', l, nx),
              document.removeEventListener('touchmove', l, nx),
              (tx.isOutOfCanvas = !1)),
            (r = FC(r, tx, n)),
            rx
              ? a(r, e.evt.shiftKey)
              : (t.id,
                t.x,
                t.y,
                t.points,
                (function (e) {
                  ;(rx = XC(e)),
                    n.add(rx),
                    e.name === Gy.TEXT &&
                      ((ix = XC(
                        ex(
                          ex({}, e),
                          {},
                          {
                            name: Gy.RECT,
                            fill: '',
                            stroke: '#000000',
                            strokeWidth: 2,
                            shadowColor: '#ffffff',
                            shadowBlur: 1,
                            shadowOpacity: 0.7
                          }
                        )
                      )),
                      n.add(ix)),
                    (ox = e)
                })(ex(ex({}, (e = Hu(t, KC))), r))))
        },
        u = function () {
          tx.isOutOfCanvas ||
            (document.addEventListener('mousemove', l, nx),
            document.addEventListener('touchmove', l, nx),
            (tx.isOutOfCanvas = !0))
        },
        d = function () {
          var n, i, o
          s(),
            ox &&
              ((1 <= ox.width && 1 <= ox.height) ||
                (1 <= ox.radiusX && 1 <= ox.radiusY) ||
                (null != (o = ox.points) && o[2]) ||
                (null != (o = ox.points) && o[3]) ||
                1 <= ox.radius) &&
              ((o = ox).startedX,
              o.startedY,
              o.offsetX,
              o.offsetY,
              (n = o.width),
              (i = o.height),
              (o = Hu(o, QC)),
              $C.includes(t.name) || ((o.width = n), (o.height = i)),
              r(o, !0)),
            (ox = ix = rx = null),
            e.off('mousemove touchmove', c),
            e.off('mouseleave touchcancel', u),
            document.removeEventListener('mouseup', d, nx),
            document.removeEventListener('touchend', d, nx),
            document.removeEventListener('mouseleave', d, nx),
            document.removeEventListener('touchcancel', d, nx),
            document.removeEventListener('mousemove', l, nx),
            document.removeEventListener('touchmove', l, nx),
            (tx.isOutOfCanvas = !1)
        }
      return (
        e.on('mousedown touchstart', i),
        function () {
          s(), e.off('mousedown touchstart', i)
        }
      )
    },
    lx = function (e, t) {
      var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : []
      return s.exports.useCallback(BC(e, t), n)
    },
    sx = ['fonts', 'onFontChange'],
    cx = [
      'x',
      'y',
      'width',
      'height',
      'radius',
      'radiusX',
      'radiusY',
      'points',
      'image',
      'text',
      'scaleX',
      'scaleY',
      'rotation'
    ],
    ux = ['shouldSave', 'neverSave']
  function dx(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function fx(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? dx(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : dx(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function hx() {
    var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
      t = !(1 < arguments.length && void 0 !== arguments[1]) || arguments[1],
      n = jC(),
      r = n.dispatch,
      i = n.previewGroup,
      o = n.annotations,
      a = n.selectionsIds,
      l = void 0 === a ? [] : a,
      c = fx(fx({}, (a = n.config).annotationsCommon), a[(null == (n = o[l[0]]) ? void 0 : n.name) || e.name]),
      u = (a = Lg(
        s.exports.useState(function () {
          return fx(fx(fx({}, c), e), o[l[0]])
        }),
        2
      ))[0],
      d = a[1],
      f = s.exports.useRef(),
      h = null == i ? void 0 : i.getStage(),
      p = s.exports.useCallback(function (t) {
        t.fonts, t.onFontChange
        var n = Hu(t, sx)
        r({ type: GT, payload: n }),
          n.id &&
            e.name !== Gy.PEN &&
            BC(function () {
              r({ type: $T, payload: { annotationId: n.id } })
            }, 30)()
      }, []),
      g = lx(function (e) {
        d(function (t) {
          return fx(fx({}, t), {}, { shouldSave: !1, neverSave: !1 }, 'function' == typeof e ? e(t) : e)
        })
      }, 15),
      m = s.exports.useCallback(function (t, n) {
        return t.name === n
          ? (t.x,
            t.y,
            t.width,
            t.height,
            t.radius,
            t.radiusX,
            t.radiusY,
            t.points,
            t.image,
            t.text,
            t.scaleX,
            t.scaleY,
            t.rotation,
            (n = Hu(t, cx)),
            fx(fx(fx({}, c), e), n))
          : fx(fx({}, c), e)
      }, []),
      v = s.exports.useCallback(function (t) {
        d(function (n) {
          return fx(
            fx(fx({}, m(n, t.name || e.name)), t),
            {},
            { id: t.id || HC(t.name || n.name), shouldSave: !0, neverSave: !1 }
          )
        })
      }, [])
    return (
      s.exports.useEffect(
        function () {
          var e = u.shouldSave,
            t = u.neverSave,
            n = Hu(u, ux),
            r = 1 === l.length && o[l[0]]
          t || (!e && !r) || p(fx(fx({}, n), {}, { id: (e ? n : r).id }))
        },
        [u]
      ),
      s.exports.useEffect(
        function () {
          setTimeout(function () {
            1 === l.length
              ? ((f.current = u), d(fx(fx({}, o[l[0]]), {}, { neverSave: !0 })))
              : f.current && (d(fx(fx({}, f.current), {}, { neverSave: !0 })), (f.current = null))
          })
        },
        [l, o]
      ),
      s.exports.useEffect(
        function () {
          var n,
            r = null
          return (
            h && t && ((n = m(u, e.name)), (r = ax(h, fx(fx({}, n), {}, { name: e.name }), i, v))),
            function () {
              r && r()
            }
          )
        },
        [h, u, i]
      ),
      s.exports.useMemo(
        function () {
          return [u, g, v]
        },
        [u, g, v]
      )
    )
  }
  var px = ['isDesignState']
  function gx(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function mx(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? gx(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : gx(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function vx() {
    return window.matchMedia('(max-width: 438px)').matches
  }
  function yx(e, t, n, r, i) {
    return ((e - t) * (i - r)) / (n - t) + r
  }
  var bx,
    wx = function (e, t) {
      var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {},
        r = mx(mx({}, t), {}, { pastDesignStates: [], futureDesignStates: [], hasRedo: !1, hasUndo: !1 })
      return s.exports.useReducer(function (t, i) {
        var o,
          a = e(t, i) || r
        return ![zT, Bw, Gw].includes(i.type) && a.isDesignState
          ? ((i = Nw(t)),
            a.isDesignState,
            (o = mx(
              mx({}, Hu(a, px)),
              {},
              {
                pastDesignStates: [i].concat(Dp(t.pastDesignStates)),
                hasUndo: !0,
                hasRedo: !1,
                futureDesignStates: [],
                isResetted: !1,
                haveNotSavedChanges: !0
              }
            )),
            (bx = setTimeout(function () {
              clearTimeout(bx), 'function' == typeof n.onModify && n.onModify(o)
            })),
            o)
          : a
      }, r)
    },
    Cx = function () {
      var e = s.exports.useRef(0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : function () {}),
        t = s.exports.useRef(),
        n = s.exports.useCallback(function (t) {
          t.forEach(function (t) {
            var n, r
            t.contentRect &&
              ((n = (r = t.contentRect).width), (r = r.height), e.current({ entry: t, width: n, height: r }))
          })
        }, []),
        r = s.exports.useCallback(function (t) {
          e.current = t
        }, []),
        i = s.exports.useCallback(function () {
          t.current || (t.current = new ResizeObserver(n))
        }, []),
        o = s.exports.useCallback(function (n, r) {
          n && (t.current || i(), t.current.observe(n), r) && (e.current = r)
        }, []),
        a = s.exports.useCallback(function (n, r) {
          t.current && n && (t.current.unobserve(n), r) && (e.current = r)
        }, []),
        l = s.exports.useCallback(function () {
          t.current && t.current.disconnect()
        }, [])
      return (
        s.exports.useEffect(function () {
          return i(), l
        }, []),
        s.exports.useMemo(function () {
          return [o, a, r]
        }, [])
      )
    }
  function xx(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function Ex(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? xx(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : xx(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function Sx(e, t) {
    return (e << t) | (e >>> (32 - t))
  }
  function Ox(e) {
    for (var t = '', n = 7; 0 <= n; n--) t += (15 & (e >>> (4 * n))).toString(16)
    return t
  }
  function kx(e) {
    for (
      var t,
        n,
        r,
        i,
        o,
        a,
        l,
        s,
        c = e,
        u = Array(80),
        d = 1732584193,
        f = 4023233417,
        h = 2562383102,
        p = 271733878,
        g = 3285377520,
        m = (c = (function (e) {
          for (var t, n = e.replace(/\r\n/g, '\n'), r = '', i = 0; i < n.length; i++)
            (t = n.charCodeAt(i)) < 128
              ? (r += String.fromCharCode(t))
              : (127 < t && t < 2048
                  ? (r += String.fromCharCode(192 | (t >> 6)))
                  : (r = (r += String.fromCharCode(224 | (t >> 12))) + String.fromCharCode(128 | (63 & (t >> 6)))),
                (r += String.fromCharCode(128 | (63 & t))))
          return r
        })(c)).length,
        v = [],
        y = 0;
      y < m - 3;
      y += 4
    )
      (n = (c.charCodeAt(y) << 24) | (c.charCodeAt(y + 1) << 16) | (c.charCodeAt(y + 2) << 8) | c.charCodeAt(y + 3)),
        v.push(n)
    switch (m % 4) {
      case 0:
        y = 2147483648
        break
      case 1:
        y = 8388608 | (c.charCodeAt(m - 1) << 24)
        break
      case 2:
        y = (c.charCodeAt(m - 2) << 24) | (c.charCodeAt(m - 1) << 16) | 32768
        break
      case 3:
        y = (c.charCodeAt(m - 3) << 24) | (c.charCodeAt(m - 2) << 16) | (c.charCodeAt(m - 1) << 8) | 128
    }
    for (v.push(y); 14 != v.length % 16; ) v.push(0)
    for (v.push(m >>> 29), v.push(4294967295 & (m << 3)), t = 0; t < v.length; t += 16) {
      for (y = 0; y < 16; y++) u[y] = v[t + y]
      for (y = 16; y <= 79; y++) u[y] = Sx(u[y - 3] ^ u[y - 8] ^ u[y - 14] ^ u[y - 16], 1)
      for (r = d, i = f, o = h, a = p, l = g, y = 0; y <= 19; y++)
        (s = 4294967295 & (Sx(r, 5) + ((i & o) | (~i & a)) + l + u[y] + 1518500249)),
          (l = a),
          (a = o),
          (o = Sx(i, 30)),
          (i = r),
          (r = s)
      for (y = 20; y <= 39; y++)
        (s = 4294967295 & (Sx(r, 5) + (i ^ o ^ a) + l + u[y] + 1859775393)),
          (l = a),
          (a = o),
          (o = Sx(i, 30)),
          (i = r),
          (r = s)
      for (y = 40; y <= 59; y++)
        (s = 4294967295 & (Sx(r, 5) + ((i & o) | (i & a) | (o & a)) + l + u[y] + 2400959708)),
          (l = a),
          (a = o),
          (o = Sx(i, 30)),
          (i = r),
          (r = s)
      for (y = 60; y <= 79; y++)
        (s = 4294967295 & (Sx(r, 5) + (i ^ o ^ a) + l + u[y] + 3395469782)),
          (l = a),
          (a = o),
          (o = Sx(i, 30)),
          (i = r),
          (r = s)
      ;(d = 4294967295 & (d + r)),
        (f = 4294967295 & (f + i)),
        (h = 4294967295 & (h + o)),
        (p = 4294967295 & (p + a)),
        (g = 4294967295 & (g + l))
    }
    return (s = Ox(d) + Ox(f) + Ox(h) + Ox(p) + Ox(g)).toLowerCase()
  }
  function Px(e, t, n, r) {
    return [
      (t = kx(t + (e = btoa(e).replace(/=*$/g, '')) + n).slice(0, r)) ? 'ci_seal='.concat(t) : '',
      e ? 'ci_eqs='.concat(e) : ''
    ]
      .filter(function (e) {
        return e
      })
      .join('&')
  }
  var _x = function (e, t, n) {
      var r
      return Ex(
        Ex(
          Ex({}, e.x || 0 === e.x ? { x: Math.round(yx(e.x, 0, t.width, 0, n.width)) } : {}),
          e.y || 0 === e.y ? { y: Math.round(yx(e.y, 0, t.height, 0, n.height)) } : {}
        ),
        {},
        {
          width: Math.round(yx(null != (r = e.width) ? r : t.width, 0, t.width, 0, n.width)),
          height: Math.round(yx(null != (r = e.height) ? r : t.height, 0, t.height, 0, n.height))
        }
      )
    },
    Lx = function (e, t) {
      var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 0,
        r = Math.abs(n),
        i = ((n = Math.round(n)), (o = 90 < r) ? t : e),
        o = ((e = o ? e : t), (t = ((o ? r - 90 : r) * Math.PI) / 180), Math.abs(Math.sin(t)))
      r = Math.abs(Math.cos(t))
      return {
        width: Math.round(i * r) + Math.round(e * o),
        height: Math.round(i * o) + Math.round(e * r),
        offsetTop: 0 <= n && n <= 90 ? 0 : (n < 0 && -90 < n) || 90 < n ? i * o : e * r + i * o,
        offsetLeft: n <= 0 && -90 <= n ? 0 : 90 < n ? i * r + e * o : e * o
      }
    },
    Tx = function (e) {
      var t, n
      return e instanceof HTMLImageElement
        ? ((n = (t = document.createElement('canvas')).getContext('2d')),
          (t.width = e.width),
          (t.height = e.height),
          n.drawImage(e, 0, 0),
          t.toDataURL())
        : ''
    },
    Ix = function () {
      var e,
        t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : '',
        n = 1 < arguments.length ? arguments[1] : void 0,
        r = t
      return (
        !n &&
          Uy.some(function (e) {
            return t.lastIndexOf('.'.concat(e)) === t.length - '.'.concat(e).length
          }) &&
          ((n =
            (e = null == (e = t.slice(t.lastIndexOf('.') + 1)) ? void 0 : e.toLowerCase()) && Zy.includes(e) ? e : Xy),
          (r = t.slice(0, t.lastIndexOf('.')))),
        (n = n || Xy),
        { fullName: ''.concat(r, '.').concat(n), name: r, extension: n }
      )
    },
    Mx = function (e) {
      var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 5
      return e && +parseFloat(e).toFixed(t)
    },
    jx = ['width', 'height', 'x', 'y', 'opacity', 'scaleX', 'scaleY']
  function Rx(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function Dx(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? Rx(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : Rx(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var Ax = {
      Brighten: {
        cloudimage: { name: 'bright', min: -100, max: 100 },
        internal: { propName: 'brightness', min: -1, max: 1 }
      },
      Contrast: {
        cloudimage: { name: 'contrast', min: -100, max: 100 },
        internal: { propName: 'contrast', min: -100, max: 100 }
      },
      Blur: { cloudimage: { name: 'blur', min: 0, max: 100 }, internal: { propName: 'blurRadius', min: 0, max: 100 } }
    },
    zx = function (e, t, n, r) {
      var i,
        o,
        a,
        l,
        s,
        c,
        u = e.token,
        d = e.domain,
        f = e.dontPrefixUrl,
        h = e.version,
        p = e.imageSealing,
        g = ((e = e.secureProtocol), t.imgSrc),
        m = (b = t.adjustments).crop,
        v = b.rotation,
        y = b.isFlippedX,
        b = b.isFlippedY,
        w = void 0 === (w = t.resize) ? {} : w,
        C = void 0 === (C = t.finetunes) ? {} : C,
        x = t.finetunesProps,
        E =
          ((t = void 0 === (t = t.annotations) ? {} : t),
          (e = f
            ? ''
            : 'http'
                .concat(e ? 's' : '', '://')
                .concat(u, '.')
                .concat(d.replace(/^(https?:\/\/)?(www\.)?|^\.|\/$/g, ''), '/')
                .concat(h ? ''.concat(h, '/') : '')),
          (u = []),
          m.width &&
            m.height &&
            (m.x || 0 === m.x) &&
            (m.y || 0 === m.y) &&
            u.push(
              ((i = (h = _x((d = m), (h = n), (i = r))).x),
              (E = h.y),
              (o = h.width),
              (h = h.height),
              'tl_px='
                .concat(i, ',')
                .concat(E, '&br_px=')
                .concat(i + o, ',')
                .concat(E + h)
                .concat(d.ratio === $y ? '&radius='.concat(Math.max(o, h), '&force_format=png') : ''))
            ),
          (w.width || w.height) &&
            u.push(
              (function () {
                var e = (t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {}).width,
                  t = t.height
                return 'w='.concat(e, '&h=').concat(t)
              })(Dx(Dx({}, r), w))
            ),
          v && u.push('r='.concat(-v)),
          (y || b) && u.push(((i = b), 'flip='.concat(y ? 'x' : '').concat(i ? 'y' : ''))),
          0 < C.length &&
            x &&
            u.push(
              (function (e) {
                var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
                  n = []
                return (
                  e.forEach(function (e) {
                    var r
                    ;(e = (e.finetuneName || e.name) && Ax[e.finetuneName || e.name]) &&
                      ((r = Mx(
                        yx(t[e.internal.propName], e.internal.min, e.internal.max, e.cloudimage.min, e.cloudimage.max),
                        2
                      )),
                      n.push(''.concat(e.cloudimage.name, '=').concat(r)))
                  }),
                  n.join('&')
                )
              })(C, x)
            ),
          t[By] &&
            u.push(
              (function () {
                var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
                  t = 1 < arguments.length ? arguments[1] : void 0,
                  n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {},
                  r = e.width,
                  i = e.height,
                  o = e.x,
                  a = e.y,
                  l = e.opacity,
                  s = void 0 === (s = e.scaleX) ? 1 : s,
                  c = void 0 === (c = e.scaleY) ? 1 : c,
                  u = Hu(e, jx),
                  d = t.width * t.scaledBy
                ;(t = t.height * t.scaledBy),
                  (l = 'wat=1&wat_gravity=absolute&wat_opacity='
                    .concat(l, '&wat_pos=')
                    .concat(Math.floor(((o - (n.x || 0)) / d) * 100, 2), 'p,')
                    .concat(Math.floor(((a - (n.y || 0)) / t) * 100, 2), 'p'))
                return e.name === Gy.TEXT
                  ? ''
                      .concat(l, '&wat_text=')
                      .concat(u.text.replaceAll('\n', ''), '&wat_font=')
                      .concat(u.fontFamily, '&wat_color=')
                      .concat(u.fill.replace('#', ''), '&wat_fontsize=')
                      .concat(u.fontSize, 'max')
                  : ((n = !(a = (null == (o = u.image) ? void 0 : o.src) || u.image).startsWith('blob:') && a),
                    ''
                      .concat(l, '&wat_scale=')
                      .concat(Mx(((r * s) / d) * 100, 2), 'p,')
                      .concat(Mx(((i * c) / t) * 100, 2), 'p')
                      .concat(n ? '&wat_url='.concat(encodeURIComponent(n)) : ''))
              })(t[By], n, m)
            ),
          u.push('ci_url_encoded=1'),
          u.join('&'))
      p.enable &&
        ((d = E),
        (o = g),
        (r = (h = (h = p) || {}).salt),
        (w = h.charCount),
        (h = h.includeParams),
        (l = !(a = void 0 === h ? [] : h) || 0 === (null == a ? void 0 : a.length)),
        (h = ''),
        (s = []),
        (c = []),
        d.split('&').forEach(function (e) {
          var t = Lg(e.split('='), 1)[0]
          ;(-1 < (null == a ? void 0 : a.indexOf(t)) || l ? s : c).push(e)
        }),
        0 < c.length && (h = c.join('&')),
        (E = [Px(s.join('&'), o, r, w), h]
          .filter(function (e) {
            return e
          })
          .join('&'))),
        (E = E.replaceAll(' ', '+')),
        (v = f && -1 !== g.indexOf('?') ? '&' : '?')
      return ''
        .concat(e)
        .concat(f ? g : encodeURIComponent(g))
        .concat(E ? ''.concat(v).concat(E.replace(/&$/, '')) : '')
    },
    Nx = ['filter']
  function Fx(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function Hx(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? Fx(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : Fx(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function Bx() {
    var e = jC(),
      t = e.dispatch,
      n = e.designLayer,
      r = e.shownImageDimensions,
      i = e.originalImage,
      o = (p = e.adjustments).crop,
      a = p.rotation,
      l = void 0 === a ? 0 : a,
      s = p.isFlippedX,
      c = p.isFlippedY,
      u = (a = e.config).savingPixelRatio,
      d = a.previewPixelRatio,
      f = a.forceToPngInEllipticalCrop,
      h = a.defaultSavedImageType,
      p = a.useCloudimage,
      g = a.cloudimage
    return p
      ? function () {
          var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
            n = ((n = Nw(e)).filter, Hu(n, Nx)),
            a = zx(g, n, r, i),
            l = _x({ x: o.x, y: o.y, width: o.width, height: o.height }, r, i)
          return {
            imageData: {
              cloudimageUrl: a,
              width: (null == t || null == (a = t.size) ? void 0 : a.width) || l.width,
              height: (null == t || null == (a = t.size) ? void 0 : a.height) || l.height
            },
            designState: n
          }
        }
      : function () {
          function a() {
            t({ type: sb })
          }
          var p = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
            g = !!(1 < arguments.length && void 0 !== arguments[1]) && arguments[1],
            m = !!(2 < arguments.length && void 0 !== arguments[2]) && arguments[2],
            v = (g = ((ry.pixelRatio = g || u), n.attrs)).clipWidth,
            y = g.clipHeight,
            b = g.clipX,
            w =
              ((g = g.clipY),
              Lg(
                (k =
                  (n.setAttr('isSaving', !0),
                  n.getStage().clone({ width: i.width, height: i.height, scaleX: s ? -1 : 1, scaleY: c ? -1 : 1 })))
                  .children,
                1
              )[0]),
            C = (k.children[1].destroy(), k.findOne('#'.concat(Fy))),
            x = (C.cache(), { x: k.width() / r.width, y: k.height() / r.height }),
            E =
              ((x = (w =
                (w.setAttrs({ rotation: 0, offsetX: 0, offsetY: 0, x: 0, y: 0, scaleX: x.x, scaleY: x.y }),
                Hx(
                  Hx(
                    {},
                    (!p.name || !p.extension) &&
                      Ix(i.name, f && o.ratio === $y ? 'png' : Zy.includes(null == h ? void 0 : h.toLowerCase()) && h)
                  ),
                  p
                ))).name),
              (p = w.extension),
              void 0 === (E = w.quality) ? 92 : E),
            S = ((w = void 0 === (w = w.size) ? {} : w), ['jpeg', 'jpg'].includes(p)),
            O =
              ((b = _x({ x: o.x || b, y: o.y || g, width: o.width || v, height: o.height || y }, r, k.attrs)),
              (g = Lx(b.width, b.height, l)),
              (g =
                (k.setAttrs({
                  offsetX: b.width / 2 + b.x,
                  offsetY: b.height / 2 + b.y,
                  width: g.width,
                  height: g.height,
                  x: g.width / 2,
                  y: g.height / 2,
                  rotation: l
                }),
                w.width &&
                  ((v = (s ? -1 : 1) * (w.width / k.width())),
                  k.setAttrs({ scaleX: v, width: w.width, x: k.x() * Math.abs(v) })),
                w.height &&
                  ((y = (c ? -1 : 1) * (w.height / k.height())),
                  k.setAttrs({ scaleY: y, height: w.height, y: k.y() * Math.abs(y) })),
                Hx({ mimeType: 'image/'.concat('jpg' === p ? 'jpeg' : p) }, S ? { quality: E } : {}))),
              (v = k.toCanvas(g)),
              (y = k.toDataURL(g)),
              Hx(
                Hx({}, Nw(e)),
                {},
                {
                  shownImageDimensions: {
                    width: e.shownImageDimensions.width,
                    height: e.shownImageDimensions.height,
                    scaledBy: e.shownImageDimensions.scaledBy
                  }
                }
              )),
            k =
              (O.filter && (O.filter = O.filter.filterName || O.filter.name),
              (O.finetunes = O.finetunes.map(function (e) {
                return e.finetuneName || e.name
              })),
              Object.keys(O.annotations).forEach(function (e) {
                var t = O.annotations[e],
                  n = t.name === Gy.IMAGE && (null == (n = t.image) ? void 0 : n.src)
                n && n.startsWith('blob:')
                  ? (O.annotations[e].image = Tx(t.image))
                  : t.image instanceof HTMLImageElement && (O.annotations[e].image = n)
              }),
              Hx(
                {
                  fullName: ''.concat(x, '.').concat(p),
                  name: x,
                  extension: p,
                  mimeType: 'image/'.concat(p),
                  imageCanvas: v,
                  imageBase64: y,
                  width: w.width || b.width,
                  height: w.height || b.height
                },
                S ? { quality: E } : {}
              ))
          return (
            n.setAttr('isSaving', !1),
            t({ type: GI }),
            C.clearCache(),
            (ry.pixelRatio = d),
            m || a(),
            { imageData: k, designState: O, hideLoadingSpinner: a }
          )
        }
  }
  var Vx = 'undefined' != typeof window ? s.exports.useLayoutEffect : s.exports.useEffect
  function Wx(e) {
    var t = s.exports.useRef(e)
    return (
      Vx(function () {
        t.current = e
      }),
      s.exports.useCallback(function () {
        return t.current.apply(void 0, arguments)
      }, [])
    )
  }
  var Gx = { Auto: 'auto', On: 'on', Off: 'off' },
    Zx =
      ((mg = 'Slider'),
      (y = c.span.attrs({ className: Ap(mg, 'root') }).withConfig({ componentId: 'sc-jjink6-0' })(function (e) {
        var t = e.theme
        return Yf(
          [
            'display:inline-block;border-radius:2px;position:relative;cursor:pointer;touch-action:none;color:',
            ';height:4px;width:100%;padding:12px 0;'
          ],
          void 0 !== (e = e.disabled) && e ? t.palette[dg.AccentPrimaryDisabled] : t.palette[dg.BorderActiveBottom]
        )
      })),
      (l = c.span.attrs({ className: Ap(mg, 'rail') }).withConfig({ componentId: 'sc-jjink6-1' })([
        'display:block;position:absolute;border-radius:inherit;background-color:currentColor;opacity:0.38;width:100%;height:inherit;top:50%;transform:translateY(-50%);'
      ])),
      (ug = c.span.attrs({ className: Ap(mg, 'Track') }).withConfig({ componentId: 'sc-jjink6-2' })([
        'display:block;position:absolute;border-radius:inherit;border:1px solid currentColor;background-color:currentColor;height:inherit;top:50%;transform:translateY(-50%);'
      ])),
      (Og = c.span.attrs({ className: Ap(mg, 'thumb') }).withConfig({ componentId: 'sc-jjink6-3' })([
        "position:absolute;width:15px;height:15px;box-sizing:border-box;border-radius:50%;outline:0;background-color:currentColor;display:flex;align-items:center;justify-content:center;top:50%;transform:translate(-50%,-50%);& > input{border:0px;clip:rect(0px,0px,0px,0px);height:100%;margin:-1px;overflow:hidden;padding:0px;position:absolute;white-space:nowrap;width:100%;direction:ltr;}&::before{position:absolute;content:'';border-radius:inherit;width:100%;height:100%;box-shadow:0px 3px 1px -2px rgb(0 0 0 / 20%),0px 2px 2px 0px rgb(0 0 0 / 14%),0px 1px 5px 0px rgb(0 0 0 / 12%);}&::after{position:absolute;content:'';border-radius:50%;width:42px;height:42px;top:50%;left:50%;transform:translate(-50%,-50%);}"
      ])),
      (f = c.span.attrs({ className: Ap(mg, 'label') }).withConfig({ componentId: 'sc-jjink6-4' })(function (e) {
        var t = e.theme,
          n = e.open
        return Yf(
          [
            'display:flex;align-items:center;justify-content:center;padding:6px 6px;border-radius:2px;position:absolute;top:-10px;font-size:10px;z-index:1;white-space:nowrap;transition:transform 150ms cubic-bezier(0.4,0,0.2,1) 0ms;transform-origin:bottom center;transform:',
            ';background-color:',
            ";color:#fff;cursor:pointer;&::before{position:absolute;content:'';background-color:inherit;width:8px;height:8px;bottom:0px;left:50%;transform:translate(-50%,50%) rotate(45deg);}"
          ],
          void 0 !== n && n ? 'translateY(-100%) scale(1)' : 'translateY(-100%) scale(0)',
          void 0 !== (e = e.disabled) && e ? t.palette[dg.AccentPrimaryDisabled] : t.palette[dg.LinkHover]
        )
      })),
      Hp({
        Slider: y,
        Rail: l,
        Track: ug,
        Thumb: Og,
        SliderAnnotation: c.div.attrs({ className: Ap(mg, 'annotation') }).withConfig({ componentId: 'sc-jjink6-5' })(
          function (e) {
            return Yf(
              ['display:flex;justify-content:space-between;margin-top:12px;color:', ';'],
              e.theme.palette[dg.TextSecondary]
            )
          }
        ),
        LabelTooltip: f
      })),
    Ux = [
      'defaultValue',
      'disabled',
      'disableSwap',
      'hideTrack',
      'hideAnnotation',
      'value',
      'min',
      'max',
      'onChange',
      'onMouseDown',
      'onMouseUp',
      'step',
      'labelTooltip',
      'annotation',
      'components',
      'componentsProps'
    ]
  function Xx(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function Yx(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {}
      t % 2
        ? Xx(Object(n), !0).forEach(function (t) {
            r(e, t, n[t])
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
        : Xx(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
          })
    }
    return e
  }
  var qx = 'data-index',
    $x =
      ((p = zp(function (e, t) {
        function n(e) {
          var t,
            n,
            r,
            i,
            o = e.finger,
            a = void 0 !== (a = e.move) && a,
            l = ((e = e.values), j.current)
          return l
            ? ((t = (l = l.getBoundingClientRect()).width),
              (r = l.height),
              (n = l.bottom),
              (l = l.left),
              (n = 0 === A.indexOf('vertical') ? (n - o.y) / r : (o.x - l) / t),
              A.includes('-reverse') && (n = 1 - n),
              (r = (g - p) * n + p),
              (r = ag(
                (r = b
                  ? (function (e, t, n) {
                      var r
                      return (
                        (e = Math.round((e - n) / t) * t + n),
                        Number(
                          e.toFixed(
                            ((n = t),
                            Math.abs(n) < 1
                              ? ((r = (e = n.toExponential().split('e-'))[0].split('.')[1]) ? r.length : 0) +
                                Number.parseInt(e[1], 10)
                              : (r = n.toString().split('.')[1])
                              ? r.length
                              : 0)
                          )
                        )
                      )
                    })(r, b, p)
                  : r),
                p,
                g
              )),
              (o = 0),
              z &&
                ((o = a
                  ? I.current
                  : ((i = r),
                    e.reduce(function (e, t, n) {
                      return (
                        (t = Math.abs(i - t)),
                        null === e || t < e.distance || t === e.distance ? { distance: t, index: n } : e
                      )
                    }, null).index)),
                (l = r = u ? ag(r, e[o - 1] || -1 / 0, e[o + 1] || 1 / 0) : r),
                (r = ig({ values: e, newValue: r, index: o })),
                (u && a) || !Array.isArray(r) || ((o = r.indexOf(l)), (I.current = o))),
              { newValue: r, activeIndex: o })
            : null
        }
        function r(e, t, n) {
          m && m(e, t, n)
        }
        function i(e) {
          var t,
            n,
            i = Number(e.currentTarget.getAttribute(qx)),
            o = e.target.valueAsNumber
          z &&
            ((t = o = u ? ag(o, N[i - 1] || -1 / 0, N[i + 1] || 1 / 0) : o),
            (o = ig({ values: N, newValue: o, index: i })),
            (n = i),
            u || (n = o.indexOf(t)),
            cg({ sliderRef: j, activeIndex: n })),
            D(o),
            r(e, o, i),
            y && y(e)
        }
        var o,
          a,
          l = e.defaultValue,
          c = void 0 !== (d = e.disabled) && d,
          u = void 0 !== (d = e.disableSwap) && d,
          d = void 0 !== (d = e.hideTrack) && d,
          f = void 0 !== (f = e.hideAnnotation) && f,
          h = e.value,
          p = void 0 === (C = e.min) ? 0 : C,
          g = void 0 === (C = e.max) ? 100 : C,
          m = e.onChange,
          v = e.onMouseDown,
          y = e.onMouseUp,
          b = void 0 === (C = e.step) ? 1 : C,
          w = void 0 === (C = e.labelTooltip) ? Gx.Off : C,
          C = void 0 === (C = e.annotation) ? '' : C,
          x = void 0 === (x = e.components) ? {} : x,
          E = void 0 === (E = e.componentsProps) ? {} : E,
          S = ((e = Hu(e, Ux)), (R = Lg(s.exports.useState(-1), 2))[0]),
          O = R[1],
          k = (R = Lg(s.exports.useState(-1), 2))[0],
          P = R[1],
          _ = (R = Lg(s.exports.useState(!1), 2))[0],
          L = R[1],
          T = s.exports.useRef(0),
          I = s.exports.useRef(0),
          M = s.exports.useRef(),
          j = s.exports.useRef(null),
          R = Vp(t, j),
          D =
            ((t =
              ((h = (t = { controlled: h, default: null != l ? l : p }).controlled),
              (t = t.default),
              (o = s.exports.useRef(void 0 !== h).current),
              (l = (t = Lg(s.exports.useState(t), 2))[0]),
              (a = t[1]),
              [
                o ? h : l,
                s.exports.useCallback(function (e) {
                  o || a(e)
                }, [])
              ])),
            (l = (h = Lg(t, 2))[0]),
            h[1]),
          A = 'horizontal',
          z = Array.isArray(l),
          N = z ? l.slice().sort(ng) : [l],
          F = Wx(function (e) {
            var t,
              i = lg(e, M)
            i &&
              ((T.current += 1),
              'mousemove' === e.type && 0 === e.buttons
                ? H(e)
                : ((t = (i = n({ finger: i, move: !0, values: N })).newValue),
                  (i = i.activeIndex),
                  cg({ sliderRef: j, activeIndex: i, setActive: O }),
                  D(t),
                  !_ && 2 < T.current && L(!0),
                  r(e, t, i)))
          }),
          H = Wx(function (e) {
            var t = lg(e, M)
            L(!1), t && (O(-1), 'touchend' === e.type && P(-1), y && y(e), (M.current = void 0), W())
          }),
          B =
            ((t = Wx(function (e) {
              var t = (i = n({
                  finger: (i = (null != (i = e.changedTouches[0]) && (M.current = i.identifier), lg(e, M))),
                  values: N
                })).newValue,
                i = i.activeIndex
              ;(e =
                (cg({ sliderRef: j, activeIndex: i, setActive: O }),
                D(t),
                r(e, t, i),
                (T.current = 0),
                og(j.current))).addEventListener('touchmove', F),
                e.addEventListener('touchend', H)
            })),
            Wx(function (e) {
              ;(e = Number(e.currentTarget.getAttribute(qx))), P(e)
            })),
          V = Wx(function () {
            P(-1)
          }),
          W =
            ((h = Wx(function (e) {
              var t, i
              c
                ? e.preventDefault()
                : (v && v(e),
                  0 === e.button &&
                    (e.preventDefault(),
                    (t = (i = n({ finger: (i = lg(e, M)), values: N })).newValue),
                    (i = i.activeIndex),
                    cg({ sliderRef: j, activeIndex: i, setActive: O }),
                    D(t),
                    r(e, t, i),
                    (T.current = 0),
                    (e = og(j.current)).addEventListener('mousemove', F),
                    e.addEventListener('mouseup', H)))
            })),
            s.exports.useCallback(
              function () {
                var e = og(j.current)
                e.removeEventListener('mousemove', F),
                  e.removeEventListener('mouseup', H),
                  e.removeEventListener('touchmove', F),
                  e.removeEventListener('touchend', H)
              },
              [H, F]
            )),
          G =
            ((l =
              (s.exports.useEffect(
                function () {
                  if (j.current)
                    return function () {
                      W()
                    }
                },
                [W, t]
              ),
              s.exports.useEffect(
                function () {
                  c && W()
                },
                [c, W]
              ),
              c && -1 !== S && O(-1),
              rg(z ? N[0] : p, p, g))),
            rg(N[N.length - 1], p, g) - l),
          Z =
            ((l = Yx(Yx({}, sg[A].offset(l)), sg[A].leap(G))),
            (G = E.rail),
            (G =
              'function' == typeof x.Rail
                ? ue.createElement(x.Rail, Tg({}, G, { style: Yx({}, null == G ? void 0 : G.style) }))
                : ue.createElement(Zx.Rail, Tg({}, G, { style: Yx({}, null == G ? void 0 : G.style) }))),
            E.track),
          U =
            ((d =
              !d &&
              ('function' == typeof x.Track
                ? ue.createElement(x.Track, Tg({}, Z, { style: Yx(Yx({}, l), null == Z ? void 0 : Z.style) }))
                : ue.createElement(Zx.Track, Tg({}, Z, { style: Yx(Yx({}, l), null == Z ? void 0 : Z.style) })))),
            E.thumb),
          X = x.Thumb || Zx.Thumb,
          Y = x.LabelTooltip || Zx.LabelTooltip,
          q = E.labelTooltip,
          $ = C ? ' '.concat(C) : ''
        return ue.createElement(
          Zx.Slider,
          Tg({ ref: R, disabled: c, onTouchStart: t, onMouseDown: h }, e),
          G,
          d,
          N.map(function (e, t) {
            return (
              (e = rg(e, p, g)),
              (e = sg[A].offset(e)),
              ue.createElement(
                ue.Fragment,
                { key: t },
                ue.createElement(
                  X,
                  Tg({ 'data-index': t, onMouseOver: B, onMouseLeave: V }, U, {
                    style: Yx(
                      Yx({}, e),
                      {},
                      { pointerEvents: u && S !== t ? 'none' : void 0 },
                      null == U ? void 0 : U.style
                    )
                  }),
                  ue.createElement('input', {
                    'data-index': t,
                    type: 'range',
                    min: p,
                    max: g,
                    value: N[t],
                    step: b,
                    disabled: c,
                    onChange: i
                  }),
                  ue.createElement(
                    Y,
                    {
                      open: k === t || S === t || 'on' === w,
                      disabled: c,
                      style: Yx({}, null == q ? void 0 : q.style)
                    },
                    N[t],
                    $
                  )
                )
              )
            )
          }),
          !f &&
            ue.createElement(
              Zx.SliderAnnotation,
              null,
              ue.createElement('span', null, p, $),
              ue.createElement('span', null, g, $)
            )
        )
      })),
      (p.defaultProps = { annotation: 'MB', min: 0, max: 100, step: 1, labelTooltip: Gx.Off }),
      (p.propTypes = {
        defaultValue: ce.oneOfType([ce.array, ce.number]),
        value: ce.oneOfType([ce.array, ce.number]),
        min: ce.number,
        max: ce.number,
        onChange: ce.func,
        onMouseDown: ce.func,
        onMouseUp: ce.func,
        step: ce.number,
        annotation: ce.string,
        disabled: ce.bool,
        disableSwap: ce.bool,
        hideTrack: ce.bool,
        hideAnnotation: ce.bool,
        labelTooltip: ce.oneOf(Fp(Gx)),
        components: ce.shape({
          Rail: ce.elementType,
          Track: ce.elementType,
          Thumb: ce.elementType,
          LabelTooltip: ce.elementType
        }),
        componentsProps: ce.object
      }),
      p),
    Kx = c($x).withConfig({ componentId: 'sc-1wort0h-0' })(
      [
        'width:',
        ';max-width:',
        ';user-select:none;margin-bottom:24px;.SfxSlider-annotation{font-size:13px;line-height:16px;}'
      ],
      function (e) {
        return e.width || '100px'
      },
      function (e) {
        return e.width || '100px'
      }
    ),
    Qx = ['onChange'],
    Jx = function (e) {
      var t = e.onChange
      e = Hu(e, Qx)
      return ue.createElement(
        Kx,
        Tg(
          {
            annotation: '',
            onChange: function (e, n) {
              return t ? t(n) : void 0
            }
          },
          e
        )
      )
    },
    eE = { brightness: 0 },
    tE = { width: 150, padding: 0 },
    nE = ['color', 'size'],
    rE = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, nE)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 14 14', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M13.5968 11.0258H12.2124V2.22491H2.91714V0.444957C2.91714 0.197742 2.71937 -3.05176e-05 2.47215 -3.05176e-05C2.22494 -3.05176e-05 2.02716 0.197742 2.02716 0.444957V2.22491H0.444987C0.197772 2.22491 0 2.47212 0 2.71934C0 2.96655 0.197772 3.16432 0.444987 3.16432H2.02716V11.9157H11.273V13.4979C11.273 13.7451 11.4708 13.9429 11.718 13.9429C11.9652 13.9429 12.163 13.7451 12.163 13.4979V11.9157H13.5474C13.7946 11.9157 13.9924 11.718 13.9924 11.4707C14.0418 11.2235 13.844 11.0258 13.5968 11.0258ZM2.91714 11.0258V3.16432H11.273V11.0258H2.91714Z',
          fill: n
        })
      )
    }),
    iE = 'top',
    oE = 'bottom',
    aE = 'right',
    lE = 'left',
    sE = 'auto',
    cE = [iE, oE, aE, lE],
    uE = 'start',
    dE = 'end',
    fE = 'viewport',
    hE = 'popper',
    pE = cE.reduce(function (e, t) {
      return e.concat([t + '-' + uE, t + '-' + dE])
    }, []),
    gE = [].concat(cE, [sE]).reduce(function (e, t) {
      return e.concat([t, t + '-' + uE, t + '-' + dE])
    }, []),
    mE = ['beforeRead', 'read', 'afterRead', 'beforeMain', 'main', 'afterMain', 'beforeWrite', 'write', 'afterWrite']
  function vE(e) {
    return e ? (e.nodeName || '').toLowerCase() : null
  }
  function yE(e) {
    var t
    return null == e
      ? window
      : '[object Window]' !== e.toString()
      ? ((t = e.ownerDocument) && t.defaultView) || window
      : e
  }
  function bE(e) {
    return e instanceof yE(e).Element || e instanceof Element
  }
  function wE(e) {
    return e instanceof yE(e).HTMLElement || e instanceof HTMLElement
  }
  function CE(e) {
    return 'undefined' != typeof ShadowRoot && (e instanceof yE(e).ShadowRoot || e instanceof ShadowRoot)
  }
  function xE(e) {
    return e.split('-')[0]
  }
  var EE = Math.max,
    SE = Math.min,
    OE = Math.round
  function kE() {
    var e = navigator.userAgentData
    return null != e && e.brands && Array.isArray(e.brands)
      ? e.brands
          .map(function (e) {
            return e.brand + '/' + e.version
          })
          .join(' ')
      : navigator.userAgent
  }
  function PE() {
    return !/^((?!chrome|android).)*safari/i.test(kE())
  }
  function _E(e, t, n) {
    void 0 === t && (t = !1), void 0 === n && (n = !1)
    var r = e.getBoundingClientRect(),
      i = 1,
      o = 1
    return (
      t &&
        wE(e) &&
        ((i = (0 < e.offsetWidth && OE(r.width) / e.offsetWidth) || 1),
        (o = (0 < e.offsetHeight && OE(r.height) / e.offsetHeight) || 1)),
      (t = (bE(e) ? yE(e) : window).visualViewport),
      (e = !PE() && n),
      (n = (r.left + (e && t ? t.offsetLeft : 0)) / i),
      (e = (r.top + (e && t ? t.offsetTop : 0)) / o),
      { width: (t = r.width / i), height: (i = r.height / o), top: e, right: n + t, bottom: e + i, left: n, x: n, y: e }
    )
  }
  function LE(e) {
    var t = _E(e),
      n = e.offsetWidth,
      r = e.offsetHeight
    return (
      Math.abs(t.width - n) <= 1 && (n = t.width),
      Math.abs(t.height - r) <= 1 && (r = t.height),
      { x: e.offsetLeft, y: e.offsetTop, width: n, height: r }
    )
  }
  function TE(e, t) {
    var n = t.getRootNode && t.getRootNode()
    if (e.contains(t)) return !0
    if (n && CE(n)) {
      var r = t
      do {
        if (r && e.isSameNode(r)) return !0
      } while ((r = r.parentNode || r.host))
    }
    return !1
  }
  function IE(e) {
    return yE(e).getComputedStyle(e)
  }
  function ME(e) {
    return ((bE(e) ? e.ownerDocument : e.document) || window.document).documentElement
  }
  function jE(e) {
    return 'html' === vE(e) ? e : e.assignedSlot || e.parentNode || (CE(e) ? e.host : null) || ME(e)
  }
  function RE(e) {
    return wE(e) && 'fixed' !== IE(e).position ? e.offsetParent : null
  }
  function DE(e) {
    for (var t = yE(e), n = RE(e); n && 0 <= ['table', 'td', 'th'].indexOf(vE(n)) && 'static' === IE(n).position; )
      n = RE(n)
    return (
      ((!n || ('html' !== vE(n) && ('body' !== vE(n) || 'static' !== IE(n).position))) &&
        (n ||
          (function (e) {
            var t = /firefox/i.test(kE())
            if (!/Trident/i.test(kE()) || !wE(e) || 'fixed' !== IE(e).position) {
              var n = jE(e)
              for (CE(n) && (n = n.host); wE(n) && ['html', 'body'].indexOf(vE(n)) < 0; ) {
                var r = IE(n)
                if (
                  'none' !== r.transform ||
                  'none' !== r.perspective ||
                  'paint' === r.contain ||
                  -1 !== ['transform', 'perspective'].indexOf(r.willChange) ||
                  (t && 'filter' === r.willChange) ||
                  (t && r.filter && 'none' !== r.filter)
                )
                  return n
                n = n.parentNode
              }
            }
            return null
          })(e))) ||
      t
    )
  }
  function AE(e) {
    return 0 <= ['top', 'bottom'].indexOf(e) ? 'x' : 'y'
  }
  function zE(e, t, n) {
    return EE(e, SE(t, n))
  }
  function NE(e) {
    return Object.assign({}, { top: 0, right: 0, bottom: 0, left: 0 }, e)
  }
  function FE(e, t) {
    return t.reduce(function (t, n) {
      return (t[n] = e), t
    }, {})
  }
  function HE(e) {
    return e.split('-')[1]
  }
  var BE = { top: 'auto', right: 'auto', bottom: 'auto', left: 'auto' }
  function VE(e) {
    var t,
      n = e.popper,
      r = e.popperRect,
      i = e.placement,
      o = e.variation,
      a = e.offsets,
      l = e.position,
      s = e.gpuAcceleration,
      c = e.adaptive,
      u = e.roundOffsets,
      d = ((e = e.isFixed), void 0 === (d = a.x) ? 0 : d),
      f = void 0 === (f = a.y) ? 0 : f,
      h = ((d = (h = 'function' == typeof u ? u({ x: d, y: f }) : { x: d, y: f }).x), (f = h.y), a.hasOwnProperty('x')),
      p = ((a = a.hasOwnProperty('y')), lE),
      g = iE,
      m = window,
      v =
        (c &&
          ((v = 'clientHeight'),
          (t = 'clientWidth'),
          (y = DE(n)) === yE(n) &&
            'static' !== IE((y = ME(n))).position &&
            'absolute' === l &&
            ((v = 'scrollHeight'), (t = 'scrollWidth')),
          (i !== iE && ((i !== lE && i !== aE) || o !== dE)) ||
            ((g = oE),
            (f =
              (f - ((e && y === m && m.visualViewport ? m.visualViewport.height : y[v]) - r.height)) * (s ? 1 : -1))),
          (i !== lE && ((i !== iE && i !== oE) || o !== dE)) ||
            ((p = aE),
            (d = (d - ((e && y === m && m.visualViewport ? m.visualViewport.width : y[t]) - r.width)) * (s ? 1 : -1)))),
        Object.assign({ position: l }, c && BE)),
      y =
        !0 === u
          ? ((i = { x: d, y: f }),
            (o = yE(n)),
            (e = i.x),
            (i = i.y),
            (o = o.devicePixelRatio || 1),
            { x: OE(e * o) / o || 0, y: OE(i * o) / o || 0 })
          : { x: d, y: f }
    return (
      (d = y.x),
      (f = y.y),
      s
        ? Object.assign(
            {},
            v,
            (((t = {})[g] = a ? '0' : ''),
            (t[p] = h ? '0' : ''),
            (t.transform =
              (m.devicePixelRatio || 1) <= 1
                ? 'translate(' + d + 'px, ' + f + 'px)'
                : 'translate3d(' + d + 'px, ' + f + 'px, 0)'),
            t)
          )
        : Object.assign({}, v, (((r = {})[g] = a ? f + 'px' : ''), (r[p] = h ? d + 'px' : ''), (r.transform = ''), r))
    )
  }
  var WE = { passive: !0 },
    GE = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' }
  function ZE(e) {
    return e.replace(/left|right|bottom|top/g, function (e) {
      return GE[e]
    })
  }
  var UE = { start: 'end', end: 'start' }
  function XE(e) {
    return e.replace(/start|end/g, function (e) {
      return UE[e]
    })
  }
  function YE(e) {
    return { scrollLeft: (e = yE(e)).pageXOffset, scrollTop: e.pageYOffset }
  }
  function qE(e) {
    return _E(ME(e)).left + YE(e).scrollLeft
  }
  function $E(e) {
    var t = (e = IE(e)).overflow,
      n = e.overflowX
    e = e.overflowY
    return /auto|scroll|overlay|hidden/.test(t + e + n)
  }
  function KE(e, t) {
    void 0 === t && (t = [])
    e =
      (r = (function e(t) {
        return 0 <= ['html', 'body', '#document'].indexOf(vE(t)) ? t.ownerDocument.body : wE(t) && $E(t) ? t : e(jE(t))
      })(e)) === (null == (e = e.ownerDocument) ? void 0 : e.body)
    var n = yE(r),
      r = ((n = e ? [n].concat(n.visualViewport || [], $E(r) ? r : []) : r), t.concat(n))
    return e ? r : r.concat(KE(jE(n)))
  }
  function QE(e) {
    return Object.assign({}, e, { left: e.x, top: e.y, right: e.x + e.width, bottom: e.y + e.height })
  }
  function JE(e, t, n) {
    return t === fE
      ? QE(
          ((i = n),
          (a = yE((r = e))),
          (l = ME(r)),
          (a = a.visualViewport),
          (s = l.clientWidth),
          (l = l.clientHeight),
          (u = c = 0),
          a &&
            ((s = a.width), (l = a.height), (o = PE()) || (!o && 'fixed' === i)) &&
            ((c = a.offsetLeft), (u = a.offsetTop)),
          { width: s, height: l, x: c + qE(r), y: u })
        )
      : bE(t)
      ? (((i = _E((o = t), !1, 'fixed' === (i = n))).top = i.top + o.clientTop),
        (i.left = i.left + o.clientLeft),
        (i.bottom = i.top + o.clientHeight),
        (i.right = i.left + o.clientWidth),
        (i.width = o.clientWidth),
        (i.height = o.clientHeight),
        (i.x = i.left),
        (i.y = i.top),
        i)
      : QE(
          ((a = ME(e)),
          (s = ME(a)),
          (l = YE(a)),
          (c = null == (c = a.ownerDocument) ? void 0 : c.body),
          (r = EE(s.scrollWidth, s.clientWidth, c ? c.scrollWidth : 0, c ? c.clientWidth : 0)),
          (u = EE(s.scrollHeight, s.clientHeight, c ? c.scrollHeight : 0, c ? c.clientHeight : 0)),
          (a = -l.scrollLeft + qE(a)),
          (l = -l.scrollTop),
          'rtl' === IE(c || s).direction && (a += EE(s.clientWidth, c ? c.clientWidth : 0) - r),
          { width: r, height: u, x: a, y: l })
        )
    var r, i, o, a, l, s, c, u
  }
  function eS(e) {
    var t,
      n = e.reference,
      r = e.element,
      i = (e = e.placement) ? xE(e) : null,
      o = ((e = e ? HE(e) : null), n.x + n.width / 2 - r.width / 2),
      a = n.y + n.height / 2 - r.height / 2
    switch (i) {
      case iE:
        t = { x: o, y: n.y - r.height }
        break
      case oE:
        t = { x: o, y: n.y + n.height }
        break
      case aE:
        t = { x: n.x + n.width, y: a }
        break
      case lE:
        t = { x: n.x - r.width, y: a }
        break
      default:
        t = { x: n.x, y: n.y }
    }
    var l = i ? AE(i) : null
    if (null != l) {
      var s = 'y' === l ? 'height' : 'width'
      switch (e) {
        case uE:
          t[l] = t[l] - (n[s] / 2 - r[s] / 2)
          break
        case dE:
          t[l] = t[l] + (n[s] / 2 - r[s] / 2)
      }
    }
    return t
  }
  function tS(e, t) {
    var n,
      r = void 0 === (r = (t = t = void 0 === t ? {} : t).placement) ? e.placement : r,
      i = void 0 === (i = t.strategy) ? e.strategy : i,
      o = void 0 === (o = t.boundary) ? 'clippingParents' : o,
      a = void 0 === (a = t.rootBoundary) ? fE : a,
      l = void 0 === (l = t.elementContext) ? hE : l,
      s = void 0 !== (s = t.altBoundary) && s,
      c = ((t = NE('number' != typeof (t = void 0 === (t = t.padding) ? 0 : t) ? t : FE(t, cE))), e.rects.popper),
      u =
        ((s = (function (e, t, n, r) {
          var i,
            o =
              'clippingParents' === t
                ? ((a = KE(jE((o = e)))),
                  bE((i = 0 <= ['absolute', 'fixed'].indexOf(IE(o).position) && wE(o) ? DE(o) : o))
                    ? a.filter(function (e) {
                        return bE(e) && TE(e, i) && 'body' !== vE(e)
                      })
                    : [])
                : [].concat(t),
            a = [].concat(o, [n])
          return (
            (t = a[0]),
            ((n = a.reduce(function (t, n) {
              return (
                (n = JE(e, n, r)),
                (t.top = EE(n.top, t.top)),
                (t.right = SE(n.right, t.right)),
                (t.bottom = SE(n.bottom, t.bottom)),
                (t.left = EE(n.left, t.left)),
                t
              )
            }, JE(e, t, r))).width = n.right - n.left),
            (n.height = n.bottom - n.top),
            (n.x = n.left),
            (n.y = n.top),
            n
          )
        })(
          bE((s = e.elements[s ? (l === hE ? 'reference' : hE) : l])) ? s : s.contextElement || ME(e.elements.popper),
          o,
          a,
          i
        )),
        (a = eS({ reference: (o = _E(e.elements.reference)), element: c, strategy: 'absolute', placement: r })),
        (i = QE(Object.assign({}, c, a))),
        (c = l === hE ? i : o),
        {
          top: s.top - c.top + t.top,
          bottom: c.bottom - s.bottom + t.bottom,
          left: s.left - c.left + t.left,
          right: c.right - s.right + t.right
        })
    a = e.modifiersData.offset
    return (
      l === hE &&
        a &&
        ((n = a[r]),
        Object.keys(u).forEach(function (e) {
          var t = 0 <= [aE, oE].indexOf(e) ? 1 : -1,
            r = 0 <= [iE, oE].indexOf(e) ? 'y' : 'x'
          u[e] += n[r] * t
        })),
      u
    )
  }
  function nS(e, t, n) {
    return {
      top: e.top - t.height - (n = void 0 === n ? { x: 0, y: 0 } : n).y,
      right: e.right - t.width + n.x,
      bottom: e.bottom - t.height + n.y,
      left: e.left - t.width - n.x
    }
  }
  function rS(e) {
    return [iE, aE, oE, lE].some(function (t) {
      return 0 <= e[t]
    })
  }
  function iS(e, t, n) {
    void 0 === n && (n = !1)
    var r = wE(t),
      i =
        wE(t) &&
        ((a = (i = t).getBoundingClientRect()),
        (o = OE(a.width) / i.offsetWidth || 1),
        (a = OE(a.height) / i.offsetHeight || 1),
        1 !== o || 1 !== a),
      o = ME(t),
      a = _E(e, i, n),
      l = ((e = { scrollLeft: 0, scrollTop: 0 }), { x: 0, y: 0 })
    return (
      (!r && n) ||
        (('body' === vE(t) && !$E(o)) ||
          (e = (r = t) !== yE(r) && wE(r) ? { scrollLeft: r.scrollLeft, scrollTop: r.scrollTop } : YE(r)),
        wE(t) ? (((l = _E(t, !0)).x += t.clientLeft), (l.y += t.clientTop)) : o && (l.x = qE(o))),
      { x: a.left + e.scrollLeft - l.x, y: a.top + e.scrollTop - l.y, width: a.width, height: a.height }
    )
  }
  var oS = { placement: 'bottom', modifiers: [], strategy: 'absolute' }
  function aS() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n]
    return !t.some(function (e) {
      return !(e && 'function' == typeof e.getBoundingClientRect)
    })
  }
  var lS = (function (e) {
    var t,
      n = void 0 === (t = (e = e = void 0 === e ? {} : e).defaultModifiers) ? [] : t,
      r = void 0 === (t = e.defaultOptions) ? oS : t
    return function (e, t, i) {
      void 0 === i && (i = r)
      var o,
        a,
        l = {
          placement: 'bottom',
          orderedModifiers: [],
          options: Object.assign({}, oS, r),
          modifiersData: {},
          elements: { reference: e, popper: t },
          attributes: {},
          styles: {}
        },
        s = [],
        c = !1,
        u = {
          state: l,
          setOptions: function (i) {
            var o, a
            ;(i = 'function' == typeof i ? i(l.options) : i),
              d(),
              (l.options = Object.assign({}, r, l.options, i)),
              (l.scrollParents = {
                reference: bE(e) ? KE(e) : e.contextElement ? KE(e.contextElement) : [],
                popper: KE(t)
              }),
              (i = [].concat(n, l.options.modifiers)),
              (a = i.reduce(function (e, t) {
                var n = e[t.name]
                return (
                  (e[t.name] = n
                    ? Object.assign({}, n, t, {
                        options: Object.assign({}, n.options, t.options),
                        data: Object.assign({}, n.data, t.data)
                      })
                    : t),
                  e
                )
              }, {})),
              (i = Object.keys(a).map(function (e) {
                return a[e]
              })),
              (o = (function (e) {
                var t = new Map(),
                  n = new Set(),
                  r = []
                return (
                  e.forEach(function (e) {
                    t.set(e.name, e)
                  }),
                  e.forEach(function (e) {
                    n.has(e.name) ||
                      (function e(i) {
                        n.add(i.name),
                          [].concat(i.requires || [], i.requiresIfExists || []).forEach(function (r) {
                            n.has(r) || ((r = t.get(r)) && e(r))
                          }),
                          r.push(i)
                      })(e)
                  }),
                  r
                )
              })(i)),
              (i = mE.reduce(function (e, t) {
                return e.concat(
                  o.filter(function (e) {
                    return e.phase === t
                  })
                )
              }, []))
            return (
              (l.orderedModifiers = i.filter(function (e) {
                return e.enabled
              })),
              l.orderedModifiers.forEach(function (e) {
                var t = e.name,
                  n = e.options
                'function' == typeof (e = e.effect) &&
                  ((e = e({ state: l, name: t, instance: u, options: void 0 === n ? {} : n })),
                  s.push(e || function () {}))
              }),
              u.update()
            )
          },
          forceUpdate: function () {
            if (!c) {
              var e,
                t = (e = l.elements).reference
              if (aS(t, (e = e.popper))) {
                ;(l.rects = { reference: iS(t, DE(e), 'fixed' === l.options.strategy), popper: LE(e) }),
                  (l.reset = !1),
                  (l.placement = l.options.placement),
                  l.orderedModifiers.forEach(function (e) {
                    return (l.modifiersData[e.name] = Object.assign({}, e.data))
                  })
                for (var n, r, i, o = 0; o < l.orderedModifiers.length; o++)
                  !0 === l.reset
                    ? ((l.reset = !1), (o = -1))
                    : ((n = (i = l.orderedModifiers[o]).fn),
                      (r = i.options),
                      (i = i.name),
                      'function' == typeof n &&
                        (l = n({ state: l, options: void 0 === r ? {} : r, name: i, instance: u }) || l))
              }
            }
          },
          update:
            ((o = function () {
              return new Promise(function (e) {
                u.forceUpdate(), e(l)
              })
            }),
            function () {
              return (a =
                a ||
                new Promise(function (e) {
                  Promise.resolve().then(function () {
                    ;(a = void 0), e(o())
                  })
                }))
            }),
          destroy: function () {
            d(), (c = !0)
          }
        }
      return (
        aS(e, t) &&
          u.setOptions(i).then(function (e) {
            !c && i.onFirstUpdate && i.onFirstUpdate(e)
          }),
        u
      )
      function d() {
        s.forEach(function (e) {
          return e()
        }),
          (s = [])
      }
    }
  })({
    defaultModifiers: [
      {
        name: 'eventListeners',
        enabled: !0,
        phase: 'write',
        fn: function () {},
        effect: function (e) {
          var t = e.state,
            n = e.instance,
            r = (e = e.options).scroll,
            i = void 0 === r || r,
            o = void 0 === (r = e.resize) || r,
            a = yE(t.elements.popper),
            l = [].concat(t.scrollParents.reference, t.scrollParents.popper)
          return (
            i &&
              l.forEach(function (e) {
                e.addEventListener('scroll', n.update, WE)
              }),
            o && a.addEventListener('resize', n.update, WE),
            function () {
              i &&
                l.forEach(function (e) {
                  e.removeEventListener('scroll', n.update, WE)
                }),
                o && a.removeEventListener('resize', n.update, WE)
            }
          )
        },
        data: {}
      },
      {
        name: 'popperOffsets',
        enabled: !0,
        phase: 'read',
        fn: function (e) {
          var t = e.state
          e = e.name
          t.modifiersData[e] = eS({
            reference: t.rects.reference,
            element: t.rects.popper,
            strategy: 'absolute',
            placement: t.placement
          })
        },
        data: {}
      },
      {
        name: 'computeStyles',
        enabled: !0,
        phase: 'beforeWrite',
        fn: function (e) {
          var t = e.state,
            n = void 0 === (n = (e = e.options).gpuAcceleration) || n,
            r = void 0 === (r = e.adaptive) || r
          ;(e = void 0 === (e = e.roundOffsets) || e),
            (n = {
              placement: xE(t.placement),
              variation: HE(t.placement),
              popper: t.elements.popper,
              popperRect: t.rects.popper,
              gpuAcceleration: n,
              isFixed: 'fixed' === t.options.strategy
            })
          null != t.modifiersData.popperOffsets &&
            (t.styles.popper = Object.assign(
              {},
              t.styles.popper,
              VE(
                Object.assign({}, n, {
                  offsets: t.modifiersData.popperOffsets,
                  position: t.options.strategy,
                  adaptive: r,
                  roundOffsets: e
                })
              )
            )),
            null != t.modifiersData.arrow &&
              (t.styles.arrow = Object.assign(
                {},
                t.styles.arrow,
                VE(
                  Object.assign({}, n, {
                    offsets: t.modifiersData.arrow,
                    position: 'absolute',
                    adaptive: !1,
                    roundOffsets: e
                  })
                )
              )),
            (t.attributes.popper = Object.assign({}, t.attributes.popper, { 'data-popper-placement': t.placement }))
        },
        data: {}
      },
      {
        name: 'applyStyles',
        enabled: !0,
        phase: 'write',
        fn: function (e) {
          var t = e.state
          Object.keys(t.elements).forEach(function (e) {
            var n = t.styles[e] || {},
              r = t.attributes[e] || {},
              i = t.elements[e]
            wE(i) &&
              vE(i) &&
              (Object.assign(i.style, n),
              Object.keys(r).forEach(function (e) {
                var t = r[e]
                !1 === t ? i.removeAttribute(e) : i.setAttribute(e, !0 === t ? '' : t)
              }))
          })
        },
        effect: function (e) {
          var t = e.state,
            n = {
              popper: { position: t.options.strategy, left: '0', top: '0', margin: '0' },
              arrow: { position: 'absolute' },
              reference: {}
            }
          return (
            Object.assign(t.elements.popper.style, n.popper),
            (t.styles = n),
            t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow),
            function () {
              Object.keys(t.elements).forEach(function (e) {
                var r = t.elements[e],
                  i = t.attributes[e] || {}
                e = Object.keys((t.styles.hasOwnProperty(e) ? t.styles : n)[e]).reduce(function (e, t) {
                  return (e[t] = ''), e
                }, {})
                wE(r) &&
                  vE(r) &&
                  (Object.assign(r.style, e),
                  Object.keys(i).forEach(function (e) {
                    r.removeAttribute(e)
                  }))
              })
            }
          )
        },
        requires: ['computeStyles']
      },
      {
        name: 'offset',
        enabled: !0,
        phase: 'main',
        requires: ['popperOffsets'],
        fn: function (e) {
          var t = e.state,
            n = e.options,
            r = ((e = e.name), void 0 === (n = n.offset) ? [0, 0] : n),
            i = (o = (n = gE.reduce(function (e, n) {
              var i, o, a, l
              return (
                (e[n] =
                  ((i = t.rects),
                  (o = r),
                  (a = xE(n)),
                  (l = 0 <= [lE, iE].indexOf(a) ? -1 : 1),
                  (n = (i = 'function' == typeof o ? o(Object.assign({}, i, { placement: n })) : o)[0] || 0),
                  (o = (i[1] || 0) * l),
                  0 <= [lE, aE].indexOf(a) ? { x: o, y: n } : { x: n, y: o })),
                e
              )
            }, {}))[t.placement]).x,
            o = o.y
          null != t.modifiersData.popperOffsets &&
            ((t.modifiersData.popperOffsets.x += i), (t.modifiersData.popperOffsets.y += o)),
            (t.modifiersData[e] = n)
        }
      },
      {
        name: 'flip',
        enabled: !0,
        phase: 'main',
        fn: function (e) {
          var t = e.state,
            n = e.options
          e = e.name
          if (!t.modifiersData[e]._skip) {
            for (
              var r,
                i = void 0 === (a = n.mainAxis) || a,
                o = void 0 === (a = n.altAxis) || a,
                a = n.fallbackPlacements,
                l = n.padding,
                s = n.boundary,
                c = n.rootBoundary,
                u = n.altBoundary,
                d = void 0 === (r = n.flipVariations) || r,
                f = n.allowedAutoPlacements,
                h =
                  ((n = xE((r = t.options.placement))),
                  (a = a || (n !== r && d ? (xE((a = r)) === sE ? [] : ((n = ZE(a)), [XE(a), n, XE(n)])) : [ZE(r)])),
                  [r].concat(a).reduce(function (e, n) {
                    return e.concat(
                      xE(n) === sE
                        ? ((r = t),
                          (i = (e = e =
                            void 0 ===
                            (e = {
                              placement: n,
                              boundary: s,
                              rootBoundary: c,
                              padding: l,
                              flipVariations: d,
                              allowedAutoPlacements: f
                            })
                              ? {}
                              : e).placement),
                          (o = e.boundary),
                          (a = e.rootBoundary),
                          (u = e.padding),
                          (h = e.flipVariations),
                          (p = void 0 === (e = e.allowedAutoPlacements) ? gE : e),
                          (e = (g = HE(i))
                            ? h
                              ? pE
                              : pE.filter(function (e) {
                                  return HE(e) === g
                                })
                            : cE),
                          (m = (i =
                            0 ===
                            (i = e.filter(function (e) {
                              return 0 <= p.indexOf(e)
                            })).length
                              ? e
                              : i).reduce(function (e, t) {
                            return (e[t] = tS(r, { placement: t, boundary: o, rootBoundary: a, padding: u })[xE(t)]), e
                          }, {})),
                          Object.keys(m).sort(function (e, t) {
                            return m[e] - m[t]
                          }))
                        : n
                    )
                    var r, i, o, a, u, h, p, g, m
                  }, [])),
                p = t.rects.reference,
                g = t.rects.popper,
                m = new Map(),
                v = !0,
                y = h[0],
                b = 0;
              b < h.length;
              b++
            ) {
              var w = h[b],
                C = xE(w),
                x = HE(w) === uE,
                E = (O = 0 <= [iE, oE].indexOf(C)) ? 'width' : 'height',
                S = tS(t, { placement: w, boundary: s, rootBoundary: c, altBoundary: u, padding: l }),
                O = O ? (x ? aE : lE) : x ? oE : iE
              ;(x = (p[E] > g[E] && (O = ZE(O)), ZE(O))), (E = [])
              if (
                (i && E.push(S[C] <= 0),
                o && E.push(S[O] <= 0, S[x] <= 0),
                E.every(function (e) {
                  return e
                }))
              ) {
                ;(y = w), (v = !1)
                break
              }
              m.set(w, E)
            }
            if (v)
              for (
                var k = d ? 3 : 1;
                0 < k &&
                'break' !==
                  (function (e) {
                    var t = h.find(function (t) {
                      if ((t = m.get(t)))
                        return t.slice(0, e).every(function (e) {
                          return e
                        })
                    })
                    if (t) return (y = t), 'break'
                  })(k);
                k--
              );
            t.placement !== y && ((t.modifiersData[e]._skip = !0), (t.placement = y), (t.reset = !0))
          }
        },
        requiresIfExists: ['offset'],
        data: { _skip: !1 }
      },
      {
        name: 'preventOverflow',
        enabled: !0,
        phase: 'main',
        fn: function (e) {
          var t,
            n,
            r,
            i,
            o,
            a,
            l,
            s,
            c,
            u = e.state,
            d = e.options,
            f = ((e = e.name), void 0 === (f = d.mainAxis) || f),
            h = void 0 !== (h = d.altAxis) && h,
            p = d.boundary,
            g = d.rootBoundary,
            m = d.altBoundary,
            v = d.padding,
            y = void 0 === (y = d.tether) || y,
            b =
              ((d = void 0 === (d = d.tetherOffset) ? 0 : d),
              (p = tS(u, { boundary: p, rootBoundary: g, padding: v, altBoundary: m })),
              (g = xE(u.placement)),
              (m = !(v = HE(u.placement))),
              AE(g)),
            w = 'x' === b ? 'y' : 'x',
            C = u.modifiersData.popperOffsets,
            x = u.rects.reference,
            E = u.rects.popper,
            S =
              ((d =
                'number' ==
                typeof (d = 'function' == typeof d ? d(Object.assign({}, u.rects, { placement: u.placement })) : d)
                  ? { mainAxis: d, altAxis: d }
                  : Object.assign({ mainAxis: 0, altAxis: 0 }, d)),
              u.modifiersData.offset ? u.modifiersData.offset[u.placement] : null),
            O = { x: 0, y: 0 }
          C &&
            (f &&
              ((f = 'y' === b ? 'height' : 'width'),
              (a = (l = C[b]) + p[(n = 'y' === b ? iE : lE)]),
              (s = l - p[(c = 'y' === b ? oE : aE)]),
              (t = y ? -E[f] / 2 : 0),
              (i = (v === uE ? x : E)[f]),
              (v = v === uE ? -E[f] : -x[f]),
              (o = u.elements.arrow),
              (o = y && o ? LE(o) : { width: 0, height: 0 }),
              (n = (r = u.modifiersData['arrow#persistent']
                ? u.modifiersData['arrow#persistent'].padding
                : { top: 0, right: 0, bottom: 0, left: 0 })[n]),
              (r = r[c]),
              (c = zE(0, x[f], o[f])),
              (o = m ? x[f] / 2 - t - c - n - d.mainAxis : i - c - n - d.mainAxis),
              (i = m ? -x[f] / 2 + t + c + r + d.mainAxis : v + c + r + d.mainAxis),
              (m = (n = u.elements.arrow && DE(u.elements.arrow))
                ? 'y' === b
                  ? n.clientTop || 0
                  : n.clientLeft || 0
                : 0),
              (v = l + i - (t = null != (f = null == S ? void 0 : S[b]) ? f : 0)),
              (c = zE(y ? SE(a, l + o - t - m) : a, l, y ? EE(s, v) : s)),
              (C[b] = c),
              (O[b] = c - l)),
            h &&
              ((r = 'y' == w ? 'height' : 'width'),
              (i = (n = C[w]) + p['x' === b ? iE : lE]),
              (f = n - p['x' === b ? oE : aE]),
              (o = -1 !== [iE, lE].indexOf(g)),
              (m = null != (t = null == S ? void 0 : S[w]) ? t : 0),
              (a = o ? i : n - x[r] - E[r] - m + d.altAxis),
              (v = o ? n + x[r] + E[r] - m - d.altAxis : f),
              (l = y && o ? ((s = zE((s = a), n, (c = v))), c < s ? c : s) : zE(y ? a : i, n, y ? v : f)),
              (C[w] = l),
              (O[w] = l - n)),
            (u.modifiersData[e] = O))
        },
        requiresIfExists: ['offset']
      },
      {
        name: 'arrow',
        enabled: !0,
        phase: 'main',
        fn: function (e) {
          var t,
            n,
            r,
            i,
            o = e.state,
            a = e.name,
            l = ((e = e.options), o.elements.arrow),
            s = o.modifiersData.popperOffsets,
            c = AE((u = xE(o.placement))),
            u = 0 <= [lE, aE].indexOf(u) ? 'height' : 'width'
          l &&
            s &&
            ((n = o),
            (n = NE(
              'number' !=
                typeof (e =
                  'function' == typeof (e = e.padding) ? e(Object.assign({}, n.rects, { placement: n.placement })) : e)
                ? e
                : FE(e, cE)
            )),
            (e = LE(l)),
            (i = 'y' === c ? iE : lE),
            (r = 'y' === c ? oE : aE),
            (t = o.rects.reference[u] + o.rects.reference[c] - s[c] - o.rects.popper[u]),
            (s = s[c] - o.rects.reference[c]),
            (l = (l = DE(l)) ? ('y' === c ? l.clientHeight || 0 : l.clientWidth || 0) : 0),
            (i = n[i]),
            (n = l - e[u] - n[r]),
            (i = zE(i, (r = l / 2 - e[u] / 2 + (t / 2 - s / 2)), n)),
            (o.modifiersData[a] = (((l = {})[c] = i), (l.centerOffset = i - r), l)))
        },
        effect: function (e) {
          var t = e.state
          null != (e = void 0 === (e = e.options.element) ? '[data-popper-arrow]' : e) &&
            ('string' != typeof e || (e = t.elements.popper.querySelector(e))) &&
            TE(t.elements.popper, e) &&
            (t.elements.arrow = e)
        },
        requires: ['popperOffsets'],
        requiresIfExists: ['preventOverflow']
      },
      {
        name: 'hide',
        enabled: !0,
        phase: 'main',
        requiresIfExists: ['preventOverflow'],
        fn: function (e) {
          var t = e.state,
            n = ((e = e.name), t.rects.reference),
            r = t.rects.popper,
            i = t.modifiersData.preventOverflow,
            o = tS(t, { elementContext: 'reference' }),
            a = tS(t, { altBoundary: !0 })
          ;(o = nS(o, n)), (n = nS(a, r, i)), (a = rS(o)), (r = rS(n))
          ;(t.modifiersData[e] = {
            referenceClippingOffsets: o,
            popperEscapeOffsets: n,
            isReferenceHidden: a,
            hasPopperEscaped: r
          }),
            (t.attributes.popper = Object.assign({}, t.attributes.popper, {
              'data-popper-reference-hidden': a,
              'data-popper-escaped': r
            }))
        }
      }
    ]
  })
  function sS(e) {
    var t = s.exports.useRef(null)
    return (
      s.exports.useEffect(function () {
        var n,
          r,
          i = document.querySelector('#'.concat(e)),
          o = i || ((n = e), (r = document.createElement('div')).setAttribute('id', n), r)
        return (
          i || document.body.append(o),
          t.current && o.append(t.current),
          function () {
            t.current && t.current.remove(), -1 === o.childNodes.length && o.remove()
          }
        )
      }, []),
      t.current || (t.current = document.createElement('div')),
      t.current
    )
  }
  var cS = {
      AutoStart: 'auto-start',
      Auto: 'auto',
      AutoEnd: 'auto-end',
      TopStart: 'top-start',
      Top: 'top',
      TopEnd: 'top-end',
      BottomStart: 'bottom-start',
      Bottom: 'bottom',
      BottomEnd: 'bottom-end',
      LeftStart: 'left-start',
      Left: 'left',
      LeftEnd: 'left-end',
      RightStart: 'right-start',
      Right: 'right',
      RightEnd: 'right-end'
    },
    uS =
      (r((Qy = {}), cS.Auto, Yf(['top:0px;bottom:0px;left:0px;right:0px;'])),
      r(Qy, cS.AutoEnd, Yf(['top:0px;bottom:0px;left:0px;right:0px;'])),
      r(Qy, cS.AutoStart, Yf(['top:0px;bottom:0px;left:0px;right:0px;'])),
      r(Qy, cS.Right, Yf(['left:-4px;'])),
      r(Qy, cS.RightEnd, Yf(['left:-4px;'])),
      r(Qy, cS.RightStart, Yf(['left:-4px;'])),
      r(Qy, cS.Left, Yf(['right:-4px;'])),
      r(Qy, cS.LeftEnd, Yf(['right:-4px;'])),
      r(Qy, cS.LeftStart, Yf(['right:-4px;'])),
      r(Qy, cS.Top, Yf(['bottom:-4px;'])),
      r(Qy, cS.TopEnd, Yf(['bottom:-4px;'])),
      r(Qy, cS.TopStart, Yf(['bottom:-4px;'])),
      r(Qy, cS.Bottom, Yf(['top:-4px;'])),
      r(Qy, cS.BottomEnd, Yf(['top:-4px;'])),
      r(Qy, cS.BottomStart, Yf(['top:-4px;'])),
      Qy),
    dS =
      ((Jy = 'Popper'),
      c.div.attrs({ className: Ap(Jy, 'root') }).withConfig({ componentId: 'sc-1373tsp-0' })(function () {
        return Yf([''])
      })),
    fS =
      ((oC = c.div.attrs({ className: Ap(Jy, 'wrapper') }).withConfig({ componentId: 'sc-1373tsp-1' })(function (e) {
        return Yf(['position:relative;z-index:', ';'], e.zIndex)
      })),
      (iC = c.div.attrs({ className: Ap(Jy, 'arrow') }).withConfig({ componentId: 'sc-1373tsp-2' })(function (e) {
        var t = e.position
        return Yf(
          [
            "width:8px;height:8px;position:absolute;&::before{content:'';background:",
            ';width:8px;height:8px;transform:rotate(45deg);position:absolute;top:0;left:0;z-index:-1;}',
            ''
          ],
          e.theme.palette[dg.IconsPrimary],
          uS[void 0 === t ? cS.Right : t]
        )
      })),
      Hp({
        Popper: dS,
        Overlay: c.div.attrs({ className: Ap(Jy, 'Overlay') }).withConfig({ componentId: 'sc-1373tsp-3' })(function () {
          return Yf(['position:fixed;right:0px;bottom:0px;top:0px;left:0px;background-color:transparent;'])
        }),
        Arrow: iC,
        PopperWrapper: oC
      }))
  function hS(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function pS(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {}
      t % 2
        ? hS(Object(n), !0).forEach(function (t) {
            r(e, t, n[t])
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
        : hS(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
          })
    }
    return e
  }
  ;(aC = zp(function (e, t) {
    var n = e.anchorEl,
      r = e.children,
      i = e.open,
      o = void 0 === (u = e.position) ? 'bottom' : u,
      a = void 0 !== (u = e.arrow) && u,
      l = e.popperOptions,
      c = e.onClick,
      u = void 0 !== (u = e.overlay) && u,
      d = void 0 === (d = e.zIndex) ? 1300 : d,
      f = e.enableUnderlayingEvent,
      h = ((e = void 0 === (e = e.wrapperStyles) ? {} : e), sS(Ap('Popper'))),
      p = s.exports.useRef(null),
      g = Vp(p, t)
    s.exports.useEffect(
      function () {
        var e, t
        if (n && i && null !== p.current)
          return (
            (e = a
              ? [
                  { name: 'arrow', options: { element: '[data-popper-arrow]' } },
                  { name: 'offset', options: { offset: [0, 10] } }
                ]
              : []),
            l && null != l.modifiers && (e = e.concat(l.modifiers)),
            (t = lS(n, p.current, pS(pS({ placement: o }, l), {}, { modifiers: e }))),
            (g.current = t),
            function () {
              t.destroy(), (g.current = null)
            }
          )
      },
      [n, i, l, o, a]
    ),
      (t = function (e) {
        var t
        e.persist(),
          e.preventDefault(),
          e.stopPropagation(),
          c && c(e),
          f &&
            ((t = e),
            setTimeout(function () {
              var e
              t.clientX &&
                t.clientY &&
                (e = document.elementFromPoint(t.clientX, t.clientY)) &&
                e.dispatchEvent(t.nativeEvent)
            }, 0))
      })
    return i
      ? de.exports.createPortal(
          ue.createElement(
            fS.PopperWrapper,
            { zIndex: d, style: pS({}, e) },
            u && ue.createElement(fS.Overlay, { onClick: t, onContextMenu: t }),
            ue.createElement(
              fS.Popper,
              { ref: g },
              r,
              a &&
                ue.createElement(fS.Arrow, {
                  'data-popper-arrow': !0,
                  position: (null == g || null == (d = g.state) ? void 0 : d.placement) || o
                })
            )
          ),
          h
        )
      : ue.createElement('div', { ref: g })
  })),
    (aC.defaultProps = {}),
    (rC = {
      anchorEl: ce.oneOfType([ce.instanceOf(Element), ce.object]),
      popperOptions: ce.shape({
        modifiers: ce.arrayOf(
          ce.shape({
            data: ce.object,
            effect: ce.func,
            enabled: ce.bool,
            fn: ce.func,
            name: ce.any.isRequired,
            options: ce.object,
            phase: ce.oneOf([
              'afterMain',
              'afterRead',
              'afterWrite',
              'beforeMain',
              'beforeRead',
              'beforeWrite',
              'main',
              'read',
              'write'
            ]),
            requires: ce.arrayOf(ce.string),
            requiresIfExists: ce.arrayOf(ce.string)
          })
        ),
        onFirstUpdate: ce.func,
        placement: ce.oneOf(Fp(cS)),
        strategy: ce.oneOf(Fp({ Absloute: 'absolute', Fixed: 'fixed' }))
      }),
      overlay: ce.bool,
      arrow: ce.bool,
      zIndex: ce.number,
      enableUnderlayingEvent: ce.bool,
      wrapperStyles: ce.object
    })
  var gS = ((aC.propTypes = rC), aC),
    mS =
      ((cC = c.div.attrs({ className: Ap('Menu', 'Overlay') }).withConfig({ componentId: 'sc-10okxhw-0' })(function () {
        return Yf(['position:fixed;right:0px;bottom:0px;top:0px;left:0px;background-color:transparent;z-index:-1;'])
      })),
      Hp({
        Menu: c.div.attrs({ className: Ap('Menu', 'root') }).withConfig({ componentId: 'sc-10okxhw-1' })(function (e) {
          var t = e.rect,
            n = e.theme
          e = void 0 === (e = e.maxHeight) ? '' : e
          return Yf(
            [
              'min-width:',
              'px;min-height:16px;overflow-x:hidden;overflow-y:auto;transition:opacity 251ms cubic-bezier(0.4,0,0.2,1) 0ms,transform 167ms cubic-bezier(0.4,0,0.2,1) 0ms;outline:0;box-shadow:0 2px 4px ',
              ';border-radius:',
              ';',
              '::-webkit-scrollbar{width:6px;}::-webkit-scrollbar-track{background:#f1f1f1;}::-webkit-scrollbar-thumb{background:rgba(0,0,0,0.35);border-radius:2px;}::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,0.5);}'
            ],
            t.width,
            n.palette[dg.LightShadow],
            n.shape.borderRadius[hg.Md],
            e && Yf(['max-height:', ';'], Number.isNaN(+e) ? e : ''.concat(e, 'px'))
          )
        }),
        Overlay: cC
      })),
    vS = [
      'id',
      'children',
      'open',
      'fullWidth',
      'anchorElPosition',
      'anchorEl',
      'onClose',
      'containerProps',
      'alignCenter',
      'maxHeight',
      'position',
      'popperOptions',
      'enableOverlay',
      'zIndex',
      'hideScroll',
      'enableUnderlayingEvent',
      'popperWrapperStyles'
    ]
  function yS(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function bS(e, t) {
    return Math.min(e.width / t.width, e.height / t.height) || 1
  }
  h = zp(function (e, t) {
    e.id
    var n = e.children,
      i = e.open,
      o = (e.fullWidth, e.anchorElPosition),
      a = e.anchorEl,
      l = e.onClose,
      c = e.containerProps,
      u = e.alignCenter,
      d = e.maxHeight,
      f = e.position,
      h = e.popperOptions,
      p = void 0 === (p = e.enableOverlay) || p,
      g = e.zIndex,
      m = void 0 === (v = e.hideScroll) || v,
      v = void 0 !== (v = e.enableUnderlayingEvent) && v,
      y = void 0 === (y = e.popperWrapperStyles) ? {} : y,
      b = ((e = Hu(e, vS)), (E = Lg(s.exports.useState(null), 2))[0]),
      w = E[1],
      C = (E = Lg(s.exports.useState(new DOMRect()), 2))[0],
      x = E[1],
      E = s.exports.useRef(null),
      S = s.exports.useCallback(
        function () {
          var e,
            t = (function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {}
                t % 2
                  ? yS(Object(n), !0).forEach(function (t) {
                      r(e, t, n[t])
                    })
                  : Object.getOwnPropertyDescriptors
                  ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
                  : yS(Object(n)).forEach(function (t) {
                      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
                    })
              }
              return e
            })({ top: 0, left: 0, height: 0, width: 0 }, o || {})
          t = new DOMRect(t.left, t.top, t.width, t.height)
          x(null != (e = null == a ? void 0 : a.getBoundingClientRect()) ? e : t)
        },
        [i, b, a]
      ),
      O = s.exports.useCallback(
        function () {
          i && (b && clearTimeout(b), w(setTimeout(S, 300)))
        },
        [i, b]
      )
    return (
      s.exports.useEffect(
        function () {
          return (
            window.addEventListener('resize', O),
            function () {
              window.removeEventListener('resize', O)
            }
          )
        },
        [O]
      ),
      s.exports.useEffect(
        function () {
          S()
        },
        [o, S]
      ),
      s.exports.useEffect(
        function () {
          if (m)
            return (
              i ? (document.body.classList.add('Menu-open'), S()) : document.body.classList.remove('Menu-open'),
              function () {
                document.body.classList.remove('Menu-open')
              }
            )
        },
        [i, S]
      ),
      ue.createElement(
        ue.Fragment,
        null,
        ue.createElement(
          gS,
          {
            ref: E,
            position: f || 'bottom',
            open: Boolean(a),
            anchorEl: a,
            overlay: Boolean(p),
            onClick: function (e) {
              'function' == typeof l && l(e)
            },
            popperOptions: h,
            zIndex: g,
            enableUnderlayingEvent: v,
            wrapperStyles: y
          },
          ue.createElement(mS.Menu, Tg({}, c, { alignCenter: Boolean(u), rect: C }, e, { ref: t, maxHeight: d }), n)
        )
      )
    )
  })
  var wS =
      ((h.defaultProps = {
        open: !1,
        containerProps: {},
        maxHeight: 0,
        position: cS.Bottom,
        enableOverlay: !0,
        hideScroll: !0
      }),
      {
        anchorElPosition: ce.shape({ left: ce.number, right: ce.number, top: ce.number, bottom: ce.number }),
        anchorEl: ce.instanceOf(Element),
        open: ce.bool,
        fullWidth: ce.bool,
        onClose: ce.func,
        id: ce.string,
        containerProps: ce.object,
        alignCenter: ce.bool,
        maxHeight: ce.oneOfType([ce.string, ce.number]),
        popperOptions: rC.popperOptions,
        position: ce.oneOf(Fp(cS)),
        enableOverlay: ce.bool,
        zIndex: ce.number,
        hideScroll: ce.bool,
        enableUnderlayingEvent: ce.bool,
        popperWrapperStyles: ce.object
      }),
    CS = ((h.propTypes = wS), h)
  function xS(e, t) {
    var n = s.exports.forwardRef(e)
    return (n.displayName = t || e.name), n
  }
  function ES(e) {
    switch (e) {
      case LS.Xl:
        return 16
      case LS.Lg:
      case LS.Md:
        return 14
      case LS.Sm:
        return 12
      default:
        return 11
    }
  }
  var SS = ['color', 'size'],
    OS = xS(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 28 : r
      e = Hu(e, SS)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M41.3465 44.355C33.5656 50.7844 22.9687 51.6268 14.3708 47.3665L17.8949 44.4545C24.754 47.117 32.7424 46.1093 38.709 41.1792C44.6755 36.249 47.1546 28.6071 45.8085 21.3893L49.3325 18.4773C51.9291 27.6967 49.1274 37.9256 41.3465 44.355Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M36.1749 2.63356L32.6509 5.54555C25.821 2.91828 17.838 3.86187 11.8366 8.82088C5.87009 13.7511 3.42028 21.4282 4.7372 28.6107L1.21311 31.5227C-1.38344 22.3034 1.45314 12.0456 9.19916 5.64502C16.9801 -0.784402 27.5768 -1.62682 36.1749 2.63356Z',
          fill: n
        })
      )
    }),
    kS = { Left: 'left', Right: 'right', Top: 'top', Bottom: 'bottom' },
    PS = { Primary: 'primary', Secondary: 'secondary', Link: 'link', Error: 'error' },
    _S = { Primary: 'primary', Secondary: 'secondary' },
    LS = { Xs: 'xs', Sm: 'sm', Md: 'md', Lg: 'lg', Xl: 'xl' },
    TS = { Sm: 'sm', Md: 'md' },
    IS =
      (r((l = {}), (y = { Primary: 'primary', Secondary: 'secondary', White: 'white' }).Primary, function (e) {
        return Yf(
          ['background-color:', ';color:', ';'],
          (e = e.theme.palette)[dg.AccentPrimary],
          e[dg.ButtonPrimaryText]
        )
      }),
      r(l, y.White, function (e) {
        return Yf(
          ['background-color:', ';color:', ';'],
          (e = e.theme.palette)[dg.ButtonPrimaryText],
          e[dg.AccentPrimary]
        )
      }),
      r(l, y.Secondary, function (e) {
        return Yf(['background-color:', ';color:#e9eef2;'], e.theme.palette[dg.IconsPrimary])
      }),
      l),
    MS = Hp({
      BadgeRoot: c.span.attrs({ className: Ap('Badge', 'root') }).withConfig({ componentId: 'sc-1rfm40m-0' })([
        'position:relative;display:inline-flex;flex-shrink:0;vertical-align:middle;'
      ]),
      Badge: c.span.attrs({ className: Ap('Badge') }).withConfig({ componentId: 'sc-1rfm40m-1' })(function (e) {
        var t = e.size,
          n = void 0 === (n = e.color) ? 'secondary' : n,
          r = void 0 === (r = e.fontSize) ? '0.75rem' : r,
          i = void 0 === (i = e.padding) ? '0 6px' : i
        return Yf(
          [
            '',
            ' display:flex;flex-wrap:wrap;flex-direction:row;justify-content:center;align-items:center;align-content:center;height:',
            'px;min-width:',
            'px;line-height:1;padding:',
            ';font-size:',
            ';box-sizing:border-box;transition:transform 225ms cubic-bezier(0.4,0,0.2,1) 0ms;border-radius:',
            'px;z-index:1;',
            ''
          ],
          e.inline ? '' : 'position: absolute;',
          t || 20,
          t || 20,
          'number' == typeof i ? ''.concat(i, 'px') : i,
          'number' == typeof r ? ''.concat(r, 'px') : r,
          (t || 20) / 2,
          IS[n]
        )
      })
    }),
    jS = ['badgeContent'],
    RS =
      ((ug = zp(function (e, t) {
        var n = e.badgeContent
        e = Hu(e, jS)
        return ue.createElement(MS.BadgeRoot, { ref: t }, ue.createElement(MS.Badge, e, n))
      })),
      (ug.defaultProps = { color: y.Secondary, inline: !1 }),
      (ug.propTypes = {
        color: ce.oneOf(Fp(y)),
        badgeContent: ce.node,
        size: ce.oneOfType([ce.number]),
        fontSize: ce.oneOfType([ce.number, ce.string]),
        padding: ce.oneOfType([ce.number, ce.string]),
        inline: ce.bool
      }),
      ug),
    DS =
      (r((Og = {}), PS.Primary, function (e) {
        return Yf(
          [
            'background-color:',
            ';color:',
            ';',
            '{background-color:',
            ';}&:hover{background-color:',
            ';}&:active{background-color:',
            ';}&:disabled{color:',
            ';background:',
            ';',
            '{background-color:',
            ';color:',
            ';}}'
          ],
          (e = e.theme.palette)[dg.AccentPrimary],
          e[dg.ButtonPrimaryText],
          MS.Badge,
          e[dg.ButtonPrimaryText],
          e[dg.AccentPrimaryHover],
          e[dg.AccentPrimaryActive],
          e[dg.ButtonDisabledText],
          e[dg.AccentPrimaryDisabled],
          MS.Badge,
          e[dg.ButtonDisabledText],
          e[dg.AccentPrimaryDisabled]
        )
      }),
      r(Og, PS.Secondary, function (e) {
        return Yf(
          [
            'background-color:',
            ';color:',
            ';&:hover{background-color:',
            ';}&:active{background-color:',
            ';}&:disabled{color:',
            ';background:',
            ';',
            '{background-color:',
            ';}}',
            '{background-color:',
            ';}'
          ],
          (e = e.theme.palette)[dg.ActiveSecondary],
          e[dg.IconsPrimary],
          e[dg.ActiveSecondaryHover],
          e[dg.ActiveSecondaryActive],
          e[dg.ButtonDisabledText],
          e[dg.AccentPrimaryDisabled],
          MS.Badge,
          e[dg.ButtonDisabledText],
          MS.Badge,
          e[dg.IconsPrimary]
        )
      }),
      r(Og, PS.Link, function (e) {
        return Yf(
          [
            'background-color:transparent;color:',
            ';&:hover{color:',
            ';',
            '{background-color:',
            ';}}&:active{color:',
            ';',
            '{background-color:',
            ';}}&:disabled{color:',
            ';',
            '{background-color:',
            ';}}'
          ],
          (e = e.theme.palette)[dg.LinkPrimary],
          e[dg.LinkHover],
          MS.Badge,
          e[dg.LinkHover],
          e[dg.LinkActive],
          MS.Badge,
          e[dg.LinkActive],
          e[dg.ButtonDisabledText],
          MS.Badge,
          e[dg.ButtonDisabledText]
        )
      }),
      r(Og, PS.Error, function (e) {
        return Yf(
          [
            'background-color:',
            ';color:',
            ';',
            '{background-color:',
            ';}&:hover{background-color:rgba(224,81,44,1);}&:active{background-color:rgba(201,58,23,1);}&:disabled{color:',
            ';background:',
            ';',
            '{background-color:',
            ';color:',
            ';}}'
          ],
          (e = e.theme.palette)[dg.Error],
          e[dg.ButtonPrimaryText],
          MS.Badge,
          e[dg.ButtonPrimaryText],
          e[dg.ButtonDisabledText],
          e[dg.AccentPrimaryDisabled],
          MS.Badge,
          e[dg.ButtonDisabledText],
          e[dg.AccentPrimaryDisabled]
        )
      }),
      Og),
    AS =
      (r((mg = {}), LS.Xs, Yf(['padding:4px 8px;'])),
      r(mg, LS.Sm, Yf(['padding:6px 10px;'])),
      r(mg, LS.Md, Yf(['padding:8px 12px;'])),
      r(mg, LS.Lg, Yf(['padding:10px 14px;'])),
      r(mg, LS.Xl, Yf(['padding:12px 16px;'])),
      mg),
    zS =
      (r((f = {}), LS.Xs, function (e) {
        return Yf(e.theme.typography.font[fg.ButtonXs])
      }),
      r(f, LS.Sm, function (e) {
        return Yf(e.theme.typography.font[fg.ButtonSm])
      }),
      r(f, LS.Md, function (e) {
        return Yf(e.theme.typography.font[fg.ButtonMd])
      }),
      r(f, LS.Lg, function (e) {
        return Yf(e.theme.typography.font[fg.ButtonLg])
      }),
      r(f, LS.Xl, function (e) {
        return Yf(e.theme.typography.font[fg.ButtonXl])
      }),
      f),
    NS =
      ((p = 'Button'),
      c.span.attrs({ className: Ap(p, 'Label') }).withConfig({ componentId: 'sc-lxwit0-0' })(['display:flex;'])),
    FS =
      ((Qy = c.span.attrs({ className: Ap(p, 'Badge') }).withConfig({ componentId: 'sc-lxwit0-1' })([
        'display:flex;margin-left:5px;'
      ])),
      Hp({
        Button: c.button.attrs({ className: Ap(p, 'root') }).withConfig({ componentId: 'sc-lxwit0-2' })(function (e) {
          var t = e.color,
            n = void 0 === (n = e.size) ? LS.Md : n
          return Yf(
            [
              'display:inline-flex;flex-shrink:0;flex-direction:row;align-items:center;border-radius:',
              ';border:0;cursor:pointer;outline:none;',
              ' ',
              ' ',
              '{',
              '}'
            ],
            e.theme.shape.borderRadius[hg.Sm],
            DS[void 0 === t ? PS.Secondary : t],
            AS[n],
            NS,
            zS[n]
          )
        }),
        Label: NS,
        Icon: c.span.attrs({ className: Ap(p, 'Icon') }).withConfig({ componentId: 'sc-lxwit0-3' })(function (e) {
          return Yf(
            ['display:flex;margin-right:4px;margin-left:1px;svg{animation:', ';}'],
            e.$loading ? 'spinner 1.2s linear infinite' : '1.2s'
          )
        }),
        Badge: Qy
      })),
    HS = ['children', 'icon', 'badge', 'color', 'size', 'loading', 'disabled'],
    BS =
      ((dS = zp(function (e, t) {
        var n = e.children,
          r = e.icon,
          i = e.badge,
          o = e.color,
          a = e.size,
          l = e.loading,
          s = e.disabled
        e = Hu(e, HS)
        return ue.createElement(
          FS.Button,
          Tg({ type: 'button' }, e, { disabled: l || s, color: o, size: a, ref: t }),
          r &&
            ue.createElement(
              FS.Icon,
              { $loading: l },
              'function' == typeof r
                ? l
                  ? ue.createElement(OS, { size: ES(a) })
                  : r({ size: ES(a) })
                : l
                ? ue.createElement(OS, { size: ES(a) })
                : r
            ),
          l && !r && ue.createElement(FS.Icon, { $loading: l }, ue.createElement(OS, { size: ES(a) })),
          ue.createElement(FS.Label, null, n),
          i &&
            ue.createElement(
              FS.Badge,
              null,
              ue.createElement(RS, {
                inline: !0,
                size: 14,
                fontSize: 10,
                padding: '0 1px',
                badgeContent: i,
                color: o === PS.Primary ? 'white' : 'secondary'
              })
            )
        )
      })),
      (dS.defaultProps = { size: LS.Md, color: PS.Secondary }),
      (dS.propTypes = {
        size: ce.oneOf(Fp(LS)),
        color: ce.oneOf(Fp(PS)),
        icon: ce.oneOfType([ce.node, ce.func]),
        badge: ce.node,
        loading: ce.bool,
        disabled: ce.bool
      }),
      dS),
    VS = c(BS).withConfig({ componentId: 'sc-ldar2z-0' })(['margin:0 0 0 6px;padding:0;']),
    WS = c.div.withConfig({ componentId: 'sc-ldar2z-1' })(['margin-right:6px;svg,span{vertical-align:middle;}']),
    GS = c(uC).withConfig({ componentId: 'sc-ldar2z-2' })(['margin-left:4px;cursor:pointer;']),
    ZS = ['color', 'size'],
    US =
      ((Jy = Kw(function (e, t) {
        var n = void 0 === (n = e.color) ? 'currentColor' : n,
          r = void 0 === (r = e.size) ? 14 : r
        e = Hu(e, ZS)
        return ue.createElement(
          'svg',
          Tg(
            { ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
            e
          ),
          ue.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M0.562515 0.562512H3.68752V2.90626H2.90627V3.68751H0.562515V0.562512ZM0.562515 44.3125V47.4375H3.68752V45.0938H2.90627V44.3125H0.562515ZM44.3125 47.4375H47.4375V44.3125H45.0938V45.0938H44.3125V47.4375ZM47.4375 3.68751V0.562512H44.3125V2.90626H45.0938V3.68751H47.4375ZM7.59376 0.562512V3.68751H12.2813V0.562512H7.59376ZM16.9688 0.562512V3.68751H21.6563V0.562512H16.9688ZM26.3438 0.562512V3.68751H31.0313V0.562512H26.3438ZM35.7188 0.562512V3.68751H40.4063V0.562512H35.7188ZM47.4375 7.59376H44.3125V12.2813H47.4375V7.59376ZM47.4375 16.9688H44.3125V21.6563H47.4375V16.9688ZM47.4375 26.3438H44.3125V31.0313H47.4375V26.3438ZM47.4375 35.7188H44.3125V40.4063H47.4375V35.7188ZM40.4063 47.4375V44.3125H35.7188V47.4375H40.4063ZM31.0313 47.4375V44.3125H26.3438V47.4375H31.0313ZM21.6563 47.4375V44.3125H16.9688V47.4375H21.6563ZM12.2813 47.4375V44.3125H7.59377V47.4375H12.2813ZM0.562515 40.4063H3.68752V35.7188H0.562515V40.4063ZM0.562515 31.0313H3.68752V26.3438H0.562515V31.0313ZM0.562515 21.6563H3.68752V16.9688H0.562515V21.6563ZM0.562515 12.2813H3.68752V7.59376H0.562515V12.2813Z',
            fill: n
          })
        )
      })),
      ['color', 'size']),
    XS = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, US)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M25.2047 46.875C37.2859 46.875 47.0797 37.0812 47.0797 25C47.0797 12.9188 37.2859 3.125 25.2047 3.125C13.1235 3.125 3.32968 12.9188 3.32968 25C3.32968 37.0812 13.1235 46.875 25.2047 46.875ZM25.2047 50C39.0118 50 50.2047 38.8071 50.2047 25C50.2047 11.1929 39.0118 0 25.2047 0C11.3976 0 0.204681 11.1929 0.204681 25C0.204681 38.8071 11.3976 50 25.2047 50Z',
          fill: n
        })
      )
    }),
    YS = ((iC = XS), ['color', 'size']),
    qS =
      ((oC = Kw(function (e, t) {
        var n = void 0 === (n = e.color) ? 'currentColor' : n,
          r = void 0 === (r = e.size) ? 14 : r
        e = Hu(e, YS)
        return ue.createElement(
          'svg',
          Tg(
            { ref: t, width: r, height: r, viewBox: '0 0 51 36', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
            e
          ),
          ue.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M4.11841 3.93805V32.063H47.8684V3.93805H4.11841ZM3.49341 0.813049C2.1127 0.813049 0.993408 1.91235 0.993408 3.26841V32.7327C0.993408 34.0887 2.1127 35.188 3.49341 35.188H48.4934C49.8741 35.188 50.9934 34.0887 50.9934 32.7327V3.26841C50.9934 1.91235 49.8741 0.813049 48.4934 0.813049H3.49341Z',
            fill: n
          })
        )
      })),
      ['color', 'size']),
    $S =
      ((aC = Kw(function (e, t) {
        var n = void 0 === (n = e.color) ? 'currentColor' : n,
          r = void 0 === (r = e.size) ? 14 : r
        e = Hu(e, qS)
        return ue.createElement(
          'svg',
          Tg(
            { ref: t, width: r, height: r, viewBox: '0 0 36 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
            e
          ),
          ue.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M32.0559 46.8755L32.0559 3.12555L3.93091 3.12555L3.93091 46.8755H32.0559ZM35.1809 3.12555C35.1809 1.39966 33.7818 0.000549316 32.0559 0.000549316H3.93091C2.20502 0.000549316 0.805908 1.39966 0.805908 3.12555V46.8755C0.805908 48.6014 2.20502 50.0005 3.93091 50.0005H32.0559C33.7818 50.0005 35.1809 48.6014 35.1809 46.8755L35.1809 3.12555Z',
            fill: n
          })
        )
      })),
      ['color', 'size']),
    KS = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, $S)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M31.3032 17.8662C34.0646 17.8662 36.3032 15.6276 36.3032 12.8662C36.3032 10.1048 34.0646 7.86618 31.3032 7.86618C28.5418 7.86618 26.3032 10.1048 26.3032 12.8662C26.3032 15.6276 28.5418 17.8662 31.3032 17.8662ZM31.3032 15.3662C32.6839 15.3662 33.8032 14.2469 33.8032 12.8662C33.8032 11.4855 32.6839 10.3662 31.3032 10.3662C29.9225 10.3662 28.8032 11.4855 28.8032 12.8662C28.8032 14.2469 29.9225 15.3662 31.3032 15.3662Z',
          fill: n
        }),
        ue.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M15.9372 15.1063C16.3967 15.0794 16.8338 15.3071 17.075 15.6991L25.0831 28.7141L29.8357 24.4289C30.0935 24.1966 30.4362 24.0818 30.7819 24.1121C31.1276 24.1424 31.4452 24.3151 31.6586 24.5887L40.2822 35.6497C40.5759 36.0264 40.6292 36.5376 40.4196 36.9668C40.21 37.396 39.7741 37.6683 39.2964 37.6683H6.70331C6.2766 37.6683 5.87937 37.4506 5.64974 37.091C5.42011 36.7313 5.38981 36.2794 5.56937 35.8923L14.8765 15.8282C15.0702 15.4106 15.4777 15.1333 15.9372 15.1063ZM16.1652 18.991L8.66108 35.1683H36.7368L30.5126 27.1848L25.6422 31.5761C25.3666 31.8246 24.9947 31.9378 24.6274 31.885C24.26 31.8322 23.9351 31.6189 23.7406 31.3027L16.1652 18.991Z',
          fill: n
        }),
        ue.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M0.5 3C0.5 1.61929 1.61929 0.5 3 0.5H43C44.3807 0.5 45.5 1.61929 45.5 3V43C45.5 44.3807 44.3807 45.5 43 45.5H3C1.61929 45.5 0.5 44.3807 0.5 43V3ZM3 3H43V43H3V3Z',
          fill: n
        })
      )
    }),
    QS = [
      { titleKey: 'original', ratio: qy, icon: KS },
      { titleKey: 'custom', ratio: 'custom', icon: Jy },
      { titleKey: 'landscape', descriptionKey: '16:9', ratio: Mx(16 / 9), icon: oC },
      { titleKey: 'portrait', descriptionKey: '9:16', ratio: Mx(9 / 16), icon: aC },
      { titleKey: 'ellipse', ratio: $y, icon: iC }
    ],
    JS = ['color', 'size'],
    eO = xS(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 8 : r
      e = Hu(e, JS)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', { d: 'M37.2754 25L12.2754 -1.03614e-06L12.2754 50L37.2754 25Z', fill: n })
      )
    }),
    tO = { Sm: 'sm', Md: 'md' },
    nO =
      (r((cC = {}), tO.Sm, function (e) {
        return Yf(['padding:4px 8px;min-height:22px;', ''], e.theme.typography.font[fg.LabelSmall])
      }),
      r(cC, tO.Md, function (e) {
        return Yf(['padding:8px 12px;min-height:32px;', ''], e.theme.typography.font[fg.LabelNormal])
      }),
      cC),
    rO =
      ((rC = 'MenuItem'),
      (h = c.div.attrs({ className: Ap(rC, 'Icon') }).withConfig({ componentId: 'sc-rrzye0-0' })(function (e) {
        return Yf(
          ['display:flex;flex-shrink:0;color:', ';&:first-child{margin-right:8px;}&:last-child{margin-left:8px;}'],
          e.theme.palette[dg.IconsPrimary]
        )
      })),
      (l = c(h)
        .attrs({ className: Ap(rC, 'Actions') })
        .withConfig({ componentId: 'sc-rrzye0-1' })(function () {
        return Yf([''])
      })),
      (y = c.div.attrs({ className: Ap(rC, 'Label') }).withConfig({ componentId: 'sc-rrzye0-2' })(['flex-grow:1;'])),
      Hp({
        MenuItemWrapper: c.div.attrs({ className: Ap(rC, 'wrapper') }).withConfig({ componentId: 'sc-rrzye0-3' })(
          function (e) {
            var t = e.divider,
              n = void 0 !== (n = e.noOptionsText) && n,
              r = void 0 !== (r = e.disabled) && r
            e = e.theme
            return Yf(
              ['', ' ', ''],
              void 0 !== t &&
                t &&
                Yf(['width:100%;height:1px;background:', ';box-sizing:border-box;'], e.palette[dg.BordersSecondary]),
              (n || r) && Yf(['color:', ';'], e.palette[dg.ButtonDisabledText])
            )
          }
        ),
        MenuItem: c.div.attrs({ className: Ap(rC, 'root') }).withConfig({ componentId: 'sc-rrzye0-4' })(function (e) {
          var t = e.size,
            n = e.active,
            r = e.theme,
            i = e.disableHover,
            o = e.noOptionsText
          e = e.disabled
          return Yf(
            [
              'display:flex;flex-direction:row;align-items:center;width:100%;background:',
              ';cursor:pointer;box-sizing:border-box;',
              ' &:focus-within,&:focus,&:hover{',
              ';',
              '}'
            ],
            r.palette[n ? dg.BackgroundPrimaryHover : dg.BackgroundSecondary],
            nO[void 0 === t ? tO.Md : t],
            !(void 0 !== i && i) && 'background-color: '.concat(r.palette[dg.BackgroundPrimaryHover]),
            (o || e) && Yf(['cursor:default;background-color:white;'])
          )
        }),
        MenuPrefix: c.div.attrs({ className: Ap(rC, 'prefix') }).withConfig({ componentId: 'sc-rrzye0-5' })(
          function () {
            return Yf(['display:flex;margin-right:8px;'])
          }
        ),
        MenuContent: c.div.attrs({ className: Ap(rC, 'content') }).withConfig({ componentId: 'sc-rrzye0-6' })(
          function () {
            return Yf(['flex-grow:1;line-height:16px;'])
          }
        ),
        MenuSuffix: c.div.attrs({ className: Ap(rC, 'suffix') }).withConfig({ componentId: 'sc-rrzye0-7' })(
          function () {
            return Yf(['display:flex;margin-left:8px;'])
          }
        ),
        Label: y,
        Icon: h,
        Actions: l
      })),
    iO = ['list', 'depth', 'children', 'disableHover', 'noOptionsText', 'disabled', 'enableScrollIntoView']
  function oO(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  var aO = zp(function (e, t) {
      var n = e.list,
        i = void 0 === (i = e.depth) ? 0 : i,
        o = e.children,
        a = e.disableHover,
        l = e.noOptionsText,
        c = e.disabled,
        u = e.enableScrollIntoView,
        d = Hu(e, iO),
        f = s.exports.useRef(null),
        h = (e = Lg(ue.useState(null), 2))[0],
        p = e[1],
        g = (e = Lg(ue.useState([]), 2))[0],
        m = e[1],
        v = function (e) {
          p(e.currentTarget)
        }
      return (
        s.exports.useEffect(
          function () {
            var e
            d.active && u && null != (e = f.current) && e.scrollIntoView({ behavior: 'auto', block: 'nearest' })
          },
          [d.active]
        ),
        n
          ? ue.createElement(
              ue.Fragment,
              null,
              (function (e) {
                var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 0
                return e.map(function (e) {
                  var i,
                    o = e.subList && 0 < e.subList.length
                  return (
                    g[n] === e.key &&
                      o &&
                      ((o = n + 1),
                      (i = ue.createElement(
                        CS,
                        Tg(
                          { key: e.key, position: 'right', open: Boolean(h), anchorEl: h, enableOverlay: !1 },
                          e.subMenuProps
                        ),
                        ue.createElement(aO, Tg({ list: e.subList, depth: o }, d))
                      ))),
                    'divider' === e.content
                      ? ue.createElement(rO.MenuItemWrapper, { divider: !0, key: e.key })
                      : ue.createElement(
                          rO.MenuItemWrapper,
                          { disabled: !1, key: e.key },
                          ue.createElement(
                            rO.MenuItem,
                            Tg({}, d, {
                              className: e.className,
                              ref: t,
                              active: Boolean(e.active),
                              onClick: e.onClick
                                ? function (t) {
                                    return e.onClick(
                                      (function (e) {
                                        for (var t = 1; t < arguments.length; t++) {
                                          var n = null != arguments[t] ? arguments[t] : {}
                                          t % 2
                                            ? oO(Object(n), !0).forEach(function (t) {
                                                r(e, t, n[t])
                                              })
                                            : Object.getOwnPropertyDescriptors
                                            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
                                            : oO(Object(n)).forEach(function (t) {
                                                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
                                              })
                                        }
                                        return e
                                      })({ event: t }, d)
                                    )
                                  }
                                : void 0,
                              onMouseEnter: function (t) {
                                return (r = e.key), (i = n), ((o = g.slice(0))[i] = r), m(o), void v(t)
                                var r, i, o
                              },
                              disableHover: a || e.disableHover
                            }),
                            e.prefix &&
                              ue.createElement(
                                rO.MenuPrefix,
                                null,
                                'function' == typeof e.prefix ? e.prefix(d) : e.prefix
                              ),
                            e.content &&
                              ue.createElement(
                                rO.MenuContent,
                                null,
                                'function' == typeof e.content ? e.content(d) : e.content
                              ),
                            (e.suffix || e.subList) &&
                              ue.createElement(
                                rO.MenuSuffix,
                                null,
                                'function' == typeof e.suffix ? e.suffix(d) : e.suffix,
                                e.subList && ue.createElement(eO, { size: 8, color: '#768184' })
                              )
                          ),
                          i
                        )
                  )
                })
              })(n, i)
            )
          : ue.createElement(
              rO.MenuItemWrapper,
              { noOptionsText: Boolean(l), disabled: Boolean(c) },
              ue.createElement(rO.MenuItem, Tg({}, d, { ref: f, disableHover: a, noOptionsText: l, disabled: c }), o)
            )
      )
    }),
    lO =
      ((ug = ((aO.displayName = 'MenuItem'), { size: tO.Md, active: !1 })),
      (aO.defaultProps = ug),
      (aO.propTypes = {
        size: ce.oneOf(Fp(tO)),
        children: ce.oneOfType([ce.node, ce.func]),
        active: ce.bool,
        value: ce.oneOfType([ce.string, ce.number, ce.oneOf([null])]),
        depth: ce.number,
        disableHover: ce.bool,
        noOptionsText: ce.bool,
        disabled: ce.bool,
        enableScrollIntoView: ce.bool
      }),
      aO),
    sO = ['children', 'size'],
    cO =
      ((Og = zp(function (e, t) {
        var n = e.children,
          r = void 0 === (r = e.size) ? tO.Md : r
        e = Hu(e, sO)
        return ue.createElement(
          rO.Icon,
          Tg({}, e, { ref: t }),
          n && 'function' == typeof n ? n({ size: r !== tO.Md ? 12 : 16 }) : n
        )
      })),
      (Og.defaultProps = { size: tO.Md }),
      (Og.propTypes = { size: ce.oneOf(Fp(tO)), children: ce.oneOfType([ce.node, ce.func]).isRequired }),
      Og),
    uO = ['children'],
    dO =
      ((mg = zp(function (e, t) {
        var n = e.children
        e = Hu(e, uO)
        return ue.createElement(rO.Label, Tg({}, e, { ref: t }), n)
      })),
      (mg.displayName = 'MenuItemLabel'),
      mg),
    fO = ['children'],
    hO =
      ((f = zp(function (e, t) {
        var n = e.children
        e = Hu(e, fO)
        return ue.createElement(
          rO.Actions,
          Tg({}, e, { ref: t }),
          n && 'function' == typeof n ? n({ size: e.size }) : n
        )
      })),
      (f.displayName = 'MenuItemActions'),
      (f.defaultProps = { size: tO.Md }),
      (f.propTypes = { size: ce.oneOf(Fp(tO)), children: ce.oneOfType([ce.node, ce.func]).isRequired }),
      f),
    pO =
      ((p = {
        size: ce.number,
        width: ce.oneOfType([ce.string, ce.number]),
        height: ce.oneOfType([ce.string, ce.number]),
        color: ce.string,
        color2: ce.string,
        stroke: ce.string,
        stroke2: ce.string,
        viewBox: ce.string
      }),
      r((Qy = {}), kS.Right, Yf(['svg{transform:rotate(0);transition:transform 150ms;}'])),
      r(Qy, kS.Left, Yf(['svg{transform:rotate(180deg);transition:transform 150ms;}'])),
      r(Qy, kS.Top, Yf(['svg{transform:rotate(-90deg);transition:transform 150ms;}'])),
      r(Qy, kS.Bottom, Yf(['svg{transform:rotate(90deg);transition:transform 150ms;}'])),
      Qy),
    gO = Hp({
      ArrowTick: c.span.attrs({ className: Ap('ArrowTick', 'root') }).withConfig({ componentId: 'sc-tlypde-0' })(
        function (e) {
          return (e = e.type), Yf(['display:inline-flex;', ''], pO[void 0 === e ? kS.Right : e])
        }
      )
    }),
    mO = ['IconProps'],
    vO =
      ((dS = zp(function (e, t) {
        var n = e.IconProps
        e = Hu(e, mO)
        return ue.createElement(gO.ArrowTick, Tg({}, e, { ref: t }), ue.createElement(eO, n))
      })),
      (dS.defaultProps = { type: kS.Right }),
      (dS.propTypes = { type: ce.oneOf(Fp(kS)), IconProps: ce.exact(p) }),
      dS),
    yO =
      ((Jy = 'AccordionHeader'),
      (oC = c.span.attrs({ className: Ap(Jy, 'Icon') }).withConfig({ componentId: 'sc-1dtjsgt-0' })(function () {
        return Yf(['display:inline-flex;padding-right:8px;'])
      })),
      (aC = c.span.attrs({ className: Ap(Jy, 'Label') }).withConfig({ componentId: 'sc-1dtjsgt-1' })([''])),
      Hp({
        AccordionHeader: c.div.attrs({ className: Ap(Jy, 'root') }).withConfig({ componentId: 'sc-1dtjsgt-2' })(
          function (e) {
            return Yf(
              ['', ' display:flex;align-items:center;cursor:pointer;color:', ';'],
              Yf((e = e.theme).typography.font[fg.ButtonXs]),
              e.palette[dg.LinkPrimary]
            )
          }
        ),
        Icon: oC,
        Label: aC
      })),
    bO = ['expanded', 'label', 'onChange', 'onClick', 'onContextMenu', 'iconProps']
  function wO(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  iC = zp(function (e, t) {
    var n = e.expanded,
      i = e.label,
      o = e.onChange,
      a = e.onClick,
      l = e.onContextMenu,
      s = e.iconProps
    e = Hu(e, bO)
    return ue.createElement(
      yO.AccordionHeader,
      Tg(
        {
          ref: t,
          onClick: function (e) {
            'function' == typeof o && o(!n), 'function' == typeof a && a(e)
          }
        },
        e
      ),
      ue.createElement(
        yO.Icon,
        { onContextMenu: l },
        ue.createElement(vO, {
          type: n ? kS.Bottom : kS.Right,
          IconProps: (function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {}
              t % 2
                ? wO(Object(n), !0).forEach(function (t) {
                    r(e, t, n[t])
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
                : wO(Object(n)).forEach(function (t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
                  })
            }
            return e
          })({ size: 8 }, s)
        })
      ),
      ue.createElement(yO.Label, { onContextMenu: l }, i)
    )
  })
  var CO =
      ((iC.defaultProps = { expanded: !1 }),
      (iC.propTypes = { label: ce.node.isRequired, expanded: ce.bool, onChange: ce.func, iconProps: ce.exact(p) }),
      iC),
    xO = Hp({
      AccordionDetails: c.div
        .attrs({ className: Ap('AccordionDetails', 'root') })
        .withConfig({ componentId: 'sc-1wr6wpr-0' })(['margin:16px 0;'])
    }),
    EO = ['expanded', 'children'],
    SO =
      ((cC = zp(function (e, t) {
        var n = e.expanded,
          r = e.children
        e = Hu(e, EO)
        return ue.createElement(ue.Fragment, null, n && ue.createElement(xO.AccordionDetails, Tg({ ref: t }, e), r))
      })),
      (cC.defaultProps = { expanded: !1 }),
      (cC.propTypes = { expanded: ce.bool }),
      cC),
    OO = Hp({
      Accordion: c.div.attrs({ className: Ap('Accordion', 'root') }).withConfig({ componentId: 'sc-1g4tz7s-0' })([''])
    }),
    kO = [
      'label',
      'expanded',
      'children',
      'detailStyle',
      'headerStyle',
      'iconProps',
      'onClick',
      'onChange',
      'onContextMenu'
    ]
  function PO(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function _O(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {}
      t % 2
        ? PO(Object(n), !0).forEach(function (t) {
            r(e, t, n[t])
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
        : PO(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
          })
    }
    return e
  }
  rC = zp(function (e, t) {
    var n = e.label,
      r = e.expanded,
      i = e.children,
      o = e.detailStyle,
      a = e.headerStyle,
      l = e.iconProps,
      s = e.onClick,
      c = e.onChange,
      u = e.onContextMenu
    e = Hu(e, kO)
    return ue.createElement(
      OO.Accordion,
      Tg({ ref: t }, e),
      ue.createElement(CO, {
        label: n,
        expanded: r,
        style: _O({}, a),
        onClick: function (e) {
          'function' == typeof c && c(!r, e), 'function' == typeof s && s(e)
        },
        onContextMenu: u,
        iconProps: l
      }),
      ue.createElement(SO, { expanded: r, style: _O({}, o) }, i)
    )
  })
  var LO =
      ((rC.defaultProps = { expanded: !1 }),
      (rC.propTypes = {
        label: ce.node.isRequired,
        expanded: ce.bool,
        detailStyle: ce.object,
        headerStyle: ce.object,
        onChange: ce.func,
        onContextMenu: ce.func,
        iconProps: ce.exact(p)
      }),
      rC),
    TO = { height: 16, width: 16 },
    IO = function (e) {
      var t = e.titleKey,
        n = e.description,
        r = e.ratio,
        i = e.onClick,
        o = e.Icon,
        a = e.isActive,
        l = e.width,
        s = e.height,
        c = e.t,
        u = e.disableManualResize
      return ue.createElement(
        lO,
        {
          active: a,
          onClick: function (e) {
            return i(e, r, { ratioTitleKey: t, width: l, height: s, disableManualResize: u })
          },
          size: 'sm'
        },
        o &&
          ue.createElement(
            WS,
            null,
            'string' == typeof o
              ? ue.createElement('span', { dangerouslySetInnerHTML: { __html: o } })
              : ue.createElement(o, TO)
          ),
        c(t),
        n && ue.createElement(GS, null, n)
      )
    }
  function MO(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function jO(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? MO(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : MO(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function RO(e) {
    function t(e, t, r) {
      i(e, t, jO(jO({}, r), {}, { ratioGroupKey: n }))
    }
    var n = e.groupTitleKey,
      r = e.items,
      i = e.onItemSelect,
      o = e.t,
      a = e.isExpanded,
      l = e.setExpandedGroup,
      s = (e = jC().adjustments.crop).ratio,
      c = e.ratioGroupKey,
      u = e.ratioTitleKey
    return ue.createElement(
      LO,
      {
        label: o(n),
        onChange: function () {
          l(a ? null : n)
        },
        expanded: a
      },
      r.map(function (e) {
        var r = e.titleKey,
          i = e.ratio,
          a = e.width,
          l = e.height,
          d = e.descriptionKey,
          f = e.icon
        ;(e = e.disableManualResize), (i = null != i ? i : Mx(a / l))
        return ue.createElement(IO, {
          key: r,
          titleKey: r,
          t: o,
          description: o(d),
          size: 'sm',
          onClick: t,
          width: a,
          height: l,
          ratio: i,
          Icon: f,
          disableManualResize: e,
          isActive: s === i && u === r && c === n
        })
      })
    )
  }
  function DO(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function AO(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? DO(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : DO(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function zO(e) {
    function t(e, t, r) {
      o(e, t, AO(AO({}, r), {}, { ratioFolderKey: n }))
    }
    var n = e.titleKey,
      r = e.Icon,
      i = e.groups,
      o = e.onItemSelect,
      a = e.prefixIconDimensions,
      l = e.t,
      c = (e = jC().adjustments.crop).ratioFolderKey,
      u = e.ratioGroupKey,
      d = (e = Lg(s.exports.useState(''), 2))[0],
      f = e[1]
    return ue.createElement(lO, {
      size: 'sm',
      list: [
        {
          content: l(n),
          key: n,
          active: n === c,
          prefix:
            r &&
            ('string' == typeof r
              ? ue.createElement('span', { dangerouslySetInnerHTML: { __html: r } })
              : ue.createElement(r, a)),
          subList: i.map(function (e) {
            var n = e.titleKey
            e = e.items
            return {
              content: ue.createElement(RO, {
                groupTitleKey: n,
                setExpandedGroup: f,
                isExpanded: '' === d ? u === n : d === n,
                t: l,
                items: e,
                onItemSelect: t
              }),
              key: n,
              disableHover: !0
            }
          })
        }
      ]
    })
  }
  function NO(e) {
    function t(e, t, n) {
      e.stopPropagation(),
        (e = {
          ratio: t,
          ratioTitleKey: n.ratioTitleKey,
          ratioGroupKey: n.ratioGroupKey,
          ratioFolderKey: n.ratioFolderKey
        }),
        i({ type: dI, payload: e }),
        d.autoResize &&
          (i({ type: BI, payload: { width: n.width, height: n.height, manualChangeDisabled: n.disableManualResize } }),
          i({ type: wI, payload: { factor: n.width > u.width || n.height > u.height ? bS(u, n) : 1 } })),
        r()
    }
    var n = e.anchorEl,
      r = e.onClose,
      i = (e = jC()).dispatch,
      o = e.t,
      a = (f = void 0 === (f = (void 0 === (f = e.adjustments) ? {} : f).crop) ? {} : f).ratio,
      l = f.ratioTitleKey,
      c = f.ratioFolderKey,
      u = e.shownImageDimensions,
      d = e.config[Gy.CROP],
      f = s.exports.useMemo(
        function () {
          var e = void 0 === (e = d.presetsItems) ? [] : e,
            t = d.presetsFolders
          return [].concat(Dp(void 0 === t ? [] : t), Dp(QS), Dp(e))
        },
        [d]
      )
    return ue.createElement(
      ue.Fragment,
      null,
      ue.createElement(pC, { className: 'FIE_crop-tool-label FIE_selected-crop-preset-label' }, o(l || 'cropTool')),
      ue.createElement(
        VS,
        { className: 'FIE_crop-presets-opener-button', color: 'link', size: 'lg' },
        n ? ue.createElement(ue.Fragment, null, '▴') : ue.createElement(ue.Fragment, null, '▾')
      ),
      ue.createElement(
        CS,
        { className: 'FIE_crop-presets-menu', anchorEl: n, enableOverlay: !0, onClose: r, open: !!n, position: 'top' },
        f.map(function (e) {
          var n = e.titleKey,
            r = e.descriptionKey,
            i = e.ratio,
            l = e.width,
            s = e.height,
            u = e.groups,
            d = e.icon
          e = e.disableManualResize
          return u
            ? ue.createElement(zO, {
                key: n,
                titleKey: n,
                groups: u,
                Icon: d,
                onItemSelect: t,
                prefixIconDimensions: WO,
                t: o,
                disableManualResize: e
              })
            : ue.createElement(IO, {
                key: i,
                ratio: null != i ? i : Mx(l / s),
                titleKey: n,
                t: o,
                description: o(r),
                Icon: d,
                isActive: a === (null != i ? i : Mx(l / s)) && !c,
                width: l,
                height: s,
                onClick: t,
                disableManualResize: e
              })
        })
      )
    )
  }
  function FO(e) {
    var t = e.selectTool,
      n = ((e = e.isSelected), (r = jC()).config),
      r = r.t,
      i = Lg(s.exports.useState(), 2),
      o = i[0],
      a = i[1]
    return ue.createElement(
      mC,
      {
        className: 'FIE_crop-tool',
        id: Gy.CROP,
        Icon: rE,
        onClick: function (e, n) {
          t(e), a(n.currentTarget)
        },
        isSelected: e
      },
      n[Gy.CROP].noPresets
        ? ue.createElement(pC, { className: 'FIE_crop-tool-label' }, r('cropTool'))
        : ue.createElement(NO, {
            anchorEl: o,
            onClose: function () {
              a(null)
            }
          })
    )
  }
  function HO(e) {
    var t = e.selectTool,
      n = e.isSelected,
      r = e.t,
      i = (e = jC()).dispatch,
      o = e.adjustments.isFlippedX,
      a = (e = s.exports.useMemo(
        function () {
          return {
            reverseLabelOfCurrXFlipDir: r(o ? 'unFlipX' : 'flipX'),
            reverseIconOfCurrXFlipDir: function () {
              return ue.createElement(ZO, { style: o ? UO : void 0 })
            }
          }
        },
        [o]
      )).reverseLabelOfCurrXFlipDir,
      l =
        ((e = e.reverseIconOfCurrXFlipDir),
        s.exports.useCallback(function () {
          i({ type: sI, payload: { direction: 'X' } })
        }, [])),
      c = s.exports.useCallback(function (e) {
        t(e), l()
      }, [])
    return ue.createElement(mC, {
      className: 'FIE_flip-x-tool-button',
      id: Gy.FLIP_X,
      label: a,
      Icon: e,
      onClick: c,
      isSelected: n
    })
  }
  function BO(e) {
    var t = e.selectTool,
      n = e.isSelected,
      r = e.t,
      i = (e = jC()).dispatch,
      o = e.adjustments.isFlippedY,
      a = (e = s.exports.useMemo(
        function () {
          return {
            reverseLabelOfCurrXFlipDir: r(o ? 'unFlipY' : 'flipY'),
            reverseIconOfCurrXFlipDir: function () {
              return ue.createElement(YO, { style: o ? qO : void 0 })
            }
          }
        },
        [o]
      )).reverseLabelOfCurrXFlipDir,
      l =
        ((e = e.reverseIconOfCurrXFlipDir),
        s.exports.useCallback(function () {
          i({ type: sI, payload: { direction: 'Y' } })
        }, [])),
      c = s.exports.useCallback(function (e) {
        t(e), l()
      }, [])
    return ue.createElement(mC, {
      className: 'FIE_flip-y-tool-button',
      id: Gy.FLIP_Y,
      label: a,
      Icon: e,
      onClick: c,
      isSelected: n
    })
  }
  function VO(e) {
    var t = e.selectTool,
      n = e.isSelected
    e = e.t
    return ue.createElement(mC, {
      className: 'FIE_rotate-tool-button',
      id: Gy.ROTATE,
      label: e('rotateTool'),
      Icon: KO,
      onClick: t,
      isSelected: n
    })
  }
  ;(IO.defaultProps = { Icon: void 0, width: void 0, height: void 0, disableManualResize: !1 }),
    (zO.defaultProps = { Icon: void 0 })
  var WO = { height: 16, width: 16 },
    GO = ((FO.defaultProps = { isSelected: !(NO.defaultProps = { anchorEl: null }) }), ['color', 'size']),
    ZO = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, GO)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M24.0625 1.93758C24.0625 1.22909 23.5858 0.609274 22.901 0.427427C22.2163 0.245581 21.4949 0.547225 21.1434 1.16237L1.14337 39.2874C0.867028 39.771 0.869012 40.3651 1.14858 40.8468C1.42814 41.3286 1.94302 41.6251 2.5 41.6251H22.5C23.3629 41.6251 24.0625 40.9255 24.0625 40.0626V1.93758ZM20.9375 38.5001H5.19247L20.9375 7.82128V38.5001Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M28.8566 1.16237C28.5051 0.547225 27.7837 0.245581 27.099 0.427428C26.4142 0.609274 25.9375 1.22909 25.9375 1.93758V4.12508H26.9504L27.3934 4.9003L28.75 4.12508H29.0625V3.94651L30.1066 3.34986L28.8566 1.16237Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M35.1066 12.0999L32.6066 7.72486L29.8934 9.2753L32.3934 13.6503L35.1066 12.0999Z',
          fill: n
        }),
        ue.createElement('path', { d: 'M25.9375 8.50008V12.8751H29.0625V8.50008H25.9375Z', fill: n }),
        ue.createElement('path', {
          d: 'M40.1066 23.9749L37.6066 19.5999L34.8934 21.1503L37.3934 25.5253L40.1066 23.9749Z',
          fill: n
        }),
        ue.createElement('path', { d: 'M25.9375 20.3751V24.7501H29.0625V20.3751H25.9375Z', fill: n }),
        ue.createElement('path', {
          d: 'M45.1066 32.7249L42.6066 28.3499L39.8934 29.9003L42.3934 34.2753L45.1066 32.7249Z',
          fill: n
        }),
        ue.createElement('path', { d: 'M25.9375 29.1251V33.5001H29.0625V29.1251H25.9375Z', fill: n }),
        ue.createElement('path', {
          d: 'M48.8566 39.2874L47.6066 37.0999L45.1562 38.5001H45V38.5894L44.8934 38.6503L45 38.8369V41.6251H47.5C48.057 41.6251 48.5719 41.3286 48.8514 40.8468C49.131 40.3651 49.133 39.771 48.8566 39.2874Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M25.9375 37.8751V40.0626C25.9375 40.9255 26.6371 41.6251 27.5 41.6251H30V38.5001H29.0625V37.8751H25.9375Z',
          fill: n
        }),
        ue.createElement('path', { d: 'M35 41.6251H40V38.5001H35V41.6251Z', fill: n })
      )
    }),
    UO = { transform: 'scaleX(-1)' },
    XO = ((HO.defaultProps = { isSelected: !1 }), ['color', 'size']),
    YO = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, XO)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M37.5001 24.0625C38.2086 24.0625 38.8284 23.5858 39.0102 22.901C39.1921 22.2162 38.8904 21.4948 38.2753 21.1433L3.27531 1.14333C2.79171 0.866989 2.19757 0.868973 1.71583 1.14854C1.23409 1.4281 0.937592 1.94298 0.937592 2.49996V22.5C0.937592 23.3629 1.63715 24.0625 2.50009 24.0625L37.5001 24.0625ZM4.06259 20.9375L4.06259 5.19243L31.6164 20.9375L4.06259 20.9375Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M38.2753 28.8566C38.8904 28.5051 39.1921 27.7837 39.0102 27.0989C38.8284 26.4142 38.2086 25.9375 37.5001 25.9375H35.3126V26.9504L34.5374 27.3933L35.3126 28.75V29.0625H35.4912L36.0878 30.1066L38.2753 28.8566Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M27.3378 35.1066L31.7128 32.6066L30.1624 29.8933L25.7874 32.3933L27.3378 35.1066Z',
          fill: n
        }),
        ue.createElement('path', { d: 'M30.9376 25.9375H26.5626L26.5626 29.0625H30.9376L30.9376 25.9375Z', fill: n }),
        ue.createElement('path', {
          d: 'M18.5878 40.1066L22.9628 37.6066L21.4124 34.8933L17.0374 37.3933L18.5878 40.1066Z',
          fill: n
        }),
        ue.createElement('path', { d: 'M22.1876 25.9375H17.8126V29.0625H22.1876V25.9375Z', fill: n }),
        ue.createElement('path', {
          d: 'M9.83781 45.1066L14.2128 42.6066L12.6624 39.8933L8.28738 42.3933L9.83781 45.1066Z',
          fill: n
        }),
        ue.createElement('path', { d: 'M13.4376 25.9375H9.0626V29.0625H13.4376V25.9375Z', fill: n }),
        ue.createElement('path', {
          d: 'M3.27531 48.8566L5.46281 47.6066L4.06259 45.1562V45H3.97331L3.91238 44.8933L3.72578 45H0.937592V47.5C0.937592 48.0569 1.23409 48.5718 1.71583 48.8514C2.19758 49.1309 2.79171 49.1329 3.27531 48.8566Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M4.6876 25.9375L2.50009 25.9375C1.63715 25.9375 0.937592 26.637 0.937592 27.5V30H4.06259V29.0625H4.6876V25.9375Z',
          fill: n
        }),
        ue.createElement('path', { d: 'M0.937592 35V40L4.06259 40V35H0.937592Z', fill: n })
      )
    }),
    qO = { transform: 'scaleY(-1)' },
    $O = ((BO.defaultProps = { isSelected: !1 }), ['color', 'size']),
    KO = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, $O)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M2.66029 14.6992L3.59754 14.4432L3.09234 3.93169C3.05919 3.24213 2.47333 2.71 1.78377 2.74314C1.09421 2.77628 0.562076 3.36215 0.595218 4.05171L1.16043 15.8118C1.19357 16.5014 1.77943 17.0335 2.46899 17.0004L14.2291 16.4351C14.9186 16.402 15.4508 15.8161 15.4176 15.1266C15.3845 14.437 14.7986 13.9049 14.1091 13.938L5.48449 14.3525C8.23226 7.41028 15.0052 2.5 22.925 2.5C33.2802 2.5 41.6748 10.8946 41.6748 21.2498C41.6748 22.403 41.5707 23.5319 41.3713 24.6276L43.7968 25.2605C44.0449 23.9617 44.1748 22.6209 44.1748 21.2498C44.1748 9.51386 34.6609 0 22.925 0C15.0467 0 8.16976 4.2873 4.50003 10.6561L2.66029 14.6992Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M9.88493 34.7076L8.27775 36.6304C8.82615 37.1534 9.40249 37.6474 10.0043 38.1098L11.5276 36.1275C10.9528 35.6859 10.4044 35.2116 9.88493 34.7076Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M12.3142 39.6562C13.9038 40.5759 15.6235 41.2956 17.439 41.7809L18.0846 39.3657C16.4846 38.938 14.9685 38.3036 13.5663 37.4923L12.3142 39.6562Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M20.1654 42.3204C21.0738 42.4389 22.0002 42.5001 22.9408 42.5001C23.8815 42.5001 24.8079 42.4389 25.7163 42.3204L25.3929 39.8414C24.5915 39.946 23.7731 40.0001 22.9408 40.0001C22.1086 40.0001 21.2902 39.946 20.4888 39.8414L20.1654 42.3204Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M28.4427 41.7809C30.2582 41.2956 31.9779 40.5759 33.5674 39.6562L32.3154 37.4923C30.9132 38.3036 29.3971 38.938 27.7971 39.3657L28.4427 41.7809Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M35.8774 38.1098C37.3495 36.9786 38.6692 35.6589 39.8004 34.1868L37.8181 32.6635C36.8193 33.9633 35.6539 35.1287 34.3541 36.1275L35.8774 38.1098Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M41.3468 31.8769C42.2665 30.2873 42.9862 28.5676 43.4715 26.7521L41.0563 26.1065C40.6286 27.7065 39.9942 29.2226 39.1829 30.6248L41.3468 31.8769Z',
          fill: n
        })
      )
    }),
    QO =
      ((y = ((VO.defaultProps = { isSelected: !1 }), 'RotationSlider')),
      Hp({
        RotationSliderList: c.ul.attrs({ className: Ap(y, 'list') }).withConfig({ componentId: 'sc-1xuruq0-0' })([
          'display:flex;align-items:center;position:relative;padding:0;width:100%;list-style:none;'
        ]),
        RotationSliderBigDot: c.li.attrs({ className: Ap(y, 'big-dot') }).withConfig({ componentId: 'sc-1xuruq0-1' })(
          function (e) {
            return Yf(
              ['width:8px;height:8px;border-radius:50%;background-color:', ';cursor:pointer;'],
              e.theme.palette[dg.LinkPrimary]
            )
          }
        ),
        RotationSliderSmallDotWrapper: c.div
          .attrs({ className: Ap(y, 'small-dot-wrapper') })
          .withConfig({ componentId: 'sc-1xuruq0-2' })(['padding:2px;']),
        RotationSliderSmallDot: c.li
          .attrs({ className: Ap(y, 'small-dot') })
          .withConfig({ componentId: 'sc-1xuruq0-3' })(function (e) {
          return Yf(
            ['width:2px;height:2px;border-radius:50%;background-color:', ';cursor:pointer;'],
            e.theme.palette[dg.LinkPrimary]
          )
        }),
        RotationSliderControl: c.span
          .attrs({ className: Ap(y, 'control') })
          .withConfig({ componentId: 'sc-1xuruq0-4' })(function (e) {
          return Yf(
            [
              'display:flex;justify-content:center;align-items:center;position:absolute;height:18px;width:2px;transform:translate(-50%,-50%);top:50%;background-color:',
              ";& > input{border:0px;clip:rect(0px,0px,0px,0px);height:100%;margin:-1px;overflow:hidden;padding:0px;position:absolute;white-space:nowrap;width:100%;direction:ltr;}&::before{position:absolute;content:'';border-radius:inherit;width:100%;height:100%;box-shadow:0px 3px 1px -2px rgb(0 0 0 / 20%),0px 2px 2px 0px rgb(0 0 0 / 14%),0px 1px 5px 0px rgb(0 0 0 / 12%);}&::after{position:absolute;content:'';border-radius:50%;width:42px;height:42px;top:50%;left:50%;transform:translate(-50%,-50%);}"
            ],
            e.theme.palette[dg.LinkActive]
          )
        }),
        RotationSliderMark: c.div.attrs({ className: Ap(y, 'mark') }).withConfig({ componentId: 'sc-1xuruq0-5' })([
          'padding:4px;'
        ]),
        RotationSliderMarkText: c.span
          .attrs({ className: Ap(y, 'mark-text') })
          .withConfig({ componentId: 'sc-1xuruq0-6' })(function (e) {
          return Yf(
            ['position:absolute;top:20px;font-size:14px;transform:translateX(-10%);color:', ';'],
            e.theme.palette[dg.TextPrimary]
          )
        })
      })),
    JO = [
      'min',
      'max',
      'angle',
      'onChange',
      'onMouseDown',
      'onMouseUp',
      'step',
      'labelTooltipOptions',
      'annotation',
      'hideMarkText',
      'value',
      'railProps',
      'trackProps',
      'thumbProps',
      'labelTooltipProps',
      'markStyles',
      'markTextStyles'
    ]
  function ek(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function tk(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {}
      t % 2
        ? ek(Object(n), !0).forEach(function (t) {
            r(e, t, n[t])
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
        : ek(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
          })
    }
    return e
  }
  function nk(e) {
    var t = e.selectTool,
      n = e.isSelected
    e = e.t
    return ue.createElement(mC, {
      className: 'FIE_contrast-tool-button',
      id: Gy.CONTRAST,
      label: e('contrastTool'),
      Icon: vk,
      onClick: t,
      isSelected: n
    })
  }
  function rk(e) {
    var t = e.selectTool,
      n = e.isSelected
    e = e.t
    return ue.createElement(mC, {
      className: 'FIE_hsv-tool-button',
      id: Gy.HSV,
      label: e('hsvTool'),
      Icon: Ck,
      onClick: t,
      isSelected: n
    })
  }
  function ik(e) {
    var t = e.selectTool,
      n = e.isSelected
    e = e.t
    return ue.createElement(mC, {
      className: 'FIE_blur-tool-button',
      id: Gy.BLUR,
      label: e('blurTool'),
      Icon: kk,
      onClick: t,
      isSelected: n
    })
  }
  function ok(e) {
    var t = e.selectTool,
      n = e.isSelected
    e = e.t
    return ue.createElement(mC, {
      className: 'FIE_warmth-tool-button',
      id: Gy.WARMTH,
      label: e('warmthTool'),
      Icon: Tk,
      onClick: t,
      isSelected: n
    })
  }
  function ak(e) {
    function t(e, t) {
      var n = e.findIndex(function (e) {
        return e.classList.contains('FIE_carousel-item')
      })
      ;-1 !== n &&
        (e[n].scrollIntoView({ inline: t, behavior: 'smooth', block: 'nearest' }),
        setTimeout(function () {
          p()
        }, 500))
    }
    function n(e) {
      var t
      ;(a.current = ((null == (t = e.touches) ? void 0 : t[0]) || e).pageX),
        document.addEventListener('mousemove', g),
        document.addEventListener('mouseup', m),
        document.addEventListener('touchmove', g),
        document.addEventListener('touchcancel', m),
        document.addEventListener('touchend', m)
    }
    var r = e.children,
      i = e.style,
      o = e.className,
      a = s.exports.useRef(!1),
      l = s.exports.useRef(),
      c = Lg(Cx(), 1)[0],
      u = (e = Lg(s.exports.useState(!1), 2))[0],
      d = e[1],
      f = (e = Lg(s.exports.useState(!1), 2))[0],
      h = e[1],
      p =
        ((e = s.exports.Children.toArray(r)),
        function () {
          var e, t, n
          l.current &&
            ((t = (e = l.current).scrollWidth),
            (n = e.offsetWidth),
            (e = e.scrollLeft),
            (t = Math.round(t - n)),
            (n = Math.round(t - e)),
            d(0 < e),
            h(0 < n))
        }),
      g = function (e) {
        var t
        a.current &&
          ((t = ((null == (t = e.touches) ? void 0 : t[0]) || e).pageX),
          l.current.scrollBy(a.current - t, 0),
          (a.current = t),
          BC(p, 30)())
      },
      m = function () {
        ;(a.current = null),
          document.removeEventListener('mousemove', g),
          document.removeEventListener('mouseup', m),
          document.removeEventListener('touchmove', g),
          document.removeEventListener('touchcancel', m),
          document.removeEventListener('touchend', m)
      }
    return (
      s.exports.useEffect(function () {
        l.current && c(l.current, p)
      }, []),
      ue.createElement(
        Dk,
        { className: ''.concat(o, '-wrapper'), style: i, onMouseDown: n, onTouchStart: n },
        u &&
          ue.createElement(
            Nk,
            {
              className: 'FIE_carousel-prev-button',
              onClick: function (e) {
                var n = (r = VC()).topOffset,
                  r = r.leftOffset
                t((r = document.elementsFromPoint(e.pageX + e.currentTarget.offsetWidth - r, e.pageY - n)), 'end')
              }
            },
            ue.createElement(Rk, null)
          ),
        ue.createElement(
          Ak,
          { className: ''.concat(o, '-items'), ref: l },
          e.map(function (e) {
            return ue.createElement(zk, { className: ''.concat(o, '-item-wrapper FIE_carousel-item'), key: e.key }, e)
          })
        ),
        f &&
          ue.createElement(
            Fk,
            {
              className: 'FIE_carousel-next-button',
              onClick: function (e) {
                var n = (r = VC()).topOffset,
                  r = r.leftOffset
                t((r = document.elementsFromPoint(e.pageX - e.currentTarget.offsetWidth - r, e.pageY - n)), 'start')
              }
            },
            ue.createElement(Rk, null)
          )
      )
    )
  }
  function lk(e) {
    var t = e.filterLabel,
      n = e.filterFn,
      r = e.applyFilter,
      i = e.isActive,
      o = e.image,
      a = s.exports.useRef(),
      l =
        ((e = s.exports.useCallback(
          function () {
            r(n)
          },
          [n]
        )),
        s.exports.useCallback(function () {
          a.current ? a.current.cache() : setTimeout(l, 0)
        }, [])),
      c =
        (s.exports.useEffect(
          function () {
            return (
              o && l(),
              function () {
                var e
                null != (e = a.current) && e.clearCache()
              }
            )
          },
          [o]
        ),
        o.width / o.height),
      u = (d = c < 1) ? 60 : 45 * c,
      d = d ? 60 / c : 45
    return ue.createElement(
      Hk,
      { className: 'FIE_filters-item', onClick: e, 'aria-selected': i },
      ue.createElement(
        Bk,
        { className: 'FIE_filters-item-preview', width: 60, height: 45 },
        ue.createElement(
          Iy,
          { onTap: e },
          ue.createElement(jy, {
            image: o,
            filters: n ? [n] : [],
            width: u,
            height: d,
            x: -(u - 60) / 2,
            y: -(d - 45) / 2,
            ref: a
          })
        )
      ),
      ue.createElement(Vk, { className: 'FIE_filters-item-label' }, t)
    )
  }
  function sk(e) {
    var t = e.selectTool,
      n = e.isSelected
    e = e.t
    return ue.createElement(mC, {
      className: 'FIE_text-tool-button',
      id: Gy.TEXT,
      label: e('textTool'),
      Icon: Xk,
      onClick: t,
      isSelected: n
    })
  }
  function ck(e) {
    var t = e.annotation,
      n = e.updateAnnotation
    ;(e = e.t), (t = t.opacity)
    return ue.createElement(
      cP,
      null,
      ue.createElement(uC, null, e('opacity')),
      ue.createElement(Jx, {
        annotation: '%',
        onChange: function (e) {
          n({ opacity: WC(e / 100, pP, gP) })
        },
        value: Math.round(100 * t)
      })
    )
  }
  function uk(e) {
    return Yf(
      ['background:', ' !important;border:1px solid ', ' !important;'],
      (e = e.theme.palette)[dg.BackgroundSecondary],
      e[dg.Error]
    )
  }
  h = zp(function (e, t) {
    var n = void 0 === (l = e.min) ? 0 : l,
      r = void 0 === (l = e.max) ? 100 : l,
      i = void 0 === (l = e.angle) ? 10 : l,
      o = e.onChange,
      a = void 0 === (l = (e.onMouseDown, e.onMouseUp, e.step)) ? 1 : l,
      l = void 0 === (l = e.labelTooltipOptions) ? Gx.Off : l,
      s = void 0 === (u = e.annotation) ? '°' : u,
      c = void 0 !== (u = e.hideMarkText) && u,
      u = e.value,
      d = void 0 === (d = e.railProps) ? {} : d,
      f = void 0 === (f = e.trackProps) ? {} : f,
      h = void 0 === (h = e.thumbProps) ? {} : h,
      p = void 0 === (p = e.labelTooltipProps) ? {} : p,
      g = void 0 === (v = e.markStyles) ? {} : v,
      m = void 0 === (v = e.markTextStyles) ? {} : v,
      v = Hu(e, JO)
    return ue.createElement(
      $x,
      Tg(
        {
          min: n,
          max: r,
          step: a,
          value: u || 0 === u ? (r < u ? r : u < n ? n : u) : n,
          hideTrack: !0,
          hideAnnotation: !0,
          annotation: s,
          onChange: function (e, t) {
            o && o(e, t)
          },
          labelTooltip: l,
          ref: t,
          components: {
            Rail: function (e, t) {
              return ue.createElement(
                QO.RotationSliderList,
                Tg({}, e, { styles: tk({}, t) }),
                (function () {
                  for (var e, t = [], o = n; o <= r; o += a)
                    (e = []),
                      o % i == 0 || o === r
                        ? (e = ue.createElement(
                            QO.RotationSliderMark,
                            { key: o, style: tk({}, g) },
                            !c &&
                              ue.createElement(
                                QO.RotationSliderMarkText,
                                { style: tk({}, m) },
                                o === n + 1 ? r : o,
                                ue.createElement('sup', null, s)
                              ),
                            ue.createElement(QO.RotationSliderBigDot, null)
                          ))
                        : o % 10 == 0 &&
                          (e = ue.createElement(
                            QO.RotationSliderSmallDotWrapper,
                            { key: o },
                            ue.createElement(QO.RotationSliderSmallDot, null)
                          )),
                      Array.isArray(e) || t.push(e)
                  return t
                })()
              )
            },
            Thumb: QO.RotationSliderControl
          },
          componentsProps: {
            rail: tk(tk({}, d), {}, { style: tk({}, d.style) }),
            track: tk(tk({}, f), {}, { style: tk({}, f.style) }),
            thumb: tk(tk({}, h), {}, { style: tk({ top: '15%' }, h.style) }),
            labelTooltip: tk(tk({}, p), {}, { style: tk({}, p.style) })
          }
        },
        v,
        { defaultValue: Number(v.defaultValue), style: tk({ width: 'auto', height: 'auto' }, v.style) }
      )
    )
  })
  var dk =
      ((h.defaultProps = { annotation: '°', min: 0, max: 100, step: 1, labelTooltipOptions: Gx.Off }),
      (h.propTypes = {
        value: ce.oneOfType([ce.array, ce.number]),
        min: ce.number,
        max: ce.number,
        angle: ce.number,
        onChange: ce.func,
        onMouseDown: ce.func,
        onMouseUp: ce.func,
        step: ce.number,
        annotation: ce.string,
        hideMarkText: ce.bool,
        railProps: ce.object,
        trackProps: ce.object,
        thumbProps: ce.object,
        labelTooltipProps: ce.object,
        markStyles: ce.object,
        markTextStyles: ce.object,
        labelTooltipOptions: ce.oneOf(Fp(Gx))
      }),
      h),
    fk = ['color', 'size'],
    hk = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, fk)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement(
          'g',
          { clipPath: 'url(#clip0)' },
          ue.createElement('path', {
            d: 'M24.5667 25.0889H0.275391V1L11.2065 11.9311C15.6599 7.68012 20.5182 5.85827 26.591 5.85827C38.1294 5.85827 46.4289 12.336 49.6677 23.8744L47.441 24.4816C44.607 13.9554 37.3196 8.2874 26.7934 8.2874C21.3278 8.2874 17.2793 9.90684 13.0283 13.753L24.5667 25.0889Z',
            fill: n
          }),
          ue.createElement('path', {
            d: 'M15.6602 45.3317L17.0772 43.3075C16.4699 42.9026 15.8626 42.2953 15.2553 41.8905L13.6359 43.5099C14.2432 44.1172 15.0529 44.7244 15.6602 45.3317Z',
            fill: n
          }),
          ue.createElement('path', {
            d: 'M20.1135 47.5585L20.9232 45.3318C22.3402 45.9391 23.7572 46.1415 25.1742 46.3439L24.9718 48.7731C24.3645 48.7731 23.7572 48.5707 23.1499 48.3682C21.9354 48.1658 21.1257 47.9633 20.1135 47.5585ZM29.6276 46.5463C31.0446 46.3439 32.4616 46.1415 33.8786 45.7367L34.6883 47.9634C33.0689 48.5707 31.4495 48.7731 29.83 48.9755L29.6276 46.5463ZM38.1296 43.9148C39.3441 43.1051 40.5587 42.2954 41.7733 41.2833L43.3927 43.1051C42.1782 44.3197 40.7612 45.1294 39.3441 46.1415L38.1296 43.9148ZM44.4048 37.842C45.2145 36.6274 46.0243 35.2104 46.4291 33.9959L48.6558 34.8056C48.0485 36.425 47.2388 37.842 46.4291 39.2589L44.4048 37.842Z',
            fill: n
          }),
          ue.createElement('path', {
            d: 'M47.6438 29.5423L50.073 29.7448C50.2754 28.7326 50.2754 27.9229 50.2754 26.9107H47.8462C47.8462 27.9229 47.8463 28.7327 47.6438 29.5423Z',
            fill: n
          })
        ),
        ue.createElement(
          'defs',
          null,
          ue.createElement(
            'clipPath',
            { id: 'clip0' },
            ue.createElement('rect', { width: '50', height: '50', fill: 'white', transform: 'translate(0.275391)' })
          )
        )
      )
    }),
    pk = ['color', 'size'],
    gk = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, pk)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement(
          'g',
          { clipPath: 'url(#clip0)' },
          ue.createElement('path', {
            d: 'M50.2753 26.8064H24.4689L36.5656 14.7096C32.735 11.0806 28.7027 9.66933 23.6624 9.66933C13.3802 9.66933 6.32372 15.3145 3.50118 25.5967L0.275391 24.7903C3.50118 13.0968 11.9689 6.44355 23.6625 6.44355C29.7109 6.44355 34.348 8.25806 38.9851 12.2903L50.2754 1L50.2753 26.8064Z',
            fill: n
          }),
          ue.createElement('path', {
            d: 'M34.5495 46.3628L33.1382 44.3467C33.743 43.9435 34.3479 43.3386 34.9527 42.9355L36.5656 44.75C35.9608 45.1532 35.3559 45.758 34.5495 46.3628Z',
            fill: n
          }),
          ue.createElement('path', {
            d: 'M27.2913 49.387C26.6865 49.5886 26.0817 49.5886 25.4768 49.7903L25.0736 47.3709C26.4848 47.1693 27.8962 46.7661 29.3074 46.3628L30.1139 48.5806C29.1058 48.9838 28.2994 49.1854 27.2913 49.387ZM20.4365 49.9919C18.8235 49.7903 17.2107 49.5886 15.5978 48.9838L16.4042 46.766C17.8155 47.1693 19.2268 47.5724 20.6381 47.5724L20.4365 49.9919ZM11.1623 46.9677C9.75104 46.1612 8.33971 45.1532 7.13003 43.9435L8.74296 42.129C9.75104 43.137 10.9607 43.9435 12.372 44.7499L11.1623 46.9677ZM3.90425 40.3144C2.89617 38.9032 2.08974 37.2903 1.6865 35.879L3.90425 35.0726C4.50909 36.4838 5.11393 37.6935 5.92036 38.9032L3.90425 40.3144Z',
            fill: n
          }),
          ue.createElement('path', {
            d: 'M3.2996 30.0322L0.880241 30.2338C0.678647 29.2257 0.678647 28.4193 0.678647 27.4112H3.09801C3.09801 28.4193 3.2996 29.2258 3.2996 30.0322Z',
            fill: n
          })
        ),
        ue.createElement(
          'defs',
          null,
          ue.createElement(
            'clipPath',
            { id: 'clip0' },
            ue.createElement('rect', { width: '50', height: '50', fill: 'white', transform: 'translate(0.275391)' })
          )
        )
      )
    }),
    mk = ['color', 'size'],
    vk = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, mk)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M20.4376 40.6858V38.5625V4.18746V3.31418C10.8133 4.10816 3.25006 12.1708 3.25006 22C3.25006 31.8292 10.8133 39.8918 20.4376 40.6858ZM40.7501 22C40.7501 31.8292 33.1868 39.8918 23.5626 40.6858V38.5625V4.18746V3.31418C33.1868 4.10816 40.7501 12.1708 40.7501 22ZM43.8751 22C43.8751 34.0812 34.0813 43.875 22.0001 43.875C9.91883 43.875 0.125061 34.0812 0.125061 22C0.125061 9.91877 9.91883 0.125 22.0001 0.125C34.0813 0.125 43.8751 9.91877 43.8751 22Z',
          fill: n
        })
      )
    }),
    yk = ((nk.defaultProps = { isSelected: !1 }), { contrast: 0 }),
    bk = { width: 150, padding: 0 },
    wk = ['color', 'size'],
    Ck = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, wk)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M37.2341 37.6984H37.5121V37.4237C41.4447 33.4687 43.875 28.0182 43.875 22C43.875 15.9819 41.4447 10.5314 37.5121 6.57632V6.30045H37.2328C33.2942 2.47819 27.9219 0.125031 22 0.125031C9.91877 0.125031 0.125 9.9188 0.125 22C0.125 34.0813 9.91877 43.875 22 43.875C24.718 43.875 27.3203 43.3793 29.7213 42.4733H30.5303V42.1494C33.0389 41.0861 35.308 39.5679 37.2341 37.6984ZM20.4257 3.31519C10.807 4.1148 3.25 12.1749 3.25 22C3.25 31.8252 10.807 39.8853 20.4257 40.6849V3.31519ZM34.3871 36.0759C33.221 37.1029 31.9263 37.9873 30.5303 38.7017V5.29836C31.9263 6.01281 33.221 6.89715 34.3871 7.92411V36.0759ZM37.5121 11.4641C39.5556 14.4669 40.75 18.094 40.75 22C40.75 25.9061 39.5556 29.5332 37.5121 32.536V11.4641ZM23.5507 40.6868C24.8796 40.578 26.1693 40.3307 27.4053 39.9592V4.04089C26.1693 3.66941 24.8796 3.42203 23.5507 3.31324V40.6868Z',
          fill: n
        })
      )
    }),
    xk = ((rk.defaultProps = { isSelected: !1 }), c.div.withConfig({ componentId: 'sc-tm5uj2-0' })(['margin:6px;'])),
    Ek = { hue: 0, saturation: 0, value: 0 },
    Sk = { padding: 0 },
    Ok = ['color', 'size'],
    kk = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, Ok)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M18.3626 41.293C17.5103 41.4285 16.7096 40.8474 16.5742 39.9952C16.4387 39.143 17.0198 38.3423 17.872 38.2068C18.2902 38.1403 18.6988 38.0456 19.0958 37.9246C21.9368 37.059 24.1957 34.8468 25.1254 32.0335C25.2671 31.6049 25.378 31.1621 25.4555 30.7076C25.6005 29.857 26.4076 29.2849 27.2583 29.4299C28.109 29.5749 28.681 30.3821 28.536 31.2327C28.432 31.8429 28.283 32.4379 28.0926 33.0142C26.8449 36.7893 23.8206 39.7519 20.0065 40.914C19.4728 41.0766 18.9239 41.2038 18.3626 41.293Z',
          fill: n
        }),
        ue.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M33.9356 31.0645C33.9356 23.9644 24.1764 8.59028 19.4747 1.59549C18.2785 -0.184172 15.7216 -0.184172 14.5254 1.59548C9.82374 8.59028 0.0645752 23.9644 0.0645752 31.0645C0.0645752 40.4177 7.64685 48 17.0001 48C26.3533 48 33.9356 40.4177 33.9356 31.0645ZM30.8106 31.0645C30.8106 29.8836 30.375 28.0316 29.4236 25.578C28.5 23.1959 27.1988 20.5159 25.7187 17.7756C22.8106 12.3913 19.3287 6.98743 17.0001 3.51586C14.6715 6.98743 11.1895 12.3913 8.28145 17.7756C6.80135 20.5159 5.50017 23.1959 4.57655 25.578C3.62517 28.0316 3.18958 29.8836 3.18958 31.0645C3.18958 38.6918 9.37274 44.875 17.0001 44.875C24.6274 44.875 30.8106 38.6918 30.8106 31.0645Z',
          fill: n
        })
      )
    }),
    Pk = ((ik.defaultProps = { isSelected: !1 }), { blurRadius: 0 }),
    _k = { width: 150, padding: 0 },
    Lk = ['color', 'size'],
    Tk = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, Lk)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M9.48799 3.125H17.0311L17.0311 24.4063C17.0311 26.6148 18.1889 28.4084 19.5429 29.5401C21.7011 31.3438 23.0656 34.0456 23.0656 37.069C23.0656 42.4847 18.6753 46.875 13.2595 46.875C7.84382 46.875 3.45351 42.4847 3.45351 37.069C3.45351 34.0456 4.81799 31.3438 6.97617 29.5401C8.33021 28.4084 9.48799 26.6148 9.48799 24.4063V3.125ZM20.1561 3.125C20.1561 1.39911 18.757 0 17.0311 0H9.48799C7.7621 0 6.36299 1.39911 6.36299 3.125V24.4063C6.36299 25.4785 5.79482 26.4547 4.97216 27.1423C2.13398 29.5143 0.328506 33.0808 0.328506 37.069C0.328506 44.2106 6.11793 50 13.2595 50C20.4012 50 26.1906 44.2106 26.1906 37.069C26.1906 33.0808 24.3851 29.5143 21.5469 27.1423C20.7243 26.4547 20.1561 25.4785 20.1561 24.4063V3.125ZM35.6715 1.25C35.6715 0.559645 35.1119 0 34.4215 0H28.1715C27.4812 0 26.9215 0.559644 26.9215 1.25C26.9215 1.94036 27.4812 2.5 28.1715 2.5L34.4215 2.5C35.1119 2.5 35.6715 1.94036 35.6715 1.25ZM35.6715 8.24951C35.6715 7.55916 35.1119 6.99951 34.4215 6.99951H28.1715C27.4812 6.99951 26.9215 7.55916 26.9215 8.24951C26.9215 8.93987 27.4812 9.49951 28.1715 9.49951H34.4215C35.1119 9.49951 35.6715 8.93987 35.6715 8.24951ZM34.4215 13.999C35.1119 13.999 35.6715 14.5587 35.6715 15.249C35.6715 15.9394 35.1119 16.499 34.4215 16.499H28.1715C27.4812 16.499 26.9215 15.9394 26.9215 15.249C26.9215 14.5587 27.4812 13.999 28.1715 13.999H34.4215ZM13.2594 43.7501C16.366 43.7501 18.8844 41.2317 18.8844 38.1251C18.8844 35.4037 16.9519 33.1337 14.3844 32.6126V10.3662C14.3844 9.67582 13.8247 9.11617 13.1344 9.11617C12.444 9.11617 11.8844 9.67582 11.8844 10.3662V32.6694C9.44245 33.2829 7.63441 35.4928 7.63441 38.1251C7.63441 41.2317 10.1528 43.7501 13.2594 43.7501Z',
          fill: n
        })
      )
    }),
    Ik = ((ok.defaultProps = { isSelected: !1 }), { warmth: 0 }),
    Mk = { width: 150, padding: 0 },
    jk = ['stroke', 'size'],
    Rk = Kw(function (e, t) {
      var n = void 0 === (n = e.stroke) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 10 : r
      e = Hu(e, jk)
      return ue.createElement(
        'svg',
        Tg(
          {
            ref: t,
            width: r * (51 / 56),
            height: r,
            viewBox: '0 0 51 56',
            fill: 'none',
            xmlns: 'http://www.w3.org/2000/svg'
          },
          e
        ),
        ue.createElement('path', {
          d: 'M12.2754 3L37.2754 27.0741L12.2754 53',
          stroke: n,
          strokeWidth: '5',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        })
      )
    }),
    Dk = c.div.withConfig({ componentId: 'sc-1nr0bka-0' })([
      'max-width:680px;min-width:150px;position:relative;overflow:hidden;touch-action:pan-y pinch-zoom;'
    ]),
    Ak = c.ul.withConfig({ componentId: 'sc-1nr0bka-1' })(['padding:0;margin:0;white-space:nowrap;overflow:hidden;']),
    zk = c.li.withConfig({ componentId: 'sc-1nr0bka-2' })([
      'padding:4px;display:inline-block;list-style-type:none;user-select:none;'
    ]),
    Nk = c.div.withConfig({ componentId: 'sc-1nr0bka-3' })(
      [
        '',
        ' left:0;background:linear-gradient( 90deg,#ffffff 1.56%,rgba(255,255,255,0.93) 70%,rgba(255,255,255,0) 100% );svg{transform:scaleX(-1);}'
      ],
      '\n  position: absolute;\n  top: 0;\n  height: 100%;\n  width: 30px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n'
    ),
    Fk = c.div.withConfig({ componentId: 'sc-1nr0bka-4' })(
      [
        '',
        ' background:linear-gradient( 270deg,#ffffff 1.56%,rgba(255,255,255,0.93) 70%,rgba(255,255,255,0) 100% );right:0;'
      ],
      '\n  position: absolute;\n  top: 0;\n  height: 100%;\n  width: 30px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n'
    ),
    Hk =
      ((ak.defaultProps = { style: null }),
      c.div.withConfig({ componentId: 'sc-oxugzy-0' })([
        'display:inline-flex;flex-direction:column;align-items:center;justify-content:center;margin:0 4px;padding:2px;cursor:pointer;border-radius:2px;canvas{border-radius:2px;}'
      ])),
    Bk = c(Fj).withConfig({ componentId: 'sc-oxugzy-1' })(
      ["[aria-selected='true'] &{padding:1px;border:2px solid ", ';border-radius:2px;}'],
      function (e) {
        return e.theme.palette['accent-primary-active']
      }
    ),
    Vk = c(uC).withConfig({ componentId: 'sc-oxugzy-2' })(
      ["margin-top:6px;font-size:11px;line-height:12px;[aria-selected='true'] &{color:", ';}'],
      function (e) {
        return e.theme.palette['accent-primary-active']
      }
    ),
    Wk = ((lk.defaultProps = { filterFn: void 0 }), s.exports.memo(lk)),
    Gk = [
      { label: 'Original', filterFn: null },
      { label: 'Invert', filterFn: (l = ry.Filters).Invert },
      { label: 'Black & White', filterFn: db },
      { label: 'Sepia', filterFn: l.Sepia },
      { label: 'Solarize', filterFn: l.Solarize },
      { label: 'Clarendon', filterFn: bb },
      { label: 'Gingham', filterFn: wb },
      { label: 'Moon', filterFn: Cb },
      { label: 'Lark', filterFn: Eb },
      { label: 'Reyes', filterFn: Sb },
      { label: 'Juno', filterFn: kb },
      { label: 'Slumber', filterFn: Pb },
      { label: 'Crema', filterFn: Lb },
      { label: 'Ludwig', filterFn: Tb },
      { label: 'Aden', filterFn: Mb },
      { label: 'Perpetua', filterFn: Rb },
      { label: 'Amaro', filterFn: Db },
      { label: 'Mayfair', filterFn: zb },
      { label: 'Rise', filterFn: Fb },
      { label: 'Hudson', filterFn: Bb },
      { label: 'Valencia', filterFn: Wb },
      { label: 'X-Pro II', filterFn: Zb },
      { label: 'Sierra', filterFn: Ub },
      { label: 'Willow', filterFn: Yb },
      { label: 'Lo-Fi', filterFn: qb },
      { label: 'Inkwell', filterFn: l.Grayscale },
      { label: 'Hefe', filterFn: $b },
      { label: 'Nashville', filterFn: Qb },
      { label: 'Stinson', filterFn: Jb },
      { label: 'Vesper', filterFn: tw },
      { label: 'Earlybird', filterFn: rw },
      { label: 'Brannan', filterFn: ow },
      { label: 'Sutro', filterFn: aw },
      { label: 'Toaster', filterFn: sw },
      { label: 'Walden', filterFn: uw },
      { label: '1977', filterFn: fw },
      { label: 'Kelvin', filterFn: gw },
      { label: 'Maven', filterFn: vw },
      { label: 'Ginza', filterFn: yw },
      { label: 'Skyline', filterFn: bw },
      { label: 'Dogpatch', filterFn: ww },
      { label: 'Brooklyn', filterFn: xw },
      { label: 'Helena', filterFn: Sw },
      { label: 'Ashby', filterFn: kw },
      { label: 'Charmes', filterFn: _w }
    ],
    Zk = { maxWidth: '100%', width: '100%' },
    Uk = ['color', 'size'],
    Xk = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, Uk)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M39.4229 8.89453L39.7891 16.6582H38.8613C38.6823 15.291 38.4382 14.3145 38.1289 13.7285C37.6243 12.7845 36.9489 12.0928 36.1025 11.6533C35.2725 11.1976 34.1738 10.9697 32.8066 10.9697H28.1436V36.2627C28.1436 38.2972 28.3633 39.5667 28.8027 40.0713C29.4212 40.7549 30.3734 41.0967 31.6592 41.0967H32.8066V42H18.7686V41.0967H19.9404C21.3402 41.0967 22.333 40.6735 22.9189 39.8271C23.277 39.3063 23.4561 38.1182 23.4561 36.2627V10.9697H19.4766C17.9303 10.9697 16.8317 11.0837 16.1807 11.3115C15.3343 11.6208 14.61 12.2148 14.0078 13.0938C13.4056 13.9727 13.0475 15.1608 12.9336 16.6582H12.0059L12.3965 8.89453H39.4229Z',
          fill: n
        })
      )
    }),
    Yk = Xk,
    qk = ((sk.defaultProps = { isSelected: !1 }), ['color', 'size']),
    $k = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, qk)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 14 18', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M0.214966 17.4813V0.518677H6.61123C8.82693 0.518677 10.5075 0.914783 11.653 1.70699C12.7985 2.49144 13.3712 3.64481 13.3712 5.16709C13.3712 5.99814 13.1413 6.7321 12.6814 7.36898C12.2216 7.99809 11.5819 8.46021 10.7625 8.75535C11.699 8.97282 12.4348 9.41164 12.9699 10.0718C13.5133 10.732 13.7851 11.5397 13.7851 12.4951C13.7851 14.1261 13.2249 15.361 12.1045 16.1998C10.9841 17.0386 9.38713 17.4658 7.31357 17.4813H0.214966ZM3.97748 10.0951V14.6736H7.20069C8.08697 14.6736 8.77677 14.4795 9.27007 14.0911C9.77174 13.695 10.0226 13.1513 10.0226 12.4601C10.0226 10.9067 9.1572 10.1184 7.42644 10.0951H3.97748ZM3.97748 7.62528H6.76173C8.65971 7.59421 9.6087 6.89132 9.6087 5.5166C9.6087 4.74769 9.36623 4.19625 8.88128 3.86228C8.4047 3.52054 7.64801 3.34967 6.61123 3.34967H3.97748V7.62528Z',
          fill: n
        })
      )
    }),
    Kk = ['color', 'size'],
    Qk = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, Kk)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 14 18', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', { d: 'M2.57409 19.3964H0.160461L3.42596 0.603638H5.83958L2.57409 19.3964Z', fill: n })
      )
    }),
    Jk = ['color', 'size'],
    eP = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, Jk)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', { d: 'M0.166672 0.166664H8.50001V8.5H0.166672V0.166664Z', fill: n }),
        ue.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M16.8333 8.5H8.50001V16.8333H0.166672V25.1667H8.50001V33.5H0.166672V41.8333H8.50001V33.5H16.8333V41.8333H25.1667V33.5H33.5V41.8333H41.8333V33.5H33.5V25.1667H41.8333V16.8333H33.5V8.5H41.8333V0.166664H33.5V8.5H25.1667V0.166664H16.8333V8.5ZM16.8333 16.8333V8.5H25.1667V16.8333H16.8333ZM16.8333 25.1667V33.5H25.1667V25.1667H33.5V16.8333H25.1667V25.1667H16.8333ZM16.8333 25.1667H8.50001V16.8333H16.8333V25.1667Z',
          fill: n
        })
      )
    }),
    tP = ['color', 'size'],
    nP = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, tP)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M2.95831 0.458374C1.5776 0.458374 0.458313 1.57766 0.458313 2.95837V35.4584C0.458313 36.8391 1.5776 37.9584 2.95831 37.9584H7.54167V43.7917C7.54167 45.8627 9.2206 47.5417 11.2917 47.5417H43.7917C45.8627 47.5417 47.5417 45.8627 47.5417 43.7917V11.2917C47.5417 9.22059 45.8627 7.54166 43.7917 7.54166H37.9583V2.95837C37.9583 1.57766 36.839 0.458374 35.4583 0.458374H2.95831ZM35.4583 2.95837H2.95831L2.95831 35.4584H35.4583V2.95837ZM15.7267 37.9584L10.0417 43.746V37.9584H15.7267ZM11.5135 45.0417L18.4712 37.9584H28.5529L21.4696 45.0417H11.5135ZM24.4159 45.0417H34.2932L45.0417 34.1339V24.0207L37.9583 31.3242V35.4584C37.9583 36.8391 36.839 37.9584 35.4583 37.9584H31.4912C31.4689 37.9859 31.445 38.0126 31.4194 38.0382L24.4159 45.0417ZM45.0417 21.3515L37.9583 28.655V18.9107L45.0417 11.8338V21.3515ZM37.0311 45.0417H43.7917C44.482 45.0417 45.0417 44.482 45.0417 43.7917V36.9124L37.0311 45.0417ZM43.8844 10.045C43.8538 10.0428 43.8229 10.0417 43.7917 10.0417H37.9583V15.9657L43.8844 10.045Z',
          fill: n
        })
      )
    }),
    rP = ['color', 'size'],
    iP = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, rP)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M5.50015 7.9997C5.50015 6.61898 6.61944 5.49969 8.00015 5.49969H38.0002C39.3809 5.49969 40.5002 6.61898 40.5002 7.99969V37.9997C40.5002 39.3804 39.3809 40.4997 38.0002 40.4997H8.00015C6.61944 40.4997 5.50015 39.3804 5.50015 37.9997V7.9997ZM8.00015 7.99969H38.0002V37.9997H8.00015V7.99969Z',
          fill: n
        }),
        ue.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M0.5 3C0.5 1.61929 1.61929 0.5 3 0.5H43C44.3807 0.5 45.5 1.61929 45.5 3V43C45.5 44.3807 44.3807 45.5 43 45.5H3C1.61929 45.5 0.5 44.3807 0.5 43V3ZM3 3H43V43H3V3Z',
          fill: n
        })
      )
    }),
    oP = ['color', 'size'],
    aP = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, oP)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', { d: 'M9.25008 9.24878H11.7501V10.9675H10.9688V11.7488H9.25008V9.24878Z', fill: n }),
        ue.createElement('path', { d: 'M9.25008 34.2488V36.7488H11.7501V35.03H10.9688V34.2488H9.25008Z', fill: n }),
        ue.createElement('path', { d: 'M34.2501 36.7488H36.7501V34.2488H35.0313V35.03H34.2501V36.7488Z', fill: n }),
        ue.createElement('path', { d: 'M36.7501 11.7488V9.24878H34.2501V10.9675H35.0313V11.7488H36.7501Z', fill: n }),
        ue.createElement('path', { d: 'M14.4063 9.24878V11.7488H17.8438V9.24878H14.4063Z', fill: n }),
        ue.createElement('path', { d: 'M21.2813 9.24878V11.7488H24.7188V9.24878H21.2813Z', fill: n }),
        ue.createElement('path', { d: 'M28.1563 9.24878V11.7488H31.5938V9.24878H28.1563Z', fill: n }),
        ue.createElement('path', { d: 'M36.7501 14.405H34.2501V17.8425H36.7501V14.405Z', fill: n }),
        ue.createElement('path', { d: 'M36.7501 21.28H34.2501V24.7175H36.7501V21.28Z', fill: n }),
        ue.createElement('path', { d: 'M36.7501 28.155H34.2501V31.5925H36.7501V28.155Z', fill: n }),
        ue.createElement('path', { d: 'M31.5938 36.7488V34.2488H28.1563V36.7488H31.5938Z', fill: n }),
        ue.createElement('path', { d: 'M24.7188 36.7488V34.2488H21.2813V36.7488H24.7188Z', fill: n }),
        ue.createElement('path', { d: 'M17.8438 36.7488V34.2488H14.4063V36.7488H17.8438Z', fill: n }),
        ue.createElement('path', { d: 'M9.25008 31.5925H11.7501V28.155H9.25008V31.5925Z', fill: n }),
        ue.createElement('path', { d: 'M9.25008 24.7175H11.7501V21.28H9.25008V24.7175Z', fill: n }),
        ue.createElement('path', { d: 'M9.25008 17.8425H11.7501V14.405H9.25008V17.8425Z', fill: n }),
        ue.createElement('path', {
          d: 'M23.0002 26.7497C25.0712 26.7497 26.7502 25.0708 26.7502 22.9997C26.7502 20.9286 25.0712 19.2497 23.0002 19.2497C20.9291 19.2497 19.2502 20.9286 19.2502 22.9997C19.2502 25.0708 20.9291 26.7497 23.0002 26.7497Z',
          fill: n
        }),
        ue.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M3 0.5C1.61929 0.5 0.5 1.61929 0.5 3V43C0.5 44.3807 1.61929 45.5 3 45.5H43C44.3807 45.5 45.5 44.3807 45.5 43V3C45.5 1.61929 44.3807 0.5 43 0.5H3ZM43 3H3V43H43V3Z',
          fill: n
        })
      )
    }),
    lP = c.div.withConfig({ componentId: 'sc-qvjmv1-0' })([
      'display:flex;align-items:center;justify-content:center;margin-top:8px;flex-wrap:wrap;'
    ]),
    sP = c.div.withConfig({ componentId: 'sc-qvjmv1-1' })(
      [
        'background:',
        ';box-shadow:0px 1px 2px ',
        ";border-radius:2px;overflow:visible;*{font-family:'Roboto',sans-serif;}"
      ],
      function (e) {
        return e.theme.palette['bg-secondary']
      },
      function (e) {
        return e.theme.palette['light-shadow']
      }
    ),
    cP = c.div.withConfig({ componentId: 'sc-qvjmv1-2' })(['padding:8px 12px;']),
    uP = c(uC).withConfig({ componentId: 'sc-qvjmv1-3' })(['font-weight:500;margin-bottom:12px;']),
    dP = c.div.withConfig({ componentId: 'sc-qvjmv1-4' })([
      'display:flex;align-items:center;justify-content:space-between;'
    ]),
    fP = c.div.withConfig({ componentId: 'sc-qvjmv1-5' })(['&:not(:first-child){margin-left:12px;}']),
    hP = c.div.withConfig({ componentId: 'sc-qvjmv1-6' })(function (e) {
      var t = e.theme,
        n = e.addThinBorder,
        r = e.noMargin
      e = e.secondaryIconColor
      return '\n    cursor: pointer;\n    padding: 3px 6px;\n    margin: '
        .concat(
          r ? 0 : '0 4px',
          ';\n    display: inline-block;\n\n    svg {\n      vertical-align: middle;\n      margin: 0 auto;\n    }\n\n    '
        )
        .concat(n ? 'border: 0.5px solid '.concat(t.palette['borders-secondary']) : '', ';\n    color: ')
        .concat(e ? '#959DA8' : '', ";\n\n    &[aria-selected='true'] {\n      background: ")
        .concat(t.palette['bg-primary-active'], ';\n\n      * {\n        color: ')
        .concat(t.palette['accent-primary-active'], ';\n      }\n    }\n\n    :hover {\n      background: ')
        .concat(t.palette['bg-primary-active'], ';\n    }\n  ')
    }),
    pP = 0,
    gP = 1,
    mP = ['size'],
    vP = xS(function (e, t) {
      var n = void 0 === (n = e.size) ? 59 : n
      e = Hu(e, mP)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: n, height: n, viewBox: '0 0 59 59', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M50.8184 49.7351C50.7251 49.8331 50.6271 49.9264 50.5326 50.0232C50.3828 50.1788 50.2342 50.3309 50.0786 50.4841C50.0717 50.4899 50.0659 50.5003 50.0556 50.506L49.6995 50.8517C48.0352 52.4221 46.1932 53.7927 44.2109 54.9356C44.2043 54.941 44.1969 54.9453 44.189 54.9483L44.068 55.0152C43.7661 55.1834 43.4641 55.3516 43.1553 55.5107L43.0482 55.5683C42.714 55.74 42.3775 55.9048 42.0341 56.0672C41.3427 56.3911 40.6351 56.6907 39.9138 56.9603C39.2915 57.1988 38.6554 57.412 38.0136 57.6056C37.8799 57.6494 37.7462 57.6886 37.6125 57.7266C31.4734 59.4637 24.936 59.1591 18.9849 56.8589L18.9561 56.8485C17.5942 56.3173 16.2738 55.6852 15.0059 54.9575C14.999 54.9575 14.9955 54.9518 14.9897 54.9518L14.9483 54.9299C14.6498 54.7582 14.3571 54.5842 14.0644 54.3952C12.0372 53.1261 10.1717 51.6155 8.50895 49.8964L8.47669 49.8642C8.45825 49.8423 8.4352 49.8204 8.41331 49.7973C3.18291 44.3478 0.267746 37.0834 0.280068 29.5299C0.280068 13.3464 13.4007 0.223511 29.5876 0.223511C45.7746 0.223511 58.894 13.3464 58.894 29.5299C58.9055 37.0538 56.0126 44.2919 50.8184 49.7351Z',
          fill: '#3ECF8B'
        }),
        ue.createElement('path', {
          d: 'M50.5292 50.0244C50.3794 50.18 50.2308 50.3321 50.0752 50.4854C50.0683 50.4911 50.0625 50.5015 50.0522 50.5073L49.6961 50.853C48.0318 52.4233 46.1898 53.7939 44.2075 54.9369C44.2009 54.9422 44.1935 54.9465 44.1856 54.9495L44.0646 55.0164C43.7627 55.1881 43.4608 55.354 43.1519 55.5153L43.0448 55.573C42.7106 55.7447 42.3741 55.9094 42.0307 56.0719C41.3393 56.3957 40.6318 56.6953 39.9104 56.965C39.2881 57.2035 38.652 57.4167 38.0102 57.6103C37.8765 57.6541 37.7428 57.6933 37.6092 57.7313C31.47 59.4683 24.9326 59.1638 18.9815 56.8636L18.9527 56.8532C17.5908 56.3219 16.2704 55.6898 15.0025 54.9622C14.9967 54.9598 14.9913 54.9567 14.9864 54.953C14.9737 54.9438 14.9575 54.9369 14.9449 54.9276C14.6464 54.7559 14.3537 54.5819 14.061 54.393C12.0352 53.1244 10.1709 51.6145 8.50903 49.8965C9.43091 46.6642 13.1184 46.1203 13.5206 46.073L13.4929 45.9013L12.7105 41.0477C12.3851 38.9396 12.5084 36.7865 13.0723 34.7294L13.1207 34.5646C13.1368 34.5104 13.1518 34.4597 13.1714 34.4056C13.5717 33.0639 14.2064 31.8037 15.0463 30.6835C15.6608 29.8717 16.3813 29.1458 17.1885 28.5251L14.4044 15.9024L16.1018 15.4829L19.3088 27.1896C21.2574 26.2066 23.7557 25.5048 26.9523 25.2721C27.0065 25.2663 27.0572 25.2629 27.1113 25.2594L27.2703 25.2502C27.9617 25.2029 28.6716 25.1799 29.4218 25.1799C30.2284 25.1799 30.989 25.2052 31.7195 25.2571L31.8786 25.2663C31.9327 25.2663 31.9834 25.2721 32.0376 25.279C35.3909 25.5302 37.9745 26.2769 39.9646 27.3129L43.137 15.7214L44.8332 16.1409L42.0676 28.6738C42.7757 29.2352 43.4137 29.8798 43.9678 30.5936C44.4899 31.2652 44.9334 31.9944 45.2895 32.7669C45.3276 32.8464 45.3667 32.9259 45.3979 33.0055C45.4843 33.1956 45.5638 33.3869 45.6283 33.5816C45.6606 33.6681 45.6917 33.7499 45.7205 33.8328C45.7908 34.0264 45.8542 34.2177 45.9118 34.409C45.9279 34.4632 45.9429 34.5242 45.959 34.5738L46.0063 34.7432C46.042 34.8699 46.0731 34.9944 46.1019 35.1177C46.125 35.2064 46.1434 35.2963 46.163 35.385C46.1826 35.4738 46.201 35.559 46.2172 35.6455C46.2448 35.7849 46.2702 35.9255 46.2932 36.0649C46.3947 36.6628 46.4563 37.2669 46.4776 37.873C46.4776 37.9432 46.4776 38.0101 46.4776 38.0769C46.5071 38.8666 46.4604 39.6573 46.3382 40.4381L45.5684 45.6409L45.4866 46.1975C45.4915 46.1959 45.4967 46.1959 45.5016 46.1975C45.9176 46.2482 49.6039 46.7852 50.5292 50.0244Z',
          fill: 'white'
        }),
        ue.createElement('path', {
          d: 'M14.8608 16.7251C16.1775 16.7251 17.245 15.6576 17.245 14.3409C17.245 13.0241 16.1775 11.9567 14.8608 11.9567C13.544 11.9567 12.4766 13.0241 12.4766 14.3409C12.4766 15.6576 13.544 16.7251 14.8608 16.7251Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M44.3791 16.7251C45.6958 16.7251 46.7633 15.6576 46.7633 14.3409C46.7633 13.0241 45.6958 11.9567 44.3791 11.9567C43.0623 11.9567 41.9949 13.0241 41.9949 14.3409C41.9949 15.6576 43.0623 16.7251 44.3791 16.7251Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M46.353 40.438L45.5833 45.6408L45.5014 46.1974L44.8942 50.3193L44.8527 50.5866L44.2074 54.931C44.2008 54.9364 44.1934 54.9406 44.1855 54.9437L44.0645 55.0105C43.7626 55.1787 43.4606 55.347 43.1518 55.506L43.0447 55.5636C42.7105 55.7353 42.374 55.9001 42.0306 56.0626C41.3392 56.3864 40.6316 56.686 39.9103 56.9556C40.12 54.4205 40.324 51.8992 40.5083 49.5691L40.5176 49.4839V49.4677L40.5268 49.3248V49.3018C40.5268 49.258 40.5268 49.2096 40.5395 49.1658C40.559 48.9238 40.574 48.6853 40.5971 48.4537L40.6478 47.8533C40.6639 47.6562 40.6789 47.4649 40.6985 47.2771C41.1214 42.8279 42.0433 40.6062 42.2299 38.4202V38.3845C42.2588 38.0388 42.2772 37.7138 42.2876 37.3992C42.2876 37.3358 42.2876 37.2725 42.2933 37.2056C42.3821 34.6221 42.0871 33.071 43.9654 30.5889C44.4875 31.2605 44.931 31.9896 45.2871 32.7622C45.3251 32.8417 45.3643 32.9212 45.3954 33.0007C45.4819 33.1909 45.5614 33.3821 45.6259 33.5769C45.6582 33.6633 45.6893 33.7451 45.7181 33.8281C45.7884 34.0217 45.8518 34.213 45.9094 34.4043C45.9255 34.4584 45.9405 34.5195 45.9566 34.5691L46.0039 34.7385C46.0396 34.8652 46.0707 34.9897 46.0995 35.113C46.1226 35.2017 46.141 35.2916 46.1606 35.3803C46.1802 35.469 46.1986 35.5543 46.2147 35.6407C46.2424 35.7802 46.2678 35.9208 46.2908 36.0602C46.3923 36.6581 46.4539 37.2621 46.4752 37.8682C46.4752 37.9385 46.4752 38.0054 46.4752 38.0722C46.5107 38.8629 46.4698 39.6551 46.353 40.438Z',
          fill: '#D8DDEE'
        }),
        ue.createElement('path', {
          d: 'M18.9527 56.8474C17.5908 56.3161 16.2704 55.684 15.0025 54.9564C14.9829 54.9471 14.9644 54.9345 14.9449 54.9252L13.4929 45.8955L12.7105 41.0418C12.3769 38.8765 12.5169 36.6647 13.1207 34.5587C13.5216 33.1588 14.1741 31.8437 15.0463 30.6776C16.7183 33.0491 16.5017 34.6025 16.5685 37.0697C16.5685 37.1768 16.5754 37.2921 16.5789 37.4027C16.5916 37.7426 16.61 38.0941 16.6423 38.4744V38.5089C16.8266 40.6926 17.7128 42.9109 18.161 47.246C18.168 47.329 18.1772 47.412 18.1829 47.4938C18.206 47.7242 18.2279 47.9708 18.2498 48.2151L18.3005 48.8259C18.3132 48.9722 18.3258 49.1151 18.3362 49.258C18.3362 49.2799 18.3362 49.3053 18.3362 49.3283C18.3454 49.4493 18.3558 49.5738 18.365 49.6947L18.3869 49.9736C18.5678 52.1504 18.7591 54.4897 18.9527 56.8474Z',
          fill: '#D8DDEE'
        }),
        ue.createElement('path', {
          d: 'M26.565 37.1273L25.4092 34.8411L24.1774 37.1262L26.565 37.1273Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M26.8231 37.2864H23.9111L25.4092 34.5L26.8231 37.2864ZM24.4435 36.9672H26.3057L25.4034 35.1833L24.4435 36.9672Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M34.378 37.1273L33.2222 34.8411L31.9904 37.1262L34.378 37.1273Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M34.636 37.2864H31.724L33.222 34.5L34.636 37.2864ZM32.2564 36.9672H34.1197L33.2174 35.1833L32.2564 36.9672Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M37.2277 41.7274C38.1346 41.7274 38.8698 40.9922 38.8698 40.0853C38.8698 39.1784 38.1346 38.4432 37.2277 38.4432C36.3208 38.4432 35.5856 39.1784 35.5856 40.0853C35.5856 40.9922 36.3208 41.7274 37.2277 41.7274Z',
          fill: '#F7EBE4'
        }),
        ue.createElement('path', {
          d: 'M21.6537 42.1515C22.5606 42.1515 23.2958 41.4163 23.2958 40.5094C23.2958 39.6025 22.5606 38.8673 21.6537 38.8673C20.7468 38.8673 20.0116 39.6025 20.0116 40.5094C20.0116 41.4163 20.7468 42.1515 21.6537 42.1515Z',
          fill: '#F7EBE4'
        }),
        ue.createElement('path', {
          d: 'M33.493 42.0801C33.493 43.1622 31.6677 44.0391 29.4149 44.0391C27.162 44.0391 25.3356 43.1622 25.3356 42.0801C25.3356 40.9981 27.2277 41.9476 29.484 41.9476C31.7403 41.9476 33.493 40.9969 33.493 42.0801Z',
          fill: '#C9D1E5'
        }),
        ue.createElement('path', {
          d: 'M46.5432 34.1796C46.3173 34.1921 46.1005 34.2724 45.9209 34.41L45.9083 34.4193C45.3194 34.8514 44.764 35.9231 44.2616 37.6009C43.4549 40.2674 42.9836 43.7705 42.7635 45.6201C42.6713 46.4371 42.6045 47.1388 42.5596 47.7081C42.5324 48.1055 42.3551 48.4777 42.0636 48.7492C41.7722 49.0208 41.3884 49.1714 40.9901 49.1704H18.0504C17.6431 49.1692 17.2522 49.0106 16.9592 48.7278C16.6662 48.4449 16.494 48.0597 16.4786 47.6528C16.4474 46.9729 16.4094 46.308 16.3633 45.6765C16.1248 42.3001 15.68 39.5829 15.0439 37.5963C14.3525 35.4449 13.5885 34.682 13.2197 34.4412C13.2063 34.4236 13.1889 34.4094 13.169 34.3997C13.169 34.3997 13.1598 34.3997 13.1564 34.3928C13.0595 34.3224 12.9493 34.2726 12.8325 34.2464C12.7916 34.2403 12.7498 34.2501 12.7159 34.274C12.682 34.2978 12.6586 34.3337 12.6505 34.3743C12.6446 34.4155 12.6545 34.4574 12.6782 34.4917C12.7019 34.5259 12.7377 34.5498 12.7784 34.5587C12.8547 34.5827 12.9267 34.6189 12.9916 34.6659L13.01 34.6762L13.0192 34.6855C13.0373 34.6964 13.0543 34.7092 13.0699 34.7235C13.4421 34.9908 14.107 35.7283 14.7385 37.6919C15.37 39.6555 15.8102 42.3485 16.0453 45.7019C16.0902 46.3276 16.1282 46.989 16.1605 47.6609C16.1793 48.1496 16.3863 48.6122 16.7383 48.9517C17.0904 49.2913 17.5601 49.4816 18.0492 49.4827H40.9947C41.4732 49.4842 41.9344 49.3037 42.2849 48.9778C42.6354 48.652 42.8489 48.2051 42.8822 47.7277C42.9237 47.1584 42.9974 46.4601 43.085 45.6535C43.2982 43.8097 43.7764 40.3296 44.5669 37.685C45.0279 36.1628 45.5107 35.1717 46.0154 34.7396C46.0411 34.714 46.0689 34.6905 46.0984 34.6693C46.2303 34.5649 46.3913 34.5037 46.5593 34.4942C46.5802 34.4934 46.6008 34.4886 46.6198 34.4799C46.6388 34.4712 46.6559 34.4589 46.6701 34.4435C46.6844 34.4282 46.6954 34.4103 46.7027 34.3907C46.71 34.3711 46.7134 34.3503 46.7126 34.3294C46.7119 34.3082 46.7069 34.2874 46.6979 34.2683C46.6889 34.2491 46.676 34.232 46.6602 34.218C46.6443 34.204 46.6258 34.1933 46.6057 34.1867C46.5855 34.1801 46.5643 34.1777 46.5432 34.1796Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M31.8784 25.2652L31.7194 25.2559V30.0612H27.2702V25.249L27.1112 25.2582C27.057 25.2582 27.0063 25.2652 26.9521 25.2709V30.2202C26.9525 30.2623 26.9693 30.3026 26.9991 30.3323C27.0288 30.3621 27.0691 30.379 27.1112 30.3793H31.8784C31.9204 30.3787 31.9605 30.3617 31.9902 30.332C32.0199 30.3023 32.0368 30.2622 32.0374 30.2202V25.2778C31.9833 25.2709 31.9326 25.2686 31.8784 25.2652Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M22.5457 33.9514C22.5457 33.9514 23.3246 31.6156 25.9117 31.5315',
          stroke: '#7386F3',
          strokeMiterlimit: '10',
          strokeLinecap: 'round'
        }),
        ue.createElement('path', {
          d: 'M36.2574 33.9514C36.2574 33.9514 35.4784 31.6156 32.8926 31.5315',
          stroke: '#7386F3',
          strokeMiterlimit: '10',
          strokeLinecap: 'round'
        }),
        ue.createElement('path', {
          d: 'M12.9363 35.1959L13.2497 34.1323L12.3382 33.4017L11.9625 34.3824L12.9363 35.1959Z',
          fill: '#3ECF8B'
        }),
        ue.createElement('path', {
          d: 'M46.1445 35.1649L45.8311 34.1013L46.7426 33.3707L47.1171 34.3514L46.1445 35.1649Z',
          fill: '#3ECF8B'
        })
      )
    }),
    yP = ['size'],
    bP = xS(function (e, t) {
      var n = void 0 === (n = e.size) ? 59 : n
      e = Hu(e, yP)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: n, height: n, viewBox: '0 0 59 59', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M50.8183 49.6509C50.7249 49.7488 50.627 49.8422 50.5325 49.939C50.3827 50.0945 50.234 50.2466 50.0785 50.3999C50.0716 50.4057 50.0658 50.416 50.0554 50.4218C49.9402 50.537 49.8169 50.6523 49.6994 50.7675C48.0341 52.3385 46.1909 53.7095 44.2073 54.8526C44.2007 54.8579 44.1933 54.8622 44.1854 54.8652L44.0644 54.9321C43.7625 55.1003 43.4606 55.2685 43.1517 55.4276L43.0446 55.4852C42.7104 55.6569 42.3739 55.8217 42.0305 55.9842C41.3391 56.308 40.6316 56.6076 39.9102 56.8772C39.2879 57.1158 38.6518 57.3289 38.01 57.5225C37.8763 57.5663 37.7426 57.6055 37.609 57.6435C31.4698 59.3806 24.9324 59.076 18.9813 56.7758L18.9525 56.7654C17.5906 56.2342 16.2702 55.6021 15.0023 54.8744C14.9954 54.8744 14.9919 54.8687 14.9862 54.8687L14.9447 54.8468C14.6462 54.6751 14.3535 54.5011 14.0608 54.3121C12.0345 53.0428 10.1702 51.5317 8.50883 49.8122L8.47657 49.7799C8.45813 49.758 8.43508 49.7361 8.41319 49.7131C3.18279 44.2635 0.267624 36.9991 0.279946 29.4457C0.279946 13.2622 13.4005 0.139282 29.5875 0.139282C45.7745 0.139282 58.8939 13.2622 58.8939 29.4457C58.9054 36.9696 56.0125 44.2076 50.8183 49.6509Z',
          fill: '#6E7BB2'
        }),
        ue.createElement('path', {
          d: 'M50.529 49.9391C50.3792 50.0947 50.2305 50.2468 50.075 50.4001C50.0681 50.4058 50.0623 50.4162 50.0519 50.422C49.9367 50.5372 49.8134 50.6524 49.6959 50.7677C48.0316 52.338 46.1895 53.7086 44.2072 54.8516C44.2007 54.857 44.1933 54.8612 44.1853 54.8643L44.0644 54.9311C43.7624 55.1028 43.4605 55.2687 43.1517 55.4301L43.0445 55.4877C42.7104 55.6594 42.3739 55.8242 42.0305 55.9866C41.3391 56.3104 40.6315 56.6101 39.9102 56.8797C39.2879 57.1182 38.6518 57.3314 38.0099 57.525C37.8763 57.5688 37.7426 57.608 37.6089 57.646C31.4697 59.383 24.9324 59.0785 18.9813 56.7783L18.9525 56.7679C17.5906 56.2367 16.2702 55.6046 15.0022 54.8769C14.9965 54.8745 14.9911 54.8715 14.9861 54.8677C14.9734 54.8585 14.9573 54.8516 14.9446 54.8424C14.6462 54.6707 14.3535 54.4967 14.0608 54.3077C12.0345 53.0384 10.1701 51.5273 8.50879 49.8078C9.43066 46.5812 13.1182 46.0315 13.5203 45.9843L13.4927 45.8126L12.7102 40.9589C12.3849 38.8508 12.5082 36.6978 13.0721 34.6406L13.1205 34.4758C13.1366 34.4217 13.1516 34.371 13.1712 34.3168C13.5714 32.9751 14.2062 31.715 15.046 30.5947C15.6603 29.7827 16.3808 29.0568 17.1882 28.4364L14.4042 15.8159L16.1016 15.3965L19.3086 27.1031C21.2572 26.1202 23.7554 25.4184 26.952 25.1856C27.0062 25.1799 27.0569 25.1764 27.1111 25.173L27.2701 25.1637C27.9615 25.1165 28.6713 25.0935 29.4215 25.0935C30.2282 25.0935 30.9887 25.12 31.7193 25.1707L31.8783 25.1799C31.9325 25.1799 31.9832 25.1856 32.0373 25.1926C35.3907 25.4438 37.9742 26.1905 39.9643 27.2264L43.1367 15.635L44.833 16.0545L42.0673 28.5874C42.7755 29.1488 43.4135 29.7933 43.9676 30.5072C44.4897 31.1788 44.9332 31.9079 45.2893 32.6805C45.3273 32.76 45.3665 32.8395 45.3976 32.919C45.484 33.1092 45.5636 33.3005 45.6281 33.4952C45.6603 33.5816 45.6915 33.6634 45.7203 33.7464C45.7906 33.94 45.8539 34.1313 45.9116 34.3226C45.9277 34.3767 45.9427 34.4378 45.9588 34.4874L46.0061 34.6568C46.0418 34.7835 46.0729 34.908 46.1017 35.0313C46.1247 35.12 46.1432 35.2099 46.1628 35.2986C46.1824 35.3873 46.2008 35.4726 46.2169 35.559C46.2446 35.6985 46.2699 35.8391 46.293 35.9785C46.3945 36.5764 46.4561 37.1804 46.4774 37.7865C46.4774 37.8568 46.4774 37.9237 46.4774 37.9905C46.5068 38.7802 46.4601 39.5709 46.3379 40.3516L45.5682 45.5545L45.4863 46.1111C45.4912 46.1095 45.4965 46.1095 45.5013 46.1111C45.9173 46.1629 49.6037 46.7034 50.529 49.9391Z',
          fill: 'white'
        }),
        ue.createElement('path', {
          d: 'M14.8605 16.6399C16.1773 16.6399 17.2447 15.5724 17.2447 14.2557C17.2447 12.9389 16.1773 11.8715 14.8605 11.8715C13.5438 11.8715 12.4763 12.9389 12.4763 14.2557C12.4763 15.5724 13.5438 16.6399 14.8605 16.6399Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M44.3791 16.6399C45.6958 16.6399 46.7633 15.5724 46.7633 14.2557C46.7633 12.9389 45.6958 11.8715 44.3791 11.8715C43.0623 11.8715 41.9949 12.9389 41.9949 14.2557C41.9949 15.5724 43.0623 16.6399 44.3791 16.6399Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M46.3529 40.3529L45.5831 45.5557L45.5013 46.1123L44.894 50.2342L44.8526 50.5016L44.2072 54.8459C44.2007 54.8513 44.1933 54.8556 44.1854 54.8586L44.0644 54.9254C43.7624 55.0937 43.4605 55.2619 43.1517 55.4209L43.0445 55.4785C42.7104 55.6502 42.3739 55.815 42.0305 55.9775C41.3391 56.3013 40.6315 56.6009 39.9102 56.8706C40.1199 54.3354 40.3238 51.8141 40.5082 49.4841L40.5174 49.3988V49.3826L40.5267 49.2397V49.2167C40.5267 49.1729 40.5267 49.1245 40.5393 49.0807C40.5589 48.8387 40.5739 48.6002 40.597 48.3686L40.6477 47.7682C40.6638 47.5712 40.6788 47.3799 40.6984 47.192C41.1213 42.7428 42.0431 40.5211 42.2298 38.3351V38.2994C42.2586 37.9537 42.2771 37.6287 42.2874 37.3141C42.2874 37.2508 42.2874 37.1874 42.2932 37.1205C42.3819 34.537 42.0869 32.9859 43.9653 30.5038C44.4874 31.1754 44.9309 31.9046 45.287 32.6771C45.325 32.7566 45.3642 32.8361 45.3953 32.9156C45.4817 33.1058 45.5613 33.2971 45.6258 33.4918C45.658 33.5782 45.6892 33.6601 45.718 33.743C45.7883 33.9366 45.8516 34.1279 45.9093 34.3192C45.9254 34.3734 45.9404 34.4344 45.9565 34.484L46.0038 34.6534C46.0395 34.7801 46.0706 34.9046 46.0994 35.0279C46.1224 35.1166 46.1409 35.2065 46.1605 35.2952C46.1801 35.384 46.1985 35.4692 46.2146 35.5557C46.2423 35.6951 46.2676 35.8357 46.2907 35.9751C46.3922 36.573 46.4538 37.177 46.4751 37.7831C46.4751 37.8534 46.4751 37.9203 46.4751 37.9871C46.5105 38.7778 46.4696 39.57 46.3529 40.3529Z',
          fill: '#D8DDEE'
        }),
        ue.createElement('path', {
          d: 'M18.9526 56.7623C17.5907 56.231 16.2703 55.5989 15.0023 54.8713C14.9828 54.862 14.9643 54.8494 14.9447 54.8401L13.4928 45.8104L12.7103 40.9567C12.3768 38.7914 12.5167 36.5796 13.1206 34.4736C13.5215 33.0738 14.174 31.7586 15.0461 30.5925C16.7182 32.9641 16.5015 34.5174 16.5684 36.9846C16.5684 37.0917 16.5753 37.207 16.5788 37.3176C16.5914 37.6633 16.6099 38.009 16.6421 38.3893V38.4239C16.8265 40.6075 17.7127 42.8258 18.1609 47.1609C18.1667 47.2439 18.1771 47.3269 18.1828 47.4087C18.2059 47.6392 18.2278 47.8858 18.2497 48.1301L18.3004 48.7408C18.313 48.8871 18.3257 49.03 18.3361 49.1729C18.3361 49.1948 18.3361 49.2202 18.3361 49.2432C18.3453 49.3584 18.3557 49.4887 18.3649 49.6097L18.3868 49.8885C18.5677 52.0653 18.759 54.4046 18.9526 56.7623Z',
          fill: '#D8DDEE'
        }),
        ue.createElement('path', {
          d: 'M26.5649 37.0421L25.4079 34.7559L24.1772 37.041L26.5649 37.0421Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M26.8231 37.2012H23.9111L25.4092 34.4148L26.8231 37.2012ZM24.4435 36.882H26.3057L25.4034 35.0981L24.4435 36.882Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M34.3778 37.0421L33.222 34.7559L31.9901 37.041L34.3778 37.0421Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M34.6359 37.2012H31.7239L33.2219 34.4148L34.6359 37.2012ZM32.2563 36.882H34.1196L33.2173 35.0981L32.2563 36.882Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M37.2275 41.6423C38.1344 41.6423 38.8696 40.9071 38.8696 40.0002C38.8696 39.0933 38.1344 38.3582 37.2275 38.3582C36.3206 38.3582 35.5854 39.0933 35.5854 40.0002C35.5854 40.9071 36.3206 41.6423 37.2275 41.6423Z',
          fill: '#F7EBE4'
        }),
        ue.createElement('path', {
          d: 'M21.6537 42.0664C22.5606 42.0664 23.2958 41.3312 23.2958 40.4243C23.2958 39.5174 22.5606 38.7822 21.6537 38.7822C20.7468 38.7822 20.0116 39.5174 20.0116 40.4243C20.0116 41.3312 20.7468 42.0664 21.6537 42.0664Z',
          fill: '#F7EBE4'
        }),
        ue.createElement('path', {
          d: 'M33.4927 41.4844C33.4927 42.5664 31.6674 42.6863 29.4146 42.6863C27.1617 42.6863 25.3341 42.571 25.3341 41.4844C25.3341 40.3977 27.2274 40.5948 29.4825 40.5948C31.7377 40.5948 33.4927 40.4046 33.4927 41.4844Z',
          fill: '#C9D1E5'
        }),
        ue.createElement('path', {
          d: 'M46.5431 34.0945C46.3172 34.107 46.1003 34.1873 45.9208 34.325L45.9081 34.3342C45.3193 34.7663 44.7639 35.838 44.2614 37.5158C43.4548 40.1823 42.9835 43.6855 42.7634 45.535C42.6712 46.352 42.6044 47.0538 42.5594 47.623C42.5334 48.0204 42.3573 48.3931 42.0667 48.6655C41.7761 48.9379 41.3928 49.0896 40.9946 49.0899H18.0502C17.6422 49.0887 17.2506 48.9295 16.9575 48.6456C16.6645 48.3618 16.4927 47.9754 16.4784 47.5677C16.4473 46.8878 16.4093 46.2229 16.3632 45.5914C16.1247 42.2151 15.6799 39.4978 15.0438 37.5112C14.3524 35.3598 13.5884 34.5969 13.2196 34.3561C13.2062 34.3385 13.1888 34.3243 13.1689 34.3146C13.1689 34.3146 13.1597 34.3146 13.1562 34.3077C13.0594 34.2373 12.9492 34.1875 12.8324 34.1613C12.7915 34.1552 12.7497 34.1651 12.7158 34.1889C12.6819 34.2127 12.6585 34.2486 12.6504 34.2892C12.6444 34.3304 12.6543 34.3724 12.6781 34.4066C12.7018 34.4408 12.7376 34.4647 12.7783 34.4736C12.8546 34.4977 12.9266 34.5338 12.9914 34.5808L13.0099 34.5912L13.0191 34.6004C13.0372 34.6114 13.0542 34.6241 13.0698 34.6384C13.442 34.9057 14.1069 35.6432 14.7384 37.6068C15.3699 39.5704 15.8101 42.2635 16.0452 45.6168C16.0901 46.2425 16.1281 46.9039 16.1604 47.5758C16.1791 48.0645 16.3862 48.5271 16.7382 48.8667C17.0902 49.2062 17.56 49.3965 18.0491 49.3976H40.9946C41.4731 49.3991 41.9343 49.2186 42.2848 48.8927C42.6353 48.5669 42.8488 48.12 42.8821 47.6426C42.9236 47.0733 42.9973 46.375 43.0849 45.5684C43.2981 43.7246 43.7763 40.2446 44.5668 37.5999C45.0278 36.0777 45.5106 35.0867 46.0153 34.6545C46.041 34.6289 46.0688 34.6054 46.0983 34.5842C46.2302 34.4798 46.3912 34.4186 46.5592 34.4091C46.5801 34.4083 46.6006 34.4035 46.6197 34.3948C46.6387 34.3861 46.6558 34.3738 46.67 34.3585C46.6842 34.3432 46.6953 34.3252 46.7026 34.3056C46.7099 34.286 46.7132 34.2652 46.7125 34.2443C46.7118 34.2231 46.7068 34.2024 46.6978 34.1832C46.6887 34.164 46.6759 34.1469 46.6601 34.1329C46.6442 34.1189 46.6256 34.1082 46.6055 34.1016C46.5854 34.095 46.5642 34.0926 46.5431 34.0945Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M31.8784 25.18L31.7194 25.1707V29.976H27.2702V25.1638L27.1112 25.173C27.057 25.173 27.0063 25.18 26.9521 25.1857V30.135C26.9525 30.1771 26.9693 30.2174 26.9991 30.2471C27.0288 30.2769 27.0691 30.2938 27.1112 30.2941H31.8784C31.9204 30.2935 31.9605 30.2765 31.9902 30.2468C32.0199 30.2171 32.0368 30.177 32.0374 30.135V25.1926C31.9833 25.1857 31.9326 25.1834 31.8784 25.18Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M13.1712 34.3146L13.0721 34.6384L12.587 34.5059L12.4729 34.0103L12.8635 33.9954L13.1712 34.3146Z',
          fill: '#6E7BB2'
        }),
        ue.createElement('path', {
          d: 'M45.9209 34.3237L46.0154 34.6579L46.8359 34.356L46.6861 34.0264L46.3 33.978L45.9209 34.3237Z',
          fill: '#6E7BB2'
        })
      )
    }),
    wP = ['size'],
    CP = xS(function (e, t) {
      var n = void 0 === (n = e.size) ? 59 : n
      e = Hu(e, wP)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: n, height: n, viewBox: '0 0 59 59', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M50.8184 49.6567C50.725 49.7547 50.6271 49.8492 50.5326 49.9448C50.3828 50.1004 50.2341 50.2525 50.0786 50.4058C50.0721 50.4142 50.0643 50.4216 50.0555 50.4277C49.9403 50.5429 49.817 50.6581 49.6995 50.7734C48.0335 52.3415 46.1903 53.7102 44.2074 54.8515C44.2016 54.8515 44.1947 54.8607 44.1855 54.8642L44.0645 54.9299C43.7626 55.0981 43.4607 55.2675 43.1518 55.4254L43.0447 55.483C42.7105 55.6547 42.374 55.8195 42.0306 55.9819C41.3392 56.3058 40.6317 56.6054 39.9103 56.875C39.288 57.1136 38.6519 57.3267 38.0101 57.5203C37.8764 57.5653 37.7427 57.6033 37.6091 57.6413C31.4699 59.3784 24.9326 59.0738 18.9814 56.7736L18.9526 56.7644C17.5909 56.2326 16.2706 55.6006 15.0024 54.8734C14.9955 54.8734 14.992 54.8665 14.9863 54.8665L14.9448 54.8446C14.6463 54.6729 14.3536 54.4989 14.0609 54.3111C12.0349 53.041 10.1706 51.5296 8.50894 49.81L8.47667 49.7789C8.45676 49.7555 8.4356 49.7332 8.41329 49.712C3.18524 44.2642 0.270299 37.0033 0.280054 29.4527C0.280054 13.268 13.4006 0.145142 29.5876 0.145142C45.7746 0.145142 58.894 13.268 58.894 29.4527C58.9053 36.9762 56.0125 44.2138 50.8184 49.6567Z',
          fill: '#E85B46'
        }),
        ue.createElement('path', {
          d: 'M50.5291 49.9459C50.3793 50.1015 50.2307 50.2536 50.0751 50.4069C50.0686 50.4153 50.0608 50.4227 50.0521 50.4288C49.9368 50.544 49.8135 50.6592 49.696 50.7745C48.031 52.342 46.189 53.7102 44.2074 54.8515C44.2016 54.8515 44.1947 54.8607 44.1855 54.8641L44.0645 54.9298C43.7626 55.1015 43.4607 55.2675 43.1518 55.4288L43.0447 55.4864C42.7105 55.6581 42.374 55.8229 42.0306 55.9854C41.3392 56.3092 40.6316 56.6088 39.9103 56.8784C39.288 57.117 38.6519 57.3301 38.0101 57.5237C37.8764 57.5687 37.7427 57.6067 37.609 57.6447C31.4699 59.3818 24.9325 59.0772 18.9814 56.777L18.9526 56.7678C17.5909 56.236 16.2705 55.604 15.0024 54.8768L14.9862 54.8664C14.9736 54.8572 14.9574 54.8503 14.9448 54.8411C14.6463 54.6694 14.3536 54.4954 14.0609 54.3075C12.0348 53.0375 10.1705 51.5261 8.50891 49.8065C9.43079 46.5799 13.1183 46.0303 13.5205 45.983L13.4928 45.8113L12.7104 40.9576C12.385 38.8495 12.5083 36.6965 13.0722 34.6393L13.1206 34.4746C13.1367 34.4204 13.1517 34.3697 13.1713 34.3155C13.5716 32.9739 14.2063 31.7137 15.0462 30.5935C15.6604 29.7814 16.3809 29.0555 17.1884 28.4351L14.4043 15.8239L16.1017 15.4044L19.3087 27.1099C21.2573 26.1281 23.7556 25.4252 26.9522 25.1936C27.0063 25.1867 27.057 25.1832 27.1112 25.1809L27.2702 25.1705C27.9616 25.1233 28.6715 25.1014 29.4216 25.1014C30.2283 25.1014 30.9888 25.1267 31.7194 25.1774L31.8784 25.1867C31.9326 25.1867 31.9833 25.1936 32.0375 25.1993C35.3908 25.4506 37.9743 26.1973 39.9644 27.2332L43.1368 15.6418L44.8331 16.0624L42.0675 28.5941C42.7756 29.1555 43.4136 29.8001 43.9677 30.514C44.4898 31.1855 44.9333 31.9147 45.2894 32.6873C45.3274 32.7668 45.3666 32.8463 45.3977 32.9258C45.4842 33.1171 45.5637 33.3072 45.6282 33.502C45.6605 33.5884 45.6916 33.6714 45.7204 33.7532C45.7907 33.9479 45.8541 34.1381 45.9117 34.3294C45.9278 34.3835 45.9428 34.4446 45.9589 34.4953L46.0062 34.6635C46.0419 34.7903 46.073 34.9148 46.1018 35.0381C46.1249 35.1279 46.1433 35.2167 46.1629 35.3054C46.1825 35.3941 46.2009 35.4806 46.2171 35.5658C46.2447 35.7064 46.2701 35.8458 46.2931 35.9853C46.3947 36.5836 46.4563 37.188 46.4775 37.7945C46.4775 37.8636 46.4775 37.9304 46.4775 37.9973C46.507 38.787 46.4603 39.5777 46.3381 40.3584L45.5683 45.5613L45.4865 46.1178C45.4913 46.1163 45.4966 46.1163 45.5014 46.1178C45.9174 46.1697 49.6038 46.7101 50.5291 49.9459Z',
          fill: 'white'
        }),
        ue.createElement('path', {
          d: 'M14.8606 16.6467C16.1774 16.6467 17.2448 15.5793 17.2448 14.2625C17.2448 12.9457 16.1774 11.8783 14.8606 11.8783C13.5439 11.8783 12.4764 12.9457 12.4764 14.2625C12.4764 15.5793 13.5439 16.6467 14.8606 16.6467Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M44.3791 16.6467C45.6958 16.6467 46.7633 15.5793 46.7633 14.2625C46.7633 12.9457 45.6958 11.8783 44.3791 11.8783C43.0623 11.8783 41.9949 12.9457 41.9949 14.2625C41.9949 15.5793 43.0623 16.6467 44.3791 16.6467Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M46.3532 40.3596L45.5834 45.5625L45.5016 46.119L44.8943 50.2421L44.8528 50.5095L44.2075 54.8515C44.2017 54.8515 44.1948 54.8607 44.1856 54.8642L44.0646 54.9299C43.7627 55.0981 43.4608 55.2675 43.1519 55.4254L43.0448 55.483C42.7106 55.6547 42.3741 55.8195 42.0307 55.9819C41.3393 56.3058 40.6318 56.6054 39.9104 56.875C40.1201 54.3399 40.3241 51.8185 40.5085 49.4885L40.5177 49.4032V49.3871L40.5269 49.2442V49.2223C40.5269 49.1774 40.5269 49.1301 40.5396 49.0852C40.5592 48.8432 40.5741 48.6058 40.5972 48.373L40.6479 47.7726C40.664 47.5756 40.679 47.3843 40.6986 47.1965C41.1215 42.7461 42.0434 40.5244 42.2301 38.3384V38.3027C42.2589 37.957 42.2773 37.632 42.2877 37.3174C42.2877 37.2541 42.2877 37.1907 42.2934 37.1238C42.3822 34.5403 42.0872 32.9892 43.9655 30.5071C44.4876 31.1787 44.9311 31.9079 45.2872 32.6804C45.3253 32.7599 45.3644 32.8394 45.3956 32.9189C45.482 33.1102 45.5615 33.3004 45.626 33.4951C45.6583 33.5815 45.6894 33.6645 45.7182 33.7463C45.7885 33.9411 45.8519 34.1312 45.9095 34.3225C45.9256 34.3767 45.9406 34.4377 45.9567 34.4884L46.004 34.6567C46.0397 34.7834 46.0708 34.9079 46.0996 35.0312C46.1227 35.1211 46.1411 35.2098 46.1607 35.2985C46.1803 35.3873 46.1987 35.4737 46.2149 35.559C46.2425 35.6995 46.2679 35.839 46.2909 35.9784C46.3925 36.5767 46.4541 37.1811 46.4753 37.7876C46.4753 37.8567 46.4753 37.9236 46.4753 37.9904C46.511 38.7822 46.4701 39.5757 46.3532 40.3596Z',
          fill: '#D8DDEE'
        }),
        ue.createElement('path', {
          d: 'M18.9526 56.7701C17.5909 56.2384 16.2705 55.6063 15.0023 54.8791C14.9828 54.8687 14.9643 54.8561 14.9447 54.8469L13.4928 45.8171L12.7103 40.9634C12.3768 38.7981 12.5167 36.5863 13.1206 34.4803C13.5215 33.0805 14.174 31.7653 15.0461 30.5992C16.7182 32.9708 16.5015 34.5253 16.5684 36.9913C16.5684 37.0996 16.5753 37.2137 16.5788 37.3243C16.5914 37.67 16.6099 38.0157 16.6421 38.396V38.4306C16.8265 40.6143 17.7127 42.8325 18.1609 47.1676C18.1667 47.2506 18.1771 47.3336 18.1828 47.4154C18.2059 47.6459 18.2278 47.8925 18.2497 48.1379L18.3004 48.7475C18.313 48.8938 18.3257 49.0367 18.3361 49.1796C18.3361 49.2027 18.3361 49.228 18.3361 49.2499C18.3453 49.3652 18.3557 49.4942 18.3649 49.6152L18.3868 49.8952C18.5677 52.072 18.759 54.4113 18.9526 56.7701Z',
          fill: '#D8DDEE'
        }),
        ue.createElement('path', {
          d: 'M26.565 37.0489L25.4081 34.7627L24.1774 37.0478L26.565 37.0489Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M26.8231 37.2079H23.9111L25.4092 34.4204L26.8231 37.2079ZM24.4435 36.8887H26.3057L25.4034 35.1049L24.4435 36.8887Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M34.3779 37.0489L33.2221 34.7627L31.9902 37.0478L34.3779 37.0489Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M34.6361 37.2079H31.7241L33.2222 34.4204L34.6361 37.2079ZM32.2565 36.8887H34.1198L33.2176 35.1049L32.2565 36.8887Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M37.2277 41.649C38.1346 41.649 38.8698 40.9139 38.8698 40.007C38.8698 39.1001 38.1346 38.3649 37.2277 38.3649C36.3208 38.3649 35.5856 39.1001 35.5856 40.007C35.5856 40.9139 36.3208 41.649 37.2277 41.649Z',
          fill: '#F7DDE4'
        }),
        ue.createElement('path', {
          d: 'M21.6538 42.0731C22.5607 42.0731 23.2959 41.3379 23.2959 40.431C23.2959 39.5241 22.5607 38.7889 21.6538 38.7889C20.7469 38.7889 20.0117 39.5241 20.0117 40.431C20.0117 41.3379 20.7469 42.0731 21.6538 42.0731Z',
          fill: '#F7EBE4'
        }),
        ue.createElement('path', {
          d: 'M25.3354 42.6643C25.3354 41.5823 27.1619 40.7053 29.4147 40.7053C31.6676 40.7053 33.4929 41.5823 33.4929 42.6643C33.4929 43.7464 31.6007 42.7968 29.3445 42.7968C27.0882 42.7968 25.3354 43.7475 25.3354 42.6643Z',
          fill: '#C9D1E5'
        }),
        ue.createElement('path', {
          d: 'M46.5432 34.1024C46.3172 34.1143 46.1002 34.1947 45.9209 34.3329C45.9209 34.3329 45.9106 34.3398 45.9083 34.3433C45.3194 34.7754 44.764 35.8413 44.2616 37.5237C43.4549 40.1914 42.9836 43.6934 42.7635 45.5429C42.6713 46.3599 42.6045 47.0628 42.5596 47.6309C42.5316 48.0269 42.3546 48.3976 42.0642 48.6683C41.7738 48.939 41.3917 49.0896 40.9947 49.0898H18.0504C17.6435 49.0886 17.2529 48.9303 16.96 48.648C16.6671 48.3656 16.4946 47.981 16.4786 47.5745C16.4474 46.8946 16.4094 46.2308 16.3633 45.5982C16.1248 42.223 15.68 39.5058 15.0439 37.5191C14.3525 35.3666 13.5885 34.6037 13.2197 34.3629C13.2063 34.3453 13.1889 34.3311 13.169 34.3214C13.169 34.3214 13.1598 34.3214 13.1564 34.3145C13.0596 34.2442 12.9494 34.1947 12.8325 34.1693C12.7917 34.1628 12.7499 34.1724 12.716 34.196C12.6821 34.2197 12.6586 34.2555 12.6505 34.296C12.6446 34.3372 12.6545 34.3791 12.6782 34.4133C12.7019 34.4476 12.7377 34.4715 12.7784 34.4804C12.8549 34.5046 12.9269 34.5412 12.9916 34.5887L13.01 34.5979L13.0192 34.6072C13.0368 34.6189 13.0537 34.6316 13.0699 34.6452C13.4421 34.9125 14.107 35.65 14.7385 37.6136C15.37 39.5772 15.8102 42.2702 16.0453 45.6236C16.0902 46.2493 16.1282 46.9107 16.1605 47.5825C16.1793 48.0713 16.3863 48.5339 16.7383 48.8734C17.0904 49.213 17.5601 49.4033 18.0492 49.4044H40.9947C41.4732 49.4059 41.9344 49.2254 42.2849 48.8995C42.6354 48.5737 42.8489 48.1268 42.8822 47.6494C42.9237 47.0813 42.9975 46.3818 43.085 45.5752C43.2982 43.7314 43.7764 40.2513 44.5669 37.6079C45.0279 36.0856 45.5107 35.0934 46.0154 34.6613C46.0411 34.6357 46.0689 34.6122 46.0984 34.591C46.2304 34.4868 46.3914 34.4261 46.5593 34.417C46.6016 34.4152 46.6415 34.3968 46.6702 34.3657C46.6989 34.3346 46.7142 34.2934 46.7126 34.2511C46.7118 34.23 46.7066 34.2094 46.6976 34.1903C46.6885 34.1713 46.6756 34.1543 46.6598 34.1404C46.6439 34.1265 46.6254 34.116 46.6054 34.1095C46.5854 34.1029 46.5642 34.1005 46.5432 34.1024Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M31.8785 25.1867L31.7195 25.1774V29.9827H27.2703V25.1705L27.1113 25.1809C27.0571 25.1809 27.0064 25.1809 26.9523 25.1936V30.1417C26.9523 30.1839 26.969 30.2244 26.9988 30.2542C27.0287 30.284 27.0691 30.3008 27.1113 30.3008H31.8785C31.9205 30.3002 31.9606 30.2832 31.9903 30.2535C32.02 30.2238 32.037 30.1837 32.0376 30.1417V25.1993C31.9834 25.1936 31.9327 25.1901 31.8785 25.1867Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M25.7239 32.0098C25.7239 32.0098 24.946 34.3456 22.359 34.4297',
          stroke: '#7386F3',
          strokeMiterlimit: '10',
          strokeLinecap: 'round'
        }),
        ue.createElement('path', {
          d: 'M32.7059 32.0098C32.7059 32.0098 33.4838 34.3456 36.0708 34.4297',
          stroke: '#7386F3',
          strokeMiterlimit: '10',
          strokeLinecap: 'round'
        }),
        ue.createElement('path', {
          d: 'M13.2519 34.0667C13.2519 34.0667 13.0399 34.7316 12.9523 35.1233L12.5559 34.2084L13.2519 34.0667Z',
          fill: '#E85B46'
        }),
        ue.createElement('path', {
          d: 'M45.9209 34.3306L46.0154 34.6647L46.0557 34.7177L46.701 34.5195L46.7932 34.1266L46.4971 33.8961L45.9209 34.3306Z',
          fill: '#E85B46'
        })
      )
    }),
    xP = ['size'],
    EP = xS(function (e, t) {
      var n = void 0 === (n = e.size) ? 59 : n
      e = Hu(e, xP)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: n, height: n, viewBox: '0 0 59 59', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M50.8184 49.7317C50.725 49.8308 50.6271 49.9241 50.5326 50.0209C50.3828 50.1776 50.2341 50.3298 50.0786 50.4819C50.0714 50.4897 50.0637 50.497 50.0555 50.5038C49.9403 50.619 49.817 50.7342 49.6995 50.8495C48.0349 52.4195 46.1929 53.79 44.2108 54.9334C44.204 54.9383 44.1967 54.9426 44.189 54.946L44.068 55.0129C43.766 55.1811 43.4641 55.3494 43.1553 55.5084L43.0481 55.566C42.714 55.7377 42.3775 55.9025 42.0341 56.065C41.3427 56.3892 40.6359 56.6869 39.9138 56.958C39.2915 57.1954 38.6554 57.4086 38.0135 57.6034C37.8799 57.6471 37.7462 57.6852 37.6125 57.7186C31.4735 59.4572 24.9357 59.1527 18.9849 56.8509L18.9561 56.8416C17.5942 56.3104 16.2738 55.6783 15.0059 54.9507C14.9989 54.9507 14.9955 54.9437 14.9897 54.9437L14.9482 54.9207C14.6498 54.749 14.3571 54.575 14.0644 54.3872C12.0384 53.1175 10.174 51.6065 8.5124 49.8873C8.50318 49.8769 8.48935 49.8642 8.48013 49.855C8.47091 49.8458 8.43865 49.8101 8.41675 49.7882C3.18695 44.3407 0.270688 37.0792 0.280052 29.5276C0.280052 13.3441 13.4006 0.220093 29.5876 0.220093C45.7746 0.220093 58.894 13.3441 58.894 29.5276C58.9056 37.0512 56.0127 44.2889 50.8184 49.7317Z',
          fill: '#FFAC4A'
        }),
        ue.createElement('path', {
          d: 'M50.5293 50.021C50.3794 50.1777 50.2308 50.3298 50.0752 50.4819C50.0681 50.4897 50.0604 50.4971 50.0522 50.5038C49.9369 50.619 49.8136 50.7343 49.6961 50.8495C48.0315 52.4195 46.1896 53.7901 44.2075 54.9334C44.2007 54.9384 44.1933 54.9426 44.1856 54.9461L44.0646 55.0129C43.7627 55.1846 43.4608 55.3494 43.1519 55.5119L43.0448 55.5695C42.7106 55.7412 42.3741 55.906 42.0307 56.0685C41.3393 56.3927 40.6325 56.6903 39.9104 56.9615C39.2881 57.1989 38.652 57.4121 38.0102 57.6068C37.8765 57.6506 37.7428 57.6887 37.6092 57.7221C31.4702 59.4607 24.9323 59.1562 18.9815 56.8544L18.9527 56.8451C17.5908 56.3139 16.2704 55.6818 15.0025 54.9541L14.9864 54.9449C14.9737 54.9357 14.9576 54.9299 14.9449 54.9196C14.6464 54.7479 14.3537 54.5739 14.061 54.386C12.035 53.1164 10.1707 51.6054 8.50903 49.8861C9.43091 46.6538 13.1184 46.1099 13.5206 46.0627L13.4929 45.891L12.7105 41.0373C12.3851 38.9292 12.5084 36.7762 13.0723 34.719C13.0884 34.6648 13.1046 34.6038 13.1207 34.553C13.1368 34.5023 13.1518 34.4482 13.1714 34.394C13.5717 33.0527 14.2065 31.7929 15.0463 30.6731C15.6603 29.8608 16.3808 29.1348 17.1885 28.5148L14.4044 15.9024L16.1018 15.4829L19.3088 27.1884C21.2574 26.2066 23.7557 25.5037 26.9523 25.2721C27.0065 25.2663 27.0572 25.2629 27.1113 25.2594L27.2703 25.2502C27.9617 25.2018 28.6716 25.1799 29.4218 25.1799C30.2284 25.1799 30.989 25.2052 31.7195 25.2559L31.8786 25.2663C31.9327 25.2663 31.9834 25.2721 32.0376 25.279C35.3909 25.529 37.9745 26.2769 39.9646 27.3129L43.137 15.718L44.8332 16.1328L42.0676 28.6646C42.7754 29.2263 43.4134 29.8708 43.9678 30.5844C44.49 31.2564 44.9334 31.9859 45.2895 32.7588C45.3276 32.8384 45.3667 32.9179 45.3979 32.9974C45.4843 33.1875 45.5638 33.3788 45.6283 33.5736C45.6606 33.6588 45.6917 33.7418 45.7205 33.8248C45.7908 34.0184 45.8542 34.2085 45.9118 34.4009C45.9279 34.4551 45.9429 34.5162 45.9591 34.5657L46.0063 34.734C46.042 34.8619 46.0731 34.9852 46.1019 35.1096C46.125 35.1984 46.1434 35.2871 46.163 35.3758C46.1826 35.4646 46.201 35.551 46.2172 35.6374C46.2448 35.7768 46.2702 35.9163 46.2932 36.0569C46.3948 36.6548 46.4564 37.2588 46.4776 37.8649C46.4776 37.9352 46.4776 38.002 46.4776 38.0688C46.5071 38.8585 46.4604 39.6493 46.3382 40.43L45.5684 45.6328L45.4866 46.1894C45.4915 46.1883 45.4966 46.1883 45.5016 46.1894C45.9176 46.2459 49.6039 46.7852 50.5293 50.021Z',
          fill: 'white'
        }),
        ue.createElement('path', {
          d: 'M14.8608 16.7227C16.1775 16.7227 17.245 15.6553 17.245 14.3385C17.245 13.0218 16.1775 11.9543 14.8608 11.9543C13.544 11.9543 12.4766 13.0218 12.4766 14.3385C12.4766 15.6553 13.544 16.7227 14.8608 16.7227Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M44.3791 16.7227C45.6958 16.7227 46.7633 15.6553 46.7633 14.3385C46.7633 13.0218 45.6958 11.9543 44.3791 11.9543C43.0623 11.9543 41.9949 13.0218 41.9949 14.3385C41.9949 15.6553 43.0623 16.7227 44.3791 16.7227Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M46.3532 40.4357L45.5834 45.6386L45.5016 46.1952L44.8943 50.3171L44.8528 50.5844L44.2075 54.9288C44.2007 54.9337 44.1933 54.938 44.1856 54.9414L44.0646 55.0083C43.7627 55.1765 43.4608 55.3448 43.1519 55.5038L43.0448 55.5614C42.7106 55.7331 42.3741 55.8979 42.0307 56.0604C41.3393 56.3846 40.6325 56.6822 39.9104 56.9534C40.1201 54.4183 40.3241 51.8958 40.5085 49.5669L40.5177 49.4805V49.4644L40.5269 49.3215V49.2996C40.5269 49.2546 40.5269 49.2074 40.5396 49.1624C40.5592 48.9216 40.5741 48.6831 40.5972 48.4514L40.6479 47.8499C40.664 47.6529 40.679 47.4627 40.6986 47.2737C41.1215 42.8245 42.0434 40.6028 42.2301 38.4157V38.3811C42.2589 38.0354 42.2773 37.7104 42.2877 37.3959C42.2877 37.3325 42.2877 37.2691 42.2934 37.2023C42.3822 34.6176 42.0872 33.0665 43.9655 30.5844C44.4876 31.2563 44.9311 31.9859 45.2872 32.7588C45.3253 32.8383 45.3644 32.9178 45.3956 32.9974C45.482 33.1875 45.5615 33.3788 45.626 33.5735C45.6583 33.6588 45.6894 33.7418 45.7182 33.8247C45.7885 34.0183 45.8519 34.2085 45.9095 34.4009C45.9256 34.4551 45.9406 34.5161 45.9567 34.5657L46.004 34.7339C46.0397 34.8619 46.0708 34.9852 46.0996 35.1096C46.1227 35.1983 46.1411 35.2871 46.1607 35.3758C46.1803 35.4645 46.1987 35.551 46.2149 35.6374C46.2425 35.7768 46.2679 35.9162 46.2909 36.0568C46.3925 36.6547 46.4541 37.2588 46.4753 37.8649C46.4753 37.9352 46.4753 38.002 46.4753 38.0688C46.5109 38.8599 46.47 39.6525 46.3532 40.4357Z',
          fill: '#D8DDEE'
        }),
        ue.createElement('path', {
          d: 'M18.9526 56.8451C17.5907 56.3139 16.2703 55.6818 15.0023 54.9541C14.9827 54.9449 14.9643 54.9322 14.9447 54.9219L13.4928 45.8933L12.7103 41.0396C12.3768 38.8739 12.5167 36.6617 13.1206 34.5554C13.5212 33.1557 14.1738 31.8409 15.0461 30.6754C16.7182 33.0458 16.5015 34.6003 16.5684 37.0663C16.5684 37.1746 16.5753 37.2887 16.5787 37.4005C16.5914 37.7404 16.6099 38.0919 16.6421 38.471V38.5067C16.8265 40.6904 17.7126 42.9087 18.1609 47.2438C18.1667 47.3256 18.177 47.4086 18.1828 47.4916C18.2058 47.722 18.2277 47.9686 18.2496 48.2129L18.3003 48.8237C18.313 48.9689 18.3257 49.1129 18.3361 49.2558C18.3361 49.2777 18.3361 49.303 18.3361 49.3249C18.3453 49.4459 18.3557 49.5692 18.3649 49.6902L18.3868 49.9703C18.5677 52.1482 18.759 54.4874 18.9526 56.8451Z',
          fill: '#D8DDEE'
        }),
        ue.createElement('path', {
          d: 'M26.565 37.1251L25.4081 34.8389L24.1774 37.1228L26.565 37.1251Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M26.8231 37.284H23.9111L25.4092 34.4977L26.8231 37.284ZM24.4435 36.9637H26.3057L25.4034 35.1799L24.4435 36.9637Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M34.3779 37.1251L33.2221 34.8389L31.9902 37.1228L34.3779 37.1251Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M34.6361 37.284H31.7241L33.2222 34.4977L34.6361 37.284ZM32.2565 36.9637H34.1198L33.2176 35.1799L32.2565 36.9637Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M37.2277 41.7252C38.1346 41.7252 38.8698 40.99 38.8698 40.0831C38.8698 39.1762 38.1346 38.441 37.2277 38.441C36.3208 38.441 35.5856 39.1762 35.5856 40.0831C35.5856 40.99 36.3208 41.7252 37.2277 41.7252Z',
          fill: '#F7EBE4'
        }),
        ue.createElement('path', {
          d: 'M21.6537 42.1493C22.5606 42.1493 23.2958 41.4141 23.2958 40.5072C23.2958 39.6003 22.5606 38.8651 21.6537 38.8651C20.7468 38.8651 20.0116 39.6003 20.0116 40.5072C20.0116 41.4141 20.7468 42.1493 21.6537 42.1493Z',
          fill: '#F7EBE4'
        }),
        ue.createElement('path', {
          d: 'M46.5431 34.1774C46.3172 34.1899 46.1004 34.2702 45.9208 34.4078C45.9162 34.4102 45.9119 34.4134 45.9082 34.4171C45.3193 34.8492 44.7639 35.9151 44.2615 37.5987C43.4548 40.2652 42.9835 43.7672 42.7634 45.6178C42.6712 46.4337 42.6044 47.1366 42.5595 47.7059C42.532 48.1031 42.3546 48.475 42.0632 48.7463C41.7717 49.0176 41.3881 49.168 40.99 49.1671H18.0503C17.6432 49.1659 17.2524 49.0074 16.9595 48.7248C16.6666 48.4422 16.4942 48.0573 16.4785 47.6506C16.4473 46.9707 16.4093 46.3058 16.3632 45.6732C16.1247 42.2979 15.6799 39.5807 15.0438 37.5941C14.3524 35.4426 13.5884 34.6798 13.2196 34.4378C13.2056 34.4208 13.1884 34.4067 13.1689 34.3963C13.1689 34.3963 13.1597 34.3963 13.1563 34.3906C13.0594 34.3202 12.9492 34.2704 12.8324 34.2442C12.812 34.2407 12.7911 34.2412 12.7709 34.2457C12.7506 34.2502 12.7315 34.2587 12.7145 34.2706C12.6803 34.2947 12.657 34.3314 12.6498 34.3727C12.6426 34.414 12.6521 34.4564 12.6762 34.4906C12.7003 34.5249 12.737 34.5482 12.7783 34.5553C12.8545 34.5802 12.9264 34.6168 12.9915 34.6637L13.0099 34.6729L13.0191 34.6833C13.0372 34.6942 13.0542 34.707 13.0698 34.7213C13.442 34.9875 14.1069 35.725 14.7384 37.6897C15.3699 39.6545 15.8101 42.3463 16.0452 45.6985C16.0901 46.3254 16.1282 46.9857 16.1604 47.6633C16.1794 48.1518 16.3866 48.6141 16.7386 48.9534C17.0906 49.2927 17.5602 49.4828 18.0491 49.484H40.9946C41.473 49.4857 41.9342 49.3055 42.2847 48.9798C42.6352 48.6541 42.8488 48.2074 42.8821 47.7301C42.9236 47.1608 42.9973 46.4625 43.0849 45.6559C43.2981 43.8121 43.7763 40.332 44.5668 37.6874C45.0278 36.1652 45.5106 35.173 46.0153 34.7409C46.0408 34.7153 46.0685 34.6921 46.0983 34.6717C46.2299 34.5667 46.3911 34.5054 46.5592 34.4966C46.6015 34.4948 46.6414 34.4763 46.6701 34.4452C46.6988 34.4141 46.7141 34.3729 46.7125 34.3306C46.7123 34.3092 46.7076 34.288 46.6988 34.2684C46.69 34.2489 46.6772 34.2314 46.6613 34.217C46.6454 34.2026 46.6267 34.1916 46.6063 34.1848C46.586 34.178 46.5645 34.1755 46.5431 34.1774Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M31.8784 25.2628L31.7194 25.2525V30.0589H27.2702V25.2467L27.1112 25.2559C27.057 25.2559 27.0063 25.2628 26.9521 25.2686V30.2168C26.9521 30.2589 26.9689 30.2994 26.9987 30.3292C27.0285 30.359 27.069 30.3758 27.1112 30.3758H31.8784C31.9204 30.3752 31.9605 30.3582 31.9902 30.3286C32.0199 30.2989 32.0368 30.2588 32.0374 30.2168V25.2755C31.9833 25.2686 31.9326 25.2651 31.8784 25.2628Z',
          fill: '#7386F3'
        }),
        ue.createElement('path', {
          d: 'M29.5681 44.0449C30.3363 44.0449 30.959 42.9615 30.959 41.625C30.959 40.2885 30.3363 39.2051 29.5681 39.2051C28.8 39.2051 28.1772 40.2885 28.1772 41.625C28.1772 42.9615 28.8 44.0449 29.5681 44.0449Z',
          fill: '#C9D1E5'
        }),
        ue.createElement('path', {
          d: 'M22.9202 33.3396C22.9202 33.3396 24.8791 30.3965 27.0087 33.1218',
          stroke: '#7386F3',
          strokeMiterlimit: '10',
          strokeLinecap: 'round'
        }),
        ue.createElement('path', {
          d: 'M35.4922 33.3396C35.4922 33.3396 33.5332 30.3965 31.4037 33.1218',
          stroke: '#7386F3',
          strokeMiterlimit: '10',
          strokeLinecap: 'round'
        }),
        ue.createElement('path', {
          d: 'M13.1714 34.3963L13.0723 34.7212L12.7934 34.659L12.4362 34.5023L12.5399 34.1715L12.8187 34.1681L13.1714 34.3963Z',
          fill: '#FFAC4A'
        }),
        ue.createElement('path', {
          d: 'M45.9209 34.4067L46.0154 34.7397L46.7679 34.4401L46.6745 34.1405L46.2747 34.0645L45.9209 34.4067Z',
          fill: '#FFAC4A'
        })
      )
    }),
    SP = ['color', 'size'],
    OP = xS(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 12 : r
      e = Hu(e, SP)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 55 55', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M3.40256 25.4517C2.58445 24.1661 3.05194 21.8287 4.45442 20.8937C5.85689 19.9587 8.31122 20.5431 9.24621 21.5949L19.6479 36.0872L40.685 4.41461C41.62 3.01213 43.9575 2.42777 45.5937 3.71337C46.7624 4.64835 47.4636 6.28457 46.6455 7.68705L21.6347 45.437C20.5829 46.6057 18.8298 46.6057 17.7779 45.437L3.40256 25.4517Z',
          fill: n
        })
      )
    }),
    kP = ['color', 'size'],
    PP = xS(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, kP)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M29.9081 25.0577L45.8451 9.12074C46.5381 8.42782 46.8845 7.61942 46.8845 6.58005C46.8845 5.54068 46.5381 4.73228 45.8451 4.03937C44.4593 2.65354 42.1496 2.65354 40.8793 4.03937L24.9423 20.0919L9.00525 4.15486C7.61942 2.76903 5.4252 2.76903 4.03937 4.15486C3.34646 4.84777 3 5.65617 3 6.58005C3 7.50394 3.34646 8.42782 4.03937 9.12074L19.9764 25.0577L4.03937 40.9948C3.34646 41.6877 3 42.4961 3 43.42C3 44.3438 3.34646 45.2677 4.03937 45.9606C5.4252 47.3465 7.73491 47.3465 9.00525 45.9606L24.9423 30.0236L40.8793 45.9606C41.5722 46.6535 42.3806 47 43.42 47C44.4593 47 45.2677 46.6535 45.9606 45.9606C46.6535 45.2677 47 44.4593 47 43.42C47 42.3806 46.6535 41.5722 45.9606 40.8793L29.9081 25.0577Z',
          fill: n
        })
      )
    }),
    _P = ['color', 'size'],
    LP = xS(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, _P)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M43.0081 15.2287L36.7869 17.6214L28.935 29.9601C30.5809 33.9266 30.3662 38.0903 27.1408 41.3158L26.5656 41.8909C25.9554 42.5011 24.9661 42.5011 24.3559 41.8909L14.4122 31.9472L2.99211 43.3673C2.38192 43.9775 1.3926 43.9775 0.782403 43.3673C0.17221 42.7571 0.172211 41.7678 0.782403 41.1576L12.2025 29.7375L2.25883 19.7938C1.64864 19.1836 1.64864 18.1943 2.25883 17.5841L2.50512 17.3378C5.73058 14.1123 10.2231 13.5688 14.1897 15.2147L26.5283 7.36283L28.9211 1.14165C29.327 0.0863053 30.6847 -0.201832 31.4843 0.597706L43.552 12.6655C44.3516 13.465 44.0634 14.8228 43.0081 15.2287ZM29.0752 9.44618L30.9747 4.50752L39.6422 13.1751L34.7035 15.0745L25.4251 29.655L26.0486 31.1577C27.234 34.0146 27.0773 36.5309 25.4342 38.5498L5.64209 18.7576C7.75439 17.2384 10.4304 17.0382 12.992 18.1011L14.4948 18.7246L29.0752 9.44618Z',
          fill: n
        })
      )
    }),
    TP = ['color', 'size'],
    IP = xS(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, TP)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M15.75 17.3125C15.75 16.4496 16.4496 15.75 17.3125 15.75C18.1754 15.75 18.875 16.4496 18.875 17.3125L18.875 32.9375C18.875 33.8005 18.1754 34.5 17.3125 34.5C16.4496 34.5 15.75 33.8005 15.75 32.9375L15.75 17.3125Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M26.6875 15.75C25.8246 15.75 25.125 16.4496 25.125 17.3125L25.125 32.9375C25.125 33.8005 25.8246 34.5 26.6875 34.5C27.5504 34.5 28.25 33.8005 28.25 32.9375V17.3125C28.25 16.4496 27.5504 15.75 26.6875 15.75Z',
          fill: n
        }),
        ue.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M12.625 6.37503V3.25003C12.625 1.52414 14.0241 0.125031 15.75 0.125031H28.25C29.9759 0.125031 31.375 1.52414 31.375 3.25003V6.37503H42.3125C43.1754 6.37503 43.875 7.07459 43.875 7.93753C43.875 8.80048 43.1754 9.50003 42.3125 9.50003H39.1875V40.75C39.1875 42.4759 37.7884 43.875 36.0625 43.875H7.9375C6.21161 43.875 4.8125 42.4759 4.8125 40.75V9.50003L1.6875 9.50003C0.824554 9.50003 0.125 8.80048 0.125 7.93753C0.125 7.07459 0.824555 6.37503 1.6875 6.37503H12.625ZM15.75 3.25003H28.25V6.37503H15.75V3.25003ZM7.9375 9.50003L7.9375 40.75H36.0625V9.50003H7.9375Z',
          fill: n
        })
      )
    }),
    MP =
      (r((ug = {}), TS.Sm, function (e) {
        return Yf(['padding:4px 8px;height:24px;', ''], e.theme.typography.font[fg.InputSm])
      }),
      r(ug, TS.Md, function (e) {
        return Yf(['padding:8px 12px;height:30px;', ''], e.theme.typography.font[fg.InputMd])
      }),
      ug),
    jP =
      ((Og = 'Input'),
      (mg = c.span.attrs({ className: Ap(Og, 'Icon') }).withConfig({ componentId: 'sc-150k0cz-0' })(function (e) {
        var t = e.iconClickStart,
          n = e.iconClickEnd,
          r = e.clearIconClick
        return Yf(
          ['display:flex;color:', ';cursor:', ';&:first-child{margin-right:7px;}&:last-child{margin-left:10px;}'],
          e.theme.palette[dg.IconsPrimary],
          t || n || r ? 'pointer' : 'default'
        )
      })),
      Hp({
        Input: c.div.attrs({ className: Ap(Og, 'root') }).withConfig({ componentId: 'sc-150k0cz-1' })(function (e) {
          var t = void 0 === (t = e.size) ? TS.Md : t,
            n = e.error,
            r = e.fullWidth,
            i = e.theme
          return Yf(
            [
              'position:relative;display:inline-flex;align-items:center;cursor:text;width:',
              ';background:',
              ';border:1px solid ',
              ';border-radius:',
              ';box-sizing:border-box;color:',
              ';',
              ' &:focus-within{background-color:',
              '!important;border:1px solid ',
              ';}&:hover{background-color:',
              ';}',
              ''
            ],
            void 0 !== r && r ? '100%' : '300px',
            'primary' === (void 0 === (e = e.background) ? _S.Primary : e)
              ? i.palette[dg.BackgroundPrimary]
              : i.palette[dg.BackgroundSecondary],
            i.palette[dg.BordersSecondary],
            i.shape.borderRadius[hg.Sm],
            i.palette[dg.TextPrimary],
            MP[t],
            i.palette[dg.BackgroundSecondary],
            i.palette[dg.AccentPrimary],
            i.palette[dg.BackgroundPrimaryHover],
            void 0 !== n && n && uk
          )
        }),
        Container: c.div.attrs({ className: Ap(Og, 'Container') }).withConfig({ componentId: 'sc-150k0cz-2' })(
          function () {
            return Yf([
              'display:block;color:inherit;width:100%;min-width:0;margin:0;padding:0;border:0;background-color:transparent;outline:none;'
            ])
          }
        ),
        Tags: c.div.attrs({ className: Ap(Og, 'Tags') }).withConfig({ componentId: 'sc-150k0cz-3' })(function () {
          return Yf([
            'display:inline;color:inherit;width:max-content;min-width:0;margin:0;padding:0;border:0;background-color:transparent;outline:none;'
          ])
        }),
        Base: c.input.attrs({ className: Ap(Og, 'Base') }).withConfig({ componentId: 'sc-150k0cz-4' })(function (e) {
          return Yf(
            [
              'display:block;color:inherit;width:100%;min-width:0;margin:0;padding:0;border:0;background-color:transparent;outline:none;&::placeholder{color:',
              ';}'
            ],
            e.theme.palette[dg.TextPlaceholder]
          )
        }),
        Icon: mg
      })),
    RP =
      ((f = 'Select'),
      (Qy = c.span.attrs({ className: Ap(f, 'Icon') }).withConfig({ componentId: 'sc-mfrapg-0' })(function (e) {
        return Yf(['display:flex;flex-shrink:0;color:', ';'], e.theme.palette[dg.IconsPrimary])
      })),
      (dS = c.div.attrs({ className: Ap(f, 'Container') }).withConfig({ componentId: 'sc-mfrapg-1' })(function (e) {
        return Yf(
          ['position:relative;display:inline-flex;', ''],
          void 0 !== (e = e.fullWidth) && e ? 'width: 100%' : ''
        )
      })),
      (Jy = c(jP.Input)
        .attrs({ className: Ap(f, 'root') })
        .withConfig({ componentId: 'sc-mfrapg-2' })(function (e) {
        var t = e.theme.palette
        return Yf(
          ['cursor:pointer;user-select:none;background:', ';'],
          'primary' === (void 0 === (e = e.background) ? _S.Primary : e)
            ? t[dg.BackgroundPrimary]
            : t[dg.BackgroundSecondary]
        )
      })),
      (oC = c.label.attrs({ className: Ap(f, 'Label') }).withConfig({ componentId: 'sc-mfrapg-3' })([
        'flex-grow:1;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;'
      ])),
      (aC = c.span.attrs({ className: Ap(f, 'Placeholder') }).withConfig({ componentId: 'sc-mfrapg-4' })(function (e) {
        return Yf(['width:100%;color:', ';'], e.theme.palette[dg.TextPlaceholder])
      })),
      Hp({
        Container: dS,
        Select: Jy,
        Label: oC,
        Icon: Qy,
        Input: c.input
          .attrs({ className: Ap(f, 'Input'), 'aria-hidden': 'true', tabindex: '-1' })
          .withConfig({ componentId: 'sc-mfrapg-5' })([
          'left:0;width:100%;bottom:0;opacity:0;position:absolute;pointer-events:none;box-sizing:border-box;'
        ]),
        Placeholder: aC
      }))
  function DP(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function AP(e) {
    if (e && e.children) {
      for (var t = e.children; 'string' != typeof t; ) t = zP(t)
      return t
    }
  }
  var zP = function t(n) {
      return (
        (n = n.props ? n.props.children : n),
        Array.isArray(n) ? n.map(t).join(' ') : 'object' === e(n) ? t(n.props.children) : n
      )
    },
    NP = [
      'children',
      'size',
      'error',
      'multiple',
      'onChange',
      'value',
      'fullWidth',
      'selectProps',
      'MenuProps',
      'readOnly',
      'disabled',
      'placeholder',
      'background',
      'renderLabel'
    ],
    FP =
      ((iC = zp(function (e, t) {
        function n() {
          return w(void 0)
        }
        var i = e.children,
          o = e.size,
          a = e.error,
          l = e.multiple,
          c = e.onChange,
          u = e.value,
          d = e.fullWidth,
          f = e.selectProps,
          h = e.MenuProps,
          p = e.readOnly,
          g = e.disabled,
          m = e.placeholder,
          v = e.background,
          y = e.renderLabel,
          b = ((e = Hu(e, NP)), (C = Lg(s.exports.useState(void 0), 2))[0]),
          w = C[1],
          C = Boolean(b)
        return ue.createElement(
          RP.Container,
          { ref: t, fullWidth: Boolean(d) },
          ue.createElement(
            RP.Select,
            Tg({}, e, {
              size: o,
              background: v,
              error: a,
              fullWidth: Boolean(d),
              readOnly: p,
              onClick:
                p || g
                  ? void 0
                  : function (e) {
                      return w(e.currentTarget)
                    }
            }),
            ue.createElement(
              RP.Label,
              null,
              'function' == typeof y
                ? y(u)
                : (function (e) {
                    var t = e.value,
                      n = void 0 !== (n = e.multiple) && n,
                      i = ((e = e.children), [])
                    return (
                      ue.Children.forEach(e, function (e) {
                        ue.isValidElement(e) &&
                          'MenuItem' === (null == e ? void 0 : e.type).displayName &&
                          Boolean(e.props) &&
                          i.push(
                            (function (e) {
                              for (var t = 1; t < arguments.length; t++) {
                                var n = null != arguments[t] ? arguments[t] : {}
                                t % 2
                                  ? DP(Object(n), !0).forEach(function (t) {
                                      r(e, t, n[t])
                                    })
                                  : Object.getOwnPropertyDescriptors
                                  ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
                                  : DP(Object(n)).forEach(function (t) {
                                      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
                                    })
                              }
                              return e
                            })({}, e.props)
                          )
                      }),
                      0 <
                      (e = n
                        ? i.filter(function (e) {
                            return Array.isArray(t) && t.includes(e.value)
                          })
                        : [
                            i.find(function (e) {
                              return e.value === t
                            })
                          ]).length
                        ? e.map(AP).join(', ')
                        : Array.isArray(t)
                        ? t.join(', ')
                        : t
                    )
                  })({ value: u, multiple: l, children: i })
            ),
            !u && ue.createElement(RP.Placeholder, null, m),
            ue.createElement(
              RP.Icon,
              null,
              ue.createElement(vO, { type: C ? 'top' : 'bottom', IconProps: { size: 8 } })
            ),
            ue.createElement(RP.Input, f)
          ),
          ue.createElement(
            CS,
            Tg({ onClose: n, open: C, anchorEl: b }, h),
            ue.Children.map(i, function (e) {
              return (function (e, t) {
                var n,
                  r,
                  i = t.value,
                  o = void 0 !== (a = t.multiple) && a,
                  a = void 0 === (a = t.size) ? TS.Md : a,
                  l = t.onClose,
                  s = t.onChange
                return ue.isValidElement(e)
                  ? 'MenuItem' !== (null == (t = e.type) ? void 0 : t.displayName)
                    ? ue.cloneElement(e)
                    : ((r = null == e || null == (t = e.props) ? void 0 : t.value),
                      (t = 0 < (t = o ? (Array.isArray(i) ? i : []) : [i]).length && t.includes(r)),
                      ue.cloneElement(e, {
                        active: t,
                        size: a,
                        children: (function (e) {
                          var t = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : TS.Md
                          if ((r = 1 < arguments.length && void 0 !== arguments[1] && arguments[1]) && e) {
                            var n,
                              r = ue.createElement(hO, null, ue.createElement(OP, { size: t === TS.Md ? 11 : 9 }))
                            if (1 === ue.Children.count(e))
                              return (
                                ue.isValidElement((t = e)) &&
                                  'MenuItemLabel' !== (null == e || null == (n = e.type) ? void 0 : n.displayName) &&
                                  (t = ue.createElement(dO, null, e)),
                                ue.createElement(ue.Fragment, null, t, r)
                              )
                            if (
                              1 < ue.Children.count(e) &&
                              !ue.Children.toArray(e).some(function (e) {
                                return (
                                  'MenuItemActions' === (null == e || null == (e = e.type) ? void 0 : e.displayName)
                                )
                              })
                            )
                              return ue.createElement(ue.Fragment, null, e, r)
                          }
                          return e
                        })(null == e || null == (n = e.props) ? void 0 : n.children, t, a),
                        onClick: function () {
                          var e, t
                          o || 'function' != typeof l || l(),
                            'function' == typeof s &&
                              ((e = r),
                              o &&
                                (-1 < (t = (e = Dp(Array.isArray(i) ? i : [])).indexOf(r))
                                  ? e.splice(t, 1)
                                  : e.push(r)),
                              s(e))
                        }
                      }))
                  : e
              })(e, { value: u, multiple: l, size: o, onClose: n, onChange: p || g ? void 0 : c })
            })
          )
        )
      })),
      (cC = {
        size: TS.Md,
        error: !1,
        multiple: !1,
        fullWidth: !1,
        readOnly: !1,
        disabled: !1,
        background: _S.Primary
      }),
      (p = ((iC.defaultProps = cC), ce.oneOfType([ce.string, ce.number, ce.oneOf([null])]))),
      (rC = {
        size: ce.oneOf(Fp(TS)),
        error: ce.bool,
        multiple: ce.bool,
        fullWidth: ce.bool,
        children: ce.oneOfType([ce.element, ce.arrayOf(ce.element)]),
        value: ce.oneOfType([ce.string, ce.number, ce.oneOf([null]), ce.arrayOf(p)]),
        onChange: ce.func,
        MenuProps: ce.exact(wS),
        selectProps: ce.object,
        readOnly: ce.bool,
        disabled: ce.bool,
        background: ce.oneOf(Fp(_S)),
        renderLabel: ce.func
      }),
      (iC.propTypes = rC),
      iC),
    HP = [
      'children',
      'iconStart',
      'iconEnd',
      'clearIcon',
      'iconClickStart',
      'iconClickEnd',
      'clearIconClick',
      'size',
      'className',
      'style',
      'fullWidth',
      'readOnly',
      'background',
      'focusOnMount',
      'focusOnClick',
      'error'
    ],
    BP =
      ((y = zp(function (e, t) {
        function n(e, t) {
          return e
            ? ue.createElement(
                jP.Icon,
                {
                  onClick: function (e) {
                    return (n = t), y && x(), void ('start' === n ? l && l() : 'end' === n ? c && c() : u && u(e))
                    var n
                  },
                  iconClickStart: l,
                  iconClickEnd: c,
                  clearIconClick: u
                },
                'function' == typeof e ? e({ size: d === TS.Md ? 16 : 14 }) : e
              )
            : void 0
        }
        var r = e.children,
          i = e.iconStart,
          o = e.iconEnd,
          a = e.clearIcon,
          l = e.iconClickStart,
          c = e.iconClickEnd,
          u = e.clearIconClick,
          d = e.size,
          f = e.className,
          h = e.style,
          p = e.fullWidth,
          g = e.readOnly,
          m = void 0 === (m = e.background) ? 'primary' : m,
          v = void 0 !== (b = e.focusOnMount) && b,
          y = void 0 === (b = e.focusOnClick) || b,
          b = e.error,
          w = ((e = Hu(e, HP)), s.exports.useRef(null)),
          C = e.value ? '' : e.placeholder,
          x = function () {
            var e
            null != (e = w.current) && e.focus()
          }
        return (
          s.exports.useEffect(function () {
            v && x()
          }, []),
          ue.createElement(
            jP.Input,
            {
              onClick: y ? x : void 0,
              ref: t,
              size: d,
              className: f,
              style: h,
              fullWidth: Boolean(p),
              background: m,
              error: b
            },
            n(i, 'start'),
            ue.createElement(jP.Base, Tg({}, e, { placeholder: C, ref: w, readOnly: Boolean(g) })),
            n(a, 'secondEnd'),
            n(o, 'end'),
            r && ue.createElement(ue.Fragment, null, r)
          )
        )
      })),
      (h = { size: TS.Md, background: _S.Primary, error: !1, fullWidth: !1, readOnly: !1 }),
      (l =
        ((y.defaultProps = h),
        {
          size: ce.oneOf(Fp(TS)),
          iconStart: ce.oneOfType([ce.node, ce.func]),
          iconEnd: ce.oneOfType([ce.node, ce.func]),
          clearIcon: ce.node,
          error: ce.bool,
          fullWidth: ce.bool,
          value: ce.any,
          readOnly: ce.bool,
          iconClickStart: ce.func,
          iconClickEnd: ce.func,
          clearIconClick: ce.func,
          background: ce.oneOf(Fp(_S)),
          focusOnMount: ce.bool,
          focusOnClick: ce.bool
        })),
      (y.propTypes = l),
      y)
  function VP(e, t, n) {
    function r(e) {
      var t
      document.removeEventListener('mousemove', o),
        document.removeEventListener('mouseup', r),
        document.removeEventListener('mouseleave', r),
        document.removeEventListener('touchmove', o),
        document.removeEventListener('touchend', r),
        document.removeEventListener('touchcancel', r),
        'function' == typeof n && n((null == (t = e.touches) ? void 0 : t[0]) || e)
    }
    function i(e) {
      var n
      document.addEventListener('mousemove', o),
        document.addEventListener('mouseup', r),
        document.addEventListener('mouseleave', r),
        document.addEventListener('touchmove', o),
        document.addEventListener('touchend', r),
        document.addEventListener('touchcancel', r),
        'function' == typeof t && t((null == (n = e.touches) ? void 0 : n[0]) || e)
    }
    var o = function (t) {
      var n
      'function' == typeof e && e((null == (n = t.touches) ? void 0 : n[0]) || t)
    }
    return { onMouseDown: i, onTouchStart: i }
  }
  function WP(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  var GP = 'ColorPicker',
    ZP =
      ((ug = c.div.attrs({ className: Ap(GP, 'root') }).withConfig({ componentId: 'sc-qj4xo5-0' })(
        [
          'background-color:',
          ';box-shadow:0px 1px 2px rgba(78,77,77,0.15);border-radius:2px;padding:12px;max-width:200px;'
        ],
        function (e) {
          return e.theme.palette[dg.BackgroundSecondary]
        }
      )),
      (Og = c.div.attrs({ className: Ap(GP, 'icon') }).withConfig({ componentId: 'sc-qj4xo5-1' })([
        'display:flex;justify-content:space-between;align-items:center;cursor:pointer;'
      ])),
      (mg = c.div.attrs({ className: Ap(GP, 'range-picker') }).withConfig({ componentId: 'sc-qj4xo5-2' })(function (e) {
        return Yf(
          [
            'position:relative;border-radius:2px;width:186px;height:180px;user-select:none;cursor:crosshair;background-color:',
            ';'
          ],
          e.color
        )
      })),
      (dS = c.div.attrs({ className: Ap(GP, 'white-gradient') }).withConfig({ componentId: 'sc-qj4xo5-3' })([
        'background:linear-gradient(to right,white 0%,rgba(255,255,255,0) 100%);z-index:0;position:absolute;width:100%;height:100%;border-radius:2px;user-select:none;pointer-events:none;top:-1px;'
      ])),
      (Jy = c.div.attrs({ className: Ap(GP, 'black-gradient') }).withConfig({ componentId: 'sc-qj4xo5-4' })([
        'background:linear-gradient(to bottom,rgba(0,0,0,0) 0%,black 100%);z-index:1;position:absolute;width:100%;height:100%;border-radius:2px;user-select:none;pointer-events:none;'
      ])),
      (oC = c.span
        .attrs(function (e) {
          var t = void 0 === (t = e.left) ? 0 : t,
            n = void 0 === (n = e.top) ? 0 : n,
            i = void 0 !== (i = e.considerTopWidth) && i
          e = e.style
          return {
            className: Ap(GP, 'pointer'),
            style: (function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {}
                t % 2
                  ? WP(Object(n), !0).forEach(function (t) {
                      r(e, t, n[t])
                    })
                  : Object.getOwnPropertyDescriptors
                  ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
                  : WP(Object(n)).forEach(function (t) {
                      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
                    })
              }
              return e
            })({ left: t - 7, top: n - (i ? 7 : 0) }, e)
          }
        })
        .withConfig({ componentId: 'sc-qj4xo5-5' })(function (e) {
        return Yf(
          [
            'display:inline-block;box-sizing:border-box;width:15px;height:15px;border-radius:20px;box-shadow:0px 1px 2px rgba(78,77,77,0.15);border:2px solid ',
            ';background-color:',
            ';position:absolute;cursor:pointer;z-index:11;user-select:none;outline:none;'
          ],
          (e = e.theme).palette[dg.BackgroundSecondary],
          e.palette[dg.AccentPrimary]
        )
      })),
      (Qy = c.div.attrs({ className: Ap(GP, 'bar-wrapper') }).withConfig({ componentId: 'sc-qj4xo5-6' })([
        'margin-top:8px;position:relative;width:186px;height:12px;'
      ])),
      (f = c.table.attrs({ className: Ap(GP, 'bar') }).withConfig({ componentId: 'sc-qj4xo5-7' })([
        'border-radius:4px;width:100%;height:8px;border-collapse:collapse;'
      ])),
      (aC = c.td
        .attrs(function (e) {
          return (e = e.$color), { className: Ap(GP, 'stop'), style: { backgroundColor: e } }
        })
        .withConfig({ componentId: 'sc-qj4xo5-8' })([
        'padding:0;user-select:none;pointer-events:none;&:first-child{width:4px;border-top-left-radius:4px;border-bottom-left-radius:4px;}&:last-child{width:4px;border-top-right-radius:4px;border-bottom-right-radius:4px;}'
      ])),
      (cC = c.div.attrs({ className: Ap(GP, 'action') }).withConfig({ componentId: 'sc-qj4xo5-9' })([
        'display:flex;justify-content:space-between;align-items:center;'
      ])),
      (p = c.label.attrs({ className: Ap('ColorItem', 'label') }).withConfig({ componentId: 'sc-qj4xo5-10' })(function (
        e
      ) {
        var t = e.theme,
          n = e.size,
          r = e.color,
          i = e.stroke
        e = e.value
        return Yf(
          [
            'border-radius:2px;border:',
            ';box-sizing:border-box;width:',
            'px;height:',
            'px;background-color:',
            ';user-select:none;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:all 300ms;margin-bottom:8px;background:',
            ';input{display:none;}'
          ],
          '1px solid '.concat(i),
          n,
          n,
          r,
          'rgba(0,0,0,0)' === e &&
            'repeating-conic-gradient('.concat(t.palette[dg.LinkPrimary], ' 0% 25%, transparent 0% 50%) 50% / 8px 8px')
        )
      })),
      Hp({
        ColorPickerWrapper: ug,
        RangePickerWrapper: mg,
        WhiteGradient: dS,
        BlackGradient: Jy,
        ColorPointer: oC,
        BarWrapper: Qy,
        Bar: f,
        BarColorStop: aC,
        ColorPickerAction: cC,
        ColorPickerIcon: Og,
        ColorItemsContainer: c.div.withConfig({ componentId: 'sc-qj4xo5-11' })([
          'display:flex;flex-wrap:wrap;align-content:space-between;margin-top:14px;margin-bottom:12px;margin-left:12px;& > .item{margin-right:8px;display:flex;justify-content:center;}'
        ]),
        ColorItemWrapper: p,
        Select: c.div.attrs({ className: Ap(GP, 'select') }).withConfig({ componentId: 'sc-qj4xo5-12' })(function (e) {
          return Yf(['width:', ';'], 'rgb' === e.value ? '25%' : '35%')
        })
      })),
    UP =
      ((wS = zp(function (e, t) {
        var n = e.value,
          r = e.onChange,
          i = e.checked,
          o =
            ((e = void 0 === (e = e.size) ? 24 : e),
            s.exports.useMemo(
              function () {
                return '#ffffff' === n || 'rgba(0,0,0,0)' === n ? 'black' : 'white'
              },
              [n]
            ))
        return ue.createElement(
          ZP.ColorItemWrapper,
          { ref: t, color: n, size: e, stroke: 'rgba(0,0,0,0)' === n ? '#a8a8a8' : '#E9EEF2', value: n },
          ue.createElement('input', { type: 'radio', value: n, checked: i, onChange: r }),
          i && ue.createElement(OP, { color: o })
        )
      })),
      (wS.defaultProps = {}),
      (wS.propTypes = { value: ce.string.isRequired, checked: ce.bool, onChange: ce.func.isRequired, size: ce.number }),
      wS),
    XP = ['defaultColor', 'onChange', 'pinnedColors', 'showTransparentColor']
  function YP(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function qP(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {}
      t % 2
        ? YP(Object(n), !0).forEach(function (t) {
            r(e, t, n[t])
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
        : YP(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
          })
    }
    return e
  }
  function $P(e) {
    var t = e.annotation,
      n = e.updateAnnotation,
      r = ((e = e.t), t.stroke)
    t = t.strokeWidth
    return ue.createElement(
      cP,
      null,
      ue.createElement(uC, null, e('stroke')),
      ue.createElement(Jx, {
        annotation: 'px',
        onChange: function (e) {
          n({ strokeWidth: WC(e, o_, a_) })
        },
        value: t
      }),
      ue.createElement(i_, {
        color: r,
        onChange: function (e) {
          n({ stroke: e })
        },
        colorFor: 'stroke'
      })
    )
  }
  function KP(e) {
    function t(e, t) {
      i(
        r(
          {},
          e,
          WC(
            t,
            2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 0,
            3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : 100
          )
        )
      )
    }
    var n = e.annotation,
      i = e.updateAnnotation,
      o = ((e = e.t), n.shadowOffsetX),
      a = n.shadowOffsetY,
      l = n.shadowBlur,
      s = n.shadowColor
    n = n.shadowOpacity
    return ue.createElement(
      cP,
      null,
      ue.createElement(uP, null, e('shadow')),
      ue.createElement(
        dP,
        null,
        ue.createElement(
          fP,
          null,
          ue.createElement(uC, null, e('horizontal')),
          ue.createElement(Jx, {
            annotation: 'px',
            min: -100,
            max: 100,
            onChange: function (e) {
              return t('shadowOffsetX', e, -100, 100)
            },
            value: o || 0,
            hideTrack: !0
          })
        ),
        ue.createElement(
          fP,
          null,
          ue.createElement(uC, null, e('vertical')),
          ue.createElement(Jx, {
            annotation: 'px',
            min: -100,
            max: 100,
            onChange: function (e) {
              return t('shadowOffsetY', e, -100, 100)
            },
            value: a || 0,
            hideTrack: !0
          })
        )
      ),
      ue.createElement(
        dP,
        null,
        ue.createElement(
          fP,
          null,
          ue.createElement(uC, null, e('blur')),
          ue.createElement(Jx, {
            annotation: '%',
            onChange: function (e) {
              return t('shadowBlur', e)
            },
            value: l
          })
        ),
        ue.createElement(
          fP,
          null,
          ue.createElement(uC, null, e('opacity')),
          ue.createElement(Jx, {
            annotation: '%',
            onChange: function (e) {
              return t('shadowOpacity', e / 100, 0, 1)
            },
            value: Math.round(100 * n)
          })
        )
      ),
      ue.createElement(i_, {
        color: s,
        onChange: function (e) {
          i({ shadowColor: e })
        },
        colorFor: 'shadow'
      })
    )
  }
  function QP(e) {
    var t = e.annotation,
      n = e.updateAnnotation,
      r = jC().designLayer,
      i = f_.length
    return f_.map(function (e, o) {
      return ue.createElement(
        s.exports.Fragment,
        { key: e },
        ue.createElement(
          hP,
          {
            onClick: function () {
              n(d_(t, r, e))
            },
            secondaryIconColor: !0,
            addThinBorder: !0,
            noMargin: !0
          },
          e === Ky.MIDDLE_CENTER
            ? ue.createElement(u_, null)
            : ue.createElement(s_, { style: { transform: 'rotate('.concat(h_[e], 'deg)') } })
        ),
        0 == (o + 1) % 3 && o + 1 !== i && ue.createElement('div', null)
      )
    })
  }
  var JP = ['rgba(0,0,0,0)'],
    e_ = '#00000000',
    t_ =
      ((rC = zp(function (e, t) {
        function n(e) {
          return (e === JP[0] && C.color === e_) || e === C.color
        }
        function r(e) {
          return y(e) ? JP[0] : 'rgb('.concat($p(e).join(', '), ')')
        }
        function i(e, t) {
          'add' === t
            ? ((t = [].concat(Dp(E), [e])), S(t), 'function' == typeof g && g(C.color, r(e), M(t)))
            : ((t = E.filter(function (e) {
                return e !== C.color
              })),
              S(t),
              'function' == typeof g && g(C.color, r(e), M(t)))
        }
        function o(e) {
          var t, n
          null !== L &&
            ((t = tg(L).left),
            (e = Lg(Up(e || C.color), 1)[0]),
            null !== (e = L.querySelector("[data-hue='".concat(e, "']")))) &&
            ((n = e.style.backgroundColor || b.color), w({ color: n, pointerLeft: tg(e).left - t || b.pointerLeft }))
        }
        function a(e) {
          e.includes('rgb') ? P(qp(e)) : P($p(e))
        }
        function l(e) {
          return y(e) ? e_ : e
        }
        function c(e) {
          var t, n, i, s, c, u, d
          null !== T &&
            ((t = (n = tg(T)).width),
            (n = n.height),
            (i = (c = Up(e))[0]),
            (s = c[1] / 100),
            (d = ((u = 2 * (c = c[2] / 100)) + (s *= u <= 1 ? u : 2 - u)) / 2),
            (i = Gp(
              (c = [
                (u = Jp((s = (2 * s) / (u + s)), c)) || eg(s, c) ? 0 : i,
                u ? 0 : Math.round(100 * s),
                Math.round(100 * d)
              ])[1],
              0,
              100,
              0,
              t
            )),
            (u = n - Gp(c[2], 0, 100, 0, n)),
            x({ color: l(e), pointer: { left: i, top: u } }),
            o(e),
            a(e),
            'function' == typeof g) &&
            g(l(e), r(e), M(E))
        }
        function u(e, t, n) {
          var r, i, o
          null !== T &&
            ((r = (i = tg(T)).width),
            (i = i.height),
            (n = Lg(Up(n), 1)[0]),
            (e = Wp(e, 0, r) || 0),
            (t = Wp(t, 0, i) || 0),
            (n = [
              (i = Jp(
                (o =
                  0 != (r = ((2 - (o = r = e / r)) * (i = (i - t) / i)) / 2)
                    ? 1 == r
                      ? 0
                      : r < 0.5
                      ? (o * i) / (2 * r)
                      : (o * i) / (2 - 2 * r)
                    : o),
                r
              )) || eg(o, r)
                ? 0
                : n,
              i ? 0 : Math.round(100 * o),
              Math.round(100 * r)
            ]),
            (i = (function (e, t, n) {
              function r(t) {
                return (
                  (t = (t + e / 30) % 12),
                  (t = i - o * Math.max(Math.min(t - 3, 9 - t, 1), -1)),
                  Kp(Math.round(255 * t))
                )
              }
              var i = n / 100,
                o = (t * Math.min(i, 1 - i)) / 100
              return '#'.concat(r(0)).concat(r(8)).concat(r(4))
            })(n[0], n[1], n[2])),
            x({ color: i, pointer: { left: e, top: t } }),
            'function' == typeof g) &&
            g(i, 'rgb('.concat($p(i).join(', '), ')'), M(E))
        }
        function d(e) {
          var t,
            n,
            r = L
          return null !== r
            ? ((t = tg(r).width),
              (n = Wp(Math.round(Gp(e, 0, t, 0, 360)), 0, 360)),
              (r = r.querySelector("[data-hue='".concat(n, "']")).style.backgroundColor),
              w({ color: r, pointerLeft: Wp(e, 0, t) }),
              r)
            : b.color
        }
        function f(e) {
          var t, n
          null !== L &&
            ((t = tg(L).left),
            (e = d((n = (null == (n = e.touches) ? void 0 : n[0]) || e).pageX - t)),
            u(C.pointer.left, C.pointer.top, e))
        }
        function h(e) {
          var t, n, r, i
          null !== T &&
            ((r = (i = tg(T)).left),
            (t = i.top),
            (n = i.height),
            (i = i.width),
            u(
              (r = e ? Wp(e.pageX - r, 0, i) : C.pointer.left || 0),
              (i = e ? Wp(e.pageY - t, 0, n) : C.pointer.left || 0),
              b.color
            ))
        }
        var p = void 0 === (p = e.defaultColor) ? '#000000' : p,
          g = e.onChange,
          m = void 0 === (m = e.pinnedColors) ? [] : m,
          v = void 0 !== (v = e.showTransparentColor) && v,
          y =
            ((e = Hu(e, XP)),
            (v = v ? JP.concat(m) : m),
            function (e) {
              return e === e_ || e === JP[0]
            }),
          b = (m = Lg(s.exports.useState({ color: '#ff0000', pointerLeft: 0 }), 2))[0],
          w = m[1],
          C = (m = Lg(
            s.exports.useState({ color: y(p) ? '#00000000' : Xp(p) || '#000000', pointer: { left: 0, top: 0 } }),
            2
          ))[0],
          x = m[1],
          E = (p = Lg(s.exports.useState(v), 2))[0],
          S = p[1],
          O = ((v = (m = Lg(s.exports.useState('hex'), 2))[0]), m[1]),
          k = (p = Lg(s.exports.useState([]), 2))[0],
          P = p[1],
          _ = ((p = (m = Lg(s.exports.useState(Xp(C.color)), 2))[0]), m[1]),
          L = (m = Lg(s.exports.useState(null), 2))[0],
          T = ((m = m[1]), (I = Lg(s.exports.useState(null), 2))[0]),
          I = I[1],
          M = function (e) {
            return e.filter(function (e) {
              return 'rgba(0,0,0,0)' !== e
            })
          },
          j =
            (s.exports.useEffect(
              function () {
                o(C.color), c(C.color)
              },
              [L]
            ),
            s.exports.useEffect(
              function () {
                _(C.color), a(C.color)
              },
              [C.color]
            ),
            s.exports.useMemo(function () {
              return Dp(new Array(361)).map(function (e, t) {
                return ue.createElement(ZP.BarColorStop, {
                  key: t,
                  $color: 'hsl('.concat(t, ', 100%, 50%)'),
                  'data-hue': t
                })
              })
            }, [])),
          R = VP(f, f, null),
          D = VP(h, h, null)
        return ue.createElement(
          ZP.ColorPickerWrapper,
          Tg({ ref: t }, e),
          ue.createElement(
            ZP.RangePickerWrapper,
            Tg({ ref: I, color: b.color }, D),
            ue.createElement(ZP.WhiteGradient, null),
            ue.createElement(ZP.BlackGradient, null),
            ue.createElement(ZP.ColorPointer, {
              tabIndex: -1,
              left: C.pointer.left || 0,
              top: C.pointer.top || 0,
              onKeyDown: function (e) {
                var t = 0
                'ArrowLeft' === e.key || 'ArrowUp' === e.key
                  ? (t = -1)
                  : ('ArrowRight' !== e.key && 'ArrowDown' !== e.key) || (t = 1),
                  t &&
                    u(
                      (C.pointer.left || 0) + (['ArrowLeft', 'ArrowRight'].includes(e.key) ? t : 0),
                      (C.pointer.top || 0) + (['ArrowUp', 'ArrowDown'].includes(e.key) ? t : 0),
                      b.color
                    )
              },
              considerTopWidth: !0
            })
          ),
          ue.createElement(
            ZP.BarWrapper,
            R,
            ue.createElement(ZP.Bar, { ref: m }, ue.createElement('tbody', null, ue.createElement('tr', null, j))),
            ue.createElement(ZP.ColorPointer, {
              tabIndex: -1,
              left: b.pointerLeft,
              onKeyDown: function (e) {
                ;('ArrowLeft' !== e.key && 'ArrowRight' !== e.key) ||
                  d(b.pointerLeft + ('ArrowLeft' === e.key ? -1 : 1))
              },
              considerTopWidth: !1,
              style: { top: -3 }
            })
          ),
          ue.createElement(
            ZP.ColorItemsContainer,
            null,
            E.map(function (e) {
              return ue.createElement(
                'div',
                { className: 'item', key: e },
                ue.createElement(UP, {
                  value: e,
                  checked: n(e),
                  onChange: function (e) {
                    return c(e.target.value)
                  }
                })
              )
            })
          ),
          ue.createElement(
            ZP.ColorPickerAction,
            null,
            ue.createElement(
              ZP.Select,
              { value: v },
              ue.createElement(
                FP,
                {
                  size: 'sm',
                  value: v,
                  MenuProps: { zIndex: 11112 },
                  onChange: function (e) {
                    return O(e)
                  },
                  fullWidth: !0
                },
                ue.createElement(lO, { value: 'hex' }, 'Hex'),
                ue.createElement(lO, { value: 'rgb' }, 'RGB')
              )
            ),
            'hex' === v
              ? ue.createElement(BP, {
                  size: 'sm',
                  error: !/^#([\da-f]{3}){1,2}$/i.test(C.color),
                  value: p,
                  onChange: function (e) {
                    return Yp((e = e.target.value)) && c(e), void _(e)
                  },
                  style: { width: '45%' }
                })
              : k.map(function (e, t) {
                  return ue.createElement(BP, {
                    key: t,
                    size: 'sm',
                    value: e,
                    onChange: function (e) {
                      var n, r
                      ;(e = Number(null == (e = e.target) ? void 0 : e.value)),
                        (n = t),
                        255 < e ||
                          Number.isNaN(e) ||
                          (((r = k)[n] = e),
                          (n = Zp.apply(void 0, Dp(r))),
                          P(Dp(r)),
                          Yp(n) && (x(qP(qP({}, C), {}, { color: n })), o(n)))
                    },
                    style: { width: '20%' }
                  })
                }),
            C.color !== e_ &&
              ue.createElement(
                ZP.ColorPickerIcon,
                {
                  onClick: function () {
                    return E.some(n) ? i(C.color, 'delete') : i(C.color, 'add')
                  }
                },
                E.some(n) ? ue.createElement(IP, null) : ue.createElement(LP, null)
              )
          )
        )
      })),
      (iC =
        ((rC.defaultProps = { defaultColor: '#000000', pinnedColors: [], showTransparentColor: !1 }),
        (rC.propTypes = {
          defaultColor: ce.string,
          onChange: ce.func,
          pinnedColors: ce.array,
          showTransparentColor: ce.bool
        }),
        rC)),
      c.div
        .attrs(function (e) {
          return {
            style: {
              background:
                'rgba(0,0,0,0)' === (e = e.$color)
                  ? 'repeating-conic-gradient(#5d6d7e 0% 25%, transparent 0% 50%) 50% / 8px 8px'
                  : e
            }
          }
        })
        .withConfig({ componentId: 'sc-zmv0gj-0' })(
        [
          'background:',
          ';border-radius:2px;width:24px;height:24px;border:2px solid ',
          ';cursor:pointer;box-sizing:border-box;'
        ],
        function (e) {
          return e.theme.palette['icons-primary']
        },
        function (e) {
          return e.theme.palette['borders-strong']
        }
      )),
    n_ = c(iC).withConfig({ componentId: 'sc-zmv0gj-1' })(['max-width:212px;']),
    r_ = 'FIE_pinnedColors',
    i_ = function (e) {
      function t(e) {
        p(h ? null : e.currentTarget)
      }
      var n,
        i = void 0 === (i = e.position) ? 'top' : i,
        o = e.onChange,
        a = e.color,
        l = e.colorFor,
        c = void 0 === (n = (e = jC()).selectionsIds) ? [] : n,
        u = void 0 === (n = e.config.annotationsCommon) ? {} : n,
        d = e.dispatch,
        f = (void 0 === (n = e.latestColors) ? {} : n)[l],
        h = (e = Lg(s.exports.useState(), 2))[0],
        p = e[1],
        g =
          ((e = (n = Lg(
            s.exports.useState(function () {
              return f || a || u.fill
            }),
            2
          ))[0]),
          n[1]),
        m = (n = Lg(
          s.exports.useState(
            null != (n = window) && n.localStorage ? JSON.parse(localStorage.getItem(r_) || '[]') : []
          ),
          2
        ))[0],
        v = n[1]
      return (
        s.exports.useEffect(
          function () {
            var e = (0 === c.length && f) || a
            g(e), o(e)
          },
          [a, c]
        ),
        ue.createElement(
          ue.Fragment,
          null,
          ue.createElement(t_, { className: 'FIE_color-picker-triggerer', onClick: t, $color: e, onChange: o }),
          ue.createElement(
            gS,
            {
              className: 'FIE_color-picker',
              anchorEl: h,
              open: !!h,
              position: i,
              onClick: t,
              overlay: !0,
              zIndex: 11111
            },
            ue.createElement(n_, {
              onChange: function (e, t, n) {
                var i
                g(t),
                  o(t),
                  null != (i = window) &&
                    i.localStorage &&
                    ((i = window.localStorage.getItem(r_)), JSON.stringify(n) !== i) &&
                    ((i = n.slice(-9)), window.localStorage.setItem(r_, JSON.stringify(i)), v(i)),
                  f !== t && d({ type: KI, payload: { latestColors: r({}, l, t) } })
              },
              defaultColor: e,
              pinnedColors: m,
              showTransparentColor: !0
            })
          )
        )
      )
    },
    o_ = ((i_.defaultProps = { position: 'top', color: void 0 }), 0),
    a_ = 100,
    l_ = ['color', 'size'],
    s_ = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, l_)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M49.7025 23.7268L49.7008 23.725L39.4953 13.5687C38.7308 12.8079 37.4941 12.8107 36.7331 13.5754C35.9722 14.3399 35.9751 15.5766 36.7397 16.3375L43.5916 23.1562H2.22852C1.1498 23.1562 0.275391 24.0307 0.275391 25.1094C0.275391 26.1881 1.1498 27.0625 2.22852 27.0625H43.5915L36.7397 33.8812C35.9752 34.6422 35.9723 35.8788 36.7332 36.6433C37.4942 37.4081 38.731 37.4107 39.4954 36.65L49.7009 26.4937L49.7026 26.4919C50.4676 25.7284 50.4651 24.4878 49.7025 23.7268Z',
          fill: n
        })
      )
    }),
    c_ = ['color', 'size'],
    u_ = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, c_)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('circle', { cx: '25', cy: '25', r: '8.33333', fill: n })
      )
    }),
    d_ = function (e, t, n) {
      var i = e.width,
        o = e.height,
        a = e.scaleX,
        l = e.scaleY,
        s = e.rotation,
        c = void 0 === (c = e.padding) ? 0 : c,
        u = e.radius,
        d = e.radiusX,
        f =
          ((e = e.radiusY),
          (i = Lx(
            (i || 2 * (u || d)) * (void 0 === a ? 1 : a),
            (o || 2 * (u || e)) * (void 0 === l ? 1 : l),
            void 0 === s ? 0 : s
          )),
          (a = (d = t.attrs).clipWidth),
          (o = d.clipHeight),
          (e = void 0 === (u = d.clipX) ? 0 : u),
          (s = void 0 === (l = d.clipY) ? 0 : l),
          {
            left: e + i.offsetLeft + c,
            center: e + a / 2 - (i.width / 2 - i.offsetLeft) + c,
            right: e + a - i.width - c + i.offsetLeft
          }),
        h = {
          top: s + i.offsetTop + c,
          middle: s + o / 2 - (i.height / 2 - i.offsetTop) + c,
          bottom: s + o - i.height - c + i.offsetTop
        }
      return (
        r((t = {}), Ky.TOP_LEFT, function () {
          return { x: f.left, y: h.top }
        }),
        r(t, Ky.TOP_CENTER, function () {
          return { x: f.center, y: h.top }
        }),
        r(t, Ky.TOP_RIGHT, function () {
          return { x: f.right, y: h.top }
        }),
        r(t, Ky.MIDDLE_LEFT, function () {
          return { x: f.left, y: h.middle }
        }),
        r(t, Ky.MIDDLE_CENTER, function () {
          return { x: f.center, y: h.middle }
        }),
        r(t, Ky.MIDDLE_RIGHT, function () {
          return { x: f.right, y: h.middle }
        }),
        r(t, Ky.BOTTOM_LEFT, function () {
          return { x: f.left, y: h.bottom }
        }),
        r(t, Ky.BOTTOM_CENTER, function () {
          return { x: f.center, y: h.bottom }
        }),
        r(t, Ky.BOTTOM_RIGHT, function () {
          return { x: f.right, y: h.bottom }
        }),
        t[n]()
      )
    },
    f_ = Object.values(Ky),
    h_ =
      (r((h = {}), Ky.TOP_LEFT, -145),
      r(h, Ky.TOP_CENTER, -90),
      r(h, Ky.TOP_RIGHT, -45),
      r(h, Ky.MIDDLE_LEFT, 180),
      r(h, Ky.MIDDLE_CENTER, 0),
      r(h, Ky.MIDDLE_RIGHT, 0),
      r(h, Ky.BOTTOM_LEFT, 135),
      r(h, Ky.BOTTOM_CENTER, 90),
      r(h, Ky.BOTTOM_RIGHT, 45),
      h),
    p_ = 'opacity',
    g_ = 'stroke',
    m_ = 'shadow',
    v_ = 'position',
    y_ = [
      'children',
      'morePoppableOptionsPrepended',
      'moreOptionsPopupComponentsObj',
      'morePoppableOptionsAppended',
      'annotation',
      'updateAnnotation',
      'hideFillOption',
      'hidePositionField',
      'className'
    ]
  function b_(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function w_(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? b_(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : b_(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function C_(e) {
    var t = e.children,
      n = e.morePoppableOptionsPrepended,
      i = e.moreOptionsPopupComponentsObj,
      o = e.morePoppableOptionsAppended,
      a = e.annotation,
      l = e.updateAnnotation,
      c = e.hideFillOption,
      u = e.hidePositionField,
      d = e.className,
      f = ((e = Hu(e, y_)), (y = Lg(s.exports.useState(null), 2))[0]),
      h = y[1],
      p = (y = Lg(s.exports.useState(null), 2))[0],
      g = y[1],
      m = (y = jC()).config.useCloudimage,
      v = y.t,
      y = s.exports.useMemo(
        function () {
          return [].concat(
            Dp(n),
            [{ titleKey: 'opacity', name: p_, Icon: eP }],
            Dp(
              m
                ? []
                : [
                    { titleKey: 'stroke', name: g_, Icon: iP },
                    { titleKey: 'shadow', name: m_, Icon: nP }
                  ]
            ),
            [u ? void 0 : { titleKey: 'position', name: v_, Icon: aP }]
          )
        },
        [n]
      ),
      b = s.exports.useMemo(
        function () {
          var e
          return w_(w_({}, i), {}, (r((e = {}), p_, ck), r(e, g_, $P), r(e, m_, KP), r(e, v_, QP), e), o)
        },
        [i]
      ),
      w = s.exports.useCallback(function (e, t) {
        ;(e = null == e ? void 0 : e.currentTarget), h(e), g(t)
      }, []),
      C = s.exports.useCallback(
        function (e) {
          l({ fill: e })
        },
        [l]
      )
    b = f && p && b[p]
    return ue.createElement(
      lP,
      { className: 'FIE_annotations-options'.concat(d ? ' '.concat(d) : '') },
      !c && ue.createElement(i_, { color: a.fill, onChange: C, colorFor: 'fill' }),
      t,
      y.map(function (e) {
        return (
          e &&
          ue.createElement(
            hP,
            {
              className: 'FIE_annotation-option-triggerer',
              key: e.name,
              title: v(e.titleKey),
              onClick: function (t) {
                return w(t, e.name)
              }
            },
            ue.createElement(e.Icon, { size: 18 })
          )
        )
      }),
      b &&
        ue.createElement(
          CS,
          { className: 'FIE_annotation-option-popup', anchorEl: f, open: !!f, onClose: w, position: 'top' },
          ue.createElement(sP, null, ue.createElement(b, Tg({ annotation: a, updateAnnotation: l }, e)))
        )
    )
  }
  function x_(e) {
    var t = e.text,
      n = e.saveText,
      i = ((e = e.children), (h = jC()).dispatch),
      o = h.textIdOfEditableContent,
      a = h.designLayer,
      l = h.t,
      c = (h = h.config).useCloudimage,
      u = void 0 === (u = (h = h[Gy.TEXT]).fonts) ? [] : u,
      d = h.onFontChange,
      f = s.exports.useCallback(
        function (e) {
          var t = (e = e.target).name,
            i = e.value,
            o = e.type
          n(function (e) {
            return r({ id: e.id }, t, 'number' === o ? WC(i, 1, 500) : i)
          })
        },
        [n]
      ),
      h = s.exports.useCallback(
        function (e) {
          var n
          f({ target: { name: 'fontFamily', value: e } }),
            t.fontFamily !== e && 'function' == typeof d && ((n = a.draw.bind(a)), d(e, n))
        },
        [f, t, a]
      ),
      p = s.exports.useCallback(
        function (e) {
          var n = (null == (n = t.fontStyle) ? void 0 : n.replace('normal', '').split(' ')) || []
          0 < Object.keys(n).length && n.includes(e)
            ? (n = n.filter(function (t) {
                return t !== e
              }))
            : n.push(e),
            f({ target: { name: 'fontStyle', value: n.join(' ').trim() || 'normal' } })
        },
        [t]
      ),
      g = s.exports.useCallback(function () {
        i({ type: NI, payload: { textIdOfEditableContent: null } })
      }, []),
      m = s.exports.useCallback(function (e) {
        f({ target: { name: 'text', value: e } }), g()
      }, [])
    return (
      s.exports.useEffect(
        function () {
          var e, n
          return (
            o &&
              t.id === o &&
              ((e = a.getStage()),
              (n = Lg(e.findOne('#'.concat(Ny)).children, 1)[0]),
              (function (e, t, n, r, i) {
                ;(j_ = r),
                  (R_ = i),
                  (M_ = n),
                  (I_ = t.findOne('#'.concat(e))).hide(),
                  M_.hide(),
                  (r = I_.absolutePosition()),
                  (n = ''),
                  (T_ = document.createElement('textarea')),
                  t.container().parentNode.appendChild(T_),
                  (T_.value = I_.text()),
                  (T_.style.position = 'absolute'),
                  (T_.style.top = ''.concat(r.y, 'px')),
                  (T_.style.left = ''.concat(r.x, 'px')),
                  (T_.style.width = ''.concat(I_.width() - 2 * I_.padding(), 'px')),
                  (T_.style.height = ''.concat(I_.height() - 2 * I_.padding() + 5, 'px')),
                  (T_.style.maxWidth = ''.concat(I_.width() - 2 * I_.padding(), 'px')),
                  (T_.style.maxHeight = ''.concat(I_.height() - 2 * I_.padding() + 5, 'px')),
                  (T_.style.fontSize = ''.concat(I_.fontSize(), 'px')),
                  (T_.style.border = '1px solid rgba(0, 0, 0, 0.5)'),
                  (T_.style.padding = '0px'),
                  (T_.style.margin = '0px'),
                  (T_.style.overflow = 'hidden'),
                  (T_.style.background = 'none'),
                  (T_.style.outline = 'none'),
                  (T_.style.resize = 'none'),
                  (T_.style.lineHeight = I_.lineHeight()),
                  (T_.style.fontFamily = I_.fontFamily()),
                  (T_.style.transformOrigin = 'left top'),
                  (T_.style.textAlign = I_.align()),
                  (T_.style.fontStyle = I_.fontStyle()),
                  (T_.style.letterSpacing = I_.letterSpacing()),
                  (T_.style.lineHeight = I_.lineHeight()),
                  (T_.style.color = I_.fill()),
                  (i = I_.rotation()) && (n += 'rotateZ('.concat(i, 'deg)')),
                  (e = 0)
                var o = -1 < navigator.userAgent.toLowerCase().indexOf('firefox')
                o && (e += 2 + Math.round(I_.fontSize() / 20)),
                  (n += 'translateY(-'.concat(e, 'px)')),
                  (T_.style.transform = n),
                  (T_.style.height = 'auto'),
                  (T_.style.height = ''.concat(T_.scrollHeight + 3, 'px')),
                  T_.focus(),
                  T_.addEventListener('keydown', function (e) {
                    var t
                    'Enter' !== e.key || e.shiftKey || ((t = T_.value), U_(), j_(t)), 'Escape' === e.key && U_()
                  }),
                  T_.addEventListener('keydown', function (e) {
                    'Enter' !== e.key &&
                      'Escape' !== e.key &&
                      ((e = I_.getAbsoluteScale().x),
                      (e = (e = e = I_.width() * e) || I_.placeholder.length * I_.fontSize()),
                      (/^((?!chrome|android).)*safari/i.test(navigator.userAgent) || o) && (e = Math.ceil(e)),
                      (document.documentMode || /Edge/.test(navigator.userAgent)) && (e += 1),
                      (T_.style.width = ''.concat(e, 'px')),
                      (T_.style.height = 'auto'),
                      (T_.style.height = ''.concat(T_.scrollHeight + I_.fontSize(), 'px')))
                  }),
                  window &&
                    setTimeout(function () {
                      window.addEventListener('click', Z_)
                    })
              })(o, e, n, m, g)),
            function () {
              n && o && U_()
            }
          )
        },
        [o]
      ),
      ue.createElement(
        C_,
        {
          className: 'FIE_text-tool-options',
          annotation: t,
          updateAnnotation: n,
          morePoppableOptionsPrepended: c ? [] : W_,
          moreOptionsPopupComponentsObj: c ? {} : G_,
          t: l
        },
        Array.isArray(u) &&
          1 < u.length &&
          ue.createElement(
            D_,
            {
              className: 'FIE_text-font-family-option',
              onChange: h,
              value: t.fontFamily,
              placeholder: l('fontFamily'),
              size: 'sm'
            },
            u.map(function () {
              var e,
                t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : ''
              return ue.createElement(
                lO,
                {
                  className: 'FIE_text-font-family-item',
                  key: null != (e = t.value) ? e : t,
                  value: null != (e = t.value) ? e : t
                },
                null != (e = t.label) ? e : t
              )
            })
          ),
        ue.createElement(A_, {
          className: 'FIE_text-size-option',
          value: t.fontSize || '',
          name: 'fontSize',
          onChange: f,
          inputMode: 'numeric',
          type: 'number',
          size: 'sm',
          placeholder: l('size')
        }),
        !c &&
          ue.createElement(
            ue.Fragment,
            null,
            ue.createElement(
              hP,
              {
                className: 'FIE_text-bold-option',
                'aria-selected': (t.fontStyle || '').includes('bold'),
                onClick: function () {
                  return p('bold')
                }
              },
              ue.createElement($k, null)
            ),
            ue.createElement(
              hP,
              {
                className: 'FIE_text-italic-option',
                'aria-selected': (t.fontStyle || '').includes('italic'),
                onClick: function () {
                  return p('italic')
                }
              },
              ue.createElement(Qk, null)
            )
          ),
        e
      )
    )
  }
  function E_(e) {
    var t = e.selectTool,
      n = e.isSelected
    e = e.t
    return ue.createElement(mC, {
      className: 'FIE_image-tool-button',
      id: Gy.IMAGE,
      label: e('imageTool'),
      Icon: KS,
      onClick: t,
      isSelected: n
    })
  }
  function S_(e) {
    function t(e) {
      tT && (e.stopPropagation(), y(e.currentTarget))
    }
    function n() {
      tT && y(null)
    }
    var r = e.label,
      i = e.onClick,
      o = e.title,
      a = e.color,
      l = e.menuFromBtn,
      c = e.menuItems,
      u = void 0 === (u = e.menuPosition) ? 'bottom' : u,
      d = e.arrowColor,
      f = void 0 !== (f = e.disabled) && f,
      h = e.className,
      p = e.menuStyle,
      g = e.wrapperStyle,
      m = ((e = e.buttonRef), Lg(s.exports.useState(null), 2)),
      v = m[0],
      y = m[1],
      b = c.filter(Boolean),
      w = 1 < b.length
    return (
      s.exports.useEffect(function () {
        return (
          (tT = !0),
          function () {
            tT = !1
          }
        )
      }, []),
      ue.createElement(
        ue.Fragment,
        null,
        ue.createElement(
          QL,
          {
            className: ''.concat(h, '-wrapper'),
            onClick: f
              ? void 0
              : function (e) {
                  return l && w
                    ? void t(e)
                    : void ('function' == typeof i ? i() : null != (e = b[0]) && e.onClick && b[0].onClick())
                },
            style: g,
            ref: e
          },
          ue.createElement(
            JL,
            { className: ''.concat(h, '-button'), color: a, size: 'md', title: o, keepBorderRadius: !w, disabled: f },
            r
          ),
          w &&
            ue.createElement(
              eT,
              {
                className: ''.concat(h, '-menu-opener'),
                color: a,
                size: 'md',
                onClick: l || f ? void 0 : t,
                disabled: f
              },
              ue.createElement(TL, { color: d })
            )
        ),
        w &&
          ue.createElement(
            CS,
            { className: ''.concat(h, '-menu'), anchorEl: v, onClose: n, open: !0, style: p, position: u },
            c.map(function (e) {
              return (
                e &&
                ue.createElement(
                  lO,
                  {
                    className: ''.concat(h, '-menu-item'),
                    key: e.key,
                    active: e.isActive,
                    onClick: function () {
                      var t
                      'function' == typeof (t = e.onClick) && t(), n()
                    },
                    size: 'md'
                  },
                  e.icon &&
                    ue.createElement(
                      cO,
                      { size: 'md' },
                      'string' == typeof e.icon
                        ? ue.createElement('span', { dangerouslySetInnerHTML: { __html: e.icon } })
                        : ue.createElement(e.icon, null)
                    ),
                  ue.createElement(dO, null, e.label)
                )
              )
            })
          )
      )
    )
  }
  function O_(e) {
    var t = e.image,
      n = e.saveImage,
      r = e.children
    e = e.t
    return ue.createElement(
      C_,
      { className: 'FIE_image-tool-options', annotation: t, updateAnnotation: n, t: e, hideFillOption: !0 },
      r
    )
  }
  function k_(e) {
    var t = e.gallery,
      n = e.anchorEl,
      r = e.onClose,
      i = e.onSelect
    return ue.createElement(
      gS,
      { className: 'FIE_image-tool-gallery', anchorEl: n, open: !!n, position: 'top', onClick: r, overlay: !0 },
      ue.createElement(
        nT,
        null,
        t.map(function (e) {
          var t = e.originalUrl
          e = e.previewUrl
          return ue.createElement(
            rT,
            {
              key: t,
              onClick: function () {
                return i(t)
              }
            },
            ue.createElement('img', { src: e, alt: e, crossOrigin: 'Anonymous', draggable: !1 })
          )
        })
      )
    )
  }
  function P_(e) {
    var t = e.selectTool,
      n = e.isSelected
    e = e.t
    return ue.createElement(mC, {
      className: 'FIE_rect-tool-button',
      id: Gy.RECT,
      label: e('rectangleTool'),
      Icon: iL,
      onClick: t,
      isSelected: n
    })
  }
  function __(e) {
    var t = e.selectTool,
      n = e.isSelected
    e = e.t
    return ue.createElement(mC, {
      className: 'FIE_ellipse-tool-button',
      id: Gy.ELLIPSE,
      label: e('ellipseTool'),
      Icon: XS,
      onClick: t,
      isSelected: n
    })
  }
  function L_(e) {
    var t = e.selectTool,
      n = e.isSelected
    e = e.t
    return ue.createElement(mC, {
      className: 'FIE_pen-tool-button',
      id: Gy.PEN,
      label: e('penTool'),
      Icon: Y_,
      onClick: t,
      isSelected: n
    })
  }
  C_.defaultProps = {
    children: void 0,
    morePoppableOptionsPrepended: [],
    moreOptionsPopupComponentsObj: {},
    morePoppableOptionsAppended: [],
    hideFillOption: !1,
    hidePositionField: !1,
    className: void 0
  }
  var T_,
    I_,
    M_,
    j_,
    R_,
    D_ = c(FP).withConfig({ componentId: 'sc-1cwdnjz-0' })(['width:88px;margin:0 4px;']),
    A_ = c(BP).withConfig({ componentId: 'sc-1cwdnjz-1' })(['width:70px;margin:0 4px;']),
    z_ = ['color', 'size'],
    N_ = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, z_)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M38 1.5C38 0.809644 37.4404 0.25 36.75 0.25H9.25C8.55964 0.25 8 0.809644 8 1.5C8 2.19036 8.55964 2.75 9.25 2.75H36.75C37.4404 2.75 38 2.19036 38 1.5Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M45.5 14C45.5 13.3096 44.9404 12.75 44.25 12.75H1.75C1.05964 12.75 0.5 13.3096 0.5 14C0.5 14.6904 1.05964 15.25 1.75 15.25H44.25C44.9404 15.25 45.5 14.6904 45.5 14Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M36.75 25.25C37.4404 25.25 38 25.8096 38 26.5C38 27.1904 37.4404 27.75 36.75 27.75H9.25C8.55964 27.75 8 27.1904 8 26.5C8 25.8096 8.55964 25.25 9.25 25.25H36.75Z',
          fill: n
        })
      )
    }),
    F_ = ['color', 'size'],
    H_ =
      ((l = Kw(function (e, t) {
        var n = void 0 === (n = e.color) ? 'currentColor' : n,
          r = void 0 === (r = e.size) ? 14 : r
        e = Hu(e, F_)
        return ue.createElement(
          'svg',
          Tg(
            { ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
            e
          ),
          ue.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M4.29986 0.991788C4.78802 0.503633 5.57947 0.503633 6.06763 0.991788L9.367 4.29116C9.85516 4.77932 9.85516 5.57077 9.367 6.05893C8.87885 6.54708 8.08739 6.54708 7.59924 6.05893L6.43374 4.89344V34.0829L7.59924 32.9174C8.08739 32.4293 8.87885 32.4293 9.367 32.9174C9.85516 33.4056 9.85516 34.197 9.367 34.6852L6.06763 37.9846C5.8332 38.219 5.51524 38.3507 5.18371 38.3507C4.85217 38.3507 4.53422 38.219 4.29981 37.9845L1.00084 34.6851C0.512712 34.1969 0.512761 33.4055 1.00095 32.9174C1.48913 32.4292 2.28059 32.4293 2.76871 32.9175L3.93374 34.0827V4.89344L2.76825 6.05893C2.2801 6.54708 1.48864 6.54708 1.00049 6.05893C0.51233 5.57077 0.51233 4.77932 1.00049 4.29116L4.29986 0.991788ZM13.1588 8.34109V1.49725H46.3156V8.34102H43.398V7.19776C43.398 5.54595 42.0562 4.20442 40.4047 4.20442H31.8516V26.0992C31.8516 28.1387 33.5088 29.7957 35.5481 29.7957H36.5137V32.4599H23.01V29.7957H23.9756C26.0151 29.7957 27.6721 28.1387 27.6721 26.0992V4.20448H19.0697C17.418 4.20448 16.0763 5.54604 16.0763 7.19783V8.34109H13.1588ZM46.9995 39.7088C47.4877 39.2207 47.4877 38.4292 46.9995 37.9411L43.7001 34.6417C43.212 34.1535 42.4205 34.1535 41.9324 34.6417C41.4442 35.1298 41.4442 35.9213 41.9324 36.4095L43.0979 37.5749L15.0832 37.5749L16.2484 36.4099C16.7366 35.9218 16.7366 35.1303 16.2485 34.6421C15.7604 34.154 14.9689 34.1539 14.4807 34.642L11.1814 37.941C10.9469 38.1754 10.8152 38.4934 10.8152 38.8249C10.8152 39.1564 10.9469 39.4744 11.1813 39.7088L14.4807 43.0082C14.9688 43.4964 15.7603 43.4964 16.2485 43.0082C16.7366 42.5201 16.7366 41.7286 16.2485 41.2404L15.083 40.0749L43.0979 40.0749L41.9324 41.2404C41.4442 41.7286 41.4442 42.5201 41.9324 43.0082C42.4205 43.4964 43.212 43.4964 43.7001 43.0082L46.9995 39.7088Z',
            fill: n
          })
        )
      })),
      ['color', 'size']),
    B_ = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, H_)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M0 1.89453C0 1.20418 0.559644 0.644531 1.25 0.644531H28.75C29.4404 0.644531 30 1.20418 30 1.89453C30 2.58489 29.4404 3.14453 28.75 3.14453H1.25C0.559645 3.14453 0 2.58489 0 1.89453Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M0 14.3945C0 13.7042 0.559644 13.1445 1.25 13.1445H43.75C44.4404 13.1445 45 13.7042 45 14.3945C45 15.0849 44.4404 15.6445 43.75 15.6445H1.25C0.559645 15.6445 0 15.0849 0 14.3945Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M1.25 25.6445C0.559644 25.6445 0 26.2042 0 26.8945C0 27.5849 0.559645 28.1445 1.25 28.1445H28.75C29.4404 28.1445 30 27.5849 30 26.8945C30 26.2042 29.4404 25.6445 28.75 25.6445H1.25Z',
          fill: n
        })
      )
    }),
    V_ = { transform: 'scaleX(-1)' },
    W_ = [
      { titleKey: 'textAlignment', name: 'text-alignment', Icon: N_ },
      { titleKey: 'textSpacings', name: 'text-spacings', Icon: l }
    ],
    G_ =
      (r((y = {}), 'text-alignment', function (e) {
        function t(e) {
          r({ align: e })
        }
        var n = e.annotation,
          r = e.updateAnnotation
        e = n.align
        return ue.createElement(
          cP,
          null,
          ue.createElement(
            hP,
            {
              onClick: function () {
                return t('left')
              },
              'aria-selected': 'left' === e
            },
            ue.createElement(B_, null)
          ),
          ue.createElement(
            hP,
            {
              onClick: function () {
                return t('center')
              },
              'aria-selected': 'center' === e
            },
            ue.createElement(N_, null)
          ),
          ue.createElement(
            hP,
            {
              onClick: function () {
                return t('right')
              },
              'aria-selected': 'right' === e
            },
            ue.createElement(B_, { style: V_ })
          )
        )
      }),
      r(y, 'text-spacings', function (e) {
        function t(e, t) {
          i(r({}, e, WC(t, 0, 100)))
        }
        var n = e.annotation,
          i = e.updateAnnotation,
          o = ((e = e.t), n.letterSpacing)
        n = n.lineHeight
        return ue.createElement(
          cP,
          null,
          ue.createElement(uC, null, e('letterSpacing')),
          ue.createElement(Jx, {
            annotation: 'px',
            isActive: !!o,
            onChange: function (e) {
              return t('letterSpacing', e)
            },
            value: o,
            step: 1
          }),
          ue.createElement(uC, null, e('lineHeight')),
          ue.createElement(Jx, {
            annotation: 'px',
            isActive: !!n,
            onChange: function (e) {
              return t('lineHeight', e)
            },
            value: n,
            step: 1
          })
        )
      }),
      y),
    Z_ = function (e) {
      e.target !== T_ && ((e = T_.value), U_(), j_(e))
    },
    U_ = function () {
      T_ && T_.remove(T_),
        window && window.removeEventListener('click', Z_),
        I_ && I_.show(),
        M_ && (M_.show(), M_.forceUpdate()),
        'function' == typeof R_ && R_(),
        (M_ = T_ = I_ = null)
    },
    X_ = ((E_.defaultProps = { isSelected: !(x_.defaultProps = { children: null }) }), ['color', 'size']),
    Y_ = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, X_)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M48.8326 38.9412H35.1306C32.0818 38.9412 29.6019 41.4211 29.6019 44.4698C29.6019 45.9278 28.4155 47.1142 26.9576 47.1142H5.80392C4.34557 47.1142 3.15958 45.9278 3.15958 44.4698V42.5446C3.15958 41.0873 4.34518 39.9014 5.8024 39.9006L9.61443 39.8987C9.61557 39.8987 9.6171 39.8983 9.61824 39.8983C9.66173 39.8983 9.70522 39.8956 9.74908 39.8918C9.76701 39.8903 9.78456 39.8872 9.80249 39.885C9.82118 39.8823 9.84026 39.8808 9.85895 39.8777L20.0385 38.1218C20.0438 38.1207 20.0488 38.1195 20.0537 38.1184C20.0697 38.1153 20.0854 38.1119 20.101 38.1084C20.1266 38.1027 20.1518 38.097 20.1766 38.0898C20.1941 38.0852 20.2117 38.0798 20.2292 38.0745C20.2525 38.0669 20.2757 38.0589 20.299 38.0501C20.3158 38.0436 20.333 38.0379 20.3497 38.031C20.3856 38.0158 20.4207 37.9997 20.4554 37.9818C20.4691 37.9746 20.4829 37.9662 20.4966 37.9585C20.521 37.9448 20.5451 37.9311 20.5687 37.9158C20.5832 37.9067 20.5977 37.8967 20.6122 37.8868C20.6351 37.8708 20.658 37.854 20.6801 37.8365C20.6919 37.8273 20.7041 37.8181 20.716 37.8082C20.7495 37.7804 20.7823 37.7514 20.8132 37.7201L46.5228 12.011C48.5846 9.94911 48.5846 6.59409 46.5228 4.53186L43.5381 1.54762C41.4763 -0.514601 38.1209 -0.514219 36.0591 1.54762L10.3499 27.2568C10.3186 27.2877 10.2896 27.3209 10.2614 27.3544C10.2519 27.3659 10.2427 27.3777 10.2336 27.3895C10.216 27.412 10.1992 27.4349 10.1832 27.4582C10.1733 27.4723 10.1634 27.4868 10.1542 27.5013C10.1393 27.5246 10.1256 27.5482 10.1122 27.5723C10.1035 27.5879 10.0943 27.6035 10.0859 27.6192C10.0691 27.6524 10.0539 27.6856 10.0394 27.7199C10.0321 27.737 10.026 27.755 10.0192 27.7725C10.0112 27.7947 10.0031 27.8172 9.9959 27.8397C9.99017 27.858 9.98483 27.8763 9.97987 27.8946C9.97339 27.9182 9.96767 27.9423 9.96233 27.9667C9.95851 27.9835 9.9547 28.0003 9.95164 28.017C9.9505 28.022 9.94936 28.0266 9.94859 28.0312L8.39868 37.0148L5.80087 37.0159C2.75369 37.0174 0.274902 39.4978 0.274902 42.5446V44.4698C0.274902 47.5185 2.75522 49.9989 5.80392 49.9989H26.9576C30.0063 49.9989 32.4866 47.5185 32.4866 44.4698C32.4866 43.0119 33.6726 41.8255 35.1306 41.8255H48.8326C49.6291 41.8255 50.2749 41.18 50.2749 40.3835C50.2749 39.5866 49.6291 38.9412 48.8326 38.9412ZM12.3179 31.2645L16.8055 35.7521L11.3825 36.6875L12.3179 31.2645ZM33.8316 7.85408L36.0037 10.0262L15.5814 30.4485L13.4093 28.2764L33.8316 7.85408ZM19.7932 34.6603L17.6211 32.4883L38.0438 12.0659L40.2159 14.238L19.7932 34.6603ZM38.0988 3.58696C39.036 2.65007 40.5608 2.65007 41.4984 3.58696L44.4827 6.57158C45.4199 7.50885 45.4199 9.03397 44.4827 9.97124L42.2553 12.1986L35.8714 5.81436L38.0988 3.58696Z',
          fill: n
        })
      )
    }),
    q_ = ['color', 'size'],
    $_ = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, q_)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 40 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M39.5112 31.2036C39.5112 41.568 31.0785 50 20.7148 50H14.0613C12.9587 50 12.0652 49.1066 12.0652 48.004V47.3386C12.0652 46.2359 12.9586 45.3425 14.0613 45.3425H20.7148C28.5107 45.3425 34.8537 38.9995 34.8537 31.2036C34.8537 23.4078 28.5107 17.0648 20.7148 17.0648H8.4394L16.8935 25.5189C17.8015 26.4266 17.8015 27.9042 16.8935 28.8119C16.0124 29.6923 14.479 29.691 13.5999 28.8119L1.17111 16.3828C0.731285 15.943 0.488892 15.3581 0.488892 14.7359C0.488892 14.1142 0.731285 13.529 1.17111 13.0894L13.6006 0.65976C14.4797 -0.220001 16.0144 -0.220001 16.8936 0.65976C17.8016 1.56722 17.8016 3.04511 16.8936 3.95246L8.43951 12.4072H20.7148C31.0785 12.4072 39.5112 20.8395 39.5112 31.2036Z',
          fill: n
        })
      )
    }),
    K_ = ['color', 'size'],
    Q_ = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, K_)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 40 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M0.98 31.2037C0.98 41.568 9.41216 50 19.7752 50H26.4284C27.5309 50 28.4244 49.1066 28.4244 48.004V47.3386C28.4244 46.2359 27.531 45.3425 26.4284 45.3425H19.7752C11.9798 45.3425 5.6372 38.9995 5.6372 31.2037C5.6372 23.4079 11.9798 17.0648 19.7752 17.0648H32.05L23.5964 25.5189C22.6884 26.4266 22.6884 27.9043 23.5964 28.812C24.4774 29.6924 26.0107 29.6911 26.8897 28.812L39.3178 16.3828C39.7576 15.943 40 15.3582 40 14.736C40 14.1142 39.7576 13.5291 39.3178 13.0895L26.8891 0.659821C26.01 -0.21994 24.4754 -0.21994 23.5962 0.659821C22.6883 1.56728 22.6883 3.04517 23.5962 3.95252L32.0498 12.4073H19.7752C9.41216 12.4073 0.98 20.8396 0.98 31.2037Z',
          fill: n
        })
      )
    }),
    J_ = ['color', 'size'],
    eL = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, J_)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M47.7746 22.4999H27.775V2.49984C27.775 1.12014 26.6548 0 25.2747 0C23.895 0 22.7748 1.12014 22.7748 2.49984V22.4999H2.77474C1.39505 22.4999 0.274902 23.6201 0.274902 24.9998C0.274902 26.3799 1.39505 27.5001 2.77474 27.5001H22.7748V47.4997C22.7748 48.8799 23.895 50 25.2747 50C26.6548 50 27.775 48.8799 27.775 47.4997V27.5001H47.7746C49.1548 27.5001 50.2749 26.3799 50.2749 24.9998C50.2749 23.6201 49.1548 22.4999 47.7746 22.4999Z',
          fill: n
        })
      )
    }),
    tL = ['color', 'size'],
    nL = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, tL)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M3.27478 28.001H47.2746C48.9318 28.001 50.2749 26.6579 50.2749 25.0003C50.2749 23.3431 48.9322 22 47.2746 22H3.27478C1.61803 22.0004 0.274902 23.3435 0.274902 25.0007C0.274902 26.6579 1.61803 28.001 3.27478 28.001Z',
          fill: n
        })
      )
    }),
    rL = ['color', 'size'],
    iL = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, rL)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M42.4624 0H8.0874C3.77959 0 0.274902 3.50469 0.274902 7.8125V42.1875C0.274902 46.4953 3.77959 50 8.0874 50H42.4624C46.7702 50 50.2749 46.4953 50.2749 42.1875V7.8125C50.2749 3.50469 46.7702 0 42.4624 0ZM46.3687 42.1875C46.3687 44.3414 44.6163 46.0938 42.4624 46.0938H8.0874C5.9335 46.0938 4.18115 44.3414 4.18115 42.1875V7.8125C4.18115 5.65859 5.9335 3.90625 8.0874 3.90625H42.4624C44.6163 3.90625 46.3687 5.65859 46.3687 7.8125V42.1875Z',
          fill: n
        })
      )
    }),
    oL = ['color', 'size'],
    aL = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, oL)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M40.1901 7.27549L7.59689 39.8687C6.83412 40.6315 6.83412 41.8681 7.59689 42.6308C8.35965 43.3936 9.59626 43.3936 10.359 42.6308L42.9522 10.0376C43.715 9.27486 43.715 8.03825 42.9522 7.27549C42.1895 6.51272 40.9529 6.51272 40.1901 7.27549Z',
          fill: n
        })
      )
    }),
    lL = ['color', 'size'],
    sL =
      ((ug = Kw(function (e, t) {
        var n = void 0 === (n = e.color) ? 'currentColor' : n,
          r = void 0 === (r = e.size) ? 14 : r
        e = Hu(e, lL)
        return ue.createElement(
          'svg',
          Tg(
            { ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
            e
          ),
          ue.createElement('path', {
            d: 'M41.2229 16.7653C41.3215 12.426 39.7436 8.284 36.6864 5.02956C33.6292 1.77513 29.4872 -2.09808e-05 25.0493 -2.09808e-05C20.6114 -2.09808e-05 16.3708 1.77513 13.3136 5.02956C10.2564 8.18538 8.6785 12.3274 8.77712 16.7653C3.45168 19.5266 0 25.1479 0 31.1637C0 37.2781 3.25444 42.6035 8.57988 45.4635C11.0454 46.7455 13.7081 47.4359 16.2722 47.4359C19.3294 47.4359 22.288 46.5483 24.9507 44.8718C29.9803 48.1262 36.0947 48.3234 41.4201 45.4635C46.7456 42.6035 50 37.2781 50 31.1637C50 25.0493 46.6469 19.5266 41.2229 16.7653ZM22.7811 43.0966C18.6391 45.3649 13.7081 45.3649 9.56607 42.998C5.22682 40.5325 2.66272 36.1933 2.66272 31.1637C2.66272 26.43 5.12821 22.0907 9.1716 19.6252C10.1578 24.359 13.3136 28.501 17.6529 30.6706C17.4556 35.4043 19.3294 39.8422 22.7811 43.0966ZM32.1499 27.8106C31.4596 24.5562 29.783 21.499 27.3176 19.2307C30.6706 17.357 34.8126 17.0611 38.4615 18.3432C37.7712 22.2879 35.503 25.7396 32.1499 27.8106ZM20.6114 28.1065C21.3018 25.2465 22.8797 22.6824 25.0493 20.8087C27.5148 22.8797 29.1913 25.8382 29.6844 28.9941C26.7258 30.0789 23.4714 30.0789 20.4142 28.9941C20.4142 28.6982 20.5128 28.4023 20.6114 28.1065ZM25.0493 17.4556C23.57 16.4694 21.8935 15.7791 20.1183 15.3846C19.428 15.1874 18.6391 15.6805 18.5404 16.3708C18.4418 16.7653 18.5404 17.0611 18.7377 17.357C18.9349 17.6528 19.2308 17.8501 19.5266 17.9487C20.7101 18.2446 21.7949 18.639 22.7811 19.2307C20.3156 21.499 18.6391 24.4576 17.9487 27.8106C14.5957 25.7396 12.2288 22.2879 11.6371 18.3432C11.9329 18.2446 12.1302 18.1459 12.426 18.0473C12.7219 17.9487 13.0178 17.7515 13.215 17.357C13.4122 17.0611 13.4122 16.6666 13.3136 16.3708C13.1164 15.6805 12.3274 15.286 11.6371 15.4832C11.5385 15.4832 11.5385 15.4832 11.4398 15.5818C11.8343 8.48124 17.7515 2.6627 25.0493 2.6627C32.3471 2.6627 38.2643 8.38262 38.6588 15.5818C34.0237 14.2012 28.9941 14.8915 25.0493 17.4556ZM29.783 31.7554C29.5858 35.5029 27.9093 39.0532 25.0493 41.5187C22.1893 39.0532 20.4142 35.6016 20.3156 31.7554C23.3728 32.7416 26.7258 32.7416 29.783 31.7554ZM32.4458 30.6706C36.785 28.4023 39.8422 24.359 40.927 19.6252C44.9704 22.0907 47.4359 26.43 47.4359 31.1637C47.4359 36.0947 44.8718 40.5325 40.5325 42.998C36.3905 45.3649 31.4596 45.3649 27.3176 43.0966C30.7692 39.8422 32.643 35.4043 32.4458 30.6706Z',
            fill: n
          }),
          ue.createElement('path', {
            d: 'M15.5819 14.8915C14.9901 14.9901 14.497 15.5818 14.497 16.1735C14.497 16.8639 15.0888 17.5542 15.8777 17.5542C16.6667 17.5542 17.2584 16.9625 17.2584 16.1735C17.2584 15.7791 17.0611 15.3846 16.7653 15.1874C16.3708 14.9901 15.9763 14.8915 15.5819 14.8915Z',
            fill: n
          })
        )
      })),
      ['color', 'size']),
    cL =
      ((mg = Kw(function (e, t) {
        var n = void 0 === (n = e.color) ? 'currentColor' : n,
          r = void 0 === (r = e.size) ? 14 : r
        e = Hu(e, sL)
        return ue.createElement(
          'svg',
          Tg(
            { ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
            e
          ),
          ue.createElement('path', { d: 'M0.5 0.5H3V2.375H2.375V3H0.5V0.5Z', fill: n }),
          ue.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M0.5 21.125H3V21.2693H24.7308V43H24.875V45.5L0.5 45.5001V21.125ZM22.2308 43L3 43.0001V23.7693H22.2308V43Z',
            fill: n
          }),
          ue.createElement('path', { d: 'M43 45.5H45.5V43H43.625V43.625H43V45.5Z', fill: n }),
          ue.createElement('path', { d: 'M45.5 3V0.5H43V2.375H43.625V3H45.5Z', fill: n }),
          ue.createElement('path', { d: 'M6.125 0.5V3H9.875V0.5H6.125Z', fill: n }),
          ue.createElement('path', { d: 'M13.625 0.5V3H17.375V0.5H13.625Z', fill: n }),
          ue.createElement('path', { d: 'M21.125 0.5V3H24.875V0.5H21.125Z', fill: n }),
          ue.createElement('path', { d: 'M28.625 0.5V3H32.375V0.5H28.625Z', fill: n }),
          ue.createElement('path', { d: 'M36.125 0.5V3H39.875V0.5H36.125Z', fill: n }),
          ue.createElement('path', { d: 'M45.5 6.125H43V9.875H45.5V6.125Z', fill: n }),
          ue.createElement('path', { d: 'M45.5 13.625H43V17.375H45.5V13.625Z', fill: n }),
          ue.createElement('path', { d: 'M45.5 21.125H43V24.875H45.5V21.125Z', fill: n }),
          ue.createElement('path', { d: 'M45.5 28.625H43V32.375H45.5V28.625Z', fill: n }),
          ue.createElement('path', { d: 'M45.5 36.125H43V39.875H45.5V36.125Z', fill: n }),
          ue.createElement('path', { d: 'M39.875 45.5V43H36.125V45.5H39.875Z', fill: n }),
          ue.createElement('path', { d: 'M32.375 45.5V43H28.625V45.5H32.375Z', fill: n }),
          ue.createElement('path', { d: 'M0.5 17.375H3V13.625H0.5V17.375Z', fill: n }),
          ue.createElement('path', { d: 'M0.5 9.875H3V6.125H0.5V9.875Z', fill: n }),
          ue.createElement('path', {
            d: 'M35.1391 9.23718L26.3209 17.8619C25.8274 18.3446 25.8186 19.136 26.3013 19.6295C26.784 20.1231 27.5754 20.1319 28.069 19.6492L37.1012 10.815V16.9907C37.1012 17.681 37.6609 18.2407 38.3512 18.2407C39.0416 18.2407 39.6012 17.681 39.6012 16.9907V7.98718C39.6012 7.29683 39.0416 6.73718 38.3512 6.73718L29.3477 6.73718C28.6574 6.73718 28.0977 7.29683 28.0977 7.98718C28.0977 8.67754 28.6574 9.23718 29.3477 9.23718L35.1391 9.23718Z',
            fill: n
          })
        )
      })),
      ['color', 'size']),
    uL =
      ((dS = Kw(function (e, t) {
        var n = void 0 === (n = e.color) ? 'currentColor' : n,
          r = void 0 === (r = e.size) ? 14 : r
        e = Hu(e, cL)
        return ue.createElement(
          'svg',
          Tg(
            { ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
            e
          ),
          ue.createElement('path', {
            d: 'M42.1323 0.500031H2.73399C1.42693 0.500031 0.399963 1.527 0.399963 2.83406V43.166C0.399963 44.4731 1.42693 45.5 2.73399 45.5H42.1323C43.4394 45.5 44.4664 44.4731 44.4664 43.166V2.83406C44.4664 1.527 43.4394 0.500031 42.1323 0.500031ZM41.6655 3.30086V25.8942L36.624 21.693C36.1572 21.2262 35.4103 21.2262 34.8502 21.5996L28.595 26.2677L15.5244 11.2365C15.3377 10.9565 14.9643 10.7697 14.5908 10.7697C14.2174 10.7697 13.8439 10.9565 13.5639 11.1432L3.20079 21.693V3.30086H41.6655ZM3.20079 42.6992V39.8984C4.22776 40.3652 5.72154 40.832 7.58876 40.832C9.36262 40.832 10.483 40.2718 11.3232 39.805C12.0701 39.4316 12.5369 39.1515 13.3771 39.2448C14.3108 39.3382 14.8709 39.5249 15.4311 39.805C16.2713 40.0851 17.2049 40.4585 18.9788 40.4585V38.3112C17.6717 38.3112 17.0182 38.0312 16.178 37.7511C15.5244 37.471 14.6842 37.1909 13.5639 37.0975C12.0701 36.9108 11.1365 37.471 10.2962 37.8444C9.54934 38.2179 8.80245 38.5913 7.4954 38.5913C5.06801 38.5913 3.6676 37.7511 3.10743 37.2843V35.0436C4.1344 35.5104 5.62818 35.9772 7.4954 35.9772C9.26926 35.9772 10.3896 35.417 11.2298 34.9502C11.9767 34.5768 12.4435 34.2967 13.2838 34.3901C14.2174 34.4834 14.7776 34.6702 15.3377 34.9502C16.178 35.2303 17.1116 35.6038 18.8854 35.6038V33.4565C17.5784 33.4565 16.9249 33.1764 16.0846 32.8963C15.4311 32.6162 14.5908 32.3361 13.4705 32.2428C11.9767 32.056 11.0431 32.6162 10.2029 32.9897C9.45598 33.3631 8.70909 33.7365 7.40204 33.7365C4.97465 33.7365 3.57424 32.8963 3.01407 32.4295V30.1888C4.04104 30.6556 5.53482 31.1224 7.40204 31.1224C9.1759 31.1224 10.2962 30.5623 11.1365 30.0955C11.8834 29.722 12.3502 29.4419 13.1904 29.5353C14.124 29.6287 14.6842 29.8154 15.2444 30.0955C16.0846 30.3755 17.0182 30.749 18.7921 30.749V28.6017C17.485 28.6017 16.8315 28.3216 15.9912 28.0415C15.3377 27.7614 14.4975 27.4814 13.3771 27.388C11.8834 27.2013 10.9498 27.7614 10.1095 28.1349C9.36262 28.5083 8.61573 28.8818 7.30868 28.8818C4.88129 28.8818 3.48088 28.0415 2.92071 27.5747V25.7075L14.124 14.2241L27.1012 29.0685C27.568 29.6287 28.4083 29.722 28.9684 29.2552L35.4103 24.4004L41.3854 29.4419V42.6058H3.20079V42.6992Z',
            fill: n
          }),
          ue.createElement('path', {
            d: 'M32.7029 15.7179C35.4103 15.7179 37.651 13.4772 37.651 10.7697C37.651 8.06227 35.4103 5.82161 32.7029 5.82161C29.9954 5.82161 27.7547 8.06227 27.7547 10.7697C27.7547 13.4772 29.9954 15.7179 32.7029 15.7179ZM32.7029 8.15563C34.1966 8.15563 35.317 9.36933 35.317 10.7697C35.317 12.1702 34.1033 13.3838 32.7029 13.3838C31.3025 13.3838 30.0888 12.1702 30.0888 10.7697C30.0888 9.36933 31.2091 8.15563 32.7029 8.15563Z',
            fill: n
          })
        )
      })),
      ['color', 'size']),
    dL = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, uL)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement(
          'g',
          { clipPath: 'url(#clip0)' },
          ue.createElement('path', {
            d: 'M49.355 1H6.84812C6.19079 1 5.75256 1.43824 5.75256 2.09556V9.10703H7.94361V3.19112H48.0403V41.7541H42.3435V43.9452H49.1358C49.7931 43.9452 50.2314 43.5069 50.2314 42.8496V2.09556C50.4505 1.43824 49.7932 1 49.355 1Z',
            fill: n
          }),
          ue.createElement('path', {
            d: 'M43.6582 6.91586H1.37046C0.713139 6.91586 0.274902 7.3541 0.274902 8.01142V48.5464C0.274902 49.2037 0.713139 49.6419 1.37046 49.6419H43.6582C44.3156 49.6419 44.7538 49.2037 44.7538 48.5464V8.01142C44.7538 7.3541 44.3156 6.91586 43.6582 6.91586ZM42.5627 9.10698V41.9732L33.7985 31.0177C33.1411 30.3604 31.8265 30.3604 31.1692 31.0177L25.0342 38.6865L22.4049 34.9617L15.8316 25.9782C15.3934 25.3209 14.0788 25.3209 13.4214 25.9782L6.8482 34.9617L2.02785 41.754V9.10692L42.5627 9.10698Z',
            fill: n
          }),
          ue.createElement('path', {
            d: 'M36.8664 19.4051C36.8664 21.8253 34.9044 23.7872 32.4842 23.7872C30.064 23.7872 28.102 21.8253 28.102 19.4051C28.102 16.9848 30.064 15.0229 32.4842 15.0229C34.9044 15.0229 36.8664 16.9848 36.8664 19.4051Z',
            fill: n
          })
        ),
        ue.createElement(
          'defs',
          null,
          ue.createElement(
            'clipPath',
            { id: 'clip0' },
            ue.createElement('rect', { width: '50', height: '50', fill: 'white', transform: 'translate(0.274902)' })
          )
        )
      )
    }),
    fL = ['color', 'size'],
    hL = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, fL)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M40.5 20H38V12.5C38 5.6 32.4 0 25.5 0C18.6 0 13 5.6 13 12.5V20H10.5C9.1 20 8 21.1 8 22.5V47.5C8 48.9 9.1 50 10.5 50H40.5C41.9 50 43 48.9 43 47.5V22.5C43 21.1 41.9 20 40.5 20ZM15.5 12.5C15.5 7 20 2.5 25.5 2.5C31 2.5 35.5 7 35.5 12.5V20H15.5V12.5ZM40.5 47.5H10.5V22.5H40.5V47.5Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M24.3 37.3V41.3H26.8V37.3C28.3 36.8 29.3 35.4 29.3 33.8C29.3 31.7 27.6 30 25.5 30C23.4 30 21.7 31.7 21.7 33.8C21.8 35.4 22.8 36.8 24.3 37.3ZM25.5 32.5C26.2 32.5 26.8 33.1 26.8 33.8C26.8 34.5 26.2 35.1 25.5 35.1C24.8 35.1 24.2 34.5 24.2 33.8C24.3 33.1 24.8 32.5 25.5 32.5Z',
          fill: n
        })
      )
    }),
    pL = ['color', 'size'],
    gL = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, pL)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M36.2754 7.5C34.2754 3.1 29.8754 0 24.7754 0C17.8754 0 12.2754 5.6 12.2754 12.5V20H9.77539C8.37539 20 7.27539 21.1 7.27539 22.5V47.5C7.27539 48.9 8.37539 50 9.77539 50H39.7754C41.1754 50 42.2754 48.9 42.2754 47.5V22.5C42.2754 21.1 41.1754 20 39.7754 20H14.7754V12.5C14.7754 7 19.2754 2.5 24.7754 2.5C28.4754 2.5 31.7754 4.5 33.4754 7.6L36.2754 7.5ZM39.7754 47.5H9.77539V22.5H39.7754V47.5Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M24.7754 30C22.6754 30 20.9754 31.7 20.9754 33.7C20.9754 35.3 21.9754 36.7 23.4754 37.2V41.2H25.9754V37.2C27.4754 36.7 28.4754 35.3 28.4754 33.7C28.5754 31.7 26.8754 30 24.7754 30ZM24.7754 35C24.0754 35 23.4754 34.4 23.4754 33.7C23.4754 33 24.0754 32.4 24.7754 32.4C25.4754 32.4 25.9754 33 25.9754 33.7C25.9754 34.4 25.4754 35 24.7754 35Z',
          fill: n
        })
      )
    }),
    mL = ['color', 'size'],
    vL = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, mL)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M48.9856 38.314L31.3034 3.80423C29.9688 1.42247 27.6118 0 24.9985 0C22.3852 0 20.0282 1.42247 18.6936 3.80423C18.6836 3.82245 18.6751 3.84067 18.665 3.8589L1.04158 38.2594C-0.321602 40.6914 -0.347383 43.612 0.971367 46.0713C2.29314 48.5321 4.67439 50 7.345 50H42.5544C45.225 50 47.7041 48.5321 49.0258 46.0713C50.3445 43.6121 50.3188 40.6913 48.9856 38.314ZM22.0659 15.8013C22.0659 14.0842 23.3789 12.6924 24.9985 12.6924C26.6182 12.6924 27.9311 14.0843 27.9311 15.8013V28.2372C27.9311 29.9541 26.6181 31.3462 24.9985 31.3462C23.3789 31.3462 22.0659 29.954 22.0659 28.2372V15.8013ZM24.9985 43.7821C22.5728 43.7821 20.5995 41.6902 20.5995 39.1186C20.5995 36.5471 22.5727 34.4552 24.9985 34.4552C27.4242 34.4552 29.3974 36.5471 29.3974 39.1186C29.3975 41.6901 27.4243 43.7821 24.9985 43.7821Z',
          fill: n
        })
      )
    }),
    yL = ['color', 'size'],
    bL =
      ((Jy = Kw(function (e, t) {
        var n = void 0 === (n = e.color) ? 'currentColor' : n,
          r = void 0 === (r = e.size) ? 14 : r
        e = Hu(e, yL)
        return ue.createElement(
          'svg',
          Tg(
            { ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
            e
          ),
          ue.createElement('path', {
            d: 'M3 3H23V0.5H3C1.61929 0.5 0.5 1.61929 0.5 3V43C0.5 44.3807 1.61929 45.5 3 45.5H43C44.3807 45.5 45.5 44.3807 45.5 43V23H43V43H3V3Z',
            fill: n
          }),
          ue.createElement('path', {
            d: 'M45.5 7.25076H43V5.50076C43 5.15718 42.9321 4.83576 42.8113 4.54446L45.1206 3.58682C45.3651 4.17636 45.5 4.82281 45.5 5.50076V7.25076Z',
            fill: n
          }),
          ue.createElement('path', { d: 'M24.75 0.500763V3.00076H28.25V0.500763H24.75Z', fill: n }),
          ue.createElement('path', { d: 'M31.75 0.500763V3.00076H35.25V0.500763H31.75Z', fill: n }),
          ue.createElement('path', {
            d: 'M38.75 0.500763V3.00076H40.5C40.8436 3.00076 41.165 3.06868 41.4563 3.18948L42.414 0.880166C41.8244 0.635694 41.178 0.500763 40.5 0.500763H38.75Z',
            fill: n
          }),
          ue.createElement('path', { d: 'M45.5 10.7508H43V14.2508H45.5V10.7508Z', fill: n }),
          ue.createElement('path', { d: 'M45.5 17.7508H43V21.2508H45.5V17.7508Z', fill: n })
        )
      })),
      ['color', 'size']),
    wL = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, bL)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M13.8334 9.19949C13.8334 8.50914 14.3931 7.94949 15.0834 7.94949H31.3334C32.0238 7.94949 32.5834 8.50914 32.5834 9.19949C32.5834 9.88985 32.0238 10.4495 31.3334 10.4495H15.0834C14.3931 10.4495 13.8334 9.88985 13.8334 9.19949Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M15.0834 35.5496C14.3931 35.5496 13.8334 36.1092 13.8334 36.7996C13.8334 37.4899 14.3931 38.0496 15.0834 38.0496H31.3334C32.0238 38.0496 32.5834 37.4899 32.5834 36.7996C32.5834 36.1092 32.0238 35.5496 31.3334 35.5496H15.0834Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M36.8001 13.4163C37.4905 13.4163 38.0501 13.9759 38.0501 14.6663V30.9163C38.0501 31.6066 37.4905 32.1663 36.8001 32.1663C36.1098 32.1663 35.5501 31.6066 35.5501 30.9163V14.6663C35.5501 13.9759 36.1098 13.4163 36.8001 13.4163Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M10.45 14.6663C10.45 13.9759 9.89038 13.4163 9.20003 13.4163C8.50967 13.4163 7.95003 13.9759 7.95003 14.6663L7.95003 30.9163C7.95003 31.6066 8.50967 32.1663 9.20003 32.1663C9.89038 32.1663 10.45 31.6066 10.45 30.9163L10.45 14.6663Z',
          fill: n
        }),
        ue.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M3 0.5C1.61929 0.5 0.5 1.61929 0.5 3V43C0.5 44.3807 1.61929 45.5 3 45.5H43C44.3807 45.5 45.5 44.3807 45.5 43V3C45.5 1.61929 44.3807 0.5 43 0.5H3ZM43 3H3V43H43V3Z',
          fill: n
        })
      )
    }),
    CL = ['color', 'size'],
    xL = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, CL)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M44.103 18.4866L24.0002 3.8811L3.89749 18.4866L11.5761 42.1188H36.4244L44.103 18.4866ZM25.8371 1.35293C24.7418 0.557164 23.2587 0.557162 22.1634 1.35292L2.06066 15.9584C0.96539 16.7542 0.507082 18.1647 0.925439 19.4523L8.604 43.0845C9.02236 44.372 10.2222 45.2438 11.5761 45.2438H36.4244C37.7782 45.2438 38.9781 44.372 39.3965 43.0845L47.075 19.4523C47.4934 18.1647 47.0351 16.7542 45.9398 15.9584L25.8371 1.35293Z',
          fill: n
        })
      )
    }),
    EL = ['color', 'size'],
    SL =
      ((oC = Kw(function (e, t) {
        var n = void 0 === (n = e.color) ? 'currentColor' : n,
          r = void 0 === (r = e.size) ? 14 : r
        e = Hu(e, EL)
        return ue.createElement(
          'svg',
          Tg(
            { ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
            e
          ),
          ue.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M23.0078 29.9668H25.835L24.7803 35.9727H27.4609L28.5156 29.9668H32.2363V27.4473H28.9551L29.6875 23.2871H33.3496V20.7383H30.1416L31.2109 14.6445H28.5303L27.4609 20.7383H24.6191L25.6885 14.6445H23.0225L21.9531 20.7383H18.1006V23.2871H21.499L20.7666 27.4473H17.002V29.9668H20.3271L19.2725 35.9727H21.9531L23.0078 29.9668ZM26.2744 27.4473H23.4473L24.165 23.2871H27.0068L26.2744 27.4473Z',
            fill: n
          }),
          ue.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M23.5448 0.821147C24.421 0.184537 25.6075 0.184536 26.4837 0.821146L48.4803 16.8026C49.3565 17.4392 49.7231 18.5676 49.3885 19.5977L40.9865 45.4561C40.6518 46.4862 39.692 47.1836 38.6089 47.1836H11.4197C10.3366 47.1836 9.37672 46.4862 9.04204 45.4561L0.640107 19.5977C0.305422 18.5676 0.672067 17.4392 1.54829 16.8026L23.5448 0.821147ZM25.0143 2.84369L47.0108 18.8251L38.6089 44.6836H11.4197L3.01775 18.8251L25.0143 2.84369Z',
            fill: n
          })
        )
      })),
      ['color', 'size']),
    OL = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, SL)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M8.98975 13.4455C11.7193 7.13719 18.2352 2.96448 25.4662 3.53775C32.897 4.12687 38.7924 9.54635 40.3073 16.4736C40.4916 17.3166 41.3245 17.8505 42.1675 17.6662C43.0105 17.4818 43.5445 16.649 43.3601 15.8059C41.5594 7.57149 34.5543 1.12345 25.7131 0.422526C17.1213 -0.258635 9.38658 4.69317 6.13434 12.1755L3.89818 6.84608C3.56429 6.05034 2.64855 5.67594 1.85282 6.00982C1.05708 6.3437 0.682677 7.25944 1.01656 8.05518L4.73787 16.9241C4.89821 17.3062 5.20378 17.609 5.58736 17.7658C5.97094 17.9226 6.40111 17.9206 6.78323 17.7603L15.6521 14.039C16.4478 13.7051 16.8222 12.7894 16.4884 11.9936C16.1545 11.1979 15.2387 10.8235 14.443 11.1574L8.98975 13.4455Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M7.97987 23.3944C7.80368 22.5497 6.97603 22.0077 6.13126 22.1839C5.2865 22.3601 4.74451 23.1877 4.92071 24.0325C6.65659 32.3552 13.7002 38.8943 22.6071 39.6004C31.0811 40.2722 38.7213 35.4646 42.0496 28.154L44.2049 33.1157C44.5487 33.9072 45.4691 34.2701 46.2606 33.9263C47.0521 33.5825 47.415 32.6621 47.0712 31.8706L43.2414 23.0543C42.8976 22.2628 41.9772 21.8999 41.1857 22.2437L32.3694 26.0734C31.5779 26.4173 31.215 27.3376 31.5588 28.1291C31.9026 28.9206 32.823 29.2835 33.6145 28.9397L39.3938 26.4292C36.7027 32.8203 30.1416 37.063 22.8541 36.4852C15.3678 35.8917 9.4401 30.3955 7.97987 23.3944Z',
          fill: n
        })
      )
    }),
    kL = ['color', 'size'],
    PL = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, kL)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M17.5911 1.54582C16.7075 0.680052 15.2937 0.680014 14.4101 1.54573L4.05296 11.6925C3.15635 12.5709 3.14159 14.0098 4.01999 14.9064C4.89839 15.8031 6.33733 15.8178 7.23394 14.9394L13.7278 8.57741V30.4419C13.7278 31.6971 14.7454 32.7147 16.0006 32.7147C17.2558 32.7147 18.2733 31.6971 18.2733 30.4419V8.57782L24.766 14.9393C25.6625 15.8178 27.1015 15.8031 27.9799 14.9065C28.8584 14.01 28.8437 12.571 27.9471 11.6926L17.5911 1.54582Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M2.78827 36.5543C1.53308 36.5543 0.515541 37.5719 0.515541 38.827C0.515541 40.0822 1.53308 41.0998 2.78827 41.0998H29.1519C30.4071 41.0998 31.4246 40.0822 31.4246 38.827C31.4246 37.5719 30.4071 36.5543 29.1519 36.5543H2.78827Z',
          fill: n
        })
      )
    }),
    _L = PL,
    LL = ['color', 'size'],
    TL = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, LL)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M26.907 0.710361C25.7493 -0.293042 23.9445 -0.225257 22.8758 0.861763L0.931376 23.1832C-0.0773525 24.2092 -0.0773525 25.7908 0.931376 26.8168L22.8758 49.1383C23.9445 50.2253 25.7493 50.2931 26.907 49.2897C28.0647 48.2863 28.1369 46.5916 27.0683 45.5046L6.90997 25L27.0683 4.49541C28.1369 3.40839 28.0647 1.71376 26.907 0.710361Z',
          fill: n
        })
      )
    }),
    IL = ['color', 'size'],
    ML = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, IL)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M29.5089 27.2774C30.1253 27.8938 30.1253 28.8932 29.5089 29.5096C28.8925 30.126 27.8932 30.126 27.2768 29.5096L15.0002 17.2327L2.72342 29.5097C2.10703 30.1261 1.10767 30.1261 0.491282 29.5097C-0.125105 28.8934 -0.125105 27.894 0.491283 27.2776L12.7681 15.0006L0.491159 2.72344C-0.125226 2.10704 -0.125228 1.10766 0.49116 0.49126C1.10755 -0.125138 2.10691 -0.125139 2.72329 0.49126L15.0002 12.7684L27.2769 0.491449C27.8933 -0.124948 28.8927 -0.12495 29.5091 0.491449C30.1254 1.10785 30.1254 2.10723 29.5091 2.72363L17.2323 15.0006L29.5089 27.2774Z',
          fill: n
        })
      )
    }),
    jL = ['color', 'size'],
    RL = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, jL)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M1.04757 38.9503C0.437373 38.3401 0.437373 37.3508 1.04757 36.7406L33.9229 3.86697L23.8354 3.33584C22.9736 3.29047 22.3118 2.5551 22.3572 1.69335C22.4026 0.831601 23.138 0.169794 23.9997 0.215167L37.5909 0.930759C38.3892 0.972794 39.027 1.61063 39.0691 2.40894L39.7846 16.0001C39.83 16.8619 39.1682 17.5972 38.3065 17.6426C37.4447 17.688 36.7093 17.0262 36.664 16.1644L36.1328 6.07651L3.25728 38.9503C2.64708 39.5605 1.65776 39.5605 1.04757 38.9503Z',
          fill: n
        })
      )
    }),
    DL = ['color', 'size'],
    AL = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, DL)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M27.1607 4.16667V2.08333C27.1607 0.93274 26.2279 0 25.0773 0C23.9267 0 22.994 0.932741 22.994 2.08333V4.16667H4.244C1.94281 4.16667 0.0773315 6.03215 0.0773315 8.33333V41.6667C0.0773315 43.9679 1.94281 45.8333 4.244 45.8333H22.994V47.9167C22.994 49.0673 23.9267 50 25.0773 50C26.2279 50 27.1607 49.0673 27.1607 47.9167V45.8333H45.9107C48.2118 45.8333 50.0773 43.9678 50.0773 41.6667V8.33333C50.0773 6.03215 48.2119 4.16667 45.9107 4.16667H27.1607ZM22.994 8.33333H4.244L4.244 41.6667H22.994V8.33333ZM27.1607 41.6667V8.33333H45.9107V41.6667H27.1607Z',
          fill: n
        })
      )
    }),
    zL = ['color', 'size'],
    NL =
      ((Qy = Kw(function (e, t) {
        var n = void 0 === (n = e.color) ? 'currentColor' : n,
          r = void 0 === (r = e.size) ? 14 : r
        e = Hu(e, zL)
        return ue.createElement(
          'svg',
          Tg(
            { ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
            e
          ),
          ue.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M16.3679 7.50003C15.7995 10.005 13.5592 11.875 10.8823 11.875C8.20528 11.875 5.96506 10.005 5.39665 7.50003H1.5448C0.854444 7.50003 0.2948 6.94039 0.2948 6.25003C0.2948 5.55967 0.854444 5.00003 1.5448 5.00003H5.39665C5.96506 2.49504 8.20528 0.625031 10.8823 0.625031C13.5592 0.625031 15.7995 2.49504 16.3679 5.00003H48.4557C49.1461 5.00003 49.7057 5.55967 49.7057 6.25003C49.7057 6.94039 49.1461 7.50003 48.4557 7.50003H16.3679ZM14.0073 6.25003C14.0073 7.97592 12.6082 9.37503 10.8823 9.37503C9.15637 9.37503 7.75726 7.97592 7.75726 6.25003C7.75726 4.52414 9.15637 3.12503 10.8823 3.12503C12.6082 3.12503 14.0073 4.52414 14.0073 6.25003Z',
            fill: n
          }),
          ue.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M34.5715 27.625C37.2485 27.625 39.4887 25.755 40.0571 23.25H48.4554C49.1458 23.25 49.7054 22.6904 49.7054 22C49.7054 21.3096 49.1458 20.75 48.4554 20.75H40.0571C39.4887 18.245 37.2485 16.375 34.5715 16.375C31.8946 16.375 29.6543 18.245 29.0859 20.75H1.5448C0.854444 20.75 0.2948 21.3096 0.2948 22C0.2948 22.6904 0.854444 23.25 1.5448 23.25H29.0859C29.6543 25.755 31.8946 27.625 34.5715 27.625ZM34.5715 25.125C36.2974 25.125 37.6965 23.7259 37.6965 22C37.6965 20.2741 36.2974 18.875 34.5715 18.875C32.8456 18.875 31.4465 20.2741 31.4465 22C31.4465 23.7259 32.8456 25.125 34.5715 25.125Z',
            fill: n
          }),
          ue.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M22.7702 39C22.2018 41.505 19.9615 43.375 17.2845 43.375C14.6076 43.375 12.3673 41.505 11.7989 39H1.5448C0.854444 39 0.2948 38.4403 0.2948 37.75C0.2948 37.0596 0.854444 36.5 1.5448 36.5H11.7989C12.3673 33.995 14.6076 32.125 17.2845 32.125C19.9615 32.125 22.2018 33.995 22.7702 36.5H48.4554C49.1458 36.5 49.7054 37.0596 49.7054 37.75C49.7054 38.4403 49.1458 39 48.4554 39H22.7702ZM20.4095 37.75C20.4095 39.4759 19.0104 40.875 17.2845 40.875C15.5587 40.875 14.1595 39.4759 14.1595 37.75C14.1595 36.0241 15.5587 34.625 17.2845 34.625C19.0104 34.625 20.4095 36.0241 20.4095 37.75Z',
            fill: n
          })
        )
      })),
      ['color', 'size']),
    FL =
      ((f = Kw(function (e, t) {
        var n = void 0 === (n = e.color) ? 'currentColor' : n,
          r = void 0 === (r = e.size) ? 14 : r
        e = Hu(e, NL)
        return ue.createElement(
          'svg',
          Tg(
            { ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
            e
          ),
          ue.createElement('path', {
            d: 'M46.1442 31.3785C45.4585 31.3785 44.8974 31.9424 44.8974 32.6316V43.7344C44.8974 45.802 43.2267 47.4812 41.157 47.4938H6.22156C4.16433 47.4938 2.49361 45.8146 2.48114 43.7344V11.1278C2.48114 9.06018 4.15186 7.38098 6.22156 7.36845H17.2807C17.9665 7.36845 18.5275 6.80454 18.5275 6.11532C18.5275 5.42609 17.9665 4.86218 17.2807 4.86218H6.22156C2.79284 4.87471 0 7.6692 0 11.1278V43.7344C0 47.193 2.79284 50 6.22156 50H41.157C44.5982 50 47.3786 47.193 47.3786 43.7469V32.6316C47.391 31.9424 46.83 31.3785 46.1442 31.3785Z',
            fill: n
          }),
          ue.createElement('path', {
            d: 'M46.8923 1.65414C44.698 -0.551378 41.157 -0.551378 38.9627 1.65414L16.7571 23.9724C16.6075 24.1228 16.4953 24.3108 16.4329 24.5238L13.5154 35.1253C13.3907 35.5639 13.5154 36.0276 13.8396 36.3409C14.1513 36.6541 14.6251 36.7794 15.049 36.6667L25.5969 33.7343C25.8089 33.6717 25.9959 33.5714 26.1455 33.4085L48.3636 11.0777C50.5455 8.87218 50.5455 5.31328 48.3636 3.10777L46.8923 1.65414ZM19.4751 24.787L37.6535 6.51629L43.5135 12.406L25.3351 30.6892L19.4751 24.787ZM18.3031 27.1554L22.9911 31.8672L16.5077 33.6717L18.3031 27.1554ZM46.5931 9.31078L45.2715 10.6391L39.4115 4.74937L40.7331 3.42105C41.9425 2.20551 43.9249 2.20551 45.1343 3.42105L46.5931 4.88722C47.815 6.11529 47.815 8.09524 46.5931 9.31078Z',
            fill: n
          })
        )
      })),
      ['color', 'size']),
    HL = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, FL)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M0.312012 34.847V3.39883C0.312012 1.67294 1.71112 0.273834 3.43701 0.273834H26.807C28.5329 0.273834 29.932 1.67294 29.932 3.39883V34.847C29.932 36.5729 28.5329 37.972 26.807 37.972H3.43701C1.71112 37.972 0.312012 36.5729 0.312012 34.847ZM3.43701 34.847V3.39883L26.807 3.39883L26.807 34.847L3.43701 34.847Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M35.6874 12.5434C35.6874 11.6805 34.9878 10.9809 34.1249 10.9809C33.2619 10.9809 32.5624 11.6805 32.5624 12.5434V40.6009H9.89033C9.02739 40.6009 8.32783 41.3005 8.32783 42.1634C8.32783 43.0263 9.02739 43.7259 9.89033 43.7259H34.1249C34.9878 43.7259 35.6874 43.0263 35.6874 42.1634V12.5434Z',
          fill: n
        })
      )
    }),
    BL = ['color', 'size'],
    VL = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, BL)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M15.75 17.3125C15.75 16.4496 16.4496 15.75 17.3125 15.75C18.1754 15.75 18.875 16.4496 18.875 17.3125L18.875 32.9375C18.875 33.8005 18.1754 34.5 17.3125 34.5C16.4496 34.5 15.75 33.8005 15.75 32.9375L15.75 17.3125Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M26.6875 15.75C25.8246 15.75 25.125 16.4496 25.125 17.3125L25.125 32.9375C25.125 33.8005 25.8246 34.5 26.6875 34.5C27.5504 34.5 28.25 33.8005 28.25 32.9375V17.3125C28.25 16.4496 27.5504 15.75 26.6875 15.75Z',
          fill: n
        }),
        ue.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M12.625 6.37503V3.25003C12.625 1.52414 14.0241 0.125031 15.75 0.125031H28.25C29.9759 0.125031 31.375 1.52414 31.375 3.25003V6.37503H42.3125C43.1754 6.37503 43.875 7.07459 43.875 7.93753C43.875 8.80048 43.1754 9.50003 42.3125 9.50003H39.1875V40.75C39.1875 42.4759 37.7884 43.875 36.0625 43.875H7.9375C6.21161 43.875 4.8125 42.4759 4.8125 40.75V9.50003L1.6875 9.50003C0.824554 9.50003 0.125 8.80048 0.125 7.93753C0.125 7.07459 0.824555 6.37503 1.6875 6.37503H12.625ZM15.75 3.25003H28.25V6.37503H15.75V3.25003ZM7.9375 9.50003L7.9375 40.75H36.0625V9.50003H7.9375Z',
          fill: n
        })
      )
    }),
    WL = ['color', 'size'],
    GL =
      ((aC = Kw(function (e, t) {
        var n = void 0 === (n = e.color) ? 'currentColor' : n,
          r = void 0 === (r = e.size) ? 14 : r
        e = Hu(e, WL)
        return ue.createElement(
          'svg',
          Tg(
            { ref: t, width: r, height: r, viewBox: '0 0 50 50', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
            e
          ),
          ue.createElement('path', { d: 'M43 3H31.75V0.5H43C44.3807 0.5 45.5 1.61929 45.5 3V14.25H43V3Z', fill: n }),
          ue.createElement('path', { d: 'M3 14.25V3H14.25V0.5H3C1.61929 0.5 0.5 1.61929 0.5 3V14.25H3Z', fill: n }),
          ue.createElement('path', {
            d: 'M0.5 31.75V43C0.5 44.3807 1.61929 45.5 3 45.5H14.25V43H3V31.75H0.5Z',
            fill: n
          }),
          ue.createElement('path', {
            d: 'M43 31.75H45.5V43C45.5 44.3807 44.3807 45.5 43 45.5H31.75V43H43V31.75Z',
            fill: n
          })
        )
      })),
      ['color', 'size']),
    ZL = Kw(function (e, t) {
      var n = void 0 === (n = e.color) ? 'currentColor' : n,
        r = void 0 === (r = e.size) ? 14 : r
      e = Hu(e, GL)
      return ue.createElement(
        'svg',
        Tg({ ref: t, width: r, height: r, viewBox: '0 0 26 26', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, e),
        ue.createElement('path', {
          d: 'M17.3945 21.1062H8.60547C8.20098 21.1062 7.87305 21.4342 7.87305 21.8387C7.87305 22.2431 8.20098 22.5711 8.60547 22.5711H17.3945C17.799 22.5711 18.127 22.2431 18.127 21.8387C18.127 21.4342 17.799 21.1062 17.3945 21.1062Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M17.3945 15.2469H8.60547C8.20098 15.2469 7.87305 15.5748 7.87305 15.9793C7.87305 16.3838 8.20098 16.7117 8.60547 16.7117H17.3945C17.799 16.7117 18.127 16.3838 18.127 15.9793C18.127 15.5748 17.799 15.2469 17.3945 15.2469Z',
          fill: n
        }),
        ue.createElement('path', {
          d: 'M17.3945 18.1765H8.60547C8.20098 18.1765 7.87305 18.5045 7.87305 18.909C7.87305 19.3135 8.20098 19.6414 8.60547 19.6414H17.3945C17.799 19.6414 18.127 19.3135 18.127 18.909C18.127 18.5045 17.799 18.1765 17.3945 18.1765Z',
          fill: n
        }),
        ue.createElement('path', { d: 'M16.6621 0.5H6.4082V6.84766H16.6621V0.5Z', fill: n }),
        ue.createElement('path', {
          d: 'M25.2854 4.6208L21.3792 0.714551C21.2418 0.577197 21.0556 0.5 20.8613 0.5H18.127V7.58008C18.127 7.98457 17.799 8.3125 17.3945 8.3125H5.67578C5.27129 8.3125 4.94336 7.98457 4.94336 7.58008V0.5H1.23242C0.82793 0.5 0.5 0.82793 0.5 1.23242V24.7676C0.5 25.1721 0.82793 25.5 1.23242 25.5C1.45923 25.5 24.463 25.5 24.7676 25.5C25.1721 25.5 25.5 25.1721 25.5 24.7676V5.13867C25.5 4.94443 25.4228 4.75815 25.2854 4.6208ZM19.5918 24.0352H6.4082V13.7812H19.5918V24.0352Z',
          fill: n
        })
      )
    }),
    UL = c.input.withConfig({ componentId: 'sc-h20emh-0' })([
      'display:none;width:1px;height:1px;position:absolute;z-index:-1;'
    ]),
    XL = s.exports.forwardRef(function (e, t) {
      return ue.createElement(UL, Tg({ type: 'file', ref: t }, e))
    }),
    YL =
      (r((cC = {}), LS.Xs, Yf(['padding:6px;'])),
      r(cC, LS.Sm, Yf(['padding:8px;'])),
      r(cC, LS.Md, Yf(['padding:8px;'])),
      r(cC, LS.Lg, Yf(['padding:10px;'])),
      r(cC, LS.Xl, Yf(['padding:11px;'])),
      cC),
    qL = Hp({
      IconButton: c(FS.Button)
        .attrs({ className: Ap('IconButton', 'root') })
        .withConfig({ componentId: 'sc-10edh45-0' })(function (e) {
        var t = e.square
        e = e.size
        return Yf(['', ''], void 0 !== t && t && YL[void 0 === e ? LS.Md : e])
      })
    }),
    $L = ['children'],
    KL =
      ((Og = zp(function (e, t) {
        var n = e.children
        e = Hu(e, $L)
        return ue.createElement(
          qL.IconButton,
          Tg({}, e, { ref: t }),
          n &&
            ('function' == typeof n
              ? n({
                  size: (function (e, t) {
                    switch (e) {
                      case LS.Xl:
                        return t ? 18 : 16
                      case LS.Lg:
                      case LS.Md:
                        return t ? 16 : 14
                      default:
                        return ES(e)
                    }
                  })(e.size, e.square)
                })
              : n)
        )
      })),
      (Og.defaultProps = { size: LS.Md, color: PS.Secondary, square: !1 }),
      (Og.propTypes = {
        children: ce.oneOfType([ce.node, ce.func]).isRequired,
        size: ce.oneOf(Fp(LS)),
        color: ce.oneOf(Fp(PS)),
        square: ce.bool
      }),
      Og),
    QL = c.div.withConfig({ componentId: 'sc-m9ezm7-0' })([
      'height:22px;display:flex;align-items:center;margin-right:4px;'
    ]),
    JL = c(BS).withConfig({ componentId: 'sc-m9ezm7-1' })(
      [
        'height:100%;padding:4px 8px;flex-grow:1;justify-content:center;align-items:center;',
        ';span{font-size:12px !important;line-height:14px !important;}'
      ],
      function (e) {
        return e.keepBorderRadius ? '' : 'border-top-right-radius: 0; border-bottom-right-radius: 0'
      }
    ),
    eT = c(KL).withConfig({ componentId: 'sc-m9ezm7-2' })([
      'border-top-left-radius:0;border-bottom-left-radius:0;margin-left:1px;height:100%;padding:4px 8px;svg{transform:rotate(-90deg);width:10px;margin-top:-4px;}'
    ]),
    tT = !0,
    nT =
      ((S_.defaultProps = {
        title: '',
        color: 'primary',
        menuFromBtn: !1,
        menuPosition: 'bottom',
        onClick: void 0,
        disabled: !1,
        arrowColor: void 0,
        menuStyle: void 0,
        wrapperStyle: void 0,
        buttonRef: void 0
      }),
      (O_.defaultProps = { children: null }),
      c.div.withConfig({ componentId: 'sc-dqni47-0' })(
        [
          'background:',
          ';box-shadow:0px 1px 2px ',
          ';border-radius:4px;padding:8px;overflow-y:auto;max-height:350px;max-width:300px;'
        ],
        function (e) {
          return e.theme.palette['bg-secondary']
        },
        function (e) {
          return e.theme.palette['light-shadow']
        }
      )),
    rT = c.div.withConfig({ componentId: 'sc-dqni47-1' })(
      [
        'display:inline-flex;align-items:center;justify-content:center;width:60px;height:60px;margin:4px;padding:4px;cursor:pointer;border-radius:4px;border:2px solid ',
        ';user-select:none;:hover{border-color:',
        ';}img{width:100%;height:100%;object-fit:contain;}'
      ],
      function (e) {
        return e.theme.palette['bg-primary-active']
      },
      function (e) {
        return e.theme.palette['accent-primary-active']
      }
    ),
    iT =
      ((P_.defaultProps = { isSelected: !(k_.defaultProps = { gallery: [], anchorEl: null }) }),
      [{ titleKey: 'cornerRadius', name: 'corner-radius', Icon: Jy }]),
    oT = r({}, 'corner-radius', function (e) {
      var t = e.annotation,
        n = e.updateAnnotation
      ;(e = e.t), (t = t.cornerRadius)
      return ue.createElement(
        cP,
        null,
        ue.createElement(uC, null, e('cornerRadius')),
        ue.createElement(Jx, {
          annotation: 'px',
          onChange: function (e) {
            n({ cornerRadius: WC(e, 0, 150) })
          },
          value: t,
          min: 0,
          max: 150
        })
      )
    })
  function aT(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function lT(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? aT(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : aT(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function sT(e) {
    var t = e.selectTool,
      n = e.isSelected
    e = e.t
    return ue.createElement(mC, {
      className: 'FIE_line-tool-button',
      id: Gy.LINE,
      label: e('lineTool'),
      Icon: aL,
      onClick: t,
      isSelected: n
    })
  }
  function cT(e) {
    var t = e.selectTool,
      n = e.isSelected
    e = e.t
    return ue.createElement(mC, {
      className: 'FIE_arrow-tool-button',
      id: Gy.ARROW,
      label: e('arrowTool'),
      Icon: RL,
      onClick: t,
      isSelected: n
    })
  }
  function uT(e) {
    var t = e.selectTool,
      n = e.isSelected
    e = e.t
    return ue.createElement(mC, {
      className: 'FIE_polygon-tool-button',
      id: Gy.POLYGON,
      label: e('polygonTool'),
      Icon: xL,
      onClick: t,
      isSelected: n
    })
  }
  var dT = { passive: !0 },
    fT =
      ((uT.defaultProps = {
        isSelected: !(cT.defaultProps = {
          isSelected: !(sT.defaultProps = {
            isSelected: !(L_.defaultProps = { isSelected: !(__.defaultProps = { isSelected: !1 }) })
          })
        })
      }),
      [{ titleKey: 'sides', name: 'sides-number', Icon: oC }]),
    hT = r({}, 'sides-number', function (e) {
      var t = e.annotation,
        n = e.updateAnnotation
      ;(e = e.t), (t = t.sides)
      return ue.createElement(
        cP,
        null,
        ue.createElement(uC, null, e('sides')),
        ue.createElement(Jx, {
          annotation: '',
          onChange: function (e) {
            n({ sides: WC(e, 3, 25) })
          },
          value: t,
          min: 3,
          max: 25
        })
      )
    })
  function pT(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function gT(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? pT(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : pT(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function mT(e, t, n, r) {
    var i = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0
    return e.width && e.height
      ? e
      : ((t = _x(t, n, r)),
        (n = Lx(t.width, t.height, i)),
        e.width || e.height
          ? { width: e.width || n.width, height: e.height || n.height }
          : (n.width && n.height && n) || gT(gT({}, r), Lx(r.width, r.height, i)))
  }
  function vT(e) {
    function t(e) {
      var t,
        o = (e = e.target).name,
        f = ((e = e.value), Lx(l.width, l.height, d)),
        h = ((e = r({}, o, WC(e, 1))), 'height' === o),
        p = h ? 'width' : 'height'
      ;(null != (t = i.ratioUnlocked) ? t : s.ratioUnlocked) ||
        ((t = f.width / f.height), (e[p] = h ? Math.round(e[o] * t) : Math.round(e[o] / t))),
        (e[o] === s[o] && e[p] === s[p]) ||
          ('function' == typeof n
            ? n(e)
            : (a({ type: BI, payload: e }),
              (s.width && s.height) ||
                ((f = (u.width && u.height && u) || c), a({ type: wI, payload: { factor: bS(f, e) } }))))
    }
    var n = e.onChange,
      i = e.currentSize,
      o = e.hideResetButton,
      a = ((e = e.alignLeft), (h = jC()).dispatch),
      l = h.originalImage,
      s = h.resize,
      c = h.shownImageDimensions,
      u = (f = h.adjustments).crop,
      d = void 0 === (f = f.rotation) ? 0 : f,
      f = h.theme,
      h = h.t,
      p = (!s.width && !s.height) || (l.width === s.width && l.height === s.height),
      g = mT(((i.width || i.height) && i) || s, u, c, l, d),
      m = s.manualChangeDisabled
    return ue.createElement(
      wT,
      { className: 'FIE_resize-tool-options', alignLeft: e },
      ue.createElement(CT, {
        className: 'FIE_resize-width-option',
        value: g.width,
        name: 'width',
        onChange: m ? void 0 : t,
        inputMode: 'numeric',
        title: h('resizeWidthTitle'),
        type: 'number',
        size: 'sm',
        placeholder: 'Width',
        noLeftMargin: e,
        disabled: m
      }),
      ue.createElement(ET, { className: 'FIE_resize-x-label' }, 'x'),
      ue.createElement(CT, {
        className: 'FIE_resize-height-option',
        value: g.height,
        name: 'height',
        onChange: m ? void 0 : t,
        inputMode: 'numeric',
        title: h('resizeHeightTitle'),
        type: 'number',
        size: 'sm',
        placeholder: 'Height',
        disabled: m
      }),
      ue.createElement(
        xT,
        {
          className: 'FIE_resize-ratio-locker',
          title: h('toggleRatioLockTitle'),
          onClick: m
            ? void 0
            : function () {
                return 'function' == typeof n
                  ? void n({ ratioUnlocked: !i.ratioUnlocked })
                  : void a({ type: BI, payload: { ratioUnlocked: !s.ratioUnlocked } })
              },
          color: 'link',
          size: 'sm',
          disabled: m
        },
        i.ratioUnlocked || s.ratioUnlocked
          ? ue.createElement(gL, { color: f.palette['icons-secondary'] })
          : ue.createElement(hL, { color: f.palette['icons-secondary'] })
      ),
      !o &&
        ue.createElement(
          BS,
          {
            className: 'FIE_resize-reset-button',
            size: 'sm',
            onClick:
              p || m
                ? void 0
                : function () {
                    a({ type: BI, payload: { width: null, height: null, ratioUnlocked: !1 } })
                    var e = (u.width && u.height && u) || c
                    a({ type: wI, payload: { factor: bS(e, e) } })
                  },
            disabled: p || m,
            title: h('resetSize')
          },
          h('reset')
        )
    )
  }
  function yT(e) {
    function t(e) {
      n(e.currentTarget.children[0])
    }
    var n = e.selectWatermark,
      r = ((e = e.style), (a = jC()).config),
      i = a.annotations,
      o = s.exports.useMemo(
        function () {
          var e
          return null == (e = (i[By] || {}).image) ? void 0 : e.src
        },
        [i[By]]
      ),
      a = (r[Gy.WATERMARK] || {}).gallery
    return 0 === (r = void 0 === a ? [] : a).length
      ? null
      : ue.createElement(
          ak,
          { className: 'FIE_watermark-gallery', style: e },
          r.map(function (e) {
            return ue.createElement(
              kT,
              { className: 'FIE_watermark-selected-item', onClick: t, key: e, 'aria-selected': e === o },
              ue.createElement('img', { src: e, alt: e, crossOrigin: 'Anonymous', draggable: !1 })
            )
          })
        )
  }
  function bT(e) {
    var t = e.watermark,
      n = e.saveWatermark,
      r = ((e = e.t), (o = Lg(s.exports.useState(null), 2))[0]),
      i = o[1],
      o = t.padding
    return ue.createElement(
      ue.Fragment,
      null,
      ue.createElement(
        hP,
        {
          className: 'FIE_watermark-padding-triggerer',
          title: e('padding'),
          onClick: function (e) {
            i(e.currentTarget)
          }
        },
        ue.createElement(wL, { size: 18 })
      ),
      ue.createElement(
        CS,
        {
          className: 'FIE_watermark-padding-popup',
          anchorEl: r,
          open: !!r,
          onClose: function () {
            i(null)
          },
          position: 'top'
        },
        ue.createElement(
          sP,
          null,
          ue.createElement(
            cP,
            null,
            ue.createElement(uC, null, e('padding')),
            ue.createElement(Jx, {
              annotation: 'px',
              onChange: function (e) {
                n({ padding: WC(e, 0, 100) })
              },
              value: o
            })
          )
        )
      )
    )
  }
  var wT = c.div.withConfig({ componentId: 'sc-17otqpz-0' })(
      ['display:flex;justify-content:', ';align-items:center;flex-wrap:wrap;'],
      function (e) {
        return e.alignLeft ? 'left' : 'center'
      }
    ),
    CT = c(BP).withConfig({ componentId: 'sc-17otqpz-1' })(['width:70px;height:24px;margin:', ';'], function (e) {
      return e.noLeftMargin ? '8px 8px 8px 0' : '8px'
    }),
    xT = c(KL).withConfig({ componentId: 'sc-17otqpz-2' })(['margin-right:16px;']),
    ET = c(uC).withConfig({ componentId: 'sc-17otqpz-3' })(['font-size:13px;line-height:15px;']),
    ST =
      ((vT.defaultProps = { onChange: void 0, currentSize: {}, hideResetButton: !1, alignLeft: !1 }),
      c.div.withConfig({ componentId: 'sc-fvaj5j-0' })(
        ['display:flex;align-items:center;justify-content:center;flex-wrap:wrap;overflow:hidden;', ';'],
        function (e) {
          return e.noWrap ? 'margin-left: 4px; flex-wrap: nowrap;' : ''
        }
      )),
    OT = c.div.withConfig({ componentId: 'sc-fvaj5j-1' })(['margin-bottom:8px;']),
    kT = c.div.withConfig({ componentId: 'sc-fvaj5j-2' })(function (e) {
      return (
        (e = e.theme),
        '\n    padding: 4px;\n    border: 1px solid '
          .concat(
            e.palette['borders-primary'],
            ';\n    width: fit-content;\n    height: 32px;\n    border-radius: 2px;\n    overflow: hidden;\n    cursor: pointer;\n\n    :hover {\n      background: '
          )
          .concat(e.palette['bg-primary-active'], ";\n    }\n\n    &[aria-selected='true'] {\n      background: ")
          .concat(e.palette['bg-primary-active'], ';\n      border-color: ')
          .concat(
            e.palette['accent-primary-active'],
            ';\n    }\n\n    img {\n      max-width: 100%;\n      max-height: 100%;\n    }\n  '
          )
      )
    })
  function PT(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function _T(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? PT(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : PT(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  yT.defaultProps = { style: void 0 }
  var LT = 'watermark',
    TT =
      (r((p = {}), Gy.CROP, { id: Gy.CROP, Item: FO }),
      r(p, Gy.ROTATE, {
        id: Gy.ROTATE,
        Item: VO,
        ItemOptions: function () {
          var e,
            t = jC(),
            n = t.dispatch,
            r = void 0 === (e = t.adjustments.rotation) ? 0 : e,
            i = void 0 === (e = t.resize) ? {} : e,
            o = t.config[Gy.ROTATE],
            a = lx(function (e, t) {
              t = WC(t, -180, 180)
              n({ type: pI, payload: { rotation: t } }),
                i.width &&
                  i.height &&
                  ((t = Lx(i.width, i.height, t)), n({ type: BI, payload: { width: t.width, height: t.height } }))
            }, 20)
          return 'buttons' === o.componentType
            ? ue.createElement(
                ue.Fragment,
                null,
                ue.createElement(mC, {
                  className: 'FIE_rotate_button_left',
                  id: Gy.IMAGE,
                  label: '-'.concat(o.angle, '°'),
                  Icon: hk,
                  onClick: function (e) {
                    var t = r - o.angle
                    a(e, t)
                  }
                }),
                ue.createElement(mC, {
                  className: 'FIE_rotate_button_right',
                  id: Gy.IMAGE,
                  label: '+'.concat(o.angle, '°'),
                  Icon: gk,
                  onClick: function (e) {
                    var t = r + o.angle
                    a(e, t)
                  }
                })
              )
            : ue.createElement(dk, {
                className: 'FIE_rotate-slider',
                min: -180,
                max: 180,
                value: r,
                angle: o.angle || 90,
                onChange: a,
                style: { marginBottom: 20 }
              })
        }
      }),
      r(p, Gy.FLIP_X, { id: Gy.FLIP_X, Item: HO }),
      r(p, Gy.FLIP_Y, { id: Gy.FLIP_Y, Item: BO }),
      r(p, Gy.BRIGHTNESS, {
        id: Gy.BRIGHTNESS,
        Item: eC,
        ItemOptions: function () {
          var e = Lg(AC(ry.Filters.Brighten, eE), 2),
            t = e[0],
            n = e[1]
          return ue.createElement(Jx, {
            className: 'FIE_brightness-option',
            min: -1,
            step: 0.05,
            max: 1,
            value: null != (e = t.brightness) ? e : eE.brightness,
            onChange: function (e) {
              n({ brightness: WC(e, -1, 1) })
            },
            style: tE
          })
        }
      }),
      r(p, Gy.CONTRAST, {
        id: Gy.CONTRAST,
        Item: nk,
        ItemOptions: function () {
          var e = Lg(AC(ry.Filters.Contrast, yk), 2),
            t = e[0],
            n = e[1]
          return ue.createElement(Jx, {
            className: 'FIE_contrast-option',
            min: -100,
            max: 100,
            value: null != (e = t.contrast) ? e : yk.contrast,
            onChange: function (e) {
              n({ contrast: WC(e, -100, 100) })
            },
            style: bk
          })
        }
      }),
      r(p, Gy.HSV, {
        id: Gy.HSV,
        Item: rk,
        ItemOptions: function (e) {
          function t(e, t) {
            o(r({}, e, +t))
          }
          e = e.t
          var n = Lg(AC(ry.Filters.HSV, Ek), 2),
            i = n[0],
            o = n[1]
          return ue.createElement(
            ue.Fragment,
            null,
            ue.createElement(
              xk,
              { className: 'FIE_hue-option-wrapper' },
              ue.createElement(uC, { className: 'FIE_hue-option-label' }, e('hue')),
              ue.createElement(Jx, {
                className: 'FIE_hue-option',
                min: 0,
                step: 1,
                max: 259,
                value: null != (n = i.hue) ? n : Ek.hue,
                onChange: function (e) {
                  return t('hue', e)
                },
                style: Sk
              })
            ),
            ue.createElement(
              xk,
              { className: 'FIE_saturation-option-wrapper' },
              ue.createElement(uC, { className: 'FIE_saturation-option-label' }, e('saturation')),
              ue.createElement(Jx, {
                className: 'FIE_saturation-option',
                min: -2,
                step: 0.5,
                max: 10,
                value: null != (n = i.saturation) ? n : Ek.saturation,
                onChange: function (e) {
                  return t('saturation', e)
                },
                style: Sk
              })
            ),
            ue.createElement(
              xk,
              { className: 'FIE_value-option-wrapper' },
              ue.createElement(uC, { className: 'FIE_value-option-label' }, e('value')),
              ue.createElement(Jx, {
                className: 'FIE_value-option',
                min: -2,
                step: 0.1,
                max: 2,
                value: null != (n = i.value) ? n : Ek.value,
                onChange: function (e) {
                  return t('value', e)
                },
                style: Sk
              })
            )
          )
        },
        hideFn: function (e) {
          return e.useCloudimage
        }
      }),
      r(p, Gy.BLUR, {
        id: Gy.BLUR,
        Item: ik,
        ItemOptions: function () {
          var e = Lg(AC(ry.Filters.Blur, Pk), 2),
            t = e[0],
            n = e[1]
          return ue.createElement(Jx, {
            className: 'FIE_blur-option',
            min: 0,
            max: 100,
            value: null != (e = t.blurRadius) ? e : Pk.blurRadius,
            onChange: function (e) {
              n({ blurRadius: WC(e, 0, 100) })
            },
            style: _k
          })
        }
      }),
      r(p, Gy.WARMTH, {
        id: Gy.WARMTH,
        Item: ok,
        ItemOptions: function () {
          var e = Lg(AC(Iw, Ik), 2),
            t = e[0],
            n = e[1]
          return ue.createElement(Jx, {
            className: 'FIE_warmth-option',
            min: 0,
            max: 200,
            value: null != (e = t.warmth) ? e : Ik.warmth,
            onChange: function (e) {
              n({ warmth: WC(e, 0, 200) })
            },
            style: Mk
          })
        },
        hideFn: function (e) {
          return e.useCloudimage
        }
      }),
      r(p, Gy.FILTERS, {
        id: Gy.FILTERS,
        Item: function () {
          var e = jC().originalImage
          ;(i = jC()),
            (t = i.dispatch),
            (n = i.filter),
            (r = s.exports.useCallback(function (e) {
              t({ type: ob, payload: { filter: e } })
            }, []))
          var t,
            n,
            r,
            i = Lg(
              s.exports.useMemo(
                function () {
                  return [n, r]
                },
                [n]
              ),
              2
            ),
            o = i[0],
            a = i[1]
          return ue.createElement(
            ak,
            { className: 'FIE_filters', style: Zk },
            Gk.map(function (t) {
              return ue.createElement(Wk, {
                key: t.label,
                filterLabel: t.label,
                filterFn: t.filterFn,
                applyFilter: a,
                isActive: o === t.filterFn,
                image: e
              })
            })
          )
        }
      }),
      r(p, Gy.WATERMARK, {
        id: Gy.WATERMARK,
        Item: function () {
          function e(e) {
            var t = e.width / e.height,
              n = {},
              r =
                (v < y
                  ? ((r = (y * x) / e.height), (n.height = e.height * r), (n.width = n.height * t))
                  : ((r = (v * x) / e.width), (n.width = e.width * r), (n.height = n.width / t)),
                _T(
                  _T(_T(_T({}, a.annotationsCommon), a[Gy.IMAGE]), n),
                  {},
                  {
                    padding: 1,
                    image: e,
                    x: b + v / 2 - n.width / 2,
                    y: w + y / 2 - n.height / 2,
                    id: LT,
                    name: Gy.IMAGE,
                    replaceCurrent: !0
                  }
                ))
            l({ type: GT, payload: r })
          }
          function t(e) {
            l({ type: GT, payload: _T(_T({}, 'function' == typeof e ? e(m) : e), {}, { id: LT }) })
          }
          function n() {
            return ue.createElement(bT, { watermark: m, saveWatermark: t, t: c })
          }
          var r = (u = jC()).annotations,
            i = u.shownImageDimensions,
            o = u.selectionsIds,
            a = u.config,
            l = u.dispatch,
            c = u.t,
            u = void 0 === (u = u.adjustments.crop) ? {} : u,
            d = vx(),
            f = (g = Lg(s.exports.useState(!1), 2))[0],
            h = g[1],
            p = s.exports.useRef(),
            g = a[Gy.WATERMARK],
            m = s.exports.useMemo(
              function () {
                return r[LT]
              },
              [r[LT]]
            ),
            v = u.width || i.width,
            y = u.height || i.height,
            b = u.x || 0,
            w = u.y || 0,
            C = g.textScalingRatio || 0.33,
            x = g.imageScalingRatio || 0.33
          i = [
            !a.useCloudimage && {
              key: 'upload-watermark',
              label: c('uploadWatermark'),
              icon: _L,
              onClick: function () {
                p.current && p.current.click()
              }
            },
            {
              key: 'add-text-watermark',
              label: c('addWatermarkAsText'),
              icon: Yk,
              onClick: function () {
                var e = { height: y * C, width: v * C }
                e = _T(
                  _T(_T(_T({}, a.annotationsCommon), a[Gy.TEXT]), e),
                  {},
                  {
                    padding: 1,
                    x: b + v / 2 - e.width / 2,
                    y: w + y / 2 - e.height / 2,
                    fill: '#000000',
                    id: LT,
                    name: Gy.TEXT,
                    replaceCurrent: !0
                  }
                )
                l({ type: GT, payload: e })
              }
            }
          ]
          return (
            s.exports.useEffect(
              function () {
                m && (l({ type: JT }), l({ type: $T, payload: { annotationId: 'watermark' } }))
              },
              [m]
            ),
            s.exports.useEffect(
              function () {
                !m || (0 !== o.length && o[0].id === LT) || l({ type: $T, payload: { annotationId: 'watermark' } })
              },
              [o]
            ),
            ue.createElement(
              'div',
              { className: 'FIE_watermark-tool-wrapper' },
              (null == m ? void 0 : m.name) === Gy.TEXT &&
                ue.createElement(
                  OT,
                  { className: 'FIE_watermark-options-wrapper' },
                  ue.createElement(x_, { text: m, saveText: t, t: c }, n())
                ),
              (null == m ? void 0 : m.name) === Gy.IMAGE &&
                ue.createElement(
                  OT,
                  { className: 'FIE_watermark-options-wrapper' },
                  ue.createElement(O_, { image: m, saveImage: t, t: c }, n())
                ),
              ue.createElement(
                ST,
                { className: 'FIE_watermark-add-wrapper', noWrap: null != m && m.name },
                ue.createElement(S_, {
                  className: 'FIE_watermark-add',
                  color: 'secondary',
                  label: c('addWatermark'),
                  title: c('addWatermarkTitle'),
                  menuPosition: 'top',
                  menuItems: i,
                  menuFromBtn: !0
                }),
                ue.createElement(yT, {
                  selectWatermark: e,
                  style: d && null != m && m.name ? { width: '55%' } : void 0
                }),
                ue.createElement(XL, {
                  onChange: f
                    ? void 0
                    : function (t) {
                        var n, r
                        t.target.files &&
                          (h(!0), (n = t.target.files[0]).type.startsWith('image/')) &&
                          (((r = new Image()).onload = function () {
                            e(r), URL.revokeObjectURL(n), h(!1)
                          }),
                          (r.onerror = function () {
                            var e
                            ;(e = c('uploadImageError')),
                              l({ type: Xw, payload: { feedback: { message: e, status: tb } } }),
                              h(!1)
                          }),
                          (r.src = URL.createObjectURL(n))),
                          (t.target.value = '')
                      },
                  disabled: f,
                  ref: p
                })
              )
            )
          )
        }
      }),
      r(p, Gy.TEXT, {
        id: Gy.TEXT,
        Item: sk,
        ItemOptions: function (e) {
          e = e.t
          var t = (n = Lg(hx({ name: Gy.TEXT }), 2))[0],
            n = n[1]
          return ue.createElement(x_, { text: t, saveText: n, t: e })
        }
      }),
      r(p, Gy.IMAGE, {
        id: Gy.IMAGE,
        Item: E_,
        ItemOptions: function () {
          function e(e) {
            var t = g.width || h.width,
              n = g.height || h.height,
              r = g.x || 0,
              i = g.y || 0,
              o = Math.min(1, t / (e.width + 0.15 * e.width), n / (e.height + 0.15 * e.height))
            C({
              image: e,
              x: r + t / 2 - (e.width * o) / 2,
              y: i + n / 2 - (e.height * o) / 2,
              width: e.width * o,
              height: e.height * o
            })
          }
          function t(e) {
            ;(x.current += 1), x.current === e && ((x.current = 0), l(!1))
          }
          function n(e) {
            p({ type: Xw, payload: { feedback: { message: e, status: tb } } })
          }
          function r() {
            d.current && d.current.click()
          }
          function i() {
            u(f.current)
          }
          var o,
            a = (o = Lg(s.exports.useState(), 2))[0],
            l = o[1],
            c = (o = Lg(s.exports.useState(null), 2))[0],
            u = o[1],
            d = s.exports.useRef(),
            f = s.exports.useRef(),
            h = (o = jC()).shownImageDimensions,
            p = o.dispatch,
            g = void 0 === (E = o.adjustments.crop) ? {} : E,
            m = o.t,
            v = !(o = (void 0 === (E = o.config) ? {} : E)[Gy.IMAGE]).disableUpload,
            y = Array.isArray(o.gallery) && 0 < o.gallery.length,
            b = (E = Lg(hx({ name: Gy.IMAGE, opacity: 1 }, !1), 3))[0],
            w = E[1],
            C = E[2],
            x = s.exports.useRef(0),
            E = s.exports.useMemo(
              function () {
                return [
                  v && {
                    key: 'add-by-upload-image',
                    label: m(a ? 'importing' : 'uploadImage'),
                    icon: PL,
                    onClick: a ? void 0 : r
                  },
                  y && { key: 'add-from-gallery', label: m('fromGallery'), icon: dL, onClick: i }
                ]
              },
              [o, a, m]
            )
          return ue.createElement(
            O_,
            { image: b, saveImage: w, t: m },
            ue.createElement(S_, {
              className: 'FIE_image-tool-add-option',
              color: 'secondary',
              label: m('addImage'),
              title: m('addImageTitle'),
              menuPosition: 'top',
              menuItems: E,
              size: 'sm',
              style: { maxHeight: 24 },
              buttonRef: f,
              menuFromBtn: !0
            }),
            v &&
              ue.createElement(XL, {
                ref: d,
                onChange: a
                  ? void 0
                  : function (r) {
                      var i, o, a
                      r.target.files &&
                        (l(!0),
                        (i = []),
                        (a = Array.from(r.target.files)),
                        (o = a.length),
                        a.forEach(function (r) {
                          var a
                          r.type.startsWith('image/')
                            ? (((a = new Image()).onload = function () {
                                e(a), URL.revokeObjectURL(r), t(o)
                              }),
                              (a.onerror = function () {
                                n(m('uploadImageError')), t(o)
                              }),
                              (a.src = URL.createObjectURL(r)))
                            : (i.push(r.name), t(o))
                        }),
                        0 < i.length) &&
                        ((a = m(1 < i.length ? 'areNotImages' : 'isNotImage')),
                        n(''.concat(i.join(', '), ' ').concat(a, ' ').concat(m('toBeUploaded'), '.'))),
                        (r.target.value = '')
                    },
                disabled: a,
                multiple: !0
              }),
            y &&
              ue.createElement(k_, {
                gallery: o.gallery,
                onSelect: function (r) {
                  l(!0)
                  var i = new Image()
                  ;(i.onload = function () {
                    e(i), t(1)
                  }),
                    (i.onerror = function () {
                      n(m('uploadImageError')), t(1)
                    }),
                    (i.crossOrigin = 'Anonymous'),
                    (i.src = r)
                },
                onClose: function () {
                  u(null)
                },
                anchorEl: c
              })
          )
        }
      }),
      r(p, Gy.RECT, {
        id: Gy.RECT,
        Item: P_,
        ItemOptions: function (e) {
          e = e.t
          var t = (n = Lg(hx({ name: Gy.RECT }), 2))[0],
            n = n[1]
          return ue.createElement(C_, {
            className: 'FIE_rect-tool-options',
            moreOptionsPopupComponentsObj: oT,
            morePoppableOptionsPrepended: iT,
            annotation: t,
            updateAnnotation: n,
            t: e
          })
        }
      }),
      r(p, Gy.POLYGON, {
        id: Gy.POLYGON,
        Item: uT,
        ItemOptions: function (e) {
          e = e.t
          var t = (n = Lg(hx({ name: Gy.POLYGON }), 2))[0],
            n = n[1]
          return ue.createElement(C_, {
            className: 'FIE_polygon-tool-options',
            morePoppableOptionsPrepended: fT,
            moreOptionsPopupComponentsObj: hT,
            annotation: t,
            updateAnnotation: n,
            t: e,
            hidePositionField: !0
          })
        }
      }),
      r(p, Gy.ELLIPSE, {
        id: Gy.ELLIPSE,
        Item: __,
        ItemOptions: function (e) {
          e = e.t
          var t = (n = Lg(hx({ name: Gy.ELLIPSE }), 2))[0],
            n = n[1]
          return ue.createElement(C_, {
            className: 'FIE_ellipse-tool-options',
            annotation: t,
            updateAnnotation: n,
            t: e
          })
        }
      }),
      r(p, Gy.PEN, {
        id: Gy.PEN,
        Item: L_,
        ItemOptions: function (e) {
          e = e.t
          var t,
            n = (t = jC()).dispatch,
            r = t.designLayer,
            i = t.previewGroup,
            o = (t = Lg(
              hx(lT(lT(lT({}, (t = t.config).annotationsCommon), t[Gy.PEN]), {}, { name: Gy.PEN }), !1),
              3
            ))[0],
            a = t[1],
            l = t[2],
            c = s.exports.useRef(null),
            u = s.exports.useRef({ points: [], moved: !1, id: '' }),
            d = s.exports.useCallback(
              function () {
                var e = zC(c.current.content)
                return [(e = NC(i, e)).offsetX - (r.attrs.xPadding || 0), e.offsetY - (r.attrs.yPadding || 0)]
              },
              [r]
            ),
            f = s.exports.useCallback(
              function () {
                u.current.moved
                  ? ((u.current.points = u.current.points.concat(d())),
                    n({ type: GT, payload: { id: u.current.id, points: u.current.points, dismissHistory: !0 } }))
                  : ((u.current = { moved: !0, id: HC(Gy.PEN), points: [].concat(Dp(u.current.points), Dp(d())) }),
                    l({ id: u.current.id, name: Gy.PEN, points: u.current.points }))
              },
              [d]
            ),
            h = s.exports.useCallback(
              function () {
                u.current.id && n({ type: $T, payload: { annotationId: u.current.id } }),
                  (u.current = null),
                  c.current.off('mousemove touchmove', f),
                  c.current.off('mouseleave touchcancel', h),
                  document.removeEventListener('mouseup', h, dT),
                  document.removeEventListener('touchend', h, dT),
                  document.removeEventListener('mouseleave', h, dT),
                  document.removeEventListener('touchcancel', h, dT)
              },
              [f]
            ),
            p = s.exports.useCallback(
              function (e) {
                e.target.attrs.draggable ||
                  (e.evt.preventDefault(),
                  (u.current = { points: d() }),
                  c.current.on('mousemove touchmove', f),
                  c.current.on('mouseleave touchcancel', h),
                  document.addEventListener('mouseup', h, dT),
                  document.addEventListener('touchend', h, dT),
                  document.addEventListener('mouseleave', h, dT),
                  document.addEventListener('touchcancel', h, dT))
              },
              [d, f, h]
            )
          return (
            s.exports.useEffect(
              function () {
                return (
                  (c.current = null == r ? void 0 : r.getStage()),
                  c.current && c.current.on('mousedown touchstart', p),
                  function () {
                    c.current && c.current.off('mousedown touchstart', p)
                  }
                )
              },
              [r]
            ),
            ue.createElement(C_, {
              className: 'FIE_pen-tool-options',
              annotation: o,
              updateAnnotation: a,
              t: e,
              hidePositionField: !0,
              hideFillOption: !0
            })
          )
        }
      }),
      r(p, Gy.LINE, {
        id: Gy.LINE,
        Item: sT,
        ItemOptions: function (e) {
          e = e.t
          var t = (n = Lg(hx({ name: Gy.LINE }), 2))[0],
            n = n[1]
          return ue.createElement(C_, {
            className: 'FIE_line-tool-options',
            annotation: t,
            updateAnnotation: n,
            t: e,
            hidePositionField: !0,
            hideFillOption: !0
          })
        }
      }),
      r(p, Gy.ARROW, {
        id: Gy.ARROW,
        Item: cT,
        ItemOptions: function (e) {
          e = e.t
          var t = (n = Lg(hx({ name: Gy.ARROW }), 2))[0],
            n = n[1]
          return ue.createElement(C_, {
            className: 'FIE_arrow-tool-options',
            annotation: t,
            updateAnnotation: n,
            t: e,
            hidePositionField: !0,
            hideFillOption: !0
          })
        }
      }),
      r(p, Gy.RESIZE, { id: Gy.RESIZE, Item: vT }),
      p),
    IT =
      (r((wS = {}), Wy.ADJUST, [Gy.CROP, Gy.ROTATE, Gy.FLIP_X, Gy.FLIP_Y]),
      r(wS, Wy.FINETUNE, [Gy.BRIGHTNESS, Gy.CONTRAST, Gy.HSV, Gy.BLUR, Gy.WARMTH]),
      r(wS, Wy.FILTERS, [Gy.FILTERS]),
      r(wS, Wy.WATERMARK, [Gy.WATERMARK]),
      r(wS, Wy.ANNOTATE, [Gy.TEXT, Gy.IMAGE, Gy.RECT, Gy.ELLIPSE, Gy.POLYGON, Gy.PEN, Gy.LINE, Gy.ARROW]),
      r(wS, Wy.RESIZE, [Gy.RESIZE]),
      wS)
  function MT(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function jT(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? MT(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : MT(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var RT = 'SELECT_TAB'
  function DT(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function AT(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? DT(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : DT(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var zT = 'UNDO'
  function NT(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function FT(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? NT(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : NT(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var HT = 'SET_FINETUNE',
    BT = ['dismissHistory', 'replaceCurrent']
  function VT(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function WT(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? VT(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : VT(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var GT = 'SET_ANNOTATION'
  function ZT(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function UT(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? ZT(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : ZT(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var XT = 'CHANGE_POINTER_ICON'
  function YT(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function qT(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? YT(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : YT(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var $T = 'SELECT_ANNOTATION'
  function KT(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function QT(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? KT(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : KT(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var JT = 'CLEAR_ANNOTATIONS_SELECTIONS'
  function eI(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function tI(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? eI(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : eI(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var nI = 'TOGGLE_ORIGINAL_IMAGE_DISPLAY'
  function rI(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function iI(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? rI(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : rI(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var oI = 'SELECT_TOOL'
  function aI(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function lI(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? aI(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : aI(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var sI = 'TOGGLE_FLIP'
  function cI(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function uI(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? cI(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : cI(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var dI = 'SET_CROP'
  function fI(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function hI(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? fI(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : fI(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var pI = 'CHANGE_ROTATION'
  function gI(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function mI(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? gI(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : gI(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var vI = ['preparedDimensions']
  function yI(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function bI(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? yI(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : yI(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var wI = 'ZOOM_CANVAS'
  function CI(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function xI(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? CI(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : CI(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var EI = 'SET_CANVAS_SIZE'
  function SI(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function OI(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? SI(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : SI(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var kI = 'SET_ORIGINAL_IMAGE'
  function PI(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function _I(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? PI(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : PI(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var LI = 'SET_SHOWN_IMAGE_DIMENSIONS'
  function TI(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function II(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? TI(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : TI(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var MI = 'REMOVE_ANNOTATIONS'
  function jI(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function RI(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? jI(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : jI(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var DI = 'DUPLICATE_ANNOTATIONS'
  function AI(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function zI(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? AI(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : AI(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var NI = 'ENABLE_TEXT_CONTENT_EDIT'
  function FI(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function HI(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? FI(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : FI(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var BI = 'SET_RESIZE'
  function VI(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function WI(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? VI(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : VI(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var GI = 'SET_SAVED'
  function ZI(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  var UI = function (t) {
      var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
        i = !!(2 < arguments.length && void 0 !== arguments[2]) && arguments[2],
        o = (function (e) {
          for (var t, n = 1; n < arguments.length; n++)
            (t = null == arguments[n] ? {} : arguments[n]),
              n % 2
                ? ZI(Object(t), !0).forEach(function (n) {
                    r(e, n, t[n])
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
                : ZI(Object(t)).forEach(function (n) {
                    Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
                  })
          return e
        })({}, t)
      return (
        Object.keys(n).forEach(function (r) {
          var a = n[r]
          void 0 !== a &&
            ('object' !== e(a) || null === a || Array.isArray(a) || !t[r] || 'object' !== e(t[r])
              ? (o[r] = i && Array.isArray(o[r]) && Array.isArray(a) ? [].concat(Dp(o[r]), Dp(a)) : a)
              : (o[r] = UI(t[r], a)))
        }),
        o
      )
    },
    XI = 'UPDATE_STATE'
  function YI(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function qI(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? YI(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : YI(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function $I(e, t) {
    var n = e.x,
      r = ((e = e.y), (t = (t * Math.PI) / 180), Math.cos(t))
    return { x: n * r - e * (t = Math.sin(t)), y: e * r + n * t }
  }
  var KI = 'SET_LATEST_COLOR',
    QI =
      (r((rC = {}), kI, function (e, t) {
        return OI(OI({}, e), {}, { feedback: {}, originalImage: t.originalImage, imgSrc: t.originalImage.src })
      }),
      r(rC, Xw, function (e, t) {
        return Uw(Uw({}, e), {}, { isLoadingGlobally: !1, feedback: t.feedback || {} })
      }),
      r(rC, $w, function (e) {
        return qw(qw({}, e), {}, { isLoadingGlobally: !0 })
      }),
      r(rC, sb, function (e) {
        return lb(lb({}, e), {}, { isLoadingGlobally: !1 })
      }),
      r(rC, XT, function (e, t) {
        return e.pointerCssIcon === t.pointerCssIcon ? e : UT(UT({}, e), {}, { pointerCssIcon: t.pointerCssIcon })
      }),
      r(rC, $T, function (e, t) {
        var n
        return 1 === e.selectionsIds.length && e.selectionsIds[0] === t.annotationId
          ? e
          : (t.multiple
              ? (n = e.selectionsIds.filter(function (e) {
                  return e !== t.annotationId
                })).length === e.selectionsIds.length && n.push(t.annotationId)
              : (n = [t.annotationId]),
            qT(qT({}, e), {}, { selectionsIds: n }))
      }),
      r(rC, JT, function (e) {
        return 0 === e.selectionsIds.length ? e : QT(QT({}, e), {}, { selectionsIds: [] })
      }),
      r(rC, nI, function (e, t) {
        return tI(tI({}, e), {}, { isShowOriginalImage: t.isShow })
      }),
      r(rC, RT, function (e, t) {
        return t.tabId === e.tabId
          ? e
          : jT(
              jT({}, e),
              {},
              {
                tabId: t.tabId,
                toolId: IT[t.tabId][0],
                selectionsIds: [],
                pointerCssIcon: t.tabId === Wy.ANNOTATE ? Yy.DRAW : Yy.DEFAULT
              }
            )
      }),
      r(rC, oI, function (e, t) {
        return e.toolId === t.toolId
          ? e
          : iI(iI({}, e), {}, { toolId: t.toolId, selectionsIds: t.keepSelections ? e.selectionsIds : [] })
      }),
      r(rC, wI, function (e, t) {
        var n,
          r,
          i,
          o,
          a,
          l = WC(parseFloat(t.factor).toFixed(2), 0.05, 55)
        return (t = t.preparedDimensions
          ? (t.preparedDimensions, Hu(t, vI))
          : ((t = {
              x: t.x || 0 === t.x ? (null != (n = t.x) ? n : e.zoom.x) : e.canvasWidth / 2,
              y: t.y || 0 === t.y ? (null != (n = t.y) ? n : e.zoom.y) : e.canvasHeight / 2
            }),
            (n = bI(bI({}, t), {}, { factor: l })),
            (t = e.zoom),
            (l = e.canvasWidth),
            (r = e.canvasHeight),
            1 === n.factor
              ? { x: 0, y: 0, factor: 1 }
              : ((a = n.factor > t.factor),
                (i = (n.x - t.x || 0) / t.factor),
                (o = (n.y - t.y || 0) / t.factor),
                (i = { x: n.x - i * n.factor, y: n.y - o * n.factor }),
                (a && 1 === t.factor) ||
                  ((i.x = Math.min(0, Math.max(i.x, l * (1 - t.factor)))),
                  (i.y = Math.min(0, Math.max(i.y, r * (1 - t.factor))))),
                n.factor < 1 && ((o = l - l * n.factor), (a = r - r * n.factor), (i.x += o / 2), (i.y += a / 2)),
                mI(mI({}, i), {}, { factor: n.factor })))).factor === e.zoom.factor &&
          t.x === e.zoom.x &&
          t.y === e.zoom.y
          ? e
          : bI(bI({}, e), {}, { zoom: bI(bI({}, e.zoom), t) })
      }),
      r(rC, EI, function (e, t) {
        var n, r, i, o, a
        return e.canvasWidth === t.canvasWidth && e.canvasHeight === t.canvasHeight
          ? e
          : ((n = void 0 === (n = e.initialCanvasWidth) ? t.canvasWidth : n),
            (r = void 0 === (r = e.initialCanvasHeight) ? t.canvasHeight : r),
            (i =
              (o = Ay(e.initialCanvasWidth, e.initialCanvasHeight, e.originalImage.width, e.originalImage.height)) *
              e.originalImage.width),
            (o *= e.originalImage.height),
            (a = 1),
            (n === t.canvasWidth && r === t.canvasHeight) ||
              ((i = t.canvasWidth / i), (o = t.canvasHeight / o), (a = Math.min(i, o))),
            xI(
              xI({}, e),
              {},
              {
                initialCanvasWidth: n,
                initialCanvasHeight: r,
                canvasWidth: t.canvasWidth,
                canvasHeight: t.canvasHeight,
                canvasScale: a
              }
            ))
      }),
      r(rC, LI, function (e, t) {
        return _I(
          _I({}, e),
          {},
          {
            shownImageDimensions: _I(_I({}, e.shownImageDimensions), t.shownImageDimensions),
            designLayer: t.designLayer || e.designLayer,
            previewGroup: t.previewGroup || e.previewGroup
          }
        )
      }),
      r(rC, NI, function (e, t) {
        return zI(zI({}, e), {}, { textIdOfEditableContent: t.textIdOfEditableContent || null })
      }),
      r(rC, KI, function (e, t) {
        return qI(qI({}, e), {}, { latestColors: qI(qI({}, e.latestColors), t.latestColors) })
      }),
      r(rC, ob, function (e, t) {
        return ib(ib({}, e), {}, { isDesignState: !t.dismissHistory, filter: t.filter || null })
      }),
      r(rC, HT, function (e, t) {
        return FT(
          FT({}, e),
          {},
          {
            isDesignState: !t.dismissHistory,
            finetunes:
              !t.finetune || e.finetunes.includes(t.finetune) ? e.finetunes : [].concat(Dp(e.finetunes), [t.finetune]),
            finetunesProps: FT(FT({}, e.finetunesProps), t.finetuneProps)
          }
        )
      }),
      r(rC, GT, function (e) {
        var t = (o = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}).dismissHistory,
          n = o.replaceCurrent,
          i = Hu(o, BT),
          o = null != (o = i.id) ? o : HC(i.name),
          a = e.annotations[o]
        return a &&
          !Object.keys(i).some(function (e) {
            return (i[e] || 0 === i[e]) && i[e] !== a[e]
          })
          ? e
          : WT(
              WT({}, e),
              {},
              {
                isDesignState: !(void 0 !== t && t),
                annotations: WT(WT({}, e.annotations), {}, r({}, o, WT(WT({}, void 0 !== n && n ? {} : a), i)))
              }
            )
      }),
      r(rC, dI, function (e, t) {
        var n = null != (n = e.adjustments.crop) ? n : {},
          r = {
            x: null != (r = Mx(t.x)) ? r : n.x,
            y: null != (r = Mx(t.y)) ? r : n.y,
            ratio: 'string' == typeof t.ratio ? t.ratio : null != (r = Mx(t.ratio)) ? r : n.ratio,
            width: null != (r = Mx(t.width)) ? r : n.width,
            height: null != (r = Mx(t.height)) ? r : n.height,
            ratioTitleKey: null != (r = t.ratioTitleKey) ? r : n.ratioTitleKey,
            ratioGroupKey: t.ratioGroupKey,
            ratioFolderKey: t.ratioFolderKey
          }
        return n.x === r.x &&
          n.y === r.y &&
          (n.width === r.width ||
            (r.width === Mx(e.shownImageDimensions.width) && null !== !n.width && r.ratio !== qy)) &&
          (n.height === r.height ||
            (r.height === Mx(e.shownImageDimensions.height) && null !== n.height && r.ratio !== qy)) &&
          n.ratio === r.ratio &&
          n.ratioTitleKey === r.ratioTitleKey &&
          n.ratioGroupKey === r.ratioGroupKey &&
          n.ratioFolderKey === r.ratioFolderKey
          ? e
          : uI(
              uI({}, e),
              {},
              {
                isDesignState: !t.dismissHistory,
                adjustments: uI(uI({}, e.adjustments), {}, { crop: uI(uI({}, n), r) })
              }
            )
      }),
      r(rC, pI, function (e, t) {
        return e.adjustments.rotation === t.rotation
          ? e
          : hI(
              hI({}, e),
              {},
              { isDesignState: !t.dismissHistory, adjustments: hI(hI({}, e.adjustments), {}, { rotation: t.rotation }) }
            )
      }),
      r(rC, sI, function (e, t) {
        var n = 'isFlipped'.concat('X' === t.direction ? 'X' : 'Y')
        return lI(
          lI({}, e),
          {},
          { isDesignState: !t.dismissHistory, adjustments: lI(lI({}, e.adjustments), {}, r({}, n, !e.adjustments[n])) }
        )
      }),
      r(rC, BI, function (e, t) {
        return HI(
          HI({}, e),
          {},
          {
            isDesignState: !t.dismissHistory,
            resize: HI(HI(HI({}, e.resize), t), {}, { manualChangeDisabled: null != (e = t.manualChangeDisabled) && e })
          }
        )
      }),
      r(rC, MI, function (e, t) {
        var n = e.annotations,
          r = e.selectionsIds
        return (
          t.annotationsIds.forEach(function (t) {
            var i
            ;(r = r.filter(function (e) {
              return e !== t
            })),
              e.designLayer && n[t] && ((i = e.designLayer.findOne('#'.concat(t))) && i.destroy(), delete n[t])
          }),
          II(II({}, e), {}, { isDesignState: t.isDesignState || !0, annotations: n, selectionsIds: [] })
        )
      }),
      r(rC, DI, function (e, t) {
        var n = e.annotations,
          r = {}
        return (
          t.annotationsIds.forEach(function (e) {
            var t
            ;(e = n[e]) && ((t = HC(e.name)), (r[t] = RI(RI({}, e), {}, { id: t, x: e.x + 20, y: e.y + 20 })))
          }),
          RI(RI({}, e), {}, { isDesignState: !t.dismissHistory, annotations: RI(RI({}, n), r) })
        )
      }),
      r(rC, zT, function (e) {
        var t, n, r
        return e.pastDesignStates && 0 < e.pastDesignStates.length
          ? ((r = Nw(e)),
            (t = (n = cb(e.pastDesignStates))[0]),
            (n = n.slice(1)),
            (r = [r].concat(Dp(e.futureDesignStates || []))),
            AT(
              AT(AT({}, e), t),
              {},
              {
                selectionsIds: [],
                pastDesignStates: n,
                futureDesignStates: r,
                hasUndo: 0 < n.length,
                hasRedo: !0,
                haveNotSavedChanges: 0 < n.length
              }
            ))
          : e
      }),
      r(rC, Bw, function (e) {
        var t, n, r
        return e.futureDesignStates && 0 < e.futureDesignStates.length
          ? ((r = Nw(e)),
            (t = (n = cb(e.futureDesignStates))[0]),
            (n = n.slice(1)),
            (r = [r].concat(Dp(e.pastDesignStates || []))),
            Hw(
              Hw(Hw({}, e), t),
              {},
              {
                selectionsIds: [],
                pastDesignStates: r,
                futureDesignStates: n,
                hasUndo: !0,
                hasRedo: 0 < n.length,
                haveNotSavedChanges: !0
              }
            ))
          : e
      }),
      r(rC, Gw, function (e, t) {
        return (
          (t = Nw(Ww(Ww({}, t.config), {}, { imgSrc: e.imgSrc }), !0)),
          Ww(
            Ww(Ww({}, e), t),
            {},
            {
              selectionsIds: [],
              isResetted: !0,
              pastDesignStates: [],
              futureDesignStates: [],
              hasUndo: !1,
              hasRedo: !1,
              haveNotSavedChanges: !1
            }
          )
        )
      }),
      r(rC, GI, function (e) {
        return e.haveNotSavedChanges ? WI(WI({}, e), {}, { haveNotSavedChanges: !1 }) : e
      }),
      r(rC, XI, function (e, t) {
        return (t = t && 'function' == typeof t ? t(e) : t) ? UI(e, t) : e
      }),
      rC)
  iC = { exports: {} }
  function JI() {}
  function eM() {}
  function tM(e, t, n, r, i, o) {
    if ('SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED' !== o)
      throw (
        (((o = new Error(
          'Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types'
        )).name = 'Invariant Violation'),
        o)
      )
  }
  function nM() {
    return tM
  }
  ;(eM.resetWarningCache = JI),
    (iC.exports = (h = {
      array: (tM.isRequired = tM),
      bool: tM,
      func: tM,
      number: tM,
      object: tM,
      string: tM,
      symbol: tM,
      any: tM,
      arrayOf: nM,
      element: tM,
      elementType: tM,
      instanceOf: nM,
      node: tM,
      objectOf: nM,
      oneOf: nM,
      oneOfType: nM,
      shape: nM,
      exact: nM,
      checkPropTypes: eM,
      resetWarningCache: JI
    }).PropTypes =
      h)
  ;(l = iC.exports).string.isRequired,
    l.string.isRequired,
    l.number,
    l.number,
    l.number,
    l.string,
    l.number,
    l.number,
    l.number,
    l.number,
    l.string,
    l.number,
    l.number,
    (y = {
      rotation: 0,
      scaleX: 1,
      scaleY: 1,
      stroke: void 0,
      strokeWidth: void 0,
      shadowOffsetX: void 0,
      shadowOffsetY: void 0,
      shadowBlur: void 0,
      shadowColor: void 0,
      shadowOpacity: void 0,
      opacity: 1
    })
  var rM = [
    'id',
    'name',
    'fill',
    'x',
    'y',
    'width',
    'height',
    'scaleX',
    'scaleY',
    'rotation',
    'annotationEvents',
    'stroke',
    'strokeWidth',
    'shadowOffsetX',
    'shadowOffsetY',
    'shadowBlur',
    'shadowColor',
    'shadowOpacity',
    'opacity',
    'cornerRadius'
  ]
  function iM(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function oM(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? iM(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : iM(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function aM(e) {
    var t = e.id,
      n = e.name,
      r = e.fill,
      i = e.x,
      o = e.y,
      a = e.width,
      l = e.height,
      s = e.scaleX,
      c = e.scaleY,
      u = e.rotation,
      d = e.annotationEvents,
      f = e.stroke,
      h = e.strokeWidth,
      p = e.shadowOffsetX,
      g = e.shadowOffsetY,
      m = e.shadowBlur,
      v = e.shadowColor,
      y = e.shadowOpacity,
      b = e.opacity,
      w = e.cornerRadius
    e = Hu(e, rM)
    return ue.createElement(
      'Rect',
      Tg(
        {
          id: t,
          name: n,
          rotation: u,
          scaleX: s,
          scaleY: c,
          stroke: f,
          strokeWidth: h,
          shadowOffsetX: p,
          shadowOffsetY: g,
          shadowBlur: m,
          shadowColor: v,
          shadowOpacity: y,
          fill: r,
          x: i,
          y: o,
          width: a,
          height: l,
          opacity: b,
          cornerRadius: w
        },
        d,
        e
      )
    )
  }
  aM.defaultProps = oM(oM({}, y), {}, { fill: '#000', cornerRadius: 0, width: 0, height: 0 })
  var lM = [
    'id',
    'name',
    'fill',
    'x',
    'y',
    'radiusX',
    'radiusY',
    'scaleX',
    'scaleY',
    'rotation',
    'annotationEvents',
    'stroke',
    'strokeWidth',
    'shadowOffsetX',
    'shadowOffsetY',
    'shadowBlur',
    'shadowColor',
    'shadowOpacity',
    'opacity'
  ]
  function sM(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function cM(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? sM(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : sM(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function uM(e) {
    var t = e.id,
      n = e.name,
      r = e.fill,
      i = e.x,
      o = e.y,
      a = e.radiusX,
      l = e.radiusY,
      s = e.scaleX,
      c = e.scaleY,
      u = e.rotation,
      d = e.annotationEvents,
      f = e.stroke,
      h = e.strokeWidth,
      p = e.shadowOffsetX,
      g = e.shadowOffsetY,
      m = e.shadowBlur,
      v = e.shadowColor,
      y = e.shadowOpacity,
      b = e.opacity
    e = Hu(e, lM)
    return ue.createElement(
      My,
      Tg(
        {
          id: t,
          name: n,
          rotation: u,
          scaleX: s,
          scaleY: c,
          stroke: f,
          strokeWidth: h,
          shadowOffsetX: p,
          shadowOffsetY: g,
          shadowBlur: m,
          shadowColor: v,
          shadowOpacity: y,
          fill: r,
          x: i,
          y: o,
          radiusX: a,
          radiusY: l,
          offsetX: -a,
          offsetY: -l,
          opacity: b
        },
        d,
        e
      )
    )
  }
  uM.defaultProps = cM(cM({}, y), {}, { fill: '#000', radiusX: 0, radiusY: 0 })
  var dM = [
    'id',
    'name',
    'fill',
    'x',
    'y',
    'radius',
    'scaleX',
    'scaleY',
    'rotation',
    'sides',
    'annotationEvents',
    'stroke',
    'strokeWidth',
    'shadowOffsetX',
    'shadowOffsetY',
    'shadowBlur',
    'shadowColor',
    'shadowOpacity',
    'opacity'
  ]
  function fM(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function hM(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? fM(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : fM(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function pM(e) {
    var t = e.id,
      n = e.name,
      r = e.fill,
      i = e.x,
      o = e.y,
      a = e.radius,
      l = e.scaleX,
      s = e.scaleY,
      c = e.rotation,
      u = e.sides,
      d = e.annotationEvents,
      f = e.stroke,
      h = e.strokeWidth,
      p = e.shadowOffsetX,
      g = e.shadowOffsetY,
      m = e.shadowBlur,
      v = e.shadowColor,
      y = e.shadowOpacity,
      b = e.opacity
    e = Hu(e, dM)
    return ue.createElement(
      'RegularPolygon',
      Tg(
        {
          id: t,
          name: n,
          rotation: c,
          scaleX: l,
          scaleY: s,
          stroke: f,
          strokeWidth: h,
          shadowOffsetX: p,
          shadowOffsetY: g,
          shadowBlur: m,
          shadowColor: v,
          shadowOpacity: y,
          fill: r,
          x: i,
          y: o,
          radius: a,
          offsetX: -a,
          offsetY: -a,
          sides: u,
          opacity: b
        },
        d,
        e
      )
    )
  }
  pM.defaultProps = hM(hM({}, y), {}, { fill: '#000', sides: 3 })
  var gM = [
    'id',
    'name',
    'text',
    'fontFamily',
    'fontSize',
    'fontStyle',
    'fill',
    'x',
    'y',
    'width',
    'height',
    'scaleX',
    'scaleY',
    'rotation',
    'annotationEvents',
    'stroke',
    'strokeWidth',
    'shadowOffsetX',
    'shadowOffsetY',
    'shadowBlur',
    'shadowColor',
    'shadowOpacity',
    'opacity',
    'letterSpacing',
    'lineHeight',
    'align'
  ]
  function mM(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function vM(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? mM(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : mM(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function yM(e) {
    var t = e.id,
      n = e.name,
      r = e.text,
      i = e.fontFamily,
      o = e.fontSize,
      a = e.fontStyle,
      l = e.fill,
      s = e.x,
      c = e.y,
      u = e.width,
      d = e.height,
      f = e.scaleX,
      h = e.scaleY,
      p = e.rotation,
      g = e.annotationEvents,
      m = e.stroke,
      v = e.strokeWidth,
      y = e.shadowOffsetX,
      b = e.shadowOffsetY,
      w = e.shadowBlur,
      C = e.shadowColor,
      x = e.shadowOpacity,
      E = e.opacity,
      S = e.letterSpacing,
      O = e.lineHeight,
      k = e.align
    e = Hu(e, gM)
    return ue.createElement(
      'Text',
      Tg(
        {
          id: t,
          name: n,
          rotation: p,
          scaleX: f,
          scaleY: h,
          stroke: m,
          strokeWidth: v,
          shadowOffsetX: y,
          shadowOffsetY: b,
          shadowBlur: w,
          shadowColor: C,
          shadowOpacity: x,
          opacity: E,
          fill: l,
          text: r,
          fontFamily: i,
          fontStyle: a,
          fontSize: o,
          letterSpacing: S,
          lineHeight: O,
          align: k,
          x: s,
          y: c,
          width: u,
          height: d
        },
        g,
        e
      )
    )
  }
  function bM(e, t) {
    return new Promise(function (n, r) {
      var i = new Image()
      ;(i.crossOrigin = 'Anonymous'),
        (i.src = e),
        (i.name = null != t ? t : wM(e)),
        (i.onload = function () {
          n(i)
        }),
        (i.onerror = function () {
          r(new Error('Error in loading the image with the provided url: '.concat(e)))
        })
    })
  }
  yM.defaultProps = vM(
    vM({}, y),
    {},
    {
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur imperdiet tortor quis odio facilisis, id aliquet nulla facilisis. Etiam tincidunt tempor odio nec placerat.',
      fontFamily: 'Arial',
      fontSize: 14,
      fill: '#000',
      width: 0,
      height: 0,
      letterSpacing: void 0,
      lineHeight: void 0,
      align: 'left'
    }
  )
  var wM = function (e) {
      return (e = e.split('/'))[e.length - 1].split('?')[0]
    },
    CM = [
      'id',
      'name',
      'image',
      'x',
      'y',
      'width',
      'height',
      'scaleX',
      'scaleY',
      'rotation',
      'annotationEvents',
      'stroke',
      'strokeWidth',
      'shadowOffsetX',
      'shadowOffsetY',
      'shadowBlur',
      'shadowColor',
      'shadowOpacity',
      'opacity'
    ]
  function xM(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function EM(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? xM(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : xM(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function SM(e) {
    var t = e.id,
      n = e.name,
      r = e.image,
      i = e.x,
      o = e.y,
      a = e.width,
      l = e.height,
      c = e.scaleX,
      u = e.scaleY,
      d = e.rotation,
      f = e.annotationEvents,
      h = e.stroke,
      p = e.strokeWidth,
      g = e.shadowOffsetX,
      m = e.shadowOffsetY,
      v = e.shadowBlur,
      y = e.shadowColor,
      b = e.shadowOpacity,
      w = e.opacity,
      C = ((e = Hu(e, CM)), Lg(s.exports.useState(null), 2)),
      x = C[0],
      E = C[1]
    return (
      s.exports.useEffect(
        function () {
          'string' == typeof r && bM(r).then(E)
        },
        [r]
      ),
      (C = r instanceof HTMLImageElement) || x
        ? ((C = C ? r : x),
          ue.createElement(
            jy,
            Tg(
              {
                id: t,
                name: n,
                rotation: d,
                scaleX: c,
                scaleY: u,
                stroke: h,
                strokeWidth: p,
                shadowOffsetX: g,
                shadowOffsetY: m,
                shadowBlur: v,
                shadowColor: y,
                shadowOpacity: b,
                image: C,
                x: i,
                y: o,
                width: a,
                height: l,
                opacity: w
              },
              e,
              f,
              e
            )
          ))
        : null
    )
  }
  SM.defaultProps = EM(EM({}, y), {}, { width: 0, height: 0 })
  var OM = [
    'id',
    'name',
    'scaleX',
    'scaleY',
    'rotation',
    'annotationEvents',
    'points',
    'lineCap',
    'stroke',
    'strokeWidth',
    'shadowOffsetX',
    'shadowOffsetY',
    'shadowBlur',
    'shadowColor',
    'shadowOpacity',
    'tension',
    'opacity'
  ]
  function kM(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function PM(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? kM(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : kM(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function _M(e) {
    var t = e.id,
      n = e.name,
      r = e.scaleX,
      i = e.scaleY,
      o = e.rotation,
      a = e.annotationEvents,
      l = e.points,
      s = e.lineCap,
      c = e.stroke,
      u = e.strokeWidth,
      d = e.shadowOffsetX,
      f = e.shadowOffsetY,
      h = e.shadowBlur,
      p = e.shadowColor,
      g = e.shadowOpacity,
      m = e.tension,
      v = e.opacity
    e = Hu(e, OM)
    return ue.createElement(
      'Line',
      Tg(
        {
          id: t,
          name: n,
          rotation: o,
          scaleX: r,
          scaleY: i,
          stroke: c,
          strokeWidth: u,
          shadowOffsetX: d,
          shadowOffsetY: f,
          shadowBlur: h,
          shadowColor: p,
          shadowOpacity: g,
          points: l,
          lineCap: s,
          tension: m,
          hitStrokeWidth: 20,
          x: 0,
          y: 0,
          opacity: v
        },
        a,
        e
      )
    )
  }
  _M.defaultProps = PM(
    PM({}, y),
    {},
    { stroke: '#000000', strokeWidth: 1, lineCap: 'butt', annotationEvents: {}, tension: void 0 }
  )
  var LM = [
    'id',
    'name',
    'fill',
    'pointerLength',
    'pointerWidth',
    'scaleX',
    'scaleY',
    'rotation',
    'annotationEvents',
    'points',
    'lineCap',
    'stroke',
    'strokeWidth',
    'shadowOffsetX',
    'shadowOffsetY',
    'shadowBlur',
    'shadowColor',
    'shadowOpacity',
    'opacity'
  ]
  function TM(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function IM(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? TM(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : TM(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function MM(e) {
    var t = e.id,
      n = e.name,
      r = e.fill,
      i = e.pointerLength,
      o = e.pointerWidth,
      a = e.scaleX,
      l = e.scaleY,
      s = e.rotation,
      c = e.annotationEvents,
      u = e.points,
      d = e.lineCap,
      f = e.stroke,
      h = e.strokeWidth,
      p = e.shadowOffsetX,
      g = e.shadowOffsetY,
      m = e.shadowBlur,
      v = e.shadowColor,
      y = e.shadowOpacity,
      b = e.opacity
    e = Hu(e, LM)
    return ue.createElement(
      'Arrow',
      Tg(
        {
          id: t,
          name: n,
          rotation: s,
          scaleX: a,
          scaleY: l,
          stroke: f,
          strokeWidth: h,
          shadowOffsetX: p,
          shadowOffsetY: g,
          shadowBlur: m,
          shadowColor: v,
          shadowOpacity: y,
          fill: r,
          x: 0,
          y: 0,
          points: u,
          pointerLength: i,
          pointerWidth: o,
          lineCap: d,
          opacity: b
        },
        c,
        e
      )
    )
  }
  function jM() {
    var e,
      t,
      n,
      r,
      i,
      o,
      a,
      l,
      c,
      u = jC(),
      d = u.annotations,
      f = void 0 === d ? {} : d,
      h = void 0 === (d = u.selectionsIds) ? [] : d,
      p =
        ((u = jC()),
        (e = u.tabId),
        (t = u.dispatch),
        (n = s.exports.useMemo(
          function () {
            return e !== Wy.ANNOTATE && e !== Wy.WATERMARK
          },
          [e]
        )),
        (r = s.exports.useCallback(function (e) {
          t({ type: GT, payload: e })
        }, [])),
        (i = s.exports.useCallback(function (e) {
          r({ id: e.target.id(), x: e.target.x(), y: e.target.y() })
        }, [])),
        (o = s.exports.useCallback(function (e) {
          var t = { id: e.target.id(), rotation: e.target.rotation(), x: e.target.x(), y: e.target.y() }
          return (
            e.target.name() === Gy.TEXT
              ? ((t.width = e.target.width() * e.target.scaleX()),
                (t.height = e.target.height() * e.target.scaleY()),
                (t.scaleX = 1),
                (t.scaleY = 1))
              : ((t.scaleX = e.target.scaleX()), (t.scaleY = e.target.scaleY())),
            t
          )
        }, [])),
        (a = s.exports.useCallback(function (e) {
          r(o(e))
        }, [])),
        (l = s.exports.useCallback(function (e) {
          e.target.name() === Gy.TEXT && e.target.setAttrs(o(e))
        })),
        (c = s.exports.useCallback(function (e) {
          var n
          e.target.id() !== By &&
            ((n = e.evt.ctrlKey || e.evt.shiftKey || e.evt.metaKey),
            t({ type: $T, payload: { annotationId: e.target.id(), multiple: n } }),
            t({ type: oI, payload: { toolId: e.target.name(), keepSelections: n } }))
        }, [])),
        s.exports.useMemo(
          function () {
            return n ? {} : { onTransform: l, onTransformEnd: a, onDragEnd: i, onClick: c, onTap: c }
          },
          [n]
        ))
    return s.exports.useMemo(
      function () {
        return Object.values(f).map(function (e) {
          return ue.createElement(DM, { key: e.id, annotation: e, annotationEvents: p, selectionsIds: h })
        })
      },
      [f, p, h]
    )
  }
  ;(MM.defaultProps = IM(
    IM({}, y),
    {},
    { stroke: '#000000', strokeWidth: 6, fill: void 0, lineCap: 'butt', pointerLength: void 0, pointerWidth: void 0 }
  )),
    r((cC = {}), Gy.RECT, aM),
    r(cC, Gy.ELLIPSE, uM),
    r(cC, Gy.POLYGON, pM),
    r(cC, Gy.TEXT, yM),
    r(cC, Gy.IMAGE, SM),
    r(cC, Gy.LINE, _M),
    r(cC, Gy.ARROW, MM),
    r(cC, Gy.PEN, _M)
  var RM = cC,
    DM = s.exports.memo(function (e) {
      var t = e.annotation,
        n = e.annotationEvents,
        r = ((e = e.selectionsIds), RM[t.name])
      return r ? ue.createElement(r, Tg({ key: t.id, annotationEvents: n, draggable: e.includes(t.id) }, t)) : null
    }),
    AM = s.exports.forwardRef(function (e, t) {
      return ue.createElement('Group', Tg({ ref: t }, e))
    })
  function zM(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function NM(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? zM(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : zM(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  var FM = 2 * (window ? 0.05 * Math.min(window.innerHeight, window.innerWidth) : 12),
    HM = function () {
      var e,
        t = s.exports.useRef(),
        n = (y = jC()).initialCanvasWidth,
        r = y.initialCanvasHeight,
        i = y.canvasWidth,
        o = y.canvasHeight,
        a = y.dispatch,
        l = y.toolId,
        c = y.canvasScale,
        u = void 0 === (f = y.originalImage) ? {} : f,
        d = void 0 === (f = y.finetunes) ? [] : f,
        f = void 0 === (f = y.finetunesProps) ? {} : f,
        h = void 0 === (v = y.filter) ? null : v,
        p = void 0 === (m = (v = void 0 === (v = y.adjustments) ? {} : v).rotation) ? 0 : m,
        g = void 0 === (m = v.crop) ? {} : m,
        m = v.isFlippedX,
        v = v.isFlippedY,
        y = y.resize,
        b = s.exports.useRef(),
        w = s.exports.useRef(),
        C = l === Gy.CROP,
        x =
          ((l = s.exports.useMemo(
            function () {
              return h ? [].concat(Dp(d), [h]) : d
            },
            [d, h]
          )),
          s.exports.useMemo(
            function () {
              var e = Math.max(10, u.width - FM)
              return { width: e, height: e / (u.width / u.height) }
            },
            [u]
          )),
        E = s.exports.useMemo(
          function () {
            return Lx(u.width, u.height, p)
          },
          [u, p]
        ),
        S = s.exports.useMemo(
          function () {
            return Ay(n, r, u.width, u.height)
          },
          [u, n, r]
        ),
        O = s.exports.useMemo(
          function () {
            return { width: x.width * S, height: x.height * S }
          },
          [x, S]
        ),
        k = y.width && !C ? y.width / (null != (k = null != (k = g.width) ? k : O.width) ? k : E.width) : 1,
        P =
          ((y = y.height && !C ? y.height / (null != (y = null != (y = g.height) ? y : O.height) ? y : E.height) : 1),
          i / (2 * c) - (O.width * k) / 2),
        _ = o / (2 * c) - (O.height * y) / 2,
        L = i / (2 * c) - O.width / 2,
        T = o / (2 * c) - O.height / 2,
        I = s.exports.useMemo(
          function () {
            return {
              x: Math.round(P),
              y: Math.round(_),
              abstractX: Math.round(L),
              abstractY: Math.round(T),
              width: O.width,
              height: O.height,
              scaledBy: c
            }
          },
          [c, P, _, L, T, O]
        ),
        M = s.exports.useCallback(function () {
          b.current ? b.current.cache() : setTimeout(M, 0)
        }, [])
      ;(E = Lx(I.width, I.height, p)), (i = C ? 1 : Ay(I.width, I.height, E.width, E.height))
      return (
        s.exports.useEffect(
          function () {
            return (
              u && M(),
              function () {
                var e
                null != (e = b.current) && e.clearCache()
              }
            )
          },
          [u]
        ),
        s.exports.useEffect(
          function () {
            I && a({ type: LI, payload: { shownImageDimensions: I, designLayer: t.current, previewGroup: w.current } })
          },
          [I]
        ),
        P && _ && I
          ? ((o = g.x),
            (E = g.y),
            (e = p),
            (o =
              o && E && (e || 0 === e)
                ? ((E = $I((o = { x: -o / 2, y: -E / 2 }), 0)),
                  { x: (o = $I(o, e)).x - E.x, y: o.y - E.y, rotation: e })
                : { x: 0, y: 0, rotation: e }),
            (E = P + (!C && g.width ? (m ? -1 : 1) * (I.width / 2 - g.x - g.width / 2 + o.x) * k : 0)),
            (e = _ + (!C && g.height ? (v ? -1 : 1) * (I.height / 2 - g.y - g.height / 2 + o.y) * y : 0)),
            (o = C ? L : E),
            (E = C ? T : e),
            (e = (m ? -1 : 1) * (C ? 1 : k) * i),
            (m = (v ? -1 : 1) * (C ? 1 : y) * i),
            ue.createElement(
              Iy,
              {
                id: 'FIE_design-layer',
                ref: t,
                xPadding: o,
                yPadding: E,
                offsetX: O.width / 2,
                offsetY: O.height / 2,
                x: (O.width * k) / 2 + o,
                y: (O.height * y) / 2 + E,
                scaleX: e,
                scaleY: m,
                rotation: C ? 0 : p,
                clipFunc: function (e) {
                  var n = C && !(null != (n = t.current) && null != (n = n.attrs) && n.isSaving),
                    r = n
                      ? NM(NM({}, I), {}, { x: 0, y: 0 })
                      : { width: g.width || I.width, height: g.height || I.height, x: g.x || 0, y: g.y || 0 }
                  ;(function (e, t) {
                    t.ratio !== $y || (2 < arguments.length && void 0 !== arguments[2] && arguments[2])
                      ? e.rect(t.x, t.y, t.width, t.height)
                      : e.ellipse(t.x + t.width / 2, t.y + t.height / 2, t.width / 2, t.height / 2, 0, 0, 2 * Math.PI)
                  })(e, NM({ ratio: g.ratio }, r), n),
                    t.current &&
                      t.current.setAttrs({ clipX: r.x, clipY: r.y, clipWidth: r.width, clipHeight: r.height })
                }
              },
              ue.createElement(
                jy,
                Tg(
                  {
                    id: Fy,
                    image: u,
                    width: O.width,
                    height: O.height,
                    offsetX: O.width / 2,
                    offsetY: O.height / 2,
                    x: O.width / 2,
                    y: O.height / 2,
                    listening: !1,
                    filters: l,
                    ref: b
                  },
                  f
                )
              ),
              ue.createElement(jM, null),
              ue.createElement(AM, { ref: w })
            ))
          : null
      )
    }
  function BM(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function VM(e, t, n, i) {
    var o,
      a,
      l = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : {},
      s =
        ((n = {
          x: Mx(n.abstractX * n.scaledBy),
          y: Mx(n.abstractY * n.scaledBy),
          width: Mx(n.width * n.scaledBy),
          height: Mx(n.height * n.scaledBy)
        }),
        (function (e) {
          for (var t, n = 1; n < arguments.length; n++)
            (t = null == arguments[n] ? {} : arguments[n]),
              n % 2
                ? BM(Object(t), !0).forEach(function (n) {
                    r(e, n, t[n])
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
                : BM(Object(t)).forEach(function (n) {
                    Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
                  })
          return e
        })({}, t))
    return (
      t.x < n.x && ((s.x = n.x), (s.width = e.x - n.x + e.width)),
      t.y < n.y && ((s.y = n.y), (s.height = e.y - n.y + e.height)),
      s.x + s.width > n.x + n.width && (s.width = n.x + n.width - s.x),
      s.y + s.height > n.y + n.height && (s.height = n.y + n.height - s.y),
      i &&
        ((o = s.width / s.height), (a = i), Mx(o) !== Mx(a)) &&
        ((o = s.height * i), (a = s.width / i), Mx(s.y + a) <= n.y + n.height ? (s.height = a) : (s.width = o)),
      ((l.minWidth && s.width <= l.minWidth) || (l.maxWidth && s.width >= l.maxWidth)) &&
        ((s.width = WC(s.width, l.minWidth, l.maxWidth)), (s.x = e.x), (s.y = e.y), i) &&
        (s.height = s.width / i),
      ((l.minHeight && t.height <= l.minHeight) || (l.maxHeight && t.height >= l.maxHeight)) &&
        ((s.height = WC(s.height, l.minHeight, l.maxHeight)), (s.x = e.x), (s.y = e.y), i) &&
        (s.width = s.height * i),
      s
    )
  }
  function WM(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function GM(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? WM(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : WM(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function ZM() {
    function e() {
      return O === qy ? d.width / d.height : O
    }
    function t(e, t) {
      var n = e.width,
        r = e.height,
        i = e.x
      ;(e = e.y),
        (i = { x: g ? f.width - i - n : i, y: m ? f.height - e - r : e, width: n, height: r }),
        (e = p.width >= v.width && p.height >= v.height)
      v.width &&
        v.height &&
        (n < v.width || r < v.height) &&
        e &&
        l({ type: Xw, payload: { feedback: { message: b('cropSizeLowerThanResizedWarning'), status: tb } } }),
        l({ type: dI, payload: GM(GM(GM({}, p), i), {}, { dismissHistory: t }) })
    }
    function n(n, r) {
      C.current && w.current && C.current.nodes([w.current])
      var i = E.current
      t(
        VM(
          (n = { width: n, height: r, x: null != (n = p.x) ? n : 0, y: null != (r = p.y) ? r : 0 }),
          n,
          GM(GM({}, i), {}, { abstractX: 0, abstractY: 0 }),
          !(k || P) && e(),
          S
        ),
        !0
      )
    }
    var r,
      i,
      o,
      a = jC(),
      l = a.dispatch,
      c = a.theme,
      u = a.designLayer,
      d = a.originalImage,
      f = a.shownImageDimensions,
      h = (y = void 0 === (y = a.adjustments) ? {} : y).crop,
      p = void 0 === h ? {} : h,
      g = y.isFlippedX,
      m = y.isFlippedY,
      v = void 0 === (h = a.resize) ? {} : h,
      y = a.config,
      b = a.t,
      w = s.exports.useRef(),
      C = s.exports.useRef(),
      x = s.exports.useRef(),
      E = s.exports.useRef(),
      S = y[Gy.CROP],
      O = p.ratio || S.ratio,
      k = 'custom' === O,
      P = O === $y
    return (
      s.exports.useEffect(
        function () {
          return (
            u && C.current && w.current && (x.current && x.current.cache(), C.current.nodes([w.current])),
            function () {
              x.current && x.current.clearCache()
            }
          )
        },
        [u, d, f]
      ),
      s.exports.useEffect(
        function () {
          var e, t
          E.current && ((t = E.current), n(null != (e = p.width) ? e : t.width, null != (e = p.height) ? e : t.height))
        },
        [O]
      ),
      s.exports.useEffect(
        function () {
          C.current && w.current && E.current && p.width && p.height && n(p.width, p.height)
        },
        [S, f.width, f.height]
      ),
      s.exports.useEffect(
        function () {
          f && (E.current = f)
        },
        [f]
      ),
      u
        ? ((h = k || P ? void 0 : ['top-left', 'bottom-left', 'top-right', 'bottom-right']),
          (a = function (e) {
            var n = !!(1 < arguments.length && void 0 !== arguments[1]) && arguments[1]
            e.target &&
              t(
                {
                  width: e.target.width() * e.target.scaleX(),
                  height: e.target.height() * e.target.scaleY(),
                  x: e.target.x(),
                  y: e.target.y()
                },
                n
              )
          }),
          (o =
            void 0 ===
            (o = (y =
              p.width || p.height
                ? p
                : ((y = f.scaledBy < 1 ? f.scaledBy : 1),
                  (y = GM(GM({}, f), {}, { width: f.width / y, height: f.height / y })),
                  VM(
                    y,
                    GM(GM({}, y), {}, { x: 0, y: 0 }),
                    GM(GM({}, y), {}, { abstractX: 0, abstractY: 0 }),
                    !(k || P) && e(),
                    S
                  ))).x)
              ? 0
              : o),
          (r = void 0 === (r = y.y) ? 0 : r),
          (i = y.width),
          (y = y.height),
          (o = {
            x: g ? f.width - o - i : o,
            y: m ? f.height - r - y : r,
            ref: w,
            fill: '#FFFFFF',
            scaleX: 1,
            scaleY: 1,
            globalCompositeOperation: 'destination-out',
            onDragEnd: a,
            onDragMove: function (e) {
              var t, n
              ;(e = e.target).setAttrs(
                ((e = e.attrs),
                (n = (t = E.current).width - (2 * e.radiusX || e.width)),
                (t = t.height - (2 * e.radiusY || e.height)),
                { x: Mx(Math.min(Math.max(e.x, 0), n)), y: Mx(Math.min(Math.max(e.y, 0), t)) })
              )
            },
            onTransformEnd: a,
            draggable: !0
          }),
          ue.createElement(
            ue.Fragment,
            null,
            ue.createElement(jy, {
              image: d,
              x: g ? f.width : 0,
              y: m ? f.height : 0,
              width: f.width,
              height: f.height,
              filters: [ry.Filters.Blur, ry.Filters.Brighten],
              blurRadius: 10,
              brightness: -0.3,
              scaleX: g ? -1 : 1,
              scaleY: m ? -1 : 1,
              ref: x
            }),
            P
              ? ue.createElement(My, Tg({}, o, { radiusX: i / 2, radiusY: y / 2, offset: { x: -i / 2, y: -y / 2 } }))
              : ue.createElement('Rect', Tg({}, o, { width: i, height: y })),
            ue.createElement(Ry, {
              centeredScaling: !1,
              flipEnabled: !1,
              rotateEnabled: !1,
              nodes: w.current ? [w.current] : [],
              anchorSize: 14,
              anchorCornerRadius: 7,
              enabledAnchors: h,
              ignoreStroke: !1,
              anchorStroke: c.palette['accent-primary'],
              anchorFill: c.palette['access-primary'],
              anchorStrokeWidth: 2,
              borderStroke: c.palette['accent-primary'],
              borderStrokeWidth: 2,
              borderDash: [4],
              keepRatio: !k || !P,
              ref: C,
              boundBoxFunc: function (t, n) {
                return VM(t, n, E.current, !(k || P) && e(), S)
              }
            })
          ))
        : null
    )
  }
  function UM() {
    function e() {
      1 === l.length && l[0].name() === Gy.TEXT && o({ type: NI, payload: { textIdOfEditableContent: l[0].id() } })
    }
    var t,
      n = void 0 === (r = (a = jC()).selectionsIds) ? [] : r,
      r = a.theme,
      i = a.designLayer,
      o = a.dispatch,
      a = a.config.useCloudimage,
      l = s.exports.useMemo(
        function () {
          return null != i && i.findOne
            ? n
                .map(function (e) {
                  return i.findOne('#'.concat(e))
                })
                .filter(Boolean)
            : []
        },
        [n]
      )
    return ue.createElement(Ry, {
      id: Hy,
      centeredScaling: !1,
      rotationSnaps: [0, 45, 90, 135, 180, 225, 270, 315],
      nodes: l,
      rotateAnchorOffset: 30,
      anchorSize: 14,
      anchorCornerRadius: 7,
      padding: 1 === l.length && null != (t = l[0].attrs.padding) ? t : 1,
      ignoreStroke: !1,
      anchorStroke: r.palette['accent-primary'],
      anchorFill: r.palette['access-primary'],
      anchorStrokeWidth: 2,
      borderStroke: r.palette['accent-primary'],
      borderStrokeWidth: 2,
      borderDash: [4],
      rotateEnabled: !a,
      onMouseOver: function () {
        o({ type: XT, payload: { pointerCssIcon: Yy.MOVE } })
      },
      onMouseLeave: function () {
        o({ type: XT, payload: { pointerCssIcon: Yy.DRAW } })
      },
      onDblClick: e,
      onDblTap: e,
      flipEnabled: !0,
      shouldOverdrawWholeArea: !0
    })
  }
  var XM = function () {
      var e = (t = jC()).toolId,
        t = t.shownImageDimensions
      return ue.createElement(
        Iy,
        { id: Ny, x: t.abstractX || 0, y: t.abstractY || 0 },
        ue.createElement(UM, null),
        e === Gy.CROP && ue.createElement(ZM, null)
      )
    },
    YM = c.div.withConfig({ componentId: 'sc-1tst9ex-0' })(function (e) {
      var t = e.theme,
        n = e.top
      e = e.left
      return '\n  position: absolute;\n  z-index: 1;\n  background: '
        .concat(
          t.palette['bg-secondary'],
          ';\n  border-radius: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0px 1px 2px '
        )
        .concat(t.palette['light-shadow'], ';\n  top: ')
        .concat((n || 0) + 8, 'px;\n  left: ')
        .concat((e || 0) + 4, 'px;\n  transform: translateX(-50%);\n  height: 32px;\n')
    }),
    qM = function () {
      var e = void 0 === (n = (l = jC()).selectionsIds) ? [] : n,
        t = l.designLayer,
        n = l.annotations,
        r = l.dispatch,
        i = (l = Lg(s.exports.useState({ left: 0, top: 0 }), 2))[0],
        o = l[1],
        a = s.exports.useMemo(
          function () {
            var e
            return null == t || null == (e = t.getStage()) ? void 0 : e.findOne('#'.concat(Hy))
          },
          [t]
        ),
        l = e.length,
        c = BC(function () {
          a && o({ left: (a.x() + a.width() / 2) * a.scaleX(), top: (a.y() + a.height()) * a.scaleY() })
        }, 0)
      return (
        s.exports.useEffect(
          function () {
            c()
          },
          [e, a, n]
        ),
        0 !== l && a
          ? ue.createElement(
              YM,
              { className: 'FIE_annotation-controls-overlay', left: i.left, top: i.top },
              e[0] !== By &&
                ue.createElement(
                  KL,
                  {
                    color: 'link',
                    size: 'sm',
                    onClick: function () {
                      r({ type: DI, payload: { annotationsIds: e } })
                    }
                  },
                  ue.createElement(HL, null)
                ),
              ue.createElement(
                KL,
                {
                  color: 'link',
                  size: 'sm',
                  onClick: function () {
                    r({ type: MI, payload: { annotationsIds: e } })
                  }
                },
                ue.createElement(VL, null)
              )
            )
          : null
      )
    }
  function $M(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function KM(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? $M(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : $M(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function QM(e, t) {
    return { x: (e.x + t.x) / 2, y: (e.y + t.y) / 2 }
  }
  var JM = null,
    ej = 0,
    tj = c.div.withConfig({ componentId: 'sc-3ln9py-0' })(
      [
        'width:100%;position:relative;height:calc(100% - 94px - 12px);background:',
        ';overflow:hidden;min-height:250px;flex-grow:1;'
      ],
      function (e) {
        return e.theme.palette['bg-primary']
      }
    ),
    nj = c.img.withConfig({ componentId: 'sc-3ln9py-1' })([
      'max-width:98%;max-height:98%;box-shadow:0 0 0 5px rgba(0,0,0,0.1);position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:2;'
    ]),
    rj = c(Fj).withConfig({ componentId: 'sc-3ln9py-2' })(['outline:none;background:', ';'], function (e) {
      return e.theme.palette['bg-secondary']
    })
  function ij(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function oj(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? ij(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : ij(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function aj() {
    var e = Lg(Cx(), 1)[0],
      t = jC(),
      n = s.exports.useRef(null),
      r = s.exports.useCallback(function (e) {
        var n = e.width
        e = e.height
        t.dispatch({ type: EI, payload: { canvasWidth: n, canvasHeight: e } })
      }, [])
    return (
      s.exports.useEffect(function () {
        e(n.current, r)
      }, []),
      ue.createElement(
        tj,
        { className: 'FIE_canvas-container', ref: n },
        !t.textIdOfEditableContent && ue.createElement(qM, null),
        t.isShowOriginalImage &&
          ue.createElement(nj, { className: 'FIE_original-image-compare', src: t.originalImage.src }),
        ue.createElement(
          lj,
          null,
          ue.createElement(MC, { overridingValue: t }, ue.createElement(HM, null), ue.createElement(XM, null))
        )
      )
    )
  }
  var lj = s.exports.memo(function (e) {
      function t(e) {
        l({ type: wI, payload: e })
      }
      function n() {
        return x(u !== Wy.ANNOTATE || u === Wy.WATERMARK)
      }
      function r(e) {
        ;('Space' === e.code || 'Control' === e.key) &&
          !e.repeat &&
          m.factor > b &&
          w &&
          (e.preventDefault(), x(!0), l({ type: XT, payload: { pointerCssIcon: Yy.DRAG } }))
      }
      function i(e) {
        'Space' === e.code && (e.preventDefault(), n())
      }
      function o() {
        a.current && a.current.container().focus()
      }
      e = e.children
      var a =
          ((function (e) {
            cy = e
          })(!0),
          s.exports.useRef()),
        l = (v = jC()).dispatch,
        c = v.pointerCssIcon,
        u = v.tabId,
        d = v.toolId,
        f = v.canvasWidth,
        h = v.canvasHeight,
        p = v.canvasScale,
        g = void 0 === (y = v.selectionsIds) ? [] : y,
        m = void 0 === (y = v.zoom) ? {} : y,
        v = (y = v.config).previewPixelRatio,
        y = y.disableZooming,
        b = ((ry.pixelRatio = v), 1),
        w = !y && d !== Gy.CROP,
        C = (v = Lg(s.exports.useState(u !== Wy.ANNOTATE && u !== Wy.WATERMARK && m.factor > b), 2))[0],
        x = v[1]
      ;(y = s.exports.useMemo(
        function () {
          return { cursor: c === Yy.DEFAULT && u === Wy.ANNOTATE ? Yy.DRAW : c }
        },
        [u, c]
      )),
        (d = s.exports.useCallback(
          function (e) {
            var t, n
            e.evt.preventDefault(),
              null != (t = (n = e.currentTarget).container) && t.call(n).focus(),
              e.target instanceof ry.Stage && 0 < g.length && l({ type: JT })
          },
          [g]
        )),
        s.exports.useEffect(
          function () {
            l({ type: XT, payload: { pointerCssIcon: Yy[C ? 'DRAG' : 'DEFAULT'] } })
          },
          [C]
        ),
        s.exports.useEffect(
          function () {
            var e
            return (
              x(u !== Wy.ANNOTATE && u !== Wy.WATERMARK && m.factor > b),
              a.current &&
                ((e = a.current.container()).addEventListener('mouseenter', o),
                e.addEventListener('keydown', r),
                e.addEventListener('keyup', i)),
              function () {
                e &&
                  (e.removeEventListener('mouseenter', o),
                  e.removeEventListener('keydown', r),
                  e.removeEventListener('keyup', i))
              }
            )
          },
          [u, m.factor, b]
        ),
        (v = p * ((w && m.factor) || b))
      return ue.createElement(
        rj,
        {
          className: 'FIE_canvas-node',
          tabIndex: -1,
          ref: a,
          width: f,
          height: h,
          scaleX: v,
          scaleY: v,
          x: (w && m.x) || null,
          y: (w && m.y) || null,
          zoomFactor: (w && m.factor) || b,
          onWheel: w
            ? function (e) {
                e.evt.preventDefault()
                var n = (m.factor || b) + -0.006 * e.evt.deltaY
                t(oj(oj({}, (e = e.currentTarget.getPointerPosition())), {}, { factor: n }))
              }
            : void 0,
          onTap: d,
          onClick: d,
          onTouchMove: w
            ? function (e) {
                return (function (e, t) {
                  e.evt.preventDefault()
                  var n,
                    r,
                    i,
                    o,
                    a,
                    l,
                    s = e.evt.touches[0],
                    c = e.evt.touches[1]
                  s &&
                    c &&
                    ((e = e.currentTarget).isDragging() && e.stopDrag(),
                    (s = { x: s.clientX, y: s.clientY }),
                    (c = { x: c.clientX, y: c.clientY }),
                    JM
                      ? ((n = QM(s, c)),
                        (a = s),
                        (l = c),
                        (l = Math.sqrt(Math.pow(l.x - a.x, 2) + Math.pow(l.y - a.y, 2))),
                        (ej = ej || l),
                        (a = (n.x - e.x()) / e.scaleX()),
                        (r = (n.y - e.y()) / e.scaleX()),
                        (e = e.scaleX() * (l / ej)),
                        (i = n.x - JM.x),
                        (o = n.y - JM.y),
                        (a = { x: n.x - a * e + i, y: n.y - r * e + o }),
                        (ej = l),
                        (JM = n),
                        t(KM(KM({}, a), {}, { factor: e, preparedDimensions: !0 })))
                      : (JM = QM(s, c)))
                })(e, t)
              }
            : void 0,
          onDragStart: function (e) {
            1 < (null == (e = e.evt.touches) ? void 0 : e.length) && x(!1)
          },
          onTouchEnd: w
            ? function () {
                var e
                ;(ej = 0), (JM = null), 'function' == typeof (e = n) && e()
              }
            : void 0,
          dragBoundFunc: function (e) {
            return {
              x: Math.min(0, Math.max(e.x, f * (1 - m.factor))),
              y: Math.min(0, Math.max(e.y, h * (1 - m.factor)))
            }
          },
          draggable: w && C,
          onDragEnd: function (e) {
            e.currentTarget.draggable() &&
              'stage' === e.target.nodeType.toLowerCase() &&
              w &&
              C &&
              t({ factor: m.factor, x: e.target.x(), y: e.target.y(), preparedDimensions: !0 })
          },
          style: y
        },
        e
      )
    }),
    sj = c.div.withConfig({ componentId: 'sc-etsyb6-0' })(
      ['display:inline-block;height:', ';width:', ';border-radius:1px;background:#dfe7ed;'],
      function (e) {
        return e.height
      },
      function (e) {
        return e.width
      }
    ),
    cj = function (e) {
      var t = e.height
      e = e.width
      return ue.createElement(sj, { height: t, width: e })
    },
    uj =
      ((cj.defaultProps = { height: '11px', width: '1px' }),
      c.div.withConfig({ componentId: 'sc-21g986-0' })(
        [
          'padding:12px 12px 8px 12px;box-sizing:border-box;position:relative;width:100%;display:flex;align-items:center;justify-content:space-between;',
          ";[data-phone='true'] &{padding:6px 6px 4px 6px;}overflow:auto;"
        ],
        function (e) {
          return e.reverseDirection ? 'flex-direction: row-reverse' : ''
        }
      )),
    dj = c.div.withConfig({ componentId: 'sc-21g986-1' })([
      'display:flex;margin:0 4px;column-gap:4px;align-items:center;'
    ]),
    fj = c(KL).withConfig({ componentId: 'sc-21g986-2' })(
      ['margin:', ';display:flex;justify-content:center;align-items:center;width:16px;height:16px;padding:2px;'],
      function (e) {
        return null != (e = e.margin) ? e : '0 4px'
      }
    ),
    hj = c(uC).withConfig({ componentId: 'sc-21g986-3' })(['flex-shrink:0;']),
    pj = c(KL).withConfig({ componentId: 'sc-21g986-4' })(
      ['width:20px;height:20px;margin:0 ', ';padding:4px;'],
      function (e) {
        return null != (e = e.horizontalMargin) ? e : '4px'
      }
    ),
    gj = c.div.withConfig({ componentId: 'sc-21g986-5' })(['display:flex;align-items:center;', ';'], function (e) {
      return e.reverseDirection ? 'flex-direction: row-reverse' : ''
    }),
    mj = c(uC).withConfig({ componentId: 'sc-21g986-6' })(['cursor:pointer;']),
    vj = c.span.withConfig({ componentId: 'sc-21g986-7' })(['font-size:11px;line-height:12px;']),
    yj = c(KL).withConfig({ componentId: 'sc-21g986-8' })(['padding:0;z-index:111;']),
    bj =
      (c(BS).withConfig({ componentId: 'sc-21g986-9' })(['padding:4px 12px;']),
      c(BP).withConfig({ componentId: 'sc-21g986-10' })(['width:200px;'])),
    wj = c(FP).withConfig({ componentId: 'sc-21g986-11' })(['width:60px;margin-left:4px;']),
    Cj = c.div.withConfig({ componentId: 'sc-21g986-12' })(['width:100%;margin-top:8px;']),
    xj = c.div.withConfig({ componentId: 'sc-21g986-13' })(['margin-top:8px;width:100%;']),
    Ej = function () {
      var e = jC(),
        t = e.haveNotSavedChanges,
        n = e.config.onClose
      return 'function' == typeof n
        ? ue.createElement(
            yj,
            {
              className: 'FIE_topbar-close-button',
              color: 'link',
              size: 'sm',
              onClick: function () {
                n(eb, t)
              }
            },
            n && ue.createElement(ML, null)
          )
        : ue.createElement('span', null)
    },
    Sj = { Xs: 'xs', Sm: 'sm', Md: 'md', Lg: 'lg', Xl: 'xl' },
    Oj = s.exports.createContext({ modalOpened: !1 }),
    kj =
      (r((Og = {}), Sj.Xs, Yf(['max-width:300px;'])),
      r(Og, Sj.Sm, Yf(['max-width:600px;'])),
      r(Og, Sj.Md, Yf(['max-width:960px;'])),
      r(Og, Sj.Lg, Yf(['max-width:1280px;'])),
      r(Og, Sj.Xl, Yf(['max-width:1920px;'])),
      Og),
    Pj =
      ((Jy = 'Modal'),
      (oC = c.div.attrs({ className: Ap(Jy, 'Wrapper') }).withConfig({ componentId: 'sc-80m07l-0' })(function (e) {
        return Yf(
          ['position:fixed;right:0px;bottom:0px;top:0px;left:0px;z-index:1200;visibility:', ';'],
          e.open ? 'visible' : 'hidden'
        )
      })),
      (p = c.div.attrs({ className: Ap(Jy, 'Overlay') }).withConfig({ componentId: 'sc-80m07l-1' })(function (e) {
        return Yf(
          [
            'position:fixed;right:0px;bottom:0px;top:0px;left:0px;background-color:rgba(0,0,0,0.5);z-index:-1;transition:opacity 251ms cubic-bezier(0.4,0,0.2,1) 0ms;opacity:',
            ';'
          ],
          e.open ? '1' : '0'
        )
      })),
      (wS = c.div.attrs({ className: Ap(Jy, 'Container') }).withConfig({ componentId: 'sc-80m07l-2' })(function (e) {
        var t = e.theme,
          n = void 0 !== (n = e.open) && n,
          r = e.fullWidth
        e = void 0 === (e = e.maxWidth) ? Sj.Sm : e
        return Yf(
          [
            'position:absolute;overflow-x:hidden;overflow-y:auto;transition:opacity 251ms cubic-bezier(0.4,0,0.2,1) 0ms,transform 167ms cubic-bezier(0.4,0,0.2,1) 0ms;outline:0;border-radius:',
            ';background-color:',
            ';box-shadow:0px 2px 4px ',
            ';visibility:',
            ';opacity:',
            ';display:flex;max-height:calc(100% - 64px);flex-direction:column;',
            ' ',
            ' top:50%;left:50%;transform:translate(-50%,-50%);'
          ],
          t.shape.borderRadius[hg.Md],
          t.palette[dg.BackgroundSecondary],
          t.palette[dg.LightShadow],
          n ? 'visible' : 'hidden',
          n ? '1' : '0',
          void 0 !== r && r && Yf(['width:calc(100% - 64px);']),
          kj[e]
        )
      })),
      Hp({
        Modal: c.div.attrs({ className: Ap(Jy, 'root') }).withConfig({ componentId: 'sc-80m07l-3' })(function () {
          return Yf([
            'position:relative;padding-top:8px;padding-bottom:8px;margin:0;padding:0;outline:0;display:flex;flex-direction:column;'
          ])
        }),
        Wrapper: oC,
        Overlay: p,
        Container: wS
      })),
    _j = ['children', 'open', 'onClose', 'maxWidth', 'fullWidth']
  function Lj(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  ;(rC = zp(function (e, t) {
    function n() {
      'function' == typeof a && a()
    }
    var i = e.children,
      o = e.open,
      a = e.onClose,
      l = e.maxWidth,
      c = e.fullWidth,
      u =
        ((e = Hu(e, _j)),
        (u = i) && s.exports.isValidElement(u) && 1 === ue.Children.count(u) && u.type === ue.Fragment
          ? i.props.children
          : i)
    i = document.querySelector('body')
    return (
      s.exports.useEffect(
        function () {
          return (
            o ? document.body.classList.add('Modal-open') : document.body.classList.remove('Modal-open'),
            function () {
              document.body.classList.remove('Modal-open')
            }
          )
        },
        [o]
      ),
      s.exports.useEffect(function () {
        function e(e) {
          'Escape' === e.key && n()
        }
        return (
          document.addEventListener('keydown', e),
          function () {
            return document.removeEventListener('keydown', e)
          }
        )
      }),
      de.exports.createPortal(
        ue.createElement(
          Oj.Provider,
          { value: { modalOpened: Boolean(o) } },
          ue.createElement(
            Pj.Wrapper,
            { open: Boolean(o), ref: t },
            ue.createElement(Pj.Overlay, { onClick: n, open: Boolean(o) }),
            ue.createElement(
              Pj.Container,
              Tg({}, e, { maxWidth: l, fullWidth: c, open: Boolean(o) }),
              ue.createElement(
                Pj.Modal,
                null,
                ue.Children.map(u, function (e) {
                  return s.exports.isValidElement(e) && 'ModalTitle' === e.type.displayName
                    ? ue.cloneElement(
                        e,
                        (function (e) {
                          for (var t = 1; t < arguments.length; t++) {
                            var n = null != arguments[t] ? arguments[t] : {}
                            t % 2
                              ? Lj(Object(n), !0).forEach(function (t) {
                                  r(e, t, n[t])
                                })
                              : Object.getOwnPropertyDescriptors
                              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
                              : Lj(Object(n)).forEach(function (t) {
                                  Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
                                })
                          }
                          return e
                        })({ onClose: n }, e.props || {})
                      )
                    : e
                })
              )
            )
          )
        ),
        i
      )
    )
  })),
    (rC.defaultProps = { open: !1, fullWidth: !1, maxWidth: Sj.Xs }),
    (h = {
      onClose: ce.func.isRequired,
      children: ce.node.isRequired,
      maxWidth: ce.oneOf(Fp(Sj)),
      open: ce.bool,
      fullWidth: ce.bool
    })
  var Tj = ((rC.propTypes = h), rC),
    Ij = { Left: 'left', Center: 'center', Right: 'right' },
    Mj = Hp({
      ModalActions: c.div.attrs({ className: Ap('ModalActions', 'root') }).withConfig({ componentId: 'sc-1wg6u00-0' })(
        function (e) {
          return Yf(
            [
              'position:relative;display:flex;align-items:center;padding:12px 16px;justify-content:',
              ';> *:not(:first-child){margin-left:8px;}'
            ],
            (e = void 0 === (e = e.align) ? Ij.Center : e) === Ij.Right ? 'flex-end' : e
          )
        }
      )
    }),
    jj = ['children'],
    Rj =
      ((iC = zp(function (e, t) {
        var n = e.children
        e = Hu(e, jj)
        return ue.createElement(Mj.ModalActions, Tg({}, e, { ref: t }), n)
      })),
      (iC.defaultProps = { align: Ij.Center }),
      (iC.propTypes = { children: ce.node.isRequired, align: ce.oneOf(Fp(Ij)) }),
      (iC.displayName = 'ModalActions'),
      iC),
    Dj = Hp({
      ModalContent: c.div.attrs({ className: Ap('ModalContent', 'root') }).withConfig({ componentId: 'sc-1ng1w0v-0' })(
        function () {
          return Yf(['position:relative;padding:15px 16px;'])
        }
      )
    }),
    Aj = ['children'],
    zj =
      ((l = zp(function (e, t) {
        var n = e.children
        e = Hu(e, Aj)
        return ue.createElement(Dj.ModalContent, Tg({}, e, { ref: t }), n)
      })),
      (l.defaultProps = {}),
      (l.propTypes = { children: ce.node.isRequired }),
      (l.displayName = 'ModalContent'),
      l),
    Nj = { Default: 'default', WithIcon: 'with-icon' },
    Fj =
      ((y = 'ModalTitle'),
      (cC = c.div.attrs({ className: Ap(y, 'Icon') }).withConfig({ componentId: 'sc-l3tf49-0' })(function (e) {
        return Yf(
          ['display:flex;margin-bottom:8px;padding:12.5px;border-radius:50%;background:', ';color:', ';'],
          (e = e.theme.palette)[dg.BackgroundPrimary],
          e[dg.AccentPrimary]
        )
      })),
      c.div.attrs({ className: Ap(y, 'LabelPrimary') }).withConfig({ componentId: 'sc-l3tf49-1' })(function () {
        return Yf(['font-size:16px;line-height:18px;'])
      })),
    Hj =
      ((Og = c.div.attrs({ className: Ap(y, 'LabelSecondary') }).withConfig({ componentId: 'sc-l3tf49-2' })([
        'font-size:12px;line-height:14px;margin-top:4px;'
      ])),
      (Jy = c.div.attrs({ className: Ap(y, 'Close') }).withConfig({ componentId: 'sc-l3tf49-3' })(function (e) {
        var t = void 0 === (t = e.variant) ? Nj.Default : t
        e = e.theme.palette
        return Yf(
          ['position:absolute;display:flex;top:', 'px;right:', 'px;color:', ';&:hover{color:', ';}cursor:pointer;'],
          t === Nj.WithIcon ? 12 : 16,
          t === Nj.WithIcon ? 12 : 16,
          e[dg.IconsSecondary],
          e[dg.IconsPrimary]
        )
      })),
      Hp({
        ModalTitle: c.div.attrs({ className: Ap(y, 'root') }).withConfig({ componentId: 'sc-l3tf49-4' })(function (e) {
          var t = void 0 === (n = e.variant) ? Nj.Default : n,
            n = ((e = (n = e.theme).palette), n.shape.borderRadius)
          return Yf(
            ['position:relative;color:', ';border-radius:', 'px ', 'px 0px 0px;', ' ', ' ', ''],
            e[dg.TextPrimary],
            n[hg.Md],
            n[hg.Md],
            function () {
              var e = t === Nj.WithIcon ? 12 : 11
              return Yf(['padding:', 'px ', 'px ', 'px ', 'px;'], e, t === Nj.WithIcon ? 18 : 40, e, 18)
            },
            t === Nj.Default &&
              Yf(['background:', ';border-bottom:1px solid ', ';'], e[dg.BackgroundPrimary], e[dg.BordersSecondary]),
            t === Nj.WithIcon && Yf(['display:flex;align-items:center;flex-direction:column;'])
          )
        }),
        LabelPrimary: Fj,
        LabelSecondary: Og,
        Close: Jy,
        Icon: cC
      })),
    Bj = ['secondary', 'onClose'],
    Vj =
      ((oC = zp(function (e, t) {
        var n = e.secondary,
          r = e.onClose
        e = Hu(e, Bj)
        return ue.createElement(
          Hj.ModalTitle,
          Tg({}, e, { ref: t }),
          e.icon && ue.createElement(Hj.Icon, { iconShadow: Boolean(e.iconShadow) }, e.icon),
          ue.createElement(Hj.LabelPrimary, null, e.primary),
          e.variant === Nj.WithIcon && n && ue.createElement(Hj.LabelSecondary, null, n),
          ue.createElement(Hj.Close, { variant: e.variant, onClick: r }, ue.createElement(PP, { size: 11 }))
        )
      })),
      (p =
        ((oC.defaultProps = { iconShadow: !0, variant: Nj.Default }),
        (oC.propTypes = {
          primary: ce.node.isRequired,
          secondary: ce.node,
          icon: ce.node,
          iconShadow: ce.bool,
          onClose: ce.func,
          variant: ce.oneOf(Fp(Nj))
        }),
        (oC.displayName = 'ModalTitle'),
        oC)),
      { Happy: 'happy', Neutral: 'neutral', Sad: 'sad', Worried: 'worried' }),
    Wj = Hp({
      Robot: c.span.attrs({ className: Ap('Robot', 'root') }).withConfig({ componentId: 'sc-q3dl9f-0' })(function () {
        return Yf(['display:flex;'])
      })
    }),
    Gj = ['status'],
    Zj =
      ((wS = zp(function (e, t) {
        var n = e.status
        e = Hu(e, Gj)
        return ue.createElement(
          Wj.Robot,
          Tg({}, e, { ref: t }),
          (function (e) {
            switch (e) {
              case Vj.Worried:
                return ue.createElement(EP, null)
              case Vj.Sad:
                return ue.createElement(CP, null)
              case Vj.Neutral:
                return ue.createElement(bP, null)
              default:
                return ue.createElement(vP, null)
            }
          })(n)
        )
      })),
      (h = { status: Vj.Happy }),
      (rC = ((wS.defaultProps = h), { status: ce.oneOf(Fp(Vj)) })),
      (wS.propTypes = rC),
      wS),
    Uj =
      ((iC = 'PopupContent'),
      (l = c.span.attrs({ className: Ap(iC, 'Label') }).withConfig({ componentId: 'sc-njbmnt-0' })(function (e) {
        var t = (e = e.theme).palette
        e = e.shape
        return Yf(
          [
            'display:flex;flex-grow:1;margin-left:31px;padding:8px 8px 8px 39px;background:',
            ';border-radius:',
            ';min-height:41px;'
          ],
          t[dg.ButtonPrimaryText],
          e.borderRadius[hg.Sm]
        )
      })),
      (y = c.span.attrs({ className: Ap(iC, 'Label') }).withConfig({ componentId: 'sc-njbmnt-1' })(function (e) {
        var t = (e = e.theme).palette
        e = e.typography.font
        return Yf(['display:flex;align-items:center;color:', ';', ''], t[dg.TextSecondary], e[fg.LabelSmall])
      })),
      Hp({
        PopupContent: c.div.attrs({ className: Ap(iC, 'PopupContent') }).withConfig({ componentId: 'sc-njbmnt-2' })([
          'position:relative;display:flex;align-items:center;width:256px;filter:drop-shadow(0px 4px 4px rgba(0,0,0,0.25));'
        ]),
        Robot: c.div.attrs({ className: Ap(iC, 'Robot') }).withConfig({ componentId: 'sc-njbmnt-3' })(function (e) {
          return Yf(
            [
              'position:absolute;left:0;display:flex;z-index:1;border-radius:50%;background:',
              ';border:1px solid ',
              ';box-sizing:border-box;'
            ],
            (e = e.theme.palette)[dg.ButtonPrimaryText],
            e[dg.BackgroundSecondary]
          )
        }),
        LabelWrapper: l,
        Label: y
      })),
    Xj = ['message', 'status']
  function Yj(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function qj(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {}
      t % 2
        ? Yj(Object(n), !0).forEach(function (t) {
            r(e, t, n[t])
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
        : Yj(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
          })
    }
    return e
  }
  var $j = zp(function (e, t) {
      var n = e.message,
        r = e.status
      e = Hu(e, Xj)
      return ue.createElement(
        Uj.PopupContent,
        Tg({}, e, { ref: t }),
        ue.createElement(Uj.Robot, null, ue.createElement(Zj, { status: r })),
        ue.createElement(Uj.LabelWrapper, null, ue.createElement(Uj.Label, null, n))
      )
    }),
    Kj =
      ((Fj = qj({}, h)),
      (Og = (($j.defaultProps = Fj), qj(qj({}, rC), {}, { message: ce.node.isRequired }))),
      ($j.propTypes = Og),
      { Center: 'center', Left: 'left', Right: 'right' }),
    Qj = { Top: 'top', Bottom: 'bottom' },
    Jj =
      (r((Jy = {}), Kj.Left, Yf(['left:25px;right:auto;'])),
      r(Jy, Kj.Center, Yf(['left:50%;right:auto;transform:translateX(-50%);'])),
      r(Jy, Kj.Right, Yf(['left:auto;right:25px;'])),
      Jy),
    eR = (r((cC = {}), Qj.Top, Yf(['top:25px;bottom:auto;'])), r(cC, Qj.Bottom, Yf(['top:auto;bottom:25px;'])), cC),
    tR = Hp({
      Popup: c.div.attrs({ className: Ap('Popup', 'root') }).withConfig({ componentId: 'sc-jmtjri-0' })(function (e) {
        return (
          (e = e.anchorOrigin),
          Yf(
            ['position:fixed;display:flex;align-items:center;justify-content:center;z-index:1400;', ' ', ''],
            Jj[(null == e ? void 0 : e.horizontal) || Kj.Left],
            eR[(null == e ? void 0 : e.vertical) || Qj.Bottom]
          )
        )
      })
    }),
    nR = ['autoHideDuration', 'anchorOrigin', 'open', 'onClose']
  function rR(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function iR(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {}
      t % 2
        ? rR(Object(n), !0).forEach(function (t) {
            r(e, t, n[t])
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
        : rR(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
          })
    }
    return e
  }
  oC = zp(function (e, t) {
    var n = e.autoHideDuration,
      r = (e.anchorOrigin, e.open),
      i = e.onClose,
      o = Hu(e, nR),
      a = sS(Ap('Popup'))
    return (
      s.exports.useEffect(
        function () {
          var e = null
          return (
            r && n && 'function' == typeof i && (e = setTimeout(i, n)),
            function () {
              e && clearTimeout(e)
            }
          )
        },
        [n, r, i]
      ),
      de.exports.createPortal(r ? ue.createElement(tR.Popup, e, ue.createElement($j, Tg({}, o, { ref: t }))) : null, a)
    )
  })
  var oR =
      ((oC.defaultProps = iR(iR({}, Fj), {}, { open: !1, anchorOrigin: { vertical: Qj.Bottom, horizontal: Kj.Left } })),
      (oC.propTypes = iR(
        iR({}, Og),
        {},
        {
          anchorOrigin: ce.exact({ vertical: ce.oneOf(Fp(Qj)), horizontal: ce.oneOf(Fp(Kj)) }),
          open: ce.bool,
          autoHideDuration: ce.number,
          onClose: ce.func
        }
      )),
      oC),
    aR = c(p).withConfig({ componentId: 'sc-kpjpf5-0' })([
      '.SfxModalTitle-LabelPrimary{font-size:14px;line-height:16px;font-weight:500;}'
    ])
  function lR(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function sR(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? lR(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : lR(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function cR(e) {
    var t = e.title,
      n = e.hint,
      r = e.Icon,
      i = e.onDone,
      o = e.onCancel,
      a = e.doneLabel,
      l = e.cancelLabel,
      s = e.isOpened,
      c = e.doneButtonStyle,
      u = void 0 === (u = e.doneButtonColor) ? 'link' : u,
      d = void 0 === (d = e.cancelButtonColor) ? 'link' : d,
      f = e.children,
      h = e.areButtonsDisabled,
      p = e.zIndex
    e = e.className
    return ue.createElement(
      Tj,
      {
        className: e,
        open: s,
        onClose: o,
        style: sR(sR({}, uR), {}, { zIndex: p }),
        onKeyUp: function (e) {
          'Enter' === e.key && i(e)
        }
      },
      ue.createElement(aR, {
        icon: ue.createElement(r, { size: 25 }),
        iconShadow: !0,
        onClose: o,
        primary: t,
        secondary: n,
        variant: 'with-icon'
      }),
      f && ue.createElement(zj, null, f),
      ue.createElement(
        Rj,
        { align: 'center' },
        ue.createElement(BS, { color: d, onClick: o, size: 'md', disabled: h }, l),
        ue.createElement(BS, { color: u, onClick: i, size: 'md', style: c, disabled: h }, a)
      )
    )
  }
  var uR = { width: 300 }
  function dR(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function fR(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? dR(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : dR(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function hR() {
    var e = (t = jC().config).showBackButton,
      t = t.disableZooming
    return ue.createElement(
      uj,
      { reverseDirection: e, className: 'FIE_topbar' },
      ue.createElement(
        gj,
        { reverseDirection: e, className: 'FIE_topbar-buttons-wrapper' },
        ue.createElement(ER, null),
        ue.createElement(
          dj,
          { className: 'FIE_topbar-history-buttons' },
          ue.createElement(SR, { margin: '0' }),
          ue.createElement(OR, { margin: '0' }),
          ue.createElement(kR, { margin: '0' })
        )
      ),
      ue.createElement(
        gj,
        { className: 'FIE_topbar-center-options' },
        ue.createElement(PR, null),
        !t && ue.createElement(ue.Fragment, null, ue.createElement(cj, null), ue.createElement(LR, null))
      ),
      e ? ue.createElement(TR, null) : ue.createElement(Ej, null)
    )
  }
  function pR(e) {
    var t = e.id,
      n = e.label,
      r = e.Icon,
      i = e.isSelected,
      o = e.onClick
    e = s.exports.useCallback(
      function () {
        'function' == typeof o && o(t)
      },
      [t]
    )
    return ue.createElement(
      MR,
      { className: 'FIE_tab', 'aria-selected': i, onClick: e },
      ue.createElement(r, null),
      n && ue.createElement(jR, { className: 'FIE_tab-label' }, n)
    )
  }
  function gR() {
    var e = (l = jC()).t,
      t = l.dispatch,
      n = l.tabId,
      r = void 0 === n ? null : n,
      i = (n = l.config).tabsIds,
      o = n.defaultTabId,
      a = n.useCloudimage,
      l = s.exports.useMemo(
        function () {
          var e = []
          return (
            0 < Object.keys(i).length
              ? DR.forEach(function (t) {
                  var n = i.indexOf(t.id)
                  ;-1 !== n && (e[n] = t)
                })
              : (e = DR),
            (0 < e.length ? e : DR).filter(function (e) {
              return !(e = e.hideFn) || !e({ useCloudimage: a })
            })
          )
        },
        [i]
      ),
      c = s.exports.useCallback(function (e) {
        t({ type: RT, payload: { tabId: e } })
      }, [])
    return 1 === l.length
      ? null
      : ue.createElement(
          IR,
          { className: 'FIE_tabs' },
          l.map(function (t) {
            var n = t.id,
              i = t.labelKey
            t = t.icon
            return ue.createElement(RR, { key: n, id: n, label: e(i), Icon: t, isSelected: (r || o) === n, onClick: c })
          })
        )
  }
  function mR() {
    var e = (l = jC()).t,
      t = l.dispatch,
      n = l.tabId,
      r = l.toolId,
      i = l.annotations,
      o = l.selectionsIds,
      a = void 0 === o ? [] : o,
      l = (o = l.config).defaultTabId,
      c = o.defaultToolId,
      u = o.useCloudimage,
      d = n || l,
      f = r || c || (null == (o = IT[d]) ? void 0 : o[0]),
      h = s.exports.useMemo(
        function () {
          return IT[d] || []
        },
        [d]
      ),
      p = s.exports.useCallback(function (e) {
        t({ type: oI, payload: { toolId: e } })
      }, [])
    ;(n = s.exports.useMemo(
      function () {
        return h.map(function (t) {
          var n = (r = TT[t]).Item,
            r = r.hideFn
          return (
            n &&
            (!r || !r({ useCloudimage: u })) &&
            ue.createElement(n, { key: t, selectTool: p, t: e, isSelected: f === t })
          )
        })
      },
      [h, f]
    )),
      (l = s.exports.useMemo(
        function () {
          if (!f) return !1
          if (d === Wy.ANNOTATE) {
            var e,
              t = a.length
            if (1 === t) return (e = i[a[0]]), null == (e = TT[e.name]) ? void 0 : e.ItemOptions
            if (1 < t) return null
          }
          return (
            d &&
            f &&
            IT[d].includes(f) &&
            (!(null != (e = TT[r]) && e.hideFn) || !(null != (t = TT[r]) && t.hideFn({ useCloudimage: u }))) &&
            (null == (e = TT[r]) ? void 0 : e.ItemOptions)
          )
        },
        [d, f, i, a]
      ))
    return (
      s.exports.useEffect(function () {
        !r && f && t({ type: oI, payload: { toolId: f } })
      }, []),
      ue.createElement(
        dC,
        { className: 'FIE_tools-bar-wrapper' },
        ue.createElement(AR, null, l && ue.createElement(l, { t: e })),
        n && ue.createElement(fC, { className: 'FIE_tools-bar' }, n)
      )
    )
  }
  function vR(e) {
    e = e.anchorOrigin
    var t = jC(),
      n = void 0 === (n = t.feedback) ? {} : n,
      r = t.dispatch
    return n.message
      ? ue.createElement(oR, {
          className: 'FIE_feedback-robot',
          anchorOrigin: e,
          autoHideDuration: null != (t = n.duration) ? t : 5e3,
          message: n.message,
          open: !!n.message,
          status: zR[n.status || nb],
          onClose: function () {
            r({ type: Xw, payload: { feedback: {} } })
          }
        })
      : null
  }
  function yR(e) {
    return (
      (e = e.label),
      ue.createElement(
        NR,
        { className: 'FIE_spinner-wrapper' },
        ue.createElement(FR, { className: 'FIE_spinner' }),
        e && ue.createElement(uC, { className: 'FIE_spinner-label' }, e)
      )
    )
  }
  cR.defaultProps = {
    hint: '',
    isOpened: !1,
    doneLabel: 'Yes',
    cancelLabel: 'No',
    doneButtonStyle: void 0,
    doneButtonColor: 'link',
    cancelButtonColor: 'link',
    children: void 0,
    areButtonsDisabled: !1,
    zIndex: void 0,
    className: void 0
  }
  var bR = { marginBottom: 16 },
    wR = { width: 67 },
    CR = { marginLeft: 12 },
    xR = !0,
    ER = function () {
      function e() {
        function e() {
          c({ type: sb })
        }
        var t = T(_, !1, !0)
        ;(t = (a.current || w)(t.imageData, t.designState)) instanceof Promise ? t.finally(e) : e(),
          (a.current = null),
          y && v && v('after-saving', h)
      }
      function t() {
        if ('function' != typeof (a.current || w)) throw new Error('Please provide onSave function handler.')
        return _.name && _.extension
          ? void M()
          : void c({ type: Xw, payload: { feedback: { message: g('nameIsRequired') } } })
      }
      function n() {
        var e
        if (!S) return a.current || 'function' != typeof b || !1 !== b(_) ? void P(!0) : void t()
        ;(e = T(_)), (a.current || w)(e.imageData, e.designState)
      }
      function r(e, t) {
        if ('function' != typeof e)
          throw new Error('onSave function callback is required as an argument to the passed function.')
        ;(a.current = e), t()
      }
      function i() {
        var e = (t = Ix(
            x || u.name,
            C && m.ratio === $y ? 'png' : Zy.includes(null == E ? void 0 : E.toLowerCase()) && E
          )).name,
          t = t.extension
        L(fR(fR({}, _), {}, { name: e, extension: t }))
      }
      var o = jC(),
        a = s.exports.useRef(),
        l = o.theme,
        c = o.dispatch,
        u = o.originalImage,
        d = o.resize,
        f = o.isLoadingGlobally,
        h = o.haveNotSavedChanges,
        p = o.feedback,
        g = o.t,
        m = (void 0 === (O = o.adjustments) ? {} : O).crop,
        v = (O = o.config).onClose,
        y = O.closeAfterSave,
        b = O.onBeforeSave,
        w = O.onSave,
        C = O.forceToPngInEllipticalCrop,
        x = O.defaultSavedImageName,
        E = O.defaultSavedImageType,
        S = ((o = void 0 === (o = O.defaultSavedImageQuality) ? 0.92 : o), O.useCloudimage),
        O = O.moreSaveOptions,
        k = (I = Lg(s.exports.useState(!1), 2))[0],
        P = I[1],
        _ = (I = Lg(s.exports.useState({ quality: o <= 0 || 1 < o ? 0.92 : o }), 2))[0],
        L = I[1],
        T = Bx(),
        I = ((o = ['jpeg', 'jpg'].includes(_.extension)), 0 === p.duration),
        M = function () {
          c({ type: $w }), P(!1), setTimeout(e, 3)
        }
      s.exports.useEffect(
        function () {
          u && i()
        },
        [u]
      ),
        s.exports.useEffect(
          function () {
            !u || (_.name && _.extension) || i()
          },
          [k]
        ),
        s.exports.useEffect(
          function () {
            L(fR(fR({}, _), {}, { size: { width: d.width, height: d.height } }))
          },
          [d]
        ),
        s.exports.useEffect(function () {
          return (
            (xR = !0),
            function () {
              xR = !1
            }
          )
        }, []),
        (p =
          Array.isArray(O) && 0 < O.length
            ? O.map(function (e, t) {
                return fR(
                  fR({}, e),
                  {},
                  {
                    key: ''.concat(e.label || t, '-option-key'),
                    onClick:
                      'function' == typeof e.onClick
                        ? function () {
                            return e.onClick(
                              function (e) {
                                return r(e, n)
                              },
                              function (e) {
                                return r(e, M)
                              }
                            )
                          }
                        : void 0
                  }
                )
              })
            : [])
      return ue.createElement(
        ue.Fragment,
        null,
        ue.createElement(S_, {
          className: 'FIE_topbar-save',
          color: 'primary',
          label: g('save'),
          onClick: n,
          menuPosition: 'bottom',
          menuItems: p,
          menuStyle: CR,
          wrapperStyle: wR,
          disabled: f || I
        }),
        k &&
          ue.createElement(
            cR,
            {
              className: 'FIE_save-modal',
              title: g('saveAsModalLabel'),
              Icon: function (e) {
                return ue.createElement(ZL, Tg({ color: l.palette['accent-primary'] }, e))
              },
              isOpened: k,
              onCancel: function () {
                xR && k && ((a.current = null), P(!1))
              },
              onDone: t,
              doneLabel: g('save'),
              cancelLabel: g('cancel'),
              doneButtonColor: 'primary',
              areButtonsDisabled: f,
              zIndex: 11110
            },
            ue.createElement(bj, {
              className: 'FIE_save-file-name-input',
              value: _.name,
              onChange: function (e) {
                ;(e = e.target.value), L(fR(fR({}, _), {}, { name: e }))
              },
              size: 'sm',
              placeholder: g('name'),
              error: !_.name,
              focusOnMount: !0
            }),
            ue.createElement(
              wj,
              {
                className: 'FIE_save-extension-selector',
                onChange: function (e) {
                  return L(fR(fR({}, _), {}, { extension: e }))
                },
                value: _.extension,
                placeholder: g('extension'),
                size: 'sm'
              },
              Zy.map(function (e) {
                return ue.createElement(lO, { key: e, value: e }, e)
              })
            ),
            o &&
              ue.createElement(
                Cj,
                { className: 'FIE_save-quality-wrapper' },
                ue.createElement(uC, null, g('quality')),
                ue.createElement(Jx, {
                  annotation: '%',
                  min: 1,
                  max: 100,
                  onChange: function (e) {
                    L(fR(fR({}, _), {}, { quality: WC(e / 100, 0.01, 1) }))
                  },
                  value: parseInt(100 * _.quality, 10),
                  width: '100%',
                  style: bR
                })
              ),
            ue.createElement(
              xj,
              { className: 'FIE_save-resize-wrapper' },
              ue.createElement(uC, null, g('resize')),
              ue.createElement(vT, {
                onChange: function (e) {
                  L(fR(fR({}, _), {}, { size: fR(fR({}, _.size), e) }))
                },
                currentSize: (null == _ ? void 0 : _.size) || {},
                hideResetButton: !0,
                alignLeft: !0
              })
            )
          )
      )
    },
    SR = function (e) {
      function t() {
        d(!1)
      }
      e = e.margin
      var n = (c = jC()).dispatch,
        r = void 0 === (r = c.isResetted) || r,
        i = c.theme,
        o = c.feedback,
        a = c.t,
        l = c.config,
        c = 0 === o.duration,
        u = (o = Lg(s.exports.useState(!1), 2))[0],
        d = o[1]
      o = s.exports.useCallback(
        function () {
          n({ type: Gw, payload: { config: l } }), t()
        },
        [l]
      )
      return ue.createElement(
        ue.Fragment,
        null,
        ue.createElement(
          fj,
          {
            className: 'FIE_topbar-reset-button',
            color: 'link',
            onClick: r
              ? void 0
              : function () {
                  d(!0)
                },
            disabled: r || c,
            title: a('resetOperations'),
            margin: e
          },
          ue.createElement(OL, { size: 12 })
        ),
        u &&
          ue.createElement(cR, {
            title: a('changesLoseConfirmation'),
            hint: a('changesLoseConfirmationHint'),
            isOpened: u,
            onCancel: t,
            onDone: o,
            Icon: function () {
              return ue.createElement(vL, { color: i.palette.warning, size: 25 })
            },
            doneLabel: a('continue'),
            cancelLabel: a('cancel'),
            doneButtonColor: 'error',
            doneButtonStyle: { background: i.palette.warning }
          })
      )
    },
    OR =
      ((SR.defaultProps = { margin: void 0 }),
      function (e) {
        e = e.margin
        var t = (i = jC()).dispatch,
          n = void 0 !== (n = i.hasUndo) && n,
          r = i.t,
          i = 0 === i.feedback.duration,
          o = s.exports.useCallback(function () {
            t({ type: zT })
          }, [])
        return ue.createElement(
          fj,
          {
            className: 'FIE_topbar-undo-button',
            color: 'link',
            onClick: n ? o : void 0,
            disabled: !n || i,
            title: r('undoTitle'),
            margin: e
          },
          ue.createElement($_, { size: 12 })
        )
      }),
    kR =
      ((OR.defaultProps = { margin: void 0 }),
      function (e) {
        e = e.margin
        var t = (r = jC()).dispatch,
          n = void 0 !== (n = r.hasRedo) && n,
          r = r.t,
          i = s.exports.useCallback(function () {
            t({ type: Bw })
          }, [])
        return ue.createElement(
          fj,
          {
            className: 'FIE_topbar-redo-button',
            color: 'link',
            onClick: n ? i : void 0,
            disabled: !n,
            title: r('redoTitle'),
            margin: e
          },
          ue.createElement(Q_, { size: 12 })
        )
      }),
    PR =
      ((kR.defaultProps = { margin: void 0 }),
      function () {
        function e() {
          t({ type: nI, payload: { isShow: !0 } }),
            document.addEventListener('mouseup', c),
            document.addEventListener('mouseleave', c),
            document.addEventListener('touchcancel', c),
            document.addEventListener('touchend', c)
        }
        var t = (s = jC()).dispatch,
          n = void 0 === (n = s.isResetted) || n,
          r = s.originalImage,
          i = s.resize,
          o = (a = s.adjustments).crop,
          a = a.rotation,
          l = s.shownImageDimensions,
          s = s.t,
          c = function () {
            t({ type: nI, payload: { isShow: !1 } }),
              document.removeEventListener('mouseup', c),
              document.removeEventListener('mouseleave', c),
              document.removeEventListener('touchcancel', c),
              document.removeEventListener('touchend', c)
          }
        return r
          ? ((i = mT(void 0 === i ? {} : i, o, l, r, void 0 === a ? 0 : a)),
            ue.createElement(
              ue.Fragment,
              null,
              ue.createElement(
                hj,
                { title: s('imageDimensionsHoverTitle') },
                ''.concat(i.width, ' x ').concat(i.height, ' px')
              ),
              ue.createElement(
                pj,
                {
                  color: 'link',
                  horizontalMargin: '8px',
                  onMouseDown: n ? void 0 : e,
                  onTouchStart: n ? void 0 : e,
                  disabled: n,
                  title: s('showImageTitle')
                },
                ue.createElement(AL, null)
              )
            ))
          : null
      }),
    _R = [
      { labelKey: 'fitSize', factor: 'fit' },
      { labelKey: 'actualSize', factor: 1 },
      { label: '25%', factor: 0.25 },
      { label: '50%', factor: 0.5 },
      { label: '75%', factor: 0.75 },
      { label: '125%', factor: 1.25 },
      { label: '170%', factor: 1.7 },
      { label: '300%', factor: 3 },
      { label: '500%', factor: 5 },
      { label: '1000%', factor: 10 }
    ],
    LR = function () {
      function e(e) {
        r({ type: wI, payload: { factor: e } })
      }
      function t() {
        var t = (u.width && u.height && u) || (f.width && f.height && f) || c
        e((t = bS((f.width && f.height && f) || c, t)) || 1)
      }
      function n(e) {
        g(p ? null : e.target)
      }
      var r = (h = jC()).dispatch,
        i = void 0 === (o = h.zoom) ? {} : o,
        o = h.toolId,
        a = h.feedback,
        l = h.t,
        c = h.shownImageDimensions,
        u = h.resize,
        d = h.originalImage,
        f = h.adjustments.crop,
        h = h.config.useZoomPresetsMenu,
        p = ((a = 0 === a.duration), (m = Lg(s.exports.useState(null), 2))[0]),
        g = m[1],
        m = o === Gy.CROP || a
      o =
        !d || u.width || u.height
          ? i.factor
          : Math.min((c.width * i.factor) / d.width, (c.height * i.factor) / d.height)
      return ue.createElement(
        ue.Fragment,
        null,
        ue.createElement(
          pj,
          {
            onClick: function () {
              e(i.factor / 1.1)
            },
            color: 'link',
            title: l('zoomOutTitle'),
            disabled: m,
            className: 'FIE_topbar-zoom-out-btn'
          },
          ue.createElement(nL, null)
        ),
        ue.createElement(
          mj,
          {
            title: l('toggleZoomMenuTitle'),
            onClick: m ? void 0 : h ? n : t,
            'aria-disabled': m,
            className: 'FIE_topbar-zoom-label'
          },
          ''.concat(Mx(100 * o, 0), '%')
        ),
        ue.createElement(
          pj,
          {
            onClick: function () {
              e(1.1 * i.factor)
            },
            color: 'link',
            title: l('zoomInTitle'),
            disabled: m,
            className: 'FIE_topbar-zoom-in-btn'
          },
          ue.createElement(eL, null)
        ),
        ue.createElement(
          CS,
          { anchorEl: p, onClose: n, open: !!p, position: 'bottom', className: 'FIE_topbar-zoom-menu' },
          _R.map(function (r) {
            var i = r.factor,
              o = r.labelKey
            r = r.label
            return ue.createElement(
              lO,
              {
                key: r || o,
                onClick: function () {
                  var r
                  'fit' === (r = i) ? t() : e((r = Math.min((r * d.width) / c.width, (r * d.height) / c.height))), n()
                }
              },
              ue.createElement(dO, null, null != r ? r : l(o))
            )
          })
        )
      )
    },
    TR = function () {
      var e = jC(),
        t = e.t,
        n = e.haveNotSavedChanges,
        r = e.config.onClose
      return 'function' == typeof r
        ? ue.createElement(
            yj,
            {
              className: 'FIE_topbar-back-button',
              color: 'link',
              size: 'sm',
              onClick: function () {
                r(eb, n)
              }
            },
            r &&
              ue.createElement(
                ue.Fragment,
                null,
                ue.createElement(TL, { size: 9 }),
                ue.createElement(vj, null, t('back'))
              )
          )
        : ue.createElement('span', null)
    },
    IR = c.div.withConfig({ componentId: 'sc-qhd6ow-0' })([
      "padding:0 12px 12px 0;overflow-y:auto;max-height:100%;[data-phone='true'] &{display:flex;padding:0;}"
    ]),
    MR = c.div.withConfig({ componentId: 'sc-qhd6ow-1' })(function (e) {
      return (
        (e = e.theme),
        '\n    width: 67px;\n    height: 62px;\n    border-radius: 4px;\n    display: flex;\n    flex-direction: column;\n    background: '
          .concat(
            e.palette['bg-primary'],
            ";\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 8px;\n\n    [data-phone='true'] & {\n      margin-bottom: 0;\n      height: 50px;\n      border-radius: 0;\n    }\n\n    &,\n    * {\n      cursor: pointer;\n    }\n\n    &:hover {\n      background: "
          )
          .concat(e.palette['bg-primary-active'], ";\n    }\n\n    &[aria-selected='true'] {\n      background: ")
          .concat(e.palette['bg-primary-active'], ';\n\n      * {\n        color: ')
          .concat(e.palette['accent-primary-active'], ';\n      }\n    }\n  ')
      )
    }),
    jR = c(uC).withConfig({ componentId: 'sc-qhd6ow-2' })([
      "margin-top:6px;font-size:11px;line-height:12px;text-align:center;[data-phone='true'] &{font-size:10px;}"
    ]),
    RR = ((pR.defaultProps = { isSelected: !1, onClick: void 0, label: void 0 }), s.exports.memo(pR)),
    DR = [
      { id: Wy.ADJUST, labelKey: 'adjustTab', icon: aC },
      { id: Wy.FINETUNE, labelKey: 'finetuneTab', icon: Qy },
      {
        id: Wy.FILTERS,
        labelKey: 'filtersTab',
        icon: ug,
        hideFn: function (e) {
          return e.useCloudimage
        }
      },
      { id: Wy.WATERMARK, labelKey: 'watermarkTab', icon: dS },
      {
        id: Wy.ANNOTATE,
        labelKey: 'annotateTab',
        icon: f,
        hideFn: function (e) {
          return e.useCloudimage
        }
      },
      { id: Wy.RESIZE, labelKey: 'resizeTab', icon: mg }
    ],
    AR = function (e) {
      return (e = e.children), ue.createElement(gC, { className: 'FIE_tool-options-wrapper', hasChildren: !!e }, e)
    },
    zR = ((AR.defaultProps = { children: void 0 }), r((wS = {}), nb, 'sad'), r(wS, tb, 'worried'), wS),
    NR =
      ((iC =
        ((vR.defaultProps = { anchorOrigin: { horizontal: 'center', vertical: 'bottom' } }),
        (function (e) {
          for (var t = arguments.length, n = new Array(1 < t ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r]
          e = Yf.apply(void 0, [e].concat(n)).join('')
          var i = Jf(e)
          return new Nf(i, e)
        })([
          '0%{transform:rotate(0);animation-timing-function:cubic-bezier(0.55,0.055,0.675,0.19);}50%{transform:rotate(900deg);animation-timing-function:cubic-bezier(0.215,0.61,0.355,1);}100%{transform:rotate(1800deg);}'
        ]))),
      c.div.withConfig({ componentId: 'sc-m42fbk-0' })([
        'background:rgba(0,0,0,0.25);display:flex;align-items:center;justify-content:center;position:absolute;z-index:11111;top:0;bottom:0;right:0;left:0;flex-direction:column;user-select:none;label{color:#ffffff;}'
      ])),
    FR = c.div.withConfig({ componentId: 'sc-m42fbk-1' })(
      [
        "display:inline-block;position:relative;width:80px;height:80px;:after{content:' ';display:block;border-radius:50%;width:0;height:0;margin:8px;box-sizing:border-box;border:32px solid #fff;border-color:#fff transparent #fff transparent;animation:",
        ' 1.2s infinite;}'
      ],
      iC
    ),
    HR = ((yR.defaultProps = { label: '' }), ['cropX2', 'cropY2', 'crop', 'watermark'])
  function BR(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function VR(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? BR(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : BR(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function WR(e, t) {
    return (
      e &&
      t &&
      ((e instanceof HTMLImageElement && e.src === t.src && e.width === t.width && e.height === t.height) ||
        ((null == e ? void 0 : e.src) || e) === t.src)
    )
  }
  var GR = c.div
      .attrs(function (e) {
        var t
        return {
          style: {
            width: null != (t = (e = void 0 === (e = e.$size) ? {} : e).width) ? t : '100%',
            height: null != (t = e.height) ? t : '100%'
          }
        }
      })
      .withConfig({ componentId: 'sc-ugtqr7-0' })(
      [
        'display:flex;flex-direction:column;align-items:center;height:100%;max-height:100%;width:100%;max-width:100%;overflow:auto;position:relative;min-height:250px;background:',
        ';'
      ],
      function (e) {
        return e.theme.palette['bg-secondary']
      }
    ),
    ZR = c.div.withConfig({ componentId: 'sc-ugtqr7-1' })([
      "display:flex;align-items:flex-start;width:100%;padding:12px;box-sizing:border-box;height:calc(100% - 95px);flex-grow:1;[data-phone='true'] &{padding:0;}"
    ]),
    UR = c.div.withConfig({ componentId: 'sc-ugtqr7-2' })([
      'height:100%;width:calc(100% - 80px);flex-grow:1;overflow-y:auto;display:flex;flex-direction:column;'
    ]),
    XR = c.div.withConfig({ componentId: 'sc-ugtqr7-3' })([
      'width:100%;flex-grow:1;display:flex;flex-direction:column;justify-content:flex-end;'
    ])
  function YR(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function qR(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? YR(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : YR(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function $R(e) {
    var t = e.img,
      n = e.source,
      r = e.useCloudimage,
      i = e.cloudimage
    if (t) throw new Error('`img` is renamed to `source` please consider renaming it from your configurations.')
    if (!n || ('string' != typeof n && !(n instanceof HTMLImageElement)))
      throw new Error(
        '`source` property is required either a string of image url or a HTMLImageElement for the image that will be edited.'
      )
    if (
      !r ||
      null == i ||
      null == (t = i.imageSealing) ||
      !t.enable ||
      (null != i && null != (n = i.imageSealing) && n.salt)
    )
      return (
        (r = UI(ub, e)),
        ue.createElement(
          ue.StrictMode,
          null,
          ue.createElement(
            kg,
            { theme: r.theme },
            ue.createElement(QR, null),
            ue.createElement(JR, null),
            ue.createElement(TC, { config: r }, ue.createElement(KR, null))
          )
        )
      )
    throw new Error(
      '`salt` property of imageSealing object is required in cloudimage mode as long as `imageSealing` is enabled.'
    )
  }
  var KR = s.exports.memo(function () {
      function t(e) {
        return new Promise(function (t) {
          var n,
            r = (null == e ? void 0 : e.src) || e
          D.current === r || (!r && d) || WR(r, d)
            ? D.current || t()
            : ((n = function () {
                ;(D.current = null), t()
              }),
              (D.current = r),
              'string' == typeof e
                ? bM(e, E).then(N).catch(F).finally(n)
                : e instanceof HTMLImageElement
                ? (!e.name && E && (e.name = E),
                  e.complete
                    ? (N(e), n())
                    : e.addEventListener('load', function () {
                        N(e), n()
                      }))
                : (F(h('invalidImageError')), n()))
        })
      }
      function n(e) {
        A.current && (e.preventDefault(), (e.returnValue = ''))
      }
      function i() {
        var e =
          0 < arguments.length && void 0 !== arguments[0]
            ? arguments[0]
            : function () {
                return []
              }
        u({ type: $w }),
          Promise.all(e()).finally(function () {
            u({ type: sb })
          })
      }
      function o() {
        g &&
          0 < Object.keys(g).length &&
          u({
            type: XI,
            payload: qR(
              qR({}, g),
              {},
              { finetunes: Rw(null == g ? void 0 : g.finetunes), filter: Tw(null == g ? void 0 : g.filter) }
            )
          })
      }
      var a = (p = jC()).config,
        l = p.isLoadingGlobally,
        c = p.haveNotSavedChanges,
        u = p.dispatch,
        d = p.originalImage,
        f = p.shownImageDimensions,
        h = p.t,
        p = void 0 === (p = p.feedback) ? {} : p,
        g = a.loadableDesignState,
        m = a.useCloudimage,
        v = a.cloudimage,
        y = a.source,
        b = a.avoidChangesNotSavedAlertOnLeave,
        w = a.useBackendTranslations,
        C = a.translations,
        x = a.language,
        E = a.defaultSavedImageName,
        S = a.observePluginContainerSize,
        O = a.showCanvasOnly,
        k = a.getCurrentImgDataFnRef,
        P = a.updateStateFnRef,
        _ = (a = Lg(Cx(), 2))[0],
        L = a[1],
        T = (a = Lg(s.exports.useState({ width: void 0, height: void 0 }), 2))[0],
        I = a[1],
        M = ((a = vx()), s.exports.useRef(null)),
        j = s.exports.useRef(!0),
        R = s.exports.useRef(!1),
        D = s.exports.useRef(null),
        A = s.exports.useRef(c),
        z = Bx(),
        N = s.exports.useCallback(function (e) {
          u({ type: kI, payload: { originalImage: e } })
        }, []),
        F = s.exports.useCallback(function (e) {
          u({ type: Xw, payload: { feedback: { message: e.message || e, duration: 0 } } })
        }, [])
      return (
        s.exports.useEffect(
          function () {
            j.current ||
              !y ||
              WR(y, d) ||
              ((R.current = !1),
              i(function () {
                return [t(y)]
              }))
          },
          [y]
        ),
        s.exports.useEffect(
          function () {
            var e
            j.current ||
              ((e = null == g ? void 0 : g.imgSrc) && !WR(e, d)
                ? i(function () {
                    return [t(e).then(o)]
                  })
                : o())
          },
          [g]
        ),
        s.exports.useEffect(
          function () {
            var e, t, n, i, o, a, l, s
            0 < Object.keys(f || {}).length &&
              !Object.keys(f).some(function (e) {
                return !f[e]
              }) &&
              d &&
              m &&
              null != v &&
              v.loadableQuery &&
              !R.current &&
              (u({
                type: XI,
                payload:
                  ((e = v.loadableQuery),
                  (t = f),
                  (n = d),
                  e
                    ? ((e = e.split('&')),
                      (i = {}),
                      e.forEach(function (e) {
                        var o = (function (e, t) {
                          var n,
                            i = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {},
                            o = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {}
                          switch (e) {
                            case 'wat_text':
                              return { watermark: { text: t.replaceAll('+', ' ') } }
                            case 'wat_font':
                              return { watermark: { fontFamily: t } }
                            case 'wat_color':
                              return { watermark: { fill: '#'.concat(t) } }
                            case 'wat_fontsize':
                              return { watermark: { fontSize: parseFloat(t) } }
                            case 'wat_opacity':
                              return { watermark: { opacity: parseFloat(t) } }
                            case 'wat_pos':
                              var a = (l = Lg(t.split(','), 2))[0],
                                l = l[1]
                              return {
                                watermark: { x: (parseFloat(a) / 100) * i.width, y: (parseFloat(l) / 100) * i.height }
                              }
                            case 'wat_url':
                              return { watermark: { image: decodeURIComponent(t) } }
                            case 'wat_scale':
                              return (
                                (l = (a = Lg(t.split(','), 2))[0]),
                                (a = a[1]),
                                {
                                  watermark: {
                                    width: (parseFloat(l) / 100) * (i.width || 0),
                                    height: (parseFloat(a) / 100) * (i.height || 0)
                                  }
                                }
                              )
                            case 'tl_px':
                              return (
                                (a = (l = Lg(t.split(','), 2))[0]),
                                (l = l[1]),
                                {
                                  crop: {
                                    x: yx(parseFloat(a), 0, o.width, 0, i.width),
                                    y: yx(parseFloat(l), 0, o.height, 0, i.height)
                                  }
                                }
                              )
                            case 'br_px':
                              return (
                                (l = (a = Lg(t.split(','), 2))[0]),
                                (a = a[1]),
                                {
                                  cropX2: yx(parseFloat(l), 0, o.width, 0, i.width),
                                  cropY2: yx(parseFloat(a), 0, o.height, 0, i.height)
                                }
                              )
                            case 'round':
                              return { crop: { ratio: $y } }
                            case 'w':
                              return { resize: { width: parseFloat(t) } }
                            case 'h':
                              return { resize: { height: parseFloat(t) } }
                            case 'r':
                              return { adjustments: { rotation: -parseInt(t, 10) } }
                            case 'flip':
                            case 'mirror':
                              return {
                                adjustments: {
                                  isFlippedX: t.includes('x') || t.includes('h'),
                                  isFlippedY: t.includes('y') || t.includes('v')
                                }
                              }
                            default:
                              return (
                                Object.keys(Ax).forEach(function (t) {
                                  Ax[t].cloudimage.name === e.toLowerCase() && (n = t)
                                }),
                                n
                                  ? ((a = (l = Ax[n]).cloudimage),
                                    (l = l.internal),
                                    {
                                      finetunes: [ry.Filters[n]],
                                      finetunesProps: r({}, l.propName, yx(parseFloat(t), a.min, a.max, l.min, l.max))
                                    })
                                  : null
                              )
                          }
                        })((o = (e = Lg(e.split('='), 2))[0]), (e = e[1]), t, n)
                        o && (i = UI(i, o, !0))
                      }),
                      (o = (e = i).cropX2),
                      (a = e.cropY2),
                      (l = e.crop),
                      (s = e.watermark),
                      VR(
                        VR(
                          VR({}, (e = Hu(e, HR))),
                          o && a && l
                            ? {
                                adjustments: VR(
                                  VR({}, e.adjustments),
                                  {},
                                  { crop: VR(VR({}, l), {}, { width: (o || 0) - l.x, height: (a || 0) - l.y }) }
                                )
                              }
                            : {}
                        ),
                        {},
                        {
                          annotations: VR(
                            {},
                            s
                              ? r(
                                  {},
                                  By,
                                  VR(
                                    VR({}, s),
                                    {},
                                    {
                                      x: ((null == l ? void 0 : l.x) || 0) + (s.x || 0),
                                      y: ((null == l ? void 0 : l.y) || 0) + (s.y || 0),
                                      id: By,
                                      name: s.text ? Gy.TEXT : Gy.IMAGE
                                    },
                                    s.text ? { width: s.text.length * s.fontSize, height: s.fontSize } : {}
                                  )
                                )
                              : {}
                          )
                        }
                      ))
                    : null)
              }),
              (R.current = !0))
          },
          [f, d, m, v]
        ),
        s.exports.useEffect(
          function () {
            var e = !1
            return (
              S && M.current
                ? _(M.current.parentNode, function (e) {
                    var t = e.width
                    e = e.height
                    return I({ width: t, height: e })
                  })
                : T.width && T.height && !e && I({ width: void 0, height: void 0 }),
              function () {
                S && M.current && L(M.current), (e = !0)
              }
            )
          },
          [S]
        ),
        s.exports.useEffect(function () {
          return (
            i(function () {
              return [t((null == g ? void 0 : g.imgSrc) || y)].concat(
                Dp(
                  w
                    ? [
                        (function () {
                          var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 'en',
                            t = 1 < arguments.length ? arguments[1] : void 0
                          return new Promise(function (n, i) {
                            var o = e.toLowerCase(),
                              a = new XMLHttpRequest()
                            ;(a.responseType = 'json'),
                              (a.onload = function () {
                                var e, l
                                200 <= a.status && a.status < 300
                                  ? ((a.response || []).forEach(function (e) {
                                      EC[o] = wC(wC({}, EC[o]), {}, r({}, e.translation_key, e.translations[o]))
                                    }),
                                    (e = []),
                                    Object.keys(yC).forEach(function (t) {
                                      var n
                                      !t || (null != (n = EC[o]) && n[t]) || e.push({ key: t, lang: o, default: yC[t] })
                                    }),
                                    0 < e.length && PC(e),
                                    kC(t, o),
                                    n(SC))
                                  : (console.error('Status code: '.concat(a.status)),
                                    console.error(
                                      (null == (l = a.response) ? void 0 : l.msg) ||
                                        (null == (l = a.response) ? void 0 : l.msg) ||
                                        (null == (l = a.response) ? void 0 : l.details) ||
                                        OC
                                    ),
                                    i())
                              }),
                              (a.onerror = function () {
                                console.error('Status code '.concat(a.status, ', error: ').concat(OC)), i()
                              }),
                              a.open('GET', 'https://i18n.ultrafast.io/api/export?grid='.concat(Vy)),
                              a.send()
                          })
                        })(x, C)
                      ]
                    : []
                )
              )
            }),
            (j.current = !1),
            window && !b && window.addEventListener('beforeunload', n),
            function () {
              window && !b && window.removeEventListener('beforeunload', n)
            }
          )
        }, []),
        s.exports.useEffect(
          function () {
            P &&
              'object' === e(P) &&
              (P.current = function (e) {
                u({ type: XI, payload: e })
              })
          },
          [P, u]
        ),
        s.exports.useEffect(
          function () {
            k && 'object' === e(k) && (k.current = z)
          },
          [z]
        ),
        s.exports.useEffect(
          function () {
            A.current = c
          },
          [c]
        ),
        ue.createElement(
          GR,
          { className: zy, 'data-phone': a, ref: M, $size: T },
          l && ue.createElement(yR, { label: h('loading') }),
          !O && ue.createElement(hR, null),
          d &&
            0 !== p.duration &&
            ue.createElement(
              ZR,
              { className: 'FIE_main-container' },
              !a && !O && ue.createElement(gR, null),
              ue.createElement(
                UR,
                { className: 'FIE_editor-content' },
                ue.createElement(aj, null),
                !O &&
                  (a
                    ? ue.createElement(
                        XR,
                        { className: 'FIE_phone-tools-tabs-wrapper' },
                        ue.createElement(mR, null),
                        ue.createElement(gR, null)
                      )
                    : ue.createElement(mR, null))
              )
            ),
          ue.createElement(vR, null)
        )
      )
    }),
    QR = dh(
      ['.', '{font-family:', ';}.SfxModal-Wrapper *{font-family:', ';}'],
      zy,
      function (e) {
        return (null == (e = (void 0 === (e = e.theme) ? {} : e).typography) ? void 0 : e.fontFamily) || 'Arial'
      },
      function (e) {
        return (null == (e = (void 0 === (e = e.theme) ? {} : e).typography) ? void 0 : e.fontFamily) || 'Arial'
      }
    ),
    JR = dh(
      [
        '.Menu-open{overflow:visible !important;}.',
        ',#SfxPopper{box-sizing:border-box;.SfxPopper-root .SfxMenu-root{overflow:visible;width:max-content;.SfxMenuItem-prefix{margin-right:6px;}}}.',
        ' *,#SfxPopper *{box-sizing:border-box;scrollbar-color:rgba(203,211,218,1) rgba(203,211,218,0.35);:not(button) > svg:not([color]){color:',
        '}:disabled,[aria-disabled="true"]{cursor:not-allowed;}&::-webkit-scrollbar{width:4px;height:4px;}&::-webkit-scrollbar-track{background:rgba(203,211,218,0.35);}&::-webkit-scrollbar-thumb{background:rgba(203,211,218,1);border-radius:10px;}}'
      ],
      zy,
      zy,
      function (e) {
        return e.theme.palette['icons-primary']
      }
    ),
    eD = (($R.defaultProps = { useCloudimage: !1, cloudimage: {}, img: void 0 }), s.exports.memo($R))
  function tD(e, t) {
    var n,
      r = Object.keys(e)
    return (
      Object.getOwnPropertySymbols &&
        ((n = Object.getOwnPropertySymbols(e)),
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
          })),
        r.push.apply(r, n)),
      r
    )
  }
  function nD(e) {
    for (var t, n = 1; n < arguments.length; n++)
      (t = null == arguments[n] ? {} : arguments[n]),
        n % 2
          ? tD(Object(t), !0).forEach(function (n) {
              r(e, n, t[n])
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
          : tD(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
            })
    return e
  }
  function rD(e, t, n) {
    var r = e
    if (t.has(r)) throw new TypeError('Cannot initialize the same private elements twice on an object')
    t.set(e, n)
  }
  var iD = new WeakMap(),
    oD = new WeakMap(),
    aD = new WeakMap()
  ;(l = lD),
    (y = [
      {
        key: 'render',
        value: function (t) {
          'object' === e(t) && (this.config = this.config = UI(this.config || {}, t)),
            (this.config = nD(
              nD({}, this.config),
              {},
              { getCurrentImgDataFnRef: o(this, oD), updateStateFnRef: o(this, aD) }
            )),
            o(this, iD).render(s.exports.createElement(eD, this.config))
        }
      },
      {
        key: 'terminate',
        value: function () {
          o(this, iD).unmount()
        }
      },
      {
        key: 'getCurrentImgData',
        value: function (e, t, n) {
          var r, i
          return (null == (r = o(this, oD)) || null == (i = r.current) ? void 0 : i.call(r, e, t, n)) || {}
        }
      },
      {
        key: 'updateState',
        value: function (e) {
          var t, n
          null != (t = o(this, aD)) && null != (n = t.current) && n.call(t, e)
        }
      }
    ]) && n(l.prototype, y),
    Object.defineProperty(l, 'prototype', { writable: !1 }),
    (h = lD)
  function lD(e) {
    var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
      n = this,
      r = lD
    if (!(n instanceof r)) throw new TypeError('Cannot call a class as a function')
    if (
      (rD(this, iD, { writable: !0, value: void 0 }),
      rD(this, oD, { writable: !0, value: void 0 }),
      rD(this, aD, { writable: !0, value: void 0 }),
      (this.container = e),
      (this.config = t),
      !(e && e instanceof HTMLElement))
    )
      throw new Error('`container` (argument 0) is required to initialize the image editor plugin.')
    a(this, iD, Fu(this.container)), a(this, oD, {}), a(this, aD, {})
  }
  return r(h, 'TABS', Wy), r(h, 'TOOLS', Gy), (h.TABS = Wy), (h.TOOLS = Gy), h
})
